var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import * as React$1 from "react";
import React__default, { useState, useEffect, useCallback, createContext, forwardRef, useContext, createElement, Fragment as Fragment$1, useLayoutEffect, useRef, useMemo, Component, useImperativeHandle, useReducer, Children } from "react";
import * as ReactDOM from "react-dom";
import ReactDOM__default, { createPortal } from "react-dom";
var index$1 = "";
var globals = "";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getAugmentedNamespace(n2) {
  if (n2.__esModule)
    return n2;
  var a = Object.defineProperty({}, "__esModule", { value: true });
  Object.keys(n2).forEach(function(k2) {
    var d2 = Object.getOwnPropertyDescriptor(n2, k2);
    Object.defineProperty(a, k2, d2.get ? d2 : {
      enumerable: true,
      get: function() {
        return n2[k2];
      }
    });
  });
  return a;
}
var classnames$3 = { exports: {} };
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
(function(module) {
  (function() {
    var hasOwn = {}.hasOwnProperty;
    function classNames2() {
      var classes = [];
      for (var i2 = 0; i2 < arguments.length; i2++) {
        var arg = arguments[i2];
        if (!arg)
          continue;
        var argType = typeof arg;
        if (argType === "string" || argType === "number") {
          classes.push(arg);
        } else if (Array.isArray(arg)) {
          if (arg.length) {
            var inner2 = classNames2.apply(null, arg);
            if (inner2) {
              classes.push(inner2);
            }
          }
        } else if (argType === "object") {
          if (arg.toString === Object.prototype.toString) {
            for (var key in arg) {
              if (hasOwn.call(arg, key) && arg[key]) {
                classes.push(key);
              }
            }
          } else {
            classes.push(arg.toString());
          }
        }
      }
      return classes.join(" ");
    }
    if (module.exports) {
      classNames2.default = classNames2;
      module.exports = classNames2;
    } else {
      window.classNames = classNames2;
    }
  })();
})(classnames$3);
var classnames$2 = classnames$3.exports;
var propTypes$8 = { exports: {} };
var ReactPropTypesSecret$1 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;
var ReactPropTypesSecret = ReactPropTypesSecret_1;
function emptyFunction() {
}
function emptyFunctionWithReset() {
}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      return;
    }
    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
    err.name = "Invariant Violation";
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
{
  propTypes$8.exports = factoryWithThrowingShims();
}
var PropTypes$1 = propTypes$8.exports;
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === void 0) {
    throw new TypeError("Object.assign cannot be called with null or undefined");
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String("abc");
    test1[5] = "de";
    if (Object.getOwnPropertyNames(test1)[0] === "5") {
      return false;
    }
    var test2 = {};
    for (var i2 = 0; i2 < 10; i2++) {
      test2["_" + String.fromCharCode(i2)] = i2;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
      return test2[n2];
    });
    if (order2.join("") !== "0123456789") {
      return false;
    }
    var test3 = {};
    "abcdefghijklmnopqrst".split("").forEach(function(letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
shouldUseNative() ? Object.assign : function(target, source) {
  var from2;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from2 = Object(arguments[s]);
    for (var key in from2) {
      if (hasOwnProperty$2.call(from2, key)) {
        to[key] = from2[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from2);
      for (var i2 = 0; i2 < symbols.length; i2++) {
        if (propIsEnumerable.call(from2, symbols[i2])) {
          to[symbols[i2]] = from2[symbols[i2]];
        }
      }
    }
  }
  return to;
};
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f$1 = React__default, g$1 = 60103;
reactJsxRuntime_production_min.Fragment = 60107;
if ("function" === typeof Symbol && Symbol.for) {
  var h$1 = Symbol.for;
  g$1 = h$1("react.element");
  reactJsxRuntime_production_min.Fragment = h$1("react.fragment");
}
var m$1 = f$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n$2 = Object.prototype.hasOwnProperty, p$1 = { key: true, ref: true, __self: true, __source: true };
function q$1(c2, a, k2) {
  var b2, d2 = {}, e2 = null, l2 = null;
  void 0 !== k2 && (e2 = "" + k2);
  void 0 !== a.key && (e2 = "" + a.key);
  void 0 !== a.ref && (l2 = a.ref);
  for (b2 in a)
    n$2.call(a, b2) && !p$1.hasOwnProperty(b2) && (d2[b2] = a[b2]);
  if (c2 && c2.defaultProps)
    for (b2 in a = c2.defaultProps, a)
      void 0 === d2[b2] && (d2[b2] = a[b2]);
  return { $$typeof: g$1, type: c2, key: e2, ref: l2, props: d2, _owner: m$1.current };
}
reactJsxRuntime_production_min.jsx = q$1;
reactJsxRuntime_production_min.jsxs = q$1;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
const jsx$1 = jsxRuntime.exports.jsx;
const jsxs = jsxRuntime.exports.jsxs;
const Fragment = jsxRuntime.exports.Fragment;
function isModifiedEvent$1(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function DefaultLink({
  onClick,
  href,
  children,
  ...props
}) {
  return /* @__PURE__ */ jsx$1("a", {
    ...props,
    href,
    onClick: (event) => {
      let {
        target
      } = props;
      onClick();
      if (event.button === 0 && (!target || target === "_self") && !isModifiedEvent$1(event)) {
        event.preventDefault();
        window.history.pushState({}, "", href);
      }
    },
    children
  });
}
const icon$f = "epic__icon__977";
const ripple$f = "epic__ripple__6c4";
const breadcrumbs = "epic__breadcrumbs__b02";
const links = "epic__links__7e7";
const link$1 = "epic__link__9c7";
const slash = "epic__slash__aa9";
var styles$e = {
  icon: icon$f,
  "epic-icon": "epic__epic-icon__1a2",
  "epic-icon-add": "epic__epic-icon-add__682",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__2aa",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__120",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__f27",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__10c",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__38c",
  "epic-icon-calendar": "epic__epic-icon-calendar__273",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__c3d",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__702",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__02d",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__2fe",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__902",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__d18",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__dd0",
  "epic-icon-close-x": "epic__epic-icon-close-x__36e",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__a95",
  "epic-icon-confluence": "epic__epic-icon-confluence__f04",
  "epic-icon-contact": "epic__epic-icon-contact__d55",
  "epic-icon-delete": "epic__epic-icon-delete__721",
  "epic-icon-edit": "epic__epic-icon-edit__27c",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__a6f",
  "epic-icon-filter": "epic__epic-icon-filter__4f2",
  "epic-icon-github": "epic__epic-icon-github__939",
  "epic-icon-information": "epic__epic-icon-information__04e",
  "epic-icon-jira": "epic__epic-icon-jira__e0b",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__4b1",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__4cc",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__05b",
  "epic-icon-preview": "epic__epic-icon-preview__4d2",
  "epic-icon-profile": "epic__epic-icon-profile__a6e",
  "epic-icon-quotes": "epic__epic-icon-quotes__952",
  "epic-icon-search": "epic__epic-icon-search__7da",
  "epic-icon-share": "epic__epic-icon-share__62a",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__591",
  "epic-icon-slack": "epic__epic-icon-slack__dd5",
  "epic-icon-steps": "epic__epic-icon-steps__c2f",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__a9d",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__bf9",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__7ff",
  "epic-icon-warning": "epic__epic-icon-warning__e88",
  "epic-font-base": "epic__epic-font-base__4c6",
  "epic-font-base-md": "epic__epic-font-base-md__87b",
  "epic-font-marketing": "epic__epic-font-marketing__6f1",
  "epic-font-brand": "epic__epic-font-brand__e55",
  ripple: ripple$f,
  "epic-display-base": "epic__epic-display-base__fe4",
  "epic-display-1": "epic__epic-display-1__37d",
  "epic-display-2": "epic__epic-display-2__0ac",
  "epic-display-3": "epic__epic-display-3__914",
  "epic-display-4": "epic__epic-display-4__cb3",
  "epic-display-5": "epic__epic-display-5__d24",
  "epic-title-base": "epic__epic-title-base__769",
  "epic-title-1": "epic__epic-title-1__5a4",
  "epic-title-2": "epic__epic-title-2__8ff",
  "epic-title-3": "epic__epic-title-3__105",
  "epic-title-4": "epic__epic-title-4__4a2",
  "epic-title-5": "epic__epic-title-5__8ef",
  "epic-title-6": "epic__epic-title-6__472",
  "epic-subtitle-base": "epic__epic-subtitle-base__e74",
  "epic-subtitle-1": "epic__epic-subtitle-1__108",
  "epic-subtitle-2": "epic__epic-subtitle-2__1b3",
  "epic-subtitle-3": "epic__epic-subtitle-3__025",
  "epic-body-text-base": "epic__epic-body-text-base__6a2",
  "epic-body-text-1": "epic__epic-body-text-1__473",
  "epic-body-text-2": "epic__epic-body-text-2__99a",
  "epic-body-text": "epic__epic-body-text__508",
  "epic-body-text-3": "epic__epic-body-text-3__4b9",
  "epic-legal-text": "epic__epic-legal-text__59d",
  breadcrumbs,
  "epic-label-text": "epic__epic-label-text__a5d",
  "epic-button-base": "epic__epic-button-base__5e2",
  "epic-button-1": "epic__epic-button-1__789",
  "epic-button-2": "epic__epic-button-2__d0a",
  "epic-button-3": "epic__epic-button-3__4e3",
  links,
  link: link$1,
  slash
};
function Breadcrumbs({
  RouterLink,
  links: links2,
  className
}) {
  const Link2 = RouterLink || DefaultLink;
  return /* @__PURE__ */ jsx$1("div", {
    className: classnames$2(styles$e.breadcrumbs, className),
    children: /* @__PURE__ */ jsx$1("div", {
      className: styles$e.links,
      children: links2.map(({
        title: title2,
        href
      }, i2) => {
        const link2 = href ? /* @__PURE__ */ jsx$1(Link2, {
          href,
          children: title2
        }) : title2;
        return /* @__PURE__ */ jsxs("span", {
          className: styles$e.link,
          children: [i2 > 0 && i2 <= links2.length && /* @__PURE__ */ jsx$1("span", {
            className: styles$e.slash,
            children: "/"
          }), link2]
        }, title2 + i2);
      })
    })
  });
}
Breadcrumbs.propTypes = {
  links: PropTypes$1.arrayOf(PropTypes$1.shape({
    title: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.node]).isRequired,
    href: PropTypes$1.string
  })),
  className: PropTypes$1.string,
  RouterLink: PropTypes$1.object
};
Breadcrumbs.defaultProps = {
  links: [],
  className: "",
  iconType: "Home"
};
var classnames$1 = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(module) {
  (function() {
    var hasOwn = {}.hasOwnProperty;
    function classNames2() {
      var classes = [];
      for (var i2 = 0; i2 < arguments.length; i2++) {
        var arg = arguments[i2];
        if (!arg)
          continue;
        var argType = typeof arg;
        if (argType === "string" || argType === "number") {
          classes.push(arg);
        } else if (Array.isArray(arg)) {
          if (arg.length) {
            var inner2 = classNames2.apply(null, arg);
            if (inner2) {
              classes.push(inner2);
            }
          }
        } else if (argType === "object") {
          if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
            classes.push(arg.toString());
            continue;
          }
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }
      return classes.join(" ");
    }
    if (module.exports) {
      classNames2.default = classNames2;
      module.exports = classNames2;
    } else {
      window.classNames = classNames2;
    }
  })();
})(classnames$1);
var classNames$1 = classnames$1.exports;
var __assign$J = globalThis && globalThis.__assign || function() {
  __assign$J = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$J.apply(this, arguments);
};
var __rest$e = globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var DEFAULT_TEXT_AS = "p";
var Text$2 = function(_a) {
  var _b;
  var children = _a.children, className = _a.className, color = _a.color, font = _a.font, as = _a.as, rest = __rest$e(_a, ["children", "className", "color", "font", "as"]);
  var Tag2 = as || DEFAULT_TEXT_AS;
  return jsx$1(Tag2, __assign$J({ className: classNames$1((_b = {}, _b["eds-type--".concat(font)] = font, _b["eds-color--".concat(color)] = color, _b), className) }, rest, { children }));
};
var __assign$I = globalThis && globalThis.__assign || function() {
  __assign$I = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$I.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var __assign$H = globalThis && globalThis.__assign || function() {
  __assign$H = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$H.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var __assign$G = globalThis && globalThis.__assign || function() {
  __assign$G = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$G.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var __assign$F = globalThis && globalThis.__assign || function() {
  __assign$F = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$F.apply(this, arguments);
};
var __rest$d = globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var DEFAULT_BUTTON_AS = "button";
var buttonClassBuilder = function(variant, size, disabled2, className) {
  return classNames$1("eds-button", "eds-button--".concat(variant), "eds-button--".concat(size), { "eds-button--disabled": disabled2 }, className);
};
var ButtonInternals = function(_a) {
  var children = _a.children, beforeSlot = _a.beforeSlot, afterSlot = _a.afterSlot;
  return jsxs(Fragment, { children: [beforeSlot && jsx$1("span", __assign$F({ className: "eds-button__icon-before" }, { children: beforeSlot })), children, afterSlot && jsx$1("span", __assign$F({ className: "eds-button__icon-after" }, { children: afterSlot }))] });
};
var Button$1 = function(_a) {
  var as = _a.as, children = _a.children, className = _a.className, _b = _a.disabled, disabled2 = _b === void 0 ? false : _b, _c = _a.disableRipple, disableRipple = _c === void 0 ? false : _c, beforeSlot = _a.beforeSlot, afterSlot = _a.afterSlot, _d = _a.size, size = _d === void 0 ? "medium" : _d, _e = _a.type, type = _e === void 0 ? "button" : _e, _f = _a.variant, variant = _f === void 0 ? "primary" : _f, rest = __rest$d(_a, ["as", "children", "className", "disabled", "disableRipple", "beforeSlot", "afterSlot", "size", "type", "variant"]);
  var ariaDisabled = disabled2 ? { "aria-disabled": true } : {};
  var Tag2 = as || DEFAULT_BUTTON_AS;
  return jsxs(Tag2, __assign$F({ disabled: disabled2, className: buttonClassBuilder(variant, size, disabled2, className), type }, ariaDisabled, rest, { children: [jsx$1(ButtonInternals, __assign$F({ afterSlot, beforeSlot }, { children })), !disableRipple && jsx$1("span", { className: "eds-button__ripple" })] }));
};
var __assign$E = globalThis && globalThis.__assign || function() {
  __assign$E = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$E.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var __assign$D = globalThis && globalThis.__assign || function() {
  __assign$D = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$D.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
const nike$1 = {
  podiumCdsColorBlack: "#111111",
  podiumCdsColorWhite: "#FFFFFF",
  podiumCdsColorRed50: "#FFE5E5",
  podiumCdsColorRed100: "#FFC3C4",
  podiumCdsColorRed200: "#FFABAD",
  podiumCdsColorRed300: "#FF7975",
  podiumCdsColorRed400: "#FF4E4A",
  podiumCdsColorRed500: "#EE0005",
  podiumCdsColorRed600: "#D30005",
  podiumCdsColorRed700: "#A70E00",
  podiumCdsColorRed800: "#780700",
  podiumCdsColorRed900: "#530300",
  podiumCdsColorOrange50: "#FFE2D6",
  podiumCdsColorOrange100: "#FFC5AD",
  podiumCdsColorOrange200: "#FFA584",
  podiumCdsColorOrange300: "#FF8255",
  podiumCdsColorOrange400: "#FF5000",
  podiumCdsColorOrange500: "#D33918",
  podiumCdsColorOrange600: "#9F290F",
  podiumCdsColorOrange700: "#7E200D",
  podiumCdsColorOrange800: "#5D180C",
  podiumCdsColorOrange900: "#3E1009",
  podiumCdsColorYellow50: "#FEF087",
  podiumCdsColorYellow100: "#FEEA55",
  podiumCdsColorYellow200: "#FEDF35",
  podiumCdsColorYellow300: "#FFD11B",
  podiumCdsColorYellow400: "#FDC400",
  podiumCdsColorYellow500: "#FCA600",
  podiumCdsColorYellow600: "#F08E0A",
  podiumCdsColorYellow700: "#E57A09",
  podiumCdsColorYellow800: "#CD6006",
  podiumCdsColorYellow900: "#99470A",
  podiumCdsColorGreen50: "#DFFFB9",
  podiumCdsColorGreen100: "#BDFB72",
  podiumCdsColorGreen200: "#83F13B",
  podiumCdsColorGreen300: "#5FE63F",
  podiumCdsColorGreen400: "#3CCD49",
  podiumCdsColorGreen500: "#1EAA52",
  podiumCdsColorGreen600: "#007D48",
  podiumCdsColorGreen700: "#00643E",
  podiumCdsColorGreen800: "#005034",
  podiumCdsColorGreen900: "#003C2A",
  podiumCdsColorBlue50: "#D6EEFF",
  podiumCdsColorBlue100: "#B9E2FF",
  podiumCdsColorBlue200: "#87CEFF",
  podiumCdsColorBlue300: "#4CABFF",
  podiumCdsColorBlue400: "#1190FF",
  podiumCdsColorBlue500: "#1151FF",
  podiumCdsColorBlue600: "#0034E3",
  podiumCdsColorBlue700: "#061DBB",
  podiumCdsColorBlue800: "#02068E",
  podiumCdsColorBlue900: "#020664",
  podiumCdsColorTeal50: "#D4FFFB",
  podiumCdsColorTeal100: "#9CFFF7",
  podiumCdsColorTeal200: "#69EEE7",
  podiumCdsColorTeal300: "#31CBCB",
  podiumCdsColorTeal400: "#1CB2B6",
  podiumCdsColorTeal500: "#008E98",
  podiumCdsColorTeal600: "#0A7281",
  podiumCdsColorTeal700: "#005C68",
  podiumCdsColorTeal800: "#004856",
  podiumCdsColorTeal900: "#043441",
  podiumCdsColorPurple50: "#E4E1FC",
  podiumCdsColorPurple100: "#D6D1FF",
  podiumCdsColorPurple200: "#BEAFFD",
  podiumCdsColorPurple300: "#A082FF",
  podiumCdsColorPurple400: "#8755FF",
  podiumCdsColorPurple500: "#6E0FF6",
  podiumCdsColorPurple600: "#5400CC",
  podiumCdsColorPurple700: "#4400A9",
  podiumCdsColorPurple800: "#300080",
  podiumCdsColorPurple900: "#1C0060",
  podiumCdsColorPink50: "#FFE1F3",
  podiumCdsColorPink100: "#FFCDEA",
  podiumCdsColorPink200: "#FFB0DD",
  podiumCdsColorPink300: "#FE90CC",
  podiumCdsColorPink400: "#FC5DBB",
  podiumCdsColorPink500: "#ED1AA0",
  podiumCdsColorPink600: "#D00B84",
  podiumCdsColorPink700: "#A50767",
  podiumCdsColorPink800: "#770349",
  podiumCdsColorPink900: "#4C012D",
  podiumCdsColorGrey50: "#FAFAFA",
  podiumCdsColorGrey100: "#F5F5F5",
  podiumCdsColorGrey200: "#E5E5E5",
  podiumCdsColorGrey300: "#CACACB",
  podiumCdsColorGrey400: "#9E9EA0",
  podiumCdsColorGrey500: "#707072",
  podiumCdsColorGrey600: "#4B4B4D",
  podiumCdsColorGrey700: "#39393B",
  podiumCdsColorGrey800: "#28282A",
  podiumCdsColorGrey900: "#1F1F21",
  podiumCdsColorBrandRed: "#EE0005",
  podiumCdsColorBrandOrange: "#FF5000",
  podiumCdsColorGradientBrandOrange: "linear-gradient(113.7deg, #FF0015 3.64%, #FF5000 50.92%, #FF6A00 97.26%)",
  podiumCdsColorBgPrimary: "#FFFFFF",
  podiumCdsColorBgSecondary: "#F5F5F5",
  podiumCdsColorBgActive: "#F5F5F5",
  podiumCdsColorBgHover: "#E5E5E5",
  podiumCdsColorBgWarning: "#FEDF35",
  podiumCdsColorBgCritical: "#D30005",
  podiumCdsColorBgSuccess: "#007D48",
  podiumCdsColorBgDisabled: "#E5E5E5",
  podiumCdsColorBgPrimaryInverse: "#111111",
  podiumCdsColorBgSecondaryInverse: "#1F1F21",
  podiumCdsColorBgActiveInverse: "#28282A",
  podiumCdsColorBgHoverInverse: "#28282A",
  podiumCdsColorBgWarningInverse: "#FEEA55",
  podiumCdsColorBgCriticalInverse: "#FF4E4A",
  podiumCdsColorBgSuccessInverse: "#1EAA52",
  podiumCdsColorBgDisabledInverse: "#39393B",
  podiumCdsColorBgAlwaysDark: "#111111",
  podiumCdsColorBgAlwaysLight: "#FFFFFF",
  podiumCdsColorTextPrimary: "#111111",
  podiumCdsColorTextSecondary: "#707072",
  podiumCdsColorTextHover: "#707072",
  podiumCdsColorTextDisabled: "#CACACB",
  podiumCdsColorTextCritical: "#D30005",
  podiumCdsColorTextSuccess: "#007D48",
  podiumCdsColorTextLink: "#1151FF",
  podiumCdsColorTextPrimaryInverse: "#FFFFFF",
  podiumCdsColorTextSecondaryInverse: "#9E9EA0",
  podiumCdsColorTextHoverInverse: "#9E9EA0",
  podiumCdsColorTextDisabledInverse: "#4B4B4D",
  podiumCdsColorTextCriticalInverse: "#FF4E4A",
  podiumCdsColorTextSuccessInverse: "#1EAA52",
  podiumCdsColorTextLinkInverse: "#1190FF",
  podiumCdsColorBorderPrimary: "#707072",
  podiumCdsColorBorderActive: "#111111",
  podiumCdsColorBorderCritical: "#D30005",
  podiumCdsColorBorderSuccess: "#007D48",
  podiumCdsColorBorderDisabled: "#CACACB",
  podiumCdsColorBorderFocus: "#1151FF",
  podiumCdsColorBorderFocusInverse: "#1190FF",
  podiumCdsColorBorderDisabledInverse: "#39393B",
  podiumCdsColorBorderSuccessInverse: "#1EAA52",
  podiumCdsColorBorderCriticalInverse: "#FF4E4A",
  podiumCdsColorBorderActiveInverse: "#FFFFFF",
  podiumCdsColorBorderPrimaryInverse: "#9E9EA0",
  podiumCdsColorCritical: "#D30005",
  podiumCdsColorCriticalInverse: "#FF4E4A",
  podiumCdsColorSuccess: "#007D48",
  podiumCdsColorSuccessInverse: "#1EAA52",
  podiumCdsColorInfo: "#1151FF",
  podiumCdsColorInfoInverse: "#1190FF",
  podiumCdsColorWarning: "#FEDF35",
  podiumCdsColorWarningInverse: "#FEEA55",
  podiumCdsColorFocusRing: "#F5F5F5",
  podiumCdsColorBoxFocusRing: "rgba(39, 93, 197, 1)",
  podiumCdsButtonBorderRadius: "30px",
  podiumCdsButtonBorderWidth: "1.5px",
  podiumCdsButtonBoxShadowWidth: "0",
  podiumCdsButtonBoxShadowHoverWidth: "0",
  podiumCdsButtonTextDecorationLine: "underline",
  podiumCdsButtonPaddingTopS: "6px",
  podiumCdsButtonPaddingTopM: "12px",
  podiumCdsButtonPaddingTopL: "18px",
  podiumCdsButtonPaddingBottomS: "6px",
  podiumCdsButtonPaddingBottomM: "12px",
  podiumCdsButtonPaddingBottomL: "18px",
  podiumCdsButtonPaddingSidesS: "20px",
  podiumCdsButtonPaddingSidesM: "24px",
  podiumCdsButtonPaddingSidesL: "24px",
  podiumCdsButtonPaddingUnderline: "0",
  podiumCdsButtonHeightS: "34px",
  podiumCdsButtonHeightM: "46px",
  podiumCdsButtonHeightL: "58px",
  podiumCdsButtonColorBgPrimary: "#111111",
  podiumCdsButtonColorBgPrimaryInverse: "#FFFFFF",
  podiumCdsButtonColorBgPrimaryHover: "#707072",
  podiumCdsButtonColorBgPrimaryHoverInverse: "#9E9EA0",
  podiumCdsButtonColorBgPrimaryDisabled: "#E5E5E5",
  podiumCdsButtonColorBgPrimaryDisabledInverse: "#707072",
  podiumCdsButtonColorBgSecondary: "transparent",
  podiumCdsButtonColorBgSecondaryInverse: "transparent",
  podiumCdsButtonColorTextPrimaryDisabled: "#9E9EA0",
  podiumCdsButtonColorTextPrimaryDisabledInverse: "#4B4B4D",
  podiumCdsButtonColorBorderPrimary: "#111111",
  podiumCdsButtonColorBorderPrimaryInverse: "#FFFFFF",
  podiumCdsButtonColorBorderPrimaryHover: "#707072",
  podiumCdsButtonColorBorderPrimaryHoverInverse: "#9E9EA0",
  podiumCdsButtonColorBorderPrimaryDisabled: "#E5E5E5",
  podiumCdsButtonColorBorderPrimaryDisabledInverse: "#707072",
  podiumCdsButtonColorBorderSecondary: "#CACACB",
  podiumCdsButtonColorBorderSecondaryInverse: "#707072",
  podiumCdsButtonColorBorderSecondaryHover: "#111111",
  podiumCdsButtonColorBorderSecondaryHoverInverse: "#FFFFFF",
  podiumCdsButtonColorBorderSecondaryDisabled: "#CACACB",
  podiumCdsButtonColorBorderSecondaryDisabledInverse: "#4B4B4D",
  podiumCdsDialogBgBlur: "4px",
  podiumCdsInputColorDisabled: "#707072",
  podiumCdsElevation10: "10",
  podiumCdsElevation20: "20",
  podiumCdsElevation30: "30",
  podiumCdsElevation40: "40",
  podiumCdsElevation50: "50",
  podiumCdsElevation60: "60",
  podiumCdsElevation70: "70",
  podiumCdsElevation80: "80",
  podiumCdsElevation90: "90",
  podiumCdsElevation100: "100",
  podiumCdsFontWeightRegular: "400",
  podiumCdsFontWeightMedium: "500",
  podiumCdsFontWeightBold: "700",
  podiumCdsFontSizeXxs: "12px",
  podiumCdsFontSizeXs: "14px",
  podiumCdsFontSizeS: "16px",
  podiumCdsFontSizeM: "20px",
  podiumCdsFontSizeL: "24px",
  podiumCdsFontSizeXl: "28px",
  podiumCdsFontSizeXxl: "32px",
  podiumCdsFontSizeXxxl: "40px",
  podiumCdsFontSizeXxxxl: "48px",
  podiumCdsFontSizeXxxxxl: "72px",
  podiumCdsFontStyleNormal: "normal",
  podiumCdsShadow10: "0px 1px 2px rgba(17, 17, 17, 0.04), 0px 2px 6px rgba(17, 17, 17, 0.08)",
  podiumCdsShadow20: "0px 2px 3px rgba(17, 17, 17, 0.04), 0px 4px 12px rgba(17, 17, 17, 0.08)",
  podiumCdsShadow30: "0px 4px 8px rgba(17, 17, 17, 0.04), 0px 8px 24px rgba(17, 17, 17, 0.08)",
  podiumCdsShadow40: "0px 8px 16px rgba(17, 17, 17, 0.04), 0px 16px 48px rgba(17, 17, 17, 0.08)",
  podiumCdsSizeSpacingXs: "4px",
  podiumCdsSizeSpacingS: "8px",
  podiumCdsSizeSpacingM: "12px",
  podiumCdsSizeSpacingL: "24px",
  podiumCdsSizeSpacingXl: "36px",
  podiumCdsSizeSpacingXxl: "60px",
  podiumCdsSizeSpacingXxxl: "84px",
  podiumCdsSizeSpacingXxxxl: "120px",
  podiumCdsSizeSpacingGridGutter: "16px",
  podiumCdsSizeSpacingGridGutterL: "12px",
  podiumCdsSizeSpacingGridExteriorGutterS: "24px",
  podiumCdsSizeSpacingGridExteriorGutterL: "48px",
  podiumCdsSizeBorderRadiusS: "4px",
  podiumCdsSizeBorderRadiusM: "8px",
  podiumCdsSizeBorderRadiusL: "12px",
  podiumCdsSizeBorderRadiusXl: "24px",
  podiumCdsSizeBorderWidthS: "1px",
  podiumCdsSizeBorderWidthM: "1.5px",
  podiumCdsSizeBorderWidthL: "2px",
  podiumCdsSizeIconS: "16px",
  podiumCdsSizeIconM: "24px",
  podiumCdsSizeIconL: "48px",
  podiumCdsSizeFormInputContainerHeight: "84px",
  podiumCdsSizeFormInputFieldHeight: "56px",
  podiumCdsTransitionTimingFunctionEase: "cubic-bezier(.25, .1, .25, 1)",
  podiumCdsTransitionDurationFast: "150ms",
  podiumCdsTransitionDurationNormal: "250ms",
  podiumCdsBreakpointXs: "320px",
  podiumCdsBreakpointS: "600px",
  podiumCdsBreakpointM: "960px",
  podiumCdsBreakpointL: "1440px",
  podiumCdsBreakpointXl: "1920px",
  podiumCdsFormShadowFocus: "0 0 0 12px #F5F5F5",
  i18nTokens: {
    "ca-es": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display1: "800 3rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display2: "800 2.5rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display3: "800 2rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display4: "800 1.5rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.5 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display1: "800 6rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display2: "800 4.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display3: "800 3.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display4: "800 3rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay1: "800 7.5rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay2: "800 6rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay3: "800 4.75rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay4: "800 3.75rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif"
    },
    "cs-cz": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display1: "800 3rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display2: "800 2.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display3: "800 2rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display4: "800 1.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.5 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display1: "800 6rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display2: "800 4.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display3: "800 3.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display4: "800 3rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay1: "800 7.5rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay2: "800 6rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay3: "800 4.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay4: "800 3.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif"
    },
    "da-dk": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display1: "800 3rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display2: "800 2.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display3: "800 2rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display4: "800 1.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.5 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display1: "800 6rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display2: "800 4.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display3: "800 3.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display4: "800 3rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay1: "800 7.5rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay2: "800 6rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay3: "800 4.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay4: "800 3.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif"
    },
    "de-de": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display1: "800 3rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display2: "800 2.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display3: "800 2rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display4: "800 1.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.5 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display1: "800 6rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display2: "800 4.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display3: "800 3.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display4: "800 3rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay1: "800 7.5rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay2: "800 6rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay3: "800 4.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay4: "800 3.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif"
    },
    "el-gr": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.2 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.2 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.2 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display1: "800 3rem/1.1 'Nike Futura ND','HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display2: "800 2.5rem/1.1 'Nike Futura ND','HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display3: "800 2rem/1.2 'Nike Futura ND','HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display4: "800 1.5rem/1.2 'Nike Futura ND','HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.2 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.2 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.2 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.5 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.5 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.5 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.2 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.2 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.2 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.2 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1.2 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.2 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.2 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display1: "800 6rem/1 'Nike Futura ND','HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display2: "800 4.75rem/1 'Nike Futura ND','HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display3: "800 3.75rem/1 'Nike Futura ND','HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display4: "800 3rem/1.1 'Nike Futura ND','HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.2 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.2 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.2 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.2 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.5 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.5 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.1 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1.2 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1.2 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1.2 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay1: "800 7.5rem/1 'Nike Futura ND','HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay2: "800 6rem/1 'Nike Futura ND','HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay3: "800 4.75rem/1 'Nike Futura ND','HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay4: "800 3.75rem/1 'Nike Futura ND','HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.2 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.2 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.2 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.2 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.2 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.2 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.2 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.5 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.5 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.5 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.5 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.5 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.5 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.5 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.5 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif"
    },
    "en-ca": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display1: "800 3rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display2: "800 2.5rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display3: "800 2rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display4: "800 1.5rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display1: "800 6rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display2: "800 4.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display3: "800 3.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display4: "800 3rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay1: "800 7.5rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay2: "800 6rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay3: "800 4.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay4: "800 3.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif"
    },
    "en-gb": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display1: "800 3rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display2: "800 2.5rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display3: "800 2rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display4: "800 1.5rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display1: "800 6rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display2: "800 4.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display3: "800 3.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display4: "800 3rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay1: "800 7.5rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay2: "800 6rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay3: "800 4.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay4: "800 3.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif"
    },
    "en-jp": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display1: "800 3rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display2: "800 2.5rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display3: "800 2rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display4: "800 1.5rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display1: "800 6rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display2: "800 4.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display3: "800 3.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display4: "800 3rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay1: "800 7.5rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay2: "800 6rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay3: "800 4.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay4: "800 3.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif"
    },
    "en-us": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display1: "800 3rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display2: "800 2.5rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display3: "800 2rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display4: "800 1.5rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display1: "800 6rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display2: "800 4.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display3: "800 3.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display4: "800 3rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay1: "800 7.5rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay2: "800 6rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay3: "800 4.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay4: "800 3.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif"
    },
    "es-ar": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display1: "800 3rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display2: "800 2.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display3: "800 2rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display4: "800 1.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.5 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display1: "800 6rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display2: "800 4.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display3: "800 3.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display4: "800 3rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay1: "800 7.5rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay2: "800 6rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay3: "800 4.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay4: "800 3.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif"
    },
    "es-ca": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display1: "800 3rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display2: "800 2.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display3: "800 2rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display4: "800 1.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.5 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display1: "800 6rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display2: "800 4.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display3: "800 3.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display4: "800 3rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay1: "800 7.5rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay2: "800 6rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay3: "800 4.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay4: "800 3.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif"
    },
    "es-cl": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display1: "800 3rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display2: "800 2.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display3: "800 2rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display4: "800 1.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.5 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display1: "800 6rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display2: "800 4.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display3: "800 3.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display4: "800 3rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay1: "800 7.5rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay2: "800 6rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay3: "800 4.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay4: "800 3.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif"
    },
    "es-es": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display1: "800 3rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display2: "800 2.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display3: "800 2rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display4: "800 1.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.5 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display1: "800 6rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display2: "800 4.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display3: "800 3.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display4: "800 3rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay1: "800 7.5rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay2: "800 6rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay3: "800 4.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay4: "800 3.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif"
    },
    "es-la": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display1: "800 3rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display2: "800 2.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display3: "800 2rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display4: "800 1.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.5 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display1: "800 6rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display2: "800 4.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display3: "800 3.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display4: "800 3rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay1: "800 7.5rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay2: "800 6rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay3: "800 4.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay4: "800 3.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif"
    },
    "es-mx": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display1: "800 3rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display2: "800 2.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display3: "800 2rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display4: "800 1.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.5 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display1: "800 6rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display2: "800 4.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display3: "800 3.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display4: "800 3rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay1: "800 7.5rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay2: "800 6rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay3: "800 4.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay4: "800 3.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif"
    },
    "es-uy": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display1: "800 3rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display2: "800 2.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display3: "800 2rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display4: "800 1.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.5 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display1: "800 6rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display2: "800 4.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display3: "800 3.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display4: "800 3rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay1: "800 7.5rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay2: "800 6rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay3: "800 4.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay4: "800 3.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif"
    },
    "fr-fr": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display1: "800 3rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display2: "800 2.5rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display3: "800 2rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display4: "800 1.5rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.5 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display1: "800 6rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display2: "800 4.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display3: "800 3.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display4: "800 3rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay1: "800 7.5rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay2: "800 6rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay3: "800 4.75rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay4: "800 3.75rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif"
    },
    "hu-hu": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display1: "800 3rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display2: "800 2.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display3: "800 2rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display4: "800 1.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.5 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display1: "800 6rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display2: "800 4.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display3: "800 3.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display4: "800 3rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay1: "800 7.5rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay2: "800 6rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay3: "800 4.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay4: "800 3.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif"
    },
    "it-it": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display1: "800 3rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display2: "800 2.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display3: "800 2rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display4: "800 1.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.5 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display1: "800 6rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display2: "800 4.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display3: "800 3.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display4: "800 3rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay1: "800 7.5rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay2: "800 6rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay3: "800 4.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay4: "800 3.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif"
    },
    "ja-jp": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.35 'Noto Sans JP Medium', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.35 'Noto Sans JP Medium', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.35 'Noto Sans JP Medium', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography320To959Display1: "900 3rem/1.2 'Noto Sans JP Black', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography320To959Display2: "900 2.5rem/1.2 'Noto Sans JP Black', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography320To959Display3: "900 2rem/1.25 'Noto Sans JP Black', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography320To959Display4: "900 1.5rem/1.25 'Noto Sans JP Black', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.5 'Noto Sans JP', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.5 'Noto Sans JP', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.5 'Noto Sans JP', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.75 'Noto Sans JP', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.75 'Noto Sans JP', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.75 'Noto Sans JP Medium', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.5 'Noto Sans JP Medium', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.5 'Noto Sans JP Medium', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.5 'Noto Sans JP Medium', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.75 'Noto Sans JP Medium', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1.35 'Noto Sans JP Medium', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.35 'Noto Sans JP Medium', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.35 'Noto Sans JP Medium', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography960To1919Display1: "900 6rem/1.2 'Noto Sans JP Black', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography960To1919Display2: "900 4.75rem/1.2 'Noto Sans JP Black', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography960To1919Display3: "900 3.75rem/1.2 'Noto Sans JP Black', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography960To1919Display4: "900 3rem/1.2 'Noto Sans JP Black', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.5 'Noto Sans JP', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.5 'Noto Sans JP', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.5 'Noto Sans JP', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.75 'Noto Sans JP', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.75 'Noto Sans JP', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.75 'Noto Sans JP Medium', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1.35 'Noto Sans JP Medium', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1.35 'Noto Sans JP Medium', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.35 'Noto Sans JP Medium', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1.35 'Noto Sans JP Medium', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1.35 'Noto Sans JP Medium', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1.35 'Noto Sans JP Medium', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography1920PlusDisplay1: "900 7.5rem/1.2 'Noto Sans JP Black', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography1920PlusDisplay2: "900 6rem/1.2 'Noto Sans JP Black', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography1920PlusDisplay3: "900 4.75rem/1.2 'Noto Sans JP Black', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography1920PlusDisplay4: "900 3.75rem/1.2 'Noto Sans JP Black', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.5 'Noto Sans JP Medium', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.5 'Noto Sans JP Medium', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.5 'Noto Sans JP Medium', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.5 'Noto Sans JP Medium', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.5 'Noto Sans JP', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.5 'Noto Sans JP', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.5 'Noto Sans JP', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.75 'Noto Sans JP', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.75 'Noto Sans JP', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.75 'Noto Sans JP Medium', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.75 'Noto Sans JP', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.75 'Noto Sans JP Medium', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.75 'Noto Sans JP', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.75 'Noto Sans JP Medium', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.75 'Noto Sans JP', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4', 'MS Pgothic', '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', sans-serif"
    },
    "ko-kr": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.35 'Noto Sans KR Medium', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.35 'Noto Sans KR Medium', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.35 'Noto Sans KR Medium', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography320To959Display1: "900 3rem/1.2 'Noto Sans KR Black', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography320To959Display2: "900 2.5rem/1.2 'Noto Sans KR Black', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography320To959Display3: "900 2rem/1.25 'Noto Sans KR Black', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography320To959Display4: "900 1.5rem/1.25 'Noto Sans KR Black', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.5 'Noto Sans KR', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.5 'Noto Sans KR', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.5 'Noto Sans KR', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.25 'Noto Sans KR', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.75 'Noto Sans KR', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.75 'Noto Sans KR Medium', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.5 'Noto Sans KR Medium', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.5 'Noto Sans KR Medium', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.5 'Noto Sans KR Medium', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.75 'Noto Sans KR Medium', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1.35 'Noto Sans KR Medium', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.35 'Noto Sans KR Medium', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.35 'Noto Sans KR Medium', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography960To1919Display1: "900 6rem/1.2 'Noto Sans KR Black', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography960To1919Display2: "900 4.75rem/1.2 'Noto Sans KR Black', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography960To1919Display3: "900 3.75rem/1.2 'Noto Sans KR Black', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography960To1919Display4: "900 3rem/1.2 'Noto Sans KR Black', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.5 'Noto Sans KR', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.5 'Noto Sans KR', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.5 'Noto Sans KR', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.75 'Noto Sans KR', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.75 'Noto Sans KR', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.75 'Noto Sans KR Medium', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1.35 'Noto Sans KR Medium', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1.35 'Noto Sans KR Medium', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.35 'Noto Sans KR Medium', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1.35 'Noto Sans KR Medium', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1.35 'Noto Sans KR Medium', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1.35 'Noto Sans KR Medium', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography1920PlusDisplay1: "900 7.5rem/1.2 'Noto Sans KR Black', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography1920PlusDisplay2: "900 6rem/1.2 'Noto Sans KR Black', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography1920PlusDisplay3: "900 4.75rem/1.2 'Noto Sans KR Black', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography1920PlusDisplay4: "900 3.75rem/1.2 'Noto Sans KR Black', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.5 'Noto Sans KR Medium', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.5 'Noto Sans KR Medium', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.5 'Noto Sans KR Medium', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.5 'Noto Sans KR Medium', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.5 'Noto Sans KR', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.5 'Noto Sans KR', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.5 'Noto Sans KR', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.75 'Noto Sans KR', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.75 'Noto Sans KR Regular', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.75 'Noto Sans KR Medium', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.75 'Noto Sans KR Regular', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.75 'Noto Sans KR Medium', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.75 'Noto Sans KR Regular', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.75 'Noto Sans KR Medium', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.75 'Noto Sans KR Regular', Helvetica, Arial, 'Apple SD Gothic Neo', 'Apple SD \uC0B0\uB3CC\uACE0\uB515 Neo', 'Malgun Gothic', '\uB9D1\uC740 \uACE0\uB515', sans-serif"
    },
    "nl-en": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display1: "800 3rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display2: "800 2.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display3: "800 2rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display4: "800 1.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.5 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display1: "800 6rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display2: "800 4.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display3: "800 3.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display4: "800 3rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay1: "800 7.5rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay2: "800 6rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay3: "800 4.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay4: "800 3.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif"
    },
    "nl-nl": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display1: "800 3rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display2: "800 2.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display3: "800 2rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display4: "800 1.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.5 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display1: "800 6rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display2: "800 4.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display3: "800 3.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display4: "800 3rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay1: "800 7.5rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay2: "800 6rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay3: "800 4.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay4: "800 3.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif"
    },
    "no-no": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display1: "800 3rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display2: "800 2.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display3: "800 2rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display4: "800 1.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.5 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display1: "800 6rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display2: "800 4.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display3: "800 3.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display4: "800 3rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay1: "800 7.5rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay2: "800 6rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay3: "800 4.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay4: "800 3.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif"
    },
    "pl-pl": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display1: "800 3rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display2: "800 2.5rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display3: "800 2rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display4: "800 1.5rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.5 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display1: "800 6rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display2: "800 4.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display3: "800 3.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display4: "800 3rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay1: "800 7.5rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay2: "800 6rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay3: "800 4.75rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay4: "800 3.75rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif"
    },
    "pt-br": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display1: "800 3rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display2: "800 2.5rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display3: "800 2rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display4: "800 1.5rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.5 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display1: "800 6rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display2: "800 4.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display3: "800 3.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display4: "800 3rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay1: "800 7.5rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay2: "800 6rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay3: "800 4.75rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay4: "800 3.75rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif"
    },
    "pt-pt": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display1: "800 3rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display2: "800 2.5rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display3: "800 2rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display4: "800 1.5rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.5 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display1: "800 6rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display2: "800 4.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display3: "800 3.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display4: "800 3rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay1: "800 7.5rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay2: "800 6rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay3: "800 4.75rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay4: "800 3.75rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif"
    },
    "ru-ru": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.2 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.2 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.2 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display1: "800 3rem/1.1 'Nike Futura ND','HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display2: "800 2.5rem/1.2 'Nike Futura ND','HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display3: "800 2rem/1.2 'Nike Futura ND','HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display4: "800 1.5rem/1.2 'Nike Futura ND','HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.2 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.2 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.2 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.5 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.5 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.5 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.2 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.2 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.2 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.5 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1.2 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.2 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.2 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display1: "800 6rem/1.1 'Nike Futura ND','HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display2: "800 4.75rem/1.1 'Nike Futura ND','HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display3: "800 3.75rem/1.1 'Nike Futura ND','HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display4: "800 3rem/1.1 'Nike Futura ND','HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.2 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.2 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.2 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.5 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.5 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.5 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1.2 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1.2 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.2 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1.2 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1.2 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1.2 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay1: "800 7.5rem/1.1 'Nike Futura ND','HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay2: "800 6rem/1.1 'Nike Futura ND','HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay3: "800 4.75rem/1.1 'Nike Futura ND','HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay4: "800 3.75rem/1.1 'Nike Futura ND','HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.2 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.2 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.2 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.2 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.2 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.2 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.2 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.5 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.5 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.5 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.5 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.5 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.5 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.5 'HelveticaNeueLTW1G-Md', Helvetica, Arial, sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.5 'HelveticaNeueLTW1G-Roman', Helvetica, Arial, sans-serif"
    },
    "sv-se": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display1: "800 3rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display2: "800 2.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display3: "800 2rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display4: "800 1.5rem/1.1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.5 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display1: "800 6rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display2: "800 4.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display3: "800 3.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display4: "800 3rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay1: "800 7.5rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay2: "800 6rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay3: "800 4.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay4: "800 3.75rem/1 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif"
    },
    "th-th": {
      podiumCdsTypography320To959Oversize1: "700 6rem/1.75 'Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography320To959Oversize2: "700 4.75rem/1.75 'Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography320To959Oversize3: "700 3.75rem/1.75 'Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography320To959Display1: "800 3rem/1.75 'AvenirNextThaiModern-XtraBd','Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography320To959Display2: "800 2.5rem/1.75 'AvenirNextThaiModern-XtraBd','Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography320To959Display3: "800 2rem/1.75 'AvenirNextThaiModern-XtraBd','Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography320To959Display4: "800 1.5rem/1.75 'AvenirNextThaiModern-XtraBd','Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.75 'Helvetica Neue LT Thai', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.75 'Helvetica Neue LT Thai', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.75 'Helvetica Neue LT Thai', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.75 'Helvetica Neue LT Thai', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.75 'Helvetica Neue LT Thai', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.75 'Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography320To1919Title1: "700 2.5rem/1.75 'Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography320To1919Title2: "700 2rem/1.75 'Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography320To1919Title3: "700 1.5rem/1.75 'Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography320To1919Title4: "700 1.25rem/1.75 'Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography960To1439Oversize1: "700 7.5rem/1.75 'Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography960To1439Oversize2: "700 6rem/1.75 'Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography960To1439Oversize3: "700 4.75rem/1.75 'Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography960To1439Title1: "700 2.5rem/1.75 'Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography960To1439Title2: "700 2rem/1.75 'Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography960To1439Title3: "700 1.5rem/1.75 'Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography960To1439Title4: "700 1.25rem/1.75 'Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography960To1919Display1: "800 6rem/1.75 'AvenirNextThaiModern-XtraBd','Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography960To1919Display2: "800 4.75rem/1.75 'AvenirNextThaiModern-XtraBd','Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography960To1919Display3: "800 3.75rem/1.75 'AvenirNextThaiModern-XtraBd','Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography960To1919Display4: "800 3rem/1.75 'AvenirNextThaiModern-XtraBd','Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.75 'Helvetica Neue LT Thai', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.75 'Helvetica Neue LT Thai', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.75 'Helvetica Neue LT Thai', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.75 'Helvetica Neue LT Thai', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.75 'Helvetica Neue LT Thai', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.75 'Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography1440To1919Oversize1: "700 9.375rem/1.75 'Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography1440To1919Oversize2: "700 7.5rem/1.75 'Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography1440To1919Oversize3: "700 6rem/1.75 'Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography1920PlusOversize1: "700 11.625rem/1.75 'Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography1920PlusOversize2: "700 9.375rem/1.75 'Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography1920PlusOversize3: "700 7.5rem/1.75 'Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography1920PlusDisplay1: "800 7.5rem/1.75 'AvenirNextThaiModern-XtraBd','Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography1920PlusDisplay2: "800 6rem/1.75 'AvenirNextThaiModern-XtraBd','Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography1920PlusDisplay3: "800 4.75rem/1.75 'AvenirNextThaiModern-XtraBd','Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography1920PlusDisplay4: "800 3.75rem/1.75 'AvenirNextThaiModern-XtraBd','Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography1920PlusTitle1: "700 3rem/1.75 'Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography1920PlusTitle2: "700 2.5rem/1.75 'Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography1920PlusTitle3: "700 2rem/1.75 'Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography1920PlusTitle4: "700 1.5rem/1.75 'Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.75 'Helvetica Neue LT Thai', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.75 'Helvetica Neue LT Thai', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.75 'Helvetica Neue LT Thai', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.75 'Helvetica Neue LT Thai', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.75 'Helvetica Neue LT Thai', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypographyBody1Strong: "700 1rem/1.75 'Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.75 'Helvetica Neue LT Thai', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypographyBody2Strong: "700 .875rem/1.75 'Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.75 'Helvetica Neue LT Thai', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypographyBody3Strong: "700 .75rem/1.75 'Helvetica Neue LT Thai Bold', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.75 'Helvetica Neue LT Thai', Helvetica, Arial, Krungthep, '\u0E01\u0E23\u0E38\u0E07\u0E40\u0E17\u0E1E', Thonburi, '\u0E18\u0E19\u0E1A\u0E38\u0E23\u0E35', 'Leelawadee UI', '\u0E25\u0E35\u0E25\u0E32\u0E27\u0E14\u0E35 UI', Tahoma, '\u0E17\u0E32\u0E42\u0E2E\u0E21\u0E48\u0E32', sans-serif"
    },
    "tr-tr": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display1: "800 3rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display2: "800 2.5rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display3: "800 2rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Display4: "800 1.5rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.5 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display1: "800 6rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display2: "800 4.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display3: "800 3.75rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Display4: "800 3rem/.9 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.1 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay1: "800 7.5rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay2: "800 6rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay3: "800 4.75rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusDisplay4: "800 3.75rem/1.25 'Nike Futura ND', 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.2 'Helvetica Now Display Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.25 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.35 'Palatino LT Pro Light', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.5 'Helvetica Now Text Medium', Helvetica, Arial, sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.5 'Helvetica Now Text', Helvetica, Arial, sans-serif"
    },
    "zh-cn": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.35 'Noto Sans SC Medium', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.35 'Noto Sans SC Medium', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.35 'Noto Sans SC Medium', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography320To959Display1: "400 3rem/1.1 'NikeSC365', 'Noto Sans SC Black', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography320To959Display2: "400 2.5rem/1.1 'NikeSC365', 'Noto Sans SC Black', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography320To959Display3: "400 2rem/1.2 'NikeSC365', 'Noto Sans SC Black', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography320To959Display4: "400 1.5rem/1.2 'NikeSC365', 'Noto Sans SC Black', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.2 'Noto Sans SC', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.2 'Noto Sans SC', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.5 'Noto Sans SC', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.75 'Noto Sans SC', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.75 'Noto Sans SC', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.75 'Noto Sans SC Medium', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.5 'Noto Sans SC Medium', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.5 'Noto Sans SC Medium', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.5 'Noto Sans SC Medium', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.75 'Noto Sans SC Medium', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1.35 'Noto Sans SC Medium', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.35 'Noto Sans SC Medium', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/135 'Noto Sans SC Medium', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography960To1919Display1: "400 6rem/1 'NikeSC365', 'Noto Sans SC Black', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography960To1919Display2: "400 4.75rem/1 'NikeSC365', 'Noto Sans SC Black', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography960To1919Display3: "400 3.75rem/1.1 'NikeSC365', 'Noto Sans SC Black', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography960To1919Display4: "400 3rem/1.1 'NikeSC365', 'Noto Sans SC Black', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.5 'Noto Sans SC', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.5 'Noto Sans SC', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.5 'Noto Sans SC', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.75 'Noto Sans SC', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.75 'Noto Sans SC', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.75 'Noto Sans SC Medium', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1.35 'Noto Sans SC Medium', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1.35 'Noto Sans SC Medium', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.35 'Noto Sans SC Medium', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1.35 'Noto Sans SC Medium', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1.35 'Noto Sans SC Medium', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1.35 'Noto Sans SC Medium', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography1920PlusDisplay1: "400 7.5rem/1 'NikeSC365', 'Noto Sans SC Black', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography1920PlusDisplay2: "400 6rem/1 'NikeSC365', 'Noto Sans SC Black', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography1920PlusDisplay3: "400 4.75rem/1 'NikeSC365', 'Noto Sans SC Black', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography1920PlusDisplay4: "400 3.75rem/1.1 'NikeSC365', 'Noto Sans SC Black', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.5 'Noto Sans SC Medium', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.5 'Noto Sans SC Medium', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.5 'Noto Sans SC Medium', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.5 'Noto Sans SC Medium', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.5 'Noto Sans SC', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.5 'Noto Sans SC', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.5 'Noto Sans SC', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.75 'Noto Sans SC', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.75 'Noto Sans SC', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.75 'Noto Sans SC Medium', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.75 'Noto Sans SC', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.75 'Noto Sans SC Medium', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.75 'Noto Sans SC', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.75 'Noto Sans SC Medium', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.75 'Noto Sans SC', Helvetica, Arial, 'PingFang SC', '\u82F9\u65B9-\u7B80', 'Heiti SC', '\u9ED1\u4F53-\u7B80', 'Microsoft YaHei', '\u5FAE\u8F6F\u96C5\u9ED1', sans-serif"
    },
    "zh-hk": {
      podiumCdsTypographyZhHk320To959Oversize1: "500 6rem/1.35 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk320To959Oversize2: "500 4.75rem/1.35 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk320To959Oversize3: "500 3.75rem/1.35 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk320To959Display1: "900 3rem/1.2 'Noto Sans TC Black', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk320To959Display2: "900 2.5rem/1.2 'Noto Sans TC Black', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk320To959Display3: "900 2rem/1.25 'Noto Sans TC Black', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk320To959Display4: "900 1.5rem/1.25 'Noto Sans TC Black', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk320To959Conversation1: "300 2rem/1.5 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk320To959Conversation2: "300 1.5rem/1.5 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk320To959Conversation3: "300 1.25rem/1.5 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk320To959Conversation4: "300 1rem/1.75 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk320To959EditorialBody1: "400 1rem/1.75 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk320To959EditorialBody1Strong: "500 1rem/1.75 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk320To1919Title1: "500 2.5rem/1.5 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk320To1919Title2: "500 2rem/1.5 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk320To1919Title3: "500 1.5rem/1.5 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk320To1919Title4: "500 1.25rem/1.75 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk960To1439Oversize1: "500 7.5rem/1.35 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk960To1439Oversize2: "500 6rem/1.35 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk960To1439Oversize3: "500 4.75rem/1.35 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk960To1919Display1: "900 6rem/1.2 'Noto Sans TC Black', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk960To1919Display2: "900 4.75rem/1.2 'Noto Sans TC Black', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk960To1919Display3: "900 3.75rem/1.2 'Noto Sans TC Black', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk960To1919Display4: "900 3rem/1.2 'Noto Sans TC Black', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk960To1919Conversation1: "300 3rem/1.5 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk960To1919Conversation2: "300 2.5rem/1.5 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk960To1919Conversation3: "300 2rem/1.5 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk960To1919Conversation4: "300 1.25rem/1.75 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk960PlusEditorialBody1: "400 1.25rem/1.75 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk960PlusEditorialBody1Strong: "500 1.25rem/1.75 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk1440To1919Oversize1: "500 9.375rem/1.35 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk1440To1919Oversize2: "500 7.5rem/1.35 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk1440To1919Oversize3: "500 6rem/1.35 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk1920PlusOversize1: "500 11.625rem/1.35 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk1920PlusOversize2: "500 9.375rem/1.35 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk1920PlusOversize3: "500 7.5rem/1.35 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk1920PlusDisplay1: "900 7.5rem/1 'Noto Sans TC Black', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk1920PlusDisplay2: "900 6rem/1 'Noto Sans TC Black', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk1920PlusDisplay3: "900 4.75rem/1 'Noto Sans TC Black', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk1920PlusDisplay4: "900 3.75rem/1.1 'Noto Sans TC Black', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk1920PlusTitle1: "500 3rem/1.5 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk1920PlusTitle2: "500 2.5rem/1.5 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk1920PlusTitle3: "500 2rem/1.5 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk1920PlusTitle4: "500 1.5rem/1.5 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk1920PlusConversation1: "300 3.75rem/1.5 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk1920PlusConversation2: "300 3rem/1.5 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk1920PlusConversation3: "300 2.5rem/1.5 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHk1920PlusConversation4: "300 1.25rem/1.75 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHkBody1: "400 1rem/1.75 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHkBody1Strong: "500 1rem/1.75 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHkBody2: "400 .875rem/1.75 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHkBody2Strong: "500 .875rem/1.75 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHkBody3: "400 .75rem/1.75 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHkBody3Strong: "500 .75rem/1.75 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyZhHkLegal: "400 .875rem/1.75 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif"
    },
    "zh-tw": {
      podiumCdsTypography320To959Oversize1: "500 6rem/1.35 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography320To959Oversize2: "500 4.75rem/1.35 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography320To959Oversize3: "500 3.75rem/1.35 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography320To959Display1: "900 3rem/1.2 'Noto Sans TC Black', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography320To959Display2: "900 2.5rem/1.2 'Noto Sans TC Black', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography320To959Display3: "900 2rem/1.25 'Noto Sans TC Black', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography320To959Display4: "900 1.5rem/1.25 'Noto Sans TC Black', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography320To959Conversation1: "300 2rem/1.5 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography320To959Conversation2: "300 1.5rem/1.5 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography320To959Conversation3: "300 1.25rem/1.5 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography320To959Conversation4: "300 1rem/1.75 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography320To959EditorialBody1: "400 1rem/1.75 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography320To959EditorialBody1Strong: "500 1rem/1.75 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography320To1919Title1: "500 2.5rem/1.5 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography320To1919Title2: "500 2rem/1.5 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography320To1919Title3: "500 1.5rem/1.5 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography320To1919Title4: "500 1.25rem/1.75 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography960To1439Oversize1: "500 7.5rem/1.35 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography960To1439Oversize2: "500 6rem/1.35 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography960To1439Oversize3: "500 4.75rem/1.35 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography960To1919Display1: "900 6rem/1.2 'Noto Sans TC Black', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography960To1919Display2: "900 4.75rem/1.2 'Noto Sans TC Black', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography960To1919Display3: "900 3.75rem/1.2 'Noto Sans TC Black', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography960To1919Display4: "900 3rem/1.2 'Noto Sans TC Black', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography960To1919Conversation1: "300 3rem/1.5 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography960To1919Conversation2: "300 2.5rem/1.5 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography960To1919Conversation3: "300 2rem/1.5 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography960To1919Conversation4: "300 1.25rem/1.75 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography960PlusEditorialBody1: "400 1.25rem/1.75 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography960PlusEditorialBody1Strong: "500 1.25rem/1.75 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography1440To1919Oversize1: "500 9.375rem/1.35 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography1440To1919Oversize2: "500 7.5rem/1.35 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography1440To1919Oversize3: "500 6rem/1.35 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography1920PlusOversize1: "500 11.625rem/1.35 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography1920PlusOversize2: "500 9.375rem/1.35 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography1920PlusOversize3: "500 7.5rem/1.35 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography1920PlusDisplay1: "900 7.5rem/1 'Noto Sans TC Black', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography1920PlusDisplay2: "900 6rem/1 'Noto Sans TC Black', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography1920PlusDisplay3: "900 4.75rem/1 'Noto Sans TC Black', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography1920PlusDisplay4: "900 3.75rem/1.1 'Noto Sans TC Black', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography1920PlusTitle1: "500 3rem/1.5 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography1920PlusTitle2: "500 2.5rem/1.5 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography1920PlusTitle3: "500 2rem/1.5 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography1920PlusTitle4: "500 1.5rem/1.5 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography1920PlusConversation1: "300 3.75rem/1.5 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography1920PlusConversation2: "300 3rem/1.5 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography1920PlusConversation3: "300 2.5rem/1.5 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypography1920PlusConversation4: "300 1.25rem/1.75 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyBody1: "400 1rem/1.75 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyBody1Strong: "500 1rem/1.75 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyBody2: "400 .875rem/1.75 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyBody2Strong: "500 .875rem/1.75 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyBody3: "400 .75rem/1.75 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyBody3Strong: "500 .75rem/1.75 'Noto Sans TC Medium', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif",
      podiumCdsTypographyLegal: "400 .875rem/1.75 'Noto Sans TC', Helvetica, Arial, 'PingFang TC', '\u82F9\u65B9-\u7E41', 'Heiti TC', '\u9ED1\u9AD4-\u7E41', 'Microsoft JhengHei', '\u5FAE\u8EDF\u6B63\u9ED1\u9AD4', sans-serif"
    }
  }
};
function _objectWithoutProperties$3(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose$3(source, excluded), sourceSymbolKeys;
  var key, i2;
  if (Object.getOwnPropertySymbols) {
    sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++) {
      key = sourceSymbolKeys[i2];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key = sourceKeys[i2];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var podiumCdsSizeIconM = nike$1.podiumCdsSizeIconM, podiumCdsSizeIconL = nike$1.podiumCdsSizeIconL;
var viewBoxes$1 = {
  s: "0 0 ".concat(parseInt(podiumCdsSizeIconM), " ").concat(parseInt(podiumCdsSizeIconM)),
  m: "0 0 ".concat(parseInt(podiumCdsSizeIconM), " ").concat(parseInt(podiumCdsSizeIconM)),
  l: "0 0 ".concat(parseInt(podiumCdsSizeIconL), " ").concat(parseInt(podiumCdsSizeIconL))
};
var sizes$2 = {
  s: podiumCdsSizeIconM,
  m: podiumCdsSizeIconM,
  l: podiumCdsSizeIconL
};
var SvgIcon$1 = function(_ref3) {
  var ariaHidden = _ref3["aria-hidden"], className = _ref3.className, fill = _ref3.fill, height = _ref3.height, paths2 = _ref3.paths, _ref$role = _ref3.role, role = _ref$role === void 0 ? "img" : _ref$role, title2 = _ref3.title, _ref$size = _ref3.size, size = _ref$size === void 0 ? "m" : _ref$size, viewBox = _ref3.viewBox, width = _ref3.width, rest = _objectWithoutProperties$3(_ref3, ["aria-hidden", "className", "fill", "height", "paths", "role", "title", "size", "viewBox", "width"]);
  var isInaccessible = function(ariaHiddenValue2) {
    return !ariaHiddenValue2 && !title2;
  };
  var ariaHiddenValue = ariaHidden;
  if (isInaccessible(ariaHidden)) {
    ariaHiddenValue = true;
  }
  var vb = viewBox ? viewBox : viewBoxes$1[size] || viewBoxes$1.m;
  var svgWidth = width ? width : sizes$2[size];
  var svgHeight = height ? height : sizes$2[size];
  return /* @__PURE__ */ jsxs("svg", {
    ...Object.assign({
      "aria-hidden": ariaHiddenValue ? "true" : "false",
      className,
      focusable: "false",
      viewBox: vb,
      role,
      width: svgWidth,
      height: svgHeight,
      fill
    }, rest),
    children: [(paths2 === null || paths2 === void 0 ? void 0 : paths2[size]) ? paths2[size] : paths2 === null || paths2 === void 0 ? void 0 : paths2["m"], title2 && /* @__PURE__ */ jsx$1("title", {
      children: title2
    })]
  });
};
var smallPath$5 = /* @__PURE__ */ React__default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ React__default.createElement("g", {
  transform: "translate(2.000000, 2.000000)"
}, /* @__PURE__ */ React__default.createElement("rect", {
  x: "0",
  y: "0",
  width: "20",
  height: "20",
  rx: "10"
}), /* @__PURE__ */ React__default.createElement("rect", {
  className: "checkicon-fill",
  x: "0",
  y: "0",
  width: "20",
  height: "20",
  rx: "5"
}), /* @__PURE__ */ React__default.createElement("path", {
  className: "checkicon-check",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M6.00134645 9.81868355 9.12119517 13.003429 14.9964286 7"
})));
var paths$5 = {
  s: smallPath$5,
  m: smallPath$5,
  l: smallPath$5
};
var CheckboxIcon$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({
    paths: paths$5
  }, props));
});
CheckboxIcon$1.displayName = "Checkbox";
var smallPath$4 = /* @__PURE__ */ React__default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ React__default.createElement("g", {
  transform: "translate(2.000000, 2.000000)"
}, /* @__PURE__ */ React__default.createElement("circle", {
  className: "radio-outline",
  stroke: "currentColor",
  strokeWidth: "1.5",
  cx: "10",
  cy: "10",
  r: "9.25"
}), /* @__PURE__ */ React__default.createElement("circle", {
  className: "radio-fill",
  fill: "currentColor",
  cx: "10",
  cy: "10",
  r: "5"
})));
var paths$4 = {
  s: smallPath$4,
  m: smallPath$4,
  l: smallPath$4
};
var RadioIcon$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({
    paths: paths$4
  }, props));
});
RadioIcon$1.displayName = "Radio";
var podiumCdsColorBgSuccess = nike$1.podiumCdsColorBgSuccess;
var smallPath$3 = /* @__PURE__ */ React__default.createElement("g", {
  transform: "translate(8,8)"
}, /* @__PURE__ */ React__default.createElement("circle", {
  xmlns: "http://www.w3.org/2000/svg",
  cx: "4",
  cy: "4",
  r: "4",
  fill: podiumCdsColorBgSuccess
}));
var paths$3 = {
  s: smallPath$3,
  m: smallPath$3,
  l: smallPath$3
};
var SuccessIcon$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({
    paths: paths$3
  }, props));
});
SuccessIcon$1.displayName = "Success";
var compPaths$8O = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.045 10.99V7.73L6.19 10.37 3.115 9.35l1.94 2.64-1.905 2.64 3.045-1.005 1.855 2.64v-3.26l3.11-1.02-3.115-.995zm12.84 1.02l-6.82 7.49H8.21l6.825-7.49L8.21 4.5h5.856l6.819 7.51z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.045 10.99V7.73L6.19 10.37 3.115 9.35l1.94 2.64-1.905 2.64 3.045-1.005 1.855 2.64v-3.26l3.11-1.02-3.115-.995zm12.84 1.02l-6.82 7.49H8.21l6.825-7.49L8.21 4.5h5.856l6.819 7.51z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.09 21.98v-6.52l-3.708 5.28-6.152-2.042 3.88 5.282-3.81 5.28 6.09-2.01 3.71 5.278V26.01l6.22-2.04-6.23-1.99zm25.68 2.04L28.132 39H16.42l13.65-14.98L16.42 9h11.712L41.77 24.02z",
    clipRule: "evenodd"
  }))
};
var Converse$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8O,
    fill: "none"
  }));
});
var compPaths$8N = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.909 19.105c-.61-.58-1.27-1.145-1.724-1.869-2.4-3.418-2.084-8.5.82-11.529.314-.345.704-.61 1.004-.97-.05-.38-.49-.175-.74-.16-1.24.295-2.493.394-3.733.61-.99.145-1.634 1.034-1.914 1.93-.47 1.552-.94 3.122-1.034 4.753.045 1.428.389 2.841.799 4.222.235.835.485 1.744 1.21 2.289.614.49 1.429.49 2.168.578.985.096 1.945.317 2.919.506.21.155.375-.25.225-.36zM9.838 5.972c-.41-.52-1.04-.8-1.664-.865a27.193 27.193 0 01-3.389-.534c-.264-.05-.659-.205-.739.189.475.475 1.02.865 1.42 1.404 2.793 3.359 2.698 8.722-.266 11.94-.36.474-.909.755-1.209 1.269.454.175.91-.03 1.364-.11 1.065-.25 2.18-.3 3.264-.49.924-.19 1.54-1.033 1.804-1.883.394-1.24.72-2.494.94-3.764.264-1.723-.175-3.448-.66-5.112-.205-.69-.375-1.46-.865-2.044z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.909 19.105c-.61-.58-1.27-1.145-1.724-1.869-2.4-3.418-2.084-8.5.82-11.529.314-.345.704-.61 1.004-.97-.05-.38-.49-.175-.74-.16-1.24.295-2.493.394-3.733.61-.99.145-1.634 1.034-1.914 1.93-.47 1.552-.94 3.122-1.034 4.753.045 1.428.389 2.841.799 4.222.235.835.485 1.744 1.21 2.289.614.49 1.429.49 2.168.578.985.096 1.945.317 2.919.506.21.155.375-.25.225-.36zM9.838 5.972c-.41-.52-1.04-.8-1.664-.865a27.193 27.193 0 01-3.389-.534c-.264-.05-.659-.205-.739.189.475.475 1.02.865 1.42 1.404 2.793 3.359 2.698 8.722-.266 11.94-.36.474-.909.755-1.209 1.269.454.175.91-.03 1.364-.11 1.065-.25 2.18-.3 3.264-.49.924-.19 1.54-1.033 1.804-1.883.394-1.24.72-2.494.94-3.764.264-1.723-.175-3.448-.66-5.112-.205-.69-.375-1.46-.865-2.044z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M39.818 38.211c-1.22-1.16-2.54-2.29-3.45-3.738-4.796-6.838-4.168-17.002 1.64-23.058.63-.692 1.41-1.222 2.01-1.94-.1-.76-.982-.35-1.48-.32-2.48.59-4.988.788-7.466 1.218-1.98.292-3.27 2.07-3.828 3.86-.94 3.106-1.88 6.246-2.07 9.506.09 2.856.778 5.684 1.6 8.444.47 1.67.97 3.488 2.42 4.578 1.228.98 2.856.98 4.336 1.158 1.97.192 3.888.632 5.836 1.01.42.312.75-.5.452-.718zm-20.14-26.268c-.82-1.04-2.08-1.6-3.33-1.73-2.258-.22-4.546-.56-6.776-1.068-.528-.1-1.32-.41-1.48.378.952.95 2.04 1.73 2.84 2.808 5.586 6.718 5.396 17.444-.53 23.88-.72.948-1.82 1.51-2.42 2.538.91.35 1.82-.06 2.73-.218 2.128-.5 4.356-.6 6.526-.98 1.85-.38 3.078-2.068 3.608-3.768.79-2.478 1.44-4.988 1.88-7.528.53-3.446-.35-6.896-1.32-10.224-.41-1.38-.75-2.918-1.728-4.088z",
    clipRule: "evenodd"
  }))
};
var Hurley$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8N,
    fill: "none"
  }));
});
var compPaths$8M = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.182 3.733c-.012-.039-.012-.039-.012-.072a.966.966 0 01.922-1.007.97.97 0 011.007.922.964.964 0 01-.917 1.007c-.027.004-.062 0-.101 0-.016.004-.04.004-.056.022-.056.084.14.073-.005.44 0 0 0 .038-.012.077-.012.14-.08.562-.096.793.029.04.04.05.029.13a6.003 6.003 0 01-.09.534c-.04.14-.096.174-.147.202-.073.298-.095.545-.281.905-.022.276-.045.35-.106.484-.017.4.01.46-.281 1.101-.08.3-.017.507.05.821.068.321.276.461.298.793.05.771.017 1.305-.163 1.907l.135.348c.18.084.618.326.36.675.343.19.865.394 1.28.781.176.147.35.315.513.5.316.057.276.08.506.231.675.438 1.749 1.304 2.373 1.906.112.067.147.112.236.163.01.023.017.034.01.04-.026.072-.026.072-.06.14.039.04.095.073.134.107.04.005.04-.006.096-.017.079.073.18.135.214.135.106-.022.084-.005.185-.1.029-.035.084 0 .084 0 .04-.04.113-.119.214-.176.079-.045.23-.045.23-.045.052.006.04.051.029.073-.057.023-.18.057-.247.108-.152.14-.276.353-.276.353.299-.033.484.045.719.023.136-.005.237.006.377-.09 0 0 .14-.096.265-.14.118-.05.23-.017.33.062.069.084.119.084 0 .196-.044.045-.1.096-.18.17-.133.123-.313.291-.5.432a3.11 3.11 0 01-.527.315c-.338.23-.26.174-.523.394-.03.022-.124.078-.163.106-.107.062-.135.006-.197-.118 0 0-.028-.045-.08-.14-.05-.107-.09-.23-.072-.23-.062-.007-.331-.344-.331-.41-.063-.013-.304-.26-.31-.31l-.214-.18c-.253.044-.31-.113-.961-.608-.08-.006-.197-.05-.36-.174-.298-.253-1.007-.815-1.124-.883-.13-.067-.281-.134-.383-.214-.146-.022-.218-.05-.298-.067-.08-.022-.14-.057-.326-.079-.303-.045-.618-.18-.911-.337-.14-.073-.264-.107-.382-.169-.27-.124-.506-.236-.686-.28a2.148 2.148 0 01-.568-.226c-.061-.034-.095-.06-.134-.073-.09-.022-.153.006-.192.022-.23.108-.438.203-.636.31-.18.09-.348.186-.528.286a7.971 7.971 0 01-.534.254s-.534.253-.832.348c-.26.197-.787.546-1.107.715-.158.073-.467.252-.608.292-.08.061-.371.258-.596.421-.18.124-.31.231-.31.231-.106.084-.101.13-.28.045a1.491 1.491 0 00-.13.096c-.14.095-.146.073-.202.067-.101.08-.113.04-.197.13-.061.084 0 .061-.118.106-.028.006-.04.04-.057.056-.094.073-.1.293-.325.304-.135.09-.107.203-.197.191 0 .102-.18.23-.214.23-.292.096-.304-.118-.646.035-.045.016-.113.072-.197.084-.152.022-.332-.006-.444-.102a1.93 1.93 0 01-.326-.398c-.051-.13-.017-.208.163-.332.073-.045.084-.079.208-.084.06-.024.045.01.15-.024.064-.016.064-.005.193-.005.028-.017.067-.022.124-.045.1-.034.196-.062.196-.062s.028-.023.124-.01c.078-.035.169-.08.214-.097-.012-.124.005-.124.06-.174.08-.062.09-.05.148-.01.022-.007.039-.013.027-.035-.01-.073-.061-.107-.045-.247-.022-.057-.061-.129-.05-.174.01-.045.028-.069.056-.079.029-.012.045.006.057.022.028.034.05.135.05.135.006.118.04.26.152.18.067-.062.084-.242.214-.203l.096.085c.084-.073.084-.073.14-.107 0 0-.08-.073-.012-.135.045-.039.108-.067.208-.175.276-.292.422-.42.714-.657a6.811 6.811 0 011.699-.939c.146-.174.28-.286.585-.304.377-.606 1.085-1.136 1.248-1.22.134-.23.19-.208.365-.247.135-.107.175-.107.23-.214.063-.23-.112-.86.383-.877.112-.146.078-.112.196-.248a2.19 2.19 0 01-.118-.5c-.005-.016-.196-.157-.13-.332a2.33 2.33 0 01-.268-.432.202.202 0 01-.063-.012c-.022-.005-.055-.005-.09-.005-.078.196-.163.208-.303.253-.26.512-.35.731-1.046 1.142-.28.298-.382.64-.382.634a.46.46 0 00-.012.321c-.045.107-.027.124-.027.124.01.045.056.106.106.112.079.023.169.023.158.118-.011.113-.163.09-.237.073-.275-.05-.185-.23-.365-.174-.141.085-.196.348-.416.31-.028-.023-.017-.074.006-.119.028-.06.084-.118.056-.14-.146.04-.433.123-.433.123-.135.04-.281-.039-.147-.124.063-.022.153-.05.265-.118 0 0 .062-.072-.057-.039a1.144 1.144 0 01-.416.045s-.257-.039-.292-.056c-.028-.022-.061-.107.017-.1a2.71 2.71 0 00.563-.068c.095-.035.28-.14.382-.186 0 0 .113-.157.18-.19.107-.114.19-.18.28-.299.09-.18.192-.46.5-.906a4.16 4.16 0 01.535-.646s.062-.338.343-.573c.063-.14.157-.31.259-.462a1.7 1.7 0 00.106-.168c.09-.13.186-.377.518-.41 0 0 .147-.102.197-.175.084-.073.074-.186.14-.259-.106-.106-.365-.309-.382-.573a.85.85 0 01.265-.692c.196-.185.398-.275.646-.258.309.055.366.157.455.258.09.101.13.04.163.146.259.073.248.045.237.236.045.057.106.108.1.214.085-.175.108-.208.344-.399.062-.157.1-.315.15-.478.052-.146.114-.298.154-.41-.04-.326.06-.377.196-.664-.022-.039-.016-.05-.006-.112.057-.192.136-.433.186-.596 0 0 .017-.063.085-.063.06-.202.157-.579.179-.663.062-.208.029-.287-.01-.41-.012-.04-.006-.09-.03-.136a5.483 5.483 0 01-.19-.41c-.028-.073-.08-.354-.08-.354-.004-.062-.004-.09-.004-.09z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.182 3.733c-.012-.039-.012-.039-.012-.072a.966.966 0 01.922-1.007.97.97 0 011.007.922.964.964 0 01-.917 1.007c-.027.004-.062 0-.101 0-.016.004-.04.004-.056.022-.056.084.14.073-.005.44 0 0 0 .038-.012.077-.012.14-.08.562-.096.793.029.04.04.05.029.13a6.003 6.003 0 01-.09.534c-.04.14-.096.174-.147.202-.073.298-.095.545-.281.905-.022.276-.045.35-.106.484-.017.4.01.46-.281 1.101-.08.3-.017.507.05.821.068.321.276.461.298.793.05.771.017 1.305-.163 1.907l.135.348c.18.084.618.326.36.675.343.19.865.394 1.28.781.176.147.35.315.513.5.316.057.276.08.506.231.675.438 1.749 1.304 2.373 1.906.112.067.147.112.236.163.01.023.017.034.01.04-.026.072-.026.072-.06.14.039.04.095.073.134.107.04.005.04-.006.096-.017.079.073.18.135.214.135.106-.022.084-.005.185-.1.029-.035.084 0 .084 0 .04-.04.113-.119.214-.176.079-.045.23-.045.23-.045.052.006.04.051.029.073-.057.023-.18.057-.247.108-.152.14-.276.353-.276.353.299-.033.484.045.719.023.136-.005.237.006.377-.09 0 0 .14-.096.265-.14.118-.05.23-.017.33.062.069.084.119.084 0 .196-.044.045-.1.096-.18.17-.133.123-.313.291-.5.432a3.11 3.11 0 01-.527.315c-.338.23-.26.174-.523.394-.03.022-.124.078-.163.106-.107.062-.135.006-.197-.118 0 0-.028-.045-.08-.14-.05-.107-.09-.23-.072-.23-.062-.007-.331-.344-.331-.41-.063-.013-.304-.26-.31-.31l-.214-.18c-.253.044-.31-.113-.961-.608-.08-.006-.197-.05-.36-.174-.298-.253-1.007-.815-1.124-.883-.13-.067-.281-.134-.383-.214-.146-.022-.218-.05-.298-.067-.08-.022-.14-.057-.326-.079-.303-.045-.618-.18-.911-.337-.14-.073-.264-.107-.382-.169-.27-.124-.506-.236-.686-.28a2.148 2.148 0 01-.568-.226c-.061-.034-.095-.06-.134-.073-.09-.022-.153.006-.192.022-.23.108-.438.203-.636.31-.18.09-.348.186-.528.286a7.971 7.971 0 01-.534.254s-.534.253-.832.348c-.26.197-.787.546-1.107.715-.158.073-.467.252-.608.292-.08.061-.371.258-.596.421-.18.124-.31.231-.31.231-.106.084-.101.13-.28.045a1.491 1.491 0 00-.13.096c-.14.095-.146.073-.202.067-.101.08-.113.04-.197.13-.061.084 0 .061-.118.106-.028.006-.04.04-.057.056-.094.073-.1.293-.325.304-.135.09-.107.203-.197.191 0 .102-.18.23-.214.23-.292.096-.304-.118-.646.035-.045.016-.113.072-.197.084-.152.022-.332-.006-.444-.102a1.93 1.93 0 01-.326-.398c-.051-.13-.017-.208.163-.332.073-.045.084-.079.208-.084.06-.024.045.01.15-.024.064-.016.064-.005.193-.005.028-.017.067-.022.124-.045.1-.034.196-.062.196-.062s.028-.023.124-.01c.078-.035.169-.08.214-.097-.012-.124.005-.124.06-.174.08-.062.09-.05.148-.01.022-.007.039-.013.027-.035-.01-.073-.061-.107-.045-.247-.022-.057-.061-.129-.05-.174.01-.045.028-.069.056-.079.029-.012.045.006.057.022.028.034.05.135.05.135.006.118.04.26.152.18.067-.062.084-.242.214-.203l.096.085c.084-.073.084-.073.14-.107 0 0-.08-.073-.012-.135.045-.039.108-.067.208-.175.276-.292.422-.42.714-.657a6.811 6.811 0 011.699-.939c.146-.174.28-.286.585-.304.377-.606 1.085-1.136 1.248-1.22.134-.23.19-.208.365-.247.135-.107.175-.107.23-.214.063-.23-.112-.86.383-.877.112-.146.078-.112.196-.248a2.19 2.19 0 01-.118-.5c-.005-.016-.196-.157-.13-.332a2.33 2.33 0 01-.268-.432.202.202 0 01-.063-.012c-.022-.005-.055-.005-.09-.005-.078.196-.163.208-.303.253-.26.512-.35.731-1.046 1.142-.28.298-.382.64-.382.634a.46.46 0 00-.012.321c-.045.107-.027.124-.027.124.01.045.056.106.106.112.079.023.169.023.158.118-.011.113-.163.09-.237.073-.275-.05-.185-.23-.365-.174-.141.085-.196.348-.416.31-.028-.023-.017-.074.006-.119.028-.06.084-.118.056-.14-.146.04-.433.123-.433.123-.135.04-.281-.039-.147-.124.063-.022.153-.05.265-.118 0 0 .062-.072-.057-.039a1.144 1.144 0 01-.416.045s-.257-.039-.292-.056c-.028-.022-.061-.107.017-.1a2.71 2.71 0 00.563-.068c.095-.035.28-.14.382-.186 0 0 .113-.157.18-.19.107-.114.19-.18.28-.299.09-.18.192-.46.5-.906a4.16 4.16 0 01.535-.646s.062-.338.343-.573c.063-.14.157-.31.259-.462a1.7 1.7 0 00.106-.168c.09-.13.186-.377.518-.41 0 0 .147-.102.197-.175.084-.073.074-.186.14-.259-.106-.106-.365-.309-.382-.573a.85.85 0 01.265-.692c.196-.185.398-.275.646-.258.309.055.366.157.455.258.09.101.13.04.163.146.259.073.248.045.237.236.045.057.106.108.1.214.085-.175.108-.208.344-.399.062-.157.1-.315.15-.478.052-.146.114-.298.154-.41-.04-.326.06-.377.196-.664-.022-.039-.016-.05-.006-.112.057-.192.136-.433.186-.596 0 0 .017-.063.085-.063.06-.202.157-.579.179-.663.062-.208.029-.287-.01-.41-.012-.04-.006-.09-.03-.136a5.483 5.483 0 01-.19-.41c-.028-.073-.08-.354-.08-.354-.004-.062-.004-.09-.004-.09z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M26.363 7.467c-.024-.078-.024-.078-.024-.144a1.933 1.933 0 011.844-2.014 1.94 1.94 0 012.014 1.844 1.927 1.927 0 01-1.834 2.014c-.054.008-.124 0-.202 0-.032.008-.078.008-.112.044-.112.168.28.146-.01.878 0 0 0 .078-.024.156-.024.28-.158 1.124-.192 1.586.058.08.08.1.058.26-.024.212-.102.73-.18 1.068-.08.28-.192.348-.294.404-.146.596-.19 1.09-.562 1.81-.044.552-.09.698-.212.968-.034.798.022.92-.562 2.202-.16.598-.034 1.014.1 1.642.136.642.552.922.596 1.586.102 1.542.034 2.61-.326 3.814l.27.696c.36.168 1.236.652.72 1.35.686.38 1.73.788 2.562 1.562.35.294.698.63 1.024 1 .632.114.552.158 1.012.462 1.35.876 3.498 2.608 4.746 3.812.224.134.294.224.472.326.022.046.034.068.022.078-.054.146-.054.146-.122.282.078.08.19.146.268.214.08.01.08-.012.192-.034.158.146.36.27.428.27.212-.044.168-.01.37-.202.058-.068.168 0 .168 0 .082-.078.226-.236.428-.35.158-.09.462-.09.462-.09.102.012.078.102.056.146-.114.046-.36.114-.494.216-.304.28-.552.706-.552.706.598-.066.968.09 1.438.046.272-.01.474.012.754-.18 0 0 .282-.192.53-.282.236-.1.46-.032.662.126.136.168.236.168 0 .392-.09.09-.202.192-.36.338-.268.248-.628.584-1 .866-.382.28-.798.516-1.056.63-.676.46-.518.348-1.046.788-.058.044-.248.156-.326.212-.214.124-.27.012-.394-.236 0 0-.056-.09-.158-.282-.102-.212-.18-.46-.146-.46-.124-.012-.662-.686-.662-.82-.126-.024-.608-.518-.62-.62l-.428-.36c-.506.09-.618-.224-1.922-1.214-.158-.012-.394-.102-.72-.348-.596-.506-2.014-1.63-2.248-1.766-.26-.134-.562-.268-.766-.428-.292-.044-.436-.1-.596-.134-.158-.044-.28-.114-.652-.158-.606-.09-1.236-.36-1.822-.674-.28-.146-.528-.214-.764-.338-.54-.248-1.012-.472-1.372-.562-.136-.012-.798-.236-1.136-.45-.122-.068-.19-.122-.268-.146-.18-.044-.306.012-.384.044-.46.216-.876.406-1.272.62-.358.18-.696.372-1.056.572-.314.17-.686.338-1.068.508 0 0-1.068.506-1.664.696-.518.394-1.574 1.092-2.214 1.43-.316.146-.934.504-1.216.584-.158.122-.742.516-1.192.842-.36.248-.618.462-.618.462-.214.168-.204.258-.562.09a2.983 2.983 0 00-.258.192c-.282.19-.294.146-.406.134-.202.158-.226.078-.394.258-.122.17 0 .124-.236.214-.056.012-.078.078-.114.112-.188.146-.2.586-.65.608-.27.178-.214.406-.394.382 0 .204-.36.46-.428.46-.584.192-.608-.236-1.292.07-.09.032-.226.144-.394.168-.304.044-.664-.012-.888-.204-.338-.282-.652-.796-.652-.796-.102-.26-.034-.416.326-.664.146-.09.168-.158.416-.168.122-.048.09.02.302-.048.126-.032.126-.01.384-.01.056-.034.134-.044.248-.09.2-.068.392-.124.392-.124s.056-.046.248-.022c.156-.068.338-.158.428-.192-.024-.248.01-.248.122-.348.16-.124.18-.1.294-.022.044-.012.078-.024.054-.068-.02-.146-.122-.214-.09-.494-.044-.114-.122-.258-.098-.348.02-.09.054-.138.11-.158.058-.024.09.012.114.044.056.068.102.27.102.27.01.236.078.518.302.36.134-.124.168-.484.428-.406l.192.17c.168-.146.168-.146.28-.214 0 0-.158-.146-.024-.27.09-.078.216-.134.416-.35.552-.584.844-.84 1.428-1.314a13.622 13.622 0 013.398-1.878c.292-.348.562-.572 1.17-.608.754-1.212 2.17-2.272 2.496-2.44.268-.46.382-.416.73-.494.27-.214.35-.214.46-.428.126-.46-.224-1.72.766-1.754.224-.292.156-.224.392-.496a4.382 4.382 0 01-.236-1c-.01-.032-.392-.314-.258-.664-.158-.2-.46-.652-.538-.864a.403.403 0 01-.126-.024c-.044-.01-.11-.01-.18-.01-.156.392-.326.416-.606.506-.518 1.024-.698 1.462-2.092 2.284-.56.596-.764 1.28-.764 1.268-.102.204-.078.486-.024.642-.09.214-.054.248-.054.248.022.09.112.212.212.224.158.046.338.046.316.236-.022.226-.326.18-.474.146-.55-.1-.37-.46-.73-.348-.282.17-.392.696-.832.618-.056-.044-.034-.146.012-.236.056-.122.168-.236.112-.282-.292.08-.866.248-.866.248-.27.08-.562-.078-.294-.248.126-.044.306-.1.53-.236 0 0 .124-.144-.114-.078a2.288 2.288 0 01-.832.09s-.514-.078-.584-.112c-.056-.044-.122-.214.034-.202.214.012.732-.046 1.126-.134.19-.07.562-.282.764-.372 0 0 .226-.314.36-.382.214-.226.382-.36.562-.596.18-.36.382-.922 1-1.812.282-.404.63-.876 1.068-1.292 0 0 .124-.676.686-1.146a6.53 6.53 0 01.518-.924 3.4 3.4 0 00.212-.336c.182-.26.372-.754 1.036-.822 0 0 .294-.202.394-.348.168-.146.148-.372.282-.518-.214-.212-.732-.618-.766-1.146-.032-.586.168-1.036.53-1.384.392-.37.796-.55 1.292-.516.618.11.732.314.91.516.18.202.26.08.326.292.518.146.496.09.474.472.09.114.212.216.202.428.168-.35.214-.416.686-.798.124-.314.202-.63.302-.956.102-.292.226-.596.306-.82-.08-.652.122-.754.392-1.328-.044-.078-.032-.102-.012-.224.114-.384.272-.866.372-1.192 0 0 .034-.126.17-.126.122-.404.314-1.158.358-1.326.124-.416.058-.574-.02-.82-.024-.08-.012-.18-.058-.272-.134-.246-.28-.584-.382-.82-.056-.146-.158-.708-.158-.708-.01-.124-.01-.18-.01-.18z",
    clipRule: "evenodd"
  }))
};
var Jordan$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8M,
    fill: "none"
  }));
});
var compPaths$8L = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.98",
    d: "M11.27 5.97H4.32v13.883h13.863V12.9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".99",
    d: "M19.002 3.425s.833-.34 1.55.377c.717.717.377 1.55.377 1.55l-8.31 8.306a.994.994 0 01-.398.243l-2.606.835.835-2.606a.994.994 0 01.244-.399l8.308-8.306z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: ".99",
    d: "M12.601 13.693s.34-.834-.376-1.55c-.717-.717-1.55-.378-1.55-.378"
  }), /* @__PURE__ */ React__default.createElement("defs", null, /* @__PURE__ */ React__default.createElement("radialGradient", {
    id: "paint0_angular",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(6.93142 0 0 6.94133 11.251 12.911)",
    gradientUnits: "userSpaceOnUse"
  }, /* @__PURE__ */ React__default.createElement("stop", {
    stopColor: "#1390DD"
  }), /* @__PURE__ */ React__default.createElement("stop", {
    offset: ".257",
    stopColor: "#ED2324"
  }), /* @__PURE__ */ React__default.createElement("stop", {
    offset: ".476",
    stopColor: "#E59F1C"
  }), /* @__PURE__ */ React__default.createElement("stop", {
    offset: ".75",
    stopColor: "#5ABA47"
  })))),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.98",
    d: "M11.27 5.97H4.32v13.883h13.863V12.9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".99",
    d: "M19.002 3.425s.833-.34 1.55.377c.717.717.377 1.55.377 1.55l-8.31 8.306a.994.994 0 01-.398.243l-2.606.835.835-2.606a.994.994 0 01.244-.399l8.308-8.306z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: ".99",
    d: "M12.601 13.693s.34-.834-.376-1.55c-.717-.717-1.55-.378-1.55-.378"
  }), /* @__PURE__ */ React__default.createElement("defs", null, /* @__PURE__ */ React__default.createElement("radialGradient", {
    id: "paint0_angular",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(6.93142 0 0 6.94133 11.251 12.911)",
    gradientUnits: "userSpaceOnUse"
  }, /* @__PURE__ */ React__default.createElement("stop", {
    stopColor: "#1390DD"
  }), /* @__PURE__ */ React__default.createElement("stop", {
    offset: ".257",
    stopColor: "#ED2324"
  }), /* @__PURE__ */ React__default.createElement("stop", {
    offset: ".476",
    stopColor: "#E59F1C"
  }), /* @__PURE__ */ React__default.createElement("stop", {
    offset: ".75",
    stopColor: "#5ABA47"
  })))),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "3.96",
    d: "M21.54 12.94H7.64v27.765h27.726V26.801"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.98",
    d: "M37.005 7.85s1.666-.679 3.1.755c1.433 1.433.752 3.1.752 3.1L24.24 28.315c-.223.224-.497.39-.798.487l-5.212 1.67 1.67-5.212c.096-.301.264-.575.487-.798L37.005 7.851z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "1.98",
    d: "M24.203 28.385s.68-1.666-.753-3.1c-1.434-1.433-3.1-.754-3.1-.754"
  }), /* @__PURE__ */ React__default.createElement("defs", null, /* @__PURE__ */ React__default.createElement("radialGradient", {
    id: "paint0_angular",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(13.8628 0 0 13.8827 21.503 26.823)",
    gradientUnits: "userSpaceOnUse"
  }, /* @__PURE__ */ React__default.createElement("stop", {
    stopColor: "#1390DD"
  }), /* @__PURE__ */ React__default.createElement("stop", {
    offset: ".257",
    stopColor: "#ED2324"
  }), /* @__PURE__ */ React__default.createElement("stop", {
    offset: ".476",
    stopColor: "#E59F1C"
  }), /* @__PURE__ */ React__default.createElement("stop", {
    offset: ".75",
    stopColor: "#5ABA47"
  }))))
};
var NBY$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8L,
    fill: "none"
  }));
});
var compPaths$8K = {
  s: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M21 8.719L7.836 14.303C6.74 14.768 5.818 15 5.075 15c-.836 0-1.445-.295-1.819-.884-.485-.76-.273-1.982.559-3.272.494-.754 1.122-1.446 1.734-2.108-.144.234-1.415 2.349-.025 3.345.275.2.666.298 1.147.298.386 0 .829-.063 1.316-.19L21 8.719z",
      clipRule: "evenodd"
    })
  }),
  m: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M21 8.719L7.836 14.303C6.74 14.768 5.818 15 5.075 15c-.836 0-1.445-.295-1.819-.884-.485-.76-.273-1.982.559-3.272.494-.754 1.122-1.446 1.734-2.108-.144.234-1.415 2.349-.025 3.345.275.2.666.298 1.147.298.386 0 .829-.063 1.316-.19L21 8.719z",
      clipRule: "evenodd"
    })
  }),
  l: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M42 17.438L15.672 28.606C13.48 29.536 11.636 30 10.15 30c-1.672 0-2.89-.59-3.638-1.768-.97-1.518-.546-3.964 1.118-6.544.988-1.508 2.244-2.892 3.468-4.216-.288.468-2.83 4.698-.05 6.69.55.4 1.332.596 2.294.596.772 0 1.658-.126 2.632-.38L42 17.438z",
      clipRule: "evenodd"
    })
  })
};
var NikeApp$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ jsx$1(SvgIcon$1, {
    ...Object.assign({}, props, {
      paths: compPaths$8K,
      fill: "none"
    })
  });
});
NikeApp$1.displayName = "[Deprecated] NikeApp";
var compPaths$8J = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21 8.719L7.836 14.303C6.74 14.768 5.818 15 5.075 15c-.836 0-1.445-.295-1.819-.884-.485-.76-.273-1.982.559-3.272.494-.754 1.122-1.446 1.734-2.108-.144.234-1.415 2.349-.025 3.345.275.2.666.298 1.147.298.386 0 .829-.063 1.316-.19L21 8.719z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21 8.719L7.836 14.303C6.74 14.768 5.818 15 5.075 15c-.836 0-1.445-.295-1.819-.884-.485-.76-.273-1.982.559-3.272.494-.754 1.122-1.446 1.734-2.108-.144.234-1.415 2.349-.025 3.345.275.2.666.298 1.147.298.386 0 .829-.063 1.316-.19L21 8.719z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M42 17.438L15.672 28.606C13.48 29.536 11.636 30 10.15 30c-1.672 0-2.89-.59-3.638-1.768-.97-1.518-.546-3.964 1.118-6.544.988-1.508 2.244-2.892 3.468-4.216-.288.468-2.83 4.698-.05 6.69.55.4 1.332.596 2.294.596.772 0 1.658-.126 2.632-.38L42 17.438z",
    clipRule: "evenodd"
  }))
};
var NikeSwoosh$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8J,
    fill: "none"
  }));
});
var compPaths$8I = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.196 12.105l2.442 1.313c.66.36 1.31.758 1.815 1.18.036.022.06.048.084.071.457.398.782.83.854 1.323a.89.89 0 01-.18.686c-.156.218-.505.495-1.214.567-.194.023-.867.072-1.36.023-.192-.01-.373-.035-.529-.048a9.552 9.552 0 01-.77-.107l.008.185c.007.523-.088.99-.344 1.343a.906.906 0 01-.613.348c-.265.037-.71-.012-1.262-.456-.145-.12-.662-.554-.975-.939-.426-.503-.684-.828-.79-.991l-.027-.045c-.397.458-.83.782-1.323.855a.895.895 0 01-.686-.18c-.217-.157-.493-.506-.565-1.216a7.688 7.688 0 01-.024-1.36c.072-.723.12-1.155.156-1.312.036-.013.073-.013.108-.013.012.098.06.796.157 1.024.216.505.48.783.793.854.554.109 1.239-.444 1.9-1.059l.072-.07c.322-.321 1.556-1.547 1.924-1.916 0 0 0 .013.013.013l.018.012.018.012-1.31 2.455c-.301.552-.619 1.095-.967 1.553l-.213.265c.072.06.601.516.83.613.517.206.902.229 1.167.049.438-.292.55-1.078.592-1.915l.009-.18v-2.816h.06l.817 2.647c.205.723.386 1.457.445 2.118l.004.013c.092-.013.79-.06 1.02-.157.504-.216.78-.481.852-.794.109-.553-.444-1.24-1.058-1.902l-.672-.672c-.355-.355-.775-.775-1.064-1.066l-.248-.248c0-.011.013-.011.013-.023.011-.012.023-.024.023-.037zm4.474-5.319s.012.011.036.024c.204.168.468.518.541 1.204.024.192.072.866.024 1.36-.07.704-.118 1.133-.154 1.3.596-.035 1.12.05 1.513.336.012.013.024.013.036.025.18.131.288.337.325.577.035.265-.012.71-.458 1.263-.12.145-.553.663-.938.976-.553.469-.889.734-1.034.818-.035-.023-.06-.048-.084-.072.06-.073.517-.603.613-.83.205-.518.23-.904.048-1.168-.313-.47-1.19-.566-2.092-.602h-2.813c0-.012 0-.036-.013-.06l2.659-.806c.72-.206 1.454-.386 2.115-.445l.01-.003.002.014c-.012-.095-.06-.793-.156-1.022-.217-.506-.481-.795-.794-.856-.553-.12-1.238.434-1.9 1.048-.06.06-.552.554-1.044 1.045l-.94.94c-.012-.01-.012-.023-.024-.023l-.018-.013-.018-.011 1.298-2.443c.362-.662.746-1.313 1.18-1.818.023-.036.048-.06.072-.085.396-.457.829-.781 1.322-.854a.895.895 0 01.686.181zM7.434 9.337c.037.025.06.048.084.072-.06.073-.517.603-.613.831-.204.518-.229.903-.048 1.167.292.439 1.077.552 1.913.595l.18.007h2.813c0 .008 0 .021.004.037l.008.024-2.657.818c-.601.17-1.211.324-1.78.405l-.337.04h-.108c-.601.036-1.142-.048-1.54-.337a.86.86 0 01-.348-.601c-.024-.265.024-.71.457-1.264l.107-.127c.184-.217.523-.598.831-.848.541-.458.89-.734 1.034-.82zm5.436-3.863c.144.12.66.553.973.938.47.554.734.891.819 1.036-.024.036-.049.06-.073.085-.072-.062-.6-.518-.83-.615-.517-.204-.901-.229-1.166-.048-.437.292-.55 1.077-.593 1.913l-.008.182v2.804l-.036.001-.036.01-.806-2.659c-.17-.603-.324-1.212-.406-1.781l-.039-.338v.013c-.096.012-.793.06-1.022.156-.505.216-.794.481-.854.794-.108.553.445 1.24 1.059 1.902l.602.603 1.134 1.136.248.246-.012.012-.012.02-.012.017-2.442-1.312c-.66-.362-1.31-.746-1.815-1.18a.468.468 0 01-.084-.072c-.458-.398-.783-.83-.854-1.323a.898.898 0 01.168-.674c.156-.217.504-.494 1.215-.566a7.676 7.676 0 011.359-.024c.721.072 1.154.12 1.31.157v-.013c-.035-.602.048-1.144.337-1.54a.906.906 0 01.613-.349c.277-.025.71.024 1.263.469z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.252 12.136l3.14 1.687c.849.465 1.684.976 2.333 1.517.047.03.077.062.108.092.588.512 1.006 1.068 1.098 1.702.047.31-.03.62-.232.882-.2.28-.649.636-1.56.728-.25.03-1.114.093-1.748.03-.247-.014-.48-.045-.68-.062-.526-.06-.851-.107-.99-.138l.01.239c.009.672-.114 1.272-.444 1.727a1.165 1.165 0 01-.787.447c-.34.047-.913-.015-1.623-.587-.186-.154-.851-.712-1.253-1.207-.549-.647-.88-1.064-1.017-1.274l-.034-.058c-.51.59-1.067 1.006-1.7 1.1-.31.046-.62-.032-.883-.232-.278-.202-.633-.65-.726-1.564-.03-.247-.093-1.113-.03-1.748.092-.929.154-1.486.2-1.687.046-.016.093-.016.139-.016.015.125.078 1.022.201 1.316.278.65.618 1.006 1.02 1.098.712.14 1.593-.57 2.444-1.362l.09-.09c.415-.412 2.002-1.99 2.475-2.463 0 0 0 .017.017.017l.023.015.023.016-1.685 3.156c-.387.709-.795 1.407-1.242 1.997l-.274.34c.093.077.773.664 1.067.789.665.264 1.16.294 1.5.062.563-.375.708-1.386.762-2.461l.01-.233v-3.62h.078l1.05 3.404c.265.929.496 1.872.573 2.723l.005.017c.119-.017 1.016-.077 1.31-.202.65-.278 1.005-.619 1.097-1.021.14-.712-.571-1.595-1.36-2.446l-.865-.864-1.368-1.37-.319-.32c0-.014.017-.014.017-.03.014-.015.03-.03.03-.046zm5.751-6.839s.016.015.047.03c.263.217.603.666.696 1.548.03.247.093 1.114.03 1.749-.09.906-.15 1.458-.198 1.671.767-.044 1.44.066 1.945.433.016.016.032.016.047.032.232.169.371.433.418.742.046.34-.016.912-.588 1.624-.155.186-.712.852-1.206 1.254-.712.604-1.144.944-1.33 1.052-.045-.03-.076-.062-.108-.092.077-.094.665-.775.789-1.068.262-.665.294-1.162.06-1.501-.401-.604-1.53-.727-2.688-.774h-3.618c0-.016 0-.046-.016-.078l3.418-1.036c.926-.264 1.87-.495 2.72-.572l.013-.004.003.018c-.016-.122-.078-1.02-.202-1.314-.278-.65-.618-1.022-1.02-1.1-.712-.154-1.592.558-2.443 1.347-.078.078-.71.712-1.343 1.344l-1.207 1.209c-.017-.015-.017-.03-.031-.03l-.024-.017-.023-.014 1.67-3.14c.463-.853.958-1.69 1.515-2.338.03-.047.062-.077.093-.11.51-.588 1.066-1.004 1.7-1.098.31-.046.619.032.881.233zM6.13 8.577c.046.032.076.062.108.092-.077.094-.665.775-.789 1.07-.263.664-.294 1.16-.061 1.5.374.563 1.384.709 2.459.764l.23.01h3.618c0 .009 0 .027.005.047l.01.03-3.416 1.053c-.772.218-1.557.416-2.29.52l-.431.051h-.14c-.772.047-1.468-.061-1.978-.433-.247-.17-.402-.448-.45-.773-.029-.34.032-.913.589-1.625l.137-.163c.237-.278.673-.768 1.069-1.09.696-.589 1.145-.944 1.33-1.053zm6.988-4.967c.185.155.85.712 1.252 1.206.604.713.943 1.146 1.052 1.332-.03.047-.062.077-.093.11-.093-.08-.773-.667-1.067-.792-.665-.261-1.16-.294-1.5-.06-.562.375-.708 1.384-.762 2.46l-.01.232v3.606l-.046.001-.047.013L10.86 8.3c-.22-.776-.416-1.56-.522-2.291l-.05-.435v.017c-.124.016-1.02.077-1.314.2-.65.279-1.021.62-1.098 1.022-.14.711.572 1.595 1.36 2.445l.774.776 1.46 1.46.318.317-.016.015-.015.024-.016.023-3.14-1.686c-.849-.465-1.684-.96-2.333-1.518a.603.603 0 01-.108-.092c-.588-.511-1.006-1.067-1.098-1.702-.047-.31.03-.618.216-.866.201-.279.649-.635 1.562-.727.247-.032 1.113-.094 1.747-.032.928.093 1.485.155 1.685.202v-.016c-.046-.775.061-1.47.433-1.98a1.16 1.16 0 01.789-.448c.355-.033.912.03 1.623.602z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M24.504 24.272l6.278 3.374c1.7.929 3.37 1.951 4.668 3.034.094.06.154.125.216.185 1.176 1.022 2.012 2.136 2.196 3.403.094.621-.06 1.24-.463 1.764-.4.559-1.298 1.272-3.122 1.457-.497.06-2.227.184-3.495.06-.494-.03-.96-.092-1.36-.125-1.052-.12-1.702-.214-1.98-.276l.019.477c.019 1.344-.226 2.544-.886 3.454-.37.494-.926.804-1.574.895-.682.094-1.827-.031-3.247-1.173-.372-.31-1.702-1.426-2.506-2.415-1.097-1.293-1.76-2.129-2.033-2.549l-.07-.115c-1.02 1.179-2.133 2.011-3.4 2.199a2.303 2.303 0 01-1.764-.464c-.557-.403-1.267-1.3-1.452-3.127-.063-.494-.187-2.227-.063-3.497.185-1.857.31-2.97.401-3.374.094-.031.188-.031.279-.031.03.25.156 2.045.403 2.633.554 1.298 1.236 2.01 2.04 2.196 1.423.278 3.185-1.143 4.886-2.724l.183-.183c.828-.823 4.003-3.977 4.948-4.925 0 0 0 .034.034.034l.046.031.045.032-3.37 6.311c-.772 1.419-1.588 2.816-2.483 3.994l-.547.682c.184.153 1.545 1.327 2.133 1.576 1.33.528 2.318.588 3 .125 1.126-.751 1.416-2.772 1.524-4.922l.022-.466v-7.24h.153l2.103 6.808c.528 1.858.99 3.744 1.144 5.446a.197.197 0 01.01.033c.238-.033 2.033-.153 2.62-.403 1.3-.557 2.01-1.238 2.194-2.042.279-1.423-1.142-3.19-2.721-4.891l-1.728-1.728-2.736-2.741-.639-.639c0-.028.034-.028.034-.06.029-.03.06-.06.06-.093zm11.503-13.678s.031.03.094.06c.525.435 1.205 1.332 1.392 3.096.06.495.185 2.227.06 3.497-.18 1.812-.303 2.916-.396 3.343 1.533-.088 2.88.132 3.89.867.031.03.063.03.094.062.463.339.741.867.835 1.486.091.679-.031 1.824-1.176 3.247-.31.372-1.423 1.704-2.412 2.508-1.423 1.207-2.287 1.889-2.66 2.105-.09-.06-.153-.125-.215-.185.153-.187 1.33-1.55 1.577-2.136.525-1.33.588-2.323.122-3.003-.804-1.207-3.06-1.454-5.378-1.547h-7.236c0-.032 0-.092-.032-.157l6.836-2.07c1.852-.529 3.739-.992 5.44-1.145l.027-.008.005.036c-.032-.244-.156-2.04-.404-2.628-.556-1.3-1.236-2.044-2.04-2.2-1.423-.308-3.184 1.116-4.886 2.695-.156.156-1.42 1.423-2.686 2.688l-2.414 2.417c-.034-.03-.034-.06-.062-.06l-.048-.034-.046-.029 3.338-6.28c.93-1.705 1.918-3.378 3.032-4.676.062-.093.124-.153.187-.218 1.017-1.176 2.131-2.01 3.4-2.196a2.291 2.291 0 011.762.465zm-23.748 6.56c.094.064.154.124.216.184-.153.188-1.33 1.55-1.576 2.139-.526 1.33-.588 2.32-.123 3 .749 1.128 2.767 1.418 4.918 1.529l.46.019h7.236c0 .019 0 .055.01.096l.022.06-6.833 2.104c-1.546.437-3.115.833-4.58 1.042l-.863.1h-.279c-1.545.095-2.937-.122-3.957-.866-.495-.34-.804-.895-.898-1.545-.06-.682.063-1.826 1.176-3.25l.274-.326c.475-.557 1.346-1.536 2.138-2.182 1.392-1.176 2.29-1.886 2.66-2.104zM26.237 7.22c.37.31 1.699 1.423 2.503 2.412 1.207 1.426 1.886 2.292 2.105 2.664-.063.094-.125.154-.187.218-.185-.158-1.546-1.332-2.134-1.581-1.33-.523-2.318-.588-3-.123-1.123.752-1.416 2.77-1.524 4.92l-.022.466v7.212l-.09.002-.094.027-2.072-6.838c-.439-1.55-.832-3.117-1.044-4.581l-.1-.87v.034c-.247.032-2.04.154-2.628.401-1.299.557-2.043 1.239-2.196 2.043-.279 1.423 1.144 3.19 2.721 4.89l1.548 1.551 2.919 2.92.636.635-.031.03-.032.049-.03.045-6.28-3.372c-1.698-.93-3.369-1.92-4.667-3.036a1.205 1.205 0 01-.216-.184c-1.176-1.023-2.011-2.134-2.196-3.404a2.309 2.309 0 01.432-1.732c.403-.557 1.298-1.27 3.124-1.455.495-.062 2.225-.187 3.495-.062 1.855.185 2.969.31 3.37.403v-.031c-.092-1.55.122-2.943.866-3.963.37-.494.926-.804 1.577-.895.71-.065 1.824.06 3.247 1.205z",
    clipRule: "evenodd"
  }))
};
var Sustainability$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8I,
    fill: "none"
  }));
});
var compPaths$8H = {
  s: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      stroke: "currentColor",
      strokeWidth: "1.5",
      d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5zm8.75 0h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25zm-8.75 0h5.5v-12h-5.5v12z",
      clipRule: "evenodd"
    })
  }),
  m: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      stroke: "currentColor",
      strokeWidth: "1.5",
      d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5zm8.75 0h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25zm-8.75 0h5.5v-12h-5.5v12z",
      clipRule: "evenodd"
    })
  }),
  l: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      stroke: "currentColor",
      strokeWidth: "3",
      d: "M18.5 40.5H12A4.5 4.5 0 017.5 36V25.5h11v15zm17.5 0h-6.5v-33h11V36a4.5 4.5 0 01-4.5 4.5zm-17.5 0h11v-24h-11v24z",
      clipRule: "evenodd"
    })
  })
};
var Activity$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ jsx$1(SvgIcon$1, {
    ...Object.assign({}, props, {
      paths: compPaths$8H,
      fill: "none"
    })
  });
});
Activity$1.displayName = "[Deprecated] Activity";
var compPaths$8G = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 20.25h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.25 20.25h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 20.25h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.25 20.25h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.5 40.5H12A4.5 4.5 0 017.5 36V25.5h11v15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.5 40.5H12A4.5 4.5 0 017.5 36V25.5h11v15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M36 40.5h-6.5v-33h11V36a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 40.5h-6.5v-33h11V36a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.5 40.5h11v-24h-11v24z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.5 40.5h11v-24h-11v24z",
    clipRule: "evenodd"
  }))
};
var ActivityFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8G,
    fill: "none"
  }));
});
var compPaths$8F = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5zm8.75 0h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25zm-8.75 0h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5zm8.75 0h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25zm-8.75 0h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M18.5 40.5H12A4.5 4.5 0 017.5 36V25.5h11v15zm17.5 0h-6.5v-33h11V36a4.5 4.5 0 01-4.5 4.5zm-17.5 0h11v-24h-11v24z",
    clipRule: "evenodd"
  }))
};
var ActivityStroke$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8F,
    fill: "none"
  }));
});
var compPaths$8E = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 21v-3A3.75 3.75 0 016 14.25h6A3.75 3.75 0 0115.75 18v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 15V7.5M15 11.25h7.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 21v-3A3.75 3.75 0 016 14.25h6A3.75 3.75 0 0115.75 18v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 15V7.5M15 11.25h7.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M4.5 42v-6a7.5 7.5 0 017.5-7.5h12a7.5 7.5 0 017.5 7.5v6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M25.5 15a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M37.5 30V15M30 22.5h15"
  }))
};
var AddFriends$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8E,
    fill: "none"
  }));
});
var compPaths$8D = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.25 16.5v-9A2.25 2.25 0 0018 5.25H6A2.25 2.25 0 003.75 7.5v9A2.25 2.25 0 006 18.75h6m-8.25-9h16.5m-3 5.25v7.5M21 18.75h-7.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.25 16.5v-9A2.25 2.25 0 0018 5.25H6A2.25 2.25 0 003.75 7.5v9A2.25 2.25 0 006 18.75h6m-8.25-9h16.5m-3 5.25v7.5M21 18.75h-7.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M40.5 33V15a4.5 4.5 0 00-4.5-4.5H12A4.5 4.5 0 007.5 15v18c0 2.484 2.016 4.5 4.5 4.5h12m-16.5-18h33m-6 10.5v15m7.5-7.5H27"
  }))
};
var AddPayment$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8D,
    fill: "none"
  }));
});
var compPaths$8C = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 17v-1.5m0-1.5V7"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M11.99 15V6m0 12v-1.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M23.98 30V12m0 24v-3"
  }))
};
var Alert$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8C,
    fill: "none"
  }));
});
var compPaths$8B = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 19.25c4 0 7.25-3.25 7.25-7.25S16 4.75 12 4.75 4.75 8 4.75 12 8 19.25 12 19.25zM12 17v-1.5m0-1.5V7"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M11.99 15V6m0 12v-1.5m.01 5.25c5.385 0 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25 2.25 6.615 2.25 12s4.365 9.75 9.75 9.75z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M23.98 30V12m0 24v-3M24 43.5c10.77 0 19.5-8.73 19.5-19.5S34.77 4.5 24 4.5 4.5 13.23 4.5 24 13.23 43.5 24 43.5z"
  }))
};
var AlertCircle$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8B,
    fill: "none"
  }));
});
var compPaths$8A = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm.75 13h-1.5v-1.5h1.5V17zm0-3h-1.5V7h1.5v7z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 1.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5zm.74 16.5h-1.5v-1.5h1.5V18zm0-3h-1.5V6h1.5v9z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M24 3C12.42 3 3 12.42 3 24s9.42 21 21 21 21-9.42 21-21S35.58 3 24 3zm1.48 33h-3v-3h3v3zm0-6h-3V12h3v18z"
  }))
};
var AlertCircleFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8A,
    fill: "none"
  }));
});
var compPaths$8z = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5zm8.75 0h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25zm-8.75 0h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5zm8.75 0h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25zm-8.75 0h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.5 40.5H12A4.5 4.5 0 017.5 36V25.5h11v15zm17.5 0h-6.5v-33h11V36a4.5 4.5 0 01-4.5 4.5zm-17.5 0h11v-24h-11v24z",
    clipRule: "evenodd"
  }))
};
var Analytics$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8z,
    fill: "none"
  }));
});
var compPaths$8y = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 20.25h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.25 20.25h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 20.25h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.25 20.25h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.5 40.5H12A4.5 4.5 0 017.5 36V25.5h11v15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.5 40.5H12A4.5 4.5 0 017.5 36V25.5h11v15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M36 40.5h-6.5v-33h11V36a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 40.5h-6.5v-33h11V36a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.5 40.5h11v-24h-11v24z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.5 40.5h11v-24h-11v24z",
    clipRule: "evenodd"
  }))
};
var AnalyticsFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8y,
    fill: "none"
  }));
});
var compPaths$8x = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5zm8.75 0h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25zm-8.75 0h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5zm8.75 0h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25zm-8.75 0h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M18.5 40.5H12A4.5 4.5 0 017.5 36V25.5h11v15zm17.5 0h-6.5v-33h11V36a4.5 4.5 0 01-4.5 4.5zm-17.5 0h11v-24h-11v24z",
    clipRule: "evenodd"
  }))
};
var AnalyticsStroke$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8x,
    fill: "none"
  }));
});
var compPaths$8w = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.389 10.5l2.61 1.5 2.613-1.5M12 12v2.5m0 2.5v2.814m6.75-3.897L16.308 14.5M5.25 15.917L7.692 14.5M12 7.314V4.5M5.25 8.397l2.442 1.417M18.75 8.397l-2.442 1.417m-6.875 8.518L12 19.814l2.567-1.482m0-12.35L12 4.5 9.433 5.982m6.75 11.418l2.567-1.483v-2.964m0-1.592V8.397l-2.567-1.482M7.817 17.4L5.25 15.916v-2.964m0-1.591V8.397l2.567-1.482"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.389 10.5l2.61 1.5 2.613-1.5M12 12v2.5m0 2.5v2.814m6.75-3.897L16.308 14.5M5.25 15.917L7.692 14.5M12 7.314V4.5M5.25 8.397l2.442 1.417M18.75 8.397l-2.442 1.417m-6.875 8.518L12 19.814l2.567-1.482m0-12.35L12 4.5 9.433 5.982m6.75 11.418l2.567-1.483v-2.964m0-1.592V8.397l-2.567-1.482M7.817 17.4L5.25 15.916v-2.964m0-1.591V8.397l2.567-1.482"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.777 21L24 24l5.224-3M24 24v5m0 5v5.628m13.5-7.794L32.616 29M10.5 31.834L15.384 29M24 14.629V9.001m-13.5 7.794l4.884 2.834M37.5 16.795l-4.884 2.834m-13.75 17.035L24 39.628l5.134-2.964m0-24.699L24 9l-5.134 2.964m13.5 22.835l5.134-2.964v-5.928m0-3.184v-5.928l-5.134-2.964M15.634 34.799L10.5 31.835v-5.928m0-3.184v-5.928l5.134-2.964"
  }))
};
var AR$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8w,
    fill: "none"
  }));
});
var compPaths$8v = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 8.25V6a2.25 2.25 0 012.25-2.25h3a2.25 2.25 0 110 4.5H3.75v8.25a3.75 3.75 0 003.75 3.75h9a3.75 3.75 0 003.75-3.75V8.25H17.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 8.25V6a2.25 2.25 0 012.25-2.25h3a2.25 2.25 0 110 4.5H3.75v8.25a3.75 3.75 0 003.75 3.75h9a3.75 3.75 0 003.75-3.75V8.25H17.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.5 16.5V12A4.5 4.5 0 0121 7.5h6a4.5 4.5 0 014.5 4.5 4.5 4.5 0 01-4.5 4.5H7.5V33a7.5 7.5 0 007.5 7.5h18a7.5 7.5 0 007.5-7.5V16.5H35"
  }))
};
var Bag$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8v,
    fill: "none"
  }));
});
var compPaths$8u = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 6c0-.827.673-1.5 1.5-1.5h3c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5H9V6zm7.083 1.5c.258-.443.417-.951.417-1.5 0-1.654-1.346-3-3-3h-3c-1.654 0-3 1.346-3 3v1.5H3v9C3 18.981 5.019 21 7.5 21h9c2.481 0 4.5-2.019 4.5-4.5v-9h-4.917z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 6c0-.827.673-1.5 1.5-1.5h3c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5H9V6zm7.083 1.5c.258-.443.417-.951.417-1.5 0-1.654-1.346-3-3-3h-3c-1.654 0-3 1.346-3 3v1.5H3v9C3 18.981 5.019 21 7.5 21h9c2.481 0 4.5-2.019 4.5-4.5v-9h-4.917z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 12c0-1.654 1.346-3 3-3h6c1.654 0 3 1.346 3 3s-1.346 3-3 3h-9v-3zm14.166 3c.516-.886.834-1.902.834-3 0-3.308-2.692-6-6-6h-6c-3.308 0-6 2.692-6 6v3H6v18c0 4.962 4.038 9 9 9h18c4.962 0 9-4.038 9-9V15h-9.834z",
    clipRule: "evenodd"
  }))
};
var BagFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8u,
    fill: "none"
  }));
});
var compPaths$8t = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M8.25 8.25V6a2.25 2.25 0 012.25-2.25h3a2.25 2.25 0 110 4.5H3.75v8.25a3.75 3.75 0 003.75 3.75h9a3.75 3.75 0 003.75-3.75V8.25H17.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M8.25 8.25V6a2.25 2.25 0 012.25-2.25h3a2.25 2.25 0 110 4.5H3.75v8.25a3.75 3.75 0 003.75 3.75h9a3.75 3.75 0 003.75-3.75V8.25H17.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M16.5 16.5V12A4.5 4.5 0 0121 7.5h6a4.5 4.5 0 014.5 4.5 4.5 4.5 0 01-4.5 4.5H7.5V33a7.5 7.5 0 007.5 7.5h18a7.5 7.5 0 007.5-7.5V16.5H35"
  }))
};
var BagStroke$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8t,
    fill: "none"
  }));
});
var compPaths$8s = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 3.75h9A2.25 2.25 0 0118.75 6v13.499a.75.75 0 01-1.28.53L12 14.559l-5.47 5.47a.75.75 0 01-1.28-.53V6A2.25 2.25 0 017.5 3.75z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 3.75h9A2.25 2.25 0 0118.75 6v13.499a.75.75 0 01-1.28.53L12 14.559l-5.47 5.47a.75.75 0 01-1.28-.53V6A2.25 2.25 0 017.5 3.75z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 7.5h18a4.5 4.5 0 014.5 4.5v26.998c0 1.336-1.616 2.004-2.56 1.06L24 29.118l-10.94 10.94c-.944.944-2.56.276-2.56-1.06V12A4.5 4.5 0 0115 7.5z",
    clipRule: "evenodd"
  }))
};
var Bookmark$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8s,
    fill: "none"
  }));
});
var compPaths$8r = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.999 21c-.39 0-.771-.154-1.06-.44L12 15.62l-4.939 4.94a1.497 1.497 0 01-1.635.325 1.495 1.495 0 01-.926-1.387V6c0-1.654 1.346-3 3-3h9c1.654 0 3 1.346 3 3v13.498A1.505 1.505 0 0117.999 21z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.999 21c-.39 0-.771-.154-1.06-.44L12 15.62l-4.939 4.94a1.497 1.497 0 01-1.635.325 1.495 1.495 0 01-.926-1.387V6c0-1.654 1.346-3 3-3h9c1.654 0 3 1.346 3 3v13.498A1.505 1.505 0 0117.999 21z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M35.998 41.999c-.78 0-1.542-.306-2.12-.88L24 31.239l-9.878 9.88a2.995 2.995 0 01-3.27.65A2.99 2.99 0 019 38.997V11.999c0-3.308 2.692-6 6-6h18c3.308 0 6 2.692 6 6v26.998a2.99 2.99 0 01-1.852 2.772 3.01 3.01 0 01-1.15.23z",
    clipRule: "evenodd"
  }))
};
var BookmarkFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8r,
    fill: "none"
  }));
});
var compPaths$8q = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M7.5 3.75h9A2.25 2.25 0 0118.75 6v13.499a.75.75 0 01-1.28.53L12 14.559l-5.47 5.47a.75.75 0 01-1.28-.53V6A2.25 2.25 0 017.5 3.75z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M7.5 3.75h9A2.25 2.25 0 0118.75 6v13.499a.75.75 0 01-1.28.53L12 14.559l-5.47 5.47a.75.75 0 01-1.28-.53V6A2.25 2.25 0 017.5 3.75z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M15 7.5h18a4.5 4.5 0 014.5 4.5v26.998c0 1.336-1.616 2.004-2.56 1.06L24 29.118l-10.94 10.94c-.944.944-2.56.276-2.56-1.06V12A4.5 4.5 0 0115 7.5z",
    clipRule: "evenodd"
  }))
};
var BookmarkStroke$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8q,
    fill: "none"
  }));
});
var compPaths$8p = {
  s: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      fill: "currentColor",
      d: "M19.5 18.44L5.56 4.5 4.5 5.56l1.7 1.7A7.442 7.442 0 004.5 12c0 4.14 3.36 7.5 7.5 7.5 1.8 0 3.45-.64 4.74-1.7l1.7 1.7 1.06-1.06zM12 18c-3.31 0-6-2.69-6-6 0-1.38.48-2.65 1.27-3.67l8.4 8.4A5.977 5.977 0 0112 18zm0-12c3.31 0 6 2.69 6 6 0 .83-.17 1.62-.48 2.34l1.12 1.12c.54-1.04.85-2.21.85-3.46 0-4.14-3.36-7.5-7.5-7.5-1.25 0-2.43.31-3.46.85l1.12 1.12C10.38 6.17 11.17 6 12 6z"
    })
  }),
  m: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      fill: "currentColor",
      d: "M19.5 18.44L5.56 4.5 4.5 5.56l1.7 1.7A7.442 7.442 0 004.5 12c0 4.14 3.36 7.5 7.5 7.5 1.8 0 3.45-.64 4.74-1.7l1.7 1.7 1.06-1.06zM12 18c-3.31 0-6-2.69-6-6 0-1.38.48-2.65 1.27-3.67l8.4 8.4A5.977 5.977 0 0112 18zm0-12c3.31 0 6 2.69 6 6 0 .83-.17 1.62-.48 2.34l1.12 1.12c.54-1.04.85-2.21.85-3.46 0-4.14-3.36-7.5-7.5-7.5-1.25 0-2.43.31-3.46.85l1.12 1.12C10.38 6.17 11.17 6 12 6z"
    })
  }),
  l: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      fill: "currentColor",
      d: "M39 36.88L11.12 9 9 11.12l3.4 3.4C10.28 17.1 9 20.4 9 24c0 8.28 6.72 15 15 15 3.6 0 6.9-1.28 9.48-3.4l3.4 3.4L39 36.88zM24 36c-6.62 0-12-5.38-12-12 0-2.76.96-5.3 2.54-7.34l16.8 16.8C29.3 35.04 26.76 36 24 36zm0-24c6.62 0 12 5.38 12 12 0 1.66-.34 3.24-.96 4.68l2.24 2.24c1.08-2.08 1.7-4.42 1.7-6.92 0-8.28-6.72-15-15-15-2.5 0-4.86.62-6.92 1.7l2.24 2.24c1.46-.6 3.04-.94 4.7-.94z"
    })
  })
};
var BrightnessNone$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ jsx$1(SvgIcon$1, {
    ...Object.assign({}, props, {
      paths: compPaths$8p,
      fill: "none"
    })
  });
});
BrightnessNone$1.displayName = "[Deprecated] BrightnessNone";
var compPaths$8o = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V7.5A2.25 2.25 0 016 5.25h12a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.25 9.75H3.75M8.25 3v4.5m7.5-4.5v4.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V7.5A2.25 2.25 0 016 5.25h12a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.25 9.75H3.75M8.25 3v4.5m7.5-4.5v4.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 40.5H12A4.5 4.5 0 017.5 36V15a4.5 4.5 0 014.5-4.5h24a4.5 4.5 0 014.5 4.5v21a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M40.5 19.5h-33m9-13.5v9m15-9v9"
  }))
};
var Calendar$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8o,
    fill: "none"
  }));
});
var compPaths$8n = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 13.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.5 6.75h2A2.25 2.25 0 0121.75 9v7.5A3.75 3.75 0 0118 20.25H6a3.75 3.75 0 01-3.75-3.75V9A2.25 2.25 0 014.5 6.75h9.75a1.5 1.5 0 100-3h-4.5a1.5 1.5 0 00-1.5 1.5V6M6 9.75H4.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 13.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.5 6.75h2A2.25 2.25 0 0121.75 9v7.5A3.75 3.75 0 0118 20.25H6a3.75 3.75 0 01-3.75-3.75V9A2.25 2.25 0 014.5 6.75h9.75a1.5 1.5 0 100-3h-4.5a1.5 1.5 0 00-1.5 1.5V6M6 9.75H4.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.5 27a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M35 13.5h4a4.5 4.5 0 014.5 4.5v15a7.5 7.5 0 01-7.5 7.5H12A7.5 7.5 0 014.5 33V18A4.5 4.5 0 019 13.5h19.5a3 3 0 100-6h-9a3 3 0 00-3 3V12M12 19.5H9"
  }))
};
var Camera$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8n,
    fill: "none"
  }));
});
var compPaths$8m = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 3.75h15A2.25 2.25 0 0123.25 6v9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.468 13.293c-.747-.548-.177-1.646.025-1.973-.364.402-.728.803-1.011 1.24-.446.685-.637 1.436-.335 1.919.54.868 1.84.466 2.668.117l7.685-3.242-7.594 2.005c-.636.166-1.147.144-1.438-.066z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 18.75H4.5a2.25 2.25 0 01-2.25-2.25V9A2.25 2.25 0 014.5 6.75H18A2.25 2.25 0 0120.25 9v7.5A2.25 2.25 0 0118 18.75z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 3.75h15A2.25 2.25 0 0123.25 6v9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.468 13.293c-.747-.548-.177-1.646.025-1.973-.364.402-.728.803-1.011 1.24-.446.685-.637 1.436-.335 1.919.54.868 1.84.466 2.668.117l7.685-3.242-7.594 2.005c-.636.166-1.147.144-1.438-.066z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 18.75H4.5a2.25 2.25 0 01-2.25-2.25V9A2.25 2.25 0 014.5 6.75H18A2.25 2.25 0 0120.25 9v7.5A2.25 2.25 0 0118 18.75z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M12 7.5h30c2.484 0 4.5 2.016 4.5 4.5v18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.936 26.586c-1.494-1.096-.354-3.292.05-3.946-.728.804-1.456 1.606-2.022 2.482-.892 1.368-1.274 2.87-.67 3.836 1.082 1.736 3.68.932 5.336.234L33 22.708l-15.188 4.01c-1.272.332-2.294.288-2.876-.132z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 37.5H9A4.502 4.502 0 014.5 33V18c0-2.484 2.016-4.5 4.5-4.5h27c2.484 0 4.5 2.016 4.5 4.5v15c0 2.484-2.016 4.5-4.5 4.5z",
    clipRule: "evenodd"
  }))
};
var Cards$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8m,
    fill: "none"
  }));
});
var compPaths$8l = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.5 11.5l3.75 3.75L17.5 8"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.03 11.69l4.753 4.754 9.186-9.188"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M10.06 23.382l9.507 9.506 18.372-18.376"
  }))
};
var Check$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8l,
    fill: "none"
  }));
});
var compPaths$8k = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15 10l-4 4-2-2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 19.25c4 0 7.25-3.25 7.25-7.25S16 4.75 12 4.75 4.75 8 4.75 12 8 19.25 12 19.25z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.712 9.663l-4.772 4.773-2.652-2.65"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 24c0 10.77-8.73 19.5-19.5 19.5S4.5 34.77 4.5 24 13.23 4.5 24 4.5 43.5 13.23 43.5 24z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.424 19.326l-9.544 9.546-5.304-5.302"
  }))
};
var CheckCircle$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8k,
    fill: "none"
  }));
});
var compPaths$8j = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm-1 11.06l-2.53-2.53 1.06-1.06L11 12.94l3.47-3.47 1.06 1.06L11 15.06z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 1.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5zm-1.06 14l-3.18-3.18 1.06-1.06 2.12 2.12 4.24-4.24 1.06 1.06-5.3 5.3z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M24 3C12.42 3 3 12.42 3 24s9.42 21 21 21 21-9.42 21-21S35.58 3 24 3zm-2.12 28l-6.36-6.36 2.12-2.12 4.24 4.24 8.48-8.48 2.12 2.12L21.88 31z"
  }))
};
var CheckCircleFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8j,
    fill: "none"
  }));
});
var compPaths$8i = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 21v-3A3.75 3.75 0 016 14.25h6A3.75 3.75 0 0115.75 18v3M15 12.75h3a3.75 3.75 0 013.75 3.75v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zm7.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 21v-3A3.75 3.75 0 016 14.25h6A3.75 3.75 0 0115.75 18v3M15 12.75h3a3.75 3.75 0 013.75 3.75v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zm7.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M4.5 42v-6a7.5 7.5 0 017.5-7.5h12a7.5 7.5 0 017.5 7.5v6M30 25.5h6a7.5 7.5 0 017.5 7.5v6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M25.5 15a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0zm15 0a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z",
    clipRule: "evenodd"
  }))
};
var Club$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8i,
    fill: "none"
  }));
});
var compPaths$8h = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 21H1.5v-3c0-2.481 2.019-4.5 4.5-4.5h6c2.481 0 4.5 2.019 4.5 4.5v3H15",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 19.5V12h3c2.481 0 4.5 2.019 4.5 4.5v3H21M9 12a4.505 4.505 0 01-4.5-4.5C4.5 5.019 6.519 3 9 3s4.5 2.019 4.5 4.5S11.481 12 9 12zm9-1.5c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 21H1.5v-3c0-2.481 2.019-4.5 4.5-4.5h6c2.481 0 4.5 2.019 4.5 4.5v3H15",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 19.5V12h3c2.481 0 4.5 2.019 4.5 4.5v3H21M9 12a4.505 4.505 0 01-4.5-4.5C4.5 5.019 6.519 3 9 3s4.5 2.019 4.5 4.5S11.481 12 9 12zm9-1.5c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 42H3v-6c0-4.962 4.038-9 9-9h12c4.962 0 9 4.038 9 9v6h-3",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M30 39V24h6c4.962 0 9 4.038 9 9v6h-3M18 24c-4.962 0-9-4.038-9-9s4.038-9 9-9 9 4.038 9 9-4.038 9-9 9zm18-3c-3.308 0-6-2.692-6-6s2.692-6 6-6 6 2.692 6 6-2.692 6-6 6z",
    clipRule: "evenodd"
  }))
};
var ClubFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8h,
    fill: "none"
  }));
});
var compPaths$8g = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M2.25 21v-3A3.75 3.75 0 016 14.25h6A3.75 3.75 0 0115.75 18v3M15 12.75h3a3.75 3.75 0 013.75 3.75v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M12.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zm7.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M2.25 21v-3A3.75 3.75 0 016 14.25h6A3.75 3.75 0 0115.75 18v3M15 12.75h3a3.75 3.75 0 013.75 3.75v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M12.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zm7.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M4.5 42v-6a7.5 7.5 0 017.5-7.5h12a7.5 7.5 0 017.5 7.5v6M30 25.5h6a7.5 7.5 0 017.5 7.5v6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M25.5 15a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0zm15 0a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z",
    clipRule: "evenodd"
  }))
};
var ClubStroke$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8g,
    fill: "none"
  }));
});
var compPaths$8f = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M3.75 21v-3c0-2.07 1.68-3.75 3.75-3.75h9c2.07 0 3.75 1.68 3.75 3.75v3m-12-14.25H19.5m-7.5 4.5a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M3.75 21v-3c0-2.07 1.68-3.75 3.75-3.75h9c2.07 0 3.75 1.68 3.75 3.75v3m-12-14.25H19.5m-7.5 4.5a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M7.5 42v-6c0-4.14 3.36-7.5 7.5-7.5h18c4.14 0 7.5 3.36 7.5 7.5v6m-24-28.5H39m-15 9a7.5 7.5 0 100-15 7.5 7.5 0 000 15z"
  }))
};
var Coach$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8f,
    fill: "none"
  }));
});
var compPaths$8e = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.75 21v-6.75H3M14.25 3v6.75H21"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.75 21v-6.75H3M14.25 3v6.75H21"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M19.5 42V28.5H6M28.5 6v13.5H42"
  }))
};
var Collapse$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8e,
    fill: "none"
  }));
});
var compPaths$8d = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16 17.25h2A2.25 2.25 0 0020.25 15V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v9A2.25 2.25 0 006 17.25h6a2.25 2.25 0 012.25 2.25V21"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16 17.25h2A2.25 2.25 0 0020.25 15V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v9A2.25 2.25 0 006 17.25h6a2.25 2.25 0 012.25 2.25V21"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M32 34.5h4a4.5 4.5 0 004.5-4.5V12A4.5 4.5 0 0036 7.5H12A4.5 4.5 0 007.5 12v18a4.5 4.5 0 004.5 4.5h12a4.5 4.5 0 014.5 4.5v3"
  }))
};
var Comments$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8d,
    fill: "none"
  }));
});
var compPaths$8c = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20 8.25H4.5m3.27 11.21l-3.71-3.71 3.71-3.71m8.46-7.5l3.71 3.71-3.71 3.71M4 15.75h15.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20 8.25H4.5m3.27 11.21l-3.71-3.71 3.71-3.71m8.46-7.5l3.71 3.71-3.71 3.71M4 15.75h15.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M40 16.5H9m6.54 22.42L8.12 31.5l7.42-7.42m16.92-15l7.42 7.42-7.42 7.42M8 31.5h31"
  }))
};
var Compare$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8c,
    fill: "none"
  }));
});
var compPaths$8b = {
  s: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      stroke: "currentColor",
      strokeWidth: "1.5",
      d: "M19.25 12c0 4-3.24 7.25-7.25 7.25S4.75 16 4.75 12 7.99 4.75 12 4.75 19.25 8 19.25 12zM12 8v8m4-4H8"
    })
  }),
  m: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      stroke: "currentColor",
      strokeWidth: "1.5",
      d: "M21.75 12c0 5.39-4.36 9.75-9.75 9.75S2.25 17.39 2.25 12 6.61 2.25 12 2.25s9.75 4.36 9.75 9.75zM12 6v12m6-6H6"
    })
  }),
  l: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      stroke: "currentColor",
      strokeWidth: "3",
      d: "M43.5 24c0 10.78-8.72 19.5-19.5 19.5S4.5 34.78 4.5 24 13.22 4.5 24 4.5 43.5 13.22 43.5 24zM24 12v24m12-12H12"
    })
  })
};
var CreateRule$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ jsx$1(SvgIcon$1, {
    ...Object.assign({}, props, {
      paths: compPaths$8b,
      fill: "none"
    })
  });
});
CreateRule$1.displayName = "[Deprecated] CreateRule";
var compPaths$8a = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm4 8.75h-3.25V16h-1.5v-3.25H8v-1.5h3.25V8h1.5v3.25H16v1.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 1.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5zm6 11.25h-5.25V18h-1.5v-5.25H6v-1.5h5.25V6h1.5v5.25H18v1.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M24 3C12.42 3 3 12.42 3 24s9.42 21 21 21 21-9.42 21-21S35.58 3 24 3zm12 22.5H25.5V36h-3V25.5H12v-3h10.5V12h3v10.5H36v3z"
  }))
};
var CreateRuleFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$8a,
    fill: "none"
  }));
});
var compPaths$89 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8 6.5H6.5M8 12H6.5M8 17.5H6.5M4 9.25h16m-16 5.5h16"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8 6.5H6.5M8 12H6.5M8 17.5H6.5M4 9.25h16m-16 5.5h16"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 40.5H12A4.5 4.5 0 017.5 36V12A4.5 4.5 0 0112 7.5h24a4.5 4.5 0 014.5 4.5v24a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16 13h-3m3 11h-3m3 11h-3M8.001 18.5h32m-32 11h32"
  }))
};
var Data = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$89,
    fill: "none"
  }));
});
var compPaths$88 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M13.75 10v7m-3.5-7v7m-3.5-8.5V17c0 1.24 1.01 2.25 2.25 2.25h6c1.24 0 2.25-1.01 2.25-2.25V7.75h2.25m-10-3h3.75c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5H4.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.25 7.5v12m-4.5-12v12M5.25 6v13.5c0 1.24 1.01 2.25 2.25 2.25h9c1.24 0 2.25-1.01 2.25-2.25V5.25h2.75m-2.75 0H21m-12-3h5.25c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5H3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M28.5 15v24m-9-24v24m-9-27v27c0 2.48 2.02 4.5 4.5 4.5h18c2.48 0 4.5-2.02 4.5-4.5V10.5H43m-5.5 0H42m-24-6h10.5c1.66 0 3 1.34 3 3s-1.34 3-3 3H6"
  }))
};
var Delete$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$88,
    fill: "none"
  }));
});
var compPaths$87 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M7.51 20.25h9m-3-3h6c1.24 0 2.25-1.01 2.25-2.25V6c0-1.24-1.01-2.25-2.25-2.25h-15C3.27 3.75 2.26 4.76 2.26 6v9c0 1.24 1.01 2.25 2.25 2.25h5c1.24 0 2.25 1.01 2.25 2.25v.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M7.51 20.25h9m-3-3h6c1.24 0 2.25-1.01 2.25-2.25V6c0-1.24-1.01-2.25-2.25-2.25h-15C3.27 3.75 2.26 4.76 2.26 6v9c0 1.24 1.01 2.25 2.25 2.25h5c1.24 0 2.25 1.01 2.25 2.25v.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M15.02 40.5h18m-6-6h12c2.48 0 4.5-2.02 4.5-4.5V12c0-2.48-2.02-4.5-4.5-4.5h-30c-2.48 0-4.5 2.02-4.5 4.5v18c0 2.48 2.02 4.5 4.5 4.5h10c2.48 0 4.5 2.02 4.5 4.5v1.5"
  }))
};
var Desktop$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$87,
    fill: "none"
  }));
});
var compPaths$86 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.55 9.55l-1.792 6.693 6.69-1.794 1.794-6.691L9.55 9.55z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.55 9.55l-1.792 6.693 6.69-1.794 1.794-6.691L9.55 9.55z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M19.102 19.102l-3.586 13.384 13.382-3.588 3.586-13.382-13.382 3.586z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 24c0 10.77-8.73 19.5-19.5 19.5S4.5 34.77 4.5 24 13.23 4.5 24 4.5 43.5 13.23 43.5 24z",
    clipRule: "evenodd"
  }))
};
var Discover$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$86,
    fill: "none"
  }));
});
var compPaths$85 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.837 13.837l-5.02 1.345 1.346-5.02 5.019-1.344-1.345 5.019zM12 1.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.837 13.837l-5.02 1.345 1.346-5.02 5.019-1.344-1.345 5.019zM12 1.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M27.674 27.674l-10.038 2.69 2.69-10.038 10.038-2.69-2.69 10.038zM24 3C12.42 3 3 12.422 3 24c0 11.58 9.42 21 21 21s21-9.42 21-21c0-11.578-9.42-21-21-21z",
    clipRule: "evenodd"
  }))
};
var DiscoverFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$85,
    fill: "none"
  }));
});
var compPaths$84 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M9.55 9.55l-1.792 6.693 6.69-1.794 1.794-6.691L9.55 9.55z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M9.55 9.55l-1.792 6.693 6.69-1.794 1.794-6.691L9.55 9.55z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M19.102 19.102l-3.586 13.384 13.382-3.588 3.586-13.382-13.382 3.586z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M43.5 24c0 10.77-8.73 19.5-19.5 19.5S4.5 34.77 4.5 24 13.23 4.5 24 4.5 43.5 13.23 43.5 24z",
    clipRule: "evenodd"
  }))
};
var DiscoverStroke$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$84,
    fill: "none"
  }));
});
var compPaths$83 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.125 14.25A4.125 4.125 0 1012 10.125m2.25 4.125h2m-9 0h2.5m-2.25 0a3.75 3.75 0 010-7.5m8.212 10.97L12 21.432 8.288 17.72M12 20.75V10M6.75 7.5a5.25 5.25 0 019.094-3.576"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.125 14.25A4.125 4.125 0 1012 10.125m2.25 4.125h2m-9 0h2.5m-2.25 0a3.75 3.75 0 010-7.5m8.212 10.97L12 21.432 8.288 17.72M12 20.75V10M6.75 7.5a5.25 5.25 0 019.094-3.576"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M32.25 28.5A8.25 8.25 0 1024 20.25m4.5 8.25h4m-18 0h5m-4.5 0a7.5 7.5 0 010-15m16.424 21.94L24 42.864l-7.424-7.424M24 41.5V20"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 15c0-5.798 4.702-10.5 10.5-10.5 3.036 0 5.77 1.288 7.688 3.348"
  }))
};
var Download$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$83,
    fill: "none"
  }));
});
var compPaths$82 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8.357 18H6v-2.357L15.643 6 18 8.357 8.357 18zM13.5 8l2.5 2.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M6.94 20.25H3.76v-3.18L16.77 4.06l3.18 3.18L6.94 20.25zm8.08-13.69l2.63 2.63"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M13.88 40.5H7.52v-6.36L33.54 8.12l6.36 6.36L13.88 40.5zm16.16-27.38l5.26 5.26"
  }))
};
var Edit$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$82,
    fill: "none"
  }));
});
var compPaths$81 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.5 14.25a2.25 2.25 0 11.002-4.502A2.25 2.25 0 014.5 14.25zm7.5 0a2.25 2.25 0 11.002-4.502A2.25 2.25 0 0112 14.25zm7.5 0a2.25 2.25 0 11.002-4.502 2.25 2.25 0 01-.002 4.502z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.5 14.25a2.25 2.25 0 11.002-4.502A2.25 2.25 0 014.5 14.25zm7.5 0a2.25 2.25 0 11.002-4.502A2.25 2.25 0 0112 14.25zm7.5 0a2.25 2.25 0 11.002-4.502 2.25 2.25 0 01-.002 4.502z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M9 28.5A4.502 4.502 0 014.5 24c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5-2.016 4.5-4.5 4.5zm15 0a4.502 4.502 0 01-4.5-4.5c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5-2.016 4.5-4.5 4.5zm15 0a4.502 4.502 0 01-4.5-4.5c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5-2.016 4.5-4.5 4.5z",
    clipRule: "evenodd"
  }))
};
var Ellipsis$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$81,
    fill: "none"
  }));
});
var compPaths$80 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.25 19.5a2.25 2.25 0 11-4.502-.002 2.25 2.25 0 014.502.002zm0-7.5a2.25 2.25 0 11-4.502-.002A2.25 2.25 0 0114.25 12zm0-7.5a2.25 2.25 0 11-4.502-.002 2.25 2.25 0 014.502.002z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.25 19.5a2.25 2.25 0 11-4.502-.002 2.25 2.25 0 014.502.002zm0-7.5a2.25 2.25 0 11-4.502-.002A2.25 2.25 0 0114.25 12zm0-7.5a2.25 2.25 0 11-4.502-.002 2.25 2.25 0 014.502.002z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M28.5 39c0 2.484-2.016 4.5-4.5 4.5a4.502 4.502 0 01-4.5-4.5c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5zm0-15c0 2.484-2.016 4.5-4.5 4.5a4.502 4.502 0 01-4.5-4.5c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5zm0-15c0 2.484-2.016 4.5-4.5 4.5A4.502 4.502 0 0119.5 9c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5z",
    clipRule: "evenodd"
  }))
};
var EllipsisVertical$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$80,
    fill: "none"
  }));
});
var compPaths$7$ = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 13.5v6.75h6.75m9.75-9.75V3.75H13.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 13.5v6.75h6.75m9.75-9.75V3.75H13.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 27v13.5H21M40.5 21V7.5H27"
  }))
};
var Expand$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7$,
    fill: "none"
  }));
});
var compPaths$7_ = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M7.5 3.75h9m-6.75.5v5.89c0 .6-.24 1.17-.66 1.59l-4.68 4.68C3 17.83 4 20.25 6 20.25h12c2 0 3.01-2.42 1.59-3.84l-4.68-4.68c-.42-.42-.66-.99-.66-1.59V4M6.5 14.25h11.12"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M7.5 3.75h9m-6.75.5v5.89c0 .6-.24 1.17-.66 1.59l-4.68 4.68C3 17.83 4 20.25 6 20.25h12c2 0 3.01-2.42 1.59-3.84l-4.68-4.68c-.42-.42-.66-.99-.66-1.59V4M6.5 14.25h11.12"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M15 7.5h18m-13.501 1v11.78c0 1.2-.48 2.34-1.32 3.18l-9.36 9.36c-2.82 2.84-.82 7.68 3.18 7.68h24c4 0 6.02-4.84 3.18-7.68l-9.36-9.36a4.496 4.496 0 01-1.32-3.18V8M13 28.5h22.24"
  }))
};
var Experiments$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7_,
    fill: "none"
  }));
});
var compPaths$7Z = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.92 7.25h-5c-1.24 0-2.25 1.01-2.25 2.25V17c0 1.24 1.01 2.25 2.25 2.25h7.5c1.24 0 2.25-1.01 2.25-2.25v-4.5m2.5-2.5V4.75h-5.25m-2.25 7.5l7.5-7.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 5.25H6c-1.24 0-2.25 1.01-2.25 2.25V18c0 1.24 1.01 2.25 2.25 2.25h10.5c1.24 0 2.25-1.01 2.25-2.25v-6m3-3V2.25H15m-3.75 10.5l10.5-10.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 10.5H12c-2.48 0-4.5 2.02-4.5 4.5v21c0 2.48 2.02 4.5 4.5 4.5h21c2.48 0 4.5-2.02 4.5-4.5V24m6-6V4.5H30m-7.5 21l21-21"
  }))
};
var ExternalLink$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7Z,
    fill: "none"
  }));
});
var compPaths$7Y = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.566 5.75c.984 0 1.91.385 2.606 1.082a3.707 3.707 0 010 5.228L12 18.25l-6.172-6.19a3.707 3.707 0 010-5.227A3.656 3.656 0 018.434 5.75c.985 0 1.91.385 2.606 1.082l.565.567.395.396.394-.396.566-.567a3.658 3.658 0 012.606-1.082"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.794 3.75c1.324 0 2.568.516 3.504 1.451a4.96 4.96 0 010 7.008L12 20.508l-8.299-8.299a4.96 4.96 0 010-7.007A4.923 4.923 0 017.205 3.75c1.324 0 2.568.516 3.504 1.451l.76.76.531.531.53-.531.76-.76a4.926 4.926 0 013.504-1.451"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33.589 7.5a9.852 9.852 0 017.008 2.902c3.866 3.864 3.866 10.152 0 14.016L24 41.016 7.403 24.418c-3.864-3.864-3.864-10.152 0-14.014A9.846 9.846 0 0114.41 7.5a9.852 9.852 0 017.008 2.902l1.52 1.52L24 12.984l1.06-1.062 1.52-1.52A9.852 9.852 0 0133.589 7.5"
  }))
};
var Favorite$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7Y,
    fill: "none"
  }));
});
var compPaths$7X = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.566 5.75c.984 0 1.91.385 2.606 1.082a3.707 3.707 0 010 5.228L12 18.25l-6.172-6.19a3.707 3.707 0 010-5.227A3.656 3.656 0 018.434 5.75c.985 0 1.91.385 2.606 1.082l.565.567.395.396.394-.396.566-.567a3.658 3.658 0 012.606-1.082z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.566 5.75c.984 0 1.91.385 2.606 1.082a3.707 3.707 0 010 5.228L12 18.25l-6.172-6.19a3.707 3.707 0 010-5.227A3.656 3.656 0 018.434 5.75c.985 0 1.91.385 2.606 1.082l.565.567.395.396.394-.396.566-.567a3.658 3.658 0 012.606-1.082"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.794 3.75c1.324 0 2.568.516 3.504 1.451a4.96 4.96 0 010 7.008L12 20.508l-8.299-8.299a4.96 4.96 0 010-7.007A4.923 4.923 0 017.205 3.75c1.324 0 2.568.516 3.504 1.451l.76.76.531.531.53-.531.76-.76a4.926 4.926 0 013.504-1.451z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.794 3.75c1.324 0 2.568.516 3.504 1.451a4.96 4.96 0 010 7.008L12 20.508l-8.299-8.299a4.96 4.96 0 010-7.007A4.923 4.923 0 017.205 3.75c1.324 0 2.568.516 3.504 1.451l.76.76.531.531.53-.531.76-.76a4.926 4.926 0 013.504-1.451"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M33.589 7.5a9.852 9.852 0 017.008 2.902c3.866 3.864 3.866 10.152 0 14.016L24 41.016 7.403 24.418c-3.864-3.864-3.864-10.152 0-14.014A9.846 9.846 0 0114.41 7.5a9.852 9.852 0 017.008 2.902l1.52 1.52L24 12.984l1.06-1.062 1.52-1.52A9.852 9.852 0 0133.589 7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33.589 7.5a9.852 9.852 0 017.008 2.902c3.866 3.864 3.866 10.152 0 14.016L24 41.016 7.403 24.418c-3.864-3.864-3.864-10.152 0-14.014A9.846 9.846 0 0114.41 7.5a9.852 9.852 0 017.008 2.902l1.52 1.52L24 12.984l1.06-1.062 1.52-1.52A9.852 9.852 0 0133.589 7.5"
  }))
};
var FavoriteFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7X,
    fill: "none"
  }));
});
var compPaths$7W = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M15.566 5.75c.984 0 1.91.385 2.606 1.082a3.707 3.707 0 010 5.228L12 18.25l-6.172-6.19a3.707 3.707 0 010-5.227A3.656 3.656 0 018.434 5.75c.985 0 1.91.385 2.606 1.082l.565.567.395.396.394-.396.566-.567a3.658 3.658 0 012.606-1.082"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M16.794 3.75c1.324 0 2.568.516 3.504 1.451a4.96 4.96 0 010 7.008L12 20.508l-8.299-8.299a4.96 4.96 0 010-7.007A4.923 4.923 0 017.205 3.75c1.324 0 2.568.516 3.504 1.451l.76.76.531.531.53-.531.76-.76a4.926 4.926 0 013.504-1.451"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M33.589 7.5a9.852 9.852 0 017.008 2.902c3.866 3.864 3.866 10.152 0 14.016L24 41.016 7.403 24.418c-3.864-3.864-3.864-10.152 0-14.014A9.846 9.846 0 0114.41 7.5a9.852 9.852 0 017.008 2.902l1.52 1.52L24 12.984l1.06-1.062 1.52-1.52A9.852 9.852 0 0133.589 7.5"
  }))
};
var FavoriteStroke$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7W,
    fill: "none"
  }));
});
var compPaths$7V = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 8.25h9m-9 4.5H15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 8.25h9m-9 4.5H15"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 8.25h9m-9 4.5H15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 8.25h9m-9 4.5H15"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 40.5H12A4.5 4.5 0 017.5 36V12A4.5 4.5 0 0112 7.5h24a4.5 4.5 0 014.5 4.5v24a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 16.5h18m-18 9h15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 40.5H12A4.5 4.5 0 017.5 36V12A4.5 4.5 0 0112 7.5h24a4.5 4.5 0 014.5 4.5v24a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 16.5h18m-18 9h15"
  }))
};
var Feed$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7V,
    fill: "none"
  }));
});
var compPaths$7U = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 8.25h9m-9 4.5H15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M7.5 8.25h9m-9 4.5H15"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 8.25h9m-9 4.5H15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M7.5 8.25h9m-9 4.5H15"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 40.5H12A4.5 4.5 0 017.5 36V12A4.5 4.5 0 0112 7.5h24a4.5 4.5 0 014.5 4.5v24a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 16.5h18m-18 9h15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M36 40.5H12A4.5 4.5 0 017.5 36V12A4.5 4.5 0 0112 7.5h24a4.5 4.5 0 014.5 4.5v24a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M15 16.5h18m-18 9h15"
  }))
};
var FeedStroke$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7U,
    fill: "none"
  }));
});
var compPaths$7T = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 8v0a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19 9.5h-9m-2 0H5m0 5h9m2 0h3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.75 13v0a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21 8.25H10m-5.25 0H3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 6v0a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3 15.75h10.75m5 0H21"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 13.5v0a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M42 16.5H20m-10.5 0H6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 12v0a4.5 4.5 0 100 9 4.5 4.5 0 000-9z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M6 31.5h21.5m10 0H42"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33 27v0a4.5 4.5 0 100 9 4.5 4.5 0 000-9z",
    clipRule: "evenodd"
  }))
};
var Filter$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7T,
    fill: "none"
  }));
});
var compPaths$7S = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.547",
    d: "M10.696 14.886a5.787 5.787 0 01-2.09.095 5.683 5.683 0 01-4.807-4.841 5.648 5.648 0 016.333-6.342 5.674 5.674 0 014.85 4.815 5.64 5.64 0 01-1.466 4.633 2.144 2.144 0 00.095 2.967l.99.99h1.735v1.734l1.301 1.302h2.603v-2.603l-4.286-4.286"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "bevel",
    strokeWidth: "1.5",
    d: "M8.75 10.5a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.547",
    d: "M10.696 14.886a5.787 5.787 0 01-2.09.095 5.683 5.683 0 01-4.807-4.841 5.648 5.648 0 016.333-6.342 5.674 5.674 0 014.85 4.815 5.64 5.64 0 01-1.466 4.633 2.144 2.144 0 00.095 2.967l.99.99h1.735v1.734l1.301 1.302h2.603v-2.603l-4.286-4.286"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "bevel",
    strokeWidth: "1.5",
    d: "M8.75 10.5a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3.094",
    d: "M21.393 29.771a11.561 11.561 0 01-4.182.191 11.366 11.366 0 01-9.613-9.682A11.296 11.296 0 0120.265 7.596a11.348 11.348 0 019.7 9.63 11.278 11.278 0 01-2.933 9.266 4.286 4.286 0 00.19 5.934l1.979 1.978h3.47v3.47l2.603 2.603h5.206v-5.205L31.908 26.7"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "bevel",
    strokeWidth: "3",
    d: "M17.5 21a3.5 3.5 0 100-7 3.5 3.5 0 000 7z"
  }))
};
var FirstAccess$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7S,
    fill: "none"
  }));
});
var compPaths$7R = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.25 13v6.5c0 1.24-1.01 2.25-2.25 2.25s-2.25-1.01-2.25-2.25v-8.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M10.829 11.25h2.342a3 3 0 002.809-1.947l1.267-3.377a.5.5 0 00-.468-.676H7.22a.5.5 0 00-.468.676L8.02 9.303a3 3 0 002.809 1.947z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15v1.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.25 13v6.5c0 1.24-1.01 2.25-2.25 2.25s-2.25-1.01-2.25-2.25v-8.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M10.829 11.25h2.342a3 3 0 002.809-1.947l1.267-3.377a.5.5 0 00-.468-.676H7.22a.5.5 0 00-.468.676L8.02 9.303a3 3 0 002.809 1.947z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15v1.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M28.5 26v13c0 2.48-2.02 4.5-4.5 4.5s-4.5-2.02-4.5-4.5V21.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M21.658 22.5h4.684a6 6 0 005.618-3.893l2.533-6.756a1 1 0 00-.936-1.351H14.443a1 1 0 00-.936 1.351l2.533 6.756a6 6 0 005.618 3.893z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 30v3"
  }))
};
var FlashlightOff$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7R,
    fill: "none"
  }));
});
var compPaths$7Q = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.25 13v6.5c0 1.24-1.01 2.25-2.25 2.25s-2.25-1.01-2.25-2.25v-8.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M10.829 11.25h2.342a3 3 0 002.809-1.947l1.267-3.377a.5.5 0 00-.468-.676H7.22a.5.5 0 00-.468.676L8.02 9.303a3 3 0 002.809 1.947z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15v1.5M11.94 3V0M9.65 2.98L8.15.38m6.2 2.6l1.5-2.6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.25 13v6.5c0 1.24-1.01 2.25-2.25 2.25s-2.25-1.01-2.25-2.25v-8.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M10.829 11.25h2.342a3 3 0 002.809-1.947l1.267-3.377a.5.5 0 00-.468-.676H7.22a.5.5 0 00-.468.676L8.02 9.303a3 3 0 002.809 1.947z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15v1.5M11.94 3V0M9.65 2.98L8.15.38m6.2 2.6l1.5-2.6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M28.5 26v13c0 2.48-2.02 4.5-4.5 4.5s-4.5-2.02-4.5-4.5V21.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M21.658 22.5h4.684a6 6 0 005.618-3.893l2.533-6.756a1 1 0 00-.936-1.351H14.443a1 1 0 00-.936 1.351l2.533 6.756a6 6 0 005.618 3.893z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 30v3m-.12-27V0M19.3 5.96l-3-5.2m12.4 5.2l3-5.2"
  }))
};
var FlashlightOn$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7Q,
    fill: "none"
  }));
});
var compPaths$7P = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 13.5v-2.25a1.5 1.5 0 10-3 0m0 2.25V9.75a1.5 1.5 0 10-3 0"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 13a1.5 1.5 0 113 0v2a6.726 6.726 0 01-1.977 4.773A6.732 6.732 0 0113.5 21.75a6.732 6.732 0 01-4.773-1.977l-6.059-6.059a1.501 1.501 0 012.122-2.121l2.18 2.18a.75.75 0 001.28-.531V5.25a1.5 1.5 0 113 0v8.25"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.013 2.166l1.591 1.591L14 5.334M5.487 2.166L3.896 3.757 5.5 5.334",
    opacity: ".2"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 13.5v-2.25a1.5 1.5 0 10-3 0m0 2.25V9.75a1.5 1.5 0 10-3 0"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 13a1.5 1.5 0 113 0v2a6.726 6.726 0 01-1.977 4.773A6.732 6.732 0 0113.5 21.75a6.732 6.732 0 01-4.773-1.977l-6.059-6.059a1.501 1.501 0 012.122-2.121l2.18 2.18a.75.75 0 001.28-.531V5.25a1.5 1.5 0 113 0v8.25"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.013 2.166l1.591 1.591L14 5.334M5.487 2.166L3.896 3.757 5.5 5.334",
    opacity: ".2"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 27v-4.5a3 3 0 10-6 0m0 4.5v-7.5a3 3 0 10-6 0"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 26a3 3 0 116 0v4c0 3.728-1.51 7.104-3.954 9.546A13.464 13.464 0 0127 43.5a13.464 13.464 0 01-9.546-3.954L5.336 27.428a3 3 0 014.244-4.242l4.36 4.36c.944.944 2.56.276 2.56-1.062V10.5a3 3 0 116 0V27"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M28.026 4.332l3.182 3.182L28 10.668M10.974 4.332L7.792 7.514 11 10.668",
    opacity: ".2"
  }))
};
var GestureSwipe$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7P,
    fill: "none"
  }));
});
var compPaths$7O = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.396 8.25a4.5 4.5 0 117.598-1.5",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 13.5v-2.25a1.5 1.5 0 00-3 0m0 2.25V9.75a1.5 1.5 0 00-3 0"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 13a1.5 1.5 0 013 0v2a6.73 6.73 0 01-1.977 4.773A6.73 6.73 0 0113.5 21.75a6.732 6.732 0 01-4.773-1.977l-6.059-6.059a1.501 1.501 0 012.122-2.121l2.18 2.18a.75.75 0 001.28-.531V5.25a1.5 1.5 0 113 0v8.25"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.396 8.25a4.5 4.5 0 117.598-1.5",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 13.5v-2.25a1.5 1.5 0 00-3 0m0 2.25V9.75a1.5 1.5 0 00-3 0"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 13a1.5 1.5 0 013 0v2a6.73 6.73 0 01-1.977 4.773A6.73 6.73 0 0113.5 21.75a6.732 6.732 0 01-4.773-1.977l-6.059-6.059a1.501 1.501 0 012.122-2.121l2.18 2.18a.75.75 0 001.28-.531V5.25a1.5 1.5 0 113 0v8.25"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M12.792 16.5a9 9 0 1115.196-3",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 27v-4.5a3.001 3.001 0 00-6 0m0 4.5v-7.5a3.001 3.001 0 00-6 0"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 26a3.001 3.001 0 016 0v4a13.46 13.46 0 01-3.954 9.546A13.46 13.46 0 0127 43.5a13.464 13.464 0 01-9.546-3.954L5.336 27.428a3 3 0 014.244-4.242l4.36 4.36c.944.944 2.56.276 2.56-1.062V10.5a3 3 0 116 0V27"
  }))
};
var GestureTap$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7O,
    fill: "none"
  }));
});
var compPaths$7N = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M3.76 10.5V8.25h16.5v3H6.76c-.83 0-1.5.67-1.5 1.5v6c0 .83.67 1.5 1.5 1.5h10.5c.83 0 1.5-.67 1.5-1.5v-7.5m-4.5-7.5c-1.24 0-2.25 1.01-2.25 2.25v2.25h2.25c1.24 0 2.25-1.01 2.25-2.25s-1.01-2.25-2.25-2.25zm-4.5 0c1.24 0 2.25 1.01 2.25 2.25v2.25H9.76C8.51 8.25 7.51 7.24 7.51 6s1-2.25 2.25-2.25zm2.25 4.78v11.72"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M3.76 10.5V8.25h16.5v3H6.76c-.83 0-1.5.67-1.5 1.5v6c0 .83.67 1.5 1.5 1.5h10.5c.83 0 1.5-.67 1.5-1.5v-7.5m-4.5-7.5c-1.24 0-2.25 1.01-2.25 2.25v2.25h2.25c1.24 0 2.25-1.01 2.25-2.25s-1.01-2.25-2.25-2.25zm-4.5 0c1.24 0 2.25 1.01 2.25 2.25v2.25H9.76C8.51 8.25 7.51 7.24 7.51 6s1-2.25 2.25-2.25zm2.25 4.78v11.72"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M7.52 21v-4.5h33v6h-27c-1.66 0-3 1.34-3 3v12c0 1.66 1.34 3 3 3h21c1.66 0 3-1.34 3-3v-15m-9-15c-2.48 0-4.5 2.02-4.5 4.5v4.5h4.5c2.48 0 4.5-2.02 4.5-4.5S31 7.5 28.52 7.5zm-9 0c2.48 0 4.5 2.02 4.5 4.5v4.5h-4.5c-2.5 0-4.5-2.02-4.5-4.5s2-4.5 4.5-4.5zm4.5 9.56V40.5"
  }))
};
var Gift$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7N,
    fill: "none"
  }));
});
var compPaths$7M = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.678 13.018c-.854-.627-.202-1.88.029-2.255-.417.459-.833.917-1.157 1.418-.51.782-.727 1.64-.383 2.19.618.995 2.104.536 3.05.136L18 10.8l-8.677 2.293c-.728.189-1.313.163-1.645-.076z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 16.5v-9A2.25 2.25 0 014.5 5.25h15a2.25 2.25 0 012.25 2.25v9a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.678 13.018c-.854-.627-.202-1.88.029-2.255-.417.459-.833.917-1.157 1.418-.51.782-.727 1.64-.383 2.19.618.995 2.104.536 3.05.136L18 10.8l-8.677 2.293c-.728.189-1.313.163-1.645-.076z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 16.5v-9A2.25 2.25 0 014.5 5.25h15a2.25 2.25 0 012.25 2.25v9a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.355 26.035c-1.708-1.254-.404-3.76.058-4.51-.834.918-1.666 1.834-2.314 2.836-1.018 1.564-1.454 3.282-.766 4.382 1.236 1.988 4.208 1.07 6.1.27L36 21.601l-17.354 4.586c-1.456.378-2.626.326-3.29-.152z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M39 37.5H9A4.502 4.502 0 014.5 33V15c0-2.484 2.016-4.5 4.5-4.5h30c2.484 0 4.5 2.016 4.5 4.5v18c0 2.484-2.016 4.5-4.5 4.5z",
    clipRule: "evenodd"
  }))
};
var GiftCard$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7M,
    fill: "none"
  }));
});
var compPaths$7L = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 21.75c5.385 0 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25 2.25 6.615 2.25 12s4.365 9.75 9.75 9.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 21.75c2.9 0 5.25-4.365 5.25-9.75S14.9 2.25 12 2.25 6.75 6.615 6.75 12 9.1 21.75 12 21.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15.75c5.385 0 9.75-1.679 9.75-3.75 0-2.071-4.365-3.75-9.75-3.75S2.25 9.929 2.25 12c0 2.071 4.365 3.75 9.75 3.75z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 21.75c5.385 0 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25 2.25 6.615 2.25 12s4.365 9.75 9.75 9.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 21.75c2.9 0 5.25-4.365 5.25-9.75S14.9 2.25 12 2.25 6.75 6.615 6.75 12 9.1 21.75 12 21.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15.75c5.385 0 9.75-1.679 9.75-3.75 0-2.071-4.365-3.75-9.75-3.75S2.25 9.929 2.25 12c0 2.071 4.365 3.75 9.75 3.75z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 43.5c10.77 0 19.5-8.73 19.5-19.5S34.77 4.5 24 4.5 4.5 13.23 4.5 24 13.23 43.5 24 43.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 43.5c5.799 0 10.5-8.73 10.5-19.5S29.799 4.5 24 4.5 13.5 13.23 13.5 24 18.201 43.5 24 43.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 31.5c10.77 0 19.5-3.358 19.5-7.5 0-4.142-8.73-7.5-19.5-7.5S4.5 19.858 4.5 24c0 4.142 8.73 7.5 19.5 7.5z"
  }))
};
var Global$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7L,
    fill: "none"
  }));
});
var compPaths$7K = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.5 19.5h6v-6h-6v6zm-9 0h6v-6h-6v6zm9-9h6v-6h-6v6zm-9 0h6v-6h-6v6z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.5 19.5h6v-6h-6v6zm-9 0h6v-6h-6v6zm9-9h6v-6h-6v6zm-9 0h6v-6h-6v6z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M27 39h12V27H27v12zM9 39h12V27H9v12zm18-18h12V9H27v12zM9 21h12V9H9v12z",
    clipRule: "evenodd"
  }))
};
var GridView$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7K,
    fill: "none"
  }));
});
var compPaths$7J = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.98 11.795l1.354 1.354c.098-.37.167-.75.167-1.149 0-2.481-2.02-4.5-4.5-4.5-.4 0-.78.069-1.15.167l1.355 1.354a2.986 2.986 0 012.774 2.774zM12 18c-4.37 0-7.979-4.594-8.982-5.998.568-.798 1.981-2.611 3.886-4.039l1.437 1.436A4.443 4.443 0 007.501 12a4.504 4.504 0 004.5 4.5 4.44 4.44 0 002.6-.842l1.224 1.225C14.661 17.545 13.37 18 12 18zm-2.577-7.52l4.096 4.097A2.938 2.938 0 0112 15c-1.654 0-3-1.346-3-3 0-.557.156-1.074.423-1.52zm8.744 6.624l-1.06-1.061-1.446-1.444v-.001l-1.085-1.085-4.089-4.089L9.402 8.34 8.175 7.112h.001L7.093 6.029 4.06 2.998 3 4.06l2.844 2.843c-1.999 1.537-3.451 3.391-4.048 4.23a1.495 1.495 0 000 1.735C2.903 14.424 6.912 19.5 12 19.5c1.8 0 3.461-.64 4.911-1.531l3.03 3.029L21 19.937l-2.834-2.833z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.213 11.131C21.103 9.575 17.086 4.5 12 4.5c-1.248 0-2.43.309-3.523.793l1.146 1.146A6.945 6.945 0 0112 6c4.367 0 7.984 4.59 8.99 6a20.26 20.26 0 01-2.725 3.08l1.056 1.057a21.717 21.717 0 002.892-3.268 1.5 1.5 0 000-1.738z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.98 11.795l1.354 1.354c.098-.37.167-.75.167-1.149 0-2.481-2.02-4.5-4.5-4.5-.4 0-.78.069-1.15.167l1.355 1.354a2.986 2.986 0 012.774 2.774zM12 18c-4.37 0-7.979-4.594-8.982-5.998.568-.798 1.981-2.611 3.886-4.039l1.437 1.436A4.443 4.443 0 007.501 12a4.504 4.504 0 004.5 4.5 4.44 4.44 0 002.6-.842l1.224 1.225C14.661 17.545 13.37 18 12 18zm-2.577-7.52l4.096 4.097A2.938 2.938 0 0112 15c-1.654 0-3-1.346-3-3 0-.557.156-1.074.423-1.52zm8.744 6.624l-1.06-1.061-1.446-1.444v-.001l-1.085-1.085-4.089-4.089L9.402 8.34 8.175 7.112h.001L7.093 6.029 4.06 2.998 3 4.06l2.844 2.843c-1.999 1.537-3.451 3.391-4.048 4.23a1.495 1.495 0 000 1.735C2.903 14.424 6.912 19.5 12 19.5c1.8 0 3.461-.64 4.911-1.531l3.03 3.029L21 19.937l-2.834-2.833z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.213 11.131C21.103 9.575 17.086 4.5 12 4.5c-1.248 0-2.43.309-3.523.793l1.146 1.146A6.945 6.945 0 0112 6c4.367 0 7.984 4.59 8.99 6a20.26 20.26 0 01-2.725 3.08l1.056 1.057a21.717 21.717 0 002.892-3.268 1.5 1.5 0 000-1.738z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M29.96 23.59l2.707 2.708c.196-.74.334-1.5.334-2.298 0-4.962-4.038-9-9-9-.8 0-1.56.138-2.298.334l2.708 2.708a5.973 5.973 0 015.548 5.548z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M44.426 22.262C42.206 19.15 34.172 9 24 9c-2.496 0-4.862.618-7.046 1.586l2.292 2.292C20.76 12.328 22.352 12 24 12c8.734 0 15.968 9.18 17.98 12-.894 1.254-2.822 3.76-5.45 6.16l2.112 2.114c2.802-2.57 4.83-5.2 5.784-6.536a2.999 2.999 0 000-3.476zM24 36c-8.742 0-15.958-9.188-17.964-11.996 1.136-1.596 3.962-5.222 7.772-8.078l2.874 2.872A8.886 8.886 0 0015 24c0 4.962 4.038 9 9 9a8.879 8.879 0 005.202-1.684l2.448 2.45C29.322 35.09 26.738 36 24 36zm-5.154-15.04l8.192 8.194A5.876 5.876 0 0124 30c-3.308 0-6-2.692-6-6 0-1.114.312-2.148.846-3.04zm17.488 13.248l-2.122-2.122-2.89-2.888v-.002l-2.17-2.17-8.178-8.178-2.17-2.17-2.454-2.454h.002l-2.166-2.166h-.002L8.122 5.996 6 8.118l5.688 5.686c-3.998 3.074-6.902 6.782-8.096 8.46a2.99 2.99 0 000 3.47C5.806 28.848 13.824 39 24 39c3.6 0 6.922-1.28 9.822-3.062l6.058 6.058L42 39.874l-5.666-5.666z",
    clipRule: "evenodd"
  }))
};
var Hide$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7J,
    fill: "none"
  }));
});
var compPaths$7I = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 7v5l2.64 2.64"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M4.25 6.02v3.73h3.73"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 4.75c4.01 0 7.25 3.24 7.25 7.25s-3.24 7.25-7.25 7.25S4.75 16.01 4.75 12m.34-2.2C6.02 6.88 8.77 4.75 12 4.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 6v6l3 3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M3.25 5.5v4.25H7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 3.75c4.56 0 8.25 3.69 8.25 8.25 0 4.56-3.69 8.25-8.25 8.25-4.56 0-8.25-3.69-8.25-8.25m.39-2.5A8.25 8.25 0 0112 3.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 12v12l6 6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M6.5 11v8.5H15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 7.5c9.12 0 16.5 7.38 16.5 16.5 0 9.12-7.38 16.5-16.5 16.5-9.12 0-16.5-7.38-16.5-16.5m.78-5C10.38 12.34 16.64 7.5 24 7.5"
  }))
};
var History$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7I,
    fill: "none"
  }));
});
var compPaths$7H = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 20.25h12A2.25 2.25 0 0020.25 18v-7.148L12 3.975l-8.25 6.877V21"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 20.25h12A2.25 2.25 0 0020.25 18v-7.148L12 3.975l-8.25 6.877V21"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M12 40.5h24a4.5 4.5 0 004.5-4.5V21.704L24 7.95 7.5 21.704V42"
  }))
};
var Home$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7H,
    fill: "none"
  }));
});
var compPaths$7G = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.999L3 10.5V21h15c1.654 0 3-1.346 3-3v-7.5L12 3z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.999L3 10.5V21h15c1.654 0 3-1.346 3-3v-7.5L12 3z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M24 5.997L6 21v20.998h30c3.308 0 6-2.69 6-6V21L24 5.997z",
    clipRule: "evenodd"
  }))
};
var HomeFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7G,
    fill: "none"
  }));
});
var compPaths$7F = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 21H6v-1.5h12c.827 0 1.5-.673 1.5-1.5v-6.797L12 4.952l-7.5 6.251V21H3V10.501l9-7.502 9 7.502V18c0 1.654-1.346 3-3 3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: ".5",
    d: "M18 21H6v-1.5h12c.827 0 1.5-.673 1.5-1.5v-6.797L12 4.952l-7.5 6.251V21H3V10.501l9-7.502 9 7.502V18c0 1.654-1.346 3-3 3z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 21H6v-1.5h12c.827 0 1.5-.673 1.5-1.5v-6.797L12 4.952l-7.5 6.251V21H3V10.501l9-7.502 9 7.502V18c0 1.654-1.346 3-3 3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: ".5",
    d: "M18 21H6v-1.5h12c.827 0 1.5-.673 1.5-1.5v-6.797L12 4.952l-7.5 6.251V21H3V10.501l9-7.502 9 7.502V18c0 1.654-1.346 3-3 3z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M36 42H12v-3h24c1.654 0 3-1.346 3-3V22.406L24 9.904 9 22.406V42H6V21.002L24 5.998l18 15.004V36c0 3.308-2.692 6-6 6z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    d: "M36 42H12v-3h24c1.654 0 3-1.346 3-3V22.406L24 9.904 9 22.406V42H6V21.002L24 5.998l18 15.004V36c0 3.308-2.692 6-6 6z",
    clipRule: "evenodd"
  }))
};
var HomeStroke$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7F,
    fill: "none"
  }));
});
var compPaths$7E = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 9a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 18.324l3.746-3.746 2.342 2.342 6.666-6.665 3.75 3.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 9a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 18.324l3.746-3.746 2.342 2.342 6.666-6.665 3.75 3.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 18a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 36.648l7.492-7.492 4.684 4.684 13.332-13.33 7.5 7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 40.5H12A4.5 4.5 0 017.5 36V12A4.5 4.5 0 0112 7.5h24a4.5 4.5 0 014.5 4.5v24a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }))
};
var ImagenoImage$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7E,
    fill: "none"
  }));
});
var compPaths$7D = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.567 6.1l-5.979 5.98a2.251 2.251 0 01-3.181 0l-5.55-5.55a.75.75 0 01.53-1.28H18a2.25 2.25 0 012.25 2.25v9A2.25 2.25 0 0118 18.75H6a2.25 2.25 0 01-2.25-2.25V9"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.567 6.1l-5.979 5.98a2.251 2.251 0 01-3.181 0l-5.55-5.55a.75.75 0 01.53-1.28H18a2.25 2.25 0 012.25 2.25v9A2.25 2.25 0 0118 18.75H6a2.25 2.25 0 01-2.25-2.25V9"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M39.135 12.201L27.177 24.16a4.503 4.503 0 01-6.364 0l-11.1-11.098c-.944-.944-.276-2.562 1.062-2.562h25.226c2.484 0 4.5 2.016 4.5 4.5v18a4.5 4.5 0 01-4.5 4.5h-24a4.5 4.5 0 01-4.5-4.5V18"
  }))
};
var Inbox$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7D,
    fill: "none"
  }));
});
var compPaths$7C = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.937 11.55a1.503 1.503 0 002.12 0l6.566-6.566A2.975 2.975 0 0018 4.5H6c-.6 0-1.157.181-1.626.486l6.563 6.563z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.118 12.61a2.994 2.994 0 01-2.121.877 2.992 2.992 0 01-2.121-.877L3.364 6.098A2.96 2.96 0 003 7.5v9c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3v-9c0-.511-.14-.984-.366-1.406l-6.516 6.516z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.937 11.55a1.503 1.503 0 002.12 0l6.566-6.566A2.975 2.975 0 0018 4.5H6c-.6 0-1.157.181-1.626.486l6.563 6.563z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.118 12.61a2.994 2.994 0 01-2.121.877 2.992 2.992 0 01-2.121-.877L3.364 6.098A2.96 2.96 0 003 7.5v9c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3v-9c0-.511-.14-.984-.366-1.406l-6.516 6.516z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.873 23.099a3.006 3.006 0 004.242 0l13.132-13.13A5.95 5.95 0 0036 9H12c-1.2 0-2.314.362-3.252.972l13.126 13.126z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M28.236 25.22a5.988 5.988 0 01-4.242 1.754 5.984 5.984 0 01-4.241-1.754L6.728 12.196C6.278 13.038 6 13.982 6 15v18c0 3.308 2.692 6 6 6h24c3.309 0 6-2.692 6-6V15c0-1.022-.28-1.968-.731-2.812L28.237 25.22z",
    clipRule: "evenodd"
  }))
};
var InboxFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7C,
    fill: "none"
  }));
});
var compPaths$7B = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M19.567 6.1l-5.979 5.98a2.251 2.251 0 01-3.181 0l-5.55-5.55a.75.75 0 01.53-1.28H18a2.25 2.25 0 012.25 2.25v9A2.25 2.25 0 0118 18.75H6a2.25 2.25 0 01-2.25-2.25V9"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M19.567 6.1l-5.979 5.98a2.251 2.251 0 01-3.181 0l-5.55-5.55a.75.75 0 01.53-1.28H18a2.25 2.25 0 012.25 2.25v9A2.25 2.25 0 0118 18.75H6a2.25 2.25 0 01-2.25-2.25V9"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M39.135 12.201L27.177 24.16a4.503 4.503 0 01-6.364 0l-11.1-11.098c-.944-.944-.276-2.562 1.062-2.562h25.226c2.484 0 4.5 2.016 4.5 4.5v18a4.5 4.5 0 01-4.5 4.5h-24a4.5 4.5 0 01-4.5-4.5V18"
  }))
};
var InboxStroke$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7B,
    fill: "none"
  }));
});
var compPaths$7A = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 7v1.5m0 1.5v7"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 9v9m0-12v1.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 18v18m0-24v3"
  }))
};
var Info$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7A,
    fill: "none"
  }));
});
var compPaths$7z = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 7v1.5m0 1.5v7m0 2.25c4 0 7.25-3.25 7.25-7.25S16 4.75 12 4.75 4.75 8 4.75 12 8 19.25 12 19.25z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 9v9m0-12v1.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 24c0 10.77-8.73 19.5-19.5 19.5S4.5 34.77 4.5 24 13.23 4.5 24 4.5 43.5 13.23 43.5 24z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 18v18m0-24v3"
  }))
};
var InfoCircle$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7z,
    fill: "none"
  }));
});
var compPaths$7y = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm.75 13h-1.5v-7h1.5v7zm0-8.5h-1.5V7h1.5v1.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 1.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5zm.75 16.5h-1.5V9h1.5v9zm0-10.5h-1.5V6h1.5v1.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M24 3C12.42 3 3 12.42 3 24s9.42 21 21 21 21-9.42 21-21S35.58 3 24 3zm1.5 33h-3V18h3v18zm0-21h-3v-3h3v3z"
  }))
};
var InfoCircleFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7y,
    fill: "none"
  }));
});
var compPaths$7x = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.5 3.75H5.75a2 2 0 00-2 2v14a2 2 0 002 2h12.5a2 2 0 002-2v-14a2 2 0 00-2-2H17"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M6 6.75h5.5m-5.5 3h4m.75 12h4a2.498 2.498 0 002.5-2.5m0 0a2.46 2.46 0 00-.732-1.75 2.518 2.518 0 00-1.768-.75h-1V2.25h1a2.5 2.5 0 012.5 2.5v14.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.5 3.75H5.75a2 2 0 00-2 2v14a2 2 0 002 2h12.5a2 2 0 002-2v-14a2 2 0 00-2-2H17"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M6 6.75h5.5m-5.5 3h4m.75 12h4a2.498 2.498 0 002.5-2.5m0 0a2.46 2.46 0 00-.732-1.75 2.518 2.518 0 00-1.768-.75h-1V2.25h1a2.5 2.5 0 012.5 2.5v14.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M23 7.5H11.5a4 4 0 00-4 4v28a4 4 0 004 4h25a4 4 0 004-4v-28a4 4 0 00-4-4H34"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M12 13.5h11m-11 6h8m1.5 24h8a4.995 4.995 0 005-5m0 0a4.918 4.918 0 00-1.465-3.5c-.937-.938-2.209-1.5-3.535-1.5h-2v-29h2a5 5 0 015 5v29z"
  }))
};
var Journal$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7x,
    fill: "none"
  }));
});
var compPaths$7w = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.53 16.773l-2.12 2.121a3.752 3.752 0 01-5.305-5.304l3.182-3.18a3.75 3.75 0 015.304 0l1.061 1.06"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.47 7.227l2.12-2.122a3.752 3.752 0 015.305 5.304l-3.182 3.182a3.75 3.75 0 01-5.304 0l-1.061-1.06"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.53 16.773l-2.12 2.121a3.752 3.752 0 01-5.305-5.304l3.182-3.18a3.75 3.75 0 015.304 0l1.061 1.06"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.47 7.227l2.12-2.122a3.752 3.752 0 015.305 5.304l-3.182 3.182a3.75 3.75 0 01-5.304 0l-1.061-1.06"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M25.06 33.547l-4.241 4.242a7.503 7.503 0 01-10.608 0 7.503 7.503 0 010-10.608l6.364-6.362a7.5 7.5 0 0110.608 0l2.122 2.12"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M22.94 14.454l4.241-4.244a7.503 7.503 0 0110.608 0 7.503 7.503 0 010 10.608l-6.364 6.364a7.5 7.5 0 01-10.608 0l-2.122-2.122"
  }))
};
var Link$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7w,
    fill: "none"
  }));
});
var compPaths$7v = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 2.25A9.75 9.75 0 0121.75 12"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 2.25A9.75 9.75 0 0121.75 12"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 24c0 10.77-8.73 19.5-19.5 19.5S4.5 34.77 4.5 24 13.23 4.5 24 4.5 43.5 13.23 43.5 24z",
    clipRule: "evenodd",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 4.5c10.77 0 19.5 8.73 19.5 19.5"
  }))
};
var Loading$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7v,
    fill: "none"
  }));
});
var compPaths$7u = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 19.25l-.61.436a.75.75 0 001.22 0L12 19.25zm4.5-8.998c0 1.32-.854 2.947-2.006 4.577-.56.794-1.164 1.55-1.714 2.229-.54.666-1.052 1.282-1.39 1.756l1.22.872c.304-.425.77-.987 1.335-1.683a43.976 43.976 0 001.774-2.308C16.871 14.065 18 12.091 18 10.252h-1.5zm-3.89 8.562c-.338-.474-.85-1.09-1.39-1.756a42.613 42.613 0 01-1.714-2.229C8.354 13.2 7.5 11.572 7.5 10.252H6c0 1.84 1.129 3.813 2.281 5.443.591.836 1.22 1.625 1.774 2.308.565.696 1.031 1.258 1.335 1.683l1.22-.872zM7.5 10.252C7.5 7.594 9.547 5.5 12 5.5V4c-3.347 0-6 2.833-6 6.252h1.5zM12 5.5c2.453 0 4.5 2.094 4.5 4.752H18C18 6.832 15.347 4 12 4v1.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.5 10a2.5 2.5 0 11-5 .002 2.5 2.5 0 015-.001z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 21.747l-.468.586a.75.75 0 00.936 0L12 21.747zM18 9c0 .92-.303 2.081-.824 3.362-.515 1.269-1.222 2.6-1.974 3.843a38.411 38.411 0 01-2.217 3.274c-.695.914-1.223 1.498-1.453 1.682l.936 1.172c.395-.314 1.023-1.042 1.711-1.947a39.904 39.904 0 002.306-3.404c.78-1.288 1.526-2.691 2.08-4.055.55-1.352.935-2.723.935-3.927H18zm-5.532 12.16c-.23-.183-.758-.767-1.453-1.681a38.41 38.41 0 01-2.217-3.274c-.752-1.243-1.458-2.574-1.974-3.843C6.303 11.081 6 9.921 6 9H4.5c0 1.204.385 2.575.934 3.927.555 1.364 1.302 2.767 2.08 4.055.78 1.288 1.6 2.474 2.307 3.404.688.905 1.316 1.633 1.711 1.947l.936-1.172zM6 9a6 6 0 016-6V1.5A7.5 7.5 0 004.5 9H6zm6-6a6 6 0 016 6h1.5A7.5 7.5 0 0012 1.5V3z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.25 9a3.25 3.25 0 11-6.5 0 3.25 3.25 0 016.5 0z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M24 43.5l-.936 1.173a1.5 1.5 0 001.872 0L24 43.5zm12-25.498c0 1.841-.606 4.163-1.647 6.725-1.032 2.538-2.444 5.2-3.949 7.688a76.834 76.834 0 01-4.434 6.547c-1.39 1.83-2.445 2.998-2.905 3.365l1.87 2.346c.79-.63 2.048-2.085 3.423-3.895a79.802 79.802 0 004.613-6.81c1.558-2.576 3.052-5.383 4.16-8.111C38.232 23.153 39 20.41 39 18.002h-3zM24.936 42.327c-.461-.367-1.516-1.535-2.906-3.364a76.834 76.834 0 01-4.434-6.548c-1.505-2.488-2.917-5.15-3.949-7.688C12.606 22.165 12 19.843 12 18.002H9c0 2.41.77 5.151 1.868 7.855 1.11 2.728 2.603 5.535 4.161 8.11a79.802 79.802 0 004.613 6.81c1.375 1.81 2.633 3.266 3.422 3.896l1.872-2.346zM12 18.002C12 11.373 17.373 6 24 6V3C15.715 3 9 9.717 9 18.002h3zM24 6c6.627 0 12 5.373 12 12.002h3C39 9.717 32.285 3 24 3v3z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M30.5 18a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z",
    clipRule: "evenodd"
  }))
};
var LocationPin$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7u,
    fill: "none"
  }));
});
var compPaths$7t = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 10.252C6 6.832 8.653 4 12 4s6 2.833 6 6.252c0 1.84-1.129 3.813-2.281 5.443a43.976 43.976 0 01-1.774 2.308l-.277.34c-.44.541-.805.99-1.058 1.343a.75.75 0 01-1.22 0 30.643 30.643 0 00-1.058-1.343l-.277-.34a44.003 44.003 0 01-1.774-2.308C7.129 14.065 6 12.091 6 10.252zm6 2.25a2.5 2.5 0 100-5 2.5 2.5 0 000 5z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 9.001a7.5 7.5 0 1115 0c0 1.205-.385 2.576-.934 3.928-.555 1.364-1.302 2.767-2.08 4.055a39.918 39.918 0 01-2.307 3.405c-.688.905-1.316 1.632-1.711 1.947a.75.75 0 01-.936 0c-.395-.315-1.023-1.042-1.711-1.947a39.916 39.916 0 01-2.306-3.405c-.78-1.288-1.526-2.691-2.08-4.056-.55-1.351-.935-2.722-.935-3.927zM12 12.25a3.25 3.25 0 100-6.5 3.25 3.25 0 000 6.5z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 18.002C9 9.717 15.715 3 24 3s15 6.717 15 15.002c0 2.41-.77 5.151-1.868 7.855-1.11 2.728-2.603 5.535-4.161 8.11a79.802 79.802 0 01-4.613 6.81c-1.375 1.81-2.633 3.266-3.422 3.896a1.5 1.5 0 01-1.872 0c-.789-.63-2.047-2.085-3.422-3.895a79.802 79.802 0 01-4.613-6.81c-1.558-2.576-3.052-5.383-4.16-8.111C9.768 23.153 9 20.41 9 18.002zM24 24.5a6.5 6.5 0 100-13 6.5 6.5 0 000 13z",
    clipRule: "evenodd"
  }))
};
var LocationPinFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7t,
    fill: "none"
  }));
});
var compPaths$7s = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.25 20.25H6.75c-.83 0-1.5-.67-1.5-1.5v-7.5c0-.83.67-1.5 1.5-1.5h10.5c.83 0 1.5.67 1.5 1.5v7.5c0 .83-.67 1.5-1.5 1.5zm-1.5-11V7.5c0-2.07-1.68-3.75-3.75-3.75-2.07 0-3.75 1.68-3.75 3.75v2.25M12 16v2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15.75a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.25 20.25H6.75c-.83 0-1.5-.67-1.5-1.5v-7.5c0-.83.67-1.5 1.5-1.5h10.5c.83 0 1.5.67 1.5 1.5v7.5c0 .83-.67 1.5-1.5 1.5zm-1.5-11V7.5c0-2.07-1.68-3.75-3.75-3.75-2.07 0-3.75 1.68-3.75 3.75v2.25M12 16v2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15.75a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M34.5 40.5h-21c-1.66 0-3-1.34-3-3v-15c0-1.66 1.34-3 3-3h21c1.66 0 3 1.34 3 3v15c0 1.66-1.34 3-3 3zm-3-22V15c0-4.14-3.36-7.5-7.5-7.5-4.14 0-7.5 3.36-7.5 7.5v4.5M24 32v4"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 31.5a3 3 0 100-6 3 3 0 000 6z"
  }))
};
var Lock$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7s,
    fill: "none"
  }));
});
var compPaths$7r = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M17.25 9h-.75V7.5C16.5 5.02 14.48 3 12 3S7.5 5.02 7.5 7.5V9h-.75C5.51 9 4.5 10.01 4.5 11.25v7.5C4.5 19.99 5.51 21 6.75 21h10.5c1.24 0 2.25-1.01 2.25-2.25v-7.5c0-1.24-1.01-2.25-2.25-2.25zM9 7.5c0-1.65 1.35-3 3-3s3 1.35 3 3V9H9V7.5zm3.75 8.86V18h-1.5v-1.64c-.87-.31-1.5-1.14-1.5-2.11C9.75 13.01 10.76 12 12 12s2.25 1.01 2.25 2.25c0 .98-.63 1.8-1.5 2.11z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M17.25 9h-.75V7.5C16.5 5.02 14.48 3 12 3S7.5 5.02 7.5 7.5V9h-.75C5.51 9 4.5 10.01 4.5 11.25v7.5C4.5 19.99 5.51 21 6.75 21h10.5c1.24 0 2.25-1.01 2.25-2.25v-7.5c0-1.24-1.01-2.25-2.25-2.25zM9 7.5c0-1.65 1.35-3 3-3s3 1.35 3 3V9H9V7.5zm3.75 8.86V18h-1.5v-1.64c-.87-.31-1.5-1.14-1.5-2.11C9.75 13.01 10.76 12 12 12s2.25 1.01 2.25 2.25c0 .98-.63 1.8-1.5 2.11z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M34.5 18H33v-3c0-4.96-4.04-9-9-9s-9 4.04-9 9v3h-1.5C11.02 18 9 20.02 9 22.5v15c0 2.48 2.02 4.5 4.5 4.5h21c2.48 0 4.5-2.02 4.5-4.5v-15c0-2.48-2.02-4.5-4.5-4.5zM18 15c0-3.3 2.7-6 6-6s6 2.7 6 6v3H18v-3zm7.5 17.72V36h-3v-3.28c-1.74-.62-3-2.28-3-4.22 0-2.48 2.02-4.5 4.5-4.5s4.5 2.02 4.5 4.5c0 1.96-1.26 3.6-3 4.22z"
  }))
};
var LockFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7r,
    fill: "none"
  }));
});
var compPaths$7q = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 10.5v6.75a1.5 1.5 0 01-1.5 1.5H3.75a1.5 1.5 0 01-1.5-1.5V10.5m3.308-2.25h12.885"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.79 5.599l2.652 2.65-2.652 2.653M8.21 5.599l-2.652 2.65 2.652 2.653M17.25 19v-2.5M12 19v-2.5M6.75 19v-2.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 10.5v6.75a1.5 1.5 0 01-1.5 1.5H3.75a1.5 1.5 0 01-1.5-1.5V10.5m3.308-2.25h12.885"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.79 5.599l2.652 2.65-2.652 2.653M8.21 5.599l-2.652 2.65 2.652 2.653M17.25 19v-2.5M12 19v-2.5M6.75 19v-2.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 21v13.5a3 3 0 01-3 3h-33a3 3 0 01-3-3V21m6.615-4.5h25.77"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.581 11.197l5.304 5.302-5.304 5.304M16.419 11.197L11.115 16.5l5.304 5.304M34.5 38v-5M24 38v-5m-10.5 5v-5"
  }))
};
var Measure$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7q,
    fill: "none"
  }));
});
var compPaths$7p = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 9.75l1.5-6h13.5l1.5 6v7.5a3 3 0 01-3 3H3.75V9.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20.25 9.75H3.75M12 4v6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M9.26 14.694c-.64-.474-.154-1.414.02-1.694-.314.347-.628.687-.868 1.06-.38.587-.546 1.234-.286 1.647.466.747 1.58.4 2.287.1L17 13.027l-6.507 1.72c-.547.14-.987.127-1.234-.053z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 9.75l1.5-6h13.5l1.5 6v7.5a3 3 0 01-3 3H3.75V9.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20.25 9.75H3.75M12 4v6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M9.26 14.694c-.64-.474-.154-1.414.02-1.694-.314.347-.628.687-.868 1.06-.38.587-.546 1.234-.286 1.647.466.747 1.58.4 2.287.1L17 13.027l-6.507 1.72c-.547.14-.987.127-1.234-.053z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 19.5l3-12h27l3 12v15a6 6 0 01-6 6h-27v-21z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M40.5 19.5h-33M24 8v12"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M18.518 29.387c-1.28-.947-.306-2.827.04-3.387-.626.693-1.253 1.373-1.733 2.12-.76 1.174-1.094 2.467-.574 3.294.934 1.493 3.16.8 4.574.2L34 26.054l-13.015 3.44c-1.093.28-1.973.253-2.467-.107z"
  }))
};
var MemberProduct$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7p,
    fill: "none"
  }));
});
var compPaths$7o = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 17v4.25a.5.5 0 01-.596.484c-.096-.019-.254-.134-.254-.134L12 19l-3.65 2.6s-.158.115-.254.134a.499.499 0 01-.596-.484V14"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M9.214 9.133c-.617-.457-.148-1.363.02-1.633-.303.334-.605.662-.836 1.022-.367.566-.527 1.19-.277 1.588.45.72 1.524.385 2.205.096l6.35-2.68-6.273 1.658c-.527.135-.951.122-1.19-.051z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 17v4.25a.5.5 0 01-.596.484c-.096-.019-.254-.134-.254-.134L12 19l-3.65 2.6s-.158.115-.254.134a.499.499 0 01-.596-.484V14"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M9.214 9.133c-.617-.457-.148-1.363.02-1.633-.303.334-.605.662-.836 1.022-.367.566-.527 1.19-.277 1.588.45.72 1.524.385 2.205.096l6.35-2.68-6.273 1.658c-.527.135-.951.122-1.19-.051z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33 34v8.5a1 1 0 01-1.191.968c-.192-.038-.509-.268-.509-.268L24 38l-7.3 5.2s-.317.23-.509.267A1 1 0 0115 42.5V28"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 31.5c7.456 0 13.5-6.044 13.5-13.5S31.456 4.5 24 4.5 10.5 10.544 10.5 18 16.544 31.5 24 31.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M18.428 18.265c-1.234-.913-.296-2.725.038-3.265-.604.668-1.208 1.324-1.67 2.044-.734 1.131-1.055 2.378-.554 3.175.9 1.44 3.047.772 4.41.193l12.7-5.36-12.546 3.316c-1.054.27-1.903.244-2.378-.103z"
  }))
};
var MemberRewards$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7o,
    fill: "none"
  }));
});
var compPaths$7n = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21 5.25H3M21 12H3m18 6.75H3"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21 5.25H3M21 12H3m18 6.75H3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M42 10.5H6M42 24H6m36 13.5H6"
  }))
};
var Menu$3 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7n,
    fill: "none"
  }));
});
var compPaths$7m = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3 8.25h18m-18 7.5h15"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3 8.25h18m-18 7.5h15"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M42 16.5H6m30 15H6"
  }))
};
var Menu2lines$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7m,
    fill: "none"
  }));
});
var compPaths$7l = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16 17.25h2A2.25 2.25 0 0020.25 15V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v9A2.25 2.25 0 006 17.25h6a2.25 2.25 0 012.25 2.25V21m.75-8.25H7.5m9-4.5h-9"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16 17.25h2A2.25 2.25 0 0020.25 15V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v9A2.25 2.25 0 006 17.25h6a2.25 2.25 0 012.25 2.25V21m.75-8.25H7.5m9-4.5h-9"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M32 34.5h4a4.5 4.5 0 004.5-4.5V12A4.5 4.5 0 0036 7.5H12A4.5 4.5 0 007.5 12v18a4.5 4.5 0 004.5 4.5h12a4.5 4.5 0 014.5 4.5v3M30 25.5H15m18-9H15"
  }))
};
var Message$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7l,
    fill: "none"
  }));
});
var compPaths$7k = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 10.5a3.75 3.75 0 007.5 0V6a3.75 3.75 0 00-7.5 0v4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.25 10.5a6.75 6.75 0 1013.5 0M12 22.5v-6m-3 5.25h6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 10.5a3.75 3.75 0 007.5 0V6a3.75 3.75 0 00-7.5 0v4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.25 10.5a6.75 6.75 0 1013.5 0M12 22.5v-6m-3 5.25h6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.5 21a7.5 7.5 0 0015 0v-9a7.5 7.5 0 00-15 0v9z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M10.5 21c0 7.456 6.044 13.5 13.5 13.5S37.5 28.456 37.5 21M24 45V33m-6 10.5h12"
  }))
};
var Microphone$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7k,
    fill: "none"
  }));
});
var compPaths$7j = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M5 20.25h14m-13.43-3L3.16 8.23c-.14-.49.47-.84.83-.48l4.45 4.45c.27.27.74.15.84-.22l2.24-8.35c.13-.49.83-.49.97 0l2.24 8.35c.1.37.56.5.84.22l4.45-4.45c.36-.36.97-.01.84.48l-2.42 9.02H5.57z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M5 20.25h14m-13.43-3L3.16 8.23c-.14-.49.47-.84.83-.48l4.45 4.45c.27.27.74.15.84-.22l2.24-8.35c.13-.49.83-.49.97 0l2.24 8.35c.1.37.56.5.84.22l4.45-4.45c.36-.36.97-.01.84.48l-2.42 9.02H5.57z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M10 40.5h28m-26.86-6L6.32 16.46c-.28-.98.94-1.68 1.66-.96l8.9 8.9c.54.54 1.48.3 1.68-.44l4.48-16.7c.26-.98 1.66-.98 1.94 0l4.48 16.7c.2.74 1.12 1 1.68.44l8.9-8.9c.72-.72 1.94-.02 1.68.96L36.88 34.5H11.14z"
  }))
};
var Monarch$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7j,
    fill: "none"
  }));
});
var compPaths$7i = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M13.5 20.25h-9c-1.24 0-2.25-1.01-2.25-2.25v-7.5c0-1.24 1.01-2.25 2.25-2.25h9c1.24 0 2.25 1.01 2.25 2.25V18c0 1.24-1.01 2.25-2.25 2.25z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8.25 8.25v-.76c0-1.24 1.01-2.25 2.25-2.25h9c1.24 0 2.25 1.01 2.25 2.25V15c0 1.24-1.01 2.25-2.25 2.25h-3.75m2.24-9h1.5m-1.5 3h1.5m-1.5 3h1.5m-12.74 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-1 5.95L12 13.95l3.75 3.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M13.5 20.25h-9c-1.24 0-2.25-1.01-2.25-2.25v-7.5c0-1.24 1.01-2.25 2.25-2.25h9c1.24 0 2.25 1.01 2.25 2.25V18c0 1.24-1.01 2.25-2.25 2.25z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8.25 8.25v-.76c0-1.24 1.01-2.25 2.25-2.25h9c1.24 0 2.25 1.01 2.25 2.25V15c0 1.24-1.01 2.25-2.25 2.25h-3.75m2.24-9h1.5m-1.5 3h1.5m-1.5 3h1.5m-12.74 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-1 5.95L12 13.95l3.75 3.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M27 40.5H9c-2.48 0-4.5-2.02-4.5-4.5V21c0-2.48 2.02-4.5 4.5-4.5h18c2.48 0 4.5 2.02 4.5 4.5v15c0 2.48-2.02 4.5-4.5 4.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M16.5 16.5v-1.52c0-2.48 2.02-4.5 4.5-4.5h18c2.48 0 4.5 2.02 4.5 4.5V30c0 2.48-2.02 4.5-4.5 4.5h-7.5m4.48-18h3m-3 6h3m-3 6h3m-25.48 0a3 3 0 100-6 3 3 0 000 6zm-2 11.9L24 27.9l7.5 7.5"
  }))
};
var Multimedia$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7i,
    fill: "none"
  }));
});
var compPaths$7h = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20.25 6.75V9c0 .83-.67 1.5-1.5 1.5H8.25c-.83 0-1.5-.67-1.5-1.5V6.75c0-.83.67-1.5 1.5-1.5h10.5c.83 0 1.5.67 1.5 1.5zm0 8.25v2.25c0 .83-.67 1.5-1.5 1.5H8.25c-.83 0-1.5-.67-1.5-1.5V15c0-.83.67-1.5 1.5-1.5h10.5c.83 0 1.5.67 1.5 1.5zM3 16.25h1.5M3 7.75h1.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20.25 6.75V9c0 .83-.67 1.5-1.5 1.5H8.25c-.83 0-1.5-.67-1.5-1.5V6.75c0-.83.67-1.5 1.5-1.5h10.5c.83 0 1.5.67 1.5 1.5zm0 8.25v2.25c0 .83-.67 1.5-1.5 1.5H8.25c-.83 0-1.5-.67-1.5-1.5V15c0-.83.67-1.5 1.5-1.5h10.5c.83 0 1.5.67 1.5 1.5zM3 16.25h1.5M3 7.75h1.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M40.5 13.5V18c0 1.66-1.34 3-3 3h-21c-1.66 0-3-1.34-3-3v-4.5c0-1.66 1.34-3 3-3h21c1.66 0 3 1.34 3 3zm0 16.5v4.5c0 1.66-1.34 3-3 3h-21c-1.66 0-3-1.34-3-3V30c0-1.66 1.34-3 3-3h21c1.66 0 3 1.34 3 3zM6 32.5h3m-3-17h3"
  }))
};
var MultiSelect$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7h,
    fill: "none"
  }));
});
var compPaths$7g = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.775 8.338L18.26 3.843c1.172-.391 2.288.725 1.898 1.897l-4.495 13.485c-.448 1.341-2.33 1.376-2.827.051l-2.313-5.798-5.799-2.313c-1.324-.496-1.289-2.38.052-2.827z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.775 8.338L18.26 3.843c1.172-.391 2.288.725 1.898 1.897l-4.495 13.485c-.448 1.341-2.33 1.376-2.827.051l-2.313-5.798-5.799-2.313c-1.324-.496-1.289-2.38.052-2.827z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M9.552 16.676l26.968-8.99c2.344-.782 4.576 1.45 3.794 3.794l-8.99 26.97c-.894 2.682-4.662 2.752-5.654.102l-4.624-11.596-11.6-4.626c-2.646-.992-2.576-4.76.106-5.654z",
    clipRule: "evenodd"
  }))
};
var Navigation$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7g,
    fill: "none"
  }));
});
var compPaths$7f = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 14v-.5A2.5 2.5 0 0110 11h4a2.5 2.5 0 012.5 2.5v.5M14 6.5a2 2 0 11-4 0 2 2 0 014 0v0z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M6 16h12M6 19h8"
  }), /* @__PURE__ */ React__default.createElement("rect", {
    width: "16.5",
    height: "20",
    x: "3.75",
    y: "2",
    stroke: "currentColor",
    strokeWidth: "1.5",
    rx: "2"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 14v-.5A2.5 2.5 0 0110 11h4a2.5 2.5 0 012.5 2.5v.5M14 6.5a2 2 0 11-4 0 2 2 0 014 0v0z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M6 16h12M6 19h8"
  }), /* @__PURE__ */ React__default.createElement("rect", {
    width: "16.5",
    height: "20",
    x: "3.75",
    y: "2",
    stroke: "currentColor",
    strokeWidth: "1.5",
    rx: "2"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 28v-1a5 5 0 015-5h8a5 5 0 015 5v1m-5-15a4 4 0 11-8 0 4 4 0 018 0v0z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M12 32h24m-24 6h16"
  }), /* @__PURE__ */ React__default.createElement("rect", {
    width: "33",
    height: "40",
    x: "7.5",
    y: "4",
    stroke: "currentColor",
    strokeWidth: "3",
    rx: "4"
  }))
};
var NikeMembership$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7f,
    fill: "none"
  }));
});
var compPaths$7e = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M10.12 6.62c-1.88.75-3.2 2.58-3.2 4.72V12c0 .62-.54 1.13-1.17 1.13v2.62h12.5v-2.62c-.62 0-1.17-.5-1.17-1.13v-.66c0-2.59-1.93-4.72-4.43-5.04a.745.745 0 01-.65-.74V4m1.69 13.56c0 .93-.76 1.69-1.69 1.69-.93 0-1.69-.76-1.69-1.69"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.5 4.98a6.751 6.751 0 00-4.25 6.27v1.5c0 .83-.67 1.5-1.5 1.5v3h16.5v-3c-.83 0-1.5-.67-1.5-1.5v-1.5c0-3.43-2.56-6.27-5.88-6.69-.5-.07-.87-.49-.87-.99V1.5m2.25 18c0 1.24-1.01 2.25-2.25 2.25s-2.25-1.01-2.25-2.25"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M19 9.96c-4.98 1.98-8.5 6.86-8.5 12.54v3c0 1.66-1.34 3-3 3v6h33v-6c-1.66 0-3-1.34-3-3v-3c0-6.86-5.12-12.54-11.76-13.38-1-.14-1.74-.98-1.74-1.98V3m4.5 36c0 2.48-2.02 4.5-4.5 4.5s-4.5-2.02-4.5-4.5"
  }))
};
var Notification$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7e,
    fill: "none"
  }));
});
var compPaths$7d = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M19.5 18.44L5.56 4.5 4.5 5.56l1.7 1.7A7.442 7.442 0 004.5 12c0 4.14 3.36 7.5 7.5 7.5 1.8 0 3.45-.64 4.74-1.7l1.7 1.7 1.06-1.06zM12 18c-3.31 0-6-2.69-6-6 0-1.38.48-2.65 1.27-3.67l8.4 8.4A5.977 5.977 0 0112 18zm0-12c3.31 0 6 2.69 6 6 0 .83-.17 1.62-.48 2.34l1.12 1.12c.54-1.04.85-2.21.85-3.46 0-4.14-3.36-7.5-7.5-7.5-1.25 0-2.43.31-3.46.85l1.12 1.12C10.38 6.17 11.17 6 12 6z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M19.5 18.44L5.56 4.5 4.5 5.56l1.7 1.7A7.442 7.442 0 004.5 12c0 4.14 3.36 7.5 7.5 7.5 1.8 0 3.45-.64 4.74-1.7l1.7 1.7 1.06-1.06zM12 18c-3.31 0-6-2.69-6-6 0-1.38.48-2.65 1.27-3.67l8.4 8.4A5.977 5.977 0 0112 18zm0-12c3.31 0 6 2.69 6 6 0 .83-.17 1.62-.48 2.34l1.12 1.12c.54-1.04.85-2.21.85-3.46 0-4.14-3.36-7.5-7.5-7.5-1.25 0-2.43.31-3.46.85l1.12 1.12C10.38 6.17 11.17 6 12 6z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M39 36.88L11.12 9 9 11.12l3.4 3.4C10.28 17.1 9 20.4 9 24c0 8.28 6.72 15 15 15 3.6 0 6.9-1.28 9.48-3.4l3.4 3.4L39 36.88zM24 36c-6.62 0-12-5.38-12-12 0-2.76.96-5.3 2.54-7.34l16.8 16.8C29.3 35.04 26.76 36 24 36zm0-24c6.62 0 12 5.38 12 12 0 1.66-.34 3.24-.96 4.68l2.24 2.24c1.08-2.08 1.7-4.42 1.7-6.92 0-8.28-6.72-15-15-15-2.5 0-4.86.62-6.92 1.7l2.24 2.24c1.46-.6 3.04-.94 4.7-.94z"
  }))
};
var Null$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7d,
    fill: "none"
  }));
});
var compPaths$7c = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.25 4.75C13.01 4.75 12 5.76 12 7.5v6m6.93-3.75H4.83"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.25 4.75h3.66l1.34 5v9.5H4.75v-9.5l1.34-5H10"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.25 3.75C13.01 3.75 12 4.76 12 6.5v7m8.25-3.75H3.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.25 3.75h4.39l1.61 6v10.5H3.75V9.75l1.61-6h5.14"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M28.5 7.5C26.02 7.5 24 9.52 24 13v14m16.5-7.5h-33"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M28.5 7.5h8.78l3.22 12v21h-33v-21l3.22-12H21"
  }))
};
var Orders$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7c,
    fill: "none"
  }));
});
var compPaths$7b = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 18.75H6a2.25 2.25 0 01-2.25-2.25v-9A2.25 2.25 0 016 5.25h12a2.25 2.25 0 012.25 2.25v9A2.25 2.25 0 0118 18.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 9.75h16.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 18.75H6a2.25 2.25 0 01-2.25-2.25v-9A2.25 2.25 0 016 5.25h12a2.25 2.25 0 012.25 2.25v9A2.25 2.25 0 0118 18.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 9.75h16.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 37.5H12A4.502 4.502 0 017.5 33V15a4.5 4.5 0 014.5-4.5h24a4.5 4.5 0 014.5 4.5v18c0 2.484-2.016 4.5-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 19.5h33"
  }))
};
var Payment$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7b,
    fill: "none"
  }));
});
var compPaths$7a = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 21v-3A3.75 3.75 0 016 14.25h6A3.75 3.75 0 0115.75 18v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M22.955 9.167l-4.773 4.773-2.652-2.651"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 21v-3A3.75 3.75 0 016 14.25h6A3.75 3.75 0 0115.75 18v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M22.955 9.167l-4.773 4.773-2.652-2.651"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M4.5 42v-6a7.5 7.5 0 017.5-7.5h12a7.5 7.5 0 017.5 7.5v6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M25.5 15a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M45.91 18.334l-9.546 9.546-5.304-5.302"
  }))
};
var Personalization$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$7a,
    fill: "none"
  }));
});
var compPaths$79 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.5 21.75h-15c-1.24 0-2.25-1.01-2.25-2.25V6c0-1.24 1.01-2.25 2.25-2.25h15c1.24 0 2.25 1.01 2.25 2.25v13.5c0 1.24-1.01 2.25-2.25 2.25zm2.25-13.5H2.25m6-6.75V6m7.5-4.5V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.05 16.97l4.42-4.42m-4.42 0l4.42 4.42m-7.57-4.48l-3.42 3.92-1.95-1.94"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.5 21.75h-15c-1.24 0-2.25-1.01-2.25-2.25V6c0-1.24 1.01-2.25 2.25-2.25h15c1.24 0 2.25 1.01 2.25 2.25v13.5c0 1.24-1.01 2.25-2.25 2.25zm2.25-13.5H2.25m6-6.75V6m7.5-4.5V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.05 16.97l4.42-4.42m-4.42 0l4.42 4.42m-7.57-4.48l-3.42 3.92-1.95-1.94"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M39 43.5H9c-2.48 0-4.5-2.02-4.5-4.5V12c0-2.48 2.02-4.5 4.5-4.5h30c2.48 0 4.5 2.02 4.5 4.5v27c0 2.48-2.02 4.5-4.5 4.5zm4.5-27h-39M16.5 3v9m15-9v9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M28.1 33.94l8.84-8.84m-8.84 0l8.84 8.84M21.8 24.98l-6.84 7.84-3.9-3.88"
  }))
};
var Plan$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$79,
    fill: "none"
  }));
});
var compPaths$78 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.25 12c0 4-3.24 7.25-7.25 7.25S4.75 16 4.75 12 7.99 4.75 12 4.75 19.25 8 19.25 12zM12 8v8m4-4H8"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12c0 5.39-4.36 9.75-9.75 9.75S2.25 17.39 2.25 12 6.61 2.25 12 2.25s9.75 4.36 9.75 9.75zM12 6v12m6-6H6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 24c0 10.78-8.72 19.5-19.5 19.5S4.5 34.78 4.5 24 13.22 4.5 24 4.5 43.5 13.22 43.5 24zM24 12v24m12-12H12"
  }))
};
var PlusCircle$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$78,
    fill: "none"
  }));
});
var compPaths$77 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm4 8.75h-3.25V16h-1.5v-3.25H8v-1.5h3.25V8h1.5v3.25H16v1.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 1.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5zm6 11.25h-5.25V18h-1.5v-5.25H6v-1.5h5.25V6h1.5v5.25H18v1.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M24 3C12.42 3 3 12.42 3 24s9.42 21 21 21 21-9.42 21-21S35.58 3 24 3zm12 22.5H25.5V36h-3V25.5H12v-3h10.5V12h3v10.5H36v3z"
  }))
};
var PlusCircleFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$77,
    fill: "none"
  }));
});
var compPaths$76 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15.75 14.25h-7.5v6h7.5v-6zm-7.5-6.5v-4h7.5v4"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8 17.25H6c-1.24 0-2.25-1.01-2.25-2.25v-4.5c0-1.24 1.01-2.25 2.25-2.25h12c1.24 0 2.25 1.01 2.25 2.25V15c0 1.24-1.01 2.25-2.25 2.25m-12-6h1.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15.75 14.25h-7.5v6h7.5v-6zm-7.5-6.5v-4h7.5v4"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8 17.25H6c-1.24 0-2.25-1.01-2.25-2.25v-4.5c0-1.24 1.01-2.25 2.25-2.25h12c1.24 0 2.25 1.01 2.25 2.25V15c0 1.24-1.01 2.25-2.25 2.25m-12-6h1.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M31.5 28.5h-15v12h15v-12zm-15-13v-8h15v8"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M16 34.5h-4c-2.48 0-4.5-2.02-4.5-4.5v-9c0-2.48 2.02-4.5 4.5-4.5h24c2.48 0 4.5 2.02 4.5 4.5v9c0 2.48-2.02 4.5-4.5 4.5m-24-12h3"
  }))
};
var Print$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$76,
    fill: "none"
  }));
});
var compPaths$75 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 3a4.5 4.5 0 00-4.5 4.5H9a3 3 0 013-3V3zM7.5 7.5A4.5 4.5 0 0012 12v-1.5a3 3 0 01-3-3H7.5zM12 12a4.5 4.5 0 004.5-4.5H15a3 3 0 01-3 3V12zm4.5-4.5A4.5 4.5 0 0012 3v1.5a3 3 0 013 3h1.5zM4.5 21v-3H3v3h1.5zm0-3a3 3 0 013-3v-1.5A4.5 4.5 0 003 18h1.5zm3-3h9v-1.5h-9V15zm9 0a3 3 0 013 3H21a4.5 4.5 0 00-4.5-4.5V15zm3 3v3H21v-3h-1.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 3a4.5 4.5 0 00-4.5 4.5H9a3 3 0 013-3V3zM7.5 7.5A4.5 4.5 0 0012 12v-1.5a3 3 0 01-3-3H7.5zM12 12a4.5 4.5 0 004.5-4.5H15a3 3 0 01-3 3V12zm4.5-4.5A4.5 4.5 0 0012 3v1.5a3 3 0 013 3h1.5zM4.5 21v-3H3v3h1.5zm0-3a3 3 0 013-3v-1.5A4.5 4.5 0 003 18h1.5zm3-3h9v-1.5h-9V15zm9 0a3 3 0 013 3H21a4.5 4.5 0 00-4.5-4.5V15zm3 3v3H21v-3h-1.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 42v-6a7.5 7.5 0 017.5-7.5h18a7.5 7.5 0 017.5 7.5v6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.5 15a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z",
    clipRule: "evenodd"
  }))
};
var Profile$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$75,
    fill: "none"
  }));
});
var compPaths$74 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 21H3v-3c0-2.481 2.019-4.5 4.5-4.5h9c2.481 0 4.5 2.019 4.5 4.5v3h-1.5M12 12a4.505 4.505 0 01-4.5-4.5C7.5 5.019 9.519 3 12 3s4.5 2.019 4.5 4.5S14.481 12 12 12z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 21H3v-3c0-2.481 2.019-4.5 4.5-4.5h9c2.481 0 4.5 2.019 4.5 4.5v3h-1.5M12 12a4.505 4.505 0 01-4.5-4.5C7.5 5.019 9.519 3 12 3s4.5 2.019 4.5 4.5S14.481 12 12 12z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 42H6v-6c0-4.962 4.038-9 9-9h18c4.962 0 9 4.038 9 9v6h-3M24 24c-4.962 0-9-4.038-9-9s4.038-9 9-9 9 4.038 9 9-4.038 9-9 9z",
    clipRule: "evenodd"
  }))
};
var ProfileFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$74,
    fill: "none"
  }));
});
var compPaths$73 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M3.75 21v-3a3.75 3.75 0 013.75-3.75h9A3.75 3.75 0 0120.25 18v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M15.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M3.75 21v-3a3.75 3.75 0 013.75-3.75h9A3.75 3.75 0 0120.25 18v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M15.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M7.5 42v-6a7.5 7.5 0 017.5-7.5h18a7.5 7.5 0 017.5 7.5v6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M31.5 15a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z",
    clipRule: "evenodd"
  }))
};
var ProfileStroke$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$73,
    fill: "none"
  }));
});
var compPaths$72 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 3a4.5 4.5 0 00-4.5 4.5H9a3 3 0 013-3V3zM7.5 7.5A4.5 4.5 0 0012 12v-1.5a3 3 0 01-3-3H7.5zM12 12a4.5 4.5 0 004.5-4.5H15a3 3 0 01-3 3V12zm4.5-4.5A4.5 4.5 0 0012 3v1.5a3 3 0 013 3h1.5zM4.5 21v-3H3v3h1.5zm0-3a3 3 0 013-3v-1.5A4.5 4.5 0 003 18h1.5zm3-3H17v-1.5H7.5V15z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.5 17l-8.41 3.568c-.7.297-1.29.445-1.764.445-.534 0-.923-.189-1.162-.565-.31-.485-.175-1.266.357-2.09.316-.482.717-.924 1.108-1.347-.092.15-.904 1.5-.016 2.137.176.128.425.19.733.19.246 0 .53-.04.84-.121L22.5 17z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 3a4.5 4.5 0 00-4.5 4.5H9a3 3 0 013-3V3zM7.5 7.5A4.5 4.5 0 0012 12v-1.5a3 3 0 01-3-3H7.5zM12 12a4.5 4.5 0 004.5-4.5H15a3 3 0 01-3 3V12zm4.5-4.5A4.5 4.5 0 0012 3v1.5a3 3 0 013 3h1.5zM4.5 21v-3H3v3h1.5zm0-3a3 3 0 013-3v-1.5A4.5 4.5 0 003 18h1.5zm3-3H17v-1.5H7.5V15z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.5 17l-8.41 3.568c-.7.297-1.29.445-1.764.445-.534 0-.923-.189-1.162-.565-.31-.485-.175-1.266.357-2.09.316-.482.717-.924 1.108-1.347-.092.15-.904 1.5-.016 2.137.176.128.425.19.733.19.246 0 .53-.04.84-.121L22.5 17z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M24 6a9 9 0 00-9 9h3a6 6 0 016-6V6zm-9 9a9 9 0 009 9v-3a6 6 0 01-6-6h-3zm9 9a9 9 0 009-9h-3a6 6 0 01-6 6v3zm9-9a9 9 0 00-9-9v3a6 6 0 016 6h3zM9 42v-6H6v6h3zm0-6a6 6 0 016-6v-3a9 9 0 00-9 9h3zm6-6h19v-3H15v3z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M45 34l-16.82 7.135c-1.4.594-2.579.89-3.528.89-1.068 0-1.846-.376-2.324-1.129-.62-.97-.35-2.532.714-4.18.631-.964 1.434-1.848 2.216-2.694-.184.299-1.808 3.001-.032 4.274.351.255.85.38 1.465.38.494 0 1.06-.08 1.682-.242L45 34z",
    clipRule: "evenodd"
  }))
};
var ProfileSwoosh$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$72,
    fill: "none"
  }));
});
var compPaths$71 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 2.75A4.75 4.75 0 007.25 7.5h2A2.75 2.75 0 0112 4.75v-2zM7.25 7.5A4.75 4.75 0 0012 12.25v-2A2.75 2.75 0 019.25 7.5h-2zM12 12.25a4.75 4.75 0 004.75-4.75h-2A2.75 2.75 0 0112 10.25v2zm4.75-4.75A4.75 4.75 0 0012 2.75v2a2.75 2.75 0 012.75 2.75h2zM4.75 21v-3h-2v3h2zm0-3a2.75 2.75 0 012.75-2.75v-2A4.75 4.75 0 002.75 18h2zm2.75-2.75H17v-2H7.5v2z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.5 17l-8.41 3.568c-.7.297-1.29.445-1.764.445-.534 0-.923-.189-1.162-.565-.31-.485-.175-1.266.357-2.09.316-.482.717-.924 1.108-1.347-.092.15-.904 1.5-.016 2.137.176.128.425.19.733.19.246 0 .53-.04.84-.121L22.5 17z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 2.75A4.75 4.75 0 007.25 7.5h2A2.75 2.75 0 0112 4.75v-2zM7.25 7.5A4.75 4.75 0 0012 12.25v-2A2.75 2.75 0 019.25 7.5h-2zM12 12.25a4.75 4.75 0 004.75-4.75h-2A2.75 2.75 0 0112 10.25v2zm4.75-4.75A4.75 4.75 0 0012 2.75v2a2.75 2.75 0 012.75 2.75h2zM4.75 21v-3h-2v3h2zm0-3a2.75 2.75 0 012.75-2.75v-2A4.75 4.75 0 002.75 18h2zm2.75-2.75H17v-2H7.5v2z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.5 17l-8.41 3.568c-.7.297-1.29.445-1.764.445-.534 0-.923-.189-1.162-.565-.31-.485-.175-1.266.357-2.09.316-.482.717-.924 1.108-1.347-.092.15-.904 1.5-.016 2.137.176.128.425.19.733.19.246 0 .53-.04.84-.121L22.5 17z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M24 6a9 9 0 00-9 9h3a6 6 0 016-6V6zm-9 9a9 9 0 009 9v-3a6 6 0 01-6-6h-3zm9 9a9 9 0 009-9h-3a6 6 0 01-6 6v3zm9-9a9 9 0 00-9-9v3a6 6 0 016 6h3zM9 42v-6H6v6h3zm0-6a6 6 0 016-6v-3a9 9 0 00-9 9h3zm6-6h19v-3H15v3z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M45 34l-16.82 7.135c-1.4.594-2.579.89-3.528.89-1.068 0-1.846-.376-2.324-1.129-.62-.97-.35-2.532.714-4.18.631-.964 1.434-1.848 2.216-2.694-.184.299-1.808 3.001-.032 4.274.351.255.85.38 1.465.38.494 0 1.06-.08 1.682-.242L45 34z",
    clipRule: "evenodd"
  }))
};
var ProfileSwooshStroke$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$71,
    fill: "none"
  }));
});
var compPaths$70 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.75 10.75h5v-5h-5v5zm0 7.5h5v-5h-5v5zm7.5-7.5h5v-5h-5v5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.5 13.25H16m1 0h2m-6.5 2.5H14m5 2.5h-3.25v-2.5H19"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.5 10.5h6v-6h-6v6zm0 9h6v-6h-6v6zm9-9h6v-6h-6v6z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.75 13.5h4.5m1.5 0h1.5m-7.5 3h1.5m6 3H16.5v-3h3.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M9 21h12V9H9v12zm0 18h12V27H9v12zm18-18h12V9H27v12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M25.5 27h9m3 0h3m-15 6h3m-3 6h3m12 0H33v-6h7.5"
  }))
};
var QRCode$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$70,
    fill: "none"
  }));
});
var compPaths$6$ = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 17v-1.5M9.75 10a2.25 2.25 0 113.217 2.032c-.585.278-.967.87-.967 1.523V14"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M11.99 18v-1.5M9 9.75a3 3 0 114.29 2.71c-.78.37-1.29 1.16-1.29 2.03V15"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M23.98 36v-3M18 19.5c0-3.66 3.3-6.58 7.08-5.9 2.42.42 4.4 2.4 4.82 4.82.5 2.84-1 5.4-3.32 6.5A4.51 4.51 0 0024 28.98V30"
  }))
};
var Question$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6$,
    fill: "none"
  }));
});
var compPaths$6_ = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 17v-1.5M9.75 10c0-1.37 1.24-2.47 2.65-2.21.91.16 1.65.9 1.81 1.81.19 1.07-.38 2.03-1.24 2.44-.59.27-.97.86-.97 1.51V14"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 19.25c4 0 7.25-3.25 7.25-7.25S16 4.75 12 4.75 4.75 8 4.75 12 8 19.25 12 19.25z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 21.75c5.385 0 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25 2.25 6.615 2.25 12s4.365 9.75 9.75 9.75zM11.99 18v-1.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9 9.75a3 3 0 114.29 2.71c-.78.37-1.29 1.16-1.29 2.03V15"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 43.5c10.77 0 19.5-8.73 19.5-19.5S34.77 4.5 24 4.5 4.5 13.23 4.5 24 13.23 43.5 24 43.5zm-.02-7.5v-3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M18 19.5c0-3.66 3.3-6.58 7.08-5.9 2.42.42 4.4 2.4 4.82 4.82.5 2.84-1 5.4-3.32 6.5A4.51 4.51 0 0024 28.98V30"
  }))
};
var QuestionCircle$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6_,
    fill: "none"
  }));
});
var compPaths$6Z = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm.75 13h-1.5v-1.5h1.5V17zm.54-4.29c-.33.16-.54.49-.54.84V14h-1.5v-.45c0-.93.55-1.8 1.4-2.2.51-.24.97-.84.83-1.63-.1-.59-.61-1.1-1.2-1.2A1.498 1.498 0 0010.5 10H9c0-.89.39-1.73 1.08-2.3a2.993 2.993 0 014.87 1.77c.24 1.33-.45 2.66-1.66 3.24z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 1.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5zm.74 16.5h-1.5v-1.5h1.5V18zm.87-4.86c-.52.25-.86.78-.86 1.35V15h-1.5v-.51c0-1.15.67-2.21 1.72-2.71.92-.44 1.42-1.42 1.24-2.44-.16-.9-.9-1.64-1.8-1.8-.68-.12-1.33.05-1.85.48s-.81 1.06-.81 1.73h-1.5c0-1.11.49-2.16 1.35-2.88.85-.71 1.97-1.01 3.07-.81 1.51.26 2.75 1.5 3.02 3.02.3 1.7-.54 3.33-2.08 4.06z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M24 3C12.42 3 3 12.42 3 24s9.42 21 21 21 21-9.42 21-21S35.58 3 24 3zm1.48 33h-3v-3h3v3zm1.74-9.72c-1.04.5-1.72 1.56-1.72 2.7V30h-3v-1.02c0-2.3 1.34-4.42 3.44-5.42 1.84-.88 2.84-2.84 2.48-4.88-.32-1.8-1.8-3.28-3.6-3.6-1.36-.24-2.66.1-3.7.96a4.462 4.462 0 00-1.62 3.46h-3c0-2.22.98-4.32 2.7-5.76a7.476 7.476 0 016.14-1.62c3.02.52 5.5 3 6.04 6.04.6 3.4-1.08 6.66-4.16 8.12z"
  }))
};
var QuestionCircleFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6Z,
    fill: "none"
  }));
});
var compPaths$6Y = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.223 10.726l3.675 2.695-1.403 4.363c-.162.502.408.92.83.61L12 15.697l3.675 2.697c.422.31.992-.108.83-.61l-1.403-4.363 3.675-2.695c.422-.31.205-.987-.318-.987h-4.542l-1.404-4.362a.538.538 0 00-1.026 0l-1.404 4.362H5.54c-.523 0-.74.676-.318.986z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.56 10.346l5.12 3.694-1.955 5.978c-.225.688.568 1.261 1.157.836L12 17.159l5.12 3.695c.587.425 1.381-.148 1.155-.836l-1.954-5.978 5.118-3.694c.589-.425.286-1.352-.442-1.352H14.67l-.166-.507-1.789-5.47c-.225-.69-1.205-.69-1.43 0L9.33 8.993H3.003c-.728 0-1.03.927-.442 1.352z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M5.122 20.692l10.236 7.389-3.909 11.955c-.449 1.377 1.137 2.523 2.315 1.672L24 34.318l10.238 7.39c1.175.85 2.764-.295 2.313-1.672l-3.91-11.955 10.237-7.389c1.177-.85.572-2.704-.884-2.704H29.34L25.43 6.033c-.45-1.377-2.41-1.377-2.86 0l-3.91 11.955H6.005c-1.456 0-2.061 1.853-.884 2.704z",
    clipRule: "evenodd"
  }))
};
var Rating$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6Y,
    fill: "none"
  }));
});
var compPaths$6X = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.223 10.726l3.675 2.695-1.403 4.363c-.162.502.408.92.83.61L12 15.697l3.675 2.697c.422.31.992-.108.83-.61l-1.403-4.363 3.675-2.695c.422-.31.205-.987-.318-.987h-4.542l-1.404-4.362a.538.538 0 00-1.026 0l-1.404 4.362H5.54c-.523 0-.74.676-.318.986z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.56 10.346l5.12 3.694-1.955 5.978c-.225.688.568 1.261 1.157.836L12 17.159l5.12 3.695c.587.425 1.381-.148 1.155-.836l-1.954-5.978 5.118-3.694c.589-.425.286-1.352-.442-1.352H14.67l-.166-.507-1.789-5.47c-.225-.69-1.205-.69-1.43 0L9.33 8.993H3.003c-.728 0-1.03.927-.442 1.352z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M5.122 20.692l10.236 7.389-3.909 11.955c-.449 1.377 1.137 2.523 2.315 1.672L24 34.318l10.238 7.39c1.175.85 2.764-.295 2.313-1.672l-3.91-11.955 10.237-7.389c1.177-.85.572-2.704-.884-2.704H29.34l-.333-1.014L25.43 6.033c-.45-1.377-2.41-1.377-2.86 0l-3.91 11.955H6.005c-1.456 0-2.061 1.853-.884 2.704z",
    clipRule: "evenodd"
  }))
};
var RatingFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6X,
    fill: "none"
  }));
});
var compPaths$6W = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M5.223 10.726l3.675 2.695-1.403 4.363c-.162.502.408.92.83.61L12 15.697l3.675 2.697c.422.31.992-.108.83-.61l-1.403-4.363 3.675-2.695c.422-.31.205-.987-.318-.987h-4.542l-1.404-4.362a.538.538 0 00-1.026 0l-1.404 4.362H5.54c-.523 0-.74.676-.318.986z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M2.56 10.346l5.12 3.694-1.955 5.978c-.225.688.568 1.261 1.157.836L12 17.159l5.12 3.695c.587.425 1.381-.148 1.155-.836l-1.954-5.978 5.118-3.694c.589-.425.286-1.352-.442-1.352H14.67l-1.955-5.978c-.225-.688-1.205-.688-1.43 0L9.33 8.994H3.003c-.728 0-1.03.927-.442 1.352z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M5.122 20.692l10.236 7.389-3.909 11.955c-.449 1.377 1.137 2.523 2.315 1.672L24 34.318l10.238 7.39c1.175.85 2.764-.295 2.313-1.672l-3.91-11.955 10.237-7.389c1.177-.85.572-2.704-.884-2.704H29.34l-.333-1.014L25.43 6.033c-.45-1.377-2.41-1.377-2.86 0l-3.91 11.955H6.005c-1.456 0-2.061 1.853-.884 2.704z",
    clipRule: "evenodd"
  }))
};
var RatingStroke$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6W,
    fill: "none"
  }));
});
var compPaths$6V = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M10.5 6.75H18m-7.5 3H18m-7.5 3h6M6 20.25h12c1.24 0 2.25-1.01 2.25-2.25V3.75h-12V18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8.25 18c0 1.24-1.01 2.25-2.25 2.25S3.75 19.24 3.75 18v-5.25H6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M10.5 6.75H18m-7.5 3H18m-7.5 3h6M6 20.25h12c1.24 0 2.25-1.01 2.25-2.25V3.75h-12V18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8.25 18c0 1.24-1.01 2.25-2.25 2.25S3.75 19.24 3.75 18v-5.25H6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M21 13.5h15m-15 6h15m-15 6h12m-21 15h24c2.48 0 4.5-2.02 4.5-4.5V7.5h-24V36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M16.5 36c0 2.48-2.02 4.5-4.5 4.5S7.5 38.48 7.5 36V25.5H12"
  }))
};
var Receipt$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6V,
    fill: "none"
  }));
});
var compPaths$6U = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.354 22.476L2.994 5.116l1.014-1.014 17.36 17.36-1.014 1.014z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21 3H7.5v2.48L9 6.98V4.5h10.5v12.98l1.376 1.375c.08-.27.124-.558.124-.855V3zm-.93 17.17l-1.062-1.061c-.267.243-.62.391-1.008.391H8.597c.256-.442.403-.954.403-1.5V9.1L7.5 7.6V18c0 .826-.674 1.5-1.5 1.5s-1.5-.674-1.5-1.5v-4.5H6V12H3v6c0 1.654 1.346 3 3 3h12a2.99 2.99 0 002.07-.83zM11.9 12h-1.4v.5l1 1h1.9L11.9 12zm3.62 1.5h.98V12h-2.48l1.5 1.5zm-3-3H18V9h-6.98l1.5 1.5zm-2.02-3H18V6h-7.5v1.5z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.354 22.476L2.994 5.116l1.014-1.014 17.36 17.36-1.014 1.014z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21 3H7.5v2.48L9 6.98V4.5h10.5v12.98l1.376 1.375c.08-.27.124-.558.124-.855V3zm-.93 17.17l-1.062-1.061c-.267.243-.62.391-1.008.391H8.597c.256-.442.403-.954.403-1.5V9.1L7.5 7.6V18c0 .826-.674 1.5-1.5 1.5s-1.5-.674-1.5-1.5v-4.5H6V12H3v6c0 1.654 1.346 3 3 3h12a2.99 2.99 0 002.07-.83zM11.9 12h-1.4v.5l1 1h1.9L11.9 12zm3.62 1.5h.98V12h-2.48l1.5 1.5zm-3-3H18V9h-6.98l1.5 1.5zm-2.02-3H18V6h-7.5v1.5z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M40.71 44.953L5.988 10.232l2.028-2.028 34.72 34.72-2.028 2.029z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M42 6H15v4.959l3 3V9h21v25.959l2.752 2.752A5.985 5.985 0 0042 36V6zm-1.861 34.34l-2.123-2.122A2.988 2.988 0 0136 39H17.195A5.964 5.964 0 0018 36V18.201l-3-3V36c0 1.652-1.348 3-3 3s-3-1.348-3-3v-9h3v-3H6v12c0 3.308 2.692 6 6 6h24a5.98 5.98 0 004.139-1.66zM23.799 24H21v1l2 2h3.799l-3-3zm7.242 3H33v-3h-4.959l3 3zm-6-6H36v-3H22.041l3 3zM21 15h15v-3H21v3z",
    clipRule: "evenodd"
  }))
};
var ReceiptNone$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6U,
    fill: "none"
  }));
});
var compPaths$6T = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M4.27 6.02v3.73H8m10.98 4.23A7.256 7.256 0 0112 19.25c-4.01 0-7.25-3.24-7.25-7.25M12 4.75c4.01 0 7.25 3.24 7.25 7.25M5.15 9.8a7.238 7.238 0 016.91-5.05"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M19.73 17.98v-3.73H16"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M3.25 5.5v4.25H7.5m12.44 4.5c-.98 3.46-4.16 6-7.94 6-4.56 0-8.25-3.69-8.25-8.25M12 3.75c4.56 0 8.25 3.69 8.25 8.25M4.14 9.5A8.25 8.25 0 0112 3.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20.75 18.5v-4.25H16.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M6.5 11v8.5H15m24.88 9c-1.96 6.92-8.32 12-15.88 12-9.12 0-16.5-7.38-16.5-16.5M24 7.5c9.12 0 16.5 7.38 16.5 16.5M8.28 19C10.38 12.34 16.64 7.5 24 7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M41.5 37v-8.5H33"
  }))
};
var Repeat$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6T,
    fill: "none"
  }));
});
var compPaths$6S = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M4.25 6.02v3.73h3.73"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 4.75c4.01 0 7.25 3.24 7.25 7.25s-3.24 7.25-7.25 7.25S4.75 16.01 4.75 12m.34-2.2C6.02 6.88 8.77 4.75 12 4.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.5 19.86A8.25 8.25 0 0020.25 12m-17-6.5v4.25H7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 3.75c4.56 0 8.25 3.69 8.25 8.25 0 4.56-3.69 8.25-8.25 8.25-4.56 0-8.25-3.69-8.25-8.25m.39-2.5A8.25 8.25 0 0112 3.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M6.5 11v8.5H15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 7.5c9.12 0 16.5 7.38 16.5 16.5 0 9.12-7.38 16.5-16.5 16.5-9.12 0-16.5-7.38-16.5-16.5m.78-5C10.38 12.34 16.64 7.5 24 7.5"
  }))
};
var Replay$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6S,
    fill: "none"
  }));
});
var compPaths$6R = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 21.75h-9c-1.242 0-2.25-1.191-2.25-2.66V4.91c0-1.469 1.008-2.66 2.25-2.66h6.75l4.5 4.5v12.34c0 1.469-1.008 2.66-2.25 2.66z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18.75 6.75H15.5a1.5 1.5 0 01-1.5-1.5V2m2.25 10.5l-3 3-1.5-1.5L8 17.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 21.75h-9c-1.242 0-2.25-1.191-2.25-2.66V4.91c0-1.469 1.008-2.66 2.25-2.66h6.75l4.5 4.5v12.34c0 1.469-1.008 2.66-2.25 2.66z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18.75 6.75H15.5a1.5 1.5 0 01-1.5-1.5V2m2.25 10.5l-3 3-1.5-1.5L8 17.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33 43.5H15c-2.484 0-4.5-2.383-4.5-5.318V9.818C10.5 6.883 12.516 4.5 15 4.5h13.5l9 9v24.682c0 2.935-2.016 5.318-4.5 5.318z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M37.5 13.5H31a3 3 0 01-3-3V4m4.5 21l-6 6-3-3-7.5 7.5"
  }))
};
var Report$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6R,
    fill: "none"
  }));
});
var compPaths$6Q = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M10.26 21.35l-2.19-2.1 2.19-2.15M12 4.75v8.75m6.93-3.75H4.83"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M4.75 20V9.75l1.34-5h11.82l1.34 5V17c0 1.24-1.01 2.25-2.25 2.25H8.08"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M3.75 21V9.75l1.61-6h13.28l1.61 6V18c0 1.24-1.01 2.25-2.25 2.25m0 0H8m12.25-10.5H3.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.71 22.9l-2.65-2.65 2.65-2.65M12 3.75v9.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M7.5 42V19.5l3.22-12h26.56l3.22 12V36c0 2.48-2.02 4.5-4.5 4.5m0 0H16m24.5-21h-33"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M19.42 45.8l-5.3-5.3 5.3-5.3M24 7.5V27"
  }))
};
var Return$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6Q,
    fill: "none"
  }));
});
var compPaths$6P = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.5 9.5l5 5m0-5l-5 5m-3.75-5L6.25 14 4.5 12.25"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18.75H.75V5.25H12m0 0h11.25v13.5H12"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.5 9.5l5 5m0-5l-5 5m-3.75-5L6.25 14 4.5 12.25"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18.75H.75V5.25H12m0 0h11.25v13.5H12"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M29 19l10 10m0-10L29 29m-7.5-10l-9 9L9 24.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 37.5H1.5v-27H24m0 0h22.5v27H24"
  }))
};
var Review$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6P,
    fill: "none"
  }));
});
var compPaths$6O = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18.75 14.8l2.8-2.8-2.8-2.8V5.25H14.8L12 2.45l-2.8 2.8H5.25V9.2L2.45 12l2.8 2.8v3.95H9.2l2.8 2.8 2.8-2.8h3.95V14.8z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15.45 9.35l-4.77 4.77-2.65-2.65"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18.75 14.8l2.8-2.8-2.8-2.8V5.25H14.8L12 2.45l-2.8 2.8H5.25V9.2L2.45 12l2.8 2.8v3.95H9.2l2.8 2.8 2.8-2.8h3.95V14.8z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15.45 9.35l-4.77 4.77-2.65-2.65"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M37.5 29.6l5.6-5.6-5.6-5.6v-7.9h-7.9L24 4.9l-5.6 5.6h-7.9v7.9L4.9 24l5.6 5.6v7.9h7.9l5.6 5.6 5.6-5.6h7.9v-7.9z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M30.9 18.7l-9.54 9.54-5.3-5.3"
  }))
};
var Rewards$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6O,
    fill: "none"
  }));
});
var compPaths$6N = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8.29 15.71a5.245 5.245 0 010-7.42m7.42 0a5.245 5.245 0 010 7.42m-9.54 2.12c-3.22-3.22-3.22-8.45 0-11.67m11.66.01c3.22 3.22 3.22 8.45 0 11.67M12 14.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8.29 15.71a5.245 5.245 0 010-7.42m7.42 0a5.245 5.245 0 010 7.42m-9.54 2.12c-3.22-3.22-3.22-8.45 0-11.67m11.66.01c3.22 3.22 3.22 8.45 0 11.67M12 14.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M16.58 31.42a10.49 10.49 0 010-14.84m14.84 0c4.1 4.1 4.1 10.74 0 14.84m-19.08 4.24c-6.44-6.44-6.44-16.9 0-23.34m23.32.02c6.44 6.44 6.44 16.9 0 23.34M24 28.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9z"
  }))
};
var Rfid$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6N,
    fill: "none"
  }));
});
var compPaths$6M = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M2.25 18v1.75a2 2 0 002 2H6m12 0h1.75a2 2 0 002-2V18m0-12V4.25a2 2 0 00-2-2H18m-12 0H4.25a2 2 0 00-2 2V6m11.5 0v12m-7-12v12m10.5-12v12m-7-12v12"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M2.25 18v1.75a2 2 0 002 2H6m12 0h1.75a2 2 0 002-2V18m0-12V4.25a2 2 0 00-2-2H18m-12 0H4.25a2 2 0 00-2 2V6m11.5 0v12m-7-12v12m10.5-12v12m-7-12v12"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M4.5 36v3.5a4 4 0 004 4H12m24 0h3.5a4 4 0 004-4V36m0-24V8.5a4 4 0 00-4-4H36m-24 0H8.5a4 4 0 00-4 4V12m23 0v24m-14-24v24m21-24v24m-14-24v24"
  }))
};
var Scan$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6M,
    fill: "none"
  }));
});
var compPaths$6L = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.962 16.296a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 013.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0110.5 3.75c1.864 0 3.551.755 4.773 1.977A6.728 6.728 0 0117.25 10.5a6.726 6.726 0 01-.921 3.407c-.517.882-.434 1.988.289 2.711l3.853 3.853"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.962 16.296a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 013.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0110.5 3.75c1.864 0 3.551.755 4.773 1.977A6.728 6.728 0 0117.25 10.5a6.726 6.726 0 01-.921 3.407c-.517.882-.434 1.988.289 2.711l3.853 3.853"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M27.924 32.592A13.432 13.432 0 0121 34.5c-3.728 0-7.102-1.51-9.546-3.954A13.455 13.455 0 017.5 21c0-3.728 1.51-7.102 3.954-9.546A13.455 13.455 0 0121 7.5c3.728 0 7.102 1.51 9.546 3.954A13.455 13.455 0 0134.5 21c0 2.486-.672 4.814-1.842 6.814-1.034 1.764-.868 3.976.578 5.422l7.706 7.706"
  }))
};
var Search$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6L,
    fill: "none"
  }));
});
var compPaths$6K = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.248 10.125a3.75 3.75 0 11-6.495 3.75 3.75 3.75 0 016.495-3.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.729 5.857h3.1l1.406 2.434-1.55 2.685a2.25 2.25 0 000 2.25l1.433 2.482-1.406 2.434h-2.866a2.25 2.25 0 00-1.95 1.125l-1.432 2.483h-2.81L9.22 19.267a2.25 2.25 0 00-1.95-1.125h-3.1L2.766 15.71l1.55-2.687a2.25 2.25 0 000-2.25L2.883 8.291l1.406-2.434h2.866a2.25 2.25 0 001.949-1.125l1.433-2.482h2.81l1.433 2.482a2.25 2.25 0 001.949 1.125z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.248 10.125a3.75 3.75 0 11-6.495 3.75 3.75 3.75 0 016.495-3.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.729 5.857h3.1l1.406 2.434-1.55 2.685a2.25 2.25 0 000 2.25l1.433 2.482-1.406 2.434h-2.866a2.25 2.25 0 00-1.95 1.125l-1.432 2.483h-2.81L9.22 19.267a2.25 2.25 0 00-1.95-1.125h-3.1L2.766 15.71l1.55-2.687a2.25 2.25 0 000-2.25L2.883 8.291l1.406-2.434h2.866a2.25 2.25 0 001.949-1.125l1.433-2.482h2.81l1.433 2.482a2.25 2.25 0 001.949 1.125z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M30.495 20.25a7.5 7.5 0 11-12.99 7.5 7.5 7.5 0 0112.99-7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33.457 11.715h6.202l2.81 4.868-3.1 5.37a4.5 4.5 0 000 4.5l2.866 4.964-2.812 4.868H33.69a4.502 4.502 0 00-3.898 2.25L26.927 43.5h-5.62l-2.866-4.966a4.502 4.502 0 00-3.898-2.25H8.34l-2.81-4.866 3.1-5.372a4.5 4.5 0 000-4.5l-2.866-4.964 2.812-4.868h5.732a4.502 4.502 0 003.898-2.25L21.073 4.5h5.62l2.866 4.964a4.502 4.502 0 003.898 2.25z",
    clipRule: "evenodd"
  }))
};
var Settings$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6K,
    fill: "none"
  }));
});
var compPaths$6J = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M20.33 11.35l1.77-3.06-1.84-3.18h-3.53c-.53 0-1.03-.29-1.3-.75L13.78 1.5H10.1L8.45 4.36c-.27.46-.76.75-1.3.75h-3.3L2.02 8.29l1.65 2.86c.27.46.27 1.04 0 1.5L1.9 15.71l1.84 3.18h3.53c.53 0 1.03.29 1.3.75l1.65 2.86h3.68l1.65-2.86c.27-.46.76-.75 1.3-.75h3.3l1.84-3.18-1.65-2.86c-.27-.46-.27-1.04-.01-1.5zM13.5 14.6c-1.43.83-3.27.33-4.1-1.1-.83-1.43-.33-3.27 1.1-4.1.46-.27.97-.4 1.49-.4.26 0 .52.04.78.1.77.21 1.42.7 1.82 1.4.84 1.43.34 3.27-1.09 4.1z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M20.33 11.35l1.77-3.06-1.84-3.18h-3.53c-.53 0-1.03-.29-1.3-.75L13.78 1.5H10.1L8.45 4.36c-.27.46-.76.75-1.3.75h-3.3L2.02 8.29l1.65 2.86c.27.46.27 1.04 0 1.5L1.9 15.71l1.84 3.18h3.53c.53 0 1.03.29 1.3.75l1.65 2.86h3.68l1.65-2.86c.27-.46.76-.75 1.3-.75h3.3l1.84-3.18-1.65-2.86c-.27-.46-.27-1.04-.01-1.5zM13.5 14.6c-1.43.83-3.27.33-4.1-1.1-.83-1.43-.33-3.27 1.1-4.1.46-.27.97-.4 1.49-.4.26 0 .52.04.78.1.77.21 1.42.7 1.82 1.4.84 1.43.34 3.27-1.09 4.1z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M40.66 22.7l3.54-6.12-3.68-6.36h-7.06a3.04 3.04 0 01-2.6-1.5L27.56 3H20.2l-3.3 5.72c-.54.92-1.52 1.5-2.6 1.5H7.7l-3.66 6.36 3.3 5.72c.54.92.54 2.08 0 3L3.8 31.42l3.68 6.36h7.06c1.06 0 2.06.58 2.6 1.5l3.3 5.72h7.36l3.3-5.72c.54-.92 1.52-1.5 2.6-1.5h6.6l3.68-6.36-3.3-5.72a3.03 3.03 0 01-.02-3zM27 29.2c-2.86 1.66-6.54.66-8.2-2.2-1.66-2.86-.66-6.54 2.2-8.2.92-.54 1.94-.8 2.98-.8.52 0 1.04.08 1.56.2 1.54.42 2.84 1.4 3.64 2.8 1.68 2.86.68 6.54-2.18 8.2z"
  }))
};
var SettingsFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6J,
    fill: "none"
  }));
});
var compPaths$6I = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.813 12v4.5c0 .932.756 1.688 1.687 1.688h9c.931 0 1.688-.756 1.688-1.688V12M12 15.934v-9.55m3.58 3.241L12 6.045l-3.58 3.58"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 13v6A2.25 2.25 0 006 21.25h12A2.25 2.25 0 0020.25 19v-6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.552",
    d: "M12 19V4"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.773 8.834l-4.772-4.773-4.774 4.773"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 26v12a4.5 4.5 0 004.5 4.5h24a4.5 4.5 0 004.5-4.5V26"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3.103",
    d: "M24 38V8"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33.547 17.668l-9.546-9.546-9.548 9.546"
  }))
};
var Share$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6I,
    fill: "none"
  }));
});
var compPaths$6H = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.25 7a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm0 10a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-10-5a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.755 7.15l-6.147 3.276c.351.359.583.834.632 1.363l6.112-3.257a2.242 2.242 0 01-.597-1.382zM9.24 12.21a2.243 2.243 0 01-.632 1.364l6.147 3.275a2.242 2.242 0 01.597-1.381L9.24 12.211z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.25 6a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm0 12a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-12-6a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.013 13.006L16 17m-.013-9.994l-7.975 3.987"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M40.5 12a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm0 24a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-24-12a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.025 26.013L32 34m-.025-19.987l-15.95 7.974"
  }))
};
var Shareaos$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6H,
    fill: "none"
  }));
});
var compPaths$6G = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 16.5a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm12 .033a2.25 2.25 0 11-4.502-.001 2.25 2.25 0 014.502.001z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 16.565H8.5M.75 11.5V14A2.25 2.25 0 003 16.25h.25m16.25-6.5H3A2.25 2.25 0 01.75 7.5V5.25h17.189c.2 0 .39.079.531.22l4.56 4.56a.75.75 0 01.22.531v3.689A2.25 2.25 0 0121 16.5h-.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 16.5a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm12 .033a2.25 2.25 0 11-4.502-.001 2.25 2.25 0 014.502.001z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 16.565H8.5M.75 11.5V14A2.25 2.25 0 003 16.25h.25m16.25-6.5H3A2.25 2.25 0 01.75 7.5V5.25h17.189c.2 0 .39.079.531.22l4.56 4.56a.75.75 0 01.22.531v3.689A2.25 2.25 0 0121 16.5h-.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.5 33a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm24 .066c0 2.484-2.016 4.5-4.5 4.5a4.5 4.5 0 114.5-4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.5 33.13H17M1.5 23v5A4.5 4.5 0 006 32.5h.5m32.5-13H6A4.5 4.5 0 011.5 15v-4.5h34.378c.4 0 .78.158 1.062.44l9.12 9.12c.282.282.44.662.44 1.062V28.5c0 2.484-2.016 4.5-4.5 4.5h-1.5"
  }))
};
var Shipping$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6G,
    fill: "none"
  }));
});
var compPaths$6F = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.366 6.5l1.51 2.636a2.819 2.819 0 01-1.02 3.835l-7.865 4.574a5.203 5.203 0 01-2.614.705H5.859c-1.11 0-1.53-1.462-.59-2.057a4.284 4.284 0 001.422-1.488l4.093-7.143c2.482.67 5.032-.813 5.698-3.312"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.259 12.835c-.57-.063-.604-.828-.597-1.065-.071.328-.142.655-.159.977-.026.505.104.967.414 1.132.56.298 1.132-.32 1.467-.763L15.5 9l-3.45 3.425c-.29.286-.57.432-.791.41z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.872 13.976c-.789-.087-.836-1.146-.826-1.475-.099.454-.197.908-.22 1.354-.037.699.143 1.339.573 1.567.775.413 1.567-.442 2.032-1.056l4.315-5.701-4.777 4.744c-.402.396-.79.598-1.097.567z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.222 4.556l2.032 3.52a3.75 3.75 0 01-1.372 5.123L9.3 19.308a7.039 7.039 0 01-3.517.942H3.742c-1.494 0-2.057-1.952-.793-2.747a5.74 5.74 0 001.913-1.987l5.506-9.54a6.258 6.258 0 007.665-4.424"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.744 27.951c-1.578-.174-1.672-2.292-1.652-2.95-.198.908-.394 1.816-.44 2.708-.074 1.398.286 2.678 1.146 3.134 1.55.826 3.134-.884 4.064-2.112l8.63-11.402-9.554 9.488c-.804.792-1.582 1.196-2.194 1.134z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M38.443 9.112l4.064 7.042a7.499 7.499 0 01-2.744 10.244L18.601 38.614a14.077 14.077 0 01-7.034 1.884H7.483c-2.988 0-4.114-3.904-1.586-5.494a11.48 11.48 0 003.826-3.974l11.012-19.08c6.678 1.79 13.54-2.171 15.33-8.847"
  }))
};
var Shoe$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6F,
    fill: "none"
  }));
});
var compPaths$6E = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.366 6.5l1.51 2.636a2.819 2.819 0 01-1.02 3.835l-7.865 4.574a5.203 5.203 0 01-2.614.705H5.859c-1.11 0-1.53-1.462-.59-2.057a4.284 4.284 0 001.422-1.488l4.093-7.143c2.482.67 5.032-.813 5.698-3.312"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.259 12.835c-.57-.063-.604-.828-.597-1.065-.071.328-.142.655-.159.977-.026.505.104.967.414 1.132.56.298 1.132-.32 1.467-.763L15.5 9l-3.45 3.425c-.29.286-.57.432-.791.41z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.43 14.366c-.464.614-1.256 1.469-2.03 1.056-.431-.228-.611-.868-.573-1.567.022-.447.12-.901.219-1.355-.01.33.037 1.389.827 1.476.305.03.695-.172 1.096-.568l4.777-4.743-4.315 5.7zM21.905 7.7L19.87 4.18l-1.217-2.11c.034-.11.074-.214.103-.325l-1.45-.39a5.514 5.514 0 01-6.744 3.896l-.557-.15L4.211 15.14a4.999 4.999 0 01-1.663 1.727 2.222 2.222 0 00-.96 2.514A2.221 2.221 0 003.743 21h2.042a7.8 7.8 0 003.892-1.043l10.58-6.11a4.473 4.473 0 002.098-2.731 4.476 4.476 0 00-.45-3.415z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.861 28.731c-.93 1.228-2.514 2.938-4.062 2.112-.862-.456-1.222-1.736-1.146-3.134.044-.894.242-1.802.438-2.71-.02.66.074 2.778 1.654 2.952.61.062 1.39-.344 2.192-1.136l9.554-9.486-8.63 11.402zm20.946-13.33l-4.066-7.04-2.434-4.22c.068-.218.148-.428.206-.65l-2.898-.778c-1.57 5.868-7.626 9.36-13.49 7.79l-1.114-.298L8.423 30.281a9.998 9.998 0 01-3.326 3.454 4.443 4.443 0 00-1.918 5.028A4.442 4.442 0 007.483 42h4.084c2.728 0 5.42-.722 7.784-2.086l21.162-12.218a8.947 8.947 0 004.194-5.464 8.953 8.953 0 00-.9-6.83z",
    clipRule: "evenodd"
  }))
};
var ShoeFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6E,
    fill: "none"
  }));
});
var compPaths$6D = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.366 6.5l1.51 2.636a2.819 2.819 0 01-1.02 3.835l-7.865 4.574a5.203 5.203 0 01-2.614.705H5.859c-1.11 0-1.53-1.462-.59-2.057a4.284 4.284 0 001.422-1.488l4.093-7.143c2.482.67 5.032-.813 5.698-3.312"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.259 12.835c-.57-.063-.604-.828-.597-1.065-.071.328-.142.655-.159.977-.026.505.104.967.414 1.132.56.298 1.132-.32 1.467-.763L15.5 9l-3.45 3.425c-.29.286-.57.432-.791.41z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.872 13.976c-.789-.087-.836-1.146-.826-1.475-.099.454-.197.908-.22 1.354-.037.699.143 1.339.573 1.567.775.413 1.567-.442 2.032-1.056l4.315-5.701-4.777 4.744c-.402.396-.79.598-1.097.567z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M19.222 4.556l2.032 3.52a3.75 3.75 0 01-1.372 5.123L9.3 19.308a7.039 7.039 0 01-3.517.942H3.742c-1.494 0-2.057-1.952-.793-2.747a5.74 5.74 0 001.913-1.987l5.506-9.54a6.258 6.258 0 007.665-4.424"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.744 27.951c-1.578-.174-1.672-2.292-1.652-2.95-.198.908-.394 1.816-.44 2.708-.074 1.398.286 2.678 1.146 3.134 1.55.826 3.134-.884 4.064-2.112l8.63-11.402-9.554 9.488c-.804.792-1.582 1.196-2.194 1.134z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M38.443 9.112l4.064 7.042a7.499 7.499 0 01-2.744 10.244L18.601 38.614a14.077 14.077 0 01-7.034 1.884H7.483c-2.988 0-4.114-3.904-1.586-5.494a11.48 11.48 0 003.826-3.974l11.012-19.08c6.678 1.79 13.54-2.171 15.33-8.847"
  }))
};
var ShoeStroke$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6D,
    fill: "none"
  }));
});
var compPaths$6C = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M0 8.25h4.5M0 12.75h4.5m12.462 3.546a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 016.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0113.5 3.75c1.864 0 3.551.755 4.773 1.977A6.728 6.728 0 0120.25 10.5a6.726 6.726 0 01-.921 3.407c-.517.882-.434 1.988.289 2.711l3.853 3.853"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M0 8.25h4.5M0 12.75h4.5m12.462 3.546a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 016.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0113.5 3.75c1.864 0 3.551.755 4.773 1.977A6.728 6.728 0 0120.25 10.5a6.726 6.726 0 01-.921 3.407c-.517.882-.434 1.988.289 2.711l3.853 3.853"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M0 16.5h9m-9 9h9m24.924 7.092A13.432 13.432 0 0127 34.5c-3.728 0-7.102-1.51-9.546-3.954A13.455 13.455 0 0113.5 21c0-3.728 1.51-7.102 3.954-9.546A13.455 13.455 0 0127 7.5c3.728 0 7.102 1.51 9.546 3.954A13.455 13.455 0 0140.5 21c0 2.486-.672 4.814-1.842 6.814-1.034 1.764-.868 3.976.578 5.422l7.706 7.706"
  }))
};
var ShopnikeApp$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6C,
    fill: "none"
  }));
});
var compPaths$6B = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 9h4.5V7.501H0V9zm0 4.5h4.5v-1.499H0V13.5zm20.148 2.587c-.463-.463-.532-1.187-.172-1.801.016-.028.027-.057.043-.085a7.51 7.51 0 00.398-.799l.008-.022c.112-.269.203-.545.284-.827.021-.075.039-.15.058-.227a7.69 7.69 0 00.137-.681c.012-.08.026-.157.036-.237.036-.298.06-.6.06-.907 0-.255-.013-.509-.038-.76-.006-.06-.019-.118-.026-.179a7.597 7.597 0 00-.087-.564c-.01-.048-.024-.093-.034-.14a7.637 7.637 0 00-.15-.582l-.032-.087a7.165 7.165 0 00-.221-.605c-.007-.018-.016-.034-.024-.05a7.16 7.16 0 00-.292-.606l-.031-.053a7.35 7.35 0 00-.343-.563c-.032-.05-.071-.095-.105-.142-.105-.147-.209-.294-.325-.435a7.502 7.502 0 00-1.028-1.027 7.103 7.103 0 00-.434-.325c-.048-.034-.093-.073-.142-.106a8.117 8.117 0 00-.563-.342c-.019-.01-.035-.022-.053-.032a7.17 7.17 0 00-.606-.29l-.05-.026a7.675 7.675 0 00-.605-.22c-.03-.01-.058-.023-.087-.032a7.886 7.886 0 00-.582-.15c-.047-.01-.093-.025-.14-.035a8.158 8.158 0 00-.564-.086c-.061-.007-.119-.02-.18-.026a7.618 7.618 0 00-1.516 0c-.061.006-.119.02-.179.026-.19.024-.379.05-.565.086-.047.01-.093.025-.14.035-.195.044-.39.091-.582.15-.029.01-.057.022-.086.031a7.393 7.393 0 00-.605.221l-.051.025a7.32 7.32 0 00-.606.291l-.052.032a7.907 7.907 0 00-.564.342c-.049.033-.094.072-.142.106a7.103 7.103 0 00-.434.325 7.502 7.502 0 00-1.028 1.027c-.116.141-.22.288-.325.435-.034.047-.072.092-.105.142a7.034 7.034 0 00-.342.563l-.032.053a7.16 7.16 0 00-.292.605c-.007.017-.017.033-.024.051-.084.198-.155.4-.221.605l-.032.087a7.631 7.631 0 00-.149.582c-.011.047-.025.092-.035.14a7.103 7.103 0 00-.086.564c-.008.061-.021.12-.027.18a7.654 7.654 0 000 1.516c.006.06.019.12.027.18.023.19.048.378.086.564.01.047.024.092.035.14.044.196.09.39.149.582.01.03.022.057.032.086.066.205.137.407.221.605.007.019.017.035.024.052.089.205.184.407.292.604l.032.053c.106.192.218.381.342.564.033.05.071.095.105.143.105.146.209.293.325.434.309.374.653.718 1.028 1.027.14.115.287.22.434.324.048.035.093.073.142.107.183.123.372.236.564.341.018.01.034.023.052.032.198.107.4.203.606.291l.051.026c.197.082.4.154.605.22.029.01.057.023.086.032.192.059.387.105.582.15.047.01.093.024.14.034.186.038.375.063.565.087.06.006.118.02.179.026.25.024.503.038.758.038.312 0 .617-.024.919-.061.082-.01.162-.026.243-.038.236-.037.467-.084.695-.142.074-.02.148-.035.221-.056.295-.085.584-.183.862-.302.016-.006.03-.015.045-.021a7.42 7.42 0 00.759-.389c.034-.018.07-.032.103-.052l-.004-.006a7.59 7.59 0 001.103-.805c.14.377.348.727.641 1.02l3.854 3.854 1.061-1.06-3.854-3.855z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 9h4.5V7.501H0V9zm0 4.5h4.5v-1.499H0V13.5zm20.148 2.587c-.463-.463-.532-1.187-.172-1.801.016-.028.027-.057.043-.085a7.51 7.51 0 00.398-.799l.008-.022c.112-.269.203-.545.284-.827.021-.075.039-.15.058-.227a7.69 7.69 0 00.137-.681c.012-.08.026-.157.036-.237.036-.298.06-.6.06-.907 0-.255-.013-.509-.038-.76-.006-.06-.019-.118-.026-.179a7.597 7.597 0 00-.087-.564c-.01-.048-.024-.093-.034-.14a7.637 7.637 0 00-.15-.582l-.032-.087a7.165 7.165 0 00-.221-.605c-.007-.018-.016-.034-.024-.05a7.16 7.16 0 00-.292-.606l-.031-.053a7.35 7.35 0 00-.343-.563c-.032-.05-.071-.095-.105-.142-.105-.147-.209-.294-.325-.435a7.502 7.502 0 00-1.028-1.027 7.103 7.103 0 00-.434-.325c-.048-.034-.093-.073-.142-.106a8.117 8.117 0 00-.563-.342c-.019-.01-.035-.022-.053-.032a7.17 7.17 0 00-.606-.29l-.05-.026a7.675 7.675 0 00-.605-.22c-.03-.01-.058-.023-.087-.032a7.886 7.886 0 00-.582-.15c-.047-.01-.093-.025-.14-.035a8.158 8.158 0 00-.564-.086c-.061-.007-.119-.02-.18-.026a7.618 7.618 0 00-1.516 0c-.061.006-.119.02-.179.026-.19.024-.379.05-.565.086-.047.01-.093.025-.14.035-.195.044-.39.091-.582.15-.029.01-.057.022-.086.031a7.393 7.393 0 00-.605.221l-.051.025a7.32 7.32 0 00-.606.291l-.052.032a7.907 7.907 0 00-.564.342c-.049.033-.094.072-.142.106a7.103 7.103 0 00-.434.325 7.502 7.502 0 00-1.028 1.027c-.116.141-.22.288-.325.435-.034.047-.072.092-.105.142a7.034 7.034 0 00-.342.563l-.032.053a7.16 7.16 0 00-.292.605c-.007.017-.017.033-.024.051-.084.198-.155.4-.221.605l-.032.087a7.631 7.631 0 00-.149.582c-.011.047-.025.092-.035.14a7.103 7.103 0 00-.086.564c-.008.061-.021.12-.027.18a7.654 7.654 0 000 1.516c.006.06.019.12.027.18.023.19.048.378.086.564.01.047.024.092.035.14.044.196.09.39.149.582.01.03.022.057.032.086.066.205.137.407.221.605.007.019.017.035.024.052.089.205.184.407.292.604l.032.053c.106.192.218.381.342.564.033.05.071.095.105.143.105.146.209.293.325.434.309.374.653.718 1.028 1.027.14.115.287.22.434.324.048.035.093.073.142.107.183.123.372.236.564.341.018.01.034.023.052.032.198.107.4.203.606.291l.051.026c.197.082.4.154.605.22.029.01.057.023.086.032.192.059.387.105.582.15.047.01.093.024.14.034.186.038.375.063.565.087.06.006.118.02.179.026.25.024.503.038.758.038.312 0 .617-.024.919-.061.082-.01.162-.026.243-.038.236-.037.467-.084.695-.142.074-.02.148-.035.221-.056.295-.085.584-.183.862-.302.016-.006.03-.015.045-.021a7.42 7.42 0 00.759-.389c.034-.018.07-.032.103-.052l-.004-.006a7.59 7.59 0 001.103-.805c.14.377.348.727.641 1.02l3.854 3.854 1.061-1.06-3.854-3.855z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 18h9v-2.998H0V18zm0 9h9v-2.998H0V27zm40.296 5.175c-.926-.926-1.064-2.374-.344-3.604.032-.056.054-.114.086-.17a15.02 15.02 0 00.796-1.596c.006-.016.01-.032.016-.046a15.03 15.03 0 00.568-1.652c.042-.15.078-.302.116-.454.112-.448.202-.902.274-1.364.024-.158.052-.314.072-.474.072-.596.12-1.2.12-1.814 0-.51-.026-1.016-.076-1.518-.012-.12-.038-.236-.052-.358a15.195 15.195 0 00-.174-1.128c-.02-.096-.048-.186-.068-.28a15.273 15.273 0 00-.3-1.164c-.02-.058-.044-.116-.064-.174a14.33 14.33 0 00-.442-1.21c-.014-.036-.032-.068-.048-.102a14.319 14.319 0 00-.584-1.21l-.062-.106a14.7 14.7 0 00-.686-1.126c-.064-.1-.142-.19-.21-.284-.21-.294-.418-.588-.65-.87a15.001 15.001 0 00-2.056-2.054c-.28-.232-.574-.442-.868-.65-.096-.068-.186-.146-.284-.212-.366-.246-.744-.47-1.126-.684-.038-.02-.07-.044-.106-.064-.394-.214-.8-.406-1.212-.582l-.1-.05a15.35 15.35 0 00-1.21-.442c-.06-.018-.116-.044-.174-.062a15.772 15.772 0 00-1.164-.3c-.094-.02-.186-.05-.28-.07-.372-.074-.75-.124-1.128-.172-.122-.014-.238-.04-.36-.052a15.236 15.236 0 00-3.032 0c-.122.012-.238.038-.358.052-.38.048-.758.098-1.13.172-.094.02-.186.05-.28.07-.39.088-.78.182-1.164.3-.058.018-.114.044-.172.062-.41.132-.816.276-1.21.442-.036.016-.068.034-.102.05a14.64 14.64 0 00-1.212.582c-.036.02-.068.044-.104.064-.384.214-.762.438-1.128.684-.098.066-.188.144-.284.212-.294.208-.588.418-.868.65a15.001 15.001 0 00-2.056 2.054c-.232.282-.44.576-.65.87-.068.094-.144.184-.21.284-.248.364-.472.742-.684 1.126-.022.036-.044.07-.064.106-.216.394-.406.798-.584 1.21-.014.034-.034.066-.048.102-.168.396-.31.8-.442 1.21-.02.058-.044.116-.064.174-.118.382-.21.772-.298 1.164-.022.094-.05.184-.07.28-.076.372-.126.75-.172 1.128-.016.122-.042.238-.054.358a15.307 15.307 0 000 3.034c.012.12.038.238.054.358.046.38.096.758.172 1.13.02.094.048.184.07.278.088.392.18.782.298 1.164.02.06.044.116.064.174.132.41.274.814.442 1.21.014.036.034.068.048.102.178.412.368.816.584 1.21.02.036.042.07.064.106.212.384.436.762.684 1.128.066.098.142.188.21.284.21.294.418.588.65.868.618.75 1.306 1.438 2.056 2.056.28.23.574.44.868.648.096.068.186.146.284.212.366.246.744.472 1.128.684.036.02.068.044.104.064.396.214.8.406 1.212.582.034.016.066.034.102.05.394.166.8.31 1.21.442.058.02.114.044.172.062.384.118.774.212 1.164.3.094.02.186.05.28.07.372.074.75.124 1.13.172.12.014.236.04.358.054.5.048 1.006.076 1.516.076.624 0 1.234-.05 1.838-.124.164-.02.324-.05.486-.076.472-.072.934-.168 1.39-.284.148-.038.296-.07.442-.112.59-.17 1.168-.366 1.724-.604.032-.012.06-.03.09-.042a14.84 14.84 0 001.518-.776c.068-.038.14-.064.206-.104l-.008-.014a15.181 15.181 0 002.206-1.608c.28.752.696 1.452 1.282 2.04l7.708 7.706 2.122-2.12-7.708-7.708z",
    clipRule: "evenodd"
  }))
};
var ShopnikeAppFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6B,
    fill: "none"
  }));
});
var compPaths$6A = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M0 8.25h4.5M0 12.75h4.5m12.462 3.546a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 016.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0113.5 3.75c1.864 0 3.551.755 4.773 1.977A6.728 6.728 0 0120.25 10.5a6.726 6.726 0 01-.921 3.407c-.517.882-.434 1.988.289 2.711l3.632 3.632"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M0 8.25h4.5M0 12.75h4.5m12.462 3.546a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 016.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0113.5 3.75c1.864 0 3.551.755 4.773 1.977A6.728 6.728 0 0120.25 10.5a6.726 6.726 0 01-.921 3.407c-.517.882-.434 1.988.289 2.711l3.632 3.632"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M0 16.5h9m-9 9h9m24.924 7.092A13.432 13.432 0 0127 34.5c-3.728 0-7.102-1.51-9.546-3.954A13.455 13.455 0 0113.5 21c0-3.728 1.51-7.102 3.954-9.546A13.455 13.455 0 0127 7.5c3.728 0 7.102 1.51 9.546 3.954A13.455 13.455 0 0140.5 21c0 2.486-.672 4.814-1.842 6.814-1.034 1.764-.868 3.976.578 5.422L46.5 40.5"
  }))
};
var ShopnikeAppStroke$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6A,
    fill: "none"
  }));
});
var compPaths$6z = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.845 12.852l3.352-5.757-2.665 6.554c-.288.706-.826 1.726-1.671 1.53-.47-.109-.806-.674-.95-1.351-.092-.433-.115-.893-.136-1.351.075.317.39 1.317 1.168 1.198.299-.049.62-.342.902-.823z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.99 6.75a4.521 4.521 0 004.312-3.164c.17-.542.841-.723 1.244-.32l3.541 3.54a2.245 2.245 0 010 3.174l-10.27 10.27H4.138a1.888 1.888 0 01-.609-3.676l2.567-.873a2.651 2.651 0 001.706-1.823L11 1.94"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.845 12.852l3.352-5.757-2.665 6.554c-.288.706-.826 1.726-1.671 1.53-.47-.109-.806-.674-.95-1.351-.092-.433-.115-.893-.136-1.351.075.317.39 1.317 1.168 1.198.299-.049.62-.342.902-.823z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.99 6.75a4.521 4.521 0 004.312-3.164c.17-.542.841-.723 1.244-.32l3.541 3.54a2.245 2.245 0 010 3.174l-10.27 10.27H4.138a1.888 1.888 0 01-.609-3.676l2.567-.873a2.651 2.651 0 001.706-1.823L11 1.94"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M25.69 25.704l6.704-11.514-5.33 13.108c-.576 1.412-1.652 3.452-3.342 3.06-.94-.218-1.612-1.348-1.9-2.702-.184-.866-.23-1.786-.272-2.702.15.634.78 2.634 2.336 2.396.598-.098 1.24-.684 1.804-1.646z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M23.98 13.5a9.044 9.044 0 008.625-6.328c.34-1.084 1.681-1.446 2.488-.64l7.081 7.08a4.49 4.49 0 010 6.348L21.635 40.5H8.276A3.775 3.775 0 014.5 36.724a3.779 3.779 0 012.558-3.576l5.135-1.746a5.303 5.303 0 003.412-3.646L22 3.882"
  }))
};
var Shopnrc$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6z,
    fill: "none"
  }));
});
var compPaths$6y = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.845 12.852l3.352-5.757-2.665 6.554c-.288.706-.826 1.726-1.671 1.53-.47-.109-.806-.674-.95-1.351-.092-.433-.115-.893-.136-1.351.075.317.39 1.317 1.168 1.198.299-.049.62-.342.902-.823z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M11.99 6.75a4.521 4.521 0 004.312-3.164c.17-.542.841-.723 1.244-.32l3.541 3.54a2.245 2.245 0 010 3.174l-10.27 10.27H4.138a1.888 1.888 0 01-.609-3.676l2.567-.873a2.651 2.651 0 001.706-1.823L11 1.94"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.845 12.852l3.352-5.757-2.665 6.554c-.288.706-.826 1.726-1.671 1.53-.47-.109-.806-.674-.95-1.351-.092-.433-.115-.893-.136-1.351.075.317.39 1.317 1.168 1.198.299-.049.62-.342.902-.823z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M11.99 6.75a4.521 4.521 0 004.312-3.164c.17-.542.841-.723 1.244-.32l3.541 3.54a2.245 2.245 0 010 3.174l-10.27 10.27H4.138a1.888 1.888 0 01-.609-3.676l2.567-.873a2.651 2.651 0 001.706-1.823L11 1.94"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M25.69 25.704l6.704-11.514-5.33 13.108c-.576 1.412-1.652 3.452-3.342 3.06-.94-.218-1.612-1.348-1.9-2.702-.184-.866-.23-1.786-.272-2.702.15.634.78 2.634 2.336 2.396.598-.098 1.24-.684 1.804-1.646z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M23.98 13.5a9.044 9.044 0 008.625-6.328c.34-1.084 1.681-1.446 2.488-.64l7.081 7.08a4.49 4.49 0 010 6.348L21.635 40.5H8.276A3.775 3.775 0 014.5 36.724a3.779 3.779 0 012.558-3.576l5.135-1.746a5.303 5.303 0 003.412-3.646L22 3.882"
  }))
};
var ShopnrcStroke$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6y,
    fill: "none"
  }));
});
var compPaths$6x = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M9.39 14.31c-.96-.71-.23-2.12.03-2.54-.47.52-.94 1.03-1.3 1.59-.57.88-.82 1.85-.43 2.47.7 1.12 2.37.6 3.43.15L21 11.81l-9.76 2.58c-.82.21-1.48.19-1.85-.08z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M23.25 4.5v12c0 1.24-1.01 2.25-2.25 2.25H3c-1.24 0-2.25-1.01-2.25-2.25v-1.93l8.76-5.06c.17-.1.33-.22.47-.36l3.9-3.9h4.13c1.24 0 2.25 1.01 2.25 2.25V9"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M9.39 14.31c-.96-.71-.23-2.12.03-2.54-.47.52-.94 1.03-1.3 1.59-.57.88-.82 1.85-.43 2.47.7 1.12 2.37.6 3.43.15L21 11.81l-9.76 2.58c-.82.21-1.48.19-1.85-.08z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M23.25 4.5v12c0 1.24-1.01 2.25-2.25 2.25H3c-1.24 0-2.25-1.01-2.25-2.25v-1.93l8.76-5.06c.17-.1.33-.22.47-.36l3.9-3.9h4.13c1.24 0 2.25 1.01 2.25 2.25V9"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M18.78 28.62c-1.92-1.42-.46-4.24.06-5.08-.94 1.04-1.88 2.06-2.6 3.18-1.14 1.76-1.64 3.7-.86 4.94 1.4 2.24 4.74 1.2 6.86.3L42 23.62l-19.52 5.16c-1.64.42-2.96.38-3.7-.16z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M46.5 9v24c0 2.48-2.02 4.5-4.5 4.5H6c-2.48 0-4.5-2.02-4.5-4.5v-3.86l17.52-10.12c.34-.2.66-.44.94-.72l7.8-7.8h8.26c2.48 0 4.5 2.02 4.5 4.5v3"
  }))
};
var ShopSNKRS$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6x,
    fill: "none"
  }));
});
var compPaths$6w = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.602 11.566a.74.74 0 010 .867C20.54 13.924 16.73 18.75 12 18.75s-8.532-4.828-9.593-6.318a.74.74 0 010-.864C3.468 10.078 7.27 5.25 12 5.25c4.73 0 8.54 4.826 9.602 6.316z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.602 11.566a.74.74 0 010 .867C20.54 13.924 16.73 18.75 12 18.75s-8.532-4.828-9.593-6.318a.74.74 0 010-.864C3.468 10.078 7.27 5.25 12 5.25c4.73 0 8.54 4.826 9.602 6.316z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.5 24a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.204 23.133a1.48 1.48 0 010 1.734C41.078 27.847 33.46 37.5 24 37.5c-9.462 0-17.064-9.656-19.186-12.636a1.48 1.48 0 010-1.73C6.936 20.155 14.538 10.5 24 10.5c9.46 0 17.078 9.652 19.204 12.632z",
    clipRule: "evenodd"
  }))
};
var Show$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6w,
    fill: "none"
  }));
});
var compPaths$6v = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.28 18.4l2.65-2.65-2.65-2.65m0-2.2l2.65-2.65-2.65-2.65"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M19.5 8.25h-4.14c-.62 0-1.18.25-1.59.66l-6.18 6.18c-.41.41-.97.66-1.59.66H3m6.09-5.34l-1.5-1.5c-.41-.41-.97-.66-1.59-.66H3m16.5 7.5h-4.14c-.62 0-1.18-.25-1.59-.66l-1.5-1.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.28 18.4l2.65-2.65-2.65-2.65m0-2.2l2.65-2.65-2.65-2.65"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M19.5 8.25h-4.14c-.62 0-1.18.25-1.59.66l-6.18 6.18c-.41.41-.97.66-1.59.66H3m6.09-5.34l-1.5-1.5c-.41-.41-.97-.66-1.59-.66H3m16.5 7.5h-4.14c-.62 0-1.18-.25-1.59-.66l-1.5-1.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M34.559 36.8l5.3-5.3-5.3-5.3m0-4.4l5.3-5.3-5.3-5.3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M39 16.5h-8.28c-1.24 0-2.36.5-3.18 1.32L15.18 30.18c-.82.82-1.94 1.32-3.18 1.32H6m12.18-10.68l-3-3A4.474 4.474 0 0012 16.5H6m33 15h-8.28c-1.24 0-2.36-.5-3.18-1.32l-3-3"
  }))
};
var Shuffle$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6v,
    fill: "none"
  }));
});
var compPaths$6u = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20.25 7.5v9c0 1.24-1.01 2.25-2.25 2.25H9c-1.24 0-2.25-1.01-2.25-2.25v-9c0-1.24 1.01-2.25 2.25-2.25h9c1.24 0 2.25 1.01 2.25 2.25zm-16.5 3.75v1.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20.25 7.5v9c0 1.24-1.01 2.25-2.25 2.25H9c-1.24 0-2.25-1.01-2.25-2.25v-9c0-1.24 1.01-2.25 2.25-2.25h9c1.24 0 2.25 1.01 2.25 2.25zm-16.5 3.75v1.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M40.5 15v18c0 2.48-2.02 4.5-4.5 4.5H18c-2.48 0-4.5-2.02-4.5-4.5V15c0-2.48 2.02-4.5 4.5-4.5h18c2.48 0 4.5 2.02 4.5 4.5zm-33 7.5v3"
  }))
};
var SingleSelect$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6u,
    fill: "none"
  }));
});
var compPaths$6t = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.925 16.229l-3.712 3.713-3.713-3.713M17.212 20V4.5M3.075 7.772l3.712-3.713L10.5 7.772M6.788 4v15.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.925 16.229l-3.712 3.713-3.713-3.713M17.212 20V4.5M3.075 7.772l3.712-3.713L10.5 7.772M6.788 4v15.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M41.85 32.457l-7.427 7.426L27 32.457M34.424 40V9M6.15 15.543l7.426-7.426L21 15.543M13.576 8v31"
  }))
};
var Sort$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6t,
    fill: "none"
  }));
});
var compPaths$6s = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 14.25H3m4.5-4.5H3m13.5 9H3m10.5-9.46l3.71-3.71 3.71 3.71M17.25 15V6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 14.25H3m4.5-4.5H3m13.5 9H3m10.5-9.46l3.71-3.71 3.71 3.71M17.25 15V6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 28.5H6m9-9H6m27 18H6m21-18.92l7.42-7.42 7.42 7.42M34.5 30V12"
  }))
};
var SortAscending$5 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6s,
    fill: "none"
  }));
});
var compPaths$6r = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12.01 9.75h-9m4.5 4.5h-4.5m13.5-9H3.01M17.26 9v9m3.71-3.27l-3.71 3.71-3.71-3.71"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12.01 9.75h-9m4.5 4.5h-4.5m13.5-9H3.01M17.26 9v9m3.71-3.27l-3.71 3.71-3.71-3.71"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24.02 19.5h-18m9 9h-9m27-18h-27m28.5 7.5v18m7.422-6.54l-7.42 7.42-7.42-7.42"
  }))
};
var SortDescending$5 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6r,
    fill: "none"
  }));
});
var compPaths$6q = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18.25 6v9.75c0 .827-.765 1.5-1.704 1.5H7.455c-.94 0-1.705-.673-1.705-1.5V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9 17v-6h6v6m-3-5.5V17M4 6.75h16"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20.25 5.25V16.5c0 1.24-1.01 2.25-2.25 2.25H6c-1.24 0-2.25-1.01-2.25-2.25V5.25"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8.25 18.5v-7.25h7.5v7.25M12 11.25v7.25M1.5 5.25h21"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M40.5 10.5V33c0 2.48-2.02 4.5-4.5 4.5H12c-2.48 0-4.5-2.02-4.5-4.5V10.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M16.5 37V22.5h15V37M24 22.5V37M3 10.5h42"
  }))
};
var Store$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6q,
    fill: "none"
  }));
});
var compPaths$6p = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M2.25 16.51v-9c0-1.24 1.01-2.25 2.25-2.25h15c1.24 0 2.25 1.01 2.25 2.25v9c0 1.24-1.01 2.25-2.25 2.25h-15c-1.24 0-2.25-1.01-2.25-2.25zm3-6.01v3"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M2.25 16.51v-9c0-1.24 1.01-2.25 2.25-2.25h15c1.24 0 2.25 1.01 2.25 2.25v9c0 1.24-1.01 2.25-2.25 2.25h-15c-1.24 0-2.25-1.01-2.25-2.25zm3-6.01v3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M4.5 33.02v-18c0-2.48 2.02-4.5 4.5-4.5h30c2.48 0 4.5 2.02 4.5 4.5v18c0 2.48-2.02 4.5-4.5 4.5H9c-2.48 0-4.5-2.02-4.5-4.5zm6-12.02v6"
  }))
};
var TabletHorizontal$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6p,
    fill: "none"
  }));
});
var compPaths$6o = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.51 21.75h-9c-1.24 0-2.25-1.01-2.25-2.25v-15c0-1.24 1.01-2.25 2.25-2.25h9c1.24 0 2.25 1.01 2.25 2.25v15c0 1.24-1.01 2.25-2.25 2.25zm-6.01-3h3"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.51 21.75h-9c-1.24 0-2.25-1.01-2.25-2.25v-15c0-1.24 1.01-2.25 2.25-2.25h9c1.24 0 2.25 1.01 2.25 2.25v15c0 1.24-1.01 2.25-2.25 2.25zm-6.01-3h3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M33.02 43.5h-18c-2.48 0-4.5-2.02-4.5-4.5V9c0-2.48 2.02-4.5 4.5-4.5h18c2.48 0 4.5 2.02 4.5 4.5v30c0 2.48-2.02 4.5-4.5 4.5zM21 37.5h6"
  }))
};
var TabletVertical$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6o,
    fill: "none"
  }));
});
var compPaths$6n = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M3.75 3.75h7.42l9.93 9.93c.86.86.86 2.25 0 3.11l-4.31 4.31c-.86.86-2.25.86-3.11 0l-9.93-9.93V3.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9 11.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M3.75 3.75h7.42l9.93 9.93c.86.86.86 2.25 0 3.11l-4.31 4.31c-.86.86-2.25.86-3.11 0l-9.93-9.93V3.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9 11.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M7.5 7.5h14.84L42.2 27.36a4.394 4.394 0 010 6.22l-8.62 8.62a4.394 4.394 0 01-6.22 0L7.5 22.34V7.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M18 22.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9z"
  }))
};
var Tag$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6n,
    fill: "none"
  }));
});
var compPaths$6m = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.25 9c0-1.86.76-3.55 1.98-4.77A6.735 6.735 0 0111 2.25h6.25c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-.75 1.75c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5H16.5h1.75c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5H16.5h1.75c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-7.68c-.38 0-.63.42-.43.75l1.73 3c.41.72.17 1.63-.55 2.05-.72.41-1.63.17-2.05-.55l-4.15-7.2A6.58 6.58 0 014.25 9zm0 0c0-3.73 3.02-6.75 6.75-6.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.25 9c0-1.86.76-3.55 1.98-4.77A6.735 6.735 0 0111 2.25h6.25c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-.75 1.75c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5H16.5h1.75c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5H16.5h1.75c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-7.68c-.38 0-.63.42-.43.75l1.73 3c.41.72.17 1.63-.55 2.05-.72.41-1.63.17-2.05-.55l-4.15-7.2A6.58 6.58 0 014.25 9zm0 0c0-3.73 3.02-6.75 6.75-6.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M8.5 18c0-3.72 1.52-7.1 3.96-9.54A13.47 13.47 0 0122 4.5h12.5c1.66 0 3 1.34 3 3s-1.34 3-3 3H33h3.5c1.66 0 3 1.34 3 3s-1.34 3-3 3H33h3.5c1.66 0 3 1.34 3 3s-1.34 3-3 3H33h3.5c1.66 0 3 1.34 3 3s-1.34 3-3 3H21.14c-.76 0-1.26.84-.86 1.5l3.46 6c.82 1.44.34 3.26-1.1 4.1-1.44.82-3.26.34-4.1-1.1l-8.3-14.4C9.12 22.66 8.5 20.4 8.5 18zm0 0c0-7.46 6.04-13.5 13.5-13.5"
  }))
};
var ThumbsDown$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6m,
    fill: "none"
  }));
});
var compPaths$6l = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.25 13.5c0 1.86.76 3.55 1.98 4.77A6.735 6.735 0 0011 20.25h6.25c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-.75 1.75c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5H16.5h1.75c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5H16.5h1.75c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-7.68c-.38 0-.63-.42-.43-.75l1.73-3A1.501 1.501 0 009.27 3l-4.15 7.2c-.56.97-.87 2.1-.87 3.3zm0 0c0 3.73 3.02 6.75 6.75 6.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.25 13.5c0 1.86.76 3.55 1.98 4.77A6.735 6.735 0 0011 20.25h6.25c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-.75 1.75c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5H16.5h1.75c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5H16.5h1.75c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-7.68c-.38 0-.63-.42-.43-.75l1.73-3A1.501 1.501 0 009.27 3l-4.15 7.2c-.56.97-.87 2.1-.87 3.3zm0 0c0 3.73 3.02 6.75 6.75 6.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M8.5 27c0 3.72 1.52 7.1 3.96 9.54A13.47 13.47 0 0022 40.5h12.5c1.66 0 3-1.34 3-3s-1.34-3-3-3H33h3.5c1.66 0 3-1.34 3-3s-1.34-3-3-3H33h3.5c1.66 0 3-1.34 3-3s-1.34-3-3-3H33h3.5c1.66 0 3-1.34 3-3s-1.34-3-3-3H21.14c-.76 0-1.26-.84-.86-1.5l3.46-6c.82-1.44.34-3.26-1.1-4.1-1.44-.82-3.28-.34-4.1 1.1l-8.3 14.4C9.12 22.34 8.5 24.6 8.5 27zm0 0c0 7.46 6.04 13.5 13.5 13.5"
  }))
};
var ThumbsUp$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6l,
    fill: "none"
  }));
});
var compPaths$6k = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 7v5h5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.25 12a7.25 7.25 0 11-14.5 0 7.25 7.25 0 0114.5 0z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 6v6h5.25"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.25 12a8.25 8.25 0 11-16.5 0 8.25 8.25 0 1116.5 0z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 12v12h10.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M40.5 24c0 9.114-7.388 16.5-16.5 16.5S7.5 33.114 7.5 24 14.888 7.5 24 7.5 40.5 14.886 40.5 24z",
    clipRule: "evenodd"
  }))
};
var Time$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6k,
    fill: "none"
  }));
});
var compPaths$6j = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M10.285 16.131h-.75v.75h.75v-.75zm3.429 0v.75h.75v-.75h-.75zm-3.429-1.352h.75v-.432l-.374-.217-.376.65zm3.429 0l-.376-.649-.374.217v.432h.75zM11.249 4v2.286h1.5V4h-1.5zM4 12.75h2.286v-1.5H4v1.5zm13.714 0H20v-1.5h-2.286v1.5zM5.834 6.928L7.45 8.544l1.06-1.06-1.616-1.617-1.06 1.06zm11.27-1.061L15.49 7.483l1.06 1.06 1.617-1.615-1.061-1.061zM9.553 20h4.894v-1.5H9.552V20zm-.23-8.19a2.678 2.678 0 012.678-2.679v-1.5a4.179 4.179 0 00-4.179 4.178h1.5zM12 9.13c1.479 0 2.678 1.2 2.678 2.678h1.5A4.179 4.179 0 0012 7.631v1.5zm-1.715 7.75h3.429v-1.5h-3.429v1.5zm.376-2.75a2.677 2.677 0 01-1.34-2.322h-1.5a4.18 4.18 0 002.089 3.62l.75-1.299zm-1.126.648v1.352h1.5v-1.352h-1.5zm5.143-2.97c0 .991-.537 1.857-1.34 2.321l.752 1.299a4.177 4.177 0 002.088-3.62h-1.5zm-1.714 2.97v1.352h1.5v-1.352h-1.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M9.75 17.75H9v.75h.75v-.75zm4.5 0v.75H15v-.75h-.75zm-4.5-2.102h.75v-.433L10.126 15l-.376.649zm4.5 0l-.376-.65-.374.217v.433h.75zm-3-14.148v3h1.5v-3h-1.5zM1.5 12.75h3v-1.5h-3v1.5zm18 0h3v-1.5h-3v1.5zM4.073 5.177l2.121 2.121 1.061-1.06-2.121-2.122-1.06 1.06zm14.793-1.06l-2.12 2.12 1.06 1.061 2.121-2.121-1.06-1.06zM9 21h6v-1.5H9V21zm-.75-9.25A3.75 3.75 0 0112 8V6.5a5.25 5.25 0 00-5.25 5.25h1.5zM12 8a3.75 3.75 0 013.75 3.75h1.5c0-2.9-2.35-5.25-5.25-5.25V8zM9.75 18.5h4.5V17h-4.5v1.5zm.376-3.501A3.748 3.748 0 018.25 11.75h-1.5a5.248 5.248 0 002.625 4.547l.75-1.298zM9 15.648v2.102h1.5v-2.102H9zm6.75-3.898c0 1.387-.753 2.6-1.876 3.249l.752 1.298a5.248 5.248 0 002.624-4.547h-1.5zm-2.25 3.898v2.102H15v-2.102h-1.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M19.5 35.5H18V37h1.5v-1.5zm9 0V37H30v-1.5h-1.5zm-9-4.204H21v-.865l-.75-.433-.75 1.298zm9 0l-.752-1.298-.749.433v.865h1.5zM22.498 3v6h3V3h-3zM3 25.5h6v-3H3v3zm36 0h6v-3h-6v3zM8.145 10.354l4.243 4.242 2.121-2.121-4.242-4.243-2.122 2.122zm29.587-2.122l-4.243 4.243 2.122 2.121 4.242-4.242-2.121-2.122zM17.999 42h12v-3H18v3zm-1.5-18.5A7.5 7.5 0 0124 16v-3c-5.799 0-10.5 4.701-10.5 10.5h3zM24 16a7.5 7.5 0 017.5 7.5h3C34.5 17.701 29.8 13 24 13v3zm-4.5 21h9v-3h-9v3zm.751-7.002A7.497 7.497 0 0116.5 23.5h-3c0 3.888 2.114 7.281 5.248 9.094l1.502-2.596zM18 31.296V35.5h3v-4.204h-3zM31.5 23.5a7.497 7.497 0 01-3.752 6.498l1.502 2.596A10.496 10.496 0 0034.5 23.5h-3zM27 31.296V35.5h3v-4.204h-3z"
  }))
};
var Tip$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6j,
    fill: "none"
  }));
});
var compPaths$6i = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M4.25 14.25H18c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25h-7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M6.71 16.9l-2.65-2.65 2.65-2.65m13.04-1.85H6c-1.24 0-2.25-1.01-2.25-2.25S4.76 5.25 6 5.25h7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.29 7.1l2.65 2.65-2.65 2.65"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M4.25 14.25H18c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25h-7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M6.71 16.9l-2.65-2.65 2.65-2.65m13.04-1.85H6c-1.24 0-2.25-1.01-2.25-2.25S4.76 5.25 6 5.25h7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.29 7.1l2.65 2.65-2.65 2.65"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M8.5 28.5H36c2.48 0 4.5 2.02 4.5 4.5s-2.02 4.5-4.5 4.5H21"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M13.42 33.8l-5.3-5.3 5.3-5.3m26.08-3.7H12c-2.48 0-4.5-2.02-4.5-4.5s2.02-4.5 4.5-4.5h15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M34.58 14.2l5.3 5.3-5.3 5.3"
  }))
};
var Transfers$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6i,
    fill: "none"
  }));
});
var compPaths$6h = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18.75H.75V5.25H12m0 0h11.25v13.5H12"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M6.68 8.25h1.77l2.65 7.5H9.4l-.49-1.54H6.15l-.51 1.54H4l2.68-7.5zm-.11 4.67h1.92l-.94-2.96-.98 2.96z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 10c0 .746-.183 1.461-.514 2.108a5.516 5.516 0 01-1.403 1.728A6.672 6.672 0 0114 15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15.014 12.108c.33.647.807 1.233 1.403 1.728.597.494 1.294.89 2.083 1.164m-2.25-6.75V10"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.5 10H20"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18.75H.75V5.25H12m0 0h11.25v13.5H12"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M6.68 8.25h1.77l2.65 7.5H9.4l-.49-1.54H6.15l-.51 1.54H4l2.68-7.5zm-.11 4.67h1.92l-.94-2.96-.98 2.96z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 10c0 .746-.183 1.461-.514 2.108a5.516 5.516 0 01-1.403 1.728A6.672 6.672 0 0114 15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15.014 12.108c.33.647.807 1.233 1.403 1.728.597.494 1.294.89 2.083 1.164m-2.25-6.75V10"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.5 10H20"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 37.5H1.5v-27H24m0 0h22.5v27H24"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M13.36 16.5h3.54l5.3 15h-3.4l-.98-3.08H12.3l-1.02 3.08H8l5.36-15zm-.22 9.34h3.84l-1.88-5.92-1.96 5.92z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M36 20a9.245 9.245 0 01-1.028 4.216c-.66 1.294-1.614 2.466-2.807 3.455A13.34 13.34 0 0128 30"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M30.027 24.216c.661 1.294 1.615 2.466 2.808 3.455A13.356 13.356 0 0037 30.001M32.5 16.5V20"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M25 20h15"
  }))
};
var Translation$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6h,
    fill: "none"
  }));
});
var compPaths$6g = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15 8.25h5.25V3m0 5.25L14 2.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.75 20.25h5.5v-4.5h-5.5v4.5zm-8.75 0h3.25V3.75h-5.5V18c0 1.24 1.01 2.25 2.25 2.25zm3.25 0h5.5v-9h-5.5v9z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15 8.25h5.25V3m0 5.25L14 2.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.75 20.25h5.5v-4.5h-5.5v4.5zm-8.75 0h3.25V3.75h-5.5V18c0 1.24 1.01 2.25 2.25 2.25zm3.25 0h5.5v-9h-5.5v9z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M30 16.5h10.5V6m0 10.5L28 5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M29.5 40.5h11v-9h-11v9zm-17.5 0h6.5v-33h-11V36c0 2.48 2.02 4.5 4.5 4.5zm6.5 0h11v-18h-11v18z"
  }))
};
var TrendingDown$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6g,
    fill: "none"
  }));
});
var compPaths$6f = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.25 9V3.75H4m5.25 0L3 9.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 15.75h-5.5v4.49h5.5v-4.49zm8.75 4.5h-3.25V3.75h5.5V18c0 1.24-1.01 2.25-2.25 2.25zm-3.25-9h-5.5v9h5.5v-9z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.25 9V3.75H4m5.25 0L3 9.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 15.75h-5.5v4.49h5.5v-4.49zm8.75 4.5h-3.25V3.75h5.5V18c0 1.24-1.01 2.25-2.25 2.25zm-3.25-9h-5.5v9h5.5v-9z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M18.5 18V7.5H8m10.5 0L6 19"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.5 31.5h-11v8.98h11V31.5zm17.5 9h-6.5v-33h11V36c0 2.48-2.02 4.5-4.5 4.5zm-6.5-18h-11v18h11v-18z"
  }))
};
var TrendingUp$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6f,
    fill: "none"
  }));
});
var compPaths$6e = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15.75V18m0-2.25a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.25 20.25H6.75c-.83 0-1.5-.67-1.5-1.5v-7.5c0-.83.67-1.5 1.5-1.5h10.5c.83 0 1.5.67 1.5 1.5v7.5c0 .83-.67 1.5-1.5 1.5zM15.75 6c0-2.07-1.68-3.75-3.75-3.75-2.07 0-3.75 1.68-3.75 3.75v3.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15.75V18m0-2.25a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.25 20.25H6.75c-.83 0-1.5-.67-1.5-1.5v-7.5c0-.83.67-1.5 1.5-1.5h10.5c.83 0 1.5.67 1.5 1.5v7.5c0 .83-.67 1.5-1.5 1.5zM15.75 6c0-2.07-1.68-3.75-3.75-3.75-2.07 0-3.75 1.68-3.75 3.75v3.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 31.5V36m0-4.5a3 3 0 100-6 3 3 0 000 6z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M34.5 40.5h-21c-1.66 0-3-1.34-3-3v-15c0-1.66 1.34-3 3-3h21c1.66 0 3 1.34 3 3v15c0 1.66-1.34 3-3 3zm-3-28.5c0-4.14-3.36-7.5-7.5-7.5-4.14 0-7.5 3.36-7.5 7.5v7.5"
  }))
};
var Unlock$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6e,
    fill: "none"
  }));
});
var compPaths$6d = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 11.25A2.248 2.248 0 016.75 9h10.5a2.248 2.248 0 012.25 2.25v7.5A2.248 2.248 0 0117.25 21H6.75a2.248 2.248 0 01-2.25-2.25v-7.5zm5.25 3a2.25 2.25 0 113 2.122V18h-1.5v-1.628a2.251 2.251 0 01-1.5-2.122z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15.75 6c0-2.07-1.68-3.75-3.75-3.75-2.07 0-3.75 1.68-3.75 3.75v3.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 11.25A2.248 2.248 0 016.75 9h10.5a2.248 2.248 0 012.25 2.25v7.5A2.248 2.248 0 0117.25 21H6.75a2.248 2.248 0 01-2.25-2.25v-7.5zm5.25 3a2.25 2.25 0 113 2.122V18h-1.5v-1.628a2.251 2.251 0 01-1.5-2.122z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15.75 6c0-2.07-1.68-3.75-3.75-3.75-2.07 0-3.75 1.68-3.75 3.75v3.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 22.5c0-2.488 2.012-4.5 4.5-4.5h21c2.488 0 4.5 2.012 4.5 4.5v15c0 2.488-2.012 4.5-4.5 4.5h-21A4.496 4.496 0 019 37.5v-15zm10.5 6a4.5 4.5 0 116 4.244V36h-3v-3.256a4.502 4.502 0 01-3-4.244z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M31.5 12c0-4.14-3.36-7.5-7.5-7.5-4.14 0-7.5 3.36-7.5 7.5v7.5"
  }))
};
var UnlockFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6d,
    fill: "none"
  }));
});
var compPaths$6c = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 7.5v9c0 2.07-1.68 3.75-3.75 3.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.25 7.51a5.254 5.254 0 00-5.24-5.26c-2.9-.01-5.25 2.34-5.26 5.24"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M7.49 6.75c-2.07 0-3.75 1.68-3.75 3.75 0 2.07 1.68 3.75 3.75 3.75h2.26m4.5 0h2.24c2.07 0 3.75-1.68 3.75-3.75 0-2.07-1.68-3.75-3.75-3.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8.29 10.78L12 7.07l3.71 3.71"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 7.5v9c0 2.07-1.68 3.75-3.75 3.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.25 7.51a5.254 5.254 0 00-5.24-5.26c-2.9-.01-5.25 2.34-5.26 5.24"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M7.49 6.75c-2.07 0-3.75 1.68-3.75 3.75 0 2.07 1.68 3.75 3.75 3.75h2.26m4.5 0h2.24c2.07 0 3.75-1.68 3.75-3.75 0-2.07-1.68-3.75-3.75-3.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8.29 10.78L12 7.07l3.71 3.71"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 15v18c0 4.14-3.36 7.5-7.5 7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M34.5 15.02A10.508 10.508 0 0024.02 4.5c-5.8-.02-10.5 4.68-10.52 10.48"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M14.98 13.5c-4.14 0-7.5 3.36-7.5 7.5 0 4.14 3.36 7.5 7.5 7.5h4.52m9 0h4.48c4.14 0 7.5-3.36 7.5-7.5 0-4.14-3.36-7.5-7.5-7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M16.578 21.56l7.42-7.42 7.42 7.42"
  }))
};
var Upload$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6c,
    fill: "none"
  }));
});
var compPaths$6b = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.39 11.35L10.28 8.4a.75.75 0 00-1.125.649v5.903a.75.75 0 001.125.649l5.11-2.951a.75.75 0 000-1.3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.5 18.75a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25h15z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.39 11.35L10.28 8.4a.75.75 0 00-1.125.649v5.903a.75.75 0 001.125.649l5.11-2.951a.75.75 0 000-1.3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.5 18.75a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25h15z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M30.781 22.701L20.56 16.8c-1-.576-2.25.144-2.25 1.298v11.806c0 1.154 1.25 1.874 2.25 1.298L30.781 25.3a1.5 1.5 0 000-2.598z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M39 37.5a4.5 4.5 0 004.5-4.5V15a4.5 4.5 0 00-4.5-4.5H9A4.5 4.5 0 004.5 15v18A4.5 4.5 0 009 37.5h30z",
    clipRule: "evenodd"
  }))
};
var VideoPlayer$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6b,
    fill: "none"
  }));
});
var compPaths$6a = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.396 10.527l2.61 1.5 2.612-1.5m-2.611 1.5v2.5m0 2.5v2.814m6.75-3.897l-2.442-1.417M5.257 15.944l2.442-1.417m4.308-7.186V4.527m-6.75 3.897l2.442 1.417m11.058-1.417l-2.442 1.417M9.44 18.36l2.567 1.481 2.567-1.482m0-12.349l-2.567-1.483L9.44 6.01m6.75 11.417l2.567-1.482V12.98m0-1.592V8.424L16.19 6.942M7.824 17.427l-2.567-1.482V12.98m0-1.592V8.424l2.567-1.482"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M23.257 12.004c0 6.214-5.039 11.254-11.253 11.254C5.788 23.258.75 18.218.75 12.004.75 5.789 5.788.75 12.004.75c6.214 0 11.253 5.039 11.253 11.254z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.396 10.527l2.61 1.5 2.612-1.5m-2.611 1.5v2.5m0 2.5v2.814m6.75-3.897l-2.442-1.417M5.257 15.944l2.442-1.417m4.308-7.186V4.527m-6.75 3.897l2.442 1.417m11.058-1.417l-2.442 1.417M9.44 18.36l2.567 1.481 2.567-1.482m0-12.349l-2.567-1.483L9.44 6.01m6.75 11.417l2.567-1.482V12.98m0-1.592V8.424L16.19 6.942M7.824 17.427l-2.567-1.482V12.98m0-1.592V8.424l2.567-1.482"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M23.257 12.004c0 6.214-5.039 11.254-11.253 11.254C5.788 23.258.75 18.218.75 12.004.75 5.789 5.788.75 12.004.75c6.214 0 11.253 5.039 11.253 11.254z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.791 21.054l5.223 3 5.224-3m-5.223 3v5m0 5v5.628m13.499-7.794l-4.884-2.834m-22.115 2.834l4.884-2.834m8.616-14.371V9.055m-13.5 7.794l4.884 2.834m22.115-2.834l-4.884 2.834M18.88 36.718l5.135 2.964 5.134-2.964m-.001-24.699l-5.134-2.964-5.134 2.964m13.5 22.834l5.135-2.964V25.96m-.001-3.184V16.85l-5.134-2.965M15.648 34.853l-5.134-2.964V25.96m.001-3.184V16.85l5.134-2.965"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M46.514 24.007c0 12.43-10.078 22.508-22.506 22.508-12.43 0-22.508-10.078-22.508-22.508S11.576 1.499 24.01 1.499c12.428 0 22.505 10.078 22.505 22.508z",
    clipRule: "evenodd"
  }))
};
var VR$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$6a,
    fill: "none"
  }));
});
var compPaths$69 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 8.25H6A2.25 2.25 0 013.75 6v12A2.25 2.25 0 006 20.25h12A2.25 2.25 0 0020.25 18v-7.5A2.25 2.25 0 0018 8.25h-2.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 6.5V3.75H6A2.25 2.25 0 003.75 6v1.25"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.25 15.75h-3a1.5 1.5 0 010-3h3v3z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 8.25H6A2.25 2.25 0 013.75 6v12A2.25 2.25 0 006 20.25h12A2.25 2.25 0 0020.25 18v-7.5A2.25 2.25 0 0018 8.25h-2.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 6.5V3.75H6A2.25 2.25 0 003.75 6v1.25"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.25 15.75h-3a1.5 1.5 0 010-3h3v3z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.5 16.5H12A4.5 4.5 0 017.5 12v24c0 2.484 2.016 4.5 4.5 4.5h24c2.484 0 4.5-2.016 4.5-4.5V21c0-2.484-2.016-4.5-4.5-4.5h-4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M37.5 13V7.5H12A4.5 4.5 0 007.5 12v2.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M40.5 31.5h-6a3.001 3.001 0 010-6h6v6z",
    clipRule: "evenodd"
  }))
};
var Wallet$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$69,
    fill: "none"
  }));
});
var compPaths$68 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.962 16.296a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 013.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0110.5 3.75a6.73 6.73 0 014.773 1.977A6.728 6.728 0 0117.25 10.5a6.726 6.726 0 01-.921 3.407c-.517.882-.434 1.988.289 2.711l3.853 3.853M10.5 13.5v-6m-3 3h6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.962 16.296a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 013.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0110.5 3.75a6.73 6.73 0 014.773 1.977A6.728 6.728 0 0117.25 10.5a6.726 6.726 0 01-.921 3.407c-.517.882-.434 1.988.289 2.711l3.853 3.853M10.5 13.5v-6m-3 3h6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M27.924 32.592A13.432 13.432 0 0121 34.5c-3.728 0-7.102-1.51-9.546-3.954A13.455 13.455 0 017.5 21c0-3.728 1.51-7.102 3.954-9.546A13.455 13.455 0 0121 7.5c3.728 0 7.102 1.51 9.546 3.954A13.455 13.455 0 0134.5 21c0 2.486-.672 4.814-1.842 6.814-1.034 1.764-.868 3.976.578 5.422l7.706 7.706M21 27V15m-6 6h12"
  }))
};
var Zoomin$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$68,
    fill: "none"
  }));
});
var compPaths$67 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.962 16.296a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 013.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0110.5 3.75a6.73 6.73 0 014.774 1.977A6.735 6.735 0 0117.25 10.5a6.717 6.717 0 01-.922 3.407c-.516.882-.433 1.988.29 2.711l3.854 3.853M7.5 10.5h6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.962 16.296a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 013.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0110.5 3.75a6.73 6.73 0 014.774 1.977A6.735 6.735 0 0117.25 10.5a6.717 6.717 0 01-.922 3.407c-.516.882-.433 1.988.29 2.711l3.854 3.853M7.5 10.5h6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M27.924 32.592A13.432 13.432 0 0121 34.5c-3.728 0-7.102-1.51-9.546-3.954A13.455 13.455 0 017.5 21c0-3.728 1.51-7.102 3.954-9.546A13.455 13.455 0 0121 7.5a13.46 13.46 0 019.548 3.954A13.47 13.47 0 0134.5 21c0 2.486-.672 4.814-1.844 6.814-1.032 1.764-.866 3.976.58 5.422l7.708 7.706M15 21h12"
  }))
};
var Zoomout$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$67,
    fill: "none"
  }));
});
var compPaths$66 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 5.75H5.75v12.5H12m0-12.5v12.5m0-12.5h6.25v12.5H12"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 3.75H3.75v16.5H12m0-16.5v16.5m0-16.5h8.25v16.5H12"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 7.5H7.5v33H24m0-33v33m0-33h16.5v33H24"
  }))
};
var Columns$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$66,
    fill: "none"
  }));
});
var compPaths$65 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 3.75h6m-9 0h-.25a2 2 0 00-2 2V6M18 3.75h.25a2 2 0 012 2V6M15 20.25H9m9 0h.25a2 2 0 002-2V18M6 20.25h-.25a2 2 0 01-2-2V18m0-3V9m16.5 6V9.375"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 3.75h6m-9 0h-.25a2 2 0 00-2 2V6M18 3.75h.25a2 2 0 012 2V6M15 20.25H9m9 0h.25a2 2 0 002-2V18M6 20.25h-.25a2 2 0 01-2-2V18m0-3V9m16.5 6V9.375"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18 7.5h12m-18 0h-.5a4 4 0 00-4 4v.5M36 7.5h.5a4 4 0 014 4v.5M30 40.5H18m18 0h.5a4 4 0 004-4V36M12 40.5h-.5a4 4 0 01-4-4V36m0-6V18m33 12V18.75"
  }))
};
var Container$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$65,
    fill: "none"
  }));
});
var compPaths$64 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7 9.25h5.5c1.24 0 2.25 1.01 2.25 2.25V17c0 1.24-1.01 2.25-2.25 2.25H7c-1.24 0-2.25-1.01-2.25-2.25v-5.5c0-1.24 1.01-2.25 2.25-2.25zM9.25 7c0-1.24 1.01-2.25 2.25-2.25m5.5 10c1.24 0 2.25-1.01 2.25-2.25m0-5.5c0-1.24-1.01-2.25-2.25-2.25m2.25 3.75V11M13 4.75h2.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 8.25h7.5c1.24 0 2.25 1.01 2.25 2.25V18c0 1.24-1.01 2.25-2.25 2.25H6c-1.24 0-2.25-1.01-2.25-2.25v-7.5c0-1.24 1.01-2.25 2.25-2.25zM8.25 6c0-1.24 1.01-2.25 2.25-2.25m7.5 12c1.24 0 2.25-1.01 2.25-2.25m0-7.5c0-1.24-1.01-2.25-2.25-2.25m2.25 3.75V12M12 3.75h4.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M12 16.5h15c2.48 0 4.5 2.02 4.5 4.5v15c0 2.48-2.02 4.5-4.5 4.5H12c-2.48 0-4.5-2.02-4.5-4.5V21c0-2.48 2.02-4.5 4.5-4.5zm4.5-4.5c0-2.48 2.02-4.5 4.5-4.5m15 24c2.48 0 4.5-2.02 4.5-4.5m0-15c0-2.48-2.02-4.5-4.5-4.5m4.5 7.5v9M24 7.5h9"
  }))
};
var CopyPaste$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$64,
    fill: "none"
  }));
});
var compPaths$63 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.25 8.5V11"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7 9.25h5.5c1.24 0 2.25 1.01 2.25 2.25V17c0 1.24-1.01 2.25-2.25 2.25H7c-1.24 0-2.25-1.01-2.25-2.25v-5.5c0-1.24 1.01-2.25 2.25-2.25z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 7c0-1.24 1.01-2.25 2.25-2.25m5.5 10c1.24 0 2.25-1.01 2.25-2.25m0-5.5c0-1.24-1.01-2.25-2.25-2.25m-4 0h2.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 8.25h7.5c1.24 0 2.25 1.01 2.25 2.25V18c0 1.24-1.01 2.25-2.25 2.25H6c-1.24 0-2.25-1.01-2.25-2.25v-7.5c0-1.24 1.01-2.25 2.25-2.25z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 6c0-1.24 1.01-2.25 2.25-2.25m7.5 12c1.24 0 2.25-1.01 2.25-2.25m0-7.5c0-1.24-1.01-2.25-2.25-2.25m2.25 3.75V12M12 3.75h4.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M12 16.5h15c2.48 0 4.5 2.02 4.5 4.5v15c0 2.48-2.02 4.5-4.5 4.5H12c-2.48 0-4.5-2.02-4.5-4.5V21c0-2.48 2.02-4.5 4.5-4.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.5 12c0-2.48 2.02-4.5 4.5-4.5m15 24c2.48 0 4.5-2.02 4.5-4.5m0-15c0-2.48-2.02-4.5-4.5-4.5m4.5 7.5v9M24 7.5h9"
  }))
};
var CopyPasteFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$63,
    fill: "none"
  }));
});
var compPaths$62 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.323 5.75h5.486c1.883 0 3.405 1.4 3.405 3.125 0 1.726-1.522 3.125-3.404 3.125M7.322 5.75V12m0-6.25H5.5m1.823 12.5h7.264c1.883 0 3.413-1.4 3.413-3.125C18 13.399 16.47 12 14.587 12H7.323m0 6.25V12m0 6.25H5.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.798 3.75h6.912c2.372 0 4.29 1.847 4.29 4.125S16.082 12 13.71 12M6.798 3.75V12m0-8.25H4.5m2.298 16.5h9.152c2.372 0 4.3-1.847 4.3-4.125S18.322 12 15.95 12H6.798m0 8.25V12m0 8.25H4.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M12.595 7.5H26.42c4.743 0 8.58 3.694 8.58 8.25S31.163 24 26.42 24M12.595 7.5V24m0-16.5H8m4.595 33H30.9c4.743 0 8.6-3.694 8.6-8.25S35.643 24 30.9 24H12.595m0 16.5V24m0 16.5H8"
  }))
};
var FormatBold$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$62,
    fill: "none"
  }));
});
var compPaths$61 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M21 4.5H9V6h12V4.5zm-16.5 0H3V6h1.5V4.5zM21 11.25H9v1.5h12v-1.5zm-16.5 0H3v1.5h1.5v-1.5zM21 18H9v1.5h12V18zM4.5 18H3v1.5h1.5V18z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M21 4.5H9V6h12V4.5zm-16.5 0H3V6h1.5V4.5zM21 11.25H9v1.5h12v-1.5zm-16.5 0H3v1.5h1.5v-1.5zM21 18H9v1.5h12V18zM4.5 18H3v1.5h1.5V18z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M42 9H18v3h24V9zM9 9H6v3h3V9zm33 13.5H18v3h24v-3zm-33 0H6v3h3v-3zM42 36H18v3h24v-3zM9 36H6v3h3v-3z"
  }))
};
var FormatBullet$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$61,
    fill: "none"
  }));
});
var compPaths$60 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10.032 5.75h6.06M7 18.25h6.06m-3.35 0l3.352-12.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10 3.75h8M5.998 20.25h8m-4.422 0L14 3.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M20.004 7.5h16M12 40.5h16m-8.844 0l8.848-33"
  }))
};
var FormatItalics$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$60,
    fill: "none"
  }));
});
var compPaths$5$ = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M3.75 20.25H3V21h.75v-.75zm0-1h.75-.75zm1.5-2l.238.712-.237-.712zM5 3.75v.75-.75zM7.5 19.5H3.75V21H7.5v-1.5zm-3-.25c0-.2.1-.481.314-.76.213-.277.473-.461.674-.528l-.474-1.424c-.55.183-1.04.585-1.389 1.038-.348.452-.624 1.046-.624 1.674h1.5zm0 1v-1H3v1h1.5zm1.5-4.5c0 .15-.055.268-.206.397-.173.147-.44.278-.78.392l.474 1.422c.41-.136.891-.341 1.28-.674.412-.351.732-.86.732-1.537H6zM5.25 15a.75.75 0 01.75.75h1.5a2.25 2.25 0 00-2.25-2.25V15zm0-1.5H3V15h2.25v-1.5zm5.25-.75H21v-1.5H10.5v1.5zm0-8.25H21V3H10.5v1.5zm0 16.5H21v-1.5H10.5V21zM4.75 4.25v6.25h1.5V4.25h-1.5zM3 4.5h2V3H3v1.5zm3.25-.25C6.25 3.56 5.69 3 5 3v1.5a.25.25 0 01-.25-.25h1.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M3.75 20.25H3V21h.75v-.75zm0-1h.75-.75zm1.5-2l.238.712-.237-.712zM5 3.75v.75-.75zM7.5 19.5H3.75V21H7.5v-1.5zm-3-.25c0-.2.1-.481.314-.76.213-.277.473-.461.674-.528l-.474-1.424c-.55.183-1.04.585-1.389 1.038-.348.452-.624 1.046-.624 1.674h1.5zm0 1v-1H3v1h1.5zm1.5-4.5c0 .15-.055.268-.206.397-.173.147-.44.278-.78.392l.474 1.422c.41-.136.891-.341 1.28-.674.412-.351.732-.86.732-1.537H6zM5.25 15a.75.75 0 01.75.75h1.5a2.25 2.25 0 00-2.25-2.25V15zm0-1.5H3V15h2.25v-1.5zm5.25-.75H21v-1.5H10.5v1.5zm0-8.25H21V3H10.5v1.5zm0 16.5H21v-1.5H10.5V21zM4.75 4.25v6.25h1.5V4.25h-1.5zM3 4.5h2V3H3v1.5zm3.25-.25C6.25 3.56 5.69 3 5 3v1.5a.25.25 0 01-.25-.25h1.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M7.5 40.5L6 40.499 5.999 42H7.5v-1.5zm.002-2l1.5.001V38.5h-1.5zm3-4l.474 1.423-.474-1.423zM10 7.5V9 7.5zM15.002 39H7.5v3h7.502v-3zm-6-.5c0-.4.197-.962.625-1.519.427-.555.947-.924 1.349-1.058l-.948-2.846c-1.1.366-2.08 1.168-2.778 2.074-.696.904-1.248 2.093-1.248 3.349h3zM9 40.501l.002-2-3-.002-.002 2 3 .002zm3-9.001c0 .302-.11.535-.412.793-.345.296-.882.557-1.561.784l.95 2.846c.818-.273 1.781-.684 2.56-1.349C14.36 33.872 15 32.855 15 31.5h-3zM10.5 30a1.5 1.5 0 011.5 1.5h3a4.5 4.5 0 00-4.5-4.5v3zm0-3H6v3h4.5v-3zM21 25.5h21v-3H21v3zM21 12h21V9H21v3zm0 27h21v-3H21v3zM9.5 8.5V21h3V8.5h-3zM6 9h4V6H6v3zm6.5-.5A2.5 2.5 0 0010 6v3a.5.5 0 01-.5-.5h3z"
  }))
};
var FormatNumberedList$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5$,
    fill: "none"
  }));
});
var compPaths$5_ = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M14.84 11.818h.75-.75zm3.031 1.705v.75-.75zM5 5v6.818h1.5V5H5zm0 6.818v7.068h1.5v-7.068H5zM14.09 5v6.818h1.5V5h-1.5zm0 6.818v7.068h1.5v-7.068h-1.5zm-8.34.75h9.09v-1.5H5.75v1.5zm11.75 1.334v4.984H19v-4.984h-1.5zm-.954.37h1.325v-1.5h-1.326v1.5zm2.454-.37a1.13 1.13 0 00-1.129-1.13v1.5a.371.371 0 01-.371-.37H19z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15.75 12h.75-.75zm4 2.25V15v-.75zM3 3v9h1.5V3H3zm0 9v9h1.5v-9H3zm12-9v9h1.5V3H15zm0 9v9h1.5v-9H15zm-11.25.75h12v-1.5h-12v1.5zm15.75 2V21H21v-6.25h-1.5zM18 15h1.75v-1.5H18V15zm3-.25c0-.69-.56-1.25-1.25-1.25V15a.25.25 0 01-.25-.25H21z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M31.5 24H33h-1.5zm8 4.5V30v-1.5zM6 6v18h3V6H6zm0 18v18h3V24H6zM30 6v18h3V6h-3zm0 18v18h3V24h-3zM7.5 25.5h24v-3h-24v3zm31.5 4V42h3V29.5h-3zm-3 .5h3.5v-3H36v3zm6-.5a2.5 2.5 0 00-2.5-2.5v3a.5.5 0 01-.5-.5h3z"
  }))
};
var Heading$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5_,
    fill: "none"
  }));
});
var compPaths$5Z = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M9 9.75H7.5v1.5H9v-1.5zm7.5 3h-9v1.5h9v-1.5zm-5-3H10v1.5h1.5v-1.5zm2.5 0h-1.5v1.5H14v-1.5zm2.5 0H15v1.5h1.5v-1.5z"
  }), /* @__PURE__ */ React__default.createElement("rect", {
    width: "14.5",
    height: "10.5",
    x: "4.75",
    y: "6.75",
    stroke: "currentColor",
    strokeWidth: "1.5",
    rx: "2.25"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("rect", {
    width: "19.5",
    height: "13.5",
    x: "2.25",
    y: "5.25",
    stroke: "currentColor",
    strokeWidth: "1.5",
    rx: "3.25"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.75 9.75h1.5m-1.5 4h1.5m1.75 0h8m-8-4h1.5m1.75 0h1.5m1.75 0H16m1.75 0h1.5m-1.5 4h1.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("rect", {
    width: "39",
    height: "27",
    x: "4.5",
    y: "10.5",
    stroke: "currentColor",
    strokeWidth: "3",
    rx: "6.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M9.5 19.5h3m-3 8h3m3.5 0h16m-16-8h3m3.5 0h3m3.5 0h3m3.5 0h3m-3 8h3"
  }))
};
var Keyboard$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5Z,
    fill: "none"
  }));
});
var compPaths$5Y = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M18.22 7.858l.532.53.528-.53-.528-.53-.531.53zm-7.29.001v.75-.75zm-5.18 5.196h.75-.75zm5.18 5.195v-.75.75zm4.972-7.005l2.85-2.858-1.062-1.059-2.85 2.857 1.062 1.06zm2.85-3.917l-2.85-2.858-1.062 1.06 2.85 2.857 1.062-1.059zm-.532-.22l-7.29.001v1.5l7.29-.001v-1.5zM5 13.055C5 16.336 7.653 19 10.93 19v-1.5a4.438 4.438 0 01-4.43-4.445H5zm5.93-5.946C7.653 7.11 5 9.773 5 13.055h1.5a4.438 4.438 0 014.43-4.446v-1.5zM17.837 17.5H10.93V19h6.907v-1.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M20 6.748l.53.53.53-.53-.53-.53-.53.53zm-9.5.002v.75-.75zM3.75 13.5h.75-.75zm6.75 6.75v-.75.75zm6.317-9.26l3.713-3.71-1.06-1.061-3.713 3.712 1.06 1.06zm3.713-4.772l-3.713-3.713-1.06 1.06 3.713 3.713 1.06-1.06zm-.53-.22L10.5 6v1.5l9.5-.002v-1.5zM3 13.5a7.5 7.5 0 007.5 7.5v-1.5a6 6 0 01-6-6H3zM10.5 6A7.5 7.5 0 003 13.5h1.5a6 6 0 016-6V6zm9 13.5h-9V21h9v-1.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M39.833 13.637l1.062 1.06 1.056-1.06-1.056-1.059-1.062 1.06zm-18.845.004v1.5-1.5zm-13.39 13.43h1.5-1.5zM20.988 40.5V39v1.5zm12.541-18.418l7.366-7.386-2.124-2.118-7.366 7.385 2.124 2.119zm7.366-9.504L33.53 5.191l-2.125 2.118 7.366 7.387 2.124-2.118zm-1.062-.44l-18.846.003.001 3 18.845-.004v-3zM6.098 27.07c0 8.24 6.662 14.93 14.89 14.93v-3c-6.563 0-11.89-5.337-11.89-11.93h-3zm14.89-14.93c-8.228 0-14.89 6.688-14.89 14.93h3c0-6.593 5.327-11.93 11.89-11.93v-3zM38.84 39H20.988v3H38.84v-3z"
  }))
};
var Redo$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5Y,
    fill: "none"
  }));
});
var compPaths$5X = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.773 7.457V5.75H17.25v1.707M8.981 18.25h6.06m-3.03 0V5.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.25 6.004V3.75h13.5v2.254M8 20.25h8m-4 0V3.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M10.5 12.008V7.5h27v4.508M16 40.5h16m-8 0v-33"
  }))
};
var Text$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5X,
    fill: "none"
  }));
});
var compPaths$5W = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M5.75 7.856l-.53-.53-.53.53.53.53.53-.53zm7.308.002v.75-.75zm5.192 5.192h-.75.75zm-5.192 5.192v-.75.75zm-3.922-8.06L6.28 7.325l-1.06 1.06 2.856 2.856 1.06-1.06zM6.28 8.385L9.136 5.53l-1.06-1.06L5.22 7.326l1.06 1.06zm-.53.22l7.307.002v-1.5L5.75 7.106v1.5zM17.5 13.05a4.442 4.442 0 01-4.442 4.442v1.5A5.942 5.942 0 0019 13.05h-1.5zm-4.442-4.442A4.442 4.442 0 0117.5 13.05H19a5.942 5.942 0 00-5.942-5.942v1.5zM6.135 18.992h6.923v-1.5H6.135v1.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M4 6.748l-.53-.53-.53.53.53.53.53-.53zm9.5.002v.75-.75zm6.75 6.75h-.75.75zm-6.75 6.75v-.75.75zM8.243 9.93L4.53 6.218l-1.06 1.06 3.713 3.713 1.06-1.061zM4.53 7.278l3.713-3.713-1.06-1.06L3.47 6.218l1.06 1.06zm-.53.22l9.5.002V6L4 5.998v1.5zM19.5 13.5a6 6 0 01-6 6V21a7.5 7.5 0 007.5-7.5h-1.5zm-6-6a6 6 0 016 6H21A7.5 7.5 0 0013.5 6v1.5zM4.5 21h9v-1.5h-9V21z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15.465 21.022L8.1 13.637m0 0l7.365-7.387M8.1 13.637l18.845.004c7.395 0 13.39 6.013 13.39 13.43 0 7.416-5.995 13.429-13.39 13.429H9.09"
  }))
};
var Undo$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5W,
    fill: "none"
  }));
});
var compPaths$5V = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.5 12.809l-.007.106a3.75 3.75 0 01-.303 1.287 3.093 3.093 0 01-1.741 1.669 3.6 3.6 0 01-1.308.232 3.723 3.723 0 01-1.578-.325 3.52 3.52 0 01-1.185-.887 3.966 3.966 0 01-.741-1.307A4.835 4.835 0 0112.381 12c0-.552.086-1.082.256-1.574.17-.493.419-.933.74-1.306a3.557 3.557 0 011.185-.892c.463-.22.995-.331 1.579-.331.434 0 .851.061 1.237.181.393.123.739.301 1.033.531.297.23.542.516.727.848.184.331.3.715.344 1.141l.012.11h-1.526l-.02-.075a2.618 2.618 0 00-.226-.587 1.573 1.573 0 00-.364-.453 1.61 1.61 0 00-.519-.298 2.112 2.112 0 00-.698-.106c-.388 0-.727.078-1.007.233a1.995 1.995 0 00-.688.627 2.87 2.87 0 00-.397.905 4.224 4.224 0 000 2.091c.085.336.219.64.397.905.175.26.407.471.688.627.28.155.619.233 1.007.233.283 0 .536-.048.751-.146.213-.097.401-.233.554-.403.155-.171.278-.375.366-.606.089-.232.149-.486.176-.756l.009-.09H19.5zm-9.384 0h1.503l-.007.106c-.03.469-.132.902-.302 1.287a3.093 3.093 0 01-1.742 1.669 3.6 3.6 0 01-1.308.232 3.723 3.723 0 01-1.578-.325 3.52 3.52 0 01-1.185-.887 3.966 3.966 0 01-.741-1.307A4.835 4.835 0 014.5 12c0-.552.086-1.082.256-1.574.17-.493.419-.933.74-1.306a3.557 3.557 0 011.185-.892c.464-.22.995-.331 1.579-.331.435 0 .852.061 1.238.181.392.123.739.301 1.032.531.297.23.542.516.727.848.184.331.3.715.345 1.141l.011.11h-1.526l-.02-.075a2.618 2.618 0 00-.226-.587 1.615 1.615 0 00-.362-.453 1.632 1.632 0 00-.52-.298c-.2-.07-.435-.106-.699-.106-.388 0-.727.078-1.006.233a1.988 1.988 0 00-.689.627 2.879 2.879 0 00-.397.905 4.224 4.224 0 000 2.091c.086.338.22.643.397.905.175.26.408.471.689.627.279.155.618.233 1.006.233.283 0 .536-.048.751-.146.214-.096.4-.232.554-.403.157-.173.28-.377.366-.605.09-.233.149-.487.176-.757l.009-.09z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.5 18.75h-15a2.25 2.25 0 01-2.25-2.25v-9A2.25 2.25 0 014.5 5.25h15a2.25 2.25 0 012.25 2.25v9a2.25 2.25 0 01-2.25 2.25z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.5 12.809l-.007.106a3.75 3.75 0 01-.303 1.287 3.093 3.093 0 01-1.741 1.669 3.6 3.6 0 01-1.308.232 3.723 3.723 0 01-1.578-.325 3.52 3.52 0 01-1.185-.887 3.966 3.966 0 01-.741-1.307A4.835 4.835 0 0112.381 12c0-.552.086-1.082.256-1.574.17-.493.419-.933.74-1.306a3.557 3.557 0 011.185-.892c.463-.22.995-.331 1.579-.331.434 0 .851.061 1.237.181.393.123.739.301 1.033.531.297.23.542.516.727.848.184.331.3.715.344 1.141l.012.11h-1.526l-.02-.075a2.618 2.618 0 00-.226-.587 1.573 1.573 0 00-.364-.453 1.61 1.61 0 00-.519-.298 2.112 2.112 0 00-.698-.106c-.388 0-.727.078-1.007.233a1.995 1.995 0 00-.688.627 2.87 2.87 0 00-.397.905 4.224 4.224 0 000 2.091c.085.336.219.64.397.905.175.26.407.471.688.627.28.155.619.233 1.007.233.283 0 .536-.048.751-.146.213-.097.401-.233.554-.403.155-.171.278-.375.366-.606.089-.232.149-.486.176-.756l.009-.09H19.5zm-9.384 0h1.503l-.007.106c-.03.469-.132.902-.302 1.287a3.093 3.093 0 01-1.742 1.669 3.6 3.6 0 01-1.308.232 3.723 3.723 0 01-1.578-.325 3.52 3.52 0 01-1.185-.887 3.966 3.966 0 01-.741-1.307A4.835 4.835 0 014.5 12c0-.552.086-1.082.256-1.574.17-.493.419-.933.74-1.306a3.557 3.557 0 011.185-.892c.464-.22.995-.331 1.579-.331.435 0 .852.061 1.238.181.392.123.739.301 1.032.531.297.23.542.516.727.848.184.331.3.715.345 1.141l.011.11h-1.526l-.02-.075a2.618 2.618 0 00-.226-.587 1.615 1.615 0 00-.362-.453 1.632 1.632 0 00-.52-.298c-.2-.07-.435-.106-.699-.106-.388 0-.727.078-1.006.233a1.988 1.988 0 00-.689.627 2.879 2.879 0 00-.397.905 4.224 4.224 0 000 2.091c.086.338.22.643.397.905.175.26.408.471.689.627.279.155.618.233 1.006.233.283 0 .536-.048.751-.146.214-.096.4-.232.554-.403.157-.173.28-.377.366-.605.09-.233.149-.487.176-.757l.009-.09z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.5 18.75h-15a2.25 2.25 0 01-2.25-2.25v-9A2.25 2.25 0 014.5 5.25h15a2.25 2.25 0 012.25 2.25v9a2.25 2.25 0 01-2.25 2.25z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M39 25.618l-.014.212c-.06.938-.264 1.804-.606 2.574a6.304 6.304 0 01-1.404 2.022 6.186 6.186 0 01-2.078 1.316c-.792.308-1.674.464-2.616.464-1.162 0-2.226-.218-3.156-.65a7.04 7.04 0 01-2.37-1.774 7.932 7.932 0 01-1.482-2.614A9.67 9.67 0 0124.762 24a9.62 9.62 0 01.512-3.148 7.954 7.954 0 011.48-2.612 7.114 7.114 0 012.37-1.784c.926-.44 1.99-.662 3.158-.662.868 0 1.702.122 2.474.362a6.453 6.453 0 012.066 1.062 5.55 5.55 0 011.454 1.696c.368.662.6 1.43.688 2.282l.024.22h-3.052l-.04-.15a5.236 5.236 0 00-.452-1.174 3.147 3.147 0 00-.728-.906 3.222 3.222 0 00-1.038-.596c-.398-.14-.868-.212-1.396-.212-.776 0-1.454.156-2.014.466a3.99 3.99 0 00-1.376 1.254 5.742 5.742 0 00-.794 1.81 8.447 8.447 0 000 4.182c.17.672.438 1.28.794 1.81.35.52.814.942 1.376 1.254.56.31 1.238.466 2.014.466.566 0 1.072-.096 1.502-.292a3.352 3.352 0 001.108-.806c.31-.342.556-.75.732-1.212.178-.464.298-.972.352-1.512l.018-.18H39zm-18.768 0h3.006l-.014.212a7.545 7.545 0 01-.604 2.574 6.373 6.373 0 01-1.406 2.022 6.186 6.186 0 01-2.078 1.316c-.792.308-1.674.464-2.616.464-1.162 0-2.226-.218-3.156-.65a7.04 7.04 0 01-2.37-1.774 7.932 7.932 0 01-1.482-2.614A9.67 9.67 0 019 24a9.62 9.62 0 01.512-3.148 7.954 7.954 0 011.48-2.612 7.114 7.114 0 012.37-1.784c.928-.44 1.99-.662 3.158-.662.87 0 1.704.122 2.476.362a6.443 6.443 0 012.064 1.062 5.55 5.55 0 011.454 1.696c.368.662.6 1.43.69 2.282l.022.22h-3.052l-.04-.15a5.236 5.236 0 00-.452-1.174 3.23 3.23 0 00-.724-.906 3.265 3.265 0 00-1.04-.596c-.4-.14-.87-.212-1.398-.212-.776 0-1.454.156-2.012.466a3.977 3.977 0 00-1.378 1.254 5.757 5.757 0 00-.794 1.81 8.447 8.447 0 000 4.182c.172.676.44 1.286.794 1.81.35.52.816.942 1.378 1.254.558.31 1.236.466 2.012.466.566 0 1.072-.096 1.502-.292.428-.192.8-.464 1.108-.806a3.77 3.77 0 00.732-1.21c.18-.466.298-.974.352-1.514l.018-.18z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M39 37.5H9A4.5 4.5 0 014.5 33V15A4.5 4.5 0 019 10.5h30a4.5 4.5 0 014.5 4.5v18a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }))
};
var ClosedCaption$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5V,
    fill: "none"
  }));
});
var compPaths$5U = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.493 12.915c-.03.469-.132.902-.303 1.288a3.179 3.179 0 01-.702 1.01 3.124 3.124 0 01-1.039.659 3.622 3.622 0 01-1.309.232 3.73 3.73 0 01-1.578-.326 3.49 3.49 0 01-1.184-.888 3.934 3.934 0 01-.74-1.306A4.841 4.841 0 0112.38 12a4.8 4.8 0 01.256-1.572 3.95 3.95 0 01.74-1.306 3.54 3.54 0 011.184-.892c.464-.22.995-.332 1.58-.332.434 0 .851.06 1.237.182.392.122.74.3 1.033.53.297.23.542.517.727.849.184.33.3.713.344 1.14l.012.11h-1.526l-.02-.075a2.695 2.695 0 00-.226-.587 1.6 1.6 0 00-.883-.75 2.091 2.091 0 00-.699-.107c-.387 0-.726.079-1.006.234a1.986 1.986 0 00-.688.627c-.18.263-.312.568-.397.904a4.216 4.216 0 000 2.091c.085.337.218.64.397.905.175.26.406.47.688.628.28.154.62.232 1.006.232.284 0 .537-.049.751-.146.214-.096.402-.232.555-.403.154-.171.277-.374.365-.605.09-.232.15-.488.177-.758l.01-.088H19.5l-.007.105zm-7.88 0c-.03.469-.133.902-.304 1.288a3.179 3.179 0 01-.702 1.01 3.124 3.124 0 01-1.039.659 3.62 3.62 0 01-1.308.232 3.73 3.73 0 01-1.579-.326 3.5 3.5 0 01-1.184-.888 3.951 3.951 0 01-.74-1.306A4.841 4.841 0 014.5 12a4.8 4.8 0 01.256-1.572c.17-.494.42-.933.74-1.306A3.55 3.55 0 016.68 8.23c.464-.22.996-.332 1.58-.332.435 0 .852.06 1.238.182a3.25 3.25 0 011.032.53c.297.23.542.517.727.849.184.33.3.713.344 1.14l.012.11h-1.526l-.02-.075a2.645 2.645 0 00-.226-.587 1.615 1.615 0 00-.363-.453 1.633 1.633 0 00-.519-.297 2.096 2.096 0 00-.699-.107c-.388 0-.727.079-1.006.234a1.97 1.97 0 00-.689.627 2.879 2.879 0 00-.397.904 4.216 4.216 0 000 2.091c.086.338.22.643.397.905.175.26.407.47.69.628.278.154.617.232 1.005.232.283 0 .536-.049.751-.146.213-.096.4-.232.554-.403.157-.173.28-.377.365-.605.09-.232.15-.488.177-.758l.01-.088h1.502l-.007.105zM19.5 4.5h-15c-1.654 0-3 1.346-3 3v9c0 1.654 1.346 3 3 3h15c1.654 0 3-1.346 3-3v-9c0-1.654-1.346-3-3-3z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.493 12.915c-.03.469-.132.902-.303 1.288a3.179 3.179 0 01-.702 1.01 3.124 3.124 0 01-1.039.659 3.622 3.622 0 01-1.309.232 3.73 3.73 0 01-1.578-.326 3.49 3.49 0 01-1.184-.888 3.934 3.934 0 01-.74-1.306A4.841 4.841 0 0112.38 12a4.8 4.8 0 01.256-1.572 3.95 3.95 0 01.74-1.306 3.54 3.54 0 011.184-.892c.464-.22.995-.332 1.58-.332.434 0 .851.06 1.237.182.392.122.74.3 1.033.53.297.23.542.517.727.849.184.33.3.713.344 1.14l.012.11h-1.526l-.02-.075a2.695 2.695 0 00-.226-.587 1.6 1.6 0 00-.883-.75 2.091 2.091 0 00-.699-.107c-.387 0-.726.079-1.006.234a1.986 1.986 0 00-.688.627c-.18.263-.312.568-.397.904a4.216 4.216 0 000 2.091c.085.337.218.64.397.905.175.26.406.47.688.628.28.154.62.232 1.006.232.284 0 .537-.049.751-.146.214-.096.402-.232.555-.403.154-.171.277-.374.365-.605.09-.232.15-.488.177-.758l.01-.088H19.5l-.007.105zm-7.88 0c-.03.469-.133.902-.304 1.288a3.179 3.179 0 01-.702 1.01 3.124 3.124 0 01-1.039.659 3.62 3.62 0 01-1.308.232 3.73 3.73 0 01-1.579-.326 3.5 3.5 0 01-1.184-.888 3.951 3.951 0 01-.74-1.306A4.841 4.841 0 014.5 12a4.8 4.8 0 01.256-1.572c.17-.494.42-.933.74-1.306A3.55 3.55 0 016.68 8.23c.464-.22.996-.332 1.58-.332.435 0 .852.06 1.238.182a3.25 3.25 0 011.032.53c.297.23.542.517.727.849.184.33.3.713.344 1.14l.012.11h-1.526l-.02-.075a2.645 2.645 0 00-.226-.587 1.615 1.615 0 00-.363-.453 1.633 1.633 0 00-.519-.297 2.096 2.096 0 00-.699-.107c-.388 0-.727.079-1.006.234a1.97 1.97 0 00-.689.627 2.879 2.879 0 00-.397.904 4.216 4.216 0 000 2.091c.086.338.22.643.397.905.175.26.407.47.69.628.278.154.617.232 1.005.232.283 0 .536-.049.751-.146.213-.096.4-.232.554-.403.157-.173.28-.377.365-.605.09-.232.15-.488.177-.758l.01-.088h1.502l-.007.105zM19.5 4.5h-15c-1.654 0-3 1.346-3 3v9c0 1.654 1.346 3 3 3h15c1.654 0 3-1.346 3-3v-9c0-1.654-1.346-3-3-3z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M38.986 25.831a7.522 7.522 0 01-.606 2.574 6.358 6.358 0 01-1.404 2.022 6.249 6.249 0 01-2.078 1.316 7.244 7.244 0 01-2.618.464c-1.162 0-2.224-.22-3.156-.652a6.98 6.98 0 01-2.368-1.774 7.868 7.868 0 01-1.482-2.612 9.682 9.682 0 01-.512-3.17c0-1.104.172-2.164.512-3.146a7.898 7.898 0 011.48-2.612 7.08 7.08 0 012.368-1.784c.928-.44 1.99-.664 3.158-.664.87 0 1.704.122 2.476.364a6.47 6.47 0 012.066 1.06 5.58 5.58 0 011.454 1.698c.368.662.6 1.428.688 2.282l.024.22h-3.052l-.04-.15a5.39 5.39 0 00-.452-1.176 3.181 3.181 0 00-1.766-1.5c-.4-.142-.868-.214-1.398-.214-.774 0-1.452.158-2.012.468a3.972 3.972 0 00-1.376 1.254 5.658 5.658 0 00-.794 1.81 8.431 8.431 0 000 4.182c.17.672.436 1.28.794 1.81.35.518.812.94 1.376 1.254.56.308 1.238.466 2.012.466.568 0 1.074-.098 1.502-.292a3.318 3.318 0 001.11-.808c.308-.342.554-.748.73-1.21.18-.464.3-.974.354-1.514l.018-.178H39l-.014.212zm-15.762 0a7.522 7.522 0 01-.606 2.574 6.358 6.358 0 01-1.404 2.022 6.249 6.249 0 01-2.078 1.316 7.241 7.241 0 01-2.616.464c-1.162 0-2.226-.22-3.158-.652a7 7 0 01-2.368-1.774 7.903 7.903 0 01-1.482-2.612A9.682 9.682 0 019 23.999c0-1.104.172-2.164.512-3.146a7.933 7.933 0 011.48-2.612 7.1 7.1 0 012.368-1.784c.928-.44 1.992-.664 3.16-.664.87 0 1.704.122 2.476.364a6.5 6.5 0 012.064 1.06 5.58 5.58 0 011.454 1.698c.368.662.598 1.428.688 2.282l.024.22h-3.052l-.04-.15a5.29 5.29 0 00-.452-1.176 3.23 3.23 0 00-.726-.906 3.266 3.266 0 00-1.038-.594c-.4-.142-.87-.214-1.398-.214-.776 0-1.454.158-2.012.468a3.94 3.94 0 00-1.378 1.254 5.757 5.757 0 00-.794 1.81 8.431 8.431 0 000 4.182c.172.676.44 1.284.794 1.81.35.52.814.94 1.378 1.254.558.308 1.236.466 2.012.466.566 0 1.072-.098 1.502-.292.426-.194.8-.464 1.108-.808.314-.346.56-.752.73-1.21.18-.464.3-.974.354-1.514l.018-.178h3.006l-.014.212zM39 8.999H9c-3.308 0-6 2.692-6 6v18c0 3.31 2.692 6 6 6h30c3.308 0 6-2.69 6-6v-18c0-3.308-2.692-6-6-6z",
    clipRule: "evenodd"
  }))
};
var ClosedCaptionFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5U,
    fill: "none"
  }));
});
var compPaths$5T = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.01 12V7.242a.75.75 0 011.126-.65l8.239 4.757a.75.75 0 010 1.3l-8.24 4.757a.75.75 0 01-1.125-.65v-1.828"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.644 11.365a.732.732 0 010 1.268l-8.268 4.773a.75.75 0 01-1.126-.65v-1.76"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 15.172v-7.93a.751.751 0 011.126-.65l6.632 3.83"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.01 12V7.242a.75.75 0 011.126-.65l8.239 4.757a.75.75 0 010 1.3l-8.24 4.757a.75.75 0 01-1.125-.65v-1.828"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.644 11.365a.732.732 0 010 1.268l-8.268 4.773a.75.75 0 01-1.126-.65v-1.76"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 15.172v-7.93a.751.751 0 011.126-.65l6.632 3.83"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24.02 24v-9.516c0-1.156 1.25-1.876 2.252-1.3l16.478 9.514c1 .578 1 2.022 0 2.6l-16.478 9.514a1.5 1.5 0 01-2.252-1.3v-3.656"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M23.287 22.73a1.464 1.464 0 010 2.537L6.751 34.813a1.501 1.501 0 01-2.252-1.3v-3.52"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M4.5 30.344v-15.86c0-1.156 1.252-1.876 2.252-1.3l13.264 7.658"
  }))
};
var FastForward$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5T,
    fill: "none"
  }));
});
var compPaths$5S = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.259 14.926V7.39a.75.75 0 011.125-.65l7.98 4.609a.75.75 0 010 1.299l-7.98 4.608a.75.75 0 01-1.125-.65v-1.751",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.259 14.926V7.39a.75.75 0 011.125-.65l7.98 4.609a.75.75 0 010 1.299l-7.98 4.608a.75.75 0 01-1.125-.65v-1.751"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.268 14.923V7.397a.75.75 0 011.125-.65l7.973 4.603a.75.75 0 010 1.299L3.393 17.25a.75.75 0 01-1.125-.65v-1.748",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.268 14.923V7.397a.75.75 0 011.125-.65l7.973 4.603a.75.75 0 010 1.299L3.393 17.25a.75.75 0 01-1.125-.65v-1.748"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.259 14.926V7.39a.75.75 0 011.125-.65l7.98 4.609a.75.75 0 010 1.299l-7.98 4.608a.75.75 0 01-1.125-.65v-1.751",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.259 14.926V7.39a.75.75 0 011.125-.65l7.98 4.609a.75.75 0 010 1.299l-7.98 4.608a.75.75 0 01-1.125-.65v-1.751"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.268 14.923V7.397a.75.75 0 011.125-.65l7.973 4.603a.75.75 0 010 1.299L3.393 17.25a.75.75 0 01-1.125-.65v-1.748",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.268 14.923V7.397a.75.75 0 011.125-.65l7.973 4.603a.75.75 0 010 1.299L3.393 17.25a.75.75 0 01-1.125-.65v-1.748"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M43.48 21.4l-15.962-9.216a2.967 2.967 0 00-2.998-.002 2.966 2.966 0 00-1.502 2.598v6.352L7.534 12.194a2.98 2.98 0 00-3-.002 2.978 2.978 0 00-1.5 2.6v18.41c0 1.086.562 2.058 1.5 2.6.472.27.986.406 1.5.406a2.98 2.98 0 001.5-.408l15.484-8.94v6.354c0 1.086.56 2.058 1.5 2.6.468.27.984.406 1.5.406a2.99 2.99 0 001.5-.408l15.96-9.216a2.964 2.964 0 001.502-2.594c0-1.086-.56-2.06-1.5-2.602z",
    clipRule: "evenodd"
  }))
};
var FastForwardFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5S,
    fill: "none"
  }));
});
var compPaths$5R = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 18V6m10.5 10.5V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 8.25H8.25v-3a1.5 1.5 0 011.5-1.5h7.5a1.5 1.5 0 011.5 1.5v3zM8.25 18a2.25 2.25 0 11-4.502-.002A2.25 2.25 0 018.25 18zm10.5-1.5a2.25 2.25 0 11-4.502-.002 2.25 2.25 0 014.502.002z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 18V6m10.5 10.5V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 8.25H8.25v-3a1.5 1.5 0 011.5-1.5h7.5a1.5 1.5 0 011.5 1.5v3zM8.25 18a2.25 2.25 0 11-4.502-.002A2.25 2.25 0 018.25 18zm10.5-1.5a2.25 2.25 0 11-4.502-.002 2.25 2.25 0 014.502.002z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.5 36V12m21 21V12"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M37.5 16.5h-21v-6c0-1.656 1.344-3 3-3h15c1.656 0 3 1.344 3 3v6zM16.5 36c0 2.484-2.016 4.5-4.5 4.5A4.502 4.502 0 017.5 36c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5zm21-3c0 2.484-2.016 4.5-4.5 4.5a4.502 4.502 0 01-4.5-4.5c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5z",
    clipRule: "evenodd"
  }))
};
var Music$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5R,
    fill: "none"
  }));
});
var compPaths$5Q = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.25 3h-7.5C8.51 3 7.5 4.01 7.5 5.25v10.167A2.968 2.968 0 006 15c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3V9h9v4.917a2.968 2.968 0 00-1.5-.417c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3V5.25C19.5 4.01 18.49 3 17.25 3z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.25 3h-7.5C8.51 3 7.5 4.01 7.5 5.25v10.167A2.968 2.968 0 006 15c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3V9h9v4.917a2.968 2.968 0 00-1.5-.417c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3V5.25C19.5 4.01 18.49 3 17.25 3z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M34.5 6h-15C17.02 6 15 8.02 15 10.5v20.334c-.886-.516-1.902-.834-3-.834-3.308 0-6 2.692-6 6s2.692 6 6 6 6-2.692 6-6V18h18v9.834c-.886-.516-1.902-.834-3-.834-3.308 0-6 2.692-6 6s2.692 6 6 6 6-2.692 6-6V10.5C39 8.02 36.98 6 34.5 6z",
    clipRule: "evenodd"
  }))
};
var MusicFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5Q,
    fill: "none"
  }));
});
var compPaths$5P = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.5 18a1.498 1.498 0 01-.814-2.756l2.07 2.07c-.267.412-.73.686-1.256.686zM6 19.5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5zm16.5.437l-3.04-3.041-3.356-3.356h-.001L11.563 9l-1.5-1.5L9 6.437 7.529 4.965v.001L5.561 2.998 4.5 4.06l3 3v8.358A2.968 2.968 0 006 15c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3V8.559l5.62 5.619A2.967 2.967 0 0013.5 16.5c0 1.654 1.346 3 3 3 .941 0 1.776-.438 2.322-1.119l2.618 2.617 1.06-1.061zM9.75 4.5h7.5a.75.75 0 01.75.75V7.5h-5.815l1.5 1.5H18v4.315l1.5 1.5V5.25C19.5 4.01 18.491 3 17.25 3h-7.5c-.573 0-1.091.222-1.489.576l1.069 1.07a.73.73 0 01.42-.146z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.5 18a1.498 1.498 0 01-.814-2.756l2.07 2.07c-.267.412-.73.686-1.256.686zM6 19.5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5zm16.5.437l-3.04-3.041-3.356-3.356h-.001L11.563 9l-1.5-1.5L9 6.437 7.529 4.965v.001L5.561 2.998 4.5 4.06l3 3v8.358A2.968 2.968 0 006 15c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3V8.559l5.62 5.619A2.967 2.967 0 0013.5 16.5c0 1.654 1.346 3 3 3 .941 0 1.776-.438 2.322-1.119l2.618 2.617 1.06-1.061zM9.75 4.5h7.5a.75.75 0 01.75.75V7.5h-5.815l1.5 1.5H18v4.315l1.5 1.5V5.25C19.5 4.01 18.491 3 17.25 3h-7.5c-.573 0-1.091.222-1.489.576l1.069 1.07a.73.73 0 01.42-.146z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M33 36c-1.654 0-3-1.346-3-3 0-1.052.548-1.976 1.372-2.512l4.14 4.14A2.993 2.993 0 0133 36zm-21 3c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm33 .874l-6.08-6.082-6.712-6.712h-.002L23.126 18l-3-3L18 12.874 15.058 9.93v.002l-3.936-3.936L9 8.118l6 6v16.716c-.886-.516-1.902-.834-3-.834-3.308 0-6 2.692-6 6s2.692 6 6 6 6-2.692 6-6V17.118l11.24 11.238A5.934 5.934 0 0027 33c0 3.308 2.692 6 6 6a5.935 5.935 0 004.644-2.238l5.236 5.234L45 39.874zM19.5 9h15c.828 0 1.5.674 1.5 1.5V15H24.37l3 3H36v8.63l3 3V10.5C39 8.02 36.982 6 34.5 6h-15a4.467 4.467 0 00-2.978 1.152l2.138 2.14c.244-.17.522-.292.84-.292z",
    clipRule: "evenodd"
  }))
};
var MusicNone$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5P,
    fill: "none"
  }));
});
var compPaths$5O = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 9v4.315l1.5 1.5V5.25C19.5 4.01 18.491 3 17.25 3h-7.5c-.574 0-1.096.218-1.492.574L13.685 9H18zm1.46 7.896l-3.356-3.356h-.001L11.563 9h.001L7.529 4.967 5.561 2.999l-1.06 1.06 2.999 3v8.359A2.968 2.968 0 006 15c-1.654 0-3 1.345-3 3 0 1.653 1.346 3 3 3s3-1.347 3-3V8.558l5.622 5.62A2.984 2.984 0 0013.5 16.5c0 1.654 1.346 3 3 3 .94 0 1.77-.444 2.32-1.122l2.62 2.62 1.061-1.06-3.041-3.041z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 9v4.315l1.5 1.5V5.25C19.5 4.01 18.491 3 17.25 3h-7.5c-.574 0-1.096.218-1.492.574L13.685 9H18zm1.46 7.896l-3.356-3.356h-.001L11.563 9h.001L7.529 4.967 5.561 2.999l-1.06 1.06 2.999 3v8.359A2.968 2.968 0 006 15c-1.654 0-3 1.345-3 3 0 1.653 1.346 3 3 3s3-1.347 3-3V8.558l5.622 5.62A2.984 2.984 0 0013.5 16.5c0 1.654 1.346 3 3 3 .94 0 1.77-.444 2.32-1.122l2.62 2.62 1.061-1.06-3.041-3.041z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M36 18v8.63l3 3V10.5C39 8.02 36.982 6 34.5 6h-15a4.448 4.448 0 00-2.984 1.148L27.37 18H36zm2.92 15.793l-6.712-6.712h-.002l-9.08-9.08h.002l-8.07-8.07-3.936-3.934-2.12 2.12 5.998 6v16.718c-.886-.516-1.902-.834-3-.834-3.308 0-6 2.69-6 6 0 3.308 2.692 6 6 6s6-2.692 6-6V17.117L29.244 28.36C27.886 29.461 27 31.121 27 33.001c0 3.308 2.692 6 6 6 1.88 0 3.54-.888 4.64-2.246l5.24 5.242 2.122-2.122-6.082-6.082z",
    clipRule: "evenodd"
  }))
};
var MusicNoneFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5O,
    fill: "none"
  }));
});
var compPaths$5N = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 15.75h4.5v-7.5h-4.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72m8.775-6.401l5.303 5.303m0-5.303l-5.303 5.303"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 15.75h4.5v-7.5h-4.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72m8.775-6.401l5.303 5.303m0-5.303l-5.303 5.303"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 31.5h9v-15h-9v15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.5 16.5l9.44-9.44c.944-.944 2.56-.274 2.56 1.062v31.756c0 1.336-1.616 2.006-2.56 1.062L16.5 31.5m17.55-12.803l10.607 10.606m-.001-10.606L34.05 29.303"
  }))
};
var Mute$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5N,
    fill: "none"
  }));
});
var compPaths$5M = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.074 2.675A1.5 1.5 0 0012.44 3l-4.5 4.5H3v9h4.94l4.5 4.5a1.497 1.497 0 001.634.325c.562-.233.926-.777.926-1.385V4.06c0-.608-.364-1.152-.926-1.385zm8.784 7.204l-1.06-1.061-2.122 2.122-2.12-2.122-1.06 1.06L18.615 12l-2.12 2.12 1.06 1.062 2.12-2.121 2.121 2.12 1.061-1.06L20.738 12l2.12-2.121z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.074 2.675A1.5 1.5 0 0012.44 3l-4.5 4.5H3v9h4.94l4.5 4.5a1.497 1.497 0 001.634.325c.562-.233.926-.777.926-1.385V4.06c0-.608-.364-1.152-.926-1.385zm8.784 7.204l-1.06-1.061-2.122 2.122-2.12-2.122-1.06 1.06L18.615 12l-2.12 2.12 1.06 1.062 2.12-2.121 2.121 2.12 1.061-1.06L20.738 12l2.12-2.121z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M28.148 5.35a2.998 2.998 0 00-3.27.65l-9 9H6v18h9.879l9 9a2.983 2.983 0 003.27.65A2.992 2.992 0 0030 39.88V8.12a2.993 2.993 0 00-1.853-2.772zm17.569 14.408l-2.122-2.122-4.242 4.244-4.242-4.244-2.12 2.122L37.233 24l-4.242 4.242 2.12 2.122 4.242-4.242 4.242 4.242 2.122-2.122L41.475 24l4.242-4.242z",
    clipRule: "evenodd"
  }))
};
var MuteFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5M,
    fill: "none"
  }));
});
var compPaths$5L = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 20.25v0A2.25 2.25 0 0114.25 18V6a2.25 2.25 0 014.5 0v12a2.25 2.25 0 01-2.25 2.25zm-9 0v0A2.25 2.25 0 015.25 18V6a2.25 2.25 0 014.5 0v12a2.25 2.25 0 01-2.25 2.25z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 20.25v0A2.25 2.25 0 0114.25 18V6a2.25 2.25 0 014.5 0v12a2.25 2.25 0 01-2.25 2.25zm-9 0v0A2.25 2.25 0 015.25 18V6a2.25 2.25 0 014.5 0v12a2.25 2.25 0 01-2.25 2.25z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33 40.5v0a4.502 4.502 0 01-4.5-4.5V12c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5v24c0 2.484-2.016 4.5-4.5 4.5zm-18 0v0a4.502 4.502 0 01-4.5-4.5V12c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5v24c0 2.484-2.016 4.5-4.5 4.5z",
    clipRule: "evenodd"
  }))
};
var Pause$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5L,
    fill: "none"
  }));
});
var compPaths$5K = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.75 20.25a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 20.25v0a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.25 20.25a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 20.25v0a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.75 20.25a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 20.25v0a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.25 20.25a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 20.25v0a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M33 6c-3.308 0-6 2.692-6 6v24c0 3.308 2.692 6 6 6s6-2.692 6-6V12c0-3.308-2.692-6-6-6zM15 6c-3.308 0-6 2.692-6 6v24c0 3.308 2.692 6 6 6s6-2.692 6-6V12c0-3.308-2.692-6-6-6z",
    clipRule: "evenodd"
  }))
};
var PauseFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5K,
    fill: "none"
  }));
});
var compPaths$5J = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 7.5v9.794a1 1 0 001.489.872l9.45-5.292a1 1 0 00-.002-1.746L6.25 4.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.248 5.09V19.5a.75.75 0 001.125.65l13.487-7.787a.75.75 0 000-1.3L6.374 3.278v0l-1.5-.867"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M10.496 10.182v28.816c0 1.154 1.25 1.878 2.25 1.3L39.72 24.724c1-.578 1-2.02 0-2.598L12.748 6.554v-.001l-3-1.732"
  }))
};
var Play$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5J,
    fill: "none"
  }));
});
var compPaths$5I = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.692 12.872a1 1 0 000-1.745L8.239 5.834a1 1 0 00-1.489.872v10.588a1 1 0 001.489.872l9.453-5.294z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.314 11.35L6.367 3.877a.75.75 0 00-1.125.65v14.949a.75.75 0 001.125.649l12.947-7.474a.75.75 0 000-1.3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.314 11.35L6.367 3.877a.75.75 0 00-1.125.65v14.949a.75.75 0 001.125.649l12.947-7.474a.75.75 0 000-1.3z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M39.377 21.402L13.485 6.452a2.98 2.98 0 00-3-.002 2.971 2.971 0 00-1.5 2.6v29.898c0 1.086.56 2.058 1.5 2.6.47.27.984.406 1.5.406s1.03-.136 1.5-.408l25.892-14.948A2.964 2.964 0 0040.88 24c0-1.086-.56-2.056-1.502-2.598z",
    clipRule: "evenodd"
  }))
};
var PlayFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5I,
    fill: "none"
  }));
});
var compPaths$5H = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.99 12V7.242a.75.75 0 00-1.126-.65L2.625 11.35a.75.75 0 000 1.3l8.239 4.757a.75.75 0 001.126-.65v-1.828"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.356 11.365a.732.732 0 000 1.268l8.268 4.773a.75.75 0 001.126-.65v-1.76"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 15.172v-7.93a.751.751 0 00-1.126-.65l-6.632 3.83"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.99 12V7.242a.75.75 0 00-1.126-.65L2.625 11.35a.75.75 0 000 1.3l8.239 4.757a.75.75 0 001.126-.65v-1.828"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.356 11.365a.732.732 0 000 1.268l8.268 4.773a.75.75 0 001.126-.65v-1.76"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 15.172v-7.93a.751.751 0 00-1.126-.65l-6.632 3.83"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M23.98 24v-9.516c0-1.156-1.25-1.876-2.252-1.3L5.25 22.698c-1 .578-1 2.022 0 2.6l16.479 9.514a1.5 1.5 0 002.252-1.3v-3.656"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24.713 22.73a1.464 1.464 0 000 2.537l16.536 9.546c1 .578 2.252-.145 2.252-1.3v-3.52"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 30.344v-15.86c0-1.156-1.252-1.876-2.252-1.3l-13.264 7.658"
  }))
};
var Rewind$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5H,
    fill: "none"
  }));
});
var compPaths$5G = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.625 6.741L2.643 11.35a.75.75 0 000 1.3l7.982 4.608a.75.75 0 001.125-.65V7.39a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10.625 6.741L2.643 11.35a.75.75 0 000 1.3l7.982 4.608a.75.75 0 001.125-.65V7.39a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.615 6.747l-7.972 4.603a.75.75 0 000 1.298l7.972 4.603a.75.75 0 001.125-.65V7.396a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.615 6.747l-7.972 4.603a.75.75 0 000 1.298l7.972 4.603a.75.75 0 001.125-.65V7.396a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.625 6.741L2.643 11.35a.75.75 0 000 1.3l7.982 4.608a.75.75 0 001.125-.65V7.39a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10.625 6.741L2.643 11.35a.75.75 0 000 1.3l7.982 4.608a.75.75 0 001.125-.65V7.39a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.615 6.747l-7.972 4.603a.75.75 0 000 1.298l7.972 4.603a.75.75 0 001.125-.65V7.396a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.615 6.747l-7.972 4.603a.75.75 0 000 1.298l7.972 4.603a.75.75 0 001.125-.65V7.396a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M43.48 12.193a2.97 2.97 0 00-3 .002L25 21.133v-6.352a2.976 2.976 0 00-1.502-2.6 2.977 2.977 0 00-2.998.002L4.534 21.401a2.973 2.973 0 00-1.5 2.6c0 1.084.564 2.054 1.5 2.594L20.5 35.813c.468.27.984.408 1.502.408.514 0 1.028-.138 1.498-.406a2.975 2.975 0 001.5-2.6v-6.352l15.48 8.938c.468.27.984.408 1.502.408.514 0 1.03-.138 1.498-.406a2.971 2.971 0 001.5-2.6v-18.41c0-1.084-.56-2.058-1.5-2.6z",
    clipRule: "evenodd"
  }))
};
var RewindFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5G,
    fill: "none"
  }));
});
var compPaths$5F = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 6v12A2.25 2.25 0 006 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H3"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 6v12A2.25 2.25 0 006 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 12v24c0 2.484 2.016 4.5 4.5 4.5h24c2.484 0 4.5-2.016 4.5-4.5V12c0-2.484-2.016-4.5-4.5-4.5H6"
  }))
};
var Stop$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5F,
    fill: "none"
  }));
});
var compPaths$5E = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.75 6v12A2.25 2.25 0 006 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 6v12A2.25 2.25 0 006 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.75 6v12A2.25 2.25 0 006 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 6v12A2.25 2.25 0 006 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M36 6H12c-3.308 0-6 2.692-6 6v24c0 3.308 2.692 6 6 6h24c3.308 0 6-2.692 6-6V12c0-3.308-2.692-6-6-6z",
    clipRule: "evenodd"
  }))
};
var StopFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5E,
    fill: "none"
  }));
});
var compPaths$5D = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 15.75h4.5v-7.5h-4.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72m9-6.75v6m3-7.5v9"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 15.75h4.5v-7.5h-4.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72m9-6.75v6m3-7.5v9"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 31.5h9v-15h-9v15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.5 16.5l9.44-9.44c.944-.944 2.56-.274 2.56 1.062v31.756c0 1.336-1.616 2.006-2.56 1.062L16.5 31.5m18-13.5v12m6-15v18"
  }))
};
var VolumeHigh$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5D,
    fill: "none"
  }));
});
var compPaths$5C = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.074 2.675A1.499 1.499 0 0012.44 3l-4.5 4.5H3v9h4.94l4.5 4.5a1.497 1.497 0 001.634.325c.562-.233.926-.777.926-1.385V4.06c0-.608-.364-1.152-.926-1.385zM16.5 15H18V9h-1.5v6zm3 1.5H21v-9h-1.5v9z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.074 2.675A1.499 1.499 0 0012.44 3l-4.5 4.5H3v9h4.94l4.5 4.5a1.497 1.497 0 001.634.325c.562-.233.926-.777.926-1.385V4.06c0-.608-.364-1.152-.926-1.385zM16.5 15H18V9h-1.5v6zm3 1.5H21v-9h-1.5v9z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M28.148 5.35a2.998 2.998 0 00-3.27.65l-9 9H6v18h9.878l9 9a2.983 2.983 0 003.27.65A2.992 2.992 0 0030 39.88V8.12a2.993 2.993 0 00-1.852-2.772zM33 30h3V18h-3v12zm6 3h3V15h-3v18z",
    clipRule: "evenodd"
  }))
};
var VolumeHighFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5C,
    fill: "none"
  }));
});
var compPaths$5B = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 15.75h4.5v-7.5h-4.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72m9-6.75v6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 15.75h4.5v-7.5h-4.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72m9-6.75v6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 31.5h9v-15h-9v15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.5 16.5l9.44-9.44c.944-.944 2.56-.274 2.56 1.062v31.756c0 1.336-1.616 2.006-2.56 1.062L16.5 31.5m18-13.5v12"
  }))
};
var VolumeLow$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5B,
    fill: "none"
  }));
});
var compPaths$5A = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.074 2.675A1.5 1.5 0 0012.44 3l-4.5 4.5H3v9h4.94l4.5 4.5a1.497 1.497 0 001.634.325c.562-.233.926-.777.926-1.385V4.06c0-.608-.364-1.152-.926-1.385zM16.5 15H18V9h-1.5v6z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.074 2.675A1.5 1.5 0 0012.44 3l-4.5 4.5H3v9h4.94l4.5 4.5a1.497 1.497 0 001.634.325c.562-.233.926-.777.926-1.385V4.06c0-.608-.364-1.152-.926-1.385zM16.5 15H18V9h-1.5v6z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M28.148 5.35a2.999 2.999 0 00-3.27.65l-9 9H6v18h9.878l9 9a2.983 2.983 0 003.27.65A2.992 2.992 0 0030 39.88V8.12a2.993 2.993 0 00-1.852-2.772zM33 30h3V18h-3v12z",
    clipRule: "evenodd"
  }))
};
var VolumeLowFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5A,
    fill: "none"
  }));
});
var compPaths$5z = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 17.28a5.28 5.28 0 000-10.56H7.529a5.28 5.28 0 000 10.56H16.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.5 12a3 3 0 11-6 0 3 3 0 016 0zm9 0a3 3 0 11-6 0 3 3 0 016 0z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 17.28a5.28 5.28 0 000-10.56H7.529a5.28 5.28 0 000 10.56H16.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.5 12a3 3 0 11-6 0 3 3 0 016 0zm9 0a3 3 0 11-6 0 3 3 0 016 0z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33 34.559c5.83 0 10.558-4.728 10.558-10.558S38.83 13.44 33 13.44H15.058C9.226 13.44 4.5 18.17 4.5 24s4.726 10.558 10.558 10.558H33z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21 24a6 6 0 11-12 0 6 6 0 0112 0zm18 0a6 6 0 11-12 0 6 6 0 0112 0z",
    clipRule: "evenodd"
  }))
};
var Adapt$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5z,
    fill: "none"
  }));
});
var compPaths$5y = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.5 12c0 4.143-3.357 7.5-7.5 7.5A7.499 7.499 0 014.5 12c0-4.143 3.357-7.5 7.5-7.5s7.5 3.357 7.5 7.5z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.5 12c0 4.143-3.357 7.5-7.5 7.5A7.499 7.499 0 014.5 12c0-4.143 3.357-7.5 7.5-7.5s7.5 3.357 7.5 7.5z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 24c0 10.77-8.73 19.5-19.5 19.5S4.5 34.77 4.5 24 13.23 4.5 24 4.5 43.5 13.23 43.5 24z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M39 24c0 8.286-6.714 15-15 15S9 32.286 9 24 15.714 9 24 9s15 6.714 15 15z",
    clipRule: "evenodd"
  }))
};
var AdaptLight$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5y,
    fill: "none"
  }));
});
var compPaths$5x = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 18.75h-7.5a3 3 0 01-3-3v-7.5a3 3 0 013-3h7.5a3 3 0 013 3v7.5a3 3 0 01-3 3zm-2.25 3h-3a2.25 2.25 0 01-2.25-2.25v-.75h7.5v.75a2.25 2.25 0 01-2.25 2.25zm-3-19.5h3a2.25 2.25 0 012.25 2.25v.75h-7.5V4.5a2.25 2.25 0 012.25-2.25z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 18.75h-7.5a3 3 0 01-3-3v-7.5a3 3 0 013-3h7.5a3 3 0 013 3v7.5a3 3 0 01-3 3zm-2.25 3h-3a2.25 2.25 0 01-2.25-2.25v-.75h7.5v.75a2.25 2.25 0 01-2.25 2.25zm-3-19.5h3a2.25 2.25 0 012.25 2.25v.75h-7.5V4.5a2.25 2.25 0 012.25-2.25z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.5 37.5h-15a6 6 0 01-6-6v-15a6 6 0 016-6h15a6 6 0 016 6v15a6 6 0 01-6 6zm-4.5 6h-6a4.502 4.502 0 01-4.5-4.5v-1.5h15V39c0 2.484-2.016 4.5-4.5 4.5zm-6-39h6c2.484 0 4.5 2.016 4.5 4.5v1.5h-15V9c0-2.484 2.016-4.5 4.5-4.5z",
    clipRule: "evenodd"
  }))
};
var AppleWatch$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5x,
    fill: "none"
  }));
});
var compPaths$5w = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.59 10.41a2.25 2.25 0 010 3.181m-3.18-.001a2.25 2.25 0 010-3.181m5.302-2.121a5.248 5.248 0 010 7.424m-7.424 0a5.248 5.248 0 010-7.424m9.546-2.122a8.25 8.25 0 010 11.668m-11.668 0a8.25 8.25 0 010-11.668"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.59 10.41a2.25 2.25 0 010 3.181m-3.18-.001a2.25 2.25 0 010-3.181m5.302-2.121a5.248 5.248 0 010 7.424m-7.424 0a5.248 5.248 0 010-7.424m9.546-2.122a8.25 8.25 0 010 11.668m-11.668 0a8.25 8.25 0 010-11.668"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M27.182 20.818a4.499 4.499 0 010 6.364m-6.364 0a4.499 4.499 0 010-6.364m10.606-4.242c4.102 4.1 4.102 10.748 0 14.848m-14.848 0c-4.102-4.1-4.102-10.748 0-14.848m19.092-4.244c6.444 6.446 6.444 16.89 0 23.336m-23.336 0c-6.444-6.446-6.444-16.89 0-23.336"
  }))
};
var AudioFeedback$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5w,
    fill: "none"
  }));
});
var compPaths$5v = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.75 19.25a1 1 0 01-1 1h-7.5a1 1 0 01-1-1V7.75a1 1 0 011-1h7.5a1 1 0 011 1v11.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M14.5 9h-5v9h5V9z",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.805 14.054H10.25L13.168 9l-1.051 3.947h1.555L10.754 18l1.05-3.946z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.5 3.75h5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.75 19.25a1 1 0 01-1 1h-7.5a1 1 0 01-1-1V7.75a1 1 0 011-1h7.5a1 1 0 011 1v11.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M14.5 9h-5v9h5V9z",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.805 14.054H10.25L13.168 9l-1.051 3.947h1.555L10.754 18l1.05-3.946z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.5 3.75h5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M33.5 38.5a2 2 0 01-2 2h-15a2 2 0 01-2-2v-23a2 2 0 012-2h15a2 2 0 012 2v23z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M29 18H19v18h10V18z",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23.61 28.108H20.5L26.336 18l-2.102 7.894h3.11L21.508 36l2.102-7.892z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M19 7.5h10"
  }))
};
var BatteryChargingFull$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5v,
    fill: "none"
  }));
});
var compPaths$5u = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.75 19.25a1 1 0 01-1 1h-7.5a1 1 0 01-1-1V7.75a1 1 0 011-1h7.5a1 1 0 011 1v11.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M14.5 13.5h-5V18h5v-4.5z",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.805 14.054H10.25L13.168 9l-1.05 3.947h1.554L10.754 18l1.051-3.946z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.5 3.75h5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.75 19.25a1 1 0 01-1 1h-7.5a1 1 0 01-1-1V7.75a1 1 0 011-1h7.5a1 1 0 011 1v11.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M14.5 13.5h-5V18h5v-4.5z",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.805 14.054H10.25L13.168 9l-1.05 3.947h1.554L10.754 18l1.051-3.946z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.5 3.75h5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M33.5 38.5a2 2 0 01-2 2h-15a2 2 0 01-2-2v-23a2 2 0 012-2h15a2 2 0 012 2v23z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M29 27H19v9h10v-9z",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23.61 28.108H20.5L26.336 18l-2.102 7.894h3.11L21.508 36l2.102-7.892z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M19 7.5h10"
  }))
};
var BatteryChargingLow$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5u,
    fill: "none"
  }));
});
var compPaths$5t = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.75 19.25a1 1 0 01-1 1h-7.5a1 1 0 01-1-1V7.75a1 1 0 011-1h7.5a1 1 0 011 1v11.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M14.5 9h-5v9h5V9z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.5 3.75h5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.75 19.25a1 1 0 01-1 1h-7.5a1 1 0 01-1-1V7.75a1 1 0 011-1h7.5a1 1 0 011 1v11.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M14.5 9h-5v9h5V9z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.5 3.75h5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M33.5 38.5a2 2 0 01-2 2h-15a2 2 0 01-2-2v-23a2 2 0 012-2h15a2 2 0 012 2v23z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M29 18H19v18h10V18z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M19 7.5h10"
  }))
};
var BatteryFull$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5t,
    fill: "none"
  }));
});
var compPaths$5s = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.75 19.25a1 1 0 01-1 1h-7.5a1 1 0 01-1-1V7.75a1 1 0 011-1h7.5a1 1 0 011 1v11.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M14.5 13.5h-5V18h5v-4.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.5 3.75h5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.75 19.25a1 1 0 01-1 1h-7.5a1 1 0 01-1-1V7.75a1 1 0 011-1h7.5a1 1 0 011 1v11.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M14.5 13.5h-5V18h5v-4.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.5 3.75h5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M33.5 38.5a2 2 0 01-2 2h-15a2 2 0 01-2-2v-23a2 2 0 012-2h15a2 2 0 012 2v23z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M29 27H19v9h10v-9z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M19 7.5h10"
  }))
};
var BatteryLow$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5s,
    fill: "none"
  }));
});
var compPaths$5r = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.757 16.242l-3.182 3.183m14.85-14.85l-3.182 3.183M6 12H1.5m21 0H18M7.757 7.758L4.575 4.575m14.85 14.85l-3.182-3.183"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.757 16.242l-3.182 3.183m14.85-14.85l-3.182 3.183M6 12H1.5m21 0H18M7.757 7.758L4.575 4.575m14.85 14.85l-3.182-3.183"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 36v9m0-42v9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.5 24a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15.515 32.484L9.15 38.85m29.7-29.7l-6.364 6.366M12 24H3m42 0h-9m-20.485-8.484L9.15 9.15m29.7 29.7l-6.364-6.366"
  }))
};
var Brightness$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5r,
    fill: "none"
  }));
});
var compPaths$5q = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15 11.25c-2.077 0-2.716-4.312-2.912-8.211-.04-.787-1.093-.998-1.426-.285C8.694 6.964 5.25 12.321 5.25 15a6.75 6.75 0 1013.5 0c0-3.75-3.5-6.75-3.5-10.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.876 18.626c0-1.277 1.693-3.214 2.587-4.146a.736.736 0 011.074 0c.894.932 2.587 2.87 2.587 4.146a3.123 3.123 0 11-6.248 0z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15 11.25c-2.077 0-2.716-4.312-2.912-8.211-.04-.787-1.093-.998-1.426-.285C8.694 6.964 5.25 12.321 5.25 15a6.75 6.75 0 1013.5 0c0-3.75-3.5-6.75-3.5-10.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.876 18.626c0-1.277 1.693-3.214 2.587-4.146a.736.736 0 011.074 0c.894.932 2.587 2.87 2.587 4.146a3.123 3.123 0 11-6.248 0z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M30 22.5c-4.154 0-5.432-8.624-5.824-16.422-.08-1.574-2.186-1.996-2.852-.57C17.388 13.928 10.5 24.642 10.5 30c0 7.456 6.044 13.5 13.5 13.5S37.5 37.456 37.5 30c0-7.5-7-13.5-7-21"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M17.752 37.252c0-2.554 3.386-6.428 5.174-8.292a1.473 1.473 0 012.148 0c1.788 1.864 5.174 5.738 5.174 8.292A6.246 6.246 0 0124 43.5a6.246 6.246 0 01-6.248-6.248z",
    clipRule: "evenodd"
  }))
};
var Burn$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5q,
    fill: "none"
  }));
});
var compPaths$5p = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 20.25h9m-3-3.002h6a2.25 2.25 0 002.25-2.25V6a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 002.25 6v8.998a2.25 2.25 0 002.25 2.25h5a2.25 2.25 0 012.25 2.25v.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.827 10.068L10.5 7.57a.5.5 0 00-.75.433v4.996a.5.5 0 00.75.433l4.327-2.498a.5.5 0 000-.866z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 20.25h9m-3-3.002h6a2.25 2.25 0 002.25-2.25V6a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 002.25 6v8.998a2.25 2.25 0 002.25 2.25h5a2.25 2.25 0 012.25 2.25v.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.827 10.068L10.5 7.57a.5.5 0 00-.75.433v4.996a.5.5 0 00.75.433l4.327-2.498a.5.5 0 000-.866z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 40.5h18m-6-6.004h12a4.5 4.5 0 004.5-4.5V12c0-2.484-2.016-4.5-4.5-4.5H9A4.502 4.502 0 004.5 12v17.996a4.5 4.5 0 004.5 4.5h10c2.484 0 4.5 2.016 4.5 4.5v1.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M29.654 20.135L21 15.139a1 1 0 00-1.5.866v9.994a1 1 0 001.5.866l8.654-4.998a.999.999 0 000-1.732z",
    clipRule: "evenodd"
  }))
};
var ClassWorkout$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5p,
    fill: "none"
  }));
});
var compPaths$5o = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15 21.75H9a2.25 2.25 0 01-2.25-2.25v-15A2.25 2.25 0 019 2.25h6a2.25 2.25 0 012.25 2.25v15A2.25 2.25 0 0115 21.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10.5 18.75h3"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15 21.75H9a2.25 2.25 0 01-2.25-2.25v-15A2.25 2.25 0 019 2.25h6a2.25 2.25 0 012.25 2.25v15A2.25 2.25 0 0115 21.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10.5 18.75h3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M30 43.5H18a4.502 4.502 0 01-4.5-4.5V9c0-2.484 2.016-4.5 4.5-4.5h12c2.484 0 4.5 2.016 4.5 4.5v30c0 2.484-2.016 4.5-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M21 37.5h6"
  }))
};
var Device$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5o,
    fill: "none"
  }));
});
var compPaths$5n = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 19.5A2.25 2.25 0 0115 21.75H9a2.25 2.25 0 01-2.25-2.25m0-15A2.25 2.25 0 019 2.25h6a2.25 2.25 0 012.25 2.25",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 15V9A2.25 2.25 0 014.5 6.75h15A2.25 2.25 0 0121.75 9v6a2.25 2.25 0 01-2.25 2.25h-15A2.25 2.25 0 012.25 15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.25 10.5v3"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 19.5A2.25 2.25 0 0115 21.75H9a2.25 2.25 0 01-2.25-2.25m0-15A2.25 2.25 0 019 2.25h6a2.25 2.25 0 012.25 2.25",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 15V9A2.25 2.25 0 014.5 6.75h15A2.25 2.25 0 0121.75 9v6a2.25 2.25 0 01-2.25 2.25h-15A2.25 2.25 0 012.25 15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.25 10.5v3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 39c0 2.484-2.016 4.5-4.5 4.5H18a4.502 4.502 0 01-4.5-4.5m0-30c0-2.484 2.016-4.5 4.5-4.5h12c2.484 0 4.5 2.016 4.5 4.5",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M4.5 30V18c0-2.484 2.016-4.5 4.5-4.5h30c2.484 0 4.5 2.016 4.5 4.5v12c0 2.484-2.016 4.5-4.5 4.5H9A4.502 4.502 0 014.5 30z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M10.5 21v6"
  }))
};
var DeviceLeft$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5n,
    fill: "none"
  }));
});
var compPaths$5m = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 19.5A2.25 2.25 0 0115 21.75H9a2.25 2.25 0 01-2.25-2.25m0-15A2.25 2.25 0 019 2.25h6a2.25 2.25 0 012.25 2.25",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 15V9a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 002.25 9v6a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 10.5v3"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 19.5A2.25 2.25 0 0115 21.75H9a2.25 2.25 0 01-2.25-2.25m0-15A2.25 2.25 0 019 2.25h6a2.25 2.25 0 012.25 2.25",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 15V9a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 002.25 9v6a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 10.5v3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 39a4.5 4.5 0 01-4.5 4.5H18a4.5 4.5 0 01-4.5-4.5m0-30A4.5 4.5 0 0118 4.5h12A4.5 4.5 0 0134.5 9",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 30V18a4.5 4.5 0 00-4.5-4.5H9A4.5 4.5 0 004.5 18v12A4.5 4.5 0 009 34.5h30a4.5 4.5 0 004.5-4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M37.5 21v6"
  }))
};
var DeviceRight$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5m,
    fill: "none"
  }));
});
var compPaths$5l = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.5 17.25A2.25 2.25 0 012.25 15V9A2.25 2.25 0 014.5 6.75m15 0A2.25 2.25 0 0121.75 9v6a2.25 2.25 0 01-2.25 2.25",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 21.75h6a2.25 2.25 0 002.25-2.25v-15A2.25 2.25 0 0015 2.25H9A2.25 2.25 0 006.75 4.5v15A2.25 2.25 0 009 21.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.5 18.75h-3"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.5 17.25A2.25 2.25 0 012.25 15V9A2.25 2.25 0 014.5 6.75m15 0A2.25 2.25 0 0121.75 9v6a2.25 2.25 0 01-2.25 2.25",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 21.75h6a2.25 2.25 0 002.25-2.25v-15A2.25 2.25 0 0015 2.25H9A2.25 2.25 0 006.75 4.5v15A2.25 2.25 0 009 21.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.5 18.75h-3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M9 34.5A4.5 4.5 0 014.5 30V18A4.5 4.5 0 019 13.5m30 0a4.5 4.5 0 014.5 4.5v12a4.5 4.5 0 01-4.5 4.5",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18 43.5h12a4.5 4.5 0 004.5-4.5V9A4.5 4.5 0 0030 4.5H18A4.5 4.5 0 0013.5 9v30a4.5 4.5 0 004.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M27 37.5h-6"
  }))
};
var DeviceVertical$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5l,
    fill: "none"
  }));
});
var compPaths$5k = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15.18 8.82a4.503 4.503 0 00-6.37 0 4.503 4.503 0 000 6.37"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M8.82 15.18a4.503 4.503 0 006.37 0 4.503 4.503 0 000-6.37"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15.18 8.82a4.503 4.503 0 00-6.37 0 4.503 4.503 0 000 6.37"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M8.82 15.18a4.503 4.503 0 006.37 0 4.503 4.503 0 000-6.37"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 37.5c7.456 0 13.5-6.044 13.5-13.5S31.456 10.5 24 10.5 10.5 16.544 10.5 24 16.544 37.5 24 37.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M30.36 17.64a9.005 9.005 0 00-12.74 0 9.005 9.005 0 000 12.74"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M17.64 30.36a9.005 9.005 0 0012.74 0 9.005 9.005 0 000-12.74"
  }))
};
var DualLightsColorChip$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5k,
    fill: "none"
  }));
});
var compPaths$5j = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M7.5 12c0-2.72 1.22-5.16 3.13-6.81A7.43 7.43 0 007.5 4.5C3.36 4.5 0 7.86 0 12c0 4.14 3.36 7.5 7.5 7.5 1.12 0 2.18-.25 3.13-.69A8.987 8.987 0 017.5 12z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.5 18.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M7.5 12c0-2.72 1.22-5.16 3.13-6.81A7.43 7.43 0 007.5 4.5C3.36 4.5 0 7.86 0 12c0 4.14 3.36 7.5 7.5 7.5 1.12 0 2.18-.25 3.13-.69A8.987 8.987 0 017.5 12z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.5 18.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15 24c0-5.44 2.44-10.32 6.26-13.62C19.36 9.5 17.24 9 15 9 6.72 9 0 15.72 0 24c0 8.28 6.72 15 15 15 2.24 0 4.36-.5 6.26-1.38C17.44 34.32 15 29.44 15 24z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M33 37.5c7.456 0 13.5-6.044 13.5-13.5S40.456 10.5 33 10.5 19.5 16.544 19.5 24 25.544 37.5 33 37.5z"
  }))
};
var EffectActive$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5j,
    fill: "none"
  }));
});
var compPaths$5i = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.5 18.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M7.5 19.5c-.31 0-.62-.02-.93-.06l.19-1.49c.5.06.99.06 1.48 0l.18 1.49c-.31.04-.61.06-.92.06zm-2.89-.58l-.05-.02a7.33 7.33 0 01-1.58-.92l.9-1.2c.39.29.81.54 1.27.73l.09.05-.34.57-.29.79zm5.8-.01l-.58-1.38c.46-.19.89-.44 1.28-.74l.9 1.2c-.49.37-1.03.68-1.6.92zm-8.89-2.39a7.47 7.47 0 01-.92-1.6l1.38-.59c.19.46.44.89.74 1.28l-1.2.91zM.06 12.93a6.953 6.953 0 010-1.84l1.49.18c-.04.24-.05.48-.05.73s.02.5.05.75l-1.49.18zm1.92-3.28L.58 9.1l.02-.05c.23-.55.54-1.07.9-1.55l1.2.9c-.28.38-.53.8-.72 1.25zm1.89-2.43l-.91-1.19c.49-.37 1.03-.68 1.6-.93l.59 1.38c-.46.19-.89.44-1.28.74zm7.23-.02c-.38-.29-.8-.53-1.24-.71l.58-1.38c.56.24 1.09.54 1.56.9l-.9 1.19zM6.74 6.05l-.19-1.49c.31-.04.63-.07.96-.06.29 0 .59.02.89.05l-.18 1.49c-.24-.03-.48-.03-.73-.04-.25 0-.5.02-.75.05z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.5 18.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M7.5 19.5c-.31 0-.62-.02-.93-.06l.19-1.49c.5.06.99.06 1.48 0l.18 1.49c-.31.04-.61.06-.92.06zm-2.89-.58l-.05-.02a7.33 7.33 0 01-1.58-.92l.9-1.2c.39.29.81.54 1.27.73l.09.05-.34.57-.29.79zm5.8-.01l-.58-1.38c.46-.19.89-.44 1.28-.74l.9 1.2c-.49.37-1.03.68-1.6.92zm-8.89-2.39a7.47 7.47 0 01-.92-1.6l1.38-.59c.19.46.44.89.74 1.28l-1.2.91zM.06 12.93a6.953 6.953 0 010-1.84l1.49.18c-.04.24-.05.48-.05.73s.02.5.05.75l-1.49.18zm1.92-3.28L.58 9.1l.02-.05c.23-.55.54-1.07.9-1.55l1.2.9c-.28.38-.53.8-.72 1.25zm1.89-2.43l-.91-1.19c.49-.37 1.03-.68 1.6-.93l.59 1.38c-.46.19-.89.44-1.28.74zm7.23-.02c-.38-.29-.8-.53-1.24-.71l.58-1.38c.56.24 1.09.54 1.56.9l-.9 1.19zM6.74 6.05l-.19-1.49c.31-.04.63-.07.96-.06.29 0 .59.02.89.05l-.18 1.49c-.24-.03-.48-.03-.73-.04-.25 0-.5.02-.75.05z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M33 37.5c7.456 0 13.5-6.044 13.5-13.5S40.456 10.5 33 10.5 19.5 16.544 19.5 24 25.544 37.5 33 37.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15 39c-.62 0-1.24-.04-1.86-.12l.38-2.98c1 .12 1.98.12 2.96 0l.36 2.98c-.62.08-1.22.12-1.84.12zm-5.78-1.16l-.1-.04c-1.12-.48-2.2-1.1-3.16-1.84l1.8-2.4c.78.58 1.62 1.08 2.54 1.46l.18.1-.68 1.14-.58 1.58zm11.6-.02l-1.16-2.76c.92-.38 1.78-.88 2.56-1.48l1.8 2.4c-.98.74-2.06 1.36-3.2 1.84zM3.04 33.04c-.74-.98-1.36-2.06-1.84-3.2l2.76-1.18c.38.92.88 1.78 1.48 2.56l-2.4 1.82zM.12 25.86C.04 25.24 0 24.62 0 24c0-.6.04-1.22.12-1.82l2.98.36c-.08.48-.1.96-.1 1.46s.04 1 .1 1.5l-2.98.36zm3.84-6.56l-2.8-1.1.04-.1C1.66 17 2.28 15.96 3 15l2.4 1.8c-.56.76-1.06 1.6-1.44 2.5zm3.78-4.86l-1.82-2.38c.98-.74 2.06-1.36 3.2-1.86l1.18 2.76c-.92.38-1.78.88-2.56 1.48zm14.46-.04c-.76-.58-1.6-1.06-2.48-1.42l1.16-2.76c1.12.48 2.18 1.08 3.12 1.8l-1.8 2.38zm-8.72-2.3l-.38-2.98c.62-.08 1.26-.14 1.92-.12.58 0 1.18.04 1.78.1l-.36 2.98c-.48-.06-.96-.06-1.46-.08-.5 0-1 .04-1.5.1z"
  }))
};
var EffectInactive$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5i,
    fill: "none"
  }));
});
var compPaths$5h = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.284 9.349l2.651 2.65-2.65 2.653M9.716 9.349l-2.651 2.65 2.65 2.653"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.284 9.349l2.651 2.65-2.65 2.653M9.716 9.349l-2.651 2.65 2.65 2.653"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 24c0 10.77-8.73 19.5-19.5 19.5S4.5 34.77 4.5 24 13.23 4.5 24 4.5 43.5 13.23 43.5 24z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M28.568 18.697L33.87 24l-5.302 5.304m-9.136-10.607L14.13 24l5.302 5.304"
  }))
};
var Effort$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5h,
    fill: "none"
  }));
});
var compPaths$5g = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 8.913L7.625 5.81a2.25 2.25 0 012.25 0l4.25 2.455a2.254 2.254 0 002.25 0L21.75 5.16"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10.306 18.75H4.75a2.5 2.5 0 01-2.5-2.5v-3.87l5.375-3.103a2.25 2.25 0 012.25 0l4.25 2.453a2.245 2.245 0 002.25 0l4.25-2.453a.75.75 0 011.125.65v6.323a2.5 2.5 0 01-2.5 2.5h-8.944z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 8.913L7.625 5.81a2.25 2.25 0 012.25 0l4.25 2.455a2.254 2.254 0 002.25 0L21.75 5.16"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10.306 18.75H4.75a2.5 2.5 0 01-2.5-2.5v-3.87l5.375-3.103a2.25 2.25 0 012.25 0l4.25 2.453a2.245 2.245 0 002.25 0l4.25-2.453a.75.75 0 011.125.65v6.323a2.5 2.5 0 01-2.5 2.5h-8.944z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M4.5 17.826l10.75-6.208a4.5 4.5 0 014.5 0l8.5 4.91a4.509 4.509 0 004.5 0L43.5 10.32"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M9.5 37.5a5 5 0 01-5-5v-7.74l10.75-6.206a4.5 4.5 0 014.5 0l8.5 4.906a4.49 4.49 0 004.5 0l8.5-4.906c1-.578 2.25.146 2.25 1.3V32.5a5 5 0 01-5 5h-29z",
    clipRule: "evenodd"
  }))
};
var ElevationChange$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5g,
    fill: "none"
  }));
});
var compPaths$5f = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.153 11.434A5.251 5.251 0 0019.8 4.917c-2.11-1.72-5.225-1.417-7.15.508l-.657.657-.78-.794C8.76 2.837 4.49 3.316 2.75 6.723c-1.014 1.985-.54 4.414 1.036 5.989l.038.038h3.158l2.517-2.5 4 4 1.5-1.5h4.042a.5.5 0 01.353.854L11.99 21 5.9 14.9"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.153 11.434A5.251 5.251 0 0019.8 4.917c-2.11-1.72-5.225-1.417-7.15.508l-.657.657-.78-.794C8.76 2.837 4.49 3.316 2.75 6.723c-1.014 1.985-.54 4.414 1.036 5.989l.038.038h3.158l2.517-2.5 4 4 1.5-1.5h4.042a.5.5 0 01.353.854L11.99 21 5.9 14.9"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M42.307 22.867A10.503 10.503 0 0039.6 9.833C35.38 6.395 29.15 7 25.3 10.85l-1.314 1.314-1.562-1.588c-4.902-4.902-13.442-3.944-16.922 2.87-2.028 3.97-1.08 8.828 2.072 11.978l.076.076h6.316l5.034-5 8 8 3-3h8.084c.89 0 1.336 1.078.706 1.708L23.979 42 11.8 29.801"
  }))
};
var HeartRate$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5f,
    fill: "none"
  }));
});
var compPaths$5e = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 18.752h12"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 14.253h12M6 9.75h12M6 5.25h12",
    opacity: ".2"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 18.752h12"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 14.253h12M6 9.75h12M6 5.25h12",
    opacity: ".2"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M12 37.504h24"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M12 28.506h24M12 19.5h24m-24-9h24",
    opacity: ".2"
  }))
};
var LaceDown$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5e,
    fill: "none"
  }));
});
var compPaths$5d = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 5.25H6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 14.25H6m12-4.5H6m12 9H6",
    opacity: ".2"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 5.25H6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 14.25H6m12-4.5H6m12 9H6",
    opacity: ".2"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M36 10.5H12"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M36 28.5H12m24-9H12m24 18H12",
    opacity: ".2"
  }))
};
var LaceUp$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5d,
    fill: "none"
  }));
});
var compPaths$5c = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M5.03 5.03l13.94 13.94"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M5.03 5.03l13.94 13.94"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M18.65 15.46c.54-1.04.85-2.21.85-3.46 0-4.14-3.36-7.5-7.5-7.5-1.25 0-2.43.31-3.46.85l10.11 10.11zM5.36 8.54A7.358 7.358 0 004.5 12c0 4.14 3.36 7.5 7.5 7.5 1.25 0 2.42-.31 3.46-.86L5.36 8.54z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M5.03 5.03l13.94 13.94"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M5.03 5.03l13.94 13.94"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M18.65 15.46c.54-1.04.85-2.21.85-3.46 0-4.14-3.36-7.5-7.5-7.5-1.25 0-2.43.31-3.46.85l10.11 10.11zM5.36 8.54A7.358 7.358 0 004.5 12c0 4.14 3.36 7.5 7.5 7.5 1.25 0 2.42-.31 3.46-.86L5.36 8.54z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M10.06 10.06l27.88 27.88"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M10.06 10.06l27.88 27.88"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M37.3 30.92C38.38 28.84 39 26.5 39 24c0-8.28-6.72-15-15-15-2.5 0-4.86.62-6.92 1.7L37.3 30.92zM10.72 17.08C9.62 19.16 9 21.5 9 24c0 8.28 6.72 15 15 15 2.5 0 4.84-.62 6.92-1.72l-20.2-20.2z"
  }))
};
var LightsOff$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5c,
    fill: "none"
  }));
});
var compPaths$5b = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 18.75H6m9-9H9m6 4.5H9m6-9H9"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 18.75H6m9-9H9m6 4.5H9m6-9H9"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M36 37.5H12m18-18H18m12 9H18m12-18H18"
  }))
};
var Loosen$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5b,
    fill: "none"
  }));
});
var compPaths$5a = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 5.25a3 3 0 11-6 0 3 3 0 016 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.793 22.112l4.966-8.602a1.5 1.5 0 00-1.299-2.25H3m10.974 4.365l-3.75 6.495M14 11.25h7"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 5.25a3 3 0 11-6 0 3 3 0 016 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.793 22.112l4.966-8.602a1.5 1.5 0 00-1.299-2.25H3m10.974 4.365l-3.75 6.495M14 11.25h7"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.5 10.5a6 6 0 11-12 0 6 6 0 0112 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.586 44.224l9.932-17.203c1.154-2-.29-4.5-2.598-4.5H6m21.947 8.729l-7.5 12.99M28 22.5h14"
  }))
};
var MuscleGroup$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$5a,
    fill: "none"
  }));
});
var compPaths$59 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.5 9h9V7.5h-9V9zm0-3h9V4.5h-9V6zm0 6h6v-1.5h-6V12zm4.52 4.299v3.18h3.18l2.8-2.797.933-.931h-.002l4.308-4.308-3.18-3.182-8.04 8.039zm6.977-4.857l1.061-1.061 1.061 1.06-1.06 1.06-1.062-1.06zM13.52 16.92l4.416-4.418L19 13.562l-4.418 4.419H13.52V16.92z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 19.5c0 .827-.673 1.5-1.5 1.5h-9c-.827 0-1.5-.673-1.5-1.5v-15C6 3.673 6.673 3 7.5 3h9c.827 0 1.5.673 1.5 1.5v3.697l1.5-1.5V4.5c0-1.654-1.346-3-3-3h-9c-1.654 0-3 1.346-3 3v15c0 1.654 1.346 3 3 3h9c1.654 0 3-1.346 3-3v-2.197l-1.5 1.5v.697z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.5 9h9V7.5h-9V9zm0-3h9V4.5h-9V6zm0 6h6v-1.5h-6V12zm4.52 4.299v3.18h3.18l2.8-2.797.933-.931h-.002l4.308-4.308-3.18-3.182-8.04 8.039zm6.977-4.857l1.061-1.061 1.061 1.06-1.06 1.06-1.062-1.06zM13.52 16.92l4.416-4.418L19 13.562l-4.418 4.419H13.52V16.92z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 19.5c0 .827-.673 1.5-1.5 1.5h-9c-.827 0-1.5-.673-1.5-1.5v-15C6 3.673 6.673 3 7.5 3h9c.827 0 1.5.673 1.5 1.5v3.697l1.5-1.5V4.5c0-1.654-1.346-3-3-3h-9c-1.654 0-3 1.346-3 3v15c0 1.654 1.346 3 3 3h9c1.654 0 3-1.346 3-3v-2.197l-1.5 1.5v.697z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 18h18v-3H15v3zm0-6h18V9H15v3zm0 12h12v-3H15v3zm9.04 8.597v6.362h6.363L36 33.361l1.866-1.862h-.002l8.616-8.616-6.362-6.364L24.04 32.597zm13.955-9.714l2.122-2.122 2.122 2.122-2.122 2.12-2.122-2.12zM27.04 33.84l8.834-8.836 2.124 2.122-8.836 8.836H27.04V33.84z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M36 39c0 1.654-1.346 3-3 3H15c-1.654 0-3-1.346-3-3V9c0-1.654 1.346-3 3-3h18c1.654 0 3 1.346 3 3v7.394l3-3V9c0-3.308-2.692-6-6-6H15c-3.308 0-6 2.692-6 6v30c0 3.308 2.692 6 6 6h18c3.308 0 6-2.692 6-6v-4.394l-3 3V39z",
    clipRule: "evenodd"
  }))
};
var Notes$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$59,
    fill: "none"
  }));
});
var compPaths$58 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.75 3.75h-2.5v3h-4v3h-4v3h-3.5V18A2.25 2.25 0 006 20.25h12A2.25 2.25 0 0020.25 18V3.75h-2.5z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.75 3.75h-2.5v3h-4v3h-4v3h-3.5V18A2.25 2.25 0 006 20.25h12A2.25 2.25 0 0020.25 18V3.75h-2.5z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M35.5 7.5h-5v6h-8v6h-8v6h-7V36c0 2.484 2.016 4.5 4.5 4.5h24c2.484 0 4.5-2.016 4.5-4.5V7.5h-5z",
    clipRule: "evenodd"
  }))
};
var ProgramIntensity$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$58,
    fill: "none"
  }));
});
var compPaths$57 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.25 5.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25H6A2.25 2.25 0 013.75 18V7.5A2.25 2.25 0 016 5.25h2.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 6.75h6v-3H9v3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.712 10.667L10.94 15.44l-2.652-2.651"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.25 5.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25H6A2.25 2.25 0 013.75 18V7.5A2.25 2.25 0 016 5.25h2.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 6.75h6v-3H9v3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.712 10.667L10.94 15.44l-2.652-2.651"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M30.5 10.5H36a4.5 4.5 0 014.5 4.5v21a4.5 4.5 0 01-4.5 4.5H12A4.5 4.5 0 017.5 36V15a4.5 4.5 0 014.5-4.5h5.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18 13.5h12v-6H18v6z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.425 21.334l-9.546 9.546-5.304-5.302"
  }))
};
var Programs$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$57,
    fill: "none"
  }));
});
var compPaths$56 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.94 16.5l-3.182-3.18 1.06-1.06 2.122 2.12 4.242-4.242 1.06 1.06L10.94 16.5zM9.75 6h4.5V4.5h-4.5V6zM18 4.5h-2.25V3h-7.5v1.5H6c-1.654 0-3 1.345-3 3V18c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V7.5c0-1.655-1.346-3-3-3z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.94 16.5l-3.182-3.18 1.06-1.06 2.122 2.12 4.242-4.242 1.06 1.06L10.94 16.5zM9.75 6h4.5V4.5h-4.5V6zM18 4.5h-2.25V3h-7.5v1.5H6c-1.654 0-3 1.345-3 3V18c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V7.5c0-1.655-1.346-3-3-3z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.879 33.001l-6.364-6.364 2.12-2.12 4.244 4.242 8.486-8.486 2.12 2.122-10.606 10.606zm-2.378-21h9v-3h-9v3zm16.5-3h-4.5v-3h-15v3h-4.5c-3.31 0-6 2.69-6 6v21c0 3.308 2.69 6 6 6h24c3.308 0 6-2.692 6-6v-21c0-3.31-2.692-6-6-6z",
    clipRule: "evenodd"
  }))
};
var ProgramsFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$56,
    fill: "none"
  }));
});
var compPaths$55 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M15.25 5.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25H6A2.25 2.25 0 013.75 18V7.5A2.25 2.25 0 016 5.25h2.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M9 6.75h6v-3H9v3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M15.712 10.667L10.94 15.44l-2.652-2.651"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M15.25 5.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25H6A2.25 2.25 0 013.75 18V7.5A2.25 2.25 0 016 5.25h2.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M9 6.75h6v-3H9v3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M15.712 10.667L10.94 15.44l-2.652-2.651"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M30.5 10.5H36a4.5 4.5 0 014.5 4.5v21a4.5 4.5 0 01-4.5 4.5H12A4.5 4.5 0 017.5 36V15a4.5 4.5 0 014.5-4.5h5.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M18 13.5h12v-6H18v6z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M31.425 21.334l-9.546 9.546-5.304-5.302"
  }))
};
var ProgramsStroke$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$55,
    fill: "none"
  }));
});
var compPaths$54 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15.18 8.82a4.509 4.509 0 00-6.36 0 4.509 4.509 0 000 6.36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M7.76 16.24l-3.18 3.18M19.42 4.58l-3.18 3.18M6 12H1.5m21 0H18M7.76 7.76L4.58 4.58m14.84 14.84l-3.18-3.18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M8.82 15.18a4.509 4.509 0 006.36 0 4.509 4.509 0 000-6.36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15.18 8.82a4.509 4.509 0 00-6.36 0 4.509 4.509 0 000 6.36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M7.76 16.24l-3.18 3.18M19.42 4.58l-3.18 3.18M6 12H1.5m21 0H18M7.76 7.76L4.58 4.58m14.84 14.84l-3.18-3.18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M8.82 15.18a4.509 4.509 0 006.36 0 4.509 4.509 0 000-6.36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 36v9m0-42v9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M30.36 17.64c-3.5-3.5-9.22-3.5-12.72 0s-3.5 9.22 0 12.72"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M15.52 32.48l-6.36 6.36M38.84 9.16l-6.36 6.36M12 24H3m42 0h-9m-20.48-8.48L9.16 9.16m29.68 29.68l-6.36-6.36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M17.64 30.36c3.5 3.5 9.22 3.5 12.72 0s3.5-9.22 0-12.72"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 36v9m0-42v9"
  }))
};
var PulsingDualLights$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$54,
    fill: "none"
  }));
});
var compPaths$53 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15.18 8.82a4.509 4.509 0 00-6.36 0 4.509 4.509 0 000 6.36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M7.76 16.24l-3.18 3.18M19.42 4.58l-3.18 3.18M6 12H1.5m21 0H18M7.76 7.76L4.58 4.58m14.84 14.84l-3.18-3.18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M8.82 15.18a4.509 4.509 0 006.36 0 4.509 4.509 0 000-6.36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15.18 8.82a4.509 4.509 0 00-6.36 0 4.509 4.509 0 000 6.36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M7.76 16.24l-3.18 3.18M19.42 4.58l-3.18 3.18M6 12H1.5m21 0H18M7.76 7.76L4.58 4.58m14.84 14.84l-3.18-3.18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M8.82 15.18a4.509 4.509 0 006.36 0 4.509 4.509 0 000-6.36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 36v9m0-42v9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M30.36 17.64c-3.5-3.5-9.22-3.5-12.72 0s-3.5 9.22 0 12.72"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M15.52 32.48l-6.36 6.36M38.84 9.16l-6.36 6.36M12 24H3m42 0h-9m-20.48-8.48L9.16 9.16m29.68 29.68l-6.36-6.36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M17.64 30.36c3.5 3.5 9.22 3.5 12.72 0s3.5-9.22 0-12.72"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 36v9m0-42v9"
  }))
};
var PulsingLights$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$53,
    fill: "none"
  }));
});
var compPaths$52 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 1.5v21m10.5 0v-21M12 19.5v3m0-7.5v3m0-7.5v3M12 6v3m0-7.5v3"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 1.5v21m10.5 0v-21M12 19.5v3m0-7.5v3m0-7.5v3M12 6v3m0-7.5v3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 3v42m21 0V3M24 39v6m0-15v6m0-15v6m0-15v6m0-15v6"
  }))
};
var Road$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$52,
    fill: "none"
  }));
});
var compPaths$51 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21 20.25h-7m10-4.504l-5.5.004"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.845 12.852l3.352-5.757-2.665 6.554c-.288.706-.826 1.726-1.671 1.53-.47-.109-.806-.674-.95-1.351-.092-.433-.115-.893-.136-1.351.075.317.39 1.317 1.168 1.198.299-.049.62-.342.902-.823z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.99 6.75a4.521 4.521 0 004.312-3.164c.17-.542.841-.723 1.244-.32l3.541 3.54a2.245 2.245 0 010 3.174l-10.27 10.27H4.138a1.888 1.888 0 01-.609-3.676l2.567-.873a2.651 2.651 0 001.706-1.823L11 1.94"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21 20.25h-7m10-4.504l-5.5.004"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.845 12.852l3.352-5.757-2.665 6.554c-.288.706-.826 1.726-1.671 1.53-.47-.109-.806-.674-.95-1.351-.092-.433-.115-.893-.136-1.351.075.317.39 1.317 1.168 1.198.299-.049.62-.342.902-.823z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.99 6.75a4.521 4.521 0 004.312-3.164c.17-.542.841-.723 1.244-.32l3.541 3.54a2.245 2.245 0 010 3.174l-10.27 10.27H4.138a1.888 1.888 0 01-.609-3.676l2.567-.873a2.651 2.651 0 001.706-1.823L11 1.94"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M42 40.5H28m20-9.008L37 31.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M25.69 25.704l6.703-11.514-5.33 13.108c-.576 1.412-1.652 3.452-3.342 3.06-.94-.218-1.612-1.348-1.9-2.702-.184-.866-.23-1.786-.272-2.702.15.634.78 2.634 2.336 2.396.598-.098 1.24-.684 1.804-1.646z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M23.98 13.5c4.046 0 7.472-2.66 8.624-6.328.34-1.084 1.682-1.446 2.488-.64l7.082 7.08a4.49 4.49 0 010 6.348L21.634 40.5H8.276A3.775 3.775 0 014.5 36.724a3.779 3.779 0 012.558-3.576l5.134-1.746a5.303 5.303 0 003.412-3.646L22 3.882"
  }))
};
var Run$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$51,
    fill: "none"
  }));
});
var compPaths$50 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14 21h7v-1.5h-7V21zm4.5-4.5l5.5-.004v-1.5L18.5 15v1.5zm-4.969-2.851c-.287.706-.825 1.726-1.67 1.53-.47-.11-.807-.674-.95-1.351-.093-.433-.115-.892-.137-1.351.075.318.391 1.318 1.168 1.198.3-.048.62-.342.902-.823l3.352-5.757-2.665 6.554zm8.086-7.373l-3.54-3.541a1.477 1.477 0 00-1.407-.395 1.503 1.503 0 00-1.082 1.022A3.756 3.756 0 0111.99 6h-1.3l1.034-3.865-1.449-.388-3.197 11.937a1.9 1.9 0 01-1.224 1.307l-2.566.873A2.638 2.638 0 004.138 21h6.99l10.49-10.49a2.996 2.996 0 000-4.234z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14 21h7v-1.5h-7V21zm4.5-4.5l5.5-.004v-1.5L18.5 15v1.5zm-4.969-2.851c-.287.706-.825 1.726-1.67 1.53-.47-.11-.807-.674-.95-1.351-.093-.433-.115-.892-.137-1.351.075.318.391 1.318 1.168 1.198.3-.048.62-.342.902-.823l3.352-5.757-2.665 6.554zm8.086-7.373l-3.54-3.541a1.477 1.477 0 00-1.407-.395 1.503 1.503 0 00-1.082 1.022A3.756 3.756 0 0111.99 6h-1.3l1.034-3.865-1.449-.388-3.197 11.937a1.9 1.9 0 01-1.224 1.307l-2.566.873A2.638 2.638 0 004.138 21h6.99l10.49-10.49a2.996 2.996 0 000-4.234z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M28 42h14v-3H28v3zm9-12v3l11-.008v-3L37 30zm-9.937-2.702c-.575 1.412-1.65 3.452-3.342 3.06-.94-.218-1.613-1.348-1.898-2.702-.186-.866-.23-1.784-.274-2.702.15.636.782 2.636 2.335 2.396.6-.096 1.24-.684 1.805-1.646l6.703-11.514-5.33 13.108zm16.171-14.746L36.153 5.47a2.954 2.954 0 00-2.813-.79 3.006 3.006 0 00-2.164 2.044A7.512 7.512 0 0123.982 12h-2.603l2.07-7.73-2.898-.776-6.394 23.874a3.8 3.8 0 01-2.447 2.614l-5.133 1.746A5.276 5.276 0 008.276 42h13.979l20.98-20.98a5.992 5.992 0 000-8.468z",
    clipRule: "evenodd"
  }))
};
var RunFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$50,
    fill: "none"
  }));
});
var compPaths$4$ = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.25 8.25a3 3 0 100-6 3 3 0 000 6zM9 15l-6.97 6.97m6.47-1.72h6.43c.67 0 1.01-.81.53-1.29l-4.15-4.15a1.49 1.49 0 010-2.12l1.66-1.66c.47-.47.14-1.28-.53-1.28H7.5L5.25 12m10.23-.95l2.21 2.2c.59.58 1.53.58 2.12 0l2.21-2.2"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.25 8.25a3 3 0 100-6 3 3 0 000 6zM9 15l-6.97 6.97m6.47-1.72h6.43c.67 0 1.01-.81.53-1.29l-4.15-4.15a1.49 1.49 0 010-2.12l1.66-1.66c.47-.47.14-1.28-.53-1.28H7.5L5.25 12m10.23-.95l2.21 2.2c.59.58 1.53.58 2.12 0l2.21-2.2"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M34.5 16.5a6 6 0 100-12 6 6 0 000 12zM18 30L4.06 43.94M17 40.5h12.86c1.34 0 2.02-1.62 1.06-2.58l-8.3-8.3c-1.18-1.18-1.18-3.08 0-4.24l3.32-3.32c.94-.94.28-2.56-1.06-2.56H15L10.5 24m20.46-1.9l4.42 4.4a3.018 3.018 0 004.24 0l4.42-4.4"
  }))
};
var Runner$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4$,
    fill: "none"
  }));
});
var compPaths$4_ = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2",
    d: "M17.25 8.25a3 3 0 100-6 3 3 0 000 6zM9 15l-6.97 6.97m6.47-1.72h6.43c.67 0 1.01-.81.53-1.29l-4.15-4.15a1.49 1.49 0 010-2.12l1.66-1.66c.47-.47.14-1.28-.53-1.28H7.5L5.25 12m10.23-.95l2.21 2.2c.59.58 1.53.58 2.12 0l2.21-2.2"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2",
    d: "M17.25 8.25a3 3 0 100-6 3 3 0 000 6zM9 15l-6.97 6.97m6.47-1.72h6.43c.67 0 1.01-.81.53-1.29l-4.15-4.15a1.49 1.49 0 010-2.12l1.66-1.66c.47-.47.14-1.28-.53-1.28H7.5L5.25 12m10.23-.95l2.21 2.2c.59.58 1.53.58 2.12 0l2.21-2.2"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "4",
    d: "M34.5 16.5a6 6 0 100-12 6 6 0 000 12zM18 30L4.06 43.94M17 40.5h12.86c1.34 0 2.02-1.62 1.06-2.58l-8.3-8.3c-1.18-1.18-1.18-3.08 0-4.24l3.32-3.32c.94-.94.28-2.56-1.06-2.56H15L10.5 24m20.46-1.9l4.42 4.4a3.018 3.018 0 004.24 0l4.42-4.4"
  }))
};
var RunnerStroke$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4_,
    fill: "none"
  }));
});
var compPaths$4Z = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M21 20.25h-7m10-4.504l-5.5.004"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.845 12.852l3.352-5.757-2.665 6.554c-.288.706-.826 1.726-1.671 1.53-.47-.109-.806-.674-.95-1.351-.092-.433-.115-.893-.136-1.351.075.317.39 1.317 1.168 1.198.299-.049.62-.342.902-.823z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M11.99 6.75a4.521 4.521 0 004.312-3.164c.17-.542.841-.723 1.244-.32l3.541 3.54a2.245 2.245 0 010 3.174l-10.27 10.27H4.138a1.888 1.888 0 01-.609-3.676l2.567-.873a2.651 2.651 0 001.706-1.823L11 1.94"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M21 20.25h-7m10-4.504l-5.5.004"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.845 12.852l3.352-5.757-2.665 6.554c-.288.706-.826 1.726-1.671 1.53-.47-.109-.806-.674-.95-1.351-.092-.433-.115-.893-.136-1.351.075.317.39 1.317 1.168 1.198.299-.049.62-.342.902-.823z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M11.99 6.75a4.521 4.521 0 004.312-3.164c.17-.542.841-.723 1.244-.32l3.541 3.54a2.245 2.245 0 010 3.174l-10.27 10.27H4.138a1.888 1.888 0 01-.609-3.676l2.567-.873a2.651 2.651 0 001.706-1.823L11 1.94"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M42 40.5H28m20-9.008L37 31.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M25.69 25.704l6.703-11.514-5.33 13.108c-.576 1.412-1.652 3.452-3.342 3.06-.94-.218-1.612-1.348-1.9-2.702-.184-.866-.23-1.786-.272-2.702.15.634.78 2.634 2.336 2.396.598-.098 1.24-.684 1.804-1.646z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M23.98 13.5c4.046 0 7.472-2.66 8.624-6.328.34-1.084 1.682-1.446 2.488-.64l7.082 7.08a4.49 4.49 0 010 6.348L21.634 40.5H8.276A3.775 3.775 0 014.5 36.724a3.779 3.779 0 012.558-3.576l5.134-1.746a5.303 5.303 0 003.412-3.646L22 3.882"
  }))
};
var RunStroke$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4Z,
    fill: "none"
  }));
});
var compPaths$4Y = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.75 6.75a3 3 0 11-6 0 3 3 0 016 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.25 16.5A3.75 3.75 0 1118 20.25h-7.5a3.75 3.75 0 010-7.5m-.75.75a3.75 3.75 0 016-3m.33.277A3.736 3.736 0 0013.5 9.75M6.75 2V.5m3.359 2.892l1.06-1.061M2.33 11.169l1.062-1.061M11.5 6.75H13m-12.5 0H2m.33-4.419l1.062 1.061"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.75 6.75a3 3 0 11-6 0 3 3 0 016 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.25 16.5A3.75 3.75 0 1118 20.25h-7.5a3.75 3.75 0 010-7.5m-.75.75a3.75 3.75 0 016-3m.33.277A3.736 3.736 0 0013.5 9.75M6.75 2V.5m3.359 2.892l1.06-1.061M2.33 11.169l1.062-1.061M11.5 6.75H13m-12.5 0H2m.33-4.419l1.062 1.061"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M19.5 13.5a6 6 0 11-12 0 6 6 0 0112 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M28.5 33a7.5 7.5 0 117.5 7.5H21a7.5 7.5 0 010-15M19.5 27a7.5 7.5 0 0112-6m.658.555A7.472 7.472 0 0027 19.5M13.5 4V1m6.718 5.783l2.122-2.122M4.661 22.338l2.122-2.122M23 13.5h3m-25 0h3m.661-8.838l2.122 2.122"
  }))
};
var Sport$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4Y,
    fill: "none"
  }));
});
var compPaths$4X = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 2.25H18a2.25 2.25 0 012.25 2.25V18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15 21.75H6a2.25 2.25 0 01-2.25-2.25v-12A2.25 2.25 0 016 5.25h9a2.25 2.25 0 012.25 2.25v12A2.25 2.25 0 0115 21.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.209 10.667L9.436 15.44l-2.652-2.652"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 2.25H18a2.25 2.25 0 012.25 2.25V18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15 21.75H6a2.25 2.25 0 01-2.25-2.25v-12A2.25 2.25 0 016 5.25h9a2.25 2.25 0 012.25 2.25v12A2.25 2.25 0 0115 21.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.209 10.667L9.436 15.44l-2.652-2.652"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 4.5h21c2.484 0 4.5 2.016 4.5 4.5v27"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M30 43.5H12A4.502 4.502 0 017.5 39V15c0-2.484 2.016-4.5 4.5-4.5h18c2.484 0 4.5 2.016 4.5 4.5v24c0 2.484-2.016 4.5-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M28.418 21.334l-9.546 9.546-5.304-5.304"
  }))
};
var Stages$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4X,
    fill: "none"
  }));
});
var compPaths$4W = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 5.25H6m9 4.5H9m6 4.5H9m6 4.5H9"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 5.25H6m9 4.5H9m6 4.5H9m6 4.5H9"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M36 10.5H12m18 9H18m12 9H18m12 9H18"
  }))
};
var Tighten$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4W,
    fill: "none"
  }));
});
var compPaths$4V = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 21.75v0a6.002 6.002 0 01-6.002-6.002V8.252a6.002 6.002 0 0112.004 0v7.496A6.002 6.002 0 0112 21.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.998 18.75v0a3 3 0 01-3-3V8.249a3 3 0 016 0v7.501a3 3 0 01-3 3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "1.5",
    d: "M5.998 15.75h2.887m.17-2.25h2.887m.113-3h2.887m.363-2.25h2.583"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.961 7.5l.037 9"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 21.75v0a6.002 6.002 0 01-6.002-6.002V8.252a6.002 6.002 0 0112.004 0v7.496A6.002 6.002 0 0112 21.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.998 18.75v0a3 3 0 01-3-3V8.249a3 3 0 016 0v7.501a3 3 0 01-3 3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "1.5",
    d: "M5.998 15.75h2.887m.17-2.25h2.887m.113-3h2.887m.363-2.25h2.583"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.961 7.5l.037 9"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 43.5v0c-6.63 0-12.004-5.376-12.004-12.004V16.504C11.996 9.876 17.37 4.5 24 4.5s12.004 5.376 12.004 12.004v14.992C36.004 38.124 30.63 43.5 24 43.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M23.995 37.5v0a6 6 0 01-6-6V16.498a6 6 0 0112 0V31.5a6 6 0 01-6 6z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "3",
    d: "M11.996 31.5h5.774m.34-4.5h5.773m.227-6h5.773m.727-4.5h5.165"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M23.923 15l.072 18"
  }))
};
var Track$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4V,
    fill: "none"
  }));
});
var compPaths$4U = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.5 17.25H3M3.75 15V7.5a3.75 3.75 0 017.5 0v8.25a4.5 4.5 0 009 0V7.5a2.25 2.25 0 00-4.5 0V14a3.25 3.25 0 01-3.25 3.25H6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.5 17.25H3M3.75 15V7.5a3.75 3.75 0 017.5 0v8.25a4.5 4.5 0 009 0V7.5a2.25 2.25 0 00-4.5 0V14a3.25 3.25 0 01-3.25 3.25H6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M9 34.5H6M7.5 30V15a7.5 7.5 0 0115 0v16.5a9 9 0 0018 0V15c0-2.484-2.016-4.5-4.5-4.5a4.502 4.502 0 00-4.5 4.5v13a6.5 6.5 0 01-6.5 6.5H12"
  }))
};
var Trail$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4U,
    fill: "none"
  }));
});
var compPaths$4T = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 20.25a1.5 1.5 0 000-3H5.25a1.5 1.5 0 000 3h13.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.265 16.958L20 6.75h-8.75a1.5 1.5 0 000 3h5.25m.744-2.7l1.05-3.917"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 18.75a1.5 1.5 0 11-3.001-.001 1.5 1.5 0 013.001.001zm13.5 0a1.5 1.5 0 11-3.001-.001 1.5 1.5 0 013.001.001z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 20.25a1.5 1.5 0 000-3H5.25a1.5 1.5 0 000 3h13.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.265 16.958L20 6.75h-8.75a1.5 1.5 0 000 3h5.25m.744-2.7l1.05-3.917"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 18.75a1.5 1.5 0 11-3.001-.001 1.5 1.5 0 013.001.001zm13.5 0a1.5 1.5 0 11-3.001-.001 1.5 1.5 0 013.001.001z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M37.5 40.5a3.001 3.001 0 000-6h-27a3.001 3.001 0 000 6h27z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.529 33.916l5.47-20.416h-17.5a3.001 3.001 0 000 6h10.5m1.489-5.398l2.1-7.836"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 37.5a3.001 3.001 0 01-6 0 3.001 3.001 0 016 0zm27 0a3.001 3.001 0 01-6 0 3.001 3.001 0 016 0z",
    clipRule: "evenodd"
  }))
};
var Treadmill$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4T,
    fill: "none"
  }));
});
var compPaths$4S = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 6.75a4.5 4.5 0 000 9h10.5a4.49 4.49 0 003.182-1.318 4.49 4.49 0 001.318-3.182 4.49 4.49 0 00-1.318-3.182A4.49 4.49 0 0017.25 6.75a4.49 4.49 0 00-3.182 1.318 4.49 4.49 0 00-1.318 3.182m-6-3.75a5.25 5.25 0 019.645-2.873M15.25 20.821l-.75 1.3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M9.35 20.446l-.75 1.3 1.3.75.75-1.3-1.3-.75zm2.995-5.188L10.1 19.146l1.3.75 2.245-3.888-1.3-.75zM4.1 20.446l-.75 1.3 1.3.75.75-1.3-1.3-.75zm2.994-5.187L4.85 19.146l1.3.75 2.244-3.887-1.3-.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.326 15.493L16 19.521"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 6.75a4.5 4.5 0 000 9h10.5a4.49 4.49 0 003.182-1.318 4.49 4.49 0 001.318-3.182 4.49 4.49 0 00-1.318-3.182A4.49 4.49 0 0017.25 6.75a4.49 4.49 0 00-3.182 1.318 4.49 4.49 0 00-1.318 3.182m-6-3.75a5.25 5.25 0 019.645-2.873M15.25 20.821l-.75 1.3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M9.35 20.446l-.75 1.3 1.3.75.75-1.3-1.3-.75zm2.995-5.188L10.1 19.146l1.3.75 2.245-3.888-1.3-.75zM4.1 20.446l-.75 1.3 1.3.75.75-1.3-1.3-.75zm2.994-5.187L4.85 19.146l1.3.75 2.244-3.887-1.3-.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.326 15.493L16 19.521"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 13.5a9 9 0 000 18h21a8.98 8.98 0 006.364-2.636A8.98 8.98 0 0043.5 22.5a8.98 8.98 0 00-2.636-6.364A8.98 8.98 0 0034.5 13.5a8.98 8.98 0 00-6.364 2.636A8.98 8.98 0 0025.5 22.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 15c0-5.798 4.702-10.5 10.5-10.5a10.49 10.49 0 018.79 4.754M30.5 41.643L29 44.24"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M18.701 40.893l-1.5 2.598 2.598 1.5 1.5-2.598-2.598-1.5zm5.99-10.377l-4.49 7.776 2.598 1.5 4.49-7.775-2.598-1.5zM8.201 40.892l-1.5 2.598 2.598 1.5 1.5-2.597-2.598-1.5zm5.988-10.373L9.7 38.293l2.598 1.5 4.488-7.774-2.598-1.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36.652 30.986L32 39.042"
  }))
};
var WeatherHail$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4S,
    fill: "none"
  }));
});
var compPaths$4R = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 6.75a1.5 1.5 0 11-3.001-.001 1.5 1.5 0 013.001.001zM8.25 9c0-2.293.736-4.413 1.983-6.14.134-.185-.018-.445-.241-.398-4.647.974-8.08 5.252-7.716 10.267.331 4.557 3.921 8.366 8.454 8.94a9.72 9.72 0 007.02-1.8c.184-.135.092-.42-.135-.443C12.352 18.859 8.25 14.414 8.25 9z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.72 10.72l1.06 1.06m1.94-1.06l1.06 1.06m-1.06-4.09l1.06 1.06"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 6.75a1.5 1.5 0 11-3.001-.001 1.5 1.5 0 013.001.001zM8.25 9c0-2.293.736-4.413 1.983-6.14.134-.185-.018-.445-.241-.398-4.647.974-8.08 5.252-7.716 10.267.331 4.557 3.921 8.366 8.454 8.94a9.72 9.72 0 007.02-1.8c.184-.135.092-.42-.135-.443C12.352 18.859 8.25 14.414 8.25 9z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.72 10.72l1.06 1.06m1.94-1.06l1.06 1.06m-1.06-4.09l1.06 1.06"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 13.5a3.001 3.001 0 01-6 0 3.001 3.001 0 016 0zm-18 4.5c0-4.586 1.472-8.826 3.966-12.28.268-.37-.036-.89-.482-.796C10.69 6.872 3.824 15.428 4.552 25.458c.662 9.114 7.842 16.732 16.908 17.88 5.274.67 10.19-.78 14.04-3.6.368-.27.184-.838-.27-.886C24.704 37.718 16.5 28.828 16.5 18z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33.44 21.44l2.121 2.121m3.879-2.121l2.121 2.121m-2.121-8.182l2.12 2.121"
  }))
};
var WeatherNightClear$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4R,
    fill: "none"
  }));
});
var compPaths$4Q = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.75 16.5a3.75 3.75 0 113.75 3.75H6a3.75 3.75 0 010-7.5m-.75.75a3.75 3.75 0 016-3m.33.277A3.736 3.736 0 009 9.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.223 6.325c0-.65.134-1.27.374-1.833.19-.444-.27-.907-.7-.685a4.342 4.342 0 00-2.293 4.531c.286 1.89 1.864 3.407 3.763 3.631a4.347 4.347 0 002.069-.253c.448-.17.404-.819-.05-.973a4.669 4.669 0 01-3.163-4.418z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.75 16.5a3.75 3.75 0 113.75 3.75H6a3.75 3.75 0 010-7.5m-.75.75a3.75 3.75 0 016-3m.33.277A3.736 3.736 0 009 9.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.223 6.325c0-.65.134-1.27.374-1.833.19-.444-.27-.907-.7-.685a4.342 4.342 0 00-2.293 4.531c.286 1.89 1.864 3.407 3.763 3.631a4.347 4.347 0 002.069-.253c.448-.17.404-.819-.05-.973a4.669 4.669 0 01-3.163-4.418z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M19.5 33a7.5 7.5 0 117.5 7.5H12a7.5 7.5 0 010-15M10.5 27a7.5 7.5 0 0112-6m.658.555A7.472 7.472 0 0018 19.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36.445 12.65c0-1.302.268-2.542.748-3.666.38-.888-.54-1.814-1.398-1.37a8.683 8.683 0 00-4.588 9.062c.572 3.78 3.728 6.814 7.526 7.262a8.693 8.693 0 004.138-.506c.896-.342.808-1.638-.1-1.946-3.678-1.254-6.326-4.732-6.326-8.836z",
    clipRule: "evenodd"
  }))
};
var WeatherNightOvercast$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4Q,
    fill: "none"
  }));
});
var compPaths$4P = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 9.75a4.5 4.5 0 000 9h10.5a4.5 4.5 0 10-4.5-4.5m-6-3.75a5.25 5.25 0 019.645-2.873"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 9.75a4.5 4.5 0 000 9h10.5a4.5 4.5 0 10-4.5-4.5m-6-3.75a5.25 5.25 0 019.645-2.873"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 19.5a9 9 0 000 18h21a9 9 0 10-9-9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 21c0-5.798 4.702-10.5 10.5-10.5a10.49 10.49 0 018.79 4.754"
  }))
};
var WeatherOvercast$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4P,
    fill: "none"
  }));
});
var compPaths$4O = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 21.75h10.5m-6-3h-12m11.25-7.5a4.5 4.5 0 114.5 4.5H6.75a4.5 4.5 0 010-9m0 .75a5.25 5.25 0 019.645-2.873M21.75 19.5a2.25 2.25 0 01-2.25 2.25"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 21.75h10.5m-6-3h-12m11.25-7.5a4.5 4.5 0 114.5 4.5H6.75a4.5 4.5 0 010-9m0 .75a5.25 5.25 0 019.645-2.873M21.75 19.5a2.25 2.25 0 01-2.25 2.25"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18 43.5h21m-12-6H3m22.5-15a9 9 0 119 9h-21a9 9 0 010-18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 15c0-5.798 4.702-10.5 10.5-10.5a10.49 10.49 0 018.79 4.754M43.5 39c0 2.484-2.016 4.5-4.5 4.5"
  }))
};
var WeatherOvercastWind$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4O,
    fill: "none"
  }));
});
var compPaths$4N = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 6.75a4.5 4.5 0 000 9h10.5a4.5 4.5 0 10-4.5-4.5m-6-3.75a5.25 5.25 0 019.645-2.873"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.995 15.633l-2.245 3.889-1.5 2.598m-1.506-6.485L5.5 19.522 4 22.12m14.326-6.627L16 19.521l-1.5 2.6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 6.75a4.5 4.5 0 000 9h10.5a4.5 4.5 0 10-4.5-4.5m-6-3.75a5.25 5.25 0 019.645-2.873"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.995 15.633l-2.245 3.889-1.5 2.598m-1.506-6.485L5.5 19.522 4 22.12m14.326-6.627L16 19.521l-1.5 2.6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 13.5a9 9 0 000 18h21a9 9 0 10-9-9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 15c0-5.798 4.702-10.5 10.5-10.5a10.49 10.49 0 018.79 4.754m-6.8 22.012l-4.49 7.778-3 5.196m-3.012-12.97L11 39.044 8 44.24m28.653-13.254L32 39.042l-3 5.198"
  }))
};
var WeatherRain$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4N,
    fill: "none"
  }));
});
var compPaths$4M = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.5 12h-5m14.75 0H14.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.25 12a2.25 2.25 0 11-4.502-.002A2.25 2.25 0 0114.25 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 21v-3.75H21M9.349 21.977l2.65-2.65 2.653 2.65M6.75 21v-3.75H3M6.75 3v3.75H3M17.25 3v3.75H21"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.349 21.974l2.65-2.651 2.653 2.65m-.001-19.947l-2.65 2.651-2.653-2.65M2.026 9.349l2.651 2.65-2.65 2.653m19.947-.001l-2.651-2.65 2.65-2.653m-11.778.972L6.66 6.785m10.43 10.43l-3.358-3.358m-1.857-4.232v-5m0 14.75v-4.75m1.68-4.305l3.535-3.535M6.66 17.215l3.358-3.358"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.5 12h-5m14.75 0H14.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.25 12a2.25 2.25 0 11-4.502-.002A2.25 2.25 0 0114.25 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 21v-3.75H21M9.349 21.977l2.65-2.65 2.653 2.65M6.75 21v-3.75H3M6.75 3v3.75H3M17.25 3v3.75H21"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.349 21.974l2.65-2.651 2.653 2.65m-.001-19.947l-2.65 2.651-2.653-2.65M2.026 9.349l2.651 2.65-2.65 2.653m19.947-.001l-2.651-2.65 2.65-2.653m-11.778.972L6.66 6.785m10.43 10.43l-3.358-3.358m-1.857-4.232v-5m0 14.75v-4.75m1.68-4.305l3.535-3.535M6.66 17.215l3.358-3.358"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M19 24H9m29.5 0H29"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M28.5 24c0 2.484-2.016 4.5-4.5 4.5a4.502 4.502 0 01-4.5-4.5c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 42v-7.5H42m-23.303 9.455l5.302-5.302 5.304 5.302M13.5 42v-7.5H6M13.5 6v7.5H6M34.5 6v7.5H42"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.697 43.947l5.302-5.302 5.304 5.302m0-39.894L24 9.355l-5.304-5.302M4.053 18.697l5.302 5.302-5.302 5.304m39.894 0L38.645 24l5.302-5.304M20.39 20.64l-7.07-7.07m20.86 20.86l-6.716-6.716M23.75 19.25v-10m0 29.5v-9.5m3.36-8.61l7.07-7.07M13.32 34.43l6.716-6.716"
  }))
};
var WeatherSnow$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4M,
    fill: "none"
  }));
});
var compPaths$4L = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 19.5v3m0-21v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 12a5.25 5.25 0 11-10.501-.001A5.25 5.25 0 0117.25 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.697 17.304l-2.122 2.12m14.85-14.849l-2.122 2.121M4.5 12h-3m21 0h-3M6.697 6.696l-2.122-2.12m14.85 14.849l-2.122-2.121"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 19.5v3m0-21v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 12a5.25 5.25 0 11-10.501-.001A5.25 5.25 0 0117.25 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.697 17.304l-2.122 2.12m14.85-14.849l-2.122 2.121M4.5 12h-3m21 0h-3M6.697 6.696l-2.122-2.12m14.85 14.849l-2.122-2.121"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 39v6m0-42v6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 24c0 5.798-4.702 10.5-10.5 10.5S13.5 29.798 13.5 24 18.202 13.5 24 13.5 34.5 18.202 34.5 24z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.394 34.607L9.15 38.85m29.7-29.7l-4.244 4.242M9 24H3m42 0h-6M13.394 13.393L9.15 9.15m29.7 29.7l-4.244-4.242"
  }))
};
var WeatherSunny$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4L,
    fill: "none"
  }));
});
var compPaths$4K = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.25 6a3.75 3.75 0 01-3.75 3.75h-9m15.75.75a2.25 2.25 0 112.25 2.25h-18M12.75 18A2.25 2.25 0 1015 15.75H1.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.25 6a3.75 3.75 0 01-3.75 3.75h-9m15.75.75a2.25 2.25 0 112.25 2.25h-18M12.75 18A2.25 2.25 0 1015 15.75H1.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M28.5 12a7.5 7.5 0 01-7.5 7.5H3M34.5 21a4.5 4.5 0 114.5 4.5H3M25.5 36a4.5 4.5 0 104.5-4.5H3"
  }))
};
var WeatherWind$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4K,
    fill: "none"
  }));
});
var compPaths$4J = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M10.5 8.25h6m-6 3.75h6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 8.25H7.5M9 12H7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M10.5 15.75h6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 15.75H7.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M10.5 8.25h6m-6 3.75h6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 8.25H7.5M9 12H7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M10.5 15.75h6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 15.75H7.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "3",
    d: "M21 16.5h12M21 24h12"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 40.5H12A4.5 4.5 0 017.5 36V12A4.5 4.5 0 0112 7.5h24c2.484 0 4.5 2.016 4.5 4.5v24c0 2.484-2.016 4.5-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18 16.5h-3m3 7.5h-3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "3",
    d: "M21 31.5h12"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18 31.5h-3"
  }))
};
var Whiteboard$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4J,
    fill: "none"
  }));
});
var compPaths$4I = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 18.75h3V5.25h-3v13.5zm13.5 0h3V5.25h-3v13.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 12h8.25M20 12h2.5m-21 0H4"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 18.75h3V5.25h-3v13.5zm13.5 0h3V5.25h-3v13.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 12h8.25M20 12h2.5m-21 0H4"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 37.5h6v-27h-6v27zm27 0h6v-27h-6v27z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18 24h16.5m5.5 0h5M3 24h5"
  }))
};
var WorkoutEquipment$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4I,
    fill: "none"
  }));
});
var compPaths$4H = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15.712 8.72l-4.242 4.243 1.06 1.06 4.243-4.243-1.061-1.06zm-3.181 5.303l4.242-4.243-1.061-1.06-4.242 4.243 1.06 1.06zM7.5 3h9V1.5h-9V3zm9-1.5h-9V3h9V1.5zm3 12A7.5 7.5 0 0112 21v1.5a9 9 0 009-9h-1.5zM12 21a7.5 7.5 0 01-7.5-7.5H3a9 9 0 009 9V21zm-7.5-7.5A7.5 7.5 0 0112 6V4.5a9 9 0 00-9 9h1.5zM12 6a7.5 7.5 0 017.5 7.5H21a9 9 0 00-9-9V6z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15.712 8.72l-4.242 4.243 1.06 1.06 4.243-4.243-1.061-1.06zm-3.181 5.303l4.242-4.243-1.061-1.06-4.242 4.243 1.06 1.06zM7.5 3h9V1.5h-9V3zm9-1.5h-9V3h9V1.5zm3 12A7.5 7.5 0 0112 21v1.5a9 9 0 009-9h-1.5zM12 21a7.5 7.5 0 01-7.5-7.5H3a9 9 0 009 9V21zm-7.5-7.5A7.5 7.5 0 0112 6V4.5a9 9 0 00-9 9h1.5zM12 6a7.5 7.5 0 017.5 7.5H21a9 9 0 00-9-9V6z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M40.5 27c0 9.112-7.386 16.5-16.5 16.5S7.5 36.112 7.5 27 14.886 10.5 24 10.5 40.5 17.888 40.5 27z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 4.5h18m-.516 14L24 26.986"
  }))
};
var Workouts$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4H,
    fill: "none"
  }));
});
var compPaths$4G = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 2.25h9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.53 14.023l-1.06-1.061 4.242-4.242 1.06 1.06-4.241 4.243zM12 4.5c-4.963 0-9 4.038-9 9s4.037 9 9 9 9-4.038 9-9-4.037-9-9-9z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 2.25h9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.53 14.023l-1.06-1.061 4.242-4.242 1.06 1.06-4.241 4.243zM12 4.5c-4.963 0-9 4.038-9 9s4.037 9 9 9 9-4.038 9-9-4.037-9-9-9z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 4.5h18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M25.06 28.046l-2.121-2.122 8.485-8.484 2.12 2.12-8.483 8.486zM24 9C14.075 9 6 17.076 6 27s8.075 18 18 18c9.926 0 18-8.076 18-18S33.927 9 24 9z",
    clipRule: "evenodd"
  }))
};
var WorkoutsFilled$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4G,
    fill: "none"
  }));
});
var compPaths$4F = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M20.25 13.5a8.25 8.25 0 11-16.5 0 8.25 8.25 0 1116.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M7.5 2.25h9m-.258 7L12 13.493"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M20.25 13.5a8.25 8.25 0 11-16.5 0 8.25 8.25 0 1116.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M7.5 2.25h9m-.258 7L12 13.493"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M40.5 27c0 9.112-7.386 16.5-16.5 16.5S7.5 36.112 7.5 27 14.886 10.5 24 10.5 40.5 17.888 40.5 27z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M15 4.5h18m-.516 14L24 26.986"
  }))
};
var WorkoutsStroke$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4F,
    fill: "none"
  }));
});
var compPaths$4E = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 17.5V5m-5.5 7.5L12 18l5.5-5.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.966 12.979L12 19.945 5.033 12.98M12 20V3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M37.933 25.957L24 39.891 10.067 25.957M24 40V6"
  }))
};
var ArrowDown$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4E,
    fill: "none"
  }));
});
var compPaths$4D = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.5 12H19m-7.5 5.5L6 12l5.5-5.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.021 18.967L4.055 12l6.966-6.967M4 12h17"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M22.042 37.933L8.11 24l13.932-13.934M8 24h34"
  }))
};
var ArrowLeft$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4D,
    fill: "none"
  }));
});
var compPaths$4C = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.5 12H5m7.5 5.5L18 12l-5.5-5.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.979 18.967L19.945 12 12.98 5.033M20 12H3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M25.957 37.933L39.891 24 25.957 10.065M40 24H6"
  }))
};
var ArrowRight$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4C,
    fill: "none"
  }));
});
var compPaths$4B = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 6.5V19m-5.5-7.5L12 6l5.5 5.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.033 11.022L12 4.055l6.967 6.967M12 4v17"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M10.066 22.043L24 8.109l13.934 13.934M24 8v34"
  }))
};
var ArrowUp$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4B,
    fill: "none"
  }));
});
var compPaths$4A = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M4.75 12c0 4 3.25 7.25 7.25 7.25S19.25 16 19.25 12 16 4.75 12 4.75 4.75 8 4.75 12z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.792 10.646L12 13.854l3.208-3.208"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 21.75A9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12 9.75 9.75 0 0112 21.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.333 10.667L12 14.334l3.667-3.667"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 43.5C13.23 43.5 4.5 34.77 4.5 24S13.23 4.5 24 4.5 43.5 13.23 43.5 24 34.77 43.5 24 43.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.208 21.208L24 29l7.793-7.792"
  }))
};
var CaretCircleDown = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4A,
    fill: "none"
  }));
});
var compPaths$4z = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8zm2.678 6.2L12 12.88 9.322 10.2l-1.06 1.06L12 15l3.739-3.739-1.061-1.06z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 1.5c5.79 0 10.5 4.71 10.5 10.5S17.79 22.5 12 22.5 1.5 17.79 1.5 12 6.21 1.5 12 1.5zm3.136 8.636L12 13.273l-3.136-3.137-1.061 1.061L12 15.394l4.197-4.197-1.06-1.06z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M24 3c11.58 0 21 9.42 21 21s-9.42 21-21 21S3 35.58 3 24 12.42 3 24 3zm6.731 17.026L24 26.757l-6.73-6.73-2.121 2.12L23.999 31l8.853-8.852-2.12-2.122z",
    clipRule: "evenodd"
  }))
};
var CaretCircleDownFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4z,
    fill: "none"
  }));
});
var compPaths$4y = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 4.75C8 4.75 4.75 8 4.75 12S8 19.25 12 19.25 19.25 16 19.25 12 16 4.75 12 4.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.354 8.792L10.146 12l3.208 3.209"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 12A9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12 9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.333 8.333L9.667 12l3.666 3.666"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M4.5 24C4.5 13.23 13.23 4.5 24 4.5S43.5 13.23 43.5 24 34.77 43.5 24 43.5 4.5 34.77 4.5 24z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M26.792 16.208L19 24l7.792 7.793"
  }))
};
var CaretCircleLeft = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4y,
    fill: "none"
  }));
});
var compPaths$4x = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 12c0 4.41-3.59 8-8 8s-8-3.59-8-8 3.59-8 8-8 8 3.59 8 8zm-6.2 2.678L11.12 12l2.68-2.678-1.06-1.06L9 12l3.739 3.739 1.06-1.061z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.5 12c0 5.79-4.71 10.5-10.5 10.5S1.5 17.79 1.5 12 6.21 1.5 12 1.5 22.5 6.21 22.5 12zm-8.636 3.136L10.727 12l3.137-3.136-1.061-1.061L8.606 12l4.197 4.197 1.06-1.06z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M45 24c0 11.58-9.42 21-21 21S3 35.58 3 24 12.42 3 24 3s21 9.42 21 21zm-17.026 6.731L21.243 24l6.73-6.73-2.12-2.122L17 24l8.852 8.852 2.122-2.12z",
    clipRule: "evenodd"
  }))
};
var CaretCircleLeftFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4x,
    fill: "none"
  }));
});
var compPaths$4w = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 19.25c4 0 7.25-3.25 7.25-7.25S16 4.75 12 4.75 4.75 8 4.75 12 8 19.25 12 19.25z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10.646 15.208L13.854 12l-3.208-3.209"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10.667 15.667L14.333 12l-3.666-3.666"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 24c0 10.77-8.73 19.5-19.5 19.5S4.5 34.77 4.5 24 13.23 4.5 24 4.5 43.5 13.23 43.5 24z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M21.208 31.792L29 24l-7.792-7.793"
  }))
};
var CaretCircleRight = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4w,
    fill: "none"
  }));
});
var compPaths$4v = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 12c0-4.41 3.59-8 8-8s8 3.59 8 8-3.59 8-8 8-8-3.59-8-8zm6.2-2.678L12.88 12l-2.68 2.678 1.06 1.06L15 12l-3.739-3.739-1.06 1.061z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.5 12C1.5 6.21 6.21 1.5 12 1.5S22.5 6.21 22.5 12 17.79 22.5 12 22.5 1.5 17.79 1.5 12zm8.636-3.137L13.273 12l-3.137 3.136 1.061 1.06L15.394 12l-4.197-4.197-1.06 1.06z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 24C3 12.42 12.42 3 24 3s21 9.42 21 21-9.42 21-21 21S3 35.58 3 24zm17.026-6.731L26.757 24l-6.73 6.73 2.12 2.122L31 24l-8.852-8.852-2.122 2.12z",
    clipRule: "evenodd"
  }))
};
var CaretCircleRightFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4v,
    fill: "none"
  }));
});
var compPaths$4u = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M19.25 12c0-4-3.25-7.25-7.25-7.25S4.75 8 4.75 12 8 19.25 12 19.25 19.25 16 19.25 12z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.208 13.458L12 10.25l-3.209 3.208"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 2.25A9.75 9.75 0 0121.75 12 9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.667 13.667L12 10l-3.667 3.667"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 4.5c10.77 0 19.5 8.73 19.5 19.5S34.77 43.5 24 43.5 4.5 34.77 4.5 24 13.23 4.5 24 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.792 26.792L24 19l-7.792 7.792"
  }))
};
var CaretCircleUp = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4u,
    fill: "none"
  }));
});
var compPaths$4t = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-2.678-5.95L12 11.37l2.678 2.678 1.06-1.06L12 9.25l-3.739 3.739 1.061 1.06z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 22.5C6.21 22.5 1.5 17.79 1.5 12S6.21 1.5 12 1.5 22.5 6.21 22.5 12 17.79 22.5 12 22.5zm-3.136-8.242L12 11.12l3.136 3.137 1.061-1.061L12 9l-4.197 4.197 1.06 1.06z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M24 45C12.42 45 3 35.58 3 24S12.42 3 24 3s21 9.42 21 21-9.42 21-21 21zm-6.731-17.026L24 21.243l6.73 6.73 2.121-2.12L24.001 17l-8.853 8.852 2.12 2.122z",
    clipRule: "evenodd"
  }))
};
var CaretCircleUpFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4t,
    fill: "none"
  }));
});
var compPaths$4s = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.5 9.25l-5.5 5.5-5.5-5.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.966 8.476L12 15.443 5.033 8.476"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M37.933 16.951L24 30.885 10.067 16.951"
  }))
};
var CaretDown$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4s,
    fill: "none"
  }));
});
var compPaths$4r = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.75 17.5L9.25 12l5.5-5.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.525 18.966L8.558 12l6.967-6.967"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.05 37.932L17.118 24 31.05 10.066"
  }))
};
var CaretLeft$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4r,
    fill: "none"
  }));
});
var compPaths$4q = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 17.5l5.5-5.5-5.5-5.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.474 18.966L15.44 12 8.474 5.033"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.947 37.932L30.881 24 16.947 10.066"
  }))
};
var CaretRight$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4q,
    fill: "none"
  }));
});
var compPaths$4p = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.5 14.75L12 9.25l-5.5 5.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.034 15.527L12 8.561l6.967 6.966"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M10.067 31.054L24 17.122l13.934 13.932"
  }))
};
var CaretUp$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4p,
    fill: "none"
  }));
});
var compPaths$4o = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.5 6.5l-11 11m0-11l11 11"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.973 5.027L5.028 18.972M5.027 5.027l13.945 13.945"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M37.945 10.055l-27.89 27.89m0-27.89l27.89 27.89"
  }))
};
var Close$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4o,
    fill: "none"
  }));
});
var compPaths$4n = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 12H6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M19.5 12h-15"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M39 24H9"
  }))
};
var Minus$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4n,
    fill: "none"
  }));
});
var compPaths$4m = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 12H6m6 6V6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M19.5 12h-15m7.5 7.5v-15"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M39 24H9m15 15V9"
  }))
};
var Plus$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4m,
    fill: "none"
  }));
});
var compPaths$4l = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10 10H5m14 4.5h-5m-6.5-2v-5M7.958 19l8.084-14"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 10.5H3m18 3.75h-6m-9-.75v-6m1.5 12.294l9-15.588"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18 21H6m36 7.5H30M12 27V15m3 24.588L33 8.412"
  }))
};
var PlusMinus$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon$1, Object.assign({}, props, {
    paths: compPaths$4l,
    fill: "none"
  }));
});
var podiumCoreIconsModule = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Converse: Converse$1,
  Hurley: Hurley$1,
  Jordan: Jordan$1,
  NBY: NBY$1,
  NikeApp: NikeApp$1,
  NikeSwoosh: NikeSwoosh$1,
  Sustainability: Sustainability$1,
  Activity: Activity$1,
  ActivityFilled: ActivityFilled$1,
  ActivityStroke: ActivityStroke$1,
  AddFriends: AddFriends$1,
  AddPayment: AddPayment$1,
  Alert: Alert$1,
  AlertCircle: AlertCircle$1,
  AlertCircleFilled: AlertCircleFilled$1,
  Analytics: Analytics$1,
  AnalyticsFilled: AnalyticsFilled$1,
  AnalyticsStroke: AnalyticsStroke$1,
  AR: AR$1,
  Bag: Bag$1,
  BagFilled: BagFilled$1,
  BagStroke: BagStroke$1,
  Bookmark: Bookmark$1,
  BookmarkFilled: BookmarkFilled$1,
  BookmarkStroke: BookmarkStroke$1,
  BrightnessNone: BrightnessNone$1,
  Calendar: Calendar$1,
  Camera: Camera$1,
  Cards: Cards$1,
  Check: Check$1,
  CheckCircle: CheckCircle$1,
  CheckCircleFilled: CheckCircleFilled$1,
  Club: Club$1,
  ClubFilled: ClubFilled$1,
  ClubStroke: ClubStroke$1,
  Coach: Coach$1,
  Collapse: Collapse$1,
  Comments: Comments$1,
  Compare: Compare$1,
  CreateRule: CreateRule$1,
  CreateRuleFilled: CreateRuleFilled$1,
  Data,
  Delete: Delete$1,
  Desktop: Desktop$1,
  Discover: Discover$1,
  DiscoverFilled: DiscoverFilled$1,
  DiscoverStroke: DiscoverStroke$1,
  Download: Download$1,
  Edit: Edit$1,
  Ellipsis: Ellipsis$1,
  EllipsisVertical: EllipsisVertical$1,
  Expand: Expand$1,
  Experiments: Experiments$1,
  ExternalLink: ExternalLink$1,
  Favorite: Favorite$1,
  FavoriteFilled: FavoriteFilled$1,
  FavoriteStroke: FavoriteStroke$1,
  Feed: Feed$1,
  FeedStroke: FeedStroke$1,
  Filter: Filter$1,
  FirstAccess: FirstAccess$1,
  FlashlightOff: FlashlightOff$1,
  FlashlightOn: FlashlightOn$1,
  GestureSwipe: GestureSwipe$1,
  GestureTap: GestureTap$1,
  Gift: Gift$1,
  GiftCard: GiftCard$1,
  Global: Global$1,
  GridView: GridView$1,
  Hide: Hide$1,
  History: History$1,
  Home: Home$1,
  HomeFilled: HomeFilled$1,
  HomeStroke: HomeStroke$1,
  ImagenoImage: ImagenoImage$1,
  Inbox: Inbox$1,
  InboxFilled: InboxFilled$1,
  InboxStroke: InboxStroke$1,
  Info: Info$1,
  InfoCircle: InfoCircle$1,
  InfoCircleFilled: InfoCircleFilled$1,
  Journal: Journal$1,
  Link: Link$1,
  Loading: Loading$1,
  LocationPin: LocationPin$1,
  LocationPinFilled: LocationPinFilled$1,
  Lock: Lock$1,
  LockFilled: LockFilled$1,
  Measure: Measure$1,
  MemberProduct: MemberProduct$1,
  MemberRewards: MemberRewards$1,
  Menu: Menu$3,
  Menu2lines: Menu2lines$1,
  Message: Message$1,
  Microphone: Microphone$1,
  Monarch: Monarch$1,
  Multimedia: Multimedia$1,
  MultiSelect: MultiSelect$1,
  Navigation: Navigation$1,
  NikeMembership: NikeMembership$1,
  Notification: Notification$1,
  Null: Null$1,
  Orders: Orders$1,
  Payment: Payment$1,
  Personalization: Personalization$1,
  Plan: Plan$1,
  PlusCircle: PlusCircle$1,
  PlusCircleFilled: PlusCircleFilled$1,
  Print: Print$1,
  Profile: Profile$1,
  ProfileFilled: ProfileFilled$1,
  ProfileStroke: ProfileStroke$1,
  ProfileSwoosh: ProfileSwoosh$1,
  ProfileSwooshStroke: ProfileSwooshStroke$1,
  QRCode: QRCode$1,
  Question: Question$1,
  QuestionCircle: QuestionCircle$1,
  QuestionCircleFilled: QuestionCircleFilled$1,
  Rating: Rating$1,
  RatingFilled: RatingFilled$1,
  RatingStroke: RatingStroke$1,
  Receipt: Receipt$1,
  ReceiptNone: ReceiptNone$1,
  Repeat: Repeat$1,
  Replay: Replay$1,
  Report: Report$1,
  Return: Return$1,
  Review: Review$1,
  Rewards: Rewards$1,
  Rfid: Rfid$1,
  Scan: Scan$1,
  Search: Search$1,
  Settings: Settings$1,
  SettingsFilled: SettingsFilled$1,
  Share: Share$1,
  Shareaos: Shareaos$1,
  Shipping: Shipping$1,
  Shoe: Shoe$1,
  ShoeFilled: ShoeFilled$1,
  ShoeStroke: ShoeStroke$1,
  ShopnikeApp: ShopnikeApp$1,
  ShopnikeAppFilled: ShopnikeAppFilled$1,
  ShopnikeAppStroke: ShopnikeAppStroke$1,
  Shopnrc: Shopnrc$1,
  ShopnrcStroke: ShopnrcStroke$1,
  ShopSNKRS: ShopSNKRS$1,
  Show: Show$1,
  Shuffle: Shuffle$1,
  SingleSelect: SingleSelect$1,
  Sort: Sort$1,
  SortAscending: SortAscending$5,
  SortDescending: SortDescending$5,
  Store: Store$1,
  TabletHorizontal: TabletHorizontal$1,
  TabletVertical: TabletVertical$1,
  Tag: Tag$1,
  ThumbsDown: ThumbsDown$1,
  ThumbsUp: ThumbsUp$1,
  Time: Time$1,
  Tip: Tip$1,
  Transfers: Transfers$1,
  Translation: Translation$1,
  TrendingDown: TrendingDown$1,
  TrendingUp: TrendingUp$1,
  Unlock: Unlock$1,
  UnlockFilled: UnlockFilled$1,
  Upload: Upload$1,
  VideoPlayer: VideoPlayer$1,
  VR: VR$1,
  Wallet: Wallet$1,
  Zoomin: Zoomin$1,
  Zoomout: Zoomout$1,
  Columns: Columns$1,
  Container: Container$1,
  CopyPaste: CopyPaste$1,
  CopyPasteFilled: CopyPasteFilled$1,
  FormatBold: FormatBold$1,
  FormatBullet: FormatBullet$1,
  FormatItalics: FormatItalics$1,
  FormatNumberedList: FormatNumberedList$1,
  Heading: Heading$1,
  Keyboard: Keyboard$1,
  Redo: Redo$1,
  Text: Text$1,
  Undo: Undo$1,
  ClosedCaption: ClosedCaption$1,
  ClosedCaptionFilled: ClosedCaptionFilled$1,
  FastForward: FastForward$1,
  FastForwardFilled: FastForwardFilled$1,
  Music: Music$1,
  MusicFilled: MusicFilled$1,
  MusicNone: MusicNone$1,
  MusicNoneFilled: MusicNoneFilled$1,
  Mute: Mute$1,
  MuteFilled: MuteFilled$1,
  Pause: Pause$1,
  PauseFilled: PauseFilled$1,
  Play: Play$1,
  PlayFilled: PlayFilled$1,
  Rewind: Rewind$1,
  RewindFilled: RewindFilled$1,
  Stop: Stop$1,
  StopFilled: StopFilled$1,
  VolumeHigh: VolumeHigh$1,
  VolumeHighFilled: VolumeHighFilled$1,
  VolumeLow: VolumeLow$1,
  VolumeLowFilled: VolumeLowFilled$1,
  Adapt: Adapt$1,
  AdaptLight: AdaptLight$1,
  AppleWatch: AppleWatch$1,
  AudioFeedback: AudioFeedback$1,
  BatteryChargingFull: BatteryChargingFull$1,
  BatteryChargingLow: BatteryChargingLow$1,
  BatteryFull: BatteryFull$1,
  BatteryLow: BatteryLow$1,
  Brightness: Brightness$1,
  Burn: Burn$1,
  ClassWorkout: ClassWorkout$1,
  Device: Device$1,
  DeviceLeft: DeviceLeft$1,
  DeviceRight: DeviceRight$1,
  DeviceVertical: DeviceVertical$1,
  DualLightsColorChip: DualLightsColorChip$1,
  EffectActive: EffectActive$1,
  EffectInactive: EffectInactive$1,
  Effort: Effort$1,
  ElevationChange: ElevationChange$1,
  HeartRate: HeartRate$1,
  LaceDown: LaceDown$1,
  LaceUp: LaceUp$1,
  LightsOff: LightsOff$1,
  Loosen: Loosen$1,
  MuscleGroup: MuscleGroup$1,
  Notes: Notes$1,
  ProgramIntensity: ProgramIntensity$1,
  Programs: Programs$1,
  ProgramsFilled: ProgramsFilled$1,
  ProgramsStroke: ProgramsStroke$1,
  PulsingDualLights: PulsingDualLights$1,
  PulsingLights: PulsingLights$1,
  Road: Road$1,
  Run: Run$1,
  RunFilled: RunFilled$1,
  Runner: Runner$1,
  RunnerStroke: RunnerStroke$1,
  RunStroke: RunStroke$1,
  Sport: Sport$1,
  Stages: Stages$1,
  Tighten: Tighten$1,
  Track: Track$1,
  Trail: Trail$1,
  Treadmill: Treadmill$1,
  WeatherHail: WeatherHail$1,
  WeatherNightClear: WeatherNightClear$1,
  WeatherNightOvercast: WeatherNightOvercast$1,
  WeatherOvercast: WeatherOvercast$1,
  WeatherOvercastWind: WeatherOvercastWind$1,
  WeatherRain: WeatherRain$1,
  WeatherSnow: WeatherSnow$1,
  WeatherSunny: WeatherSunny$1,
  WeatherWind: WeatherWind$1,
  Whiteboard: Whiteboard$1,
  WorkoutEquipment: WorkoutEquipment$1,
  Workouts: Workouts$1,
  WorkoutsFilled: WorkoutsFilled$1,
  WorkoutsStroke: WorkoutsStroke$1,
  ArrowDown: ArrowDown$1,
  ArrowLeft: ArrowLeft$1,
  ArrowRight: ArrowRight$1,
  ArrowUp: ArrowUp$1,
  CaretCircleDown,
  CaretCircleDownFilled,
  CaretCircleLeft,
  CaretCircleLeftFilled,
  CaretCircleRight,
  CaretCircleRightFilled,
  CaretCircleUp,
  CaretCircleUpFilled,
  CaretDown: CaretDown$1,
  CaretLeft: CaretLeft$1,
  CaretRight: CaretRight$1,
  CaretUp: CaretUp$1,
  Close: Close$1,
  Minus: Minus$1,
  Plus: Plus$1,
  PlusMinus: PlusMinus$1,
  CheckboxIcon: CheckboxIcon$1,
  RadioIcon: RadioIcon$1,
  SuccessIcon: SuccessIcon$1,
  SvgIcon: SvgIcon$1
}, Symbol.toStringTag, { value: "Module" }));
var __assign$C = globalThis && globalThis.__assign || function() {
  __assign$C = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$C.apply(this, arguments);
};
var __rest$c = globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var IndeterminateIcon = function(_a) {
  var className = _a.className;
  return jsx$1("svg", __assign$C({ "aria-hidden": "true", className, focusable: "false", viewBox: "0 0 24 24", role: "img", width: "24px", height: "24px", fill: "none" }, { children: jsx$1("g", __assign$C({ stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, { children: jsxs("g", __assign$C({ transform: "translate(2.000000, 2.000000)" }, { children: [jsx$1("rect", { x: "0", y: "0", width: "20", height: "20", rx: "10" }), jsx$1("rect", { className: "checkbox-indeterminate", x: "0", y: "0", width: "20", height: "20", rx: "5" }), jsx$1("path", { className: "checkicon-check", strokeWidth: "2", d: "M15 10H5", strokeLinecap: "round", strokeLinejoin: "round" })] })) })) }));
};
var Checkbox = function(_a) {
  var _b = _a.checked, checked = _b === void 0 ? false : _b, className = _a.className, _c = _a.disabled, disabled2 = _c === void 0 ? false : _c, indeterminate = _a.indeterminate, id = _a.id, label = _a.label, hideLabel = _a.hideLabel, name = _a.name, onChange2 = _a.onChange, value = _a.value, rest = __rest$c(_a, ["checked", "className", "disabled", "indeterminate", "id", "label", "hideLabel", "name", "onChange", "value"]);
  var ref = React__default.useRef();
  var _d = useState(!!checked), isChecked = _d[0], setIsChecked = _d[1];
  useEffect(function() {
    if (ref.current) {
      ref.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);
  useEffect(function() {
    setIsChecked(!!checked);
  }, [checked]);
  var handleChange = function(event) {
    if (disabled2 !== true) {
      setIsChecked(!isChecked);
      if (onChange2)
        onChange2(event);
    }
  };
  var containerClass = classNames$1(className, "eds-checkbox", {
    "eds-checkbox--disabled": disabled2
  });
  return jsxs("label", __assign$C({ htmlFor: id, className: containerClass }, { children: [jsx$1("input", __assign$C({ ref, type: "checkbox", name, id, value: value || id, checked: isChecked, disabled: disabled2 }, indeterminate ? { "aria-checked": "mixed" } : {}, { className: "eds-checkbox__input", onChange: handleChange }, rest)), jsx$1("span", { className: "eds-checkbox__box circle" }), jsx$1("span", { className: "eds-checkbox__box" }), indeterminate ? jsx$1(IndeterminateIcon, { className: "eds-checkbox__icon-container" }) : jsx$1(CheckboxIcon$1, { className: "eds-checkbox__icon-container" }), hideLabel ? jsx$1("span", __assign$C({ className: "eds-hidden--screen-reader-only" }, { children: label })) : label] }));
};
var __assign$B = globalThis && globalThis.__assign || function() {
  __assign$B = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$B.apply(this, arguments);
};
var __rest$b = globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var Label = function(_a) {
  var _b;
  var className = _a.className, screenReaderOnly = _a.screenReaderOnly, font = _a.font, color = _a.color, hasErrors2 = _a.hasErrors, children = _a.children, rest = __rest$b(_a, ["className", "screenReaderOnly", "font", "color", "hasErrors", "children"]);
  return jsxs("label", __assign$B({ className: classNames$1("eds-label", (_b = {}, _b["eds-color--".concat(color)] = color, _b["eds-type--".concat(font)] = font, _b["eds-hidden--screen-reader-only"] = screenReaderOnly, _b), className) }, rest, { children: [children, hasErrors2 && jsxs(Fragment, { children: [jsx$1("span", __assign$B({ className: "eds-color--text-danger", "aria-hidden": true }, { children: "*" })), jsx$1("span", __assign$B({ className: "eds-hidden--screen-reader-only" }, { children: " Error" }))] })] }));
};
var __assign$A = globalThis && globalThis.__assign || function() {
  __assign$A = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$A.apply(this, arguments);
};
var __rest$a = globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var InputMessageGroup = function(_a) {
  var count = _a.count, maxCount = _a.maxCount, message = _a.message, errorMessage = _a.errorMessage;
  _a.className;
  var rest = __rest$a(_a, ["count", "maxCount", "message", "errorMessage", "className"]);
  if (!(errorMessage || message || count) && count !== 0)
    return null;
  return jsxs("div", __assign$A({ className: classNames$1("eds-input-message-group") }, rest, { children: [typeof message === "string" ? jsx$1(Text$2, __assign$A({ color: "text-secondary", className: "eds-input-message-group__message" }, { children: message })) : message, errorMessage && jsxs(Text$2, __assign$A({ as: "p", className: "eds-input-message-group__error-message" }, { children: [jsx$1("span", __assign$A({ className: "eds-hidden--screen-reader-only" }, { children: "Error" })), errorMessage] })), !!(count === 0 || count) && jsxs("div", __assign$A({ className: "eds-input-message-group__counter" }, { children: [jsx$1(Text$2, __assign$A({ as: "span", color: maxCount && count > maxCount ? "text-danger" : "text-secondary" }, { children: count })), maxCount && jsxs(Fragment, { children: [jsxs("span", __assign$A({ className: "eds-hidden--screen-reader-only" }, { children: ["of ", maxCount] })), jsxs(Text$2, __assign$A({ as: "span", color: "text-secondary", "aria-hidden": true }, { children: ["/", maxCount] }))] })] }))] }));
};
var __assign$z = globalThis && globalThis.__assign || function() {
  __assign$z = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$z.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var __assign$y = globalThis && globalThis.__assign || function() {
  __assign$y = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$y.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var __assign$x = globalThis && globalThis.__assign || function() {
  __assign$x = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$x.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var __assign$w = globalThis && globalThis.__assign || function() {
  __assign$w = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$w.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var __assign$v = globalThis && globalThis.__assign || function() {
  __assign$v = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$v.apply(this, arguments);
};
var __rest$9 = globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var podiumCoreIcons = __assign$v({}, podiumCoreIconsModule);
var podiumCoreIconNames = Object.keys(podiumCoreIcons);
var sizingMap = /* @__PURE__ */ new Map([
  ["s", 16],
  ["m", 24],
  ["l", 48]
]);
var Icon$1 = function(_a) {
  var name = _a.name, _b = _a.size, size = _b === void 0 ? "m" : _b, backgroundColor = _a.backgroundColor, backgroundShape = _a.backgroundShape, className = _a.className, enableFocus = _a.enableFocus, color = _a.color, _c = _a["aria-label"], ariaLabel = _c === void 0 ? name : _c, rest = __rest$9(_a, ["name", "size", "backgroundColor", "backgroundShape", "className", "enableFocus", "color", "aria-label"]);
  var svgSize = sizingMap.get(size);
  var createIconComponent = function() {
    return React__default.createElement(podiumCoreIcons[name], __assign$v({ width: svgSize, height: svgSize, className: classNames$1("eds-icon", className), color }, rest));
  };
  if (!podiumCoreIconNames.includes(name))
    return null;
  var tabIndexProps = enableFocus ? { tabIndex: 0 } : {};
  if (backgroundShape) {
    return jsx$1("div", __assign$v({}, tabIndexProps, { "aria-label": ariaLabel, role: "img", className: classNames$1("eds-icon__wrapper", "eds-icon__wrapper--".concat(backgroundShape), "eds-icon__wrapper--".concat(size)), style: {
      backgroundColor
    } }, { children: createIconComponent() }));
  }
  return createIconComponent();
};
var __assign$u = globalThis && globalThis.__assign || function() {
  __assign$u = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$u.apply(this, arguments);
};
var __rest$8 = globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var IconButton = function(_a) {
  var className = _a.className, icon2 = _a.icon, label = _a.label, size = _a.size, rest = __rest$8(_a, ["className", "icon", "label", "size"]);
  var iconRender = typeof icon2 === "string" ? jsx$1(Icon$1, { size: "m", name: icon2 }) : icon2;
  return jsxs(Button$1, __assign$u({ size, className: classNames$1("eds-button--icon", className) }, rest, { children: [iconRender, jsx$1("span", __assign$u({ className: "eds-hidden--screen-reader-only" }, { children: label }))] }));
};
var __assign$t = globalThis && globalThis.__assign || function() {
  __assign$t = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$t.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var __assign$s = globalThis && globalThis.__assign || function() {
  __assign$s = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$s.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var __assign$r = globalThis && globalThis.__assign || function() {
  __assign$r = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$r.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var fromEntries = function fromEntries2(entries) {
  return entries.reduce(function(acc, _ref3) {
    var key = _ref3[0], value = _ref3[1];
    acc[key] = value;
    return acc;
  }, {});
};
var useIsomorphicLayoutEffect = typeof window !== "undefined" && window.document && window.document.createElement ? React$1.useLayoutEffect : React$1.useEffect;
var top = "top";
var bottom = "bottom";
var right = "right";
var left = "left";
var auto = "auto";
var basePlacements = [top, bottom, right, left];
var start = "start";
var end = "end";
var clippingParents = "clippingParents";
var viewport = "viewport";
var popper = "popper";
var reference = "reference";
var variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []);
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead";
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain";
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
function getNodeName$1(element) {
  return element ? (element.nodeName || "").toLowerCase() : null;
}
function getWindow$1(node2) {
  if (node2 == null) {
    return window;
  }
  if (node2.toString() !== "[object Window]") {
    var ownerDocument2 = node2.ownerDocument;
    return ownerDocument2 ? ownerDocument2.defaultView || window : window;
  }
  return node2;
}
function isElement$1(node2) {
  var OwnElement = getWindow$1(node2).Element;
  return node2 instanceof OwnElement || node2 instanceof Element;
}
function isHTMLElement$1(node2) {
  var OwnElement = getWindow$1(node2).HTMLElement;
  return node2 instanceof OwnElement || node2 instanceof HTMLElement;
}
function isShadowRoot$1(node2) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  var OwnElement = getWindow$1(node2).ShadowRoot;
  return node2 instanceof OwnElement || node2 instanceof ShadowRoot;
}
function applyStyles(_ref3) {
  var state = _ref3.state;
  Object.keys(state.elements).forEach(function(name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name];
    if (!isHTMLElement$1(element) || !getNodeName$1(element)) {
      return;
    }
    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function(name2) {
      var value = attributes[name2];
      if (value === false) {
        element.removeAttribute(name2);
      } else {
        element.setAttribute(name2, value === true ? "" : value);
      }
    });
  });
}
function effect$2(_ref22) {
  var state = _ref22.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }
  return function() {
    Object.keys(state.elements).forEach(function(name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
      var style = styleProperties.reduce(function(style2, property) {
        style2[property] = "";
        return style2;
      }, {});
      if (!isHTMLElement$1(element) || !getNodeName$1(element)) {
        return;
      }
      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function(attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
}
var applyStyles$1 = {
  name: "applyStyles",
  enabled: true,
  phase: "write",
  fn: applyStyles,
  effect: effect$2,
  requires: ["computeStyles"]
};
function getBasePlacement(placement) {
  return placement.split("-")[0];
}
var max = Math.max;
var min = Math.min;
var round = Math.round;
function getUAString$1() {
  var uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function(item2) {
      return item2.brand + "/" + item2.version;
    }).join(" ");
  }
  return navigator.userAgent;
}
function isLayoutViewport$1() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString$1());
}
function getBoundingClientRect$1(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (includeScale && isHTMLElement$1(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }
  var _ref3 = isElement$1(element) ? getWindow$1(element) : window, visualViewport = _ref3.visualViewport;
  var addVisualOffsets = !isLayoutViewport$1() && isFixedStrategy;
  var x2 = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y2 = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width,
    height,
    top: y2,
    right: x2 + width,
    bottom: y2 + height,
    left: x2,
    x: x2,
    y: y2
  };
}
function getLayoutRect(element) {
  var clientRect = getBoundingClientRect$1(element);
  var width = element.offsetWidth;
  var height = element.offsetHeight;
  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }
  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width,
    height
  };
}
function contains$1(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode();
  if (parent.contains(child)) {
    return true;
  } else if (rootNode && isShadowRoot$1(rootNode)) {
    var next2 = child;
    do {
      if (next2 && parent.isSameNode(next2)) {
        return true;
      }
      next2 = next2.parentNode || next2.host;
    } while (next2);
  }
  return false;
}
function getComputedStyle$2(element) {
  return getWindow$1(element).getComputedStyle(element);
}
function isTableElement(element) {
  return ["table", "td", "th"].indexOf(getNodeName$1(element)) >= 0;
}
function getDocumentElement$1(element) {
  return ((isElement$1(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}
function getParentNode$1(element) {
  if (getNodeName$1(element) === "html") {
    return element;
  }
  return element.assignedSlot || element.parentNode || (isShadowRoot$1(element) ? element.host : null) || getDocumentElement$1(element);
}
function getTrueOffsetParent(element) {
  if (!isHTMLElement$1(element) || getComputedStyle$2(element).position === "fixed") {
    return null;
  }
  return element.offsetParent;
}
function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString$1());
  var isIE = /Trident/i.test(getUAString$1());
  if (isIE && isHTMLElement$1(element)) {
    var elementCss = getComputedStyle$2(element);
    if (elementCss.position === "fixed") {
      return null;
    }
  }
  var currentNode = getParentNode$1(element);
  if (isShadowRoot$1(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement$1(currentNode) && ["html", "body"].indexOf(getNodeName$1(currentNode)) < 0) {
    var css4 = getComputedStyle$2(currentNode);
    if (css4.transform !== "none" || css4.perspective !== "none" || css4.contain === "paint" || ["transform", "perspective"].indexOf(css4.willChange) !== -1 || isFirefox && css4.willChange === "filter" || isFirefox && css4.filter && css4.filter !== "none") {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
}
function getOffsetParent(element) {
  var window2 = getWindow$1(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$2(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName$1(offsetParent) === "html" || getNodeName$1(offsetParent) === "body" && getComputedStyle$2(offsetParent).position === "static")) {
    return window2;
  }
  return offsetParent || getContainingBlock(element) || window2;
}
function getMainAxisFromPlacement(placement) {
  return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
}
function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min2, value, max2) {
  var v2 = within(min2, value, max2);
  return v2 > max2 ? max2 : v2;
}
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
function expandToHashMap(value, keys) {
  return keys.reduce(function(hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
var toPaddingObject = function toPaddingObject2(padding, state) {
  padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
};
function arrow(_ref3) {
  var _state$modifiersData$;
  var state = _ref3.state, name = _ref3.name, options = _ref3.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? "height" : "width";
  if (!arrowElement || !popperOffsets2) {
    return;
  }
  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === "y" ? top : left;
  var maxProp = axis === "y" ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets2[axis] - state.rects.popper[len];
  var startDiff = popperOffsets2[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2;
  var min2 = paddingObject[minProp];
  var max2 = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset2 = within(min2, center, max2);
  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset2, _state$modifiersData$.centerOffset = offset2 - center, _state$modifiersData$);
}
function effect$1(_ref22) {
  var state = _ref22.state, options = _ref22.options;
  var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
  if (arrowElement == null) {
    return;
  }
  if (typeof arrowElement === "string") {
    arrowElement = state.elements.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return;
    }
  }
  if (!contains$1(state.elements.popper, arrowElement)) {
    return;
  }
  state.elements.arrow = arrowElement;
}
var arrow$1 = {
  name: "arrow",
  enabled: true,
  phase: "main",
  fn: arrow,
  effect: effect$1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function getVariation(placement) {
  return placement.split("-")[1];
}
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(_ref3, win) {
  var x2 = _ref3.x, y2 = _ref3.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x2 * dpr) / dpr || 0,
    y: round(y2 * dpr) / dpr || 0
  };
}
function mapToStyles(_ref22) {
  var _Object$assign2;
  var popper2 = _ref22.popper, popperRect = _ref22.popperRect, placement = _ref22.placement, variation = _ref22.variation, offsets = _ref22.offsets, position2 = _ref22.position, gpuAcceleration = _ref22.gpuAcceleration, adaptive = _ref22.adaptive, roundOffsets = _ref22.roundOffsets, isFixed = _ref22.isFixed;
  var _offsets$x = offsets.x, x2 = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y2 = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
    x: x2,
    y: y2
  }) : {
    x: x2,
    y: y2
  };
  x2 = _ref3.x;
  y2 = _ref3.y;
  var hasX = offsets.hasOwnProperty("x");
  var hasY = offsets.hasOwnProperty("y");
  var sideX = left;
  var sideY = top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper2);
    var heightProp = "clientHeight";
    var widthProp = "clientWidth";
    if (offsetParent === getWindow$1(popper2)) {
      offsetParent = getDocumentElement$1(popper2);
      if (getComputedStyle$2(offsetParent).position !== "static" && position2 === "absolute") {
        heightProp = "scrollHeight";
        widthProp = "scrollWidth";
      }
    }
    offsetParent = offsetParent;
    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
      y2 -= offsetY - popperRect.height;
      y2 *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
      x2 -= offsetX - popperRect.width;
      x2 *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = Object.assign({
    position: position2
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x2,
    y: y2
  }, getWindow$1(popper2)) : {
    x: x2,
    y: y2
  };
  x2 = _ref4.x;
  y2 = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x2 + "px, " + y2 + "px)" : "translate3d(" + x2 + "px, " + y2 + "px, 0)", _Object$assign));
  }
  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y2 + "px" : "", _Object$assign2[sideX] = hasX ? x2 + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state, options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration,
    isFixed: state.options.strategy === "fixed"
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive,
      roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: "absolute",
      adaptive: false,
      roundOffsets
    })));
  }
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-placement": state.placement
  });
}
var computeStyles$1 = {
  name: "computeStyles",
  enabled: true,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
var passive = {
  passive: true
};
function effect(_ref3) {
  var state = _ref3.state, instance = _ref3.instance, options = _ref3.options;
  var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
  var window2 = getWindow$1(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function(scrollParent) {
      scrollParent.addEventListener("scroll", instance.update, passive);
    });
  }
  if (resize) {
    window2.addEventListener("resize", instance.update, passive);
  }
  return function() {
    if (scroll) {
      scrollParents.forEach(function(scrollParent) {
        scrollParent.removeEventListener("scroll", instance.update, passive);
      });
    }
    if (resize) {
      window2.removeEventListener("resize", instance.update, passive);
    }
  };
}
var eventListeners = {
  name: "eventListeners",
  enabled: true,
  phase: "write",
  fn: function fn() {
  },
  effect,
  data: {}
};
var hash$2 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function(matched) {
    return hash$2[matched];
  });
}
var hash$1 = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function(matched) {
    return hash$1[matched];
  });
}
function getWindowScroll(node2) {
  var win = getWindow$1(node2);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft,
    scrollTop
  };
}
function getWindowScrollBarX(element) {
  return getBoundingClientRect$1(getDocumentElement$1(element)).left + getWindowScroll(element).scrollLeft;
}
function getViewportRect(element, strategy) {
  var win = getWindow$1(element);
  var html = getDocumentElement$1(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x2 = 0;
  var y2 = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport$1();
    if (layoutViewport || !layoutViewport && strategy === "fixed") {
      x2 = visualViewport.offsetLeft;
      y2 = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x: x2 + getWindowScrollBarX(element),
    y: y2
  };
}
function getDocumentRect(element) {
  var _element$ownerDocumen;
  var html = getDocumentElement$1(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x2 = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y2 = -winScroll.scrollTop;
  if (getComputedStyle$2(body || html).direction === "rtl") {
    x2 += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }
  return {
    width,
    height,
    x: x2,
    y: y2
  };
}
function isScrollParent(element) {
  var _getComputedStyle = getComputedStyle$2(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function getScrollParent$1(node2) {
  if (["html", "body", "#document"].indexOf(getNodeName$1(node2)) >= 0) {
    return node2.ownerDocument.body;
  }
  if (isHTMLElement$1(node2) && isScrollParent(node2)) {
    return node2;
  }
  return getScrollParent$1(getParentNode$1(node2));
}
function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent$1(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow$1(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : updatedList.concat(listScrollParents(getParentNode$1(target)));
}
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect$1(element, false, strategy === "fixed");
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement$1(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement$1(element)));
}
function getClippingParents(element) {
  var clippingParents2 = listScrollParents(getParentNode$1(element));
  var canEscapeClipping = ["absolute", "fixed"].indexOf(getComputedStyle$2(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement$1(element) ? getOffsetParent(element) : element;
  if (!isElement$1(clipperElement)) {
    return [];
  }
  return clippingParents2.filter(function(clippingParent) {
    return isElement$1(clippingParent) && contains$1(clippingParent, clipperElement) && getNodeName$1(clippingParent) !== "body";
  });
}
function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
  var clippingParents2 = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents2[0];
  var clippingRect = clippingParents2.reduce(function(accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
function computeOffsets(_ref3) {
  var reference2 = _ref3.reference, element = _ref3.element, placement = _ref3.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference2.x + reference2.width / 2 - element.width / 2;
  var commonY = reference2.y + reference2.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference2.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference2.y + reference2.height
      };
      break;
    case right:
      offsets = {
        x: reference2.x + reference2.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference2.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference2.x,
        y: reference2.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === "y" ? "height" : "width";
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference2[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference2[len] / 2 - element[len] / 2);
        break;
    }
  }
  return offsets;
}
function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? clippingParents : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? popper : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement$1(element) ? element : element.contextElement || getDocumentElement$1(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect$1(state.elements.reference);
  var popperOffsets2 = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: "absolute",
    placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets2));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect;
  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset;
  if (elementContext === popper && offsetData) {
    var offset2 = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function(key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? "y" : "x";
      overflowOffsets[key] += offset2[axis] * multiply;
    });
  }
  return overflowOffsets;
}
function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function(placement2) {
    return getVariation(placement2) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function(placement2) {
    return allowedAutoPlacements.indexOf(placement2) >= 0;
  });
  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  }
  var overflows = allowedPlacements.reduce(function(acc, placement2) {
    acc[placement2] = detectOverflow(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding
    })[getBasePlacement(placement2)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function(a, b2) {
    return overflows[a] - overflows[b2];
  });
}
function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}
function flip(_ref3) {
  var state = _ref3.state, options = _ref3.options, name = _ref3.name;
  if (state.modifiersData[name]._skip) {
    return;
  }
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements2 = [preferredPlacement].concat(fallbackPlacements).reduce(function(acc, placement2) {
    return acc.concat(getBasePlacement(placement2) === auto ? computeAutoPlacement(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding,
      flipVariations,
      allowedAutoPlacements
    }) : placement2);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = /* @__PURE__ */ new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements2[0];
  for (var i2 = 0; i2 < placements2.length; i2++) {
    var placement = placements2[i2];
    var _basePlacement = getBasePlacement(placement);
    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? "width" : "height";
    var overflow = detectOverflow(state, {
      placement,
      boundary,
      rootBoundary,
      altBoundary,
      padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }
    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];
    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }
    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }
    if (checks.every(function(check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }
    checksMap.set(placement, checks);
  }
  if (makeFallbackChecks) {
    var numberOfChecks = flipVariations ? 3 : 1;
    var _loop = function _loop2(_i2) {
      var fittingPlacement = placements2.find(function(placement2) {
        var checks2 = checksMap.get(placement2);
        if (checks2) {
          return checks2.slice(0, _i2).every(function(check) {
            return check;
          });
        }
      });
      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };
    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);
      if (_ret === "break")
        break;
    }
  }
  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
}
var flip$1 = {
  name: "flip",
  enabled: true,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: false
  }
};
function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }
  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}
function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function(side) {
    return overflow[side] >= 0;
  });
}
function hide(_ref3) {
  var state = _ref3.state, name = _ref3.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: "reference"
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets,
    popperEscapeOffsets,
    isReferenceHidden,
    hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-reference-hidden": isReferenceHidden,
    "data-popper-escaped": hasPopperEscaped
  });
}
var hide$1 = {
  name: "hide",
  enabled: true,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};
function distanceAndSkiddingToXY(placement, rects, offset2) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref3 = typeof offset2 === "function" ? offset2(Object.assign({}, rects, {
    placement
  })) : offset2, skidding = _ref3[0], distance = _ref3[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset(_ref22) {
  var state = _ref22.state, options = _ref22.options, name = _ref22.name;
  var _options$offset = options.offset, offset2 = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function(acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset2);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement], x2 = _data$state$placement.x, y2 = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x2;
    state.modifiersData.popperOffsets.y += y2;
  }
  state.modifiersData[name] = data;
}
var offset$1 = {
  name: "offset",
  enabled: true,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};
function popperOffsets(_ref3) {
  var state = _ref3.state, name = _ref3.name;
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: "absolute",
    placement: state.placement
  });
}
var popperOffsets$1 = {
  name: "popperOffsets",
  enabled: true,
  phase: "read",
  fn: popperOffsets,
  data: {}
};
function getAltAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function preventOverflow(_ref3) {
  var state = _ref3.state, options = _ref3.options, name = _ref3.name;
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary,
    rootBoundary,
    padding,
    altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };
  if (!popperOffsets2) {
    return;
  }
  if (checkMainAxis) {
    var _offsetModifierState$;
    var mainSide = mainAxis === "y" ? top : left;
    var altSide = mainAxis === "y" ? bottom : right;
    var len = mainAxis === "y" ? "height" : "width";
    var offset2 = popperOffsets2[mainAxis];
    var min$1 = offset2 + overflow[mainSide];
    var max$1 = offset2 - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len];
    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide];
    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset2 + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset2 + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset2, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets2[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset2;
  }
  if (checkAltAxis) {
    var _offsetModifierState$2;
    var _mainSide = mainAxis === "x" ? top : left;
    var _altSide = mainAxis === "x" ? bottom : right;
    var _offset = popperOffsets2[altAxis];
    var _len = altAxis === "y" ? "height" : "width";
    var _min = _offset + overflow[_mainSide];
    var _max = _offset - overflow[_altSide];
    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
    popperOffsets2[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }
  state.modifiersData[name] = data;
}
var preventOverflow$1 = {
  name: "preventOverflow",
  enabled: true,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
function getNodeScroll(node2) {
  if (node2 === getWindow$1(node2) || !isHTMLElement$1(node2)) {
    return getWindowScroll(node2);
  } else {
    return getHTMLElementScroll(node2);
  }
}
function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
}
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement$1(offsetParent);
  var offsetParentIsScaled = isHTMLElement$1(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement$1(offsetParent);
  var rect = getBoundingClientRect$1(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName$1(offsetParent) !== "body" || isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement$1(offsetParent)) {
      offsets = getBoundingClientRect$1(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
function order(modifiers) {
  var map2 = /* @__PURE__ */ new Map();
  var visited = /* @__PURE__ */ new Set();
  var result = [];
  modifiers.forEach(function(modifier) {
    map2.set(modifier.name, modifier);
  });
  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function(dep) {
      if (!visited.has(dep)) {
        var depModifier = map2.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function(modifier) {
    if (!visited.has(modifier.name)) {
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  var orderedModifiers = order(modifiers);
  return modifierPhases.reduce(function(acc, phase) {
    return acc.concat(orderedModifiers.filter(function(modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
function debounce$1(fn3) {
  var pending;
  return function() {
    if (!pending) {
      pending = new Promise(function(resolve) {
        Promise.resolve().then(function() {
          pending = void 0;
          resolve(fn3());
        });
      });
    }
    return pending;
  };
}
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function(merged2, current) {
    var existing = merged2[current.name];
    merged2[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged2;
  }, {});
  return Object.keys(merged).map(function(key) {
    return merged[key];
  });
}
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function(element) {
    return !(element && typeof element.getBoundingClientRect === "function");
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers2 = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper2(reference2, popper2, options) {
    if (options === void 0) {
      options = defaultOptions;
    }
    var state = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference2,
        popper: popper2
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state,
      setOptions: function setOptions(setOptionsAction) {
        var options2 = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options2);
        state.scrollParents = {
          reference: isElement$1(reference2) ? listScrollParents(reference2) : reference2.contextElement ? listScrollParents(reference2.contextElement) : [],
          popper: listScrollParents(popper2)
        };
        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers2, state.options.modifiers)));
        state.orderedModifiers = orderedModifiers.filter(function(m2) {
          return m2.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements, reference3 = _state$elements.reference, popper3 = _state$elements.popper;
        if (!areValidElements(reference3, popper3)) {
          return;
        }
        state.rects = {
          reference: getCompositeRect(reference3, getOffsetParent(popper3), state.options.strategy === "fixed"),
          popper: getLayoutRect(popper3)
        };
        state.reset = false;
        state.placement = state.options.placement;
        state.orderedModifiers.forEach(function(modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        for (var index2 = 0; index2 < state.orderedModifiers.length; index2++) {
          if (state.reset === true) {
            state.reset = false;
            index2 = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index2], fn3 = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
          if (typeof fn3 === "function") {
            state = fn3({
              state,
              options: _options,
              name,
              instance
            }) || state;
          }
        }
      },
      update: debounce$1(function() {
        return new Promise(function(resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference2, popper2)) {
      return instance;
    }
    instance.setOptions(options).then(function(state2) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state2);
      }
    });
    function runModifierEffects() {
      state.orderedModifiers.forEach(function(_ref3) {
        var name = _ref3.name, _ref$options = _ref3.options, options2 = _ref$options === void 0 ? {} : _ref$options, effect2 = _ref3.effect;
        if (typeof effect2 === "function") {
          var cleanupFn = effect2({
            state,
            name,
            instance,
            options: options2
          });
          var noopFn = function noopFn2() {
          };
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function(fn3) {
        return fn3();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}
var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
});
var hasElementType = typeof Element !== "undefined";
var hasMap = typeof Map === "function";
var hasSet = typeof Set === "function";
var hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
function equal(a, b2) {
  if (a === b2)
    return true;
  if (a && b2 && typeof a == "object" && typeof b2 == "object") {
    if (a.constructor !== b2.constructor)
      return false;
    var length2, i2, keys;
    if (Array.isArray(a)) {
      length2 = a.length;
      if (length2 != b2.length)
        return false;
      for (i2 = length2; i2-- !== 0; )
        if (!equal(a[i2], b2[i2]))
          return false;
      return true;
    }
    var it;
    if (hasMap && a instanceof Map && b2 instanceof Map) {
      if (a.size !== b2.size)
        return false;
      it = a.entries();
      while (!(i2 = it.next()).done)
        if (!b2.has(i2.value[0]))
          return false;
      it = a.entries();
      while (!(i2 = it.next()).done)
        if (!equal(i2.value[1], b2.get(i2.value[0])))
          return false;
      return true;
    }
    if (hasSet && a instanceof Set && b2 instanceof Set) {
      if (a.size !== b2.size)
        return false;
      it = a.entries();
      while (!(i2 = it.next()).done)
        if (!b2.has(i2.value[0]))
          return false;
      return true;
    }
    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b2)) {
      length2 = a.length;
      if (length2 != b2.length)
        return false;
      for (i2 = length2; i2-- !== 0; )
        if (a[i2] !== b2[i2])
          return false;
      return true;
    }
    if (a.constructor === RegExp)
      return a.source === b2.source && a.flags === b2.flags;
    if (a.valueOf !== Object.prototype.valueOf)
      return a.valueOf() === b2.valueOf();
    if (a.toString !== Object.prototype.toString)
      return a.toString() === b2.toString();
    keys = Object.keys(a);
    length2 = keys.length;
    if (length2 !== Object.keys(b2).length)
      return false;
    for (i2 = length2; i2-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(b2, keys[i2]))
        return false;
    if (hasElementType && a instanceof Element)
      return false;
    for (i2 = length2; i2-- !== 0; ) {
      if ((keys[i2] === "_owner" || keys[i2] === "__v" || keys[i2] === "__o") && a.$$typeof) {
        continue;
      }
      if (!equal(a[keys[i2]], b2[keys[i2]]))
        return false;
    }
    return true;
  }
  return a !== a && b2 !== b2;
}
var reactFastCompare = function isEqual(a, b2) {
  try {
    return equal(a, b2);
  } catch (error) {
    if ((error.message || "").match(/stack|recursion/i)) {
      console.warn("react-fast-compare cannot handle circular refs");
      return false;
    }
    throw error;
  }
};
var EMPTY_MODIFIERS = [];
var usePopper = function usePopper2(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }
  var prevOptions = React$1.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || "bottom",
    strategy: options.strategy || "absolute",
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };
  var _React$useState = React$1.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), state = _React$useState[0], setState = _React$useState[1];
  var updateStateModifier = React$1.useMemo(function() {
    return {
      name: "updateState",
      enabled: true,
      phase: "write",
      fn: function fn3(_ref3) {
        var state2 = _ref3.state;
        var elements = Object.keys(state2.elements);
        ReactDOM.flushSync(function() {
          setState({
            styles: fromEntries(elements.map(function(element) {
              return [element, state2.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function(element) {
              return [element, state2.attributes[element]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []);
  var popperOptions = React$1.useMemo(function() {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: "applyStyles",
        enabled: false
      }])
    };
    if (reactFastCompare(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = React$1.useRef();
  useIsomorphicLayoutEffect(function() {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function() {
    if (referenceElement == null || popperElement == null) {
      return;
    }
    var createPopper$1 = options.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function() {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};
var warning = function() {
};
var warning_1 = warning;
globalThis && globalThis.__spreadArray || function(to, from2, pack) {
  if (pack || arguments.length === 2)
    for (var i2 = 0, l2 = from2.length, ar; i2 < l2; i2++) {
      if (ar || !(i2 in from2)) {
        if (!ar)
          ar = Array.prototype.slice.call(from2, 0, i2);
        ar[i2] = from2[i2];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from2));
};
var __assign$q = globalThis && globalThis.__assign || function() {
  __assign$q = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$q.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
globalThis && globalThis.__spreadArray || function(to, from2, pack) {
  if (pack || arguments.length === 2)
    for (var i2 = 0, l2 = from2.length, ar; i2 < l2; i2++) {
      if (ar || !(i2 in from2)) {
        if (!ar)
          ar = Array.prototype.slice.call(from2, 0, i2);
        ar[i2] = from2[i2];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from2));
};
var __assign$p = globalThis && globalThis.__assign || function() {
  __assign$p = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$p.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
/*!
* tabbable 6.1.2
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var candidateSelectors = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"];
var candidateSelector = /* @__PURE__ */ candidateSelectors.join(",");
var NoElement = typeof Element === "undefined";
var matches = NoElement ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function(element) {
  var _element$getRootNode;
  return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
  return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
var isInert = function isInert2(node2, lookUp) {
  var _node$getAttribute;
  if (lookUp === void 0) {
    lookUp = true;
  }
  var inertAtt = node2 === null || node2 === void 0 ? void 0 : (_node$getAttribute = node2.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node2, "inert");
  var inert = inertAtt === "" || inertAtt === "true";
  var result = inert || lookUp && node2 && isInert2(node2.parentNode);
  return result;
};
var isContentEditable = function isContentEditable2(node2) {
  var _node$getAttribute2;
  var attValue = node2 === null || node2 === void 0 ? void 0 : (_node$getAttribute2 = node2.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node2, "contenteditable");
  return attValue === "" || attValue === "true";
};
var getCandidates = function getCandidates2(el, includeContainer, filter) {
  if (isInert(el)) {
    return [];
  }
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }
  candidates = candidates.filter(filter);
  return candidates;
};
var getCandidatesIteratively = function getCandidatesIteratively2(elements, includeContainer, options) {
  var candidates = [];
  var elementsToCheck = Array.from(elements);
  while (elementsToCheck.length) {
    var element = elementsToCheck.shift();
    if (isInert(element, false)) {
      continue;
    }
    if (element.tagName === "SLOT") {
      var assigned = element.assignedElements();
      var content2 = assigned.length ? assigned : element.children;
      var nestedCandidates = getCandidatesIteratively2(content2, true, options);
      if (options.flatten) {
        candidates.push.apply(candidates, nestedCandidates);
      } else {
        candidates.push({
          scopeParent: element,
          candidates: nestedCandidates
        });
      }
    } else {
      var validCandidate = matches.call(element, candidateSelector);
      if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
        candidates.push(element);
      }
      var shadowRoot = element.shadowRoot || typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
      var validShadowRoot = !isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
      if (shadowRoot && validShadowRoot) {
        var _nestedCandidates = getCandidatesIteratively2(shadowRoot === true ? element.children : shadowRoot.children, true, options);
        if (options.flatten) {
          candidates.push.apply(candidates, _nestedCandidates);
        } else {
          candidates.push({
            scopeParent: element,
            candidates: _nestedCandidates
          });
        }
      } else {
        elementsToCheck.unshift.apply(elementsToCheck, element.children);
      }
    }
  }
  return candidates;
};
var getTabindex = function getTabindex2(node2, isScope) {
  if (node2.tabIndex < 0) {
    if ((isScope || /^(AUDIO|VIDEO|DETAILS)$/.test(node2.tagName) || isContentEditable(node2)) && isNaN(parseInt(node2.getAttribute("tabindex"), 10))) {
      return 0;
    }
  }
  return node2.tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables2(a, b2) {
  return a.tabIndex === b2.tabIndex ? a.documentOrder - b2.documentOrder : a.tabIndex - b2.tabIndex;
};
var isInput = function isInput2(node2) {
  return node2.tagName === "INPUT";
};
var isHiddenInput = function isHiddenInput2(node2) {
  return isInput(node2) && node2.type === "hidden";
};
var isDetailsWithSummary = function isDetailsWithSummary2(node2) {
  var r2 = node2.tagName === "DETAILS" && Array.prototype.slice.apply(node2.children).some(function(child) {
    return child.tagName === "SUMMARY";
  });
  return r2;
};
var getCheckedRadio = function getCheckedRadio2(nodes, form) {
  for (var i2 = 0; i2 < nodes.length; i2++) {
    if (nodes[i2].checked && nodes[i2].form === form) {
      return nodes[i2];
    }
  }
};
var isTabbableRadio = function isTabbableRadio2(node2) {
  if (!node2.name) {
    return true;
  }
  var radioScope = node2.form || getRootNode(node2);
  var queryRadios = function queryRadios2(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };
  var radioSet;
  if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") {
    radioSet = queryRadios(window.CSS.escape(node2.name));
  } else {
    try {
      radioSet = queryRadios(node2.name);
    } catch (err) {
      console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
      return false;
    }
  }
  var checked = getCheckedRadio(radioSet, node2.form);
  return !checked || checked === node2;
};
var isRadio = function isRadio2(node2) {
  return isInput(node2) && node2.type === "radio";
};
var isNonTabbableRadio = function isNonTabbableRadio2(node2) {
  return isRadio(node2) && !isTabbableRadio(node2);
};
var isNodeAttached = function isNodeAttached2(node2) {
  var _nodeRoot;
  var nodeRoot = node2 && getRootNode(node2);
  var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
  var attached = false;
  if (nodeRoot && nodeRoot !== node2) {
    var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
    attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node2 !== null && node2 !== void 0 && (_node$ownerDocument = node2.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node2));
    while (!attached && nodeRootHost) {
      var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
      nodeRoot = getRootNode(nodeRootHost);
      nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
      attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
    }
  }
  return attached;
};
var isZeroArea = function isZeroArea2(node2) {
  var _node$getBoundingClie = node2.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
  return width === 0 && height === 0;
};
var isHidden = function isHidden2(node2, _ref3) {
  var displayCheck = _ref3.displayCheck, getShadowRoot = _ref3.getShadowRoot;
  if (getComputedStyle(node2).visibility === "hidden") {
    return true;
  }
  var isDirectSummary = matches.call(node2, "details>summary:first-of-type");
  var nodeUnderDetails = isDirectSummary ? node2.parentElement : node2;
  if (matches.call(nodeUnderDetails, "details:not([open]) *")) {
    return true;
  }
  if (!displayCheck || displayCheck === "full" || displayCheck === "legacy-full") {
    if (typeof getShadowRoot === "function") {
      var originalNode = node2;
      while (node2) {
        var parentElement = node2.parentElement;
        var rootNode = getRootNode(node2);
        if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true) {
          return isZeroArea(node2);
        } else if (node2.assignedSlot) {
          node2 = node2.assignedSlot;
        } else if (!parentElement && rootNode !== node2.ownerDocument) {
          node2 = rootNode.host;
        } else {
          node2 = parentElement;
        }
      }
      node2 = originalNode;
    }
    if (isNodeAttached(node2)) {
      return !node2.getClientRects().length;
    }
    if (displayCheck !== "legacy-full") {
      return true;
    }
  } else if (displayCheck === "non-zero-area") {
    return isZeroArea(node2);
  }
  return false;
};
var isDisabledFromFieldset = function isDisabledFromFieldset2(node2) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node2.tagName)) {
    var parentNode = node2.parentElement;
    while (parentNode) {
      if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
        for (var i2 = 0; i2 < parentNode.children.length; i2++) {
          var child = parentNode.children.item(i2);
          if (child.tagName === "LEGEND") {
            return matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node2);
          }
        }
        return true;
      }
      parentNode = parentNode.parentElement;
    }
  }
  return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable2(options, node2) {
  if (node2.disabled || isInert(node2) || isHiddenInput(node2) || isHidden(node2, options) || isDetailsWithSummary(node2) || isDisabledFromFieldset(node2)) {
    return false;
  }
  return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable2(options, node2) {
  if (isNonTabbableRadio(node2) || getTabindex(node2) < 0 || !isNodeMatchingSelectorFocusable(options, node2)) {
    return false;
  }
  return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable2(shadowHostNode) {
  var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
  if (isNaN(tabIndex) || tabIndex >= 0) {
    return true;
  }
  return false;
};
var sortByOrder = function sortByOrder2(candidates) {
  var regularTabbables = [];
  var orderedTabbables = [];
  candidates.forEach(function(item2, i2) {
    var isScope = !!item2.scopeParent;
    var element = isScope ? item2.scopeParent : item2;
    var candidateTabindex = getTabindex(element, isScope);
    var elements = isScope ? sortByOrder2(item2.candidates) : element;
    if (candidateTabindex === 0) {
      isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
    } else {
      orderedTabbables.push({
        documentOrder: i2,
        tabIndex: candidateTabindex,
        item: item2,
        isScope,
        content: elements
      });
    }
  });
  return orderedTabbables.sort(sortOrderedTabbables).reduce(function(acc, sortable) {
    sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
    return acc;
  }, []).concat(regularTabbables);
};
var tabbable = function tabbable2(el, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([el], options.includeContainer, {
      filter: isNodeMatchingSelectorTabbable.bind(null, options),
      flatten: false,
      getShadowRoot: options.getShadowRoot,
      shadowRootFilter: isValidShadowRootTabbable
    });
  } else {
    candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  }
  return sortByOrder(candidates);
};
var focusable = function focusable2(el, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([el], options.includeContainer, {
      filter: isNodeMatchingSelectorFocusable.bind(null, options),
      flatten: true,
      getShadowRoot: options.getShadowRoot
    });
  } else {
    candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
  }
  return candidates;
};
var isTabbable = function isTabbable2(node2, options) {
  options = options || {};
  if (!node2) {
    throw new Error("No node provided");
  }
  if (matches.call(node2, candidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorTabbable(options, node2);
};
var focusableCandidateSelector = /* @__PURE__ */ candidateSelectors.concat("iframe").join(",");
var isFocusable$2 = function isFocusable(node2, options) {
  options = options || {};
  if (!node2) {
    throw new Error("No node provided");
  }
  if (matches.call(node2, focusableCandidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorFocusable(options, node2);
};
var index_esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  focusable,
  isFocusable: isFocusable$2,
  isTabbable,
  tabbable
}, Symbol.toStringTag, { value: "Module" }));
/*!
* focus-trap 7.4.3
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function ownKeys$d(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2$1(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys$d(Object(source), true).forEach(function(key) {
      _defineProperty$3(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$d(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$3(obj, key, value) {
  key = _toPropertyKey$3(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPrimitive$3(input2, hint) {
  if (typeof input2 !== "object" || input2 === null)
    return input2;
  var prim = input2[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input2, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input2);
}
function _toPropertyKey$3(arg) {
  var key = _toPrimitive$3(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
var activeFocusTraps = {
  activateTrap: function activateTrap(trapStack, trap) {
    if (trapStack.length > 0) {
      var activeTrap = trapStack[trapStack.length - 1];
      if (activeTrap !== trap) {
        activeTrap.pause();
      }
    }
    var trapIndex = trapStack.indexOf(trap);
    if (trapIndex === -1) {
      trapStack.push(trap);
    } else {
      trapStack.splice(trapIndex, 1);
      trapStack.push(trap);
    }
  },
  deactivateTrap: function deactivateTrap(trapStack, trap) {
    var trapIndex = trapStack.indexOf(trap);
    if (trapIndex !== -1) {
      trapStack.splice(trapIndex, 1);
    }
    if (trapStack.length > 0) {
      trapStack[trapStack.length - 1].unpause();
    }
  }
};
var isSelectableInput = function isSelectableInput2(node2) {
  return node2.tagName && node2.tagName.toLowerCase() === "input" && typeof node2.select === "function";
};
var isEscapeEvent = function isEscapeEvent2(e2) {
  return e2.key === "Escape" || e2.key === "Esc" || e2.keyCode === 27;
};
var isTabEvent = function isTabEvent2(e2) {
  return e2.key === "Tab" || e2.keyCode === 9;
};
var isKeyForward = function isKeyForward2(e2) {
  return isTabEvent(e2) && !e2.shiftKey;
};
var isKeyBackward = function isKeyBackward2(e2) {
  return isTabEvent(e2) && e2.shiftKey;
};
var delay = function delay2(fn3) {
  return setTimeout(fn3, 0);
};
var findIndex = function findIndex2(arr, fn3) {
  var idx = -1;
  arr.every(function(value, i2) {
    if (fn3(value)) {
      idx = i2;
      return false;
    }
    return true;
  });
  return idx;
};
var valueOrHandler = function valueOrHandler2(value) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }
  return typeof value === "function" ? value.apply(void 0, params) : value;
};
var getActualTarget = function getActualTarget2(event) {
  return event.target.shadowRoot && typeof event.composedPath === "function" ? event.composedPath()[0] : event.target;
};
var internalTrapStack = [];
var createFocusTrap$1 = function createFocusTrap(elements, userOptions) {
  var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
  var trapStack = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.trapStack) || internalTrapStack;
  var config = _objectSpread2$1({
    returnFocusOnDeactivate: true,
    escapeDeactivates: true,
    delayInitialFocus: true,
    isKeyForward,
    isKeyBackward
  }, userOptions);
  var state = {
    containers: [],
    containerGroups: [],
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false,
    delayInitialFocusTimer: void 0
  };
  var trap;
  var getOption = function getOption2(configOverrideOptions, optionName, configOptionName) {
    return configOverrideOptions && configOverrideOptions[optionName] !== void 0 ? configOverrideOptions[optionName] : config[configOptionName || optionName];
  };
  var findContainerIndex = function findContainerIndex2(element, event) {
    var composedPath = typeof (event === null || event === void 0 ? void 0 : event.composedPath) === "function" ? event.composedPath() : void 0;
    return state.containerGroups.findIndex(function(_ref3) {
      var container = _ref3.container, tabbableNodes = _ref3.tabbableNodes;
      return container.contains(element) || (composedPath === null || composedPath === void 0 ? void 0 : composedPath.includes(container)) || tabbableNodes.find(function(node2) {
        return node2 === element;
      });
    });
  };
  var getNodeForOption = function getNodeForOption2(optionName) {
    var optionValue = config[optionName];
    if (typeof optionValue === "function") {
      for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        params[_key2 - 1] = arguments[_key2];
      }
      optionValue = optionValue.apply(void 0, params);
    }
    if (optionValue === true) {
      optionValue = void 0;
    }
    if (!optionValue) {
      if (optionValue === void 0 || optionValue === false) {
        return optionValue;
      }
      throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
    }
    var node2 = optionValue;
    if (typeof optionValue === "string") {
      node2 = doc.querySelector(optionValue);
      if (!node2) {
        throw new Error("`".concat(optionName, "` as selector refers to no known node"));
      }
    }
    return node2;
  };
  var getInitialFocusNode = function getInitialFocusNode2() {
    var node2 = getNodeForOption("initialFocus");
    if (node2 === false) {
      return false;
    }
    if (node2 === void 0 || !isFocusable$2(node2, config.tabbableOptions)) {
      if (findContainerIndex(doc.activeElement) >= 0) {
        node2 = doc.activeElement;
      } else {
        var firstTabbableGroup = state.tabbableGroups[0];
        var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
        node2 = firstTabbableNode || getNodeForOption("fallbackFocus");
      }
    }
    if (!node2) {
      throw new Error("Your focus-trap needs to have at least one focusable element");
    }
    return node2;
  };
  var updateTabbableNodes = function updateTabbableNodes2() {
    state.containerGroups = state.containers.map(function(container) {
      var tabbableNodes = tabbable(container, config.tabbableOptions);
      var focusableNodes = focusable(container, config.tabbableOptions);
      return {
        container,
        tabbableNodes,
        focusableNodes,
        firstTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[0] : null,
        lastTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : null,
        nextTabbableNode: function nextTabbableNode(node2) {
          var forward = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
          var nodeIdx = focusableNodes.findIndex(function(n2) {
            return n2 === node2;
          });
          if (nodeIdx < 0) {
            return void 0;
          }
          if (forward) {
            return focusableNodes.slice(nodeIdx + 1).find(function(n2) {
              return isTabbable(n2, config.tabbableOptions);
            });
          }
          return focusableNodes.slice(0, nodeIdx).reverse().find(function(n2) {
            return isTabbable(n2, config.tabbableOptions);
          });
        }
      };
    });
    state.tabbableGroups = state.containerGroups.filter(function(group) {
      return group.tabbableNodes.length > 0;
    });
    if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus")) {
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    }
  };
  var tryFocus = function tryFocus2(node2) {
    if (node2 === false) {
      return;
    }
    if (node2 === doc.activeElement) {
      return;
    }
    if (!node2 || !node2.focus) {
      tryFocus2(getInitialFocusNode());
      return;
    }
    node2.focus({
      preventScroll: !!config.preventScroll
    });
    state.mostRecentlyFocusedNode = node2;
    if (isSelectableInput(node2)) {
      node2.select();
    }
  };
  var getReturnFocusNode = function getReturnFocusNode2(previousActiveElement) {
    var node2 = getNodeForOption("setReturnFocus", previousActiveElement);
    return node2 ? node2 : node2 === false ? false : previousActiveElement;
  };
  var checkPointerDown = function checkPointerDown2(e2) {
    var target = getActualTarget(e2);
    if (findContainerIndex(target, e2) >= 0) {
      return;
    }
    if (valueOrHandler(config.clickOutsideDeactivates, e2)) {
      trap.deactivate({
        returnFocus: config.returnFocusOnDeactivate
      });
      return;
    }
    if (valueOrHandler(config.allowOutsideClick, e2)) {
      return;
    }
    e2.preventDefault();
  };
  var checkFocusIn = function checkFocusIn2(e2) {
    var target = getActualTarget(e2);
    var targetContained = findContainerIndex(target, e2) >= 0;
    if (targetContained || target instanceof Document) {
      if (targetContained) {
        state.mostRecentlyFocusedNode = target;
      }
    } else {
      e2.stopImmediatePropagation();
      tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
    }
  };
  var checkKeyNav = function checkKeyNav2(event) {
    var isBackward = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var target = getActualTarget(event);
    updateTabbableNodes();
    var destinationNode = null;
    if (state.tabbableGroups.length > 0) {
      var containerIndex = findContainerIndex(target, event);
      var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : void 0;
      if (containerIndex < 0) {
        if (isBackward) {
          destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
        } else {
          destinationNode = state.tabbableGroups[0].firstTabbableNode;
        }
      } else if (isBackward) {
        var startOfGroupIndex = findIndex(state.tabbableGroups, function(_ref22) {
          var firstTabbableNode = _ref22.firstTabbableNode;
          return target === firstTabbableNode;
        });
        if (startOfGroupIndex < 0 && (containerGroup.container === target || isFocusable$2(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) {
          startOfGroupIndex = containerIndex;
        }
        if (startOfGroupIndex >= 0) {
          var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
          var destinationGroup = state.tabbableGroups[destinationGroupIndex];
          destinationNode = destinationGroup.lastTabbableNode;
        } else if (!isTabEvent(event)) {
          destinationNode = containerGroup.nextTabbableNode(target, false);
        }
      } else {
        var lastOfGroupIndex = findIndex(state.tabbableGroups, function(_ref3) {
          var lastTabbableNode = _ref3.lastTabbableNode;
          return target === lastTabbableNode;
        });
        if (lastOfGroupIndex < 0 && (containerGroup.container === target || isFocusable$2(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) {
          lastOfGroupIndex = containerIndex;
        }
        if (lastOfGroupIndex >= 0) {
          var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
          var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
          destinationNode = _destinationGroup.firstTabbableNode;
        } else if (!isTabEvent(event)) {
          destinationNode = containerGroup.nextTabbableNode(target);
        }
      }
    } else {
      destinationNode = getNodeForOption("fallbackFocus");
    }
    if (destinationNode) {
      if (isTabEvent(event)) {
        event.preventDefault();
      }
      tryFocus(destinationNode);
    }
  };
  var checkKey = function checkKey2(event) {
    if (isEscapeEvent(event) && valueOrHandler(config.escapeDeactivates, event) !== false) {
      event.preventDefault();
      trap.deactivate();
      return;
    }
    if (config.isKeyForward(event) || config.isKeyBackward(event)) {
      checkKeyNav(event, config.isKeyBackward(event));
    }
  };
  var checkClick = function checkClick2(e2) {
    var target = getActualTarget(e2);
    if (findContainerIndex(target, e2) >= 0) {
      return;
    }
    if (valueOrHandler(config.clickOutsideDeactivates, e2)) {
      return;
    }
    if (valueOrHandler(config.allowOutsideClick, e2)) {
      return;
    }
    e2.preventDefault();
    e2.stopImmediatePropagation();
  };
  var addListeners = function addListeners2() {
    if (!state.active) {
      return;
    }
    activeFocusTraps.activateTrap(trapStack, trap);
    state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function() {
      tryFocus(getInitialFocusNode());
    }) : tryFocus(getInitialFocusNode());
    doc.addEventListener("focusin", checkFocusIn, true);
    doc.addEventListener("mousedown", checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener("touchstart", checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener("click", checkClick, {
      capture: true,
      passive: false
    });
    doc.addEventListener("keydown", checkKey, {
      capture: true,
      passive: false
    });
    return trap;
  };
  var removeListeners = function removeListeners2() {
    if (!state.active) {
      return;
    }
    doc.removeEventListener("focusin", checkFocusIn, true);
    doc.removeEventListener("mousedown", checkPointerDown, true);
    doc.removeEventListener("touchstart", checkPointerDown, true);
    doc.removeEventListener("click", checkClick, true);
    doc.removeEventListener("keydown", checkKey, true);
    return trap;
  };
  var checkDomRemoval = function checkDomRemoval2(mutations) {
    var isFocusedNodeRemoved = mutations.some(function(mutation) {
      var removedNodes = Array.from(mutation.removedNodes);
      return removedNodes.some(function(node2) {
        return node2 === state.mostRecentlyFocusedNode;
      });
    });
    if (isFocusedNodeRemoved) {
      tryFocus(getInitialFocusNode());
    }
  };
  var mutationObserver = typeof window !== "undefined" && "MutationObserver" in window ? new MutationObserver(checkDomRemoval) : void 0;
  var updateObservedNodes = function updateObservedNodes2() {
    if (!mutationObserver) {
      return;
    }
    mutationObserver.disconnect();
    if (state.active && !state.paused) {
      state.containers.map(function(container) {
        mutationObserver.observe(container, {
          subtree: true,
          childList: true
        });
      });
    }
  };
  trap = {
    get active() {
      return state.active;
    },
    get paused() {
      return state.paused;
    },
    activate: function activate(activateOptions) {
      if (state.active) {
        return this;
      }
      var onActivate = getOption(activateOptions, "onActivate");
      var onPostActivate = getOption(activateOptions, "onPostActivate");
      var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
      if (!checkCanFocusTrap) {
        updateTabbableNodes();
      }
      state.active = true;
      state.paused = false;
      state.nodeFocusedBeforeActivation = doc.activeElement;
      onActivate === null || onActivate === void 0 ? void 0 : onActivate();
      var finishActivation = function finishActivation2() {
        if (checkCanFocusTrap) {
          updateTabbableNodes();
        }
        addListeners();
        updateObservedNodes();
        onPostActivate === null || onPostActivate === void 0 ? void 0 : onPostActivate();
      };
      if (checkCanFocusTrap) {
        checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
        return this;
      }
      finishActivation();
      return this;
    },
    deactivate: function deactivate(deactivateOptions) {
      if (!state.active) {
        return this;
      }
      var options = _objectSpread2$1({
        onDeactivate: config.onDeactivate,
        onPostDeactivate: config.onPostDeactivate,
        checkCanReturnFocus: config.checkCanReturnFocus
      }, deactivateOptions);
      clearTimeout(state.delayInitialFocusTimer);
      state.delayInitialFocusTimer = void 0;
      removeListeners();
      state.active = false;
      state.paused = false;
      updateObservedNodes();
      activeFocusTraps.deactivateTrap(trapStack, trap);
      var onDeactivate = getOption(options, "onDeactivate");
      var onPostDeactivate = getOption(options, "onPostDeactivate");
      var checkCanReturnFocus = getOption(options, "checkCanReturnFocus");
      var returnFocus = getOption(options, "returnFocus", "returnFocusOnDeactivate");
      onDeactivate === null || onDeactivate === void 0 ? void 0 : onDeactivate();
      var finishDeactivation = function finishDeactivation2() {
        delay(function() {
          if (returnFocus) {
            tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
          }
          onPostDeactivate === null || onPostDeactivate === void 0 ? void 0 : onPostDeactivate();
        });
      };
      if (returnFocus && checkCanReturnFocus) {
        checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
        return this;
      }
      finishDeactivation();
      return this;
    },
    pause: function pause(pauseOptions) {
      if (state.paused || !state.active) {
        return this;
      }
      var onPause = getOption(pauseOptions, "onPause");
      var onPostPause = getOption(pauseOptions, "onPostPause");
      state.paused = true;
      onPause === null || onPause === void 0 ? void 0 : onPause();
      removeListeners();
      updateObservedNodes();
      onPostPause === null || onPostPause === void 0 ? void 0 : onPostPause();
      return this;
    },
    unpause: function unpause(unpauseOptions) {
      if (!state.paused || !state.active) {
        return this;
      }
      var onUnpause = getOption(unpauseOptions, "onUnpause");
      var onPostUnpause = getOption(unpauseOptions, "onPostUnpause");
      state.paused = false;
      onUnpause === null || onUnpause === void 0 ? void 0 : onUnpause();
      updateTabbableNodes();
      addListeners();
      updateObservedNodes();
      onPostUnpause === null || onPostUnpause === void 0 ? void 0 : onPostUnpause();
      return this;
    },
    updateContainerElements: function updateContainerElements(containerElements) {
      var elementsAsArray = [].concat(containerElements).filter(Boolean);
      state.containers = elementsAsArray.map(function(element) {
        return typeof element === "string" ? doc.querySelector(element) : element;
      });
      if (state.active) {
        updateTabbableNodes();
      }
      updateObservedNodes();
      return this;
    }
  };
  trap.updateContainerElements(elements);
  return trap;
};
var focusTrap_esm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createFocusTrap: createFocusTrap$1
}, Symbol.toStringTag, { value: "Module" }));
var require$$2 = /* @__PURE__ */ getAugmentedNamespace(focusTrap_esm);
var require$$3 = /* @__PURE__ */ getAugmentedNamespace(index_esm);
function _typeof$2(obj) {
  "@babel/helpers - typeof";
  return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$2(obj);
}
function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$2(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$2(descriptor.key), descriptor);
  }
}
function _createClass$2(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$2(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$2(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits$2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass)
    _setPrototypeOf$2(subClass, superClass);
}
function _setPrototypeOf$2(o, p2) {
  _setPrototypeOf$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p3) {
    o2.__proto__ = p3;
    return o2;
  };
  return _setPrototypeOf$2(o, p2);
}
function _createSuper$3(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$3();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$2(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$2(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$2(this, result);
  };
}
function _possibleConstructorReturn$2(self2, call) {
  if (call && (_typeof$2(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$2(self2);
}
function _assertThisInitialized$2(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _isNativeReflectConstruct$3() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e2) {
    return false;
  }
}
function _getPrototypeOf$2(o) {
  _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$2(o);
}
function _defineProperty$2(obj, key, value) {
  key = _toPropertyKey$2(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$2(arg) {
  var key = _toPrimitive$2(arg, "string");
  return _typeof$2(key) === "symbol" ? key : String(key);
}
function _toPrimitive$2(input2, hint) {
  if (_typeof$2(input2) !== "object" || input2 === null)
    return input2;
  var prim = input2[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input2, hint || "default");
    if (_typeof$2(res) !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input2);
}
var React = React__default;
var PropTypes = propTypes$8.exports;
var _require = require$$2, createFocusTrap2 = _require.createFocusTrap;
var _require2 = require$$3, isFocusable$1 = _require2.isFocusable;
var FocusTrap = /* @__PURE__ */ function(_React$Component) {
  _inherits$2(FocusTrap2, _React$Component);
  var _super = _createSuper$3(FocusTrap2);
  function FocusTrap2(props) {
    var _this;
    _classCallCheck$2(this, FocusTrap2);
    _this = _super.call(this, props);
    _defineProperty$2(_assertThisInitialized$2(_this), "getNodeForOption", function(optionName2) {
      var _this$internalOptions;
      var optionValue = (_this$internalOptions = this.internalOptions[optionName2]) !== null && _this$internalOptions !== void 0 ? _this$internalOptions : this.originalOptions[optionName2];
      if (typeof optionValue === "function") {
        for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          params[_key - 1] = arguments[_key];
        }
        optionValue = optionValue.apply(void 0, params);
      }
      if (optionValue === true) {
        optionValue = void 0;
      }
      if (!optionValue) {
        if (optionValue === void 0 || optionValue === false) {
          return optionValue;
        }
        throw new Error("`".concat(optionName2, "` was specified but was not a node, or did not return a node"));
      }
      var node2 = optionValue;
      if (typeof optionValue === "string") {
        var _this$getDocument;
        node2 = (_this$getDocument = this.getDocument()) === null || _this$getDocument === void 0 ? void 0 : _this$getDocument.querySelector(optionValue);
        if (!node2) {
          throw new Error("`".concat(optionName2, "` as selector refers to no known node"));
        }
      }
      return node2;
    });
    _this.handleDeactivate = _this.handleDeactivate.bind(_assertThisInitialized$2(_this));
    _this.handlePostDeactivate = _this.handlePostDeactivate.bind(_assertThisInitialized$2(_this));
    _this.handleClickOutsideDeactivates = _this.handleClickOutsideDeactivates.bind(_assertThisInitialized$2(_this));
    _this.internalOptions = {
      returnFocusOnDeactivate: false,
      checkCanReturnFocus: null,
      onDeactivate: _this.handleDeactivate,
      onPostDeactivate: _this.handlePostDeactivate,
      clickOutsideDeactivates: _this.handleClickOutsideDeactivates
    };
    _this.originalOptions = {
      returnFocusOnDeactivate: true,
      onDeactivate: null,
      onPostDeactivate: null,
      checkCanReturnFocus: null,
      clickOutsideDeactivates: false
    };
    var focusTrapOptions = props.focusTrapOptions;
    for (var optionName in focusTrapOptions) {
      if (!Object.prototype.hasOwnProperty.call(focusTrapOptions, optionName)) {
        continue;
      }
      if (optionName === "returnFocusOnDeactivate" || optionName === "onDeactivate" || optionName === "onPostDeactivate" || optionName === "checkCanReturnFocus" || optionName === "clickOutsideDeactivates") {
        _this.originalOptions[optionName] = focusTrapOptions[optionName];
        continue;
      }
      _this.internalOptions[optionName] = focusTrapOptions[optionName];
    }
    _this.outsideClick = null;
    _this.focusTrapElements = props.containerElements || [];
    _this.updatePreviousElement();
    return _this;
  }
  _createClass$2(FocusTrap2, [{
    key: "getDocument",
    value: function getDocument() {
      return this.props.focusTrapOptions.document || (typeof document !== "undefined" ? document : void 0);
    }
  }, {
    key: "getReturnFocusNode",
    value: function getReturnFocusNode() {
      var node2 = this.getNodeForOption("setReturnFocus", this.previouslyFocusedElement);
      return node2 ? node2 : node2 === false ? false : this.previouslyFocusedElement;
    }
  }, {
    key: "updatePreviousElement",
    value: function updatePreviousElement() {
      var currentDocument = this.getDocument();
      if (currentDocument) {
        this.previouslyFocusedElement = currentDocument.activeElement;
      }
    }
  }, {
    key: "deactivateTrap",
    value: function deactivateTrap2() {
      if (!this.focusTrap || !this.focusTrap.active) {
        return;
      }
      this.focusTrap.deactivate({
        returnFocus: false,
        checkCanReturnFocus: null,
        onDeactivate: this.originalOptions.onDeactivate
      });
    }
  }, {
    key: "handleClickOutsideDeactivates",
    value: function handleClickOutsideDeactivates(event) {
      var allowDeactivation = typeof this.originalOptions.clickOutsideDeactivates === "function" ? this.originalOptions.clickOutsideDeactivates.call(null, event) : this.originalOptions.clickOutsideDeactivates;
      if (allowDeactivation) {
        this.outsideClick = {
          target: event.target,
          allowDeactivation
        };
      }
      return allowDeactivation;
    }
  }, {
    key: "handleDeactivate",
    value: function handleDeactivate() {
      if (this.originalOptions.onDeactivate) {
        this.originalOptions.onDeactivate.call(null);
      }
      this.deactivateTrap();
    }
  }, {
    key: "handlePostDeactivate",
    value: function handlePostDeactivate() {
      var _this2 = this;
      var finishDeactivation = function finishDeactivation2() {
        var returnFocusNode = _this2.getReturnFocusNode();
        var canReturnFocus = !!(_this2.originalOptions.returnFocusOnDeactivate && returnFocusNode !== null && returnFocusNode !== void 0 && returnFocusNode.focus && (!_this2.outsideClick || _this2.outsideClick.allowDeactivation && !isFocusable$1(_this2.outsideClick.target, _this2.internalOptions.tabbableOptions)));
        var _this2$internalOption = _this2.internalOptions.preventScroll, preventScroll = _this2$internalOption === void 0 ? false : _this2$internalOption;
        if (canReturnFocus) {
          returnFocusNode.focus({
            preventScroll
          });
        }
        if (_this2.originalOptions.onPostDeactivate) {
          _this2.originalOptions.onPostDeactivate.call(null);
        }
        _this2.outsideClick = null;
      };
      if (this.originalOptions.checkCanReturnFocus) {
        this.originalOptions.checkCanReturnFocus.call(null, this.getReturnFocusNode()).then(finishDeactivation, finishDeactivation);
      } else {
        finishDeactivation();
      }
    }
  }, {
    key: "setupFocusTrap",
    value: function setupFocusTrap() {
      if (this.focusTrap) {
        if (this.props.active && !this.focusTrap.active) {
          this.focusTrap.activate();
          if (this.props.paused) {
            this.focusTrap.pause();
          }
        }
      } else {
        var nodesExist = this.focusTrapElements.some(Boolean);
        if (nodesExist) {
          this.focusTrap = this.props._createFocusTrap(this.focusTrapElements, this.internalOptions);
          if (this.props.active) {
            this.focusTrap.activate();
          }
          if (this.props.paused) {
            this.focusTrap.pause();
          }
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.active) {
        this.setupFocusTrap();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.focusTrap) {
        if (prevProps.containerElements !== this.props.containerElements) {
          this.focusTrap.updateContainerElements(this.props.containerElements);
        }
        var hasActivated = !prevProps.active && this.props.active;
        var hasDeactivated = prevProps.active && !this.props.active;
        var hasPaused = !prevProps.paused && this.props.paused;
        var hasUnpaused = prevProps.paused && !this.props.paused;
        if (hasActivated) {
          this.updatePreviousElement();
          this.focusTrap.activate();
        }
        if (hasDeactivated) {
          this.deactivateTrap();
          return;
        }
        if (hasPaused) {
          this.focusTrap.pause();
        }
        if (hasUnpaused) {
          this.focusTrap.unpause();
        }
      } else {
        if (prevProps.containerElements !== this.props.containerElements) {
          this.focusTrapElements = this.props.containerElements;
        }
        if (this.props.active) {
          this.updatePreviousElement();
          this.setupFocusTrap();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.deactivateTrap();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var child = this.props.children ? React.Children.only(this.props.children) : void 0;
      if (child) {
        if (child.type && child.type === React.Fragment) {
          throw new Error("A focus-trap cannot use a Fragment as its child container. Try replacing it with a <div> element.");
        }
        var callbackRef = function callbackRef2(element) {
          var containerElements = _this3.props.containerElements;
          if (child) {
            if (typeof child.ref === "function") {
              child.ref(element);
            } else if (child.ref) {
              child.ref.current = element;
            }
          }
          _this3.focusTrapElements = containerElements ? containerElements : [element];
        };
        var childWithRef = React.cloneElement(child, {
          ref: callbackRef
        });
        return childWithRef;
      }
      return null;
    }
  }]);
  return FocusTrap2;
}(React.Component);
var ElementType = typeof Element === "undefined" ? Function : Element;
FocusTrap.propTypes = {
  active: PropTypes.bool,
  paused: PropTypes.bool,
  focusTrapOptions: PropTypes.shape({
    document: PropTypes.object,
    onActivate: PropTypes.func,
    onPostActivate: PropTypes.func,
    checkCanFocusTrap: PropTypes.func,
    onPause: PropTypes.func,
    onPostPause: PropTypes.func,
    onUnpause: PropTypes.func,
    onPostUnpause: PropTypes.func,
    onDeactivate: PropTypes.func,
    onPostDeactivate: PropTypes.func,
    checkCanReturnFocus: PropTypes.func,
    initialFocus: PropTypes.oneOfType([PropTypes.instanceOf(ElementType), PropTypes.string, PropTypes.bool, PropTypes.func]),
    fallbackFocus: PropTypes.oneOfType([
      PropTypes.instanceOf(ElementType),
      PropTypes.string,
      PropTypes.func
    ]),
    escapeDeactivates: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    clickOutsideDeactivates: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    returnFocusOnDeactivate: PropTypes.bool,
    setReturnFocus: PropTypes.oneOfType([PropTypes.instanceOf(ElementType), PropTypes.string, PropTypes.bool, PropTypes.func]),
    allowOutsideClick: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    preventScroll: PropTypes.bool,
    tabbableOptions: PropTypes.shape({
      displayCheck: PropTypes.oneOf(["full", "legacy-full", "non-zero-area", "none"]),
      getShadowRoot: PropTypes.oneOfType([PropTypes.bool, PropTypes.func])
    }),
    trapStack: PropTypes.array,
    isKeyForward: PropTypes.func,
    isKeyBackward: PropTypes.func
  }),
  containerElements: PropTypes.arrayOf(PropTypes.instanceOf(ElementType)),
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.instanceOf(ElementType)
  ])
};
FocusTrap.defaultProps = {
  active: true,
  paused: false,
  focusTrapOptions: {},
  _createFocusTrap: createFocusTrap2
};
var __assign$o = globalThis && globalThis.__assign || function() {
  __assign$o = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$o.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
let nanoid = (size = 21) => crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte) => {
  byte &= 63;
  if (byte < 36) {
    id += byte.toString(36);
  } else if (byte < 62) {
    id += (byte - 26).toString(36).toUpperCase();
  } else if (byte > 62) {
    id += "-";
  } else {
    id += "_";
  }
  return id;
}, "");
var __assign$n = globalThis && globalThis.__assign || function() {
  __assign$n = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$n.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
globalThis && globalThis.__spreadArray || function(to, from2, pack) {
  if (pack || arguments.length === 2)
    for (var i2 = 0, l2 = from2.length, ar; i2 < l2; i2++) {
      if (ar || !(i2 in from2)) {
        if (!ar)
          ar = Array.prototype.slice.call(from2, 0, i2);
        ar[i2] = from2[i2];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from2));
};
var __assign$m = globalThis && globalThis.__assign || function() {
  __assign$m = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$m.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var __assign$l = globalThis && globalThis.__assign || function() {
  __assign$l = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$l.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
function _typeof$1(obj) {
  "@babel/helpers - typeof";
  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$1(obj);
}
function _toPrimitive$1(input2, hint) {
  if (_typeof$1(input2) !== "object" || input2 === null)
    return input2;
  var prim = input2[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input2, hint || "default");
    if (_typeof$1(res) !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input2);
}
function _toPropertyKey$1(arg) {
  var key = _toPrimitive$1(arg, "string");
  return _typeof$1(key) === "symbol" ? key : String(key);
}
function _defineProperty$1(obj, key, value) {
  key = _toPropertyKey$1(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function ownKeys$c(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys$c(Object(source), true).forEach(function(key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$c(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _iterableToArrayLimit$1(arr, i2) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s, _e, _x, _r, _arr = [], _n = true, _d = false;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i2) {
        if (Object(_i) !== _i)
          return;
        _n = false;
      } else
        for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i2); _n = true) {
          ;
        }
    } catch (err) {
      _d = true, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r))
          return;
      } finally {
        if (_d)
          throw _e;
      }
    }
    return _arr;
  }
}
function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++) {
    arr2[i2] = arr[i2];
  }
  return arr2;
}
function _unsupportedIterableToArray$1(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$1(o, minLen);
  var n2 = Object.prototype.toString.call(o).slice(8, -1);
  if (n2 === "Object" && o.constructor)
    n2 = o.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray$1(o, minLen);
}
function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray$1(arr, i2) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i2) || _unsupportedIterableToArray$1(arr, i2) || _nonIterableRest$1();
}
function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key = sourceKeys[i2];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties$2(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose$2(source, excluded);
  var key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++) {
      key = sourceSymbolKeys[i2];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
var _excluded$i = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function useStateManager(_ref3) {
  var _ref$defaultInputValu = _ref3.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? "" : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref3.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref3.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref3.inputValue, propsMenuIsOpen = _ref3.menuIsOpen, propsOnChange = _ref3.onChange, propsOnInputChange = _ref3.onInputChange, propsOnMenuClose = _ref3.onMenuClose, propsOnMenuOpen = _ref3.onMenuOpen, propsValue = _ref3.value, restSelectProps = _objectWithoutProperties$2(_ref3, _excluded$i);
  var _useState = useState(propsInputValue !== void 0 ? propsInputValue : defaultInputValue), _useState2 = _slicedToArray$1(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
  var _useState3 = useState(propsMenuIsOpen !== void 0 ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = _slicedToArray$1(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
  var _useState5 = useState(propsValue !== void 0 ? propsValue : defaultValue), _useState6 = _slicedToArray$1(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
  var onChange2 = useCallback(function(value2, actionMeta) {
    if (typeof propsOnChange === "function") {
      propsOnChange(value2, actionMeta);
    }
    setStateValue(value2);
  }, [propsOnChange]);
  var onInputChange = useCallback(function(value2, actionMeta) {
    var newValue;
    if (typeof propsOnInputChange === "function") {
      newValue = propsOnInputChange(value2, actionMeta);
    }
    setStateInputValue(newValue !== void 0 ? newValue : value2);
  }, [propsOnInputChange]);
  var onMenuOpen = useCallback(function() {
    if (typeof propsOnMenuOpen === "function") {
      propsOnMenuOpen();
    }
    setStateMenuIsOpen(true);
  }, [propsOnMenuOpen]);
  var onMenuClose = useCallback(function() {
    if (typeof propsOnMenuClose === "function") {
      propsOnMenuClose();
    }
    setStateMenuIsOpen(false);
  }, [propsOnMenuClose]);
  var inputValue = propsInputValue !== void 0 ? propsInputValue : stateInputValue;
  var menuIsOpen = propsMenuIsOpen !== void 0 ? propsMenuIsOpen : stateMenuIsOpen;
  var value = propsValue !== void 0 ? propsValue : stateValue;
  return _objectSpread2(_objectSpread2({}, restSelectProps), {}, {
    inputValue,
    menuIsOpen,
    onChange: onChange2,
    onInputChange,
    onMenuClose,
    onMenuOpen,
    value
  });
}
function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$1(descriptor.key), descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _setPrototypeOf$1(o, p2) {
  _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p3) {
    o2.__proto__ = p3;
    return o2;
  };
  return _setPrototypeOf$1(o, p2);
}
function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass)
    _setPrototypeOf$1(subClass, superClass);
}
function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf$1(o);
}
function _isNativeReflectConstruct$2() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e2) {
    return false;
  }
}
function _assertThisInitialized$1(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _possibleConstructorReturn$1(self2, call) {
  if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized$1(self2);
}
function _createSuper$2(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1(this, result);
  };
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray$1(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread();
}
function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }
  for (var i2 = 0; i2 < document.styleSheets.length; i2++) {
    if (document.styleSheets[i2].ownerNode === tag) {
      return document.styleSheets[i2];
    }
  }
}
function createStyleElement(options) {
  var tag = document.createElement("style");
  tag.setAttribute("data-emotion", options.key);
  if (options.nonce !== void 0) {
    tag.setAttribute("nonce", options.nonce);
  }
  tag.appendChild(document.createTextNode(""));
  tag.setAttribute("data-s", "");
  return tag;
}
var StyleSheet = /* @__PURE__ */ function() {
  function StyleSheet2(options) {
    var _this = this;
    this._insertTag = function(tag) {
      var before;
      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }
      _this.container.insertBefore(tag, before);
      _this.tags.push(tag);
    };
    this.isSpeedy = options.speedy === void 0 ? true : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce;
    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }
  var _proto = StyleSheet2.prototype;
  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };
  _proto.insert = function insert(rule) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }
    var tag = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);
      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e2) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush() {
    this.tags.forEach(function(tag) {
      return tag.parentNode && tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };
  return StyleSheet2;
}();
var MS = "-ms-";
var MOZ = "-moz-";
var WEBKIT = "-webkit-";
var COMMENT = "comm";
var RULESET = "rule";
var DECLARATION = "decl";
var IMPORT = "@import";
var KEYFRAMES = "@keyframes";
var abs = Math.abs;
var from = String.fromCharCode;
var assign = Object.assign;
function hash(value, length2) {
  return charat(value, 0) ^ 45 ? (((length2 << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3) : 0;
}
function trim(value) {
  return value.trim();
}
function match(value, pattern) {
  return (value = pattern.exec(value)) ? value[0] : value;
}
function replace(value, pattern, replacement) {
  return value.replace(pattern, replacement);
}
function indexof(value, search) {
  return value.indexOf(search);
}
function charat(value, index2) {
  return value.charCodeAt(index2) | 0;
}
function substr(value, begin, end2) {
  return value.slice(begin, end2);
}
function strlen(value) {
  return value.length;
}
function sizeof(value) {
  return value.length;
}
function append(value, array) {
  return array.push(value), value;
}
function combine(array, callback) {
  return array.map(callback).join("");
}
var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = "";
function node(value, root2, parent, type, props, children, length2) {
  return { value, root: root2, parent, type, props, children, line, column, length: length2, return: "" };
}
function copy(root2, props) {
  return assign(node("", null, null, "", null, null, 0), root2, { length: -root2.length }, props);
}
function char() {
  return character;
}
function prev() {
  character = position > 0 ? charat(characters, --position) : 0;
  if (column--, character === 10)
    column = 1, line--;
  return character;
}
function next() {
  character = position < length ? charat(characters, position++) : 0;
  if (column++, character === 10)
    column = 1, line++;
  return character;
}
function peek() {
  return charat(characters, position);
}
function caret() {
  return position;
}
function slice(begin, end2) {
  return substr(characters, begin, end2);
}
function token(type) {
  switch (type) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(value) {
  return line = column = 1, length = strlen(characters = value), position = 0, [];
}
function dealloc(value) {
  return characters = "", value;
}
function delimit(type) {
  return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function whitespace(type) {
  while (character = peek())
    if (character < 33)
      next();
    else
      break;
  return token(type) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(index2, count) {
  while (--count && next())
    if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97)
      break;
  return slice(index2, caret() + (count < 6 && peek() == 32 && next() == 32));
}
function delimiter(type) {
  while (next())
    switch (character) {
      case type:
        return position;
      case 34:
      case 39:
        if (type !== 34 && type !== 39)
          delimiter(character);
        break;
      case 40:
        if (type === 41)
          delimiter(type);
        break;
      case 92:
        next();
        break;
    }
  return position;
}
function commenter(type, index2) {
  while (next())
    if (type + character === 47 + 10)
      break;
    else if (type + character === 42 + 42 && peek() === 47)
      break;
  return "/*" + slice(index2, position - 1) + "*" + from(type === 47 ? type : next());
}
function identifier(index2) {
  while (!token(peek()))
    next();
  return slice(index2, position);
}
function compile(value) {
  return dealloc(parse("", null, null, null, [""], value = alloc(value), 0, [0], value));
}
function parse(value, root2, parent, rule, rules, rulesets, pseudo, points, declarations) {
  var index2 = 0;
  var offset2 = 0;
  var length2 = pseudo;
  var atrule = 0;
  var property = 0;
  var previous = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character2 = 0;
  var type = "";
  var props = rules;
  var children = rulesets;
  var reference2 = rule;
  var characters2 = type;
  while (scanning)
    switch (previous = character2, character2 = next()) {
      case 40:
        if (previous != 108 && charat(characters2, length2 - 1) == 58) {
          if (indexof(characters2 += replace(delimit(character2), "&", "&\f"), "&\f") != -1)
            ampersand = -1;
          break;
        }
      case 34:
      case 39:
      case 91:
        characters2 += delimit(character2);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        characters2 += whitespace(previous);
        break;
      case 92:
        characters2 += escaping(caret() - 1, 7);
        continue;
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), root2, parent), declarations);
            break;
          default:
            characters2 += "/";
        }
        break;
      case 123 * variable:
        points[index2++] = strlen(characters2) * ampersand;
      case 125 * variable:
      case 59:
      case 0:
        switch (character2) {
          case 0:
          case 125:
            scanning = 0;
          case 59 + offset2:
            if (property > 0 && strlen(characters2) - length2)
              append(property > 32 ? declaration(characters2 + ";", rule, parent, length2 - 1) : declaration(replace(characters2, " ", "") + ";", rule, parent, length2 - 2), declarations);
            break;
          case 59:
            characters2 += ";";
          default:
            append(reference2 = ruleset(characters2, root2, parent, index2, offset2, rules, points, type, props = [], children = [], length2), rulesets);
            if (character2 === 123)
              if (offset2 === 0)
                parse(characters2, root2, reference2, reference2, props, rulesets, length2, points, children);
              else
                switch (atrule === 99 && charat(characters2, 3) === 110 ? 100 : atrule) {
                  case 100:
                  case 109:
                  case 115:
                    parse(value, reference2, reference2, rule && append(ruleset(value, reference2, reference2, 0, 0, rules, points, type, rules, props = [], length2), children), rules, children, length2, points, rule ? props : children);
                    break;
                  default:
                    parse(characters2, reference2, reference2, reference2, [""], children, 0, points, children);
                }
        }
        index2 = offset2 = property = 0, variable = ampersand = 1, type = characters2 = "", length2 = pseudo;
        break;
      case 58:
        length2 = 1 + strlen(characters2), property = previous;
      default:
        if (variable < 1) {
          if (character2 == 123)
            --variable;
          else if (character2 == 125 && variable++ == 0 && prev() == 125)
            continue;
        }
        switch (characters2 += from(character2), character2 * variable) {
          case 38:
            ampersand = offset2 > 0 ? 1 : (characters2 += "\f", -1);
            break;
          case 44:
            points[index2++] = (strlen(characters2) - 1) * ampersand, ampersand = 1;
            break;
          case 64:
            if (peek() === 45)
              characters2 += delimit(next());
            atrule = peek(), offset2 = length2 = strlen(type = characters2 += identifier(caret())), character2++;
            break;
          case 45:
            if (previous === 45 && strlen(characters2) == 2)
              variable = 0;
        }
    }
  return rulesets;
}
function ruleset(value, root2, parent, index2, offset2, rules, points, type, props, children, length2) {
  var post = offset2 - 1;
  var rule = offset2 === 0 ? rules : [""];
  var size = sizeof(rule);
  for (var i2 = 0, j = 0, k2 = 0; i2 < index2; ++i2)
    for (var x2 = 0, y2 = substr(value, post + 1, post = abs(j = points[i2])), z2 = value; x2 < size; ++x2)
      if (z2 = trim(j > 0 ? rule[x2] + " " + y2 : replace(y2, /&\f/g, rule[x2])))
        props[k2++] = z2;
  return node(value, root2, parent, offset2 === 0 ? RULESET : type, props, children, length2);
}
function comment(value, root2, parent) {
  return node(value, root2, parent, COMMENT, from(char()), substr(value, 2, -2), 0);
}
function declaration(value, root2, parent, length2) {
  return node(value, root2, parent, DECLARATION, substr(value, 0, length2), substr(value, length2 + 1, -1), length2);
}
function serialize(children, callback) {
  var output = "";
  var length2 = sizeof(children);
  for (var i2 = 0; i2 < length2; i2++)
    output += callback(children[i2], i2, children, callback) || "";
  return output;
}
function stringify(element, index2, children, callback) {
  switch (element.type) {
    case IMPORT:
    case DECLARATION:
      return element.return = element.return || element.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return element.return = element.value + "{" + serialize(element.children, callback) + "}";
    case RULESET:
      element.value = element.props.join(",");
  }
  return strlen(children = serialize(element.children, callback)) ? element.return = element.value + "{" + children + "}" : "";
}
function middleware(collection) {
  var length2 = sizeof(collection);
  return function(element, index2, children, callback) {
    var output = "";
    for (var i2 = 0; i2 < length2; i2++)
      output += collection[i2](element, index2, children, callback) || "";
    return output;
  };
}
function rulesheet(callback) {
  return function(element) {
    if (!element.root) {
      if (element = element.return)
        callback(element);
    }
  };
}
function memoize(fn3) {
  var cache = /* @__PURE__ */ Object.create(null);
  return function(arg) {
    if (cache[arg] === void 0)
      cache[arg] = fn3(arg);
    return cache[arg];
  };
}
var identifierWithPointTracking = function identifierWithPointTracking2(begin, points, index2) {
  var previous = 0;
  var character2 = 0;
  while (true) {
    previous = character2;
    character2 = peek();
    if (previous === 38 && character2 === 12) {
      points[index2] = 1;
    }
    if (token(character2)) {
      break;
    }
    next();
  }
  return slice(begin, position);
};
var toRules = function toRules2(parsed, points) {
  var index2 = -1;
  var character2 = 44;
  do {
    switch (token(character2)) {
      case 0:
        if (character2 === 38 && peek() === 12) {
          points[index2] = 1;
        }
        parsed[index2] += identifierWithPointTracking(position - 1, points, index2);
        break;
      case 2:
        parsed[index2] += delimit(character2);
        break;
      case 4:
        if (character2 === 44) {
          parsed[++index2] = peek() === 58 ? "&\f" : "";
          points[index2] = parsed[index2].length;
          break;
        }
      default:
        parsed[index2] += from(character2);
    }
  } while (character2 = next());
  return parsed;
};
var getRules = function getRules2(value, points) {
  return dealloc(toRules(alloc(value), points));
};
var fixedElements = /* @__PURE__ */ new WeakMap();
var compat = function compat2(element) {
  if (element.type !== "rule" || !element.parent || element.length < 1) {
    return;
  }
  var value = element.value, parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;
  while (parent.type !== "rule") {
    parent = parent.parent;
    if (!parent)
      return;
  }
  if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) {
    return;
  }
  if (isImplicitRule) {
    return;
  }
  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;
  for (var i2 = 0, k2 = 0; i2 < rules.length; i2++) {
    for (var j = 0; j < parentRules.length; j++, k2++) {
      element.props[k2] = points[i2] ? rules[i2].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i2];
    }
  }
};
var removeLabel = function removeLabel2(element) {
  if (element.type === "decl") {
    var value = element.value;
    if (value.charCodeAt(0) === 108 && value.charCodeAt(2) === 98) {
      element["return"] = "";
      element.value = "";
    }
  }
};
function prefix(value, length2) {
  switch (hash(value, length2)) {
    case 5103:
      return WEBKIT + "print-" + value + value;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    case 6165:
      return WEBKIT + value + MS + "flex-" + value + value;
    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + value;
    case 5443:
      return WEBKIT + value + MS + "flex-item-" + replace(value, /flex-|-self/, "") + value;
    case 4675:
      return WEBKIT + value + MS + "flex-line-pack" + replace(value, /align-content|flex-|-self/, "") + value;
    case 5548:
      return WEBKIT + value + MS + replace(value, "shrink", "negative") + value;
    case 5292:
      return WEBKIT + value + MS + replace(value, "basis", "preferred-size") + value;
    case 6060:
      return WEBKIT + "box-" + replace(value, "-grow", "") + WEBKIT + value + MS + replace(value, "grow", "positive") + value;
    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + value;
    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), value, "") + value;
    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + value + value;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + "$1$2") + value;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(value) - 1 - length2 > 6)
        switch (charat(value, length2 + 1)) {
          case 109:
            if (charat(value, length2 + 4) !== 45)
              break;
          case 102:
            return replace(value, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(value, length2 + 3) == 108 ? "$3" : "$2-$3")) + value;
          case 115:
            return ~indexof(value, "stretch") ? prefix(replace(value, "stretch", "fill-available"), length2) + value : value;
        }
      break;
    case 4949:
      if (charat(value, length2 + 1) !== 115)
        break;
    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, "!important") && 10))) {
        case 107:
          return replace(value, ":", ":" + WEBKIT) + value;
        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(value, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + value;
      }
      break;
    case 5936:
      switch (charat(value, length2 + 11)) {
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
      }
      return WEBKIT + value + MS + value + value;
  }
  return value;
}
var prefixer = function prefixer2(element, index2, children, callback) {
  if (element.length > -1) {
    if (!element["return"])
      switch (element.type) {
        case DECLARATION:
          element["return"] = prefix(element.value, element.length);
          break;
        case KEYFRAMES:
          return serialize([copy(element, {
            value: replace(element.value, "@", "@" + WEBKIT)
          })], callback);
        case RULESET:
          if (element.length)
            return combine(element.props, function(value) {
              switch (match(value, /(::plac\w+|:read-\w+)/)) {
                case ":read-only":
                case ":read-write":
                  return serialize([copy(element, {
                    props: [replace(value, /:(read-\w+)/, ":" + MOZ + "$1")]
                  })], callback);
                case "::placeholder":
                  return serialize([copy(element, {
                    props: [replace(value, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
                  }), copy(element, {
                    props: [replace(value, /:(plac\w+)/, ":" + MOZ + "$1")]
                  }), copy(element, {
                    props: [replace(value, /:(plac\w+)/, MS + "input-$1")]
                  })], callback);
              }
              return "";
            });
      }
  }
};
var defaultStylisPlugins = [prefixer];
var createCache = function createCache2(options) {
  var key = options.key;
  if (key === "css") {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(ssrStyles, function(node2) {
      var dataEmotionAttribute = node2.getAttribute("data-emotion");
      if (dataEmotionAttribute.indexOf(" ") === -1) {
        return;
      }
      document.head.appendChild(node2);
      node2.setAttribute("data-s", "");
    });
  }
  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
  var inserted = {};
  var container;
  var nodesToHydrate = [];
  {
    container = options.container || document.head;
    Array.prototype.forEach.call(document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node2) {
      var attrib = node2.getAttribute("data-emotion").split(" ");
      for (var i2 = 1; i2 < attrib.length; i2++) {
        inserted[attrib[i2]] = true;
      }
      nodesToHydrate.push(node2);
    });
  }
  var _insert;
  var omnipresentPlugins = [compat, removeLabel];
  {
    var currentSheet;
    var finalizingPlugins = [stringify, rulesheet(function(rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis2(styles2) {
      return serialize(compile(styles2), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;
      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }
  var cache = {
    key,
    sheet: new StyleSheet({
      key,
      container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};
var reactIs$1 = { exports: {} };
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e$1 = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n$1 = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r$1 = b ? Symbol.for("react.memo") : 60115, t$1 = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w$1 = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;
    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e$1:
          case g:
          case f:
          case p:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n$1:
              case t$1:
              case r$1:
              case h:
                return a;
              default:
                return u;
            }
        }
      case d:
        return u;
    }
  }
}
function A(a) {
  return z(a) === m;
}
reactIs_production_min.AsyncMode = l;
reactIs_production_min.ConcurrentMode = m;
reactIs_production_min.ContextConsumer = k;
reactIs_production_min.ContextProvider = h;
reactIs_production_min.Element = c;
reactIs_production_min.ForwardRef = n$1;
reactIs_production_min.Fragment = e$1;
reactIs_production_min.Lazy = t$1;
reactIs_production_min.Memo = r$1;
reactIs_production_min.Portal = d;
reactIs_production_min.Profiler = g;
reactIs_production_min.StrictMode = f;
reactIs_production_min.Suspense = p;
reactIs_production_min.isAsyncMode = function(a) {
  return A(a) || z(a) === l;
};
reactIs_production_min.isConcurrentMode = A;
reactIs_production_min.isContextConsumer = function(a) {
  return z(a) === k;
};
reactIs_production_min.isContextProvider = function(a) {
  return z(a) === h;
};
reactIs_production_min.isElement = function(a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};
reactIs_production_min.isForwardRef = function(a) {
  return z(a) === n$1;
};
reactIs_production_min.isFragment = function(a) {
  return z(a) === e$1;
};
reactIs_production_min.isLazy = function(a) {
  return z(a) === t$1;
};
reactIs_production_min.isMemo = function(a) {
  return z(a) === r$1;
};
reactIs_production_min.isPortal = function(a) {
  return z(a) === d;
};
reactIs_production_min.isProfiler = function(a) {
  return z(a) === g;
};
reactIs_production_min.isStrictMode = function(a) {
  return z(a) === f;
};
reactIs_production_min.isSuspense = function(a) {
  return z(a) === p;
};
reactIs_production_min.isValidElementType = function(a) {
  return "string" === typeof a || "function" === typeof a || a === e$1 || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t$1 || a.$$typeof === r$1 || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n$1 || a.$$typeof === w$1 || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
reactIs_production_min.typeOf = z;
{
  reactIs$1.exports = reactIs_production_min;
}
var reactIs = reactIs$1.exports;
var FORWARD_REF_STATICS = {
  "$$typeof": true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  "$$typeof": true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
var isBrowser = true;
function getRegisteredStyles(registered, registeredStyles, classNames2) {
  var rawClassName = "";
  classNames2.split(" ").forEach(function(className) {
    if (registered[className] !== void 0) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles2(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;
  if ((isStringTag === false || isBrowser === false) && cache.registered[className] === void 0) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles2(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;
  if (cache.inserted[serialized.name] === void 0) {
    var current = serialized;
    do {
      cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
      current = current.next;
    } while (current !== void 0);
  }
};
function murmur2(str) {
  var h2 = 0;
  var k2, i2 = 0, len = str.length;
  for (; len >= 4; ++i2, len -= 4) {
    k2 = str.charCodeAt(i2) & 255 | (str.charCodeAt(++i2) & 255) << 8 | (str.charCodeAt(++i2) & 255) << 16 | (str.charCodeAt(++i2) & 255) << 24;
    k2 = (k2 & 65535) * 1540483477 + ((k2 >>> 16) * 59797 << 16);
    k2 ^= k2 >>> 24;
    h2 = (k2 & 65535) * 1540483477 + ((k2 >>> 16) * 59797 << 16) ^ (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  }
  switch (len) {
    case 3:
      h2 ^= (str.charCodeAt(i2 + 2) & 255) << 16;
    case 2:
      h2 ^= (str.charCodeAt(i2 + 1) & 255) << 8;
    case 1:
      h2 ^= str.charCodeAt(i2) & 255;
      h2 = (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  }
  h2 ^= h2 >>> 13;
  h2 = (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  return ((h2 ^ h2 >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty2(property) {
  return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue2(value) {
  return value != null && typeof value !== "boolean";
};
var processStyleName = /* @__PURE__ */ memoize(function(styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue2(key, value) {
  switch (key) {
    case "animation":
    case "animationName": {
      if (typeof value === "string") {
        return value.replace(animationRegex, function(match2, p1, p2) {
          cursor = {
            name: p1,
            styles: p2,
            next: cursor
          };
          return p1;
        });
      }
    }
  }
  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === "number" && value !== 0) {
    return value + "px";
  }
  return value;
};
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return "";
  }
  if (interpolation.__emotion_styles !== void 0) {
    return interpolation;
  }
  switch (typeof interpolation) {
    case "boolean": {
      return "";
    }
    case "object": {
      if (interpolation.anim === 1) {
        cursor = {
          name: interpolation.name,
          styles: interpolation.styles,
          next: cursor
        };
        return interpolation.name;
      }
      if (interpolation.styles !== void 0) {
        var next2 = interpolation.next;
        if (next2 !== void 0) {
          while (next2 !== void 0) {
            cursor = {
              name: next2.name,
              styles: next2.styles,
              next: cursor
            };
            next2 = next2.next;
          }
        }
        var styles2 = interpolation.styles + ";";
        return styles2;
      }
      return createStringFromObject(mergedProps, registered, interpolation);
    }
    case "function": {
      if (mergedProps !== void 0) {
        var previousCursor = cursor;
        var result = interpolation(mergedProps);
        cursor = previousCursor;
        return handleInterpolation(mergedProps, registered, result);
      }
      break;
    }
  }
  if (registered == null) {
    return interpolation;
  }
  var cached = registered[interpolation];
  return cached !== void 0 ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string = "";
  if (Array.isArray(obj)) {
    for (var i2 = 0; i2 < obj.length; i2++) {
      string += handleInterpolation(mergedProps, registered, obj[i2]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];
      if (typeof value !== "object") {
        if (registered != null && registered[value] !== void 0) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === "NO_COMPONENT_SELECTOR" && false) {
          throw new Error(noComponentSelectorMessage);
        }
        if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === void 0)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);
          switch (_key) {
            case "animation":
            case "animationName": {
              string += processStyleName(_key) + ":" + interpolated + ";";
              break;
            }
            default: {
              string += _key + "{" + interpolated + "}";
            }
          }
        }
      }
    }
  }
  return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var cursor;
var serializeStyles = function serializeStyles2(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== void 0) {
    return args[0];
  }
  var stringMode = true;
  var styles2 = "";
  cursor = void 0;
  var strings = args[0];
  if (strings == null || strings.raw === void 0) {
    stringMode = false;
    styles2 += handleInterpolation(mergedProps, registered, strings);
  } else {
    styles2 += strings[0];
  }
  for (var i2 = 1; i2 < args.length; i2++) {
    styles2 += handleInterpolation(mergedProps, registered, args[i2]);
    if (stringMode) {
      styles2 += strings[i2];
    }
  }
  labelPattern.lastIndex = 0;
  var identifierName = "";
  var match2;
  while ((match2 = labelPattern.exec(styles2)) !== null) {
    identifierName += "-" + match2[1];
  }
  var name = murmur2(styles2) + identifierName;
  return {
    name,
    styles: styles2,
    next: cursor
  };
};
var syncFallback = function syncFallback2(create) {
  return create();
};
var useInsertionEffect = React$1["useInsertionEffect"] ? React$1["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var hasOwnProperty$1 = {}.hasOwnProperty;
var EmotionCacheContext = /* @__PURE__ */ createContext(typeof HTMLElement !== "undefined" ? /* @__PURE__ */ createCache({
  key: "css"
}) : null);
EmotionCacheContext.Provider;
var withEmotionCache = function withEmotionCache2(func) {
  return /* @__PURE__ */ forwardRef(function(props, ref) {
    var cache = useContext(EmotionCacheContext);
    return func(props, cache, ref);
  });
};
var ThemeContext = /* @__PURE__ */ createContext({});
var typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var createEmotionProps = function createEmotionProps2(type, props) {
  var newProps = {};
  for (var key in props) {
    if (hasOwnProperty$1.call(props, key)) {
      newProps[key] = props[key];
    }
  }
  newProps[typePropName] = type;
  return newProps;
};
var Insertion = function Insertion2(_ref3) {
  var cache = _ref3.cache, serialized = _ref3.serialized, isStringTag = _ref3.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(cache, serialized, isStringTag);
  });
  return null;
};
var Emotion = /* @__PURE__ */ withEmotionCache(function(props, cache, ref) {
  var cssProp = props.css;
  if (typeof cssProp === "string" && cache.registered[cssProp] !== void 0) {
    cssProp = cache.registered[cssProp];
  }
  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = "";
  if (typeof props.className === "string") {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }
  var serialized = serializeStyles(registeredStyles, void 0, useContext(ThemeContext));
  className += cache.key + "-" + serialized.name;
  var newProps = {};
  for (var key in props) {
    if (hasOwnProperty$1.call(props, key) && key !== "css" && key !== typePropName && true) {
      newProps[key] = props[key];
    }
  }
  newProps.ref = ref;
  newProps.className = className;
  return /* @__PURE__ */ createElement(Fragment$1, null, /* @__PURE__ */ createElement(Insertion, {
    cache,
    serialized,
    isStringTag: typeof WrappedComponent === "string"
  }), /* @__PURE__ */ createElement(WrappedComponent, newProps));
});
var jsx = function jsx2(type, props) {
  var args = arguments;
  if (props == null || !hasOwnProperty$1.call(props, "css")) {
    return createElement.apply(void 0, args);
  }
  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);
  for (var i2 = 2; i2 < argsLength; i2++) {
    createElementArgArray[i2] = args[i2];
  }
  return createElement.apply(null, createElementArgArray);
};
function css$2() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return serializeStyles(args);
}
var keyframes = function keyframes2() {
  var insertable = css$2.apply(void 0, arguments);
  var name = "animation-" + insertable.name;
  return {
    name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function getWindow(node2) {
  var _node$ownerDocument;
  return ((_node$ownerDocument = node2.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeName(node2) {
  return isNode(node2) ? (node2.nodeName || "").toLowerCase() : "";
}
let uaString;
function getUAString() {
  if (uaString) {
    return uaString;
  }
  const uaData = navigator.userAgentData;
  if (uaData && Array.isArray(uaData.brands)) {
    uaString = uaData.brands.map((item2) => item2.brand + "/" + item2.version).join(" ");
    return uaString;
  }
  return navigator.userAgent;
}
function isHTMLElement(value) {
  return value instanceof getWindow(value).HTMLElement;
}
function isElement(value) {
  return value instanceof getWindow(value).Element;
}
function isNode(value) {
  return value instanceof getWindow(value).Node;
}
function isShadowRoot(node2) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  const OwnElement = getWindow(node2).ShadowRoot;
  return node2 instanceof OwnElement || node2 instanceof ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$1(element);
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX) && !["inline", "contents"].includes(display);
}
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
function isLastTraversableNode(node2) {
  return ["html", "body", "#document"].includes(getNodeName(node2));
}
const FALLBACK_SCALE = {
  x: 1,
  y: 1
};
function getScale(element) {
  const domElement = !isElement(element) && element.contextElement ? element.contextElement : isElement(element) ? element : null;
  if (!domElement) {
    return FALLBACK_SCALE;
  }
  const rect = domElement.getBoundingClientRect();
  const css4 = getComputedStyle$1(domElement);
  let x2 = rect.width / parseFloat(css4.width);
  let y2 = rect.height / parseFloat(css4.height);
  if (!x2 || !Number.isFinite(x2)) {
    x2 = 1;
  }
  if (!y2 || !Number.isFinite(y2)) {
    y2 = 1;
  }
  return {
    x: x2,
    y: y2
  };
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  var _win$visualViewport$o, _win$visualViewport, _win$visualViewport$o2, _win$visualViewport2;
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  let scale = FALLBACK_SCALE;
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const win = isElement(element) ? getWindow(element) : window;
  const addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  const x2 = (clientRect.left + (addVisualOffsets ? (_win$visualViewport$o = (_win$visualViewport = win.visualViewport) == null ? void 0 : _win$visualViewport.offsetLeft) != null ? _win$visualViewport$o : 0 : 0)) / scale.x;
  const y2 = (clientRect.top + (addVisualOffsets ? (_win$visualViewport$o2 = (_win$visualViewport2 = win.visualViewport) == null ? void 0 : _win$visualViewport2.offsetTop) != null ? _win$visualViewport$o2 : 0 : 0)) / scale.y;
  const width = clientRect.width / scale.x;
  const height = clientRect.height / scale.y;
  return {
    width,
    height,
    top: y2,
    right: x2 + width,
    bottom: y2 + height,
    left: x2,
    x: x2,
    y: y2
  };
}
function getDocumentElement(node2) {
  return ((isNode(node2) ? node2.ownerDocument : node2.document) || window.document).documentElement;
}
function getParentNode(node2) {
  if (getNodeName(node2) === "html") {
    return node2;
  }
  const result = node2.assignedSlot || node2.parentNode || (isShadowRoot(node2) ? node2.host : null) || getDocumentElement(node2);
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node2) {
  const parentNode = getParentNode(node2);
  if (isLastTraversableNode(parentNode)) {
    return node2.ownerDocument.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node2, list) {
  var _node$ownerDocument;
  if (list === void 0) {
    list = [];
  }
  const scrollableAncestor = getNearestOverflowAncestor(node2);
  const isBody = scrollableAncestor === ((_node$ownerDocument = node2.ownerDocument) == null ? void 0 : _node$ownerDocument.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor));
}
function autoUpdate(reference2, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll: _ancestorScroll = true,
    ancestorResize = true,
    elementResize = true,
    animationFrame = false
  } = options;
  const ancestorScroll = _ancestorScroll && !animationFrame;
  const ancestors = ancestorScroll || ancestorResize ? [...isElement(reference2) ? getOverflowAncestors(reference2) : reference2.contextElement ? getOverflowAncestors(reference2.contextElement) : [], ...getOverflowAncestors(floating)] : [];
  ancestors.forEach((ancestor) => {
    ancestorScroll && ancestor.addEventListener("scroll", update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener("resize", update);
  });
  let observer = null;
  if (elementResize) {
    let initialUpdate = true;
    observer = new ResizeObserver(() => {
      if (!initialUpdate) {
        update();
      }
      initialUpdate = false;
    });
    isElement(reference2) && !animationFrame && observer.observe(reference2);
    if (!isElement(reference2) && reference2.contextElement && !animationFrame) {
      observer.observe(reference2.contextElement);
    }
    observer.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference2) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference2);
    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _observer;
    ancestors.forEach((ancestor) => {
      ancestorScroll && ancestor.removeEventListener("scroll", update);
      ancestorResize && ancestor.removeEventListener("resize", update);
    });
    (_observer = observer) == null ? void 0 : _observer.disconnect();
    observer = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
var index = useLayoutEffect;
var _excluded$3$1 = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"];
var noop$2 = function noop() {
};
function applyPrefixToName(prefix2, name) {
  if (!name) {
    return prefix2;
  } else if (name[0] === "-") {
    return prefix2 + name;
  } else {
    return prefix2 + "__" + name;
  }
}
function classNames(prefix2, state) {
  for (var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    classNameList[_key - 2] = arguments[_key];
  }
  var arr = [].concat(classNameList);
  if (state && prefix2) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix2, key)));
      }
    }
  }
  return arr.filter(function(i2) {
    return i2;
  }).map(function(i2) {
    return String(i2).trim();
  }).join(" ");
}
var cleanValue = function cleanValue2(value) {
  if (isArray(value))
    return value.filter(Boolean);
  if (_typeof$1(value) === "object" && value !== null)
    return [value];
  return [];
};
var cleanCommonProps = function cleanCommonProps2(props) {
  props.className;
  props.clearValue;
  props.cx;
  props.getStyles;
  props.getClassNames;
  props.getValue;
  props.hasValue;
  props.isMulti;
  props.isRtl;
  props.options;
  props.selectOption;
  props.selectProps;
  props.setValue;
  props.theme;
  var innerProps = _objectWithoutProperties$2(props, _excluded$3$1);
  return _objectSpread2({}, innerProps);
};
var getStyleProps = function getStyleProps2(props, name, classNamesState) {
  var cx2 = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
  return {
    css: getStyles(name, props),
    className: cx2(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
  };
};
function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
}
function normalizedHeight(el) {
  if (isDocumentElement(el)) {
    return window.innerHeight;
  }
  return el.clientHeight;
}
function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }
  return el.scrollTop;
}
function scrollTo(el, top2) {
  if (isDocumentElement(el)) {
    window.scrollTo(0, top2);
    return;
  }
  el.scrollTop = top2;
}
function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === "absolute";
  var overflowRx = /(auto|scroll)/;
  if (style.position === "fixed")
    return document.documentElement;
  for (var parent = element; parent = parent.parentElement; ) {
    style = getComputedStyle(parent);
    if (excludeStaticParent && style.position === "static") {
      continue;
    }
    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }
  return document.documentElement;
}
function easeOutCubic(t2, b2, c2, d2) {
  return c2 * ((t2 = t2 / d2 - 1) * t2 * t2 + 1) + b2;
}
function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : noop$2;
  var start2 = getScrollTop(element);
  var change = to - start2;
  var increment = 10;
  var currentTime = 0;
  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start2, change, duration);
    scrollTo(element, val);
    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback(element);
    }
  }
  animateScroll();
}
function scrollIntoView$1(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;
  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
}
function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}
function isTouchCapable() {
  try {
    document.createEvent("TouchEvent");
    return true;
  } catch (e2) {
    return false;
  }
}
function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e2) {
    return false;
  }
}
var passiveOptionAccessed = false;
var options$1 = {
  get passive() {
    return passiveOptionAccessed = true;
  }
};
var w = typeof window !== "undefined" ? window : {};
if (w.addEventListener && w.removeEventListener) {
  w.addEventListener("p", noop$2, options$1);
  w.removeEventListener("p", noop$2, false);
}
var supportsPassiveEvents = passiveOptionAccessed;
function notNullish(item2) {
  return item2 != null;
}
function isArray(arg) {
  return Array.isArray(arg);
}
function valueTernary(isMulti, multiValue, singleValue) {
  return isMulti ? multiValue : singleValue;
}
function singleValueAsValue(singleValue) {
  return singleValue;
}
function multiValueAsValue(multiValue) {
  return multiValue;
}
var removeProps = function removeProps2(propsObj) {
  for (var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    properties[_key2 - 1] = arguments[_key2];
  }
  var propsMap = Object.entries(propsObj).filter(function(_ref3) {
    var _ref22 = _slicedToArray$1(_ref3, 1), key = _ref22[0];
    return !properties.includes(key);
  });
  return propsMap.reduce(function(newProps, _ref3) {
    var _ref4 = _slicedToArray$1(_ref3, 2), key = _ref4[0], val = _ref4[1];
    newProps[key] = val;
    return newProps;
  }, {});
};
function getMenuPlacement(_ref3) {
  var preferredMaxHeight = _ref3.maxHeight, menuEl = _ref3.menuEl, minHeight = _ref3.minHeight, preferredPlacement = _ref3.placement, shouldScroll = _ref3.shouldScroll, isFixedPosition = _ref3.isFixedPosition, controlHeight2 = _ref3.controlHeight;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: "bottom",
    maxHeight: preferredMaxHeight
  };
  if (!menuEl || !menuEl.offsetParent)
    return defaultState;
  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
  var viewHeight = isFixedPosition ? window.innerHeight : normalizedHeight(scrollParent);
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;
  switch (preferredPlacement) {
    case "auto":
    case "bottom":
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: "bottom",
          maxHeight: preferredMaxHeight
        };
      }
      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }
        return {
          placement: "bottom",
          maxHeight: preferredMaxHeight
        };
      }
      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }
        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: "bottom",
          maxHeight: constrainedHeight
        };
      }
      if (preferredPlacement === "auto" || isFixedPosition) {
        var _constrainedHeight = preferredMaxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight2, preferredMaxHeight);
        }
        return {
          placement: "top",
          maxHeight: _constrainedHeight
        };
      }
      if (preferredPlacement === "bottom") {
        if (shouldScroll) {
          scrollTo(scrollParent, scrollDown);
        }
        return {
          placement: "bottom",
          maxHeight: preferredMaxHeight
        };
      }
      break;
    case "top":
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: "top",
          maxHeight: preferredMaxHeight
        };
      }
      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: "top",
          maxHeight: preferredMaxHeight
        };
      }
      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = preferredMaxHeight;
        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }
        return {
          placement: "top",
          maxHeight: _constrainedHeight2
        };
      }
      return {
        placement: "bottom",
        maxHeight: preferredMaxHeight
      };
    default:
      throw new Error('Invalid placement provided "'.concat(preferredPlacement, '".'));
  }
  return defaultState;
}
function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: "top",
    top: "bottom"
  };
  return placement ? placementToCSSProp[placement] : "bottom";
}
var coercePlacement = function coercePlacement2(p2) {
  return p2 === "auto" ? "bottom" : p2;
};
var menuCSS = function menuCSS2(_ref22, unstyled) {
  var _objectSpread2$12;
  var placement = _ref22.placement, _ref2$theme = _ref22.theme, borderRadius2 = _ref2$theme.borderRadius, spacing2 = _ref2$theme.spacing, colors2 = _ref2$theme.colors;
  return _objectSpread2((_objectSpread2$12 = {
    label: "menu"
  }, _defineProperty$1(_objectSpread2$12, alignToControl(placement), "100%"), _defineProperty$1(_objectSpread2$12, "position", "absolute"), _defineProperty$1(_objectSpread2$12, "width", "100%"), _defineProperty$1(_objectSpread2$12, "zIndex", 1), _objectSpread2$12), unstyled ? {} : {
    backgroundColor: colors2.neutral0,
    borderRadius: borderRadius2,
    boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    marginBottom: spacing2.menuGutter,
    marginTop: spacing2.menuGutter
  });
};
var PortalPlacementContext = /* @__PURE__ */ createContext(null);
var MenuPlacer = function MenuPlacer2(props) {
  var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
  var _ref3 = useContext(PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
  var ref = useRef(null);
  var _useState = useState(maxMenuHeight), _useState2 = _slicedToArray$1(_useState, 2), maxHeight = _useState2[0], setMaxHeight2 = _useState2[1];
  var _useState3 = useState(null), _useState4 = _slicedToArray$1(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
  var controlHeight2 = theme.spacing.controlHeight;
  index(function() {
    var menuEl = ref.current;
    if (!menuEl)
      return;
    var isFixedPosition = menuPosition === "fixed";
    var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
    var state = getMenuPlacement({
      maxHeight: maxMenuHeight,
      menuEl,
      minHeight: minMenuHeight,
      placement: menuPlacement,
      shouldScroll,
      isFixedPosition,
      controlHeight: controlHeight2
    });
    setMaxHeight2(state.maxHeight);
    setPlacement(state.placement);
    setPortalPlacement === null || setPortalPlacement === void 0 ? void 0 : setPortalPlacement(state.placement);
  }, [maxMenuHeight, menuPlacement, menuPosition, menuShouldScrollIntoView, minMenuHeight, setPortalPlacement, controlHeight2]);
  return children({
    ref,
    placerProps: _objectSpread2(_objectSpread2({}, props), {}, {
      placement: placement || coercePlacement(menuPlacement),
      maxHeight
    })
  });
};
var Menu$2 = function Menu(props) {
  var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
  return jsx("div", _extends$1({}, getStyleProps(props, "menu", {
    menu: true
  }), {
    ref: innerRef
  }, innerProps), children);
};
var menuListCSS = function menuListCSS2(_ref4, unstyled) {
  var maxHeight = _ref4.maxHeight, baseUnit2 = _ref4.theme.spacing.baseUnit;
  return _objectSpread2({
    maxHeight,
    overflowY: "auto",
    position: "relative",
    WebkitOverflowScrolling: "touch"
  }, unstyled ? {} : {
    paddingBottom: baseUnit2,
    paddingTop: baseUnit2
  });
};
var MenuList = function MenuList2(props) {
  var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
  return jsx("div", _extends$1({}, getStyleProps(props, "menuList", {
    "menu-list": true,
    "menu-list--is-multi": isMulti
  }), {
    ref: innerRef
  }, innerProps), children);
};
var noticeCSS = function noticeCSS2(_ref5, unstyled) {
  var _ref5$theme = _ref5.theme, baseUnit2 = _ref5$theme.spacing.baseUnit, colors2 = _ref5$theme.colors;
  return _objectSpread2({
    textAlign: "center"
  }, unstyled ? {} : {
    color: colors2.neutral40,
    padding: "".concat(baseUnit2 * 2, "px ").concat(baseUnit2 * 3, "px")
  });
};
var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage2(props) {
  var children = props.children, innerProps = props.innerProps;
  return jsx("div", _extends$1({}, getStyleProps(props, "noOptionsMessage", {
    "menu-notice": true,
    "menu-notice--no-options": true
  }), innerProps), children);
};
NoOptionsMessage.defaultProps = {
  children: "No options"
};
var LoadingMessage = function LoadingMessage2(props) {
  var children = props.children, innerProps = props.innerProps;
  return jsx("div", _extends$1({}, getStyleProps(props, "loadingMessage", {
    "menu-notice": true,
    "menu-notice--loading": true
  }), innerProps), children);
};
LoadingMessage.defaultProps = {
  children: "Loading..."
};
var menuPortalCSS = function menuPortalCSS2(_ref6) {
  var rect = _ref6.rect, offset2 = _ref6.offset, position2 = _ref6.position;
  return {
    left: rect.left,
    position: position2,
    top: offset2,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal = function MenuPortal2(props) {
  var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
  var menuPortalRef = useRef(null);
  var cleanupRef = useRef(null);
  var _useState5 = useState(coercePlacement(menuPlacement)), _useState6 = _slicedToArray$1(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
  var portalPlacementContext = useMemo(function() {
    return {
      setPortalPlacement
    };
  }, []);
  var _useState7 = useState(null), _useState8 = _slicedToArray$1(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
  var updateComputedPosition = useCallback(function() {
    if (!controlElement)
      return;
    var rect = getBoundingClientObj(controlElement);
    var scrollDistance = menuPosition === "fixed" ? 0 : window.pageYOffset;
    var offset2 = rect[placement] + scrollDistance;
    if (offset2 !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) {
      setComputedPosition({
        offset: offset2,
        rect
      });
    }
  }, [controlElement, menuPosition, placement, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left, computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width]);
  index(function() {
    updateComputedPosition();
  }, [updateComputedPosition]);
  var runAutoUpdate = useCallback(function() {
    if (typeof cleanupRef.current === "function") {
      cleanupRef.current();
      cleanupRef.current = null;
    }
    if (controlElement && menuPortalRef.current) {
      cleanupRef.current = autoUpdate(controlElement, menuPortalRef.current, updateComputedPosition, {
        elementResize: "ResizeObserver" in window
      });
    }
  }, [controlElement, updateComputedPosition]);
  index(function() {
    runAutoUpdate();
  }, [runAutoUpdate]);
  var setMenuPortalElement = useCallback(function(menuPortalElement) {
    menuPortalRef.current = menuPortalElement;
    runAutoUpdate();
  }, [runAutoUpdate]);
  if (!appendTo && menuPosition !== "fixed" || !computedPosition)
    return null;
  var menuWrapper = jsx("div", _extends$1({
    ref: setMenuPortalElement
  }, getStyleProps(_objectSpread2(_objectSpread2({}, props), {}, {
    offset: computedPosition.offset,
    position: menuPosition,
    rect: computedPosition.rect
  }), "menuPortal", {
    "menu-portal": true
  }), innerProps), children);
  return jsx(PortalPlacementContext.Provider, {
    value: portalPlacementContext
  }, appendTo ? /* @__PURE__ */ createPortal(menuWrapper, appendTo) : menuWrapper);
};
var containerCSS = function containerCSS2(_ref3) {
  var isDisabled = _ref3.isDisabled, isRtl = _ref3.isRtl;
  return {
    label: "container",
    direction: isRtl ? "rtl" : void 0,
    pointerEvents: isDisabled ? "none" : void 0,
    position: "relative"
  };
};
var SelectContainer = function SelectContainer2(props) {
  var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
  return jsx("div", _extends$1({}, getStyleProps(props, "container", {
    "--is-disabled": isDisabled,
    "--is-rtl": isRtl
  }), innerProps), children);
};
var valueContainerCSS = function valueContainerCSS2(_ref22, unstyled) {
  var spacing2 = _ref22.theme.spacing, isMulti = _ref22.isMulti, hasValue = _ref22.hasValue, controlShouldRenderValue = _ref22.selectProps.controlShouldRenderValue;
  return _objectSpread2({
    alignItems: "center",
    display: isMulti && hasValue && controlShouldRenderValue ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  }, unstyled ? {} : {
    padding: "".concat(spacing2.baseUnit / 2, "px ").concat(spacing2.baseUnit * 2, "px")
  });
};
var ValueContainer = function ValueContainer2(props) {
  var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
  return jsx("div", _extends$1({}, getStyleProps(props, "valueContainer", {
    "value-container": true,
    "value-container--is-multi": isMulti,
    "value-container--has-value": hasValue
  }), innerProps), children);
};
var indicatorsContainerCSS = function indicatorsContainerCSS2() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer2(props) {
  var children = props.children, innerProps = props.innerProps;
  return jsx("div", _extends$1({}, getStyleProps(props, "indicatorsContainer", {
    indicators: true
  }), innerProps), children);
};
var _templateObject;
var _excluded$2$1 = ["size"];
var _ref2$2 = {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var Svg = function Svg2(_ref3) {
  var size = _ref3.size, props = _objectWithoutProperties$2(_ref3, _excluded$2$1);
  return jsx("svg", _extends$1({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2$2
  }, props));
};
var CrossIcon = function CrossIcon2(props) {
  return jsx(Svg, _extends$1({
    size: 20
  }, props), jsx("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron2(props) {
  return jsx(Svg, _extends$1({
    size: 20
  }, props), jsx("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
};
var baseCSS = function baseCSS2(_ref3, unstyled) {
  var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit2 = _ref3$theme.spacing.baseUnit, colors2 = _ref3$theme.colors;
  return _objectSpread2({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, unstyled ? {} : {
    color: isFocused ? colors2.neutral60 : colors2.neutral20,
    padding: baseUnit2 * 2,
    ":hover": {
      color: isFocused ? colors2.neutral80 : colors2.neutral40
    }
  });
};
var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator2(props) {
  var children = props.children, innerProps = props.innerProps;
  return jsx("div", _extends$1({}, getStyleProps(props, "dropdownIndicator", {
    indicator: true,
    "dropdown-indicator": true
  }), innerProps), children || jsx(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator2(props) {
  var children = props.children, innerProps = props.innerProps;
  return jsx("div", _extends$1({}, getStyleProps(props, "clearIndicator", {
    indicator: true,
    "clear-indicator": true
  }), innerProps), children || jsx(CrossIcon, null));
};
var indicatorSeparatorCSS = function indicatorSeparatorCSS2(_ref4, unstyled) {
  var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit2 = _ref4$theme.spacing.baseUnit, colors2 = _ref4$theme.colors;
  return _objectSpread2({
    label: "indicatorSeparator",
    alignSelf: "stretch",
    width: 1
  }, unstyled ? {} : {
    backgroundColor: isDisabled ? colors2.neutral10 : colors2.neutral20,
    marginBottom: baseUnit2 * 2,
    marginTop: baseUnit2 * 2
  });
};
var IndicatorSeparator = function IndicatorSeparator2(props) {
  var innerProps = props.innerProps;
  return jsx("span", _extends$1({}, innerProps, getStyleProps(props, "indicatorSeparator", {
    "indicator-separator": true
  })));
};
var loadingDotAnimations = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"])));
var loadingIndicatorCSS = function loadingIndicatorCSS2(_ref5, unstyled) {
  var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors2 = _ref5$theme.colors, baseUnit2 = _ref5$theme.spacing.baseUnit;
  return _objectSpread2({
    label: "loadingIndicator",
    display: "flex",
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: "center",
    verticalAlign: "middle"
  }, unstyled ? {} : {
    color: isFocused ? colors2.neutral60 : colors2.neutral20,
    padding: baseUnit2 * 2
  });
};
var LoadingDot = function LoadingDot2(_ref6) {
  var delay3 = _ref6.delay, offset2 = _ref6.offset;
  return jsx("span", {
    css: /* @__PURE__ */ css$2({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay3, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: offset2 ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, "", "")
  });
};
var LoadingIndicator = function LoadingIndicator2(props) {
  var innerProps = props.innerProps, isRtl = props.isRtl;
  return jsx("div", _extends$1({}, getStyleProps(props, "loadingIndicator", {
    indicator: true,
    "loading-indicator": true
  }), innerProps), jsx(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), jsx(LoadingDot, {
    delay: 160,
    offset: true
  }), jsx(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};
LoadingIndicator.defaultProps = {
  size: 4
};
var css$1 = function css(_ref3, unstyled) {
  var isDisabled = _ref3.isDisabled, isFocused = _ref3.isFocused, _ref$theme = _ref3.theme, colors2 = _ref$theme.colors, borderRadius2 = _ref$theme.borderRadius, spacing2 = _ref$theme.spacing;
  return _objectSpread2({
    label: "control",
    alignItems: "center",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: spacing2.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms"
  }, unstyled ? {} : {
    backgroundColor: isDisabled ? colors2.neutral5 : colors2.neutral0,
    borderColor: isDisabled ? colors2.neutral10 : isFocused ? colors2.primary : colors2.neutral20,
    borderRadius: borderRadius2,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors2.primary) : void 0,
    "&:hover": {
      borderColor: isFocused ? colors2.primary : colors2.neutral30
    }
  });
};
var Control = function Control2(props) {
  var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
  return jsx("div", _extends$1({
    ref: innerRef
  }, getStyleProps(props, "control", {
    control: true,
    "control--is-disabled": isDisabled,
    "control--is-focused": isFocused,
    "control--menu-is-open": menuIsOpen
  }), innerProps), children);
};
var _excluded$1$1 = ["data"];
var groupCSS = function groupCSS2(_ref3, unstyled) {
  var spacing2 = _ref3.theme.spacing;
  return unstyled ? {} : {
    paddingBottom: spacing2.baseUnit * 2,
    paddingTop: spacing2.baseUnit * 2
  };
};
var Group = function Group2(props) {
  var children = props.children, cx2 = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading2 = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
  return jsx("div", _extends$1({}, getStyleProps(props, "group", {
    group: true
  }), innerProps), jsx(Heading2, _extends$1({}, headingProps, {
    selectProps,
    theme,
    getStyles,
    getClassNames,
    cx: cx2
  }), label), jsx("div", null, children));
};
var groupHeadingCSS = function groupHeadingCSS2(_ref22, unstyled) {
  var _ref2$theme = _ref22.theme, colors2 = _ref2$theme.colors, spacing2 = _ref2$theme.spacing;
  return _objectSpread2({
    label: "group",
    cursor: "default",
    display: "block"
  }, unstyled ? {} : {
    color: colors2.neutral40,
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: spacing2.baseUnit * 3,
    paddingRight: spacing2.baseUnit * 3,
    textTransform: "uppercase"
  });
};
var GroupHeading = function GroupHeading2(props) {
  var _cleanCommonProps = cleanCommonProps(props);
  _cleanCommonProps.data;
  var innerProps = _objectWithoutProperties$2(_cleanCommonProps, _excluded$1$1);
  return jsx("div", _extends$1({}, getStyleProps(props, "groupHeading", {
    "group-heading": true
  }), innerProps));
};
var _excluded$h = ["innerRef", "isDisabled", "isHidden", "inputClassName"];
var inputCSS = function inputCSS2(_ref3, unstyled) {
  var isDisabled = _ref3.isDisabled, value = _ref3.value, _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return _objectSpread2(_objectSpread2({
    visibility: isDisabled ? "hidden" : "visible",
    transform: value ? "translateZ(0)" : ""
  }, containerStyle), unstyled ? {} : {
    margin: spacing2.baseUnit / 2,
    paddingBottom: spacing2.baseUnit / 2,
    paddingTop: spacing2.baseUnit / 2,
    color: colors2.neutral80
  });
};
var spacingStyle = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
};
var containerStyle = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": _objectSpread2({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, spacingStyle)
};
var inputStyle = function inputStyle2(isHidden3) {
  return _objectSpread2({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: isHidden3 ? 0 : 1,
    width: "100%"
  }, spacingStyle);
};
var Input$1 = function Input(props) {
  var cx2 = props.cx, value = props.value;
  var _cleanCommonProps = cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden3 = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = _objectWithoutProperties$2(_cleanCommonProps, _excluded$h);
  return jsx("div", _extends$1({}, getStyleProps(props, "input", {
    "input-container": true
  }), {
    "data-value": value || ""
  }), jsx("input", _extends$1({
    className: cx2({
      input: true
    }, inputClassName),
    ref: innerRef,
    style: inputStyle(isHidden3),
    disabled: isDisabled
  }, innerProps)));
};
var multiValueCSS = function multiValueCSS2(_ref3, unstyled) {
  var _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, borderRadius2 = _ref$theme.borderRadius, colors2 = _ref$theme.colors;
  return _objectSpread2({
    label: "multiValue",
    display: "flex",
    minWidth: 0
  }, unstyled ? {} : {
    backgroundColor: colors2.neutral10,
    borderRadius: borderRadius2 / 2,
    margin: spacing2.baseUnit / 2
  });
};
var multiValueLabelCSS = function multiValueLabelCSS2(_ref22, unstyled) {
  var _ref2$theme = _ref22.theme, borderRadius2 = _ref2$theme.borderRadius, colors2 = _ref2$theme.colors, cropWithEllipsis = _ref22.cropWithEllipsis;
  return _objectSpread2({
    overflow: "hidden",
    textOverflow: cropWithEllipsis || cropWithEllipsis === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  }, unstyled ? {} : {
    borderRadius: borderRadius2 / 2,
    color: colors2.neutral80,
    fontSize: "85%",
    padding: 3,
    paddingLeft: 6
  });
};
var multiValueRemoveCSS = function multiValueRemoveCSS2(_ref3, unstyled) {
  var _ref3$theme = _ref3.theme, spacing2 = _ref3$theme.spacing, borderRadius2 = _ref3$theme.borderRadius, colors2 = _ref3$theme.colors, isFocused = _ref3.isFocused;
  return _objectSpread2({
    alignItems: "center",
    display: "flex"
  }, unstyled ? {} : {
    borderRadius: borderRadius2 / 2,
    backgroundColor: isFocused ? colors2.dangerLight : void 0,
    paddingLeft: spacing2.baseUnit,
    paddingRight: spacing2.baseUnit,
    ":hover": {
      backgroundColor: colors2.dangerLight,
      color: colors2.danger
    }
  });
};
var MultiValueGeneric = function MultiValueGeneric2(_ref4) {
  var children = _ref4.children, innerProps = _ref4.innerProps;
  return jsx("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
  var children = _ref5.children, innerProps = _ref5.innerProps;
  return jsx("div", _extends$1({
    role: "button"
  }, innerProps), children || jsx(CrossIcon, {
    size: 14
  }));
}
var MultiValue = function MultiValue2(props) {
  var children = props.children, components2 = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps3 = props.removeProps, selectProps = props.selectProps;
  var Container2 = components2.Container, Label2 = components2.Label, Remove = components2.Remove;
  return jsx(Container2, {
    data,
    innerProps: _objectSpread2(_objectSpread2({}, getStyleProps(props, "multiValue", {
      "multi-value": true,
      "multi-value--is-disabled": isDisabled
    })), innerProps),
    selectProps
  }, jsx(Label2, {
    data,
    innerProps: _objectSpread2({}, getStyleProps(props, "multiValueLabel", {
      "multi-value__label": true
    })),
    selectProps
  }, children), jsx(Remove, {
    data,
    innerProps: _objectSpread2(_objectSpread2({}, getStyleProps(props, "multiValueRemove", {
      "multi-value__remove": true
    })), {}, {
      "aria-label": "Remove ".concat(children || "option")
    }, removeProps3),
    selectProps
  }));
};
var optionCSS = function optionCSS2(_ref3, unstyled) {
  var isDisabled = _ref3.isDisabled, isFocused = _ref3.isFocused, isSelected = _ref3.isSelected, _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return _objectSpread2({
    label: "option",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  }, unstyled ? {} : {
    backgroundColor: isSelected ? colors2.primary : isFocused ? colors2.primary25 : "transparent",
    color: isDisabled ? colors2.neutral20 : isSelected ? colors2.neutral0 : "inherit",
    padding: "".concat(spacing2.baseUnit * 2, "px ").concat(spacing2.baseUnit * 3, "px"),
    ":active": {
      backgroundColor: !isDisabled ? isSelected ? colors2.primary : colors2.primary50 : void 0
    }
  });
};
var Option = function Option2(props) {
  var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
  return jsx("div", _extends$1({}, getStyleProps(props, "option", {
    option: true,
    "option--is-disabled": isDisabled,
    "option--is-focused": isFocused,
    "option--is-selected": isSelected
  }), {
    ref: innerRef,
    "aria-disabled": isDisabled
  }, innerProps), children);
};
var placeholderCSS = function placeholderCSS2(_ref3, unstyled) {
  var _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return _objectSpread2({
    label: "placeholder",
    gridArea: "1 / 1 / 2 / 3"
  }, unstyled ? {} : {
    color: colors2.neutral50,
    marginLeft: spacing2.baseUnit / 2,
    marginRight: spacing2.baseUnit / 2
  });
};
var Placeholder = function Placeholder2(props) {
  var children = props.children, innerProps = props.innerProps;
  return jsx("div", _extends$1({}, getStyleProps(props, "placeholder", {
    placeholder: true
  }), innerProps), children);
};
var css2 = function css3(_ref3, unstyled) {
  var isDisabled = _ref3.isDisabled, _ref$theme = _ref3.theme, spacing2 = _ref$theme.spacing, colors2 = _ref$theme.colors;
  return _objectSpread2({
    label: "singleValue",
    gridArea: "1 / 1 / 2 / 3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, unstyled ? {} : {
    color: isDisabled ? colors2.neutral40 : colors2.neutral80,
    marginLeft: spacing2.baseUnit / 2,
    marginRight: spacing2.baseUnit / 2
  });
};
var SingleValue = function SingleValue2(props) {
  var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
  return jsx("div", _extends$1({}, getStyleProps(props, "singleValue", {
    "single-value": true,
    "single-value--is-disabled": isDisabled
  }), innerProps), children);
};
var components = {
  ClearIndicator,
  Control,
  DropdownIndicator,
  DownChevron,
  CrossIcon,
  Group,
  GroupHeading,
  IndicatorsContainer,
  IndicatorSeparator,
  Input: Input$1,
  LoadingIndicator,
  Menu: Menu$2,
  MenuList,
  MenuPortal,
  LoadingMessage,
  NoOptionsMessage,
  MultiValue,
  MultiValueContainer,
  MultiValueLabel,
  MultiValueRemove,
  Option,
  Placeholder,
  SelectContainer,
  SingleValue,
  ValueContainer
};
var defaultComponents = function defaultComponents2(props) {
  return _objectSpread2(_objectSpread2({}, components), props.components);
};
var safeIsNaN = Number.isNaN || function ponyfill(value) {
  return typeof value === "number" && value !== value;
};
function isEqual2(first, second) {
  if (first === second) {
    return true;
  }
  if (safeIsNaN(first) && safeIsNaN(second)) {
    return true;
  }
  return false;
}
function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }
  for (var i2 = 0; i2 < newInputs.length; i2++) {
    if (!isEqual2(newInputs[i2], lastInputs[i2])) {
      return false;
    }
  }
  return true;
}
function memoizeOne(resultFn, isEqual3) {
  if (isEqual3 === void 0) {
    isEqual3 = areInputsEqual;
  }
  var cache = null;
  function memoized() {
    var newArgs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      newArgs[_i] = arguments[_i];
    }
    if (cache && cache.lastThis === this && isEqual3(newArgs, cache.lastArgs)) {
      return cache.lastResult;
    }
    var lastResult = resultFn.apply(this, newArgs);
    cache = {
      lastResult,
      lastArgs: newArgs,
      lastThis: this
    };
    return lastResult;
  }
  memoized.clear = function clear() {
    cache = null;
  };
  return memoized;
}
var _ref = {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var A11yText = function A11yText2(props) {
  return jsx("span", _extends$1({
    css: _ref
  }, props));
};
var defaultAriaLiveMessages = {
  guidance: function guidance(props) {
    var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
    switch (context) {
      case "menu":
        return "Use Up and Down to choose options".concat(isDisabled ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return "".concat(props["aria-label"] || "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "");
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function onChange(props) {
    var action = props.action, _props$label = props.label, label = _props$label === void 0 ? "" : _props$label, labels = props.labels, isDisabled = props.isDisabled;
    switch (action) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(label, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(labels.length > 1 ? "s" : "", " ").concat(labels.join(","), ", selected.");
      case "select-option":
        return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function onFocus(props) {
    var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? "" : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
    var getArrayIndex = function getArrayIndex2(arr, item2) {
      return arr && arr.length ? "".concat(arr.indexOf(item2) + 1, " of ").concat(arr.length) : "";
    };
    if (context === "value" && selectValue) {
      return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
    }
    if (context === "menu") {
      var disabled2 = isDisabled ? " disabled" : "";
      var status = "".concat(isSelected ? "selected" : "focused").concat(disabled2);
      return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
    }
    return "";
  },
  onFilter: function onFilter(props) {
    var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
    return "".concat(resultsMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
  }
};
var LiveRegion = function LiveRegion2(props) {
  var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
  var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel4 = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled3 = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus2 = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
  var ariaLabel = selectProps["aria-label"];
  var ariaLive = selectProps["aria-live"];
  var messages = useMemo(function() {
    return _objectSpread2(_objectSpread2({}, defaultAriaLiveMessages), ariaLiveMessages || {});
  }, [ariaLiveMessages]);
  var ariaSelected = useMemo(function() {
    var message = "";
    if (ariaSelection && messages.onChange) {
      var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
      var asOption = function asOption2(val) {
        return !Array.isArray(val) ? val : null;
      };
      var selected2 = removedValue || option || asOption(value);
      var label = selected2 ? getOptionLabel4(selected2) : "";
      var multiSelected = selectedOptions || removedValues || void 0;
      var labels = multiSelected ? multiSelected.map(getOptionLabel4) : [];
      var onChangeProps = _objectSpread2({
        isDisabled: selected2 && isOptionDisabled3(selected2, selectValue),
        label,
        labels
      }, ariaSelection);
      message = messages.onChange(onChangeProps);
    }
    return message;
  }, [ariaSelection, messages, isOptionDisabled3, selectValue, getOptionLabel4]);
  var ariaFocused = useMemo(function() {
    var focusMsg = "";
    var focused = focusedOption || focusedValue;
    var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
    if (focused && messages.onFocus) {
      var onFocusProps = {
        focused,
        label: getOptionLabel4(focused),
        isDisabled: isOptionDisabled3(focused, selectValue),
        isSelected,
        options: focusableOptions,
        context: focused === focusedOption ? "menu" : "value",
        selectValue
      };
      focusMsg = messages.onFocus(onFocusProps);
    }
    return focusMsg;
  }, [focusedOption, focusedValue, getOptionLabel4, isOptionDisabled3, messages, focusableOptions, selectValue]);
  var ariaResults = useMemo(function() {
    var resultsMsg = "";
    if (menuIsOpen && options.length && messages.onFilter) {
      var resultsMessage = screenReaderStatus2({
        count: focusableOptions.length
      });
      resultsMsg = messages.onFilter({
        inputValue,
        resultsMessage
      });
    }
    return resultsMsg;
  }, [focusableOptions, inputValue, menuIsOpen, messages, options, screenReaderStatus2]);
  var ariaGuidance = useMemo(function() {
    var guidanceMsg = "";
    if (messages.guidance) {
      var context = focusedValue ? "value" : menuIsOpen ? "menu" : "input";
      guidanceMsg = messages.guidance({
        "aria-label": ariaLabel,
        context,
        isDisabled: focusedOption && isOptionDisabled3(focusedOption, selectValue),
        isMulti,
        isSearchable,
        tabSelectsValue
      });
    }
    return guidanceMsg;
  }, [ariaLabel, focusedOption, focusedValue, isMulti, isOptionDisabled3, isSearchable, menuIsOpen, messages, selectValue, tabSelectsValue]);
  var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
  var ScreenReaderText = jsx(Fragment$1, null, jsx("span", {
    id: "aria-selection"
  }, ariaSelected), jsx("span", {
    id: "aria-context"
  }, ariaContext));
  var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus";
  return jsx(Fragment$1, null, jsx(A11yText, {
    id
  }, isInitialFocus && ScreenReaderText), jsx(A11yText, {
    "aria-live": ariaLive,
    "aria-atomic": "false",
    "aria-relevant": "additions text"
  }, isFocused && !isInitialFocus && ScreenReaderText));
};
var diacritics = [{
  base: "A",
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: "AA",
  letters: "\uA732"
}, {
  base: "AE",
  letters: "\xC6\u01FC\u01E2"
}, {
  base: "AO",
  letters: "\uA734"
}, {
  base: "AU",
  letters: "\uA736"
}, {
  base: "AV",
  letters: "\uA738\uA73A"
}, {
  base: "AY",
  letters: "\uA73C"
}, {
  base: "B",
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: "C",
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: "D",
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
}, {
  base: "DZ",
  letters: "\u01F1\u01C4"
}, {
  base: "Dz",
  letters: "\u01F2\u01C5"
}, {
  base: "E",
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: "F",
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: "G",
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: "H",
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: "I",
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: "J",
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: "K",
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: "L",
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: "LJ",
  letters: "\u01C7"
}, {
  base: "Lj",
  letters: "\u01C8"
}, {
  base: "M",
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: "N",
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: "NJ",
  letters: "\u01CA"
}, {
  base: "Nj",
  letters: "\u01CB"
}, {
  base: "O",
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: "OI",
  letters: "\u01A2"
}, {
  base: "OO",
  letters: "\uA74E"
}, {
  base: "OU",
  letters: "\u0222"
}, {
  base: "P",
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: "Q",
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: "R",
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: "S",
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: "T",
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: "TZ",
  letters: "\uA728"
}, {
  base: "U",
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: "V",
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: "VY",
  letters: "\uA760"
}, {
  base: "W",
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: "X",
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: "Y",
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: "Z",
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: "a",
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: "aa",
  letters: "\uA733"
}, {
  base: "ae",
  letters: "\xE6\u01FD\u01E3"
}, {
  base: "ao",
  letters: "\uA735"
}, {
  base: "au",
  letters: "\uA737"
}, {
  base: "av",
  letters: "\uA739\uA73B"
}, {
  base: "ay",
  letters: "\uA73D"
}, {
  base: "b",
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: "c",
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: "d",
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: "dz",
  letters: "\u01F3\u01C6"
}, {
  base: "e",
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: "f",
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: "g",
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: "h",
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: "hv",
  letters: "\u0195"
}, {
  base: "i",
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: "j",
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: "k",
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: "l",
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: "lj",
  letters: "\u01C9"
}, {
  base: "m",
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: "n",
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: "nj",
  letters: "\u01CC"
}, {
  base: "o",
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: "oi",
  letters: "\u01A3"
}, {
  base: "ou",
  letters: "\u0223"
}, {
  base: "oo",
  letters: "\uA74F"
}, {
  base: "p",
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: "q",
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: "r",
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: "s",
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: "t",
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: "tz",
  letters: "\uA729"
}, {
  base: "u",
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: "v",
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: "vy",
  letters: "\uA761"
}, {
  base: "w",
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: "x",
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: "y",
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: "z",
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}];
var anyDiacritic = new RegExp("[" + diacritics.map(function(d2) {
  return d2.letters;
}).join("") + "]", "g");
var diacriticToBase = {};
for (var i$1 = 0; i$1 < diacritics.length; i$1++) {
  var diacritic = diacritics[i$1];
  for (var j = 0; j < diacritic.letters.length; j++) {
    diacriticToBase[diacritic.letters[j]] = diacritic.base;
  }
}
var stripDiacritics$1 = function stripDiacritics(str) {
  return str.replace(anyDiacritic, function(match2) {
    return diacriticToBase[match2];
  });
};
var memoizedStripDiacriticsForInput = memoizeOne(stripDiacritics$1);
var trimString = function trimString2(str) {
  return str.replace(/^\s+|\s+$/g, "");
};
var defaultStringify = function defaultStringify2(option) {
  return "".concat(option.label, " ").concat(option.value);
};
var createFilter = function createFilter2(config) {
  return function(option, rawInput) {
    if (option.data.__isNew__)
      return true;
    var _ignoreCase$ignoreAcc = _objectSpread2({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaultStringify,
      trim: true,
      matchFrom: "any"
    }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify2 = _ignoreCase$ignoreAcc.stringify, trim2 = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
    var input2 = trim2 ? trimString(rawInput) : rawInput;
    var candidate = trim2 ? trimString(stringify2(option)) : stringify2(option);
    if (ignoreCase) {
      input2 = input2.toLowerCase();
      candidate = candidate.toLowerCase();
    }
    if (ignoreAccents) {
      input2 = memoizedStripDiacriticsForInput(input2);
      candidate = stripDiacritics$1(candidate);
    }
    return matchFrom === "start" ? candidate.substr(0, input2.length) === input2 : candidate.indexOf(input2) > -1;
  };
};
var _excluded$g = ["innerRef"];
function DummyInput(_ref3) {
  var innerRef = _ref3.innerRef, props = _objectWithoutProperties$2(_ref3, _excluded$g);
  var filteredProps = removeProps(props, "onExited", "in", "enter", "exit", "appear");
  return jsx("input", _extends$1({
    ref: innerRef
  }, filteredProps, {
    css: /* @__PURE__ */ css$2({
      label: "dummyInput",
      background: 0,
      border: 0,
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      width: 1,
      color: "transparent",
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, "", "")
  }));
}
var cancelScroll = function cancelScroll2(event) {
  event.preventDefault();
  event.stopPropagation();
};
function useScrollCapture(_ref3) {
  var isEnabled = _ref3.isEnabled, onBottomArrive = _ref3.onBottomArrive, onBottomLeave = _ref3.onBottomLeave, onTopArrive = _ref3.onTopArrive, onTopLeave = _ref3.onTopLeave;
  var isBottom = useRef(false);
  var isTop = useRef(false);
  var touchStart = useRef(0);
  var scrollTarget = useRef(null);
  var handleEventDelta = useCallback(function(event, delta) {
    if (scrollTarget.current === null)
      return;
    var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
    var target = scrollTarget.current;
    var isDeltaPositive = delta > 0;
    var availableScroll = scrollHeight - clientHeight - scrollTop;
    var shouldCancelScroll = false;
    if (availableScroll > delta && isBottom.current) {
      if (onBottomLeave)
        onBottomLeave(event);
      isBottom.current = false;
    }
    if (isDeltaPositive && isTop.current) {
      if (onTopLeave)
        onTopLeave(event);
      isTop.current = false;
    }
    if (isDeltaPositive && delta > availableScroll) {
      if (onBottomArrive && !isBottom.current) {
        onBottomArrive(event);
      }
      target.scrollTop = scrollHeight;
      shouldCancelScroll = true;
      isBottom.current = true;
    } else if (!isDeltaPositive && -delta > scrollTop) {
      if (onTopArrive && !isTop.current) {
        onTopArrive(event);
      }
      target.scrollTop = 0;
      shouldCancelScroll = true;
      isTop.current = true;
    }
    if (shouldCancelScroll) {
      cancelScroll(event);
    }
  }, [onBottomArrive, onBottomLeave, onTopArrive, onTopLeave]);
  var onWheel = useCallback(function(event) {
    handleEventDelta(event, event.deltaY);
  }, [handleEventDelta]);
  var onTouchStart = useCallback(function(event) {
    touchStart.current = event.changedTouches[0].clientY;
  }, []);
  var onTouchMove = useCallback(function(event) {
    var deltaY = touchStart.current - event.changedTouches[0].clientY;
    handleEventDelta(event, deltaY);
  }, [handleEventDelta]);
  var startListening = useCallback(function(el) {
    if (!el)
      return;
    var notPassive = supportsPassiveEvents ? {
      passive: false
    } : false;
    el.addEventListener("wheel", onWheel, notPassive);
    el.addEventListener("touchstart", onTouchStart, notPassive);
    el.addEventListener("touchmove", onTouchMove, notPassive);
  }, [onTouchMove, onTouchStart, onWheel]);
  var stopListening = useCallback(function(el) {
    if (!el)
      return;
    el.removeEventListener("wheel", onWheel, false);
    el.removeEventListener("touchstart", onTouchStart, false);
    el.removeEventListener("touchmove", onTouchMove, false);
  }, [onTouchMove, onTouchStart, onWheel]);
  useEffect(function() {
    if (!isEnabled)
      return;
    var element = scrollTarget.current;
    startListening(element);
    return function() {
      stopListening(element);
    };
  }, [isEnabled, startListening, stopListening]);
  return function(element) {
    scrollTarget.current = element;
  };
}
var STYLE_KEYS = ["boxSizing", "height", "overflow", "paddingRight", "position"];
var LOCK_STYLES = {
  boxSizing: "border-box",
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function preventTouchMove(e2) {
  e2.preventDefault();
}
function allowTouchMove(e2) {
  e2.stopPropagation();
}
function preventInertiaScroll() {
  var top2 = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top2 + this.offsetHeight;
  if (top2 === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top2 - 1;
  }
}
function isTouchDevice() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var canUseDOM$1 = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var activeScrollLocks = 0;
var listenerOptions = {
  capture: false,
  passive: false
};
function useScrollLock(_ref3) {
  var isEnabled = _ref3.isEnabled, _ref$accountForScroll = _ref3.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
  var originalStyles = useRef({});
  var scrollTarget = useRef(null);
  var addScrollLock = useCallback(function(touchScrollTarget) {
    if (!canUseDOM$1)
      return;
    var target = document.body;
    var targetStyle = target && target.style;
    if (accountForScrollbars) {
      STYLE_KEYS.forEach(function(key) {
        var val = targetStyle && targetStyle[key];
        originalStyles.current[key] = val;
      });
    }
    if (accountForScrollbars && activeScrollLocks < 1) {
      var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
      var clientWidth = document.body ? document.body.clientWidth : 0;
      var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
      Object.keys(LOCK_STYLES).forEach(function(key) {
        var val = LOCK_STYLES[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
      if (targetStyle) {
        targetStyle.paddingRight = "".concat(adjustedPadding, "px");
      }
    }
    if (target && isTouchDevice()) {
      target.addEventListener("touchmove", preventTouchMove, listenerOptions);
      if (touchScrollTarget) {
        touchScrollTarget.addEventListener("touchstart", preventInertiaScroll, listenerOptions);
        touchScrollTarget.addEventListener("touchmove", allowTouchMove, listenerOptions);
      }
    }
    activeScrollLocks += 1;
  }, [accountForScrollbars]);
  var removeScrollLock = useCallback(function(touchScrollTarget) {
    if (!canUseDOM$1)
      return;
    var target = document.body;
    var targetStyle = target && target.style;
    activeScrollLocks = Math.max(activeScrollLocks - 1, 0);
    if (accountForScrollbars && activeScrollLocks < 1) {
      STYLE_KEYS.forEach(function(key) {
        var val = originalStyles.current[key];
        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
    }
    if (target && isTouchDevice()) {
      target.removeEventListener("touchmove", preventTouchMove, listenerOptions);
      if (touchScrollTarget) {
        touchScrollTarget.removeEventListener("touchstart", preventInertiaScroll, listenerOptions);
        touchScrollTarget.removeEventListener("touchmove", allowTouchMove, listenerOptions);
      }
    }
  }, [accountForScrollbars]);
  useEffect(function() {
    if (!isEnabled)
      return;
    var element = scrollTarget.current;
    addScrollLock(element);
    return function() {
      removeScrollLock(element);
    };
  }, [isEnabled, addScrollLock, removeScrollLock]);
  return function(element) {
    scrollTarget.current = element;
  };
}
var blurSelectInput = function blurSelectInput2() {
  return document.activeElement && document.activeElement.blur();
};
var _ref2$1 = {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function ScrollManager(_ref3) {
  var children = _ref3.children, lockEnabled = _ref3.lockEnabled, _ref$captureEnabled = _ref3.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref3.onBottomArrive, onBottomLeave = _ref3.onBottomLeave, onTopArrive = _ref3.onTopArrive, onTopLeave = _ref3.onTopLeave;
  var setScrollCaptureTarget = useScrollCapture({
    isEnabled: captureEnabled,
    onBottomArrive,
    onBottomLeave,
    onTopArrive,
    onTopLeave
  });
  var setScrollLockTarget = useScrollLock({
    isEnabled: lockEnabled
  });
  var targetRef = function targetRef2(element) {
    setScrollCaptureTarget(element);
    setScrollLockTarget(element);
  };
  return jsx(Fragment$1, null, lockEnabled && jsx("div", {
    onClick: blurSelectInput,
    css: _ref2$1
  }), children(targetRef));
}
var _ref2 = {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var RequiredInput = function RequiredInput2(_ref3) {
  var name = _ref3.name, onFocus2 = _ref3.onFocus;
  return jsx("input", {
    required: true,
    name,
    tabIndex: -1,
    onFocus: onFocus2,
    css: _ref2,
    value: "",
    onChange: function onChange2() {
    }
  });
};
var formatGroupLabel = function formatGroupLabel2(group) {
  return group.label;
};
var getOptionLabel$1 = function getOptionLabel(option) {
  return option.label;
};
var getOptionValue$1 = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled2(option) {
  return !!option.isDisabled;
};
var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css$1,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css2,
  valueContainer: valueContainerCSS
};
var colors = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
};
var borderRadius = 4;
var baseUnit = 4;
var controlHeight = 38;
var menuGutter = baseUnit * 2;
var spacing = {
  baseUnit,
  controlHeight,
  menuGutter
};
var defaultTheme = {
  borderRadius,
  colors,
  spacing
};
var defaultProps$7 = {
  "aria-live": "polite",
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  classNames: {},
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel,
  getOptionLabel: getOptionLabel$1,
  getOptionValue: getOptionValue$1,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return "No options";
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function screenReaderStatus(_ref3) {
    var count = _ref3.count;
    return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: true,
  unstyled: false
};
function toCategorizedOption(props, option, selectValue, index2) {
  var isDisabled = _isOptionDisabled(props, option, selectValue);
  var isSelected = _isOptionSelected(props, option, selectValue);
  var label = getOptionLabel$2(props, option);
  var value = getOptionValue2(props, option);
  return {
    type: "option",
    data: option,
    isDisabled,
    isSelected,
    label,
    value,
    index: index2
  };
}
function buildCategorizedOptions(props, selectValue) {
  return props.options.map(function(groupOrOption, groupOrOptionIndex) {
    if ("options" in groupOrOption) {
      var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
        return toCategorizedOption(props, option, selectValue, optionIndex);
      }).filter(function(categorizedOption2) {
        return isFocusable2(props, categorizedOption2);
      });
      return categorizedOptions.length > 0 ? {
        type: "group",
        data: groupOrOption,
        options: categorizedOptions,
        index: groupOrOptionIndex
      } : void 0;
    }
    var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
    return isFocusable2(props, categorizedOption) ? categorizedOption : void 0;
  }).filter(notNullish);
}
function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
  return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
    if (categorizedOption.type === "group") {
      optionsAccumulator.push.apply(optionsAccumulator, _toConsumableArray(categorizedOption.options.map(function(option) {
        return option.data;
      })));
    } else {
      optionsAccumulator.push(categorizedOption.data);
    }
    return optionsAccumulator;
  }, []);
}
function buildFocusableOptions(props, selectValue) {
  return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}
function isFocusable2(props, categorizedOption) {
  var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue;
  var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
  return (!shouldHideSelectedOptions(props) || !isSelected) && _filterOption(props, {
    label,
    value,
    data
  }, inputValue);
}
function getNextFocusedValue(state, nextSelectValue) {
  var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
  var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
  if (lastFocusedIndex > -1) {
    var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
    if (nextFocusedIndex > -1) {
      return focusedValue;
    } else if (lastFocusedIndex < nextSelectValue.length) {
      return nextSelectValue[lastFocusedIndex];
    }
  }
  return null;
}
function getNextFocusedOption(state, options) {
  var lastFocusedOption = state.focusedOption;
  return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var getOptionLabel$2 = function getOptionLabel2(props, data) {
  return props.getOptionLabel(data);
};
var getOptionValue2 = function getOptionValue3(props, data) {
  return props.getOptionValue(data);
};
function _isOptionDisabled(props, option, selectValue) {
  return typeof props.isOptionDisabled === "function" ? props.isOptionDisabled(option, selectValue) : false;
}
function _isOptionSelected(props, option, selectValue) {
  if (selectValue.indexOf(option) > -1)
    return true;
  if (typeof props.isOptionSelected === "function") {
    return props.isOptionSelected(option, selectValue);
  }
  var candidate = getOptionValue2(props, option);
  return selectValue.some(function(i2) {
    return getOptionValue2(props, i2) === candidate;
  });
}
function _filterOption(props, option, inputValue) {
  return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var shouldHideSelectedOptions = function shouldHideSelectedOptions2(props) {
  var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
  if (hideSelectedOptions === void 0)
    return isMulti;
  return hideSelectedOptions;
};
var instanceId = 1;
var Select$1 = /* @__PURE__ */ function(_Component) {
  _inherits$1(Select2, _Component);
  var _super = _createSuper$2(Select2);
  function Select2(_props) {
    var _this;
    _classCallCheck$1(this, Select2);
    _this = _super.call(this, _props);
    _this.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      selectValue: [],
      clearFocusValueOnUpdate: false,
      prevWasFocused: false,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0
    };
    _this.blockOptionHover = false;
    _this.isComposing = false;
    _this.commonProps = void 0;
    _this.initialTouchX = 0;
    _this.initialTouchY = 0;
    _this.instancePrefix = "";
    _this.openAfterFocus = false;
    _this.scrollToFocusedOptionOnUpdate = false;
    _this.userIsDragging = void 0;
    _this.controlRef = null;
    _this.getControlRef = function(ref) {
      _this.controlRef = ref;
    };
    _this.focusedOptionRef = null;
    _this.getFocusedOptionRef = function(ref) {
      _this.focusedOptionRef = ref;
    };
    _this.menuListRef = null;
    _this.getMenuListRef = function(ref) {
      _this.menuListRef = ref;
    };
    _this.inputRef = null;
    _this.getInputRef = function(ref) {
      _this.inputRef = ref;
    };
    _this.focus = _this.focusInput;
    _this.blur = _this.blurInput;
    _this.onChange = function(newValue, actionMeta) {
      var _this$props = _this.props, onChange2 = _this$props.onChange, name = _this$props.name;
      actionMeta.name = name;
      _this.ariaOnChange(newValue, actionMeta);
      onChange2(newValue, actionMeta);
    };
    _this.setValue = function(newValue, action, option) {
      var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
      _this.onInputChange("", {
        action: "set-value",
        prevInputValue: inputValue
      });
      if (closeMenuOnSelect) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      }
      _this.setState({
        clearFocusValueOnUpdate: true
      });
      _this.onChange(newValue, {
        action,
        option
      });
    };
    _this.selectOption = function(newValue) {
      var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
      var selectValue = _this.state.selectValue;
      var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
      var isDisabled = _this.isOptionDisabled(newValue, selectValue);
      if (deselected) {
        var candidate = _this.getOptionValue(newValue);
        _this.setValue(multiValueAsValue(selectValue.filter(function(i2) {
          return _this.getOptionValue(i2) !== candidate;
        })), "deselect-option", newValue);
      } else if (!isDisabled) {
        if (isMulti) {
          _this.setValue(multiValueAsValue([].concat(_toConsumableArray(selectValue), [newValue])), "select-option", newValue);
        } else {
          _this.setValue(singleValueAsValue(newValue), "select-option");
        }
      } else {
        _this.ariaOnChange(singleValueAsValue(newValue), {
          action: "select-option",
          option: newValue,
          name
        });
        return;
      }
      if (blurInputOnSelect) {
        _this.blurInput();
      }
    };
    _this.removeValue = function(removedValue) {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var candidate = _this.getOptionValue(removedValue);
      var newValueArray = selectValue.filter(function(i2) {
        return _this.getOptionValue(i2) !== candidate;
      });
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);
      _this.onChange(newValue, {
        action: "remove-value",
        removedValue
      });
      _this.focusInput();
    };
    _this.clearValue = function() {
      var selectValue = _this.state.selectValue;
      _this.onChange(valueTernary(_this.props.isMulti, [], null), {
        action: "clear",
        removedValues: selectValue
      });
    };
    _this.popValue = function() {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];
      var newValueArray = selectValue.slice(0, selectValue.length - 1);
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);
      _this.onChange(newValue, {
        action: "pop-value",
        removedValue: lastSelectedValue
      });
    };
    _this.getValue = function() {
      return _this.state.selectValue;
    };
    _this.cx = function() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return classNames.apply(void 0, [_this.props.classNamePrefix].concat(args));
    };
    _this.getOptionLabel = function(data) {
      return getOptionLabel$2(_this.props, data);
    };
    _this.getOptionValue = function(data) {
      return getOptionValue2(_this.props, data);
    };
    _this.getStyles = function(key, props) {
      var unstyled = _this.props.unstyled;
      var base = defaultStyles[key](props, unstyled);
      base.boxSizing = "border-box";
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    };
    _this.getClassNames = function(key, props) {
      var _this$props$className, _this$props$className2;
      return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
    };
    _this.getElementId = function(element) {
      return "".concat(_this.instancePrefix, "-").concat(element);
    };
    _this.getComponents = function() {
      return defaultComponents(_this.props);
    };
    _this.buildCategorizedOptions = function() {
      return buildCategorizedOptions(_this.props, _this.state.selectValue);
    };
    _this.getCategorizedOptions = function() {
      return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
    };
    _this.buildFocusableOptions = function() {
      return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
    };
    _this.getFocusableOptions = function() {
      return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
    };
    _this.ariaOnChange = function(value, actionMeta) {
      _this.setState({
        ariaSelection: _objectSpread2({
          value
        }, actionMeta)
      });
    };
    _this.onMenuMouseDown = function(event) {
      if (event.button !== 0) {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
      _this.focusInput();
    };
    _this.onMenuMouseMove = function(event) {
      _this.blockOptionHover = false;
    };
    _this.onControlMouseDown = function(event) {
      if (event.defaultPrevented) {
        return;
      }
      var openMenuOnClick = _this.props.openMenuOnClick;
      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }
        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu("first");
        }
      } else {
        if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") {
          _this.onMenuClose();
        }
      }
      if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") {
        event.preventDefault();
      }
    };
    _this.onDropdownIndicatorMouseDown = function(event) {
      if (event && event.type === "mousedown" && event.button !== 0) {
        return;
      }
      if (_this.props.isDisabled)
        return;
      var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
      _this.focusInput();
      if (menuIsOpen) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });
        _this.onMenuClose();
      } else {
        _this.openMenu("first");
      }
      event.preventDefault();
    };
    _this.onClearIndicatorMouseDown = function(event) {
      if (event && event.type === "mousedown" && event.button !== 0) {
        return;
      }
      _this.clearValue();
      event.preventDefault();
      _this.openAfterFocus = false;
      if (event.type === "touchend") {
        _this.focusInput();
      } else {
        setTimeout(function() {
          return _this.focusInput();
        });
      }
    };
    _this.onScroll = function(event) {
      if (typeof _this.props.closeMenuOnScroll === "boolean") {
        if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === "function") {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    };
    _this.onCompositionStart = function() {
      _this.isComposing = true;
    };
    _this.onCompositionEnd = function() {
      _this.isComposing = false;
    };
    _this.onTouchStart = function(_ref22) {
      var touches = _ref22.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    };
    _this.onTouchMove = function(_ref3) {
      var touches = _ref3.touches;
      var touch = touches && touches.item(0);
      if (!touch) {
        return;
      }
      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    };
    _this.onTouchEnd = function(event) {
      if (_this.userIsDragging)
        return;
      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      }
      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    };
    _this.onControlTouchEnd = function(event) {
      if (_this.userIsDragging)
        return;
      _this.onControlMouseDown(event);
    };
    _this.onClearIndicatorTouchEnd = function(event) {
      if (_this.userIsDragging)
        return;
      _this.onClearIndicatorMouseDown(event);
    };
    _this.onDropdownIndicatorTouchEnd = function(event) {
      if (_this.userIsDragging)
        return;
      _this.onDropdownIndicatorMouseDown(event);
    };
    _this.handleInputChange = function(event) {
      var prevInputValue = _this.props.inputValue;
      var inputValue = event.currentTarget.value;
      _this.setState({
        inputIsHiddenAfterUpdate: false
      });
      _this.onInputChange(inputValue, {
        action: "input-change",
        prevInputValue
      });
      if (!_this.props.menuIsOpen) {
        _this.onMenuOpen();
      }
    };
    _this.onInputFocus = function(event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
      _this.setState({
        inputIsHiddenAfterUpdate: false,
        isFocused: true
      });
      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu("first");
      }
      _this.openAfterFocus = false;
    };
    _this.onInputBlur = function(event) {
      var prevInputValue = _this.props.inputValue;
      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();
        return;
      }
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
      _this.onInputChange("", {
        action: "input-blur",
        prevInputValue
      });
      _this.onMenuClose();
      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    };
    _this.onOptionHover = function(focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }
      _this.setState({
        focusedOption
      });
    };
    _this.shouldHideSelectedOptions = function() {
      return shouldHideSelectedOptions(_this.props);
    };
    _this.onValueInputFocus = function(e2) {
      e2.preventDefault();
      e2.stopPropagation();
      _this.focus();
    };
    _this.onKeyDown = function(event) {
      var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
      var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
      if (isDisabled)
        return;
      if (typeof onKeyDown === "function") {
        onKeyDown(event);
        if (event.defaultPrevented) {
          return;
        }
      }
      _this.blockOptionHover = true;
      switch (event.key) {
        case "ArrowLeft":
          if (!isMulti || inputValue)
            return;
          _this.focusValue("previous");
          break;
        case "ArrowRight":
          if (!isMulti || inputValue)
            return;
          _this.focusValue("next");
          break;
        case "Delete":
        case "Backspace":
          if (inputValue)
            return;
          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue)
              return;
            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }
          break;
        case "Tab":
          if (_this.isComposing)
            return;
          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }
          _this.selectOption(focusedOption);
          break;
        case "Enter":
          if (event.keyCode === 229) {
            break;
          }
          if (menuIsOpen) {
            if (!focusedOption)
              return;
            if (_this.isComposing)
              return;
            _this.selectOption(focusedOption);
            break;
          }
          return;
        case "Escape":
          if (menuIsOpen) {
            _this.setState({
              inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange("", {
              action: "menu-close",
              prevInputValue: inputValue
            });
            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }
          break;
        case " ":
          if (inputValue) {
            return;
          }
          if (!menuIsOpen) {
            _this.openMenu("first");
            break;
          }
          if (!focusedOption)
            return;
          _this.selectOption(focusedOption);
          break;
        case "ArrowUp":
          if (menuIsOpen) {
            _this.focusOption("up");
          } else {
            _this.openMenu("last");
          }
          break;
        case "ArrowDown":
          if (menuIsOpen) {
            _this.focusOption("down");
          } else {
            _this.openMenu("first");
          }
          break;
        case "PageUp":
          if (!menuIsOpen)
            return;
          _this.focusOption("pageup");
          break;
        case "PageDown":
          if (!menuIsOpen)
            return;
          _this.focusOption("pagedown");
          break;
        case "Home":
          if (!menuIsOpen)
            return;
          _this.focusOption("first");
          break;
        case "End":
          if (!menuIsOpen)
            return;
          _this.focusOption("last");
          break;
        default:
          return;
      }
      event.preventDefault();
    };
    _this.instancePrefix = "react-select-" + (_this.props.instanceId || ++instanceId);
    _this.state.selectValue = cleanValue(_props.value);
    if (_props.menuIsOpen && _this.state.selectValue.length) {
      var focusableOptions = _this.buildFocusableOptions();
      var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
      _this.state.focusedOption = focusableOptions[optionIndex];
    }
    return _this;
  }
  _createClass$1(Select2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();
      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        document.addEventListener("scroll", this.onScroll, true);
      }
      if (this.props.autoFocus) {
        this.focusInput();
      }
      if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) {
        scrollIntoView$1(this.menuListRef, this.focusedOptionRef);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
      var isFocused = this.state.isFocused;
      if (isFocused && !isDisabled && prevProps.isDisabled || isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      }
      if (isFocused && isDisabled && !prevProps.isDisabled) {
        this.setState({
          isFocused: false
        }, this.onMenuClose);
      } else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) {
        this.setState({
          isFocused: true
        });
      }
      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView$1(this.menuListRef, this.focusedOptionRef);
        this.scrollToFocusedOptionOnUpdate = false;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener("scroll", this.onScroll, true);
    }
  }, {
    key: "onMenuOpen",
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    }
  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef)
        return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef)
        return;
      this.inputRef.blur();
    }
  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this2 = this;
      var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
      var focusableOptions = this.buildFocusableOptions();
      var openAtIndex = focusOption === "first" ? 0 : focusableOptions.length - 1;
      if (!this.props.isMulti) {
        var selectedIndex = focusableOptions.indexOf(selectValue[0]);
        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      }
      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.setState({
        inputIsHiddenAfterUpdate: false,
        focusedValue: null,
        focusedOption: focusableOptions[openAtIndex]
      }, function() {
        return _this2.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
      if (!this.props.isMulti)
        return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);
      if (!focusedValue) {
        focusedIndex = -1;
      }
      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length)
        return;
      switch (direction) {
        case "previous":
          if (focusedIndex === 0) {
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }
          break;
        case "next":
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }
          break;
      }
      this.setState({
        inputIsHidden: nextFocus !== -1,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first";
      var pageSize = this.props.pageSize;
      var focusedOption = this.state.focusedOption;
      var options = this.getFocusableOptions();
      if (!options.length)
        return;
      var nextFocus = 0;
      var focusedIndex = options.indexOf(focusedOption);
      if (!focusedOption) {
        focusedIndex = -1;
      }
      if (direction === "up") {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === "down") {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === "pageup") {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0)
          nextFocus = 0;
      } else if (direction === "pagedown") {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1)
          nextFocus = options.length - 1;
      } else if (direction === "last") {
        nextFocus = options.length - 1;
      }
      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null
      });
    }
  }, {
    key: "getTheme",
    value: function getTheme() {
      if (!this.props.theme) {
        return defaultTheme;
      }
      if (typeof this.props.theme === "function") {
        return this.props.theme(defaultTheme);
      }
      return _objectSpread2(_objectSpread2({}, defaultTheme), this.props.theme);
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue, cx2 = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
      var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
      var hasValue = this.hasValue();
      return {
        clearValue,
        cx: cx2,
        getStyles,
        getClassNames,
        getValue,
        hasValue,
        isMulti,
        isRtl,
        options,
        selectOption,
        selectProps: props,
        setValue,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props7 = this.props, isClearable2 = _this$props7.isClearable, isMulti = _this$props7.isMulti;
      if (isClearable2 === void 0)
        return isMulti;
      return isClearable2;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled3(option, selectValue) {
      return _isOptionDisabled(this.props, option, selectValue);
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      return _isOptionSelected(this.props, option, selectValue);
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return _filterOption(this.props, option, inputValue);
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === "function") {
        var _inputValue = this.props.inputValue;
        var _selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context,
          inputValue: _inputValue,
          selectValue: _selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel3(data) {
      return this.props.formatGroupLabel(data);
    }
  }, {
    key: "startListeningComposition",
    value: function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener("compositionstart", this.onCompositionStart, false);
        document.addEventListener("compositionend", this.onCompositionEnd, false);
      }
    }
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener("compositionstart", this.onCompositionStart);
        document.removeEventListener("compositionend", this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    value: function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener("touchstart", this.onTouchStart, false);
        document.addEventListener("touchmove", this.onTouchMove, false);
        document.addEventListener("touchend", this.onTouchEnd, false);
      }
    }
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener("touchstart", this.onTouchStart);
        document.removeEventListener("touchmove", this.onTouchMove);
        document.removeEventListener("touchend", this.onTouchEnd);
      }
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required2 = _this$props8.required;
      var _this$getComponents = this.getComponents(), Input3 = _this$getComponents.Input;
      var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
      var commonProps = this.commonProps;
      var id = inputId || this.getElementId("input");
      var ariaAttributes = _objectSpread2(_objectSpread2(_objectSpread2({
        "aria-autocomplete": "list",
        "aria-expanded": menuIsOpen,
        "aria-haspopup": true,
        "aria-errormessage": this.props["aria-errormessage"],
        "aria-invalid": this.props["aria-invalid"],
        "aria-label": this.props["aria-label"],
        "aria-labelledby": this.props["aria-labelledby"],
        "aria-required": required2,
        role: "combobox"
      }, menuIsOpen && {
        "aria-controls": this.getElementId("listbox"),
        "aria-owns": this.getElementId("listbox")
      }), !isSearchable && {
        "aria-readonly": true
      }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus" && {
        "aria-describedby": this.getElementId("live-region")
      } : {
        "aria-describedby": this.getElementId("placeholder")
      });
      if (!isSearchable) {
        return /* @__PURE__ */ React$1.createElement(DummyInput, _extends$1({
          id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: noop$2,
          onFocus: this.onInputFocus,
          disabled: isDisabled,
          tabIndex,
          inputMode: "none",
          form,
          value: ""
        }, ariaAttributes));
      }
      return /* @__PURE__ */ React$1.createElement(Input3, _extends$1({}, commonProps, {
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        id,
        innerRef: this.getInputRef,
        isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        spellCheck: "false",
        tabIndex,
        form,
        type: "text",
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this3 = this;
      var _this$getComponents2 = this.getComponents(), MultiValue3 = _this$getComponents2.MultiValue, MultiValueContainer2 = _this$getComponents2.MultiValueContainer, MultiValueLabel2 = _this$getComponents2.MultiValueLabel, MultiValueRemove2 = _this$getComponents2.MultiValueRemove, SingleValue3 = _this$getComponents2.SingleValue, Placeholder3 = _this$getComponents2.Placeholder;
      var commonProps = this.commonProps;
      var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
      var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : /* @__PURE__ */ React$1.createElement(Placeholder3, _extends$1({}, commonProps, {
          key: "placeholder",
          isDisabled,
          isFocused,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), placeholder);
      }
      if (isMulti) {
        return selectValue.map(function(opt, index2) {
          var isOptionFocused = opt === focusedValue;
          var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
          return /* @__PURE__ */ React$1.createElement(MultiValue3, _extends$1({}, commonProps, {
            components: {
              Container: MultiValueContainer2,
              Label: MultiValueLabel2,
              Remove: MultiValueRemove2
            },
            isFocused: isOptionFocused,
            isDisabled,
            key,
            index: index2,
            removeProps: {
              onClick: function onClick() {
                return _this3.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this3.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e2) {
                e2.preventDefault();
              }
            },
            data: opt
          }), _this3.formatOptionLabel(opt, "value"));
        });
      }
      if (inputValue) {
        return null;
      }
      var singleValue = selectValue[0];
      return /* @__PURE__ */ React$1.createElement(SingleValue3, _extends$1({}, commonProps, {
        data: singleValue,
        isDisabled
      }), this.formatOptionLabel(singleValue, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var _this$getComponents3 = this.getComponents(), ClearIndicator3 = _this$getComponents3.ClearIndicator;
      var commonProps = this.commonProps;
      var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading2 = _this$props10.isLoading;
      var isFocused = this.state.isFocused;
      if (!this.isClearable() || !ClearIndicator3 || isDisabled || !this.hasValue() || isLoading2) {
        return null;
      }
      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ React$1.createElement(ClearIndicator3, _extends$1({}, commonProps, {
        innerProps,
        isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var _this$getComponents4 = this.getComponents(), LoadingIndicator3 = _this$getComponents4.LoadingIndicator;
      var commonProps = this.commonProps;
      var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading2 = _this$props11.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator3 || !isLoading2)
        return null;
      var innerProps = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ React$1.createElement(LoadingIndicator3, _extends$1({}, commonProps, {
        innerProps,
        isDisabled,
        isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$getComponents5 = this.getComponents(), DropdownIndicator3 = _this$getComponents5.DropdownIndicator, IndicatorSeparator3 = _this$getComponents5.IndicatorSeparator;
      if (!DropdownIndicator3 || !IndicatorSeparator3)
        return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return /* @__PURE__ */ React$1.createElement(IndicatorSeparator3, _extends$1({}, commonProps, {
        isDisabled,
        isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var _this$getComponents6 = this.getComponents(), DropdownIndicator3 = _this$getComponents6.DropdownIndicator;
      if (!DropdownIndicator3)
        return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ React$1.createElement(DropdownIndicator3, _extends$1({}, commonProps, {
        innerProps,
        isDisabled,
        isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this4 = this;
      var _this$getComponents7 = this.getComponents(), Group3 = _this$getComponents7.Group, GroupHeading3 = _this$getComponents7.GroupHeading, Menu4 = _this$getComponents7.Menu, MenuList3 = _this$getComponents7.MenuList, MenuPortal3 = _this$getComponents7.MenuPortal, LoadingMessage3 = _this$getComponents7.LoadingMessage, NoOptionsMessage3 = _this$getComponents7.NoOptionsMessage, Option3 = _this$getComponents7.Option;
      var commonProps = this.commonProps;
      var focusedOption = this.state.focusedOption;
      var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading2 = _this$props12.isLoading, loadingMessage2 = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage2 = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
      if (!menuIsOpen)
        return null;
      var render = function render2(props, id) {
        var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
        var isFocused = focusedOption === data;
        var onHover = isDisabled ? void 0 : function() {
          return _this4.onOptionHover(data);
        };
        var onSelect = isDisabled ? void 0 : function() {
          return _this4.selectOption(data);
        };
        var optionId = "".concat(_this4.getElementId("option"), "-").concat(id);
        var innerProps = {
          id: optionId,
          onClick: onSelect,
          onMouseMove: onHover,
          onMouseOver: onHover,
          tabIndex: -1
        };
        return /* @__PURE__ */ React$1.createElement(Option3, _extends$1({}, commonProps, {
          innerProps,
          data,
          isDisabled,
          isSelected,
          key: optionId,
          label,
          type,
          value,
          isFocused,
          innerRef: isFocused ? _this4.getFocusedOptionRef : void 0
        }), _this4.formatOptionLabel(props.data, "menu"));
      };
      var menuUI;
      if (this.hasOptions()) {
        menuUI = this.getCategorizedOptions().map(function(item2) {
          if (item2.type === "group") {
            var _data = item2.data, options = item2.options, groupIndex = item2.index;
            var groupId = "".concat(_this4.getElementId("group"), "-").concat(groupIndex);
            var headingId = "".concat(groupId, "-heading");
            return /* @__PURE__ */ React$1.createElement(Group3, _extends$1({}, commonProps, {
              key: groupId,
              data: _data,
              options,
              Heading: GroupHeading3,
              headingProps: {
                id: headingId,
                data: item2.data
              },
              label: _this4.formatGroupLabel(item2.data)
            }), item2.options.map(function(option) {
              return render(option, "".concat(groupIndex, "-").concat(option.index));
            }));
          } else if (item2.type === "option") {
            return render(item2, "".concat(item2.index));
          }
        });
      } else if (isLoading2) {
        var message = loadingMessage2({
          inputValue
        });
        if (message === null)
          return null;
        menuUI = /* @__PURE__ */ React$1.createElement(LoadingMessage3, commonProps, message);
      } else {
        var _message = noOptionsMessage2({
          inputValue
        });
        if (_message === null)
          return null;
        menuUI = /* @__PURE__ */ React$1.createElement(NoOptionsMessage3, commonProps, _message);
      }
      var menuPlacementProps = {
        minMenuHeight,
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView
      };
      var menuElement = /* @__PURE__ */ React$1.createElement(MenuPlacer, _extends$1({}, commonProps, menuPlacementProps), function(_ref4) {
        var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
        return /* @__PURE__ */ React$1.createElement(Menu4, _extends$1({}, commonProps, menuPlacementProps, {
          innerRef: ref,
          innerProps: {
            onMouseDown: _this4.onMenuMouseDown,
            onMouseMove: _this4.onMenuMouseMove,
            id: _this4.getElementId("listbox")
          },
          isLoading: isLoading2,
          placement
        }), /* @__PURE__ */ React$1.createElement(ScrollManager, {
          captureEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom,
          lockEnabled: menuShouldBlockScroll
        }, function(scrollTargetRef) {
          return /* @__PURE__ */ React$1.createElement(MenuList3, _extends$1({}, commonProps, {
            innerRef: function innerRef(instance) {
              _this4.getMenuListRef(instance);
              scrollTargetRef(instance);
            },
            isLoading: isLoading2,
            maxHeight,
            focusedOption
          }), menuUI);
        }));
      });
      return menuPortalTarget || menuPosition === "fixed" ? /* @__PURE__ */ React$1.createElement(MenuPortal3, _extends$1({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement,
        menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this5 = this;
      var _this$props13 = this.props, delimiter2 = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required2 = _this$props13.required;
      var selectValue = this.state.selectValue;
      if (!name || isDisabled)
        return;
      if (required2 && !this.hasValue()) {
        return /* @__PURE__ */ React$1.createElement(RequiredInput, {
          name,
          onFocus: this.onValueInputFocus
        });
      }
      if (isMulti) {
        if (delimiter2) {
          var value = selectValue.map(function(opt) {
            return _this5.getOptionValue(opt);
          }).join(delimiter2);
          return /* @__PURE__ */ React$1.createElement("input", {
            name,
            type: "hidden",
            value
          });
        } else {
          var input2 = selectValue.length > 0 ? selectValue.map(function(opt, i2) {
            return /* @__PURE__ */ React$1.createElement("input", {
              key: "i-".concat(i2),
              name,
              type: "hidden",
              value: _this5.getOptionValue(opt)
            });
          }) : /* @__PURE__ */ React$1.createElement("input", {
            name,
            type: "hidden",
            value: ""
          });
          return /* @__PURE__ */ React$1.createElement("div", null, input2);
        }
      } else {
        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
        return /* @__PURE__ */ React$1.createElement("input", {
          name,
          type: "hidden",
          value: _value
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      var commonProps = this.commonProps;
      var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
      var focusableOptions = this.getFocusableOptions();
      return /* @__PURE__ */ React$1.createElement(LiveRegion, _extends$1({}, commonProps, {
        id: this.getElementId("live-region"),
        ariaSelection,
        focusedOption,
        focusedValue,
        isFocused,
        selectValue,
        focusableOptions
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getComponents8 = this.getComponents(), Control3 = _this$getComponents8.Control, IndicatorsContainer3 = _this$getComponents8.IndicatorsContainer, SelectContainer3 = _this$getComponents8.SelectContainer, ValueContainer3 = _this$getComponents8.ValueContainer;
      var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ React$1.createElement(SelectContainer3, _extends$1({}, commonProps, {
        className,
        innerProps: {
          id,
          onKeyDown: this.onKeyDown
        },
        isDisabled,
        isFocused
      }), this.renderLiveRegion(), /* @__PURE__ */ React$1.createElement(Control3, _extends$1({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled,
        isFocused,
        menuIsOpen
      }), /* @__PURE__ */ React$1.createElement(ValueContainer3, _extends$1({}, commonProps, {
        isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ React$1.createElement(IndicatorsContainer3, _extends$1({}, commonProps, {
        isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
      var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
      var selectValue = cleanValue(value);
      var newMenuOptionsState = {};
      if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
        var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
        var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
        var focusedOption = getNextFocusedOption(state, focusableOptions);
        newMenuOptionsState = {
          selectValue,
          focusedOption,
          focusedValue,
          clearFocusValueOnUpdate: false
        };
      }
      var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
        inputIsHidden: inputIsHiddenAfterUpdate,
        inputIsHiddenAfterUpdate: void 0
      } : {};
      var newAriaSelection = ariaSelection;
      var hasKeptFocus = isFocused && prevWasFocused;
      if (isFocused && !hasKeptFocus) {
        newAriaSelection = {
          value: valueTernary(isMulti, selectValue, selectValue[0] || null),
          options: selectValue,
          action: "initial-input-focus"
        };
        hasKeptFocus = !prevWasFocused;
      }
      if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === "initial-input-focus") {
        newAriaSelection = null;
      }
      return _objectSpread2(_objectSpread2(_objectSpread2({}, newMenuOptionsState), newInputIsHiddenState), {}, {
        prevProps: props,
        ariaSelection: newAriaSelection,
        prevWasFocused: hasKeptFocus
      });
    }
  }]);
  return Select2;
}(Component);
Select$1.defaultProps = defaultProps$7;
var StateManagedSelect = /* @__PURE__ */ forwardRef(function(props, ref) {
  var baseSelectProps = useStateManager(props);
  return /* @__PURE__ */ React$1.createElement(Select$1, _extends$1({
    ref
  }, baseSelectProps));
});
var ReactSelect = StateManagedSelect;
var _excluded$f = ["allowCreateWhileLoading", "createOptionPosition", "formatCreateLabel", "isValidNewOption", "getNewOptionData", "onCreateOption", "options", "onChange"];
var compareOption = function compareOption2() {
  var inputValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  var option = arguments.length > 1 ? arguments[1] : void 0;
  var accessors = arguments.length > 2 ? arguments[2] : void 0;
  var candidate = String(inputValue).toLowerCase();
  var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
  var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
  return optionValue === candidate || optionLabel === candidate;
};
var builtins = {
  formatCreateLabel: function formatCreateLabel(inputValue) {
    return 'Create "'.concat(inputValue, '"');
  },
  isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
    return !(!inputValue || selectValue.some(function(option) {
      return compareOption(inputValue, option, accessors);
    }) || selectOptions.some(function(option) {
      return compareOption(inputValue, option, accessors);
    }));
  },
  getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
    return {
      label: optionLabel,
      value: inputValue,
      __isNew__: true
    };
  }
};
function useCreatable(_ref3) {
  var _ref$allowCreateWhile = _ref3.allowCreateWhileLoading, allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile, _ref$createOptionPosi = _ref3.createOptionPosition, createOptionPosition = _ref$createOptionPosi === void 0 ? "last" : _ref$createOptionPosi, _ref$formatCreateLabe = _ref3.formatCreateLabel, formatCreateLabel2 = _ref$formatCreateLabe === void 0 ? builtins.formatCreateLabel : _ref$formatCreateLabe, _ref$isValidNewOption = _ref3.isValidNewOption, isValidNewOption2 = _ref$isValidNewOption === void 0 ? builtins.isValidNewOption : _ref$isValidNewOption, _ref$getNewOptionData = _ref3.getNewOptionData, getNewOptionData2 = _ref$getNewOptionData === void 0 ? builtins.getNewOptionData : _ref$getNewOptionData, onCreateOption = _ref3.onCreateOption, _ref$options = _ref3.options, propsOptions = _ref$options === void 0 ? [] : _ref$options, propsOnChange = _ref3.onChange, restSelectProps = _objectWithoutProperties$2(_ref3, _excluded$f);
  var _restSelectProps$getO = restSelectProps.getOptionValue, getOptionValue$1$1 = _restSelectProps$getO === void 0 ? getOptionValue$1 : _restSelectProps$getO, _restSelectProps$getO2 = restSelectProps.getOptionLabel, getOptionLabel$1$1 = _restSelectProps$getO2 === void 0 ? getOptionLabel$1 : _restSelectProps$getO2, inputValue = restSelectProps.inputValue, isLoading2 = restSelectProps.isLoading, isMulti = restSelectProps.isMulti, value = restSelectProps.value, name = restSelectProps.name;
  var newOption = useMemo(function() {
    return isValidNewOption2(inputValue, cleanValue(value), propsOptions, {
      getOptionValue: getOptionValue$1$1,
      getOptionLabel: getOptionLabel$1$1
    }) ? getNewOptionData2(inputValue, formatCreateLabel2(inputValue)) : void 0;
  }, [formatCreateLabel2, getNewOptionData2, getOptionLabel$1$1, getOptionValue$1$1, inputValue, isValidNewOption2, propsOptions, value]);
  var options = useMemo(function() {
    return (allowCreateWhileLoading || !isLoading2) && newOption ? createOptionPosition === "first" ? [newOption].concat(_toConsumableArray(propsOptions)) : [].concat(_toConsumableArray(propsOptions), [newOption]) : propsOptions;
  }, [allowCreateWhileLoading, createOptionPosition, isLoading2, newOption, propsOptions]);
  var onChange2 = useCallback(function(newValue, actionMeta) {
    if (actionMeta.action !== "select-option") {
      return propsOnChange(newValue, actionMeta);
    }
    var valueArray = Array.isArray(newValue) ? newValue : [newValue];
    if (valueArray[valueArray.length - 1] === newOption) {
      if (onCreateOption)
        onCreateOption(inputValue);
      else {
        var newOptionData = getNewOptionData2(inputValue, inputValue);
        var newActionMeta = {
          action: "create-option",
          name,
          option: newOptionData
        };
        propsOnChange(valueTernary(isMulti, [].concat(_toConsumableArray(cleanValue(value)), [newOptionData]), newOptionData), newActionMeta);
      }
      return;
    }
    propsOnChange(newValue, actionMeta);
  }, [getNewOptionData2, inputValue, isMulti, name, newOption, onCreateOption, propsOnChange, value]);
  return _objectSpread2(_objectSpread2({}, restSelectProps), {}, {
    options,
    onChange: onChange2
  });
}
var CreatableSelect = /* @__PURE__ */ forwardRef(function(props, ref) {
  var creatableProps = useStateManager(props);
  var selectProps = useCreatable(creatableProps);
  return /* @__PURE__ */ React$1.createElement(Select$1, _extends$1({
    ref
  }, selectProps));
});
var __assign$k = globalThis && globalThis.__assign || function() {
  __assign$k = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$k.apply(this, arguments);
};
var __rest$7 = globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var Select = React__default.forwardRef(function(_a, ref) {
  var noBorder2 = _a.noBorder, errorMessage = _a.errorMessage, id = _a.id, label = _a.label, subtitle2 = _a.subtitle, hasErrors2 = _a.hasErrors, _b = _a.hideLabel, hideLabel = _b === void 0 ? false : _b, message = _a.message, className = _a.className, isCreatable = _a.isCreatable, rest = __rest$7(_a, ["noBorder", "errorMessage", "id", "label", "subtitle", "hasErrors", "hideLabel", "message", "className", "isCreatable"]);
  return jsxs("div", { children: [jsx$1(Label, __assign$k({ htmlFor: id, font: "title-6", screenReaderOnly: hideLabel, hasErrors: hasErrors2 }, { children: label })), subtitle2 && jsx$1(Label, __assign$k({ htmlFor: id, font: "body-3", color: "text-secondary" }, { children: subtitle2 })), jsx$1("div", __assign$k({ className: classNames$1("eds-select eds-text-field", className) }, { children: isCreatable ? jsx$1(CreatableSelect, __assign$k({ ref, className: classNames$1("eds-text-field__input eds-text-field--select", {
    "eds-text-field__input--error": hasErrors2,
    "eds-text-field__input--no-border": noBorder2 === true
  }), id, "aria-describedby": "".concat(id, "-meta"), classNamePrefix: "eds-select" }, rest)) : jsx$1(ReactSelect, __assign$k({ ref, className: classNames$1("eds-text-field__input eds-text-field--select", {
    "eds-text-field__input--error": hasErrors2,
    "eds-text-field__input--no-border": noBorder2 === true
  }), id, "aria-describedby": "".concat(id, "-meta"), classNamePrefix: "eds-select" }, rest)) })), (hasErrors2 || message) && jsx$1(InputMessageGroup, { id: "".concat(id, "-meta"), message, errorMessage: hasErrors2 && (errorMessage || "Error") })] });
});
var __assign$j = globalThis && globalThis.__assign || function() {
  __assign$j = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$j.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var __assign$i = globalThis && globalThis.__assign || function() {
  __assign$i = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$i.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var __assign$h = globalThis && globalThis.__assign || function() {
  __assign$h = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$h.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var __assign$g = globalThis && globalThis.__assign || function() {
  __assign$g = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$g.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var __assign$f = globalThis && globalThis.__assign || function() {
  __assign$f = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$f.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var __assign$e = globalThis && globalThis.__assign || function() {
  __assign$e = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$e.apply(this, arguments);
};
var __rest$6 = globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var Spinner = function(_a) {
  var _b = _a.size, size = _b === void 0 ? "medium" : _b, className = _a.className, rest = __rest$6(_a, ["size", "className"]);
  return jsx$1("div", __assign$e({ role: "progressbar", tabIndex: 0, className: classNames$1("eds-spinner", "eds-spinner--".concat(size), className) }, rest));
};
var __assign$d = globalThis && globalThis.__assign || function() {
  __assign$d = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$d.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var __assign$c = globalThis && globalThis.__assign || function() {
  __assign$c = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$c.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var __assign$b = globalThis && globalThis.__assign || function() {
  __assign$b = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$b.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var __assign$a = globalThis && globalThis.__assign || function() {
  __assign$a = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$a.apply(this, arguments);
};
var __rest$5 = globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var Table$1 = function(_a) {
  var _b = _a.isDark, isDark = _b === void 0 ? false : _b, children = _a.children, className = _a.className, rest = __rest$5(_a, ["isDark", "children", "className"]);
  return jsx$1("table", __assign$a({ className: classNames$1("eds-table", { "eds--dark": isDark }, className) }, rest, { children }));
};
var __assign$9 = globalThis && globalThis.__assign || function() {
  __assign$9 = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$9.apply(this, arguments);
};
var __rest$4 = globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var TableCell = function(_a) {
  var children = _a.children, className = _a.className, hasError = _a.hasError, _b = _a.alignment, alignment = _b === void 0 ? "left" : _b, beforeSlot = _a.beforeSlot, afterSlot = _a.afterSlot, rest = __rest$4(_a, ["children", "className", "hasError", "alignment", "beforeSlot", "afterSlot"]);
  return jsx$1("td", __assign$9({ className: classNames$1("eds-table-cell", {
    "eds-table-cell--error": !!hasError,
    "eds-table-cell--right": alignment === "right"
  }, className) }, rest, { children: jsxs("div", __assign$9({ className: "eds-table-cell__content" }, { children: [beforeSlot, children, afterSlot] })) }));
};
var __assign$8 = globalThis && globalThis.__assign || function() {
  __assign$8 = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$8.apply(this, arguments);
};
var __rest$3 = globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var TableHeading = function(_a) {
  var className = _a.className, children = _a.children, rest = __rest$3(_a, ["className", "children"]);
  return jsx$1("th", __assign$8({ className: classNames$1("eds-table-heading", className) }, rest, { children }));
};
var __assign$7 = globalThis && globalThis.__assign || function() {
  __assign$7 = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$7.apply(this, arguments);
};
var __rest$2 = globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
React__default.forwardRef(function(_a, ref) {
  var _b, _c;
  var onChange2 = _a.onChange, value = _a.value, maxChars = _a.maxChars, showCount = _a.showCount, hideLabel = _a.hideLabel, errorMessage = _a.errorMessage, message = _a.message, hasErrors2 = _a.hasErrors, _d = _a.noBorder, noBorder2 = _d === void 0 ? false : _d, id = _a.id, _e = _a.resize, resize = _e === void 0 ? "none" : _e, label = _a.label, subtitle2 = _a.subtitle, autoResize = _a.autoResize, maxRows = _a.maxRows, _f = _a.minRows, minRows = _f === void 0 ? 1 : _f, defaultValue = _a.defaultValue, className = _a.className, rest = __rest$2(_a, ["onChange", "value", "maxChars", "showCount", "hideLabel", "errorMessage", "message", "hasErrors", "noBorder", "id", "resize", "label", "subtitle", "autoResize", "maxRows", "minRows", "defaultValue", "className"]);
  var maxRef = React__default.useRef(null);
  var maxScrollHeight = React__default.useRef(void 0);
  var localRef = React__default.useRef(null);
  var _g = React__default.useState(defaultValue || value), localInputValue = _g[0], setLocalInputValue = _g[1];
  var handleChange = function(e2) {
    setLocalInputValue(e2.target.value);
    if (onChange2) {
      onChange2(e2);
    }
  };
  React__default.useEffect(function() {
    var _a2, _b2;
    localRef.current.style.height = "auto";
    if (autoResize) {
      localRef.current.style.height = "".concat(((_a2 = localRef === null || localRef === void 0 ? void 0 : localRef.current) === null || _a2 === void 0 ? void 0 : _a2.scrollHeight) + 2, "px");
      if (maxRows) {
        if (!(maxScrollHeight === null || maxScrollHeight === void 0 ? void 0 : maxScrollHeight.current) && ((_b2 = maxRef === null || maxRef === void 0 ? void 0 : maxRef.current) === null || _b2 === void 0 ? void 0 : _b2.scrollHeight)) {
          maxScrollHeight.current = maxRef.current.scrollHeight + 2;
        }
        if (maxRef.current.scrollHeight > maxScrollHeight.current) {
          localRef.current.style.height = "".concat(maxScrollHeight.current, "px");
        }
      }
    }
  }, [
    (_b = maxRef === null || maxRef === void 0 ? void 0 : maxRef.current) === null || _b === void 0 ? void 0 : _b.scrollHeight,
    (_c = localRef === null || localRef === void 0 ? void 0 : localRef.current) === null || _c === void 0 ? void 0 : _c.scrollHeight,
    maxRows,
    minRows
  ]);
  React__default.useEffect(function() {
    setLocalInputValue(value);
  }, [value]);
  var valueSpreadMapping = value === void 0 ? { defaultValue } : { value };
  var MaxHeight = function() {
    return jsx$1("textarea", { rows: maxRows, ref: maxRef, style: { position: "absolute", left: -9999 }, className: classNames$1("eds-text-field__input"), value: localInputValue, "aria-hidden": true, readOnly: true });
  };
  return jsxs("div", { children: [jsx$1(Label, __assign$7({ htmlFor: id, font: "title-6", screenReaderOnly: hideLabel, hasErrors: hasErrors2 }, { children: label })), subtitle2 && jsx$1(Label, __assign$7({ htmlFor: id, font: "body-3", color: "text-secondary" }, { children: subtitle2 })), jsxs("div", __assign$7({ className: classNames$1("eds-text-field", {
    "eds-text-field--no-border": noBorder2
  }, className) }, { children: [maxRows && jsx$1(MaxHeight, {}), jsx$1("textarea", __assign$7({ className: classNames$1("eds-text-field__input", {
    "eds-text-field__input--error": hasErrors2,
    "eds-text-field__input--no-border": noBorder2 === true
  }), rows: minRows, id, style: { resize }, ref: function(node2) {
    if (localRef !== null) {
      localRef.current = node2;
    }
    if (ref !== null) {
      ref.current = node2;
    }
  }, onChange: handleChange, "aria-describedby": "".concat(id, "-meta") }, valueSpreadMapping, rest))] })), (hasErrors2 || maxChars || showCount || message) && jsx$1(InputMessageGroup, { id: "".concat(id, "-meta"), message, errorMessage: hasErrors2 && (errorMessage || "Error"), count: showCount ? localInputValue === null || localInputValue === void 0 ? void 0 : localInputValue.toString().length : void 0, maxCount: showCount ? maxChars : void 0 })] });
});
var __assign$6 = globalThis && globalThis.__assign || function() {
  __assign$6 = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$6.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var __assign$5 = globalThis && globalThis.__assign || function() {
  __assign$5 = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$5.apply(this, arguments);
};
var __rest$1 = globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var TextField = React__default.forwardRef(function(_a, ref) {
  var beforeSlot = _a.beforeSlot, afterSlot = _a.afterSlot, _b = _a.noBorder, noBorder2 = _b === void 0 ? false : _b, onChange2 = _a.onChange, value = _a.value, maxChars = _a.maxChars, errorMessage = _a.errorMessage, id = _a.id, style = _a.style, label = _a.label, subtitle2 = _a.subtitle, hasErrors2 = _a.hasErrors, _c = _a.hideLabel, hideLabel = _c === void 0 ? false : _c, message = _a.message, _d = _a.readOnlyText, readOnlyText = _d === void 0 ? "Read-only" : _d, _e = _a.type, type = _e === void 0 ? "text" : _e, readOnly = _a.readOnly, className = _a.className, defaultValue = _a.defaultValue, rest = __rest$1(_a, ["beforeSlot", "afterSlot", "noBorder", "onChange", "value", "maxChars", "errorMessage", "id", "style", "label", "subtitle", "hasErrors", "hideLabel", "message", "readOnlyText", "type", "readOnly", "className", "defaultValue"]);
  var _f = React__default.useState(defaultValue || value), localInputValue = _f[0], setLocalInputValue = _f[1];
  var handleChange = function(e2) {
    setLocalInputValue(e2.target.value);
    if (onChange2) {
      onChange2(e2);
    }
  };
  React__default.useEffect(function() {
    setLocalInputValue(value);
  }, [value]);
  var _g = React__default.useState(0), beforeSlotWidth = _g[0], setBeforeSlotWidth = _g[1];
  var _h = React__default.useState(0), afterSlotWidth = _h[0], setAfterSlotWidth = _h[1];
  var beforeSlotOffset = beforeSlotWidth ? 24 : 16;
  var afterSlotOffset = afterSlotWidth ? 24 : 16;
  var paddingLeft = beforeSlotWidth ? beforeSlotWidth + beforeSlotOffset : beforeSlotOffset;
  var paddingRight = afterSlotWidth ? afterSlotWidth + afterSlotOffset : afterSlotOffset;
  var valueSpreadMapping = value === void 0 ? { defaultValue } : { value };
  return jsxs("div", { children: [jsx$1(Label, __assign$5({ htmlFor: id, font: "title-6", screenReaderOnly: hideLabel, hasErrors: hasErrors2 }, { children: label })), subtitle2 && jsx$1(Label, __assign$5({ htmlFor: id, font: "body-3", color: "text-secondary" }, { children: subtitle2 })), jsxs("div", __assign$5({ className: classNames$1("eds-text-field", className) }, { children: [beforeSlot && jsx$1("div", __assign$5({ className: "eds-text-field__before", ref: function(el) {
    return setBeforeSlotWidth(el === null || el === void 0 ? void 0 : el.getBoundingClientRect().width);
  } }, { children: beforeSlot })), jsx$1("input", __assign$5({ className: classNames$1("eds-text-field__input", {
    "eds-text-field__input--error": hasErrors2,
    "eds-text-field__input--no-border": noBorder2 === true
  }), style: __assign$5({ paddingLeft, paddingRight }, style), ref, onChange: handleChange, id, type, "aria-describedby": "".concat(id, "-meta"), readOnly }, valueSpreadMapping, rest)), afterSlot && jsx$1("div", __assign$5({ className: "eds-text-field__after", ref: function(el) {
    return setAfterSlotWidth(el === null || el === void 0 ? void 0 : el.getBoundingClientRect().width);
  } }, { children: afterSlot }))] })), (readOnly || hasErrors2 || maxChars || message) && jsx$1(InputMessageGroup, { id: "".concat(id, "-meta"), message: readOnly && !message ? readOnlyText : message, errorMessage: hasErrors2 && (errorMessage || "Error"), count: maxChars ? (localInputValue === null || localInputValue === void 0 ? void 0 : localInputValue.toString().length) || 0 : void 0, maxCount: maxChars })] });
});
var __assign$4 = globalThis && globalThis.__assign || function() {
  __assign$4 = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$4.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var __assign$3 = globalThis && globalThis.__assign || function() {
  __assign$3 = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$3.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
React__default.createContext(null);
var __assign$2 = globalThis && globalThis.__assign || function() {
  __assign$2 = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$2.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var __assign$1 = globalThis && globalThis.__assign || function() {
  __assign$1 = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign$1.apply(this, arguments);
};
var __rest = globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
var __spreadArray = globalThis && globalThis.__spreadArray || function(to, from2, pack) {
  if (pack || arguments.length === 2)
    for (var i2 = 0, l2 = from2.length, ar; i2 < l2; i2++) {
      if (ar || !(i2 in from2)) {
        if (!ar)
          ar = Array.prototype.slice.call(from2, 0, i2);
        ar[i2] = from2[i2];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from2));
};
var Tooltip = function(_a) {
  var children = _a.children, className = _a.className, isDark = _a.isDark, bodySlot = _a.bodySlot, modifiers = _a.modifiers, enableFocus = _a.enableFocus, _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, _c = _a.label, label = _c === void 0 ? "Tooltip" : _c, _d = _a.delay, delay3 = _d === void 0 ? 400 : _d, _e = _a.placement, placement = _e === void 0 ? "bottom" : _e, _f = _a.strategy, strategy = _f === void 0 ? "absolute" : _f, id = _a.id, rest = __rest(_a, ["children", "className", "isDark", "bodySlot", "modifiers", "enableFocus", "isOpen", "label", "delay", "placement", "strategy", "id"]);
  var timeout;
  var _g = useState(null), tooltipElement = _g[0], setTooltipElement = _g[1];
  var _h = useState(null), referenceElement = _h[0], setReferenceElement = _h[1];
  var _j = useState(null), arrowElement = _j[0], setArrowElement = _j[1];
  var _k = useState(false), displayTooltip = _k[0], setDisplayTooltip = _k[1];
  var tooltipId = useState(id || "eds-tooltip--".concat(nanoid(10)))[0];
  var showTooltip = function() {
    timeout = setTimeout(function() {
      setDisplayTooltip(true);
    }, delay3);
  };
  var hideTooltip = function() {
    clearInterval(timeout);
    setDisplayTooltip(false);
  };
  var _l = usePopper(referenceElement, tooltipElement, {
    placement,
    strategy,
    modifiers: __spreadArray([
      {
        name: "offset",
        options: {
          offset: [0, 8]
        }
      },
      {
        name: "flip",
        options: {
          fallbackPlacements: ["bottom", "top"]
        }
      },
      { name: "arrow", options: { element: arrowElement, padding: 8 } }
    ], modifiers !== null && modifiers !== void 0 ? modifiers : [], true)
  }), styles2 = _l.styles, attributes = _l.attributes;
  useEffect(function() {
    document.addEventListener("keydown", function(e2) {
      if (e2.key === "Escape") {
        setDisplayTooltip(false);
      }
    });
    return function() {
      document.removeEventListener("keydown", function(e2) {
        return e2;
      });
    };
  }, [displayTooltip]);
  var tootlipClasses = classNames$1("eds-tooltip", isDark ? "eds--dark" : "eds--light", className);
  var tabIndexProps = enableFocus ? { tabIndex: 0 } : {};
  return jsxs(Fragment, { children: [jsx$1("span", __assign$1({ className: "eds-tooltip__anchor", "aria-describedby": "edsTooltip", "aria-label": label }, tabIndexProps, { ref: setReferenceElement, onMouseEnter: showTooltip, onMouseLeave: hideTooltip, onFocus: showTooltip, onBlur: hideTooltip }, { children: React__default.cloneElement(children, {
    "aria-controls": tooltipId,
    "aria-haspopup": "dialog",
    "aria-expanded": displayTooltip || isOpen ? "true" : "false"
  }) })), (isOpen || displayTooltip) && jsxs("div", __assign$1({ id: tooltipId, className: tootlipClasses, role: "tooltip", ref: setTooltipElement, style: styles2.popper }, attributes.popper, rest, { children: [jsx$1("div", __assign$1({ className: "eds-tooltip__body", "aria-live": "polite" }, { children: typeof bodySlot === "string" ? jsx$1(Text$2, __assign$1({ as: "p", font: "body-3" }, { children: bodySlot })) : bodySlot })), jsx$1("div", __assign$1({ className: "eds-tooltip__arrow", ref: setArrowElement, style: styles2.arrow }, attributes.arrow))] }))] });
};
var __assign = globalThis && globalThis.__assign || function() {
  __assign = Object.assign || function(t2) {
    for (var s, i2 = 1, n2 = arguments.length; i2 < n2; i2++) {
      s = arguments[i2];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign.apply(this, arguments);
};
globalThis && globalThis.__rest || function(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p2 = Object.getOwnPropertySymbols(s); i2 < p2.length; i2++) {
      if (e2.indexOf(p2[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p2[i2]))
        t2[p2[i2]] = s[p2[i2]];
    }
  return t2;
};
globalThis && globalThis.__spreadArray || function(to, from2, pack) {
  if (pack || arguments.length === 2)
    for (var i2 = 0, l2 = from2.length, ar; i2 < l2; i2++) {
      if (ar || !(i2 in from2)) {
        if (!ar)
          ar = Array.prototype.slice.call(from2, 0, i2);
        ar[i2] = from2[i2];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from2));
};
const icon$e = "epic__icon__709";
const ripple$e = "epic__ripple__59f";
const button$2 = "epic__button__202";
const buttonActive = "epic__buttonActive__807";
const tooltipContainer = "epic__tooltipContainer__fea";
const tooltipContent = "epic__tooltipContent__1f0";
const tooltipLink = "epic__tooltipLink__655";
const chipsList = "epic__chipsList__1e9";
const chipsListItem = "epic__chipsListItem__6b5";
var styles$d = {
  icon: icon$e,
  "epic-icon": "epic__epic-icon__7ba",
  "epic-icon-add": "epic__epic-icon-add__8bc",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__26b",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__efa",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__ef7",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__820",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__22e",
  "epic-icon-calendar": "epic__epic-icon-calendar__794",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__fb4",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__a3f",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__d33",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__cd8",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__1e9",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__f09",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__2c6",
  "epic-icon-close-x": "epic__epic-icon-close-x__4b3",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__214",
  "epic-icon-confluence": "epic__epic-icon-confluence__d48",
  "epic-icon-contact": "epic__epic-icon-contact__e70",
  "epic-icon-delete": "epic__epic-icon-delete__031",
  "epic-icon-edit": "epic__epic-icon-edit__f3c",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__d56",
  "epic-icon-filter": "epic__epic-icon-filter__92f",
  "epic-icon-github": "epic__epic-icon-github__1d5",
  "epic-icon-information": "epic__epic-icon-information__521",
  "epic-icon-jira": "epic__epic-icon-jira__220",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__ebb",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__4c8",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__f1b",
  "epic-icon-preview": "epic__epic-icon-preview__c00",
  "epic-icon-profile": "epic__epic-icon-profile__f4f",
  "epic-icon-quotes": "epic__epic-icon-quotes__fa0",
  "epic-icon-search": "epic__epic-icon-search__95a",
  "epic-icon-share": "epic__epic-icon-share__13c",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__0f9",
  "epic-icon-slack": "epic__epic-icon-slack__65a",
  "epic-icon-steps": "epic__epic-icon-steps__0c1",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__f90",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__dee",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__def",
  "epic-icon-warning": "epic__epic-icon-warning__f63",
  "epic-font-base": "epic__epic-font-base__b03",
  "epic-font-base-md": "epic__epic-font-base-md__612",
  "epic-font-marketing": "epic__epic-font-marketing__d42",
  "epic-font-brand": "epic__epic-font-brand__c8f",
  ripple: ripple$e,
  button: button$2,
  buttonActive,
  tooltipContainer,
  tooltipContent,
  tooltipLink,
  chipsList,
  chipsListItem
};
const Button = ({
  label,
  isActive,
  onChipClick
}) => /* @__PURE__ */ jsx$1("button", {
  type: "button",
  className: classnames$2(styles$d.button, {
    [styles$d.buttonActive]: isActive
  }),
  onClick: () => onChipClick(label),
  children: label
});
const Chip = ({
  label,
  onChipClick,
  isActive,
  tooltip
}) => {
  const chip = /* @__PURE__ */ jsx$1(Button, {
    label,
    onChipClick,
    isActive
  });
  if (tooltip)
    return /* @__PURE__ */ jsx$1(Tooltip, {
      ...tooltip,
      children: chip
    });
  return chip;
};
function Chips({
  chips,
  activeItems,
  onChipClick
}) {
  return /* @__PURE__ */ jsx$1("ul", {
    className: styles$d.chipsList,
    children: chips.map((chip) => {
      const isActive = activeItems.includes(chip.label);
      return /* @__PURE__ */ jsx$1("li", {
        className: styles$d.chipsListItem,
        children: /* @__PURE__ */ jsx$1(Chip, {
          label: chip.label,
          onChipClick,
          tooltip: chip.tooltip,
          isActive
        })
      }, chip.label);
    })
  });
}
Chips.propTypes = {
  chips: PropTypes$1.arrayOf(PropTypes$1.shape({
    label: PropTypes$1.string.isRequired,
    tooltip: PropTypes$1.shape({
      content: PropTypes$1.string,
      link: PropTypes$1.string,
      linkDescription: PropTypes$1.string
    })
  })).isRequired,
  onChipClick: PropTypes$1.func,
  activeItems: PropTypes$1.arrayOf(PropTypes$1.string).isRequired,
  tooltipProps: PropTypes$1.object
};
Chips.defaultProps = {
  chips: [],
  activeItems: []
};
Chip.propTypes = {
  label: PropTypes$1.string.isRequired,
  onChipClick: PropTypes$1.func,
  tooltip: PropTypes$1.shape({
    bodySlot: PropTypes$1.string,
    placement: PropTypes$1.string,
    enableFocus: PropTypes$1.bool
  }),
  isActive: PropTypes$1.bool
};
Button.propTypes = {
  onChipClick: PropTypes$1.func,
  label: PropTypes$1.string,
  isActive: PropTypes$1.bool
};
const icon$d = "epic__icon__e5d";
const ripple$d = "epic__ripple__c84";
const title$3 = "epic__title__2fc";
const subtitle$2 = "epic__subtitle__81b";
const trigger = "epic__trigger__f8e";
const triggerIcon = "epic__triggerIcon__422";
const collapsibleInner = "epic__collapsibleInner__592";
var styles$c = {
  icon: icon$d,
  "epic-icon": "epic__epic-icon__6d6",
  "epic-icon-add": "epic__epic-icon-add__8a2",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__0d4",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__426",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__57d",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__e6b",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__311",
  "epic-icon-calendar": "epic__epic-icon-calendar__e2b",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__2c6",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__501",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__dff",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__72e",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__caf",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__c19",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__8e2",
  "epic-icon-close-x": "epic__epic-icon-close-x__855",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__062",
  "epic-icon-confluence": "epic__epic-icon-confluence__188",
  "epic-icon-contact": "epic__epic-icon-contact__e23",
  "epic-icon-delete": "epic__epic-icon-delete__11f",
  "epic-icon-edit": "epic__epic-icon-edit__235",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__c12",
  "epic-icon-filter": "epic__epic-icon-filter__ebf",
  "epic-icon-github": "epic__epic-icon-github__5fe",
  "epic-icon-information": "epic__epic-icon-information__2d8",
  "epic-icon-jira": "epic__epic-icon-jira__155",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__6da",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__278",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__ed5",
  "epic-icon-preview": "epic__epic-icon-preview__e80",
  "epic-icon-profile": "epic__epic-icon-profile__411",
  "epic-icon-quotes": "epic__epic-icon-quotes__58e",
  "epic-icon-search": "epic__epic-icon-search__dc4",
  "epic-icon-share": "epic__epic-icon-share__a09",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__c96",
  "epic-icon-slack": "epic__epic-icon-slack__91a",
  "epic-icon-steps": "epic__epic-icon-steps__1c4",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__e9e",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__d95",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__e5e",
  "epic-icon-warning": "epic__epic-icon-warning__327",
  "epic-font-base": "epic__epic-font-base__9cb",
  "epic-font-base-md": "epic__epic-font-base-md__e8e",
  "epic-font-marketing": "epic__epic-font-marketing__a3b",
  "epic-font-brand": "epic__epic-font-brand__e36",
  ripple: ripple$d,
  "epic-display-base": "epic__epic-display-base__a20",
  "epic-display-1": "epic__epic-display-1__583",
  "epic-display-2": "epic__epic-display-2__b73",
  "epic-display-3": "epic__epic-display-3__8fd",
  "epic-display-4": "epic__epic-display-4__113",
  "epic-display-5": "epic__epic-display-5__8b6",
  "epic-title-base": "epic__epic-title-base__1d3",
  "epic-title-1": "epic__epic-title-1__352",
  "epic-title-2": "epic__epic-title-2__a1b",
  "epic-title-3": "epic__epic-title-3__48e",
  "epic-title-4": "epic__epic-title-4__9b6",
  "epic-title-5": "epic__epic-title-5__5f3",
  "epic-title-6": "epic__epic-title-6__2cd",
  title: title$3,
  "epic-subtitle-base": "epic__epic-subtitle-base__c3b",
  "epic-subtitle-1": "epic__epic-subtitle-1__721",
  "epic-subtitle-2": "epic__epic-subtitle-2__70e",
  "epic-subtitle-3": "epic__epic-subtitle-3__678",
  "epic-body-text-base": "epic__epic-body-text-base__e21",
  "epic-body-text-1": "epic__epic-body-text-1__7d7",
  "epic-body-text-2": "epic__epic-body-text-2__a51",
  "epic-body-text": "epic__epic-body-text__4c9",
  "epic-body-text-3": "epic__epic-body-text-3__e73",
  subtitle: subtitle$2,
  "epic-legal-text": "epic__epic-legal-text__d23",
  "epic-label-text": "epic__epic-label-text__3d6",
  "epic-button-base": "epic__epic-button-base__d70",
  "epic-button-1": "epic__epic-button-1__ab3",
  "epic-button-2": "epic__epic-button-2__a34",
  "epic-button-3": "epic__epic-button-3__bb0",
  trigger,
  triggerIcon,
  collapsibleInner
};
const setInTransition = (innerRefScrollHeight) => innerRefScrollHeight !== 0;
class ReactCollapsible extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "continueOpenCollapsible", () => {
      const {
        innerRef
      } = this;
      this.setState({
        height: innerRef.scrollHeight,
        transition: `height ${this.props.transitionTime}ms ${this.props.easing}`,
        isClosed: false,
        hasBeenOpened: true,
        inTransition: setInTransition(innerRef.scrollHeight),
        shouldOpenOnNextCycle: false
      });
    });
    __publicField(this, "handleTriggerClick", (event) => {
      if (this.props.triggerDisabled || this.state.inTransition) {
        return;
      }
      event.preventDefault();
      if (this.props.handleTriggerClick) {
        this.props.handleTriggerClick(this.props.accordionPosition);
      } else {
        if (this.state.isClosed === true) {
          this.openCollapsible();
          this.props.onOpening();
          this.props.onTriggerOpening();
        } else {
          this.closeCollapsible();
          this.props.onClosing();
          this.props.onTriggerClosing();
        }
      }
    });
    __publicField(this, "handleTransitionEnd", (e2) => {
      if (e2.target !== this.innerRef) {
        return;
      }
      if (!this.state.isClosed) {
        this.setState({
          height: "auto",
          overflow: this.props.overflowWhenOpen,
          inTransition: false
        });
        this.props.onOpen();
      } else {
        this.setState({
          inTransition: false
        });
        this.props.onClose();
      }
    });
    __publicField(this, "setInnerRef", (ref) => this.innerRef = ref);
    this.timeout = void 0;
    this.contentId = props.contentElementId || `collapsible-content-${Date.now()}`;
    this.triggerId = props.triggerElementProps.id || `collapsible-trigger-${Date.now()}`;
    if (props.open) {
      this.state = {
        isClosed: false,
        shouldSwitchAutoOnNextCycle: false,
        height: "auto",
        transition: "none",
        hasBeenOpened: true,
        overflow: props.overflowWhenOpen,
        inTransition: false
      };
    } else {
      this.state = {
        isClosed: true,
        shouldSwitchAutoOnNextCycle: false,
        height: 0,
        transition: `height ${props.transitionTime}ms ${props.easing}`,
        hasBeenOpened: false,
        overflow: "hidden",
        inTransition: false
      };
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.shouldOpenOnNextCycle) {
      this.continueOpenCollapsible();
    }
    if ((prevState.height === "auto" || prevState.height === 0) && this.state.shouldSwitchAutoOnNextCycle === true) {
      window.clearTimeout(this.timeout);
      this.timeout = window.setTimeout(() => {
        this.setState({
          height: 0,
          overflow: "hidden",
          isClosed: true,
          shouldSwitchAutoOnNextCycle: false
        });
      }, 50);
    }
    if (prevProps.open !== this.props.open) {
      if (this.props.open === true) {
        this.openCollapsible();
        this.props.onOpening();
      } else {
        this.closeCollapsible();
        this.props.onClosing();
      }
    }
  }
  componentWillUnmount() {
    window.clearTimeout(this.timeout);
  }
  closeCollapsible() {
    const {
      innerRef
    } = this;
    this.setState({
      shouldSwitchAutoOnNextCycle: true,
      height: innerRef.scrollHeight,
      transition: `height ${this.props.transitionCloseTime ? this.props.transitionCloseTime : this.props.transitionTime}ms ${this.props.easing}`,
      inTransition: setInTransition(innerRef.scrollHeight)
    });
  }
  openCollapsible() {
    this.setState({
      inTransition: setInTransition(this.innerRef.scrollHeight),
      shouldOpenOnNextCycle: true
    });
  }
  renderNonClickableTriggerElement() {
    const {
      triggerSibling,
      classParentString
    } = this.props;
    if (!triggerSibling)
      return null;
    const triggerSiblingType = typeof triggerSibling;
    switch (triggerSiblingType) {
      case "string":
        return /* @__PURE__ */ jsx$1("span", {
          className: `${classParentString}__trigger-sibling`,
          children: triggerSibling
        });
      case "function":
        return triggerSibling();
      case "object":
        return triggerSibling;
      default:
        return null;
    }
  }
  render() {
    const dropdownStyle = {
      height: this.state.height,
      WebkitTransition: this.state.transition,
      msTransition: this.state.transition,
      transition: this.state.transition,
      overflow: this.state.overflow
    };
    var openClass = this.state.isClosed ? "is-closed" : "is-open";
    var disabledClass = this.props.triggerDisabled ? "is-disabled" : "";
    var trigger2 = this.state.isClosed === false && this.props.triggerWhenOpen !== void 0 ? this.props.triggerWhenOpen : this.props.trigger;
    const ContentContainerElement = this.props.contentContainerTagName;
    const TriggerElement = this.props.triggerTagName;
    var children = this.props.lazyRender && !this.state.hasBeenOpened && this.state.isClosed && !this.state.inTransition ? null : this.props.children;
    const {
      classParentString,
      contentOuterClassName,
      contentInnerClassName
    } = this.props;
    const triggerClassString = `${classParentString}__trigger ${openClass} ${disabledClass} ${this.state.isClosed ? this.props.triggerClassName : this.props.triggerOpenedClassName}`;
    const parentClassString = `${classParentString} ${this.state.isClosed ? this.props.className : this.props.openedClassName}`;
    const outerClassString = `${classParentString}__contentOuter ${contentOuterClassName}`;
    const innerClassString = `${classParentString}__contentInner ${contentInnerClassName}`;
    return /* @__PURE__ */ jsxs(ContentContainerElement, {
      className: parentClassString.trim(),
      ...this.props.containerElementProps,
      children: [/* @__PURE__ */ jsx$1(TriggerElement, {
        id: this.triggerId,
        className: triggerClassString.trim(),
        onClick: this.handleTriggerClick,
        style: this.props.triggerStyle && this.props.triggerStyle,
        onKeyPress: (event) => {
          const {
            key
          } = event;
          if (key === " " && this.props.triggerTagName.toLowerCase() !== "button" || key === "Enter") {
            this.handleTriggerClick(event);
          }
        },
        tabIndex: this.props.tabIndex && this.props.tabIndex,
        "aria-expanded": !this.state.isClosed,
        "aria-disabled": this.props.triggerDisabled,
        "aria-controls": this.contentId,
        role: "button",
        ...this.props.triggerElementProps,
        children: trigger2
      }), this.renderNonClickableTriggerElement(), /* @__PURE__ */ jsx$1("div", {
        id: this.contentId,
        className: outerClassString.trim(),
        style: dropdownStyle,
        onTransitionEnd: this.handleTransitionEnd,
        ref: this.setInnerRef,
        hidden: this.props.contentHiddenWhenClosed && this.state.isClosed && !this.state.inTransition,
        role: "region",
        "aria-labelledby": this.triggerId,
        children: /* @__PURE__ */ jsx$1("div", {
          className: innerClassString.trim(),
          children
        })
      })]
    });
  }
}
ReactCollapsible.propTypes = {
  transitionTime: PropTypes$1.number,
  transitionCloseTime: PropTypes$1.number,
  triggerTagName: PropTypes$1.string,
  easing: PropTypes$1.string,
  open: PropTypes$1.bool,
  containerElementProps: PropTypes$1.object,
  triggerElementProps: PropTypes$1.object,
  contentElementId: PropTypes$1.string,
  classParentString: PropTypes$1.string,
  className: PropTypes$1.string,
  openedClassName: PropTypes$1.string,
  triggerStyle: PropTypes$1.object,
  triggerClassName: PropTypes$1.string,
  triggerOpenedClassName: PropTypes$1.string,
  contentOuterClassName: PropTypes$1.string,
  contentInnerClassName: PropTypes$1.string,
  accordionPosition: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number]),
  handleTriggerClick: PropTypes$1.func,
  onOpen: PropTypes$1.func,
  onClose: PropTypes$1.func,
  onOpening: PropTypes$1.func,
  onClosing: PropTypes$1.func,
  onTriggerOpening: PropTypes$1.func,
  onTriggerClosing: PropTypes$1.func,
  trigger: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.element]),
  triggerWhenOpen: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.element]),
  triggerDisabled: PropTypes$1.bool,
  lazyRender: PropTypes$1.bool,
  overflowWhenOpen: PropTypes$1.oneOf(["hidden", "visible", "auto", "scroll", "inherit", "initial", "unset"]),
  contentHiddenWhenClosed: PropTypes$1.bool,
  triggerSibling: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.element, PropTypes$1.func]),
  tabIndex: PropTypes$1.number,
  contentContainerTagName: PropTypes$1.string,
  children: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.element])
};
ReactCollapsible.defaultProps = {
  transitionTime: 400,
  transitionCloseTime: null,
  triggerTagName: "span",
  easing: "linear",
  open: false,
  classParentString: "Collapsible",
  triggerDisabled: false,
  lazyRender: false,
  overflowWhenOpen: "hidden",
  contentHiddenWhenClosed: false,
  openedClassName: "",
  triggerStyle: null,
  triggerClassName: "",
  triggerOpenedClassName: "",
  contentOuterClassName: "",
  contentInnerClassName: "",
  className: "",
  triggerSibling: null,
  onOpen: () => {
  },
  onClose: () => {
  },
  onOpening: () => {
  },
  onClosing: () => {
  },
  onTriggerOpening: () => {
  },
  onTriggerClosing: () => {
  },
  tabIndex: null,
  contentContainerTagName: "div",
  triggerElementProps: {}
};
const Trigger = ({
  isOpen,
  title: title2,
  subtitle: subtitle2
}) => /* @__PURE__ */ jsxs("div", {
  className: styles$c.trigger,
  children: [/* @__PURE__ */ jsx$1("div", {
    className: styles$c.triggerIcon,
    children: /* @__PURE__ */ jsx$1(Icon, {
      type: isOpen ? "CaretUp" : "CaretDown",
      size: "m"
    })
  }), /* @__PURE__ */ jsxs("div", {
    children: [/* @__PURE__ */ jsx$1("div", {
      className: styles$c.title,
      children: /* @__PURE__ */ jsx$1("span", {
        children: title2
      })
    }), subtitle2 && /* @__PURE__ */ jsx$1("div", {
      className: styles$c.subtitle,
      children: /* @__PURE__ */ jsx$1("span", {
        children: subtitle2
      })
    })]
  })]
});
function Collapsible({
  className,
  innerClassName,
  title: title2,
  subtitle: subtitle2,
  transitionTime,
  children,
  isOpen
}) {
  return /* @__PURE__ */ jsx$1(ReactCollapsible, {
    className,
    openedClassName: className,
    transitionTime,
    open: isOpen,
    triggerWhenOpen: /* @__PURE__ */ jsx$1(Trigger, {
      title: title2,
      subtitle: subtitle2,
      isOpen: true
    }),
    trigger: /* @__PURE__ */ jsx$1(Trigger, {
      title: title2,
      subtitle: subtitle2
    }),
    children: /* @__PURE__ */ jsx$1("div", {
      className: classnames$2(styles$c.collapsibleInner, innerClassName),
      children
    })
  });
}
Collapsible.propTypes = {
  className: PropTypes$1.string,
  innerClassName: PropTypes$1.string,
  title: PropTypes$1.string.isRequired,
  subtitle: PropTypes$1.string,
  transitionTime: PropTypes$1.number,
  isOpen: PropTypes$1.bool
};
Collapsible.defaultProps = {
  className: "",
  innerClassName: "",
  title: "",
  subtitle: null,
  transitionTime: 50,
  isOpen: false
};
const icon$c = "epic__icon__824";
const ripple$c = "epic__ripple__6a7";
const epFavorites = "epic__epFavorites__db8";
const favoritesIcon = "epic__favoritesIcon__9cb";
var styles$b = {
  icon: icon$c,
  "epic-icon": "epic__epic-icon__d1e",
  "epic-icon-add": "epic__epic-icon-add__222",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__c45",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__4d9",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__2a1",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__51a",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__51f",
  "epic-icon-calendar": "epic__epic-icon-calendar__b3e",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__71d",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__a67",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__5a6",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__9bf",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__0d0",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__602",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__a21",
  "epic-icon-close-x": "epic__epic-icon-close-x__b3c",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__f79",
  "epic-icon-confluence": "epic__epic-icon-confluence__049",
  "epic-icon-contact": "epic__epic-icon-contact__020",
  "epic-icon-delete": "epic__epic-icon-delete__244",
  "epic-icon-edit": "epic__epic-icon-edit__992",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__a04",
  "epic-icon-filter": "epic__epic-icon-filter__d4d",
  "epic-icon-github": "epic__epic-icon-github__02d",
  "epic-icon-information": "epic__epic-icon-information__184",
  "epic-icon-jira": "epic__epic-icon-jira__205",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__8a1",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__0b1",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__20a",
  "epic-icon-preview": "epic__epic-icon-preview__abb",
  "epic-icon-profile": "epic__epic-icon-profile__9da",
  "epic-icon-quotes": "epic__epic-icon-quotes__c33",
  "epic-icon-search": "epic__epic-icon-search__ad9",
  "epic-icon-share": "epic__epic-icon-share__ab1",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__099",
  "epic-icon-slack": "epic__epic-icon-slack__bf5",
  "epic-icon-steps": "epic__epic-icon-steps__310",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__d81",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__f2b",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__45f",
  "epic-icon-warning": "epic__epic-icon-warning__7b6",
  "epic-font-base": "epic__epic-font-base__70e",
  "epic-font-base-md": "epic__epic-font-base-md__9ef",
  "epic-font-marketing": "epic__epic-font-marketing__9b4",
  "epic-font-brand": "epic__epic-font-brand__9e8",
  ripple: ripple$c,
  epFavorites,
  favoritesIcon
};
const Favorites = (props) => {
  const [selected2, setSelected] = useState(false);
  const onClick = () => {
    props.onClick && props.onClick(!selected2);
    props.isInteractive && setSelected(!selected2);
  };
  return /* @__PURE__ */ jsx$1("div", {
    onClick,
    className: classnames$2(styles$b.epFavorites),
    children: /* @__PURE__ */ jsx$1(Icon, {
      type: selected2 ? "FavoriteFilled" : "Favorite",
      size: props.size,
      className: classnames$2(styles$b.favoritesIcon)
    })
  });
};
Favorites.propTypes = {
  onClick: PropTypes$1.func,
  size: PropTypes$1.string,
  isInteractive: PropTypes$1.bool
};
Favorites.defaultProps = {
  size: "s",
  isInteractive: true
};
function EditSmall(props) {
  return /* @__PURE__ */ jsxs("svg", {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [/* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.26429 3.74232H3.92716C2.82132 3.74232 1.92487 4.63878 1.92487 5.74462V12.4189C1.92487 13.5247 2.82132 14.4212 3.92716 14.4212H10.6015C11.7073 14.4212 12.6037 13.5247 12.6037 12.4189V5.74461C12.6037 5.74174 12.6037 5.73887 12.6037 5.736V9.08176H11.6026V12.4189C11.6026 12.9718 11.1544 13.4201 10.6015 13.4201H3.92716C3.37424 13.4201 2.92601 12.9718 2.92601 12.4189V5.74462C2.92601 5.1917 3.37424 4.74347 3.92716 4.74347H7.26429V3.74232Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M8.85589 6.79736L12.7785 2.87472",
      stroke: "currentColor",
      strokeWidth: 1.66857
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M9.21853 7.62467L8.04422 6.45036L7.57685 8.08001L9.21853 7.62467Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx$1("rect", {
      x: 12.8984,
      y: 1.57877,
      width: 1.66405,
      height: 0.667778,
      transform: "rotate(45 12.8984 1.57877)",
      fill: "currentColor"
    })]
  });
}
function EditMedium(props) {
  return /* @__PURE__ */ jsxs("svg", {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [/* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.8982 7.1208H5.89819C5.06977 7.1208 4.39819 7.79238 4.39819 8.6208V18.6208C4.39819 19.4492 5.06977 20.1208 5.89819 20.1208H15.8982C16.7266 20.1208 17.3982 19.4492 17.3982 18.6208V13.6208H18.8982V18.6208C18.8982 20.2777 17.555 21.6208 15.8982 21.6208H5.89819C4.24134 21.6208 2.89819 20.2777 2.89819 18.6208V8.6208C2.89819 6.96395 4.24134 5.6208 5.89819 5.6208H10.8982V7.1208Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M13.2829 10.1981L19.1601 4.3209",
      stroke: "currentColor",
      strokeWidth: 2.5
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M13.8249 11.4367L12.0664 9.67819L11.3665 12.1186L13.8249 11.4367Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx$1("rect", {
      x: 19.3397,
      y: 2.3792,
      width: 2.49192,
      height: 1,
      transform: "rotate(45 19.3397 2.3792)",
      fill: "currentColor"
    })]
  });
}
function EditLarge(props) {
  return /* @__PURE__ */ jsxs("svg", {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [/* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.0252 11.4934L12.0094 11.4934C8.69052 11.4934 6 14.1839 6 17.5028V37.5343C6 40.8532 8.69051 43.5437 12.0094 43.5437H32.0409C35.3598 43.5437 38.0503 40.8532 38.0503 37.5343V27.5186H35.0456V37.5343C35.0456 39.1938 33.7004 40.539 32.0409 40.539H12.0094C10.35 40.539 9.00472 39.1938 9.00472 37.5343V17.5028C9.00472 15.8434 10.35 14.4981 12.0094 14.4981H22.0252V11.4934Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M26.802 20.6624L38.575 8.88943",
      stroke: "currentColor",
      strokeWidth: 5.00786
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M27.8879 23.1436L24.3653 19.621L22.9633 24.5095L27.8879 23.1436Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx$1("rect", {
      x: 38.9348,
      y: 5.00002,
      width: 4.99167,
      height: 2.00315,
      transform: "rotate(45 38.9348 5.00002)",
      fill: "currentColor"
    })]
  });
}
function NewTabSmall(props) {
  return /* @__PURE__ */ jsxs("svg", {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [/* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.04337 5.3913H2.72815C1.62958 5.3913 0.739014 6.28186 0.739014 7.38043V14.0109C0.739014 15.1095 1.62958 16 2.72815 16H9.35861C10.4572 16 11.3477 15.1095 11.3477 14.0109V7.38043C11.3477 7.37807 11.3477 7.3757 11.3477 7.37334V10.6957H10.3477V14.0109C10.3477 14.5572 9.90489 15 9.35861 15H2.72815C2.18187 15 1.73901 14.5572 1.73901 14.0109V7.38043C1.73901 6.83415 2.18187 6.3913 2.72815 6.3913H6.04337V5.3913Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M5.16823 10.8825L12.2009 3.84982",
      stroke: "currentColor"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M12.1835 8.36524L12.1835 3.88966L7.70747 3.88918",
      stroke: "currentColor"
    })]
  });
}
function NewTabMedium(props) {
  return /* @__PURE__ */ jsxs("svg", {
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [/* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.19983 8.50003H3.19983C2.3714 8.50003 1.69983 9.1716 1.69983 10V20C1.69983 20.8285 2.3714 21.5 3.19983 21.5H13.1998C14.0283 21.5 14.6998 20.8285 14.6998 20V15H16.1998V20C16.1998 21.6569 14.8567 23 13.1998 23H3.19983C1.54297 23 0.199829 21.6569 0.199829 20V10C0.199829 8.34318 1.54297 7.00003 3.19983 7.00003H8.19983V8.50003Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M6.87987 15.2819L17.4865 4.67528",
      stroke: "currentColor",
      strokeWidth: 1.5
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M17.4603 11.4854L17.4603 4.73541L10.7096 4.73468",
      stroke: "currentColor",
      strokeWidth: 1.5
    })]
  });
}
function NewTabLarge(props) {
  return /* @__PURE__ */ jsxs("svg", {
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [/* @__PURE__ */ jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 14.1421H6C2.68629 14.1421 0 16.8284 0 20.1421V42.1421C0 45.4558 2.68629 48.1421 6 48.1421H28C31.3137 48.1421 34 45.4558 34 42.1421V31H31V42.1421C31 43.799 29.6569 45.1421 28 45.1421H6C4.34315 45.1421 3 43.799 3 42.1421V20.1421C3 18.4853 4.34315 17.1421 6 17.1421H18V14.1421Z",
      fill: "currentColor"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M17.3483 30.5812L38.5615 9.36802",
      stroke: "currentColor",
      strokeWidth: 3
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M38.5092 22.9883L38.5091 9.48827L25.0077 9.48682",
      stroke: "currentColor",
      strokeWidth: 3
    })]
  });
}
function ShareSmall(props) {
  return /* @__PURE__ */ jsxs("svg", {
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M3.00601 8.67831V12.6783C3.00601 13.507 3.67801 14.1783 4.50601 14.1783H12.506C13.334 14.1783 14.006 13.507 14.006 12.6783V8.67831",
      stroke: "currentColor"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M8.50598 12.6784V2.67838",
      stroke: "currentColor",
      strokeWidth: 1.03448
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M11.6883 5.90102L8.5063 2.71902L5.32364 5.90102",
      stroke: "currentColor"
    })]
  });
}
function ShareMedium(props) {
  return /* @__PURE__ */ jsxs("svg", {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M3.75 13V19C3.75 20.243 4.758 21.25 6 21.25H18C19.242 21.25 20.25 20.243 20.25 19V13",
      stroke: "currentColor",
      strokeWidth: 1.5
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M12 19.0001V4.00006",
      stroke: "currentColor",
      strokeWidth: 1.55172
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M16.7734 8.83403L12.0004 4.06104L7.22644 8.83403",
      stroke: "currentColor",
      strokeWidth: 1.5
    })]
  });
}
function ShareLarge(props) {
  return /* @__PURE__ */ jsxs("svg", {
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M7.5 26.4225V38.4225C7.5 40.9085 9.516 42.9225 12 42.9225H36C38.484 42.9225 40.5 40.9085 40.5 38.4225V26.4225",
      stroke: "currentColor",
      strokeWidth: 3
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M24.0001 38.4225V8.42255",
      stroke: "currentColor",
      strokeWidth: 3.10345
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M33.5469 18.0904L24.0009 8.54449L14.4529 18.0904",
      stroke: "currentColor",
      strokeWidth: 3
    })]
  });
}
function SortAscending$4(props) {
  return /* @__PURE__ */ jsxs("svg", {
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M12 14.25H3",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M7.5 9.75H3",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M16.5 18.75H3",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M13.5 9.29008L17.21 5.58008L20.92 9.29008",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M17.25 15V6",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    })]
  });
}
function SortAscending$3(props) {
  return /* @__PURE__ */ jsxs("svg", {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M12 14.25H3",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M7.5 9.75H3",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M16.5 18.75H3",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M13.5 9.29008L17.21 5.58008L20.92 9.29008",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M17.25 15V6",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    })]
  });
}
function SortAscending$2(props) {
  return /* @__PURE__ */ jsxs("svg", {
    width: 48,
    height: 48,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M12 14.25H3",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M7.5 9.75H3",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M16.5 18.75H3",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M13.5 9.29008L17.21 5.58008L20.92 9.29008",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M17.25 15V6",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    })]
  });
}
function SortDescending$4(props) {
  return /* @__PURE__ */ jsxs("svg", {
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M12.0098 9.75H3.00977",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M7.50977 14.25H3.00977",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M16.5098 5.25H3.00977",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M17.2598 9V18",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M20.9708 14.73L17.2608 18.44L13.5508 14.73",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    })]
  });
}
function SortDescending$3(props) {
  return /* @__PURE__ */ jsxs("svg", {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M12.0098 9.75H3.00977",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M7.50977 14.25H3.00977",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M16.5098 5.25H3.00977",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M17.2598 9V18",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M20.9708 14.73L17.2608 18.44L13.5508 14.73",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    })]
  });
}
function SortDescending$2(props) {
  return /* @__PURE__ */ jsxs("svg", {
    width: 48,
    height: 48,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [/* @__PURE__ */ jsx$1("path", {
      d: "M12.0098 9.75H3.00977",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M7.50977 14.25H3.00977",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M16.5098 5.25H3.00977",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M17.2598 9V18",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    }), /* @__PURE__ */ jsx$1("path", {
      d: "M20.9708 14.73L17.2608 18.44L13.5508 14.73",
      stroke: "#111111",
      strokeWidth: "1.5",
      strokeMiterlimit: "10"
    })]
  });
}
var CXIcons = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EditSmall,
  EditMedium,
  EditLarge,
  NewTabSmall,
  NewTabMedium,
  NewTabLarge,
  ShareSmall,
  ShareMedium,
  ShareLarge,
  SortAscendingSmall: SortAscending$4,
  SortAscendingMedium: SortAscending$3,
  SortAscendingLarge: SortAscending$2,
  SortDescendingSmall: SortDescending$4,
  SortDescendingMedium: SortDescending$3,
  SortDescendingLarge: SortDescending$2
}, Symbol.toStringTag, { value: "Module" }));
const sizes$1 = {
  s: "Small",
  m: "Medium",
  l: "Large"
};
function CXIcon({
  type,
  size,
  ...props
}) {
  if (!type)
    return null;
  const compName = `${type}${sizes$1[size]}`;
  const IconComponent = CXIcons[compName];
  if (!IconComponent)
    return null;
  return /* @__PURE__ */ jsx$1(IconComponent, {
    type,
    size,
    ...props
  });
}
const CXTypes = ["Edit", "NewTab", "Share", "SortAscending", "SortDescending"];
CXIcon.propTypes = {
  className: PropTypes$1.string,
  type: PropTypes$1.oneOf(CXTypes).isRequired,
  size: PropTypes$1.oneOf(["s", "m", "l"])
};
CXIcon.defaultProps = {
  size: "m"
};
const nike = {
  colorContentPrimary: "#111111",
  colorContentPrimaryInverse: "#ffffff",
  colorContentSecondary: "#757575",
  colorContentSecondaryInverse: "#cccccc",
  colorContentFocus: "#111111",
  colorContentActive: "#111111",
  colorContentDisabled: "#cccccc",
  colorContentError: "#d43f21",
  colorContentSuccess: "#128a09",
  colorBackgroundPrimary: "#ffffff",
  colorBackgroundAlwaysDark: "#111111",
  colorBackgroundAlwaysLight: "#ffffff",
  colorBorderBase: "#cccccc",
  colorBorderFocus: "#111111",
  colorBorderActive: "#111111",
  colorBorderDisabled: "#e5e5e5",
  colorBorderError: "#d43f21",
  colorFocusRing: "#f5f5f5",
  buttonBorderRadius: "30px",
  buttonBorderWidth: "1.5px",
  buttonBoxShadowWidth: "0",
  buttonBoxShadowHoverWidth: "0",
  buttonPaddingTopS: "4.5px",
  buttonPaddingTopM: "10.5px",
  buttonPaddingTopL: "16.5px",
  buttonPaddingBottomS: "4.5px",
  buttonPaddingBottomM: "10.5px",
  buttonPaddingBottomL: "16.5px",
  buttonPaddingSidesS: "18.5px",
  buttonPaddingSidesM: "22.5px",
  buttonPaddingSidesL: "22.5px",
  buttonPaddingUnderline: "0",
  buttonHeightS: "36px",
  buttonHeightM: "48px",
  buttonHeightL: "60px",
  buttonColorHover: "#757575",
  buttonColorHoverInverse: "#b2b2b2",
  dialogBackgroundBlur: "4px",
  elevation10: "10",
  elevation20: "20",
  elevation30: "30",
  elevation40: "40",
  elevation50: "50",
  elevation60: "60",
  elevation70: "70",
  elevation80: "80",
  elevation90: "90",
  elevation100: "100",
  fontWeightRegular: "400",
  fontWeightMedium: "500",
  fontWeightBold: "700",
  fontSizeXxs: "12px",
  fontSizeXs: "14px",
  fontSizeS: "16px",
  fontSizeM: "20px",
  fontSizeL: "24px",
  fontSizeXl: "28px",
  fontSizeXxl: "32px",
  fontSizeXxxl: "40px",
  fontSizeXxxxl: "48px",
  fontSizeXxxxxl: "72px",
  fontStyleNormal: "normal",
  paletteBlack: "#111111",
  paletteGrey1: "#757575",
  paletteGrey2: "#cccccc",
  paletteGrey3: "#e5e5e5",
  paletteGrey4: "#f5f5f5",
  paletteGrey5: "#fafafa",
  paletteWhite: "#ffffff",
  paletteError: "#d43f21",
  paletteSuccess: "#128a09",
  sizeSpacingXs: "4px",
  sizeSpacingS: "8px",
  sizeSpacingM: "12px",
  sizeSpacingL: "24px",
  sizeSpacingXl: "36px",
  sizeSpacingXxl: "60px",
  sizeSpacingXxxl: "84px",
  sizeSpacingXxxxl: "120px",
  sizeSpacingGridGutter: "16px",
  sizeSpacingGridGutterL: "12px",
  sizeSpacingGridExteriorGutterS: "24px",
  sizeSpacingGridExteriorGutterL: "48px",
  sizeBorderRadiusS: "4px",
  sizeBorderRadiusM: "8px",
  sizeBorderRadiusL: "12px",
  sizeBorderRadiusXl: "24px",
  sizeBorderWidthS: "1px",
  sizeBorderWidthM: "1.5px",
  sizeBorderWidthL: "2px",
  sizeIconS: "16px",
  sizeIconM: "24px",
  sizeIconL: "48px",
  sizeFormInputContainerHeight: "84px",
  sizeFormInputFieldHeight: "56px",
  transitionTimingFunctionEase: "cubic-bezier(.25, .1, .25, 1)",
  transitionDurationFast: "150ms",
  transitionDurationNormal: "250ms",
  breakpointXs: "320px",
  breakpointS: "600px",
  breakpointM: "960px",
  breakpointL: "1440px",
  breakpointXl: "1920px",
  formShadowFocus: "0 0 0 12px #f5f5f5",
  i18nTokens: {
    globalFallback: {
      typographyBody1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "20px",
        fontWeight: "400",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody3: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody4: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "12px",
        fontWeight: "400",
        lineHeight: "14px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "14px",
        fontWeight: "500",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay1: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "72px",
        fontWeight: "700",
        lineHeight: "72px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay2: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "48px",
        fontWeight: "700",
        lineHeight: "48px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay3: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "40px",
        fontWeight: "700",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "32px",
        fontWeight: "500",
        lineHeight: "44px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "28px",
        fontWeight: "500",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading3: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "24px",
        fontWeight: "500",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading4: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "20px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading5: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      fontHeightXxs: "14px",
      fontHeightXs: "20px",
      fontHeightS: "24px",
      fontHeightM: "28px",
      fontHeightL: "40px",
      fontHeightXl: "40px",
      fontHeightXxl: "44px",
      fontHeightXxxl: "48px",
      fontHeightXxxxl: "72px",
      fontFamilyBase: '"Helvetica Neue", Helvetica, Arial, sans-serif',
      fontFamilyBrand: '"Nike TG", "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontFamilyMarketing: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif'
    },
    get "ca-es"() {
      return this.globalFallback;
    },
    get "cs-cz"() {
      return this.globalFallback;
    },
    get "da-dk"() {
      return this.globalFallback;
    },
    get "de-de"() {
      return this.globalFallback;
    },
    "el-gr": {
      typographyBody1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "20px",
        fontWeight: "400",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody3: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody4: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "12px",
        fontWeight: "400",
        lineHeight: "14px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "14px",
        fontWeight: "500",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay1: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "72px",
        fontWeight: "700",
        lineHeight: "60px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay2: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "48px",
        fontWeight: "700",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay3: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "40px",
        fontWeight: "700",
        lineHeight: "34px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "32px",
        fontWeight: "500",
        lineHeight: "36px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "28px",
        fontWeight: "500",
        lineHeight: "32px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading3: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "24px",
        fontWeight: "500",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading4: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "20px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading5: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      fontHeightXxs: "14px",
      fontHeightXs: "20px",
      fontHeightS: "24px",
      fontHeightM: "28px",
      fontHeightL: "32px",
      fontHeightXl: "34px",
      fontHeightXxl: "36px",
      fontHeightXxxl: "40px",
      fontHeightXxxxl: "60px",
      fontFamilyBase: '"Helvetica Neue", Helvetica, Arial, sans-serif',
      fontFamilyBrand: '"Nike TG", "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontFamilyMarketing: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif'
    },
    get "en-ca"() {
      return this["en-us"];
    },
    get "en-gb"() {
      return this["en-us"];
    },
    "en-us": {
      typographyBody1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "20px",
        fontWeight: "400",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody3: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody4: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "12px",
        fontWeight: "400",
        lineHeight: "14px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "14px",
        fontWeight: "500",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay1: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "72px",
        fontWeight: "700",
        lineHeight: "60px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay2: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "48px",
        fontWeight: "700",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay3: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "40px",
        fontWeight: "700",
        lineHeight: "34px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "32px",
        fontWeight: "500",
        lineHeight: "36px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "28px",
        fontWeight: "500",
        lineHeight: "32px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading3: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "24px",
        fontWeight: "500",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading4: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "20px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading5: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      fontHeightXxs: "14px",
      fontHeightXs: "20px",
      fontHeightS: "24px",
      fontHeightM: "28px",
      fontHeightL: "32px",
      fontHeightXl: "34px",
      fontHeightXxl: "36px",
      fontHeightXxxl: "40px",
      fontHeightXxxxl: "60px",
      fontFamilyBase: '"Helvetica Neue", Helvetica, Arial, sans-serif',
      fontFamilyBrand: '"Nike TG", "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontFamilyMarketing: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif'
    },
    get "es-ar"() {
      return this.globalFallback;
    },
    get "es-ca"() {
      return this.globalFallback;
    },
    get "es-cl"() {
      return this.globalFallback;
    },
    get "es-es"() {
      return this.globalFallback;
    },
    get "es-la"() {
      return this.globalFallback;
    },
    get "es-mx"() {
      return this.globalFallback;
    },
    get "es-uy"() {
      return this.globalFallback;
    },
    get "fr-fr"() {
      return this.globalFallback;
    },
    get "hu-hu"() {
      return this.globalFallback;
    },
    get "it-it"() {
      return this.globalFallback;
    },
    "jp-jp": {
      typographyBody1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
        fontSize: "20px",
        fontWeight: "400",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody3: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody4: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
        fontSize: "12px",
        fontWeight: "400",
        lineHeight: "14px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
        fontSize: "14px",
        fontWeight: "500",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay1: {
        fontFamily: '"Nike Futura", Meiryo, "\u30E1\u30A4\u30EA\u30AA", "MS Pgothic", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "Hiragino Kaku Gothic Pro", "\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "72px",
        fontWeight: "700",
        lineHeight: "72px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay2: {
        fontFamily: '"Nike Futura", Meiryo, "\u30E1\u30A4\u30EA\u30AA", "MS Pgothic", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "Hiragino Kaku Gothic Pro", "\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "48px",
        fontWeight: "700",
        lineHeight: "48px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay3: {
        fontFamily: '"Nike Futura", Meiryo, "\u30E1\u30A4\u30EA\u30AA", "MS Pgothic", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "Hiragino Kaku Gothic Pro", "\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "40px",
        fontWeight: "700",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
        fontSize: "32px",
        fontWeight: "500",
        lineHeight: "44px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
        fontSize: "28px",
        fontWeight: "500",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading3: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
        fontSize: "24px",
        fontWeight: "500",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading4: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
        fontSize: "20px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading5: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      fontHeightXxs: "14px",
      fontHeightXs: "20px",
      fontHeightS: "24px",
      fontHeightM: "28px",
      fontHeightL: "40px",
      fontHeightXl: "40px",
      fontHeightXxl: "44px",
      fontHeightXxxl: "48px",
      fontHeightXxxxl: "72px",
      fontFamilyBase: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
      fontFamilyBrand: '"Nike TG", Meiryo, "\u30E1\u30A4\u30EA\u30AA", "MS Pgothic", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "Hiragino Kaku Gothic Pro", "\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4", "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontFamilyMarketing: '"Nike Futura", Meiryo, "\u30E1\u30A4\u30EA\u30AA", "MS Pgothic", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "Hiragino Kaku Gothic Pro", "\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4", "Helvetica Neue", Helvetica, Arial, sans-serif'
    },
    "ko-kr": {
      typographyBody1: {
        fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
        fontSize: "20px",
        fontWeight: "400",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody2: {
        fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody3: {
        fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody4: {
        fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
        fontSize: "12px",
        fontWeight: "400",
        lineHeight: "14px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta1: {
        fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta2: {
        fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
        fontSize: "14px",
        fontWeight: "500",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay1: {
        fontFamily: '"Nike Futura", FBHanGothicDB, "Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
        fontSize: "72px",
        fontWeight: "700",
        lineHeight: "72px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay2: {
        fontFamily: '"Nike Futura", FBHanGothicDB, "Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
        fontSize: "48px",
        fontWeight: "700",
        lineHeight: "48px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay3: {
        fontFamily: '"Nike Futura", FBHanGothicDB, "Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
        fontSize: "40px",
        fontWeight: "700",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading1: {
        fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
        fontSize: "32px",
        fontWeight: "500",
        lineHeight: "44px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading2: {
        fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
        fontSize: "28px",
        fontWeight: "500",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading3: {
        fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
        fontSize: "24px",
        fontWeight: "500",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading4: {
        fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
        fontSize: "20px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading5: {
        fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      fontHeightXxs: "14px",
      fontHeightXs: "20px",
      fontHeightS: "24px",
      fontHeightM: "28px",
      fontHeightL: "40px",
      fontHeightXl: "40px",
      fontHeightXxl: "44px",
      fontHeightXxxl: "48px",
      fontHeightXxxxl: "72px",
      fontFamilyBase: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
      fontFamilyBrand: '"Nike TG", FBHanGothicDB, "Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
      fontFamilyMarketing: '"Nike Futura", FBHanGothicDB, "Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif'
    },
    get "nl-en"() {
      return this.globalFallback;
    },
    get "nl-nl"() {
      return this.globalFallback;
    },
    get "no-no"() {
      return this.globalFallback;
    },
    "pl-pl": {
      typographyBody1: {
        fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "20px",
        fontWeight: "400",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody2: {
        fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody3: {
        fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody4: {
        fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "12px",
        fontWeight: "400",
        lineHeight: "14px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta1: {
        fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta2: {
        fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "14px",
        fontWeight: "500",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay1: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "72px",
        fontWeight: "700",
        lineHeight: "72px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay2: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "48px",
        fontWeight: "700",
        lineHeight: "48px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay3: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "40px",
        fontWeight: "700",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading1: {
        fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "32px",
        fontWeight: "500",
        lineHeight: "44px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading2: {
        fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "28px",
        fontWeight: "500",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading3: {
        fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "24px",
        fontWeight: "500",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading4: {
        fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "20px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading5: {
        fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      fontHeightXxs: "14px",
      fontHeightXs: "20px",
      fontHeightS: "24px",
      fontHeightM: "28px",
      fontHeightL: "40px",
      fontHeightXl: "40px",
      fontHeightXxl: "44px",
      fontHeightXxxl: "48px",
      fontHeightXxxxl: "72px",
      fontFamilyBase: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontFamilyBrand: '"Nike TG", "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontFamilyMarketing: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif'
    },
    get "pt-br"() {
      return this.globalFallback;
    },
    get "pt-pt"() {
      return this.globalFallback;
    },
    "ru-ru": {
      typographyBody1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "20px",
        fontWeight: "400",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody3: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody4: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "12px",
        fontWeight: "400",
        lineHeight: "14px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "14px",
        fontWeight: "500",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay1: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "72px",
        fontWeight: "700",
        lineHeight: "72px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay2: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "48px",
        fontWeight: "700",
        lineHeight: "48px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay3: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "40px",
        fontWeight: "700",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "32px",
        fontWeight: "500",
        lineHeight: "44px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "28px",
        fontWeight: "500",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading3: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "24px",
        fontWeight: "500",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading4: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "20px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading5: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      fontHeightXxs: "14px",
      fontHeightXs: "20px",
      fontHeightS: "24px",
      fontHeightM: "28px",
      fontHeightL: "40px",
      fontHeightXl: "40px",
      fontHeightXxl: "44px",
      fontHeightXxxl: "48px",
      fontHeightXxxxl: "72px",
      fontFamilyBase: '"Helvetica Neue", Helvetica, Arial, sans-serif',
      fontFamilyBrand: '"Nike TG", "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontFamilyMarketing: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif'
    },
    get "sv-se"() {
      return this.globalFallback;
    },
    "th-th": {
      typographyBody1: {
        fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "20px",
        fontWeight: "400",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody2: {
        fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody3: {
        fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody4: {
        fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "12px",
        fontWeight: "400",
        lineHeight: "14px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta1: {
        fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta2: {
        fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "14px",
        fontWeight: "500",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay1: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, "Arial Bold", Arial, Tahoma, Thonburi, Ayuthaya, sans-serif',
        fontSize: "72px",
        fontWeight: "700",
        lineHeight: "72px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay2: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, "Arial Bold", Arial, Tahoma, Thonburi, Ayuthaya, sans-serif',
        fontSize: "48px",
        fontWeight: "700",
        lineHeight: "48px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay3: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, "Arial Bold", Arial, Tahoma, Thonburi, Ayuthaya, sans-serif',
        fontSize: "40px",
        fontWeight: "700",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading1: {
        fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "32px",
        fontWeight: "500",
        lineHeight: "44px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading2: {
        fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "28px",
        fontWeight: "500",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading3: {
        fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "24px",
        fontWeight: "500",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading4: {
        fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "20px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading5: {
        fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      fontHeightXxs: "14px",
      fontHeightXs: "20px",
      fontHeightS: "24px",
      fontHeightM: "28px",
      fontHeightL: "40px",
      fontHeightXl: "40px",
      fontHeightXxl: "44px",
      fontHeightXxxl: "48px",
      fontHeightXxxxl: "72px",
      fontFamilyBase: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontFamilyBrand: '"Nike TG", "Helvetica Neue W31", "Helvetica Neue", Helvetica, "Arial Bold", Arial, Tahoma, Thonburi, Ayuthaya, sans-serif',
      fontFamilyMarketing: '"Nike Futura", "Helvetica Neue", Helvetica, "Arial Bold", Arial, Tahoma, Thonburi, Ayuthaya, sans-serif'
    },
    get "tr-tr"() {
      return this.globalFallback;
    },
    "zh-cn": {
      typographyBody1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "20px",
        fontWeight: "400",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody3: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody4: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "12px",
        fontWeight: "400",
        lineHeight: "14px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "14px",
        fontWeight: "500",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay1: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "72px",
        fontWeight: "700",
        lineHeight: "72px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay2: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "48px",
        fontWeight: "700",
        lineHeight: "48px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay3: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "40px",
        fontWeight: "700",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "32px",
        fontWeight: "500",
        lineHeight: "44px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "28px",
        fontWeight: "500",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading3: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "24px",
        fontWeight: "500",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading4: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "20px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading5: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      fontHeightXxs: "14px",
      fontHeightXs: "20px",
      fontHeightS: "24px",
      fontHeightM: "28px",
      fontHeightL: "40px",
      fontHeightXl: "40px",
      fontHeightXxl: "44px",
      fontHeightXxxl: "48px",
      fontHeightXxxxl: "72px",
      fontFamilyBase: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
      fontFamilyBrand: '"Nike TG", "Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
      fontFamilyMarketing: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif'
    },
    "zh-tw": {
      typographyBody1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "20px",
        fontWeight: "400",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody3: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyBody4: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "12px",
        fontWeight: "400",
        lineHeight: "14px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyCta2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "14px",
        fontWeight: "500",
        lineHeight: "20px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay1: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "72px",
        fontWeight: "700",
        lineHeight: "72px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay2: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "48px",
        fontWeight: "700",
        lineHeight: "48px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyDisplay3: {
        fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "40px",
        fontWeight: "700",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading1: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "32px",
        fontWeight: "500",
        lineHeight: "44px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading2: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "28px",
        fontWeight: "500",
        lineHeight: "40px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading3: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "24px",
        fontWeight: "500",
        lineHeight: "28px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading4: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "20px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      typographyHeading5: {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        fontStyle: "normal",
        textTransform: "none"
      },
      fontHeightXxs: "14px",
      fontHeightXs: "20px",
      fontHeightS: "24px",
      fontHeightM: "28px",
      fontHeightL: "40px",
      fontHeightXl: "40px",
      fontHeightXxl: "44px",
      fontHeightXxxl: "48px",
      fontHeightXxxxl: "72px",
      fontFamilyBase: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
      fontFamilyBrand: '"Nike TG", "Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
      fontFamilyMarketing: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif'
    }
  }
};
function _objectWithoutProperties$1(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded), sourceSymbolKeys;
  var key, i2;
  if (Object.getOwnPropertySymbols) {
    sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++) {
      key = sourceSymbolKeys[i2];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key = sourceKeys[i2];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var sizeIconM = nike.sizeIconM, sizeIconL = nike.sizeIconL;
var viewBoxes = {
  s: "0 0 ".concat(parseInt(sizeIconM), " ").concat(parseInt(sizeIconM)),
  m: "0 0 ".concat(parseInt(sizeIconM), " ").concat(parseInt(sizeIconM)),
  l: "0 0 ".concat(parseInt(sizeIconL), " ").concat(parseInt(sizeIconL))
};
var sizes = {
  s: sizeIconM,
  m: sizeIconM,
  l: sizeIconL
};
var SvgIcon = function(_ref3) {
  var ariaHidden = _ref3["aria-hidden"], className = _ref3.className, fill = _ref3.fill, height = _ref3.height, paths2 = _ref3.paths, _ref$role = _ref3.role, role = _ref$role === void 0 ? "img" : _ref$role, title2 = _ref3.title, _ref$size = _ref3.size, size = _ref$size === void 0 ? "m" : _ref$size, viewBox = _ref3.viewBox, width = _ref3.width, rest = _objectWithoutProperties$1(_ref3, ["aria-hidden", "className", "fill", "height", "paths", "role", "title", "size", "viewBox", "width"]);
  var isInaccessible = function(ariaHiddenValue2) {
    return !ariaHiddenValue2 && !title2;
  };
  var ariaHiddenValue = ariaHidden;
  if (isInaccessible(ariaHidden)) {
    ariaHiddenValue = true;
  }
  var vb = viewBox ? viewBox : viewBoxes[size] || viewBoxes.m;
  var svgWidth = width ? width : sizes[size];
  var svgHeight = height ? height : sizes[size];
  return /* @__PURE__ */ jsxs("svg", {
    ...Object.assign({
      "aria-hidden": ariaHiddenValue ? "true" : "false",
      className,
      focusable: "false",
      viewBox: vb,
      role,
      width: svgWidth,
      height: svgHeight,
      fill
    }, rest),
    children: [(paths2 === null || paths2 === void 0 ? void 0 : paths2[size]) ? paths2[size] : paths2 === null || paths2 === void 0 ? void 0 : paths2["m"], title2 && /* @__PURE__ */ jsx$1("title", {
      children: title2
    })]
  });
};
var smallPath$2 = /* @__PURE__ */ React__default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ React__default.createElement("g", {
  transform: "translate(2.000000, 2.000000)"
}, /* @__PURE__ */ React__default.createElement("rect", {
  x: "0",
  y: "0",
  width: "20",
  height: "20",
  rx: "10"
}), /* @__PURE__ */ React__default.createElement("rect", {
  className: "checkicon-fill",
  x: "0",
  y: "0",
  width: "20",
  height: "20",
  rx: "5"
}), /* @__PURE__ */ React__default.createElement("path", {
  className: "checkicon-check",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M6.00134645 9.81868355 9.12119517 13.003429 14.9964286 7"
})));
var paths$2 = {
  s: smallPath$2,
  m: smallPath$2,
  l: smallPath$2
};
var CheckboxIcon = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({
    paths: paths$2
  }, props));
});
CheckboxIcon.displayName = "Checkbox";
var smallPath$1 = /* @__PURE__ */ React__default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ React__default.createElement("g", {
  transform: "translate(2.000000, 2.000000)"
}, /* @__PURE__ */ React__default.createElement("circle", {
  className: "radio-outline",
  stroke: "currentColor",
  strokeWidth: "1.5",
  cx: "10",
  cy: "10",
  r: "9.25"
}), /* @__PURE__ */ React__default.createElement("circle", {
  className: "radio-fill",
  fill: "currentColor",
  cx: "10",
  cy: "10",
  r: "5"
})));
var paths$1 = {
  s: smallPath$1,
  m: smallPath$1,
  l: smallPath$1
};
var RadioIcon = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({
    paths: paths$1
  }, props));
});
RadioIcon.displayName = "Radio";
var paletteSuccess = nike.paletteSuccess;
var smallPath = /* @__PURE__ */ React__default.createElement("g", {
  transform: "translate(8,8)"
}, /* @__PURE__ */ React__default.createElement("circle", {
  xmlns: "http://www.w3.org/2000/svg",
  cx: "4",
  cy: "4",
  r: "4",
  fill: paletteSuccess
}));
var paths = {
  s: smallPath,
  m: smallPath,
  l: smallPath
};
var SuccessIcon = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({
    paths
  }, props));
});
SuccessIcon.displayName = "Success";
var compPaths$4k = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.045 10.99V7.73L6.19 10.37 3.115 9.35l1.94 2.64-1.905 2.64 3.045-1.005 1.855 2.64v-3.26l3.11-1.02-3.115-.995zm12.84 1.02l-6.82 7.49H8.21l6.825-7.49L8.21 4.5h5.856l6.819 7.51z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.045 10.99V7.73L6.19 10.37 3.115 9.35l1.94 2.64-1.905 2.64 3.045-1.005 1.855 2.64v-3.26l3.11-1.02-3.115-.995zm12.84 1.02l-6.82 7.49H8.21l6.825-7.49L8.21 4.5h5.856l6.819 7.51z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.09 21.98v-6.52l-3.708 5.28-6.152-2.042 3.88 5.282-3.81 5.28 6.09-2.01 3.71 5.278V26.01l6.22-2.04-6.23-1.99zm25.68 2.04L28.132 39H16.42l13.65-14.98L16.42 9h11.712L41.77 24.02z",
    clipRule: "evenodd"
  }))
};
var Converse = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$4k,
    fill: "none"
  }));
});
var compPaths$4j = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.909 19.105c-.61-.58-1.27-1.145-1.724-1.869-2.4-3.418-2.084-8.5.82-11.529.314-.345.704-.61 1.004-.97-.05-.38-.49-.175-.74-.16-1.24.295-2.493.394-3.733.61-.99.145-1.634 1.034-1.914 1.93-.47 1.552-.94 3.122-1.034 4.753.045 1.428.389 2.841.799 4.222.235.835.485 1.744 1.21 2.289.614.49 1.429.49 2.168.578.985.096 1.945.317 2.919.506.21.155.375-.25.225-.36zM9.838 5.972c-.41-.52-1.04-.8-1.664-.865a27.193 27.193 0 01-3.389-.534c-.264-.05-.659-.205-.739.189.475.475 1.02.865 1.42 1.404 2.793 3.359 2.698 8.722-.266 11.94-.36.474-.909.755-1.209 1.269.454.175.91-.03 1.364-.11 1.065-.25 2.18-.3 3.264-.49.924-.19 1.54-1.033 1.804-1.883.394-1.24.72-2.494.94-3.764.264-1.723-.175-3.448-.66-5.112-.205-.69-.375-1.46-.865-2.044z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.909 19.105c-.61-.58-1.27-1.145-1.724-1.869-2.4-3.418-2.084-8.5.82-11.529.314-.345.704-.61 1.004-.97-.05-.38-.49-.175-.74-.16-1.24.295-2.493.394-3.733.61-.99.145-1.634 1.034-1.914 1.93-.47 1.552-.94 3.122-1.034 4.753.045 1.428.389 2.841.799 4.222.235.835.485 1.744 1.21 2.289.614.49 1.429.49 2.168.578.985.096 1.945.317 2.919.506.21.155.375-.25.225-.36zM9.838 5.972c-.41-.52-1.04-.8-1.664-.865a27.193 27.193 0 01-3.389-.534c-.264-.05-.659-.205-.739.189.475.475 1.02.865 1.42 1.404 2.793 3.359 2.698 8.722-.266 11.94-.36.474-.909.755-1.209 1.269.454.175.91-.03 1.364-.11 1.065-.25 2.18-.3 3.264-.49.924-.19 1.54-1.033 1.804-1.883.394-1.24.72-2.494.94-3.764.264-1.723-.175-3.448-.66-5.112-.205-.69-.375-1.46-.865-2.044z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M39.818 38.211c-1.22-1.16-2.54-2.29-3.45-3.738-4.796-6.838-4.168-17.002 1.64-23.058.63-.692 1.41-1.222 2.01-1.94-.1-.76-.982-.35-1.48-.32-2.48.59-4.988.788-7.466 1.218-1.98.292-3.27 2.07-3.828 3.86-.94 3.106-1.88 6.246-2.07 9.506.09 2.856.778 5.684 1.6 8.444.47 1.67.97 3.488 2.42 4.578 1.228.98 2.856.98 4.336 1.158 1.97.192 3.888.632 5.836 1.01.42.312.75-.5.452-.718zm-20.14-26.268c-.82-1.04-2.08-1.6-3.33-1.73-2.258-.22-4.546-.56-6.776-1.068-.528-.1-1.32-.41-1.48.378.952.95 2.04 1.73 2.84 2.808 5.586 6.718 5.396 17.444-.53 23.88-.72.948-1.82 1.51-2.42 2.538.91.35 1.82-.06 2.73-.218 2.128-.5 4.356-.6 6.526-.98 1.85-.38 3.078-2.068 3.608-3.768.79-2.478 1.44-4.988 1.88-7.528.53-3.446-.35-6.896-1.32-10.224-.41-1.38-.75-2.918-1.728-4.088z",
    clipRule: "evenodd"
  }))
};
var Hurley = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$4j,
    fill: "none"
  }));
});
var compPaths$4i = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.182 3.733c-.012-.039-.012-.039-.012-.072a.966.966 0 01.922-1.007.97.97 0 011.007.922.964.964 0 01-.917 1.007c-.027.004-.062 0-.101 0-.016.004-.04.004-.056.022-.056.084.14.073-.005.44 0 0 0 .038-.012.077-.012.14-.08.562-.096.793.029.04.04.05.029.13a6.003 6.003 0 01-.09.534c-.04.14-.096.174-.147.202-.073.298-.095.545-.281.905-.022.276-.045.35-.106.484-.017.4.01.46-.281 1.101-.08.3-.017.507.05.821.068.321.276.461.298.793.05.771.017 1.305-.163 1.907l.135.348c.18.084.618.326.36.675.343.19.865.394 1.28.781.176.147.35.315.513.5.316.057.276.08.506.231.675.438 1.749 1.304 2.373 1.906.112.067.147.112.236.163.01.023.017.034.01.04-.026.072-.026.072-.06.14.039.04.095.073.134.107.04.005.04-.006.096-.017.079.073.18.135.214.135.106-.022.084-.005.185-.1.029-.035.084 0 .084 0 .04-.04.113-.119.214-.176.079-.045.23-.045.23-.045.052.006.04.051.029.073-.057.023-.18.057-.247.108-.152.14-.276.353-.276.353.299-.033.484.045.719.023.136-.005.237.006.377-.09 0 0 .14-.096.265-.14.118-.05.23-.017.33.062.069.084.119.084 0 .196-.044.045-.1.096-.18.17-.133.123-.313.291-.5.432a3.11 3.11 0 01-.527.315c-.338.23-.26.174-.523.394-.03.022-.124.078-.163.106-.107.062-.135.006-.197-.118 0 0-.028-.045-.08-.14-.05-.107-.09-.23-.072-.23-.062-.007-.331-.344-.331-.41-.063-.013-.304-.26-.31-.31l-.214-.18c-.253.044-.31-.113-.961-.608-.08-.006-.197-.05-.36-.174-.298-.253-1.007-.815-1.124-.883-.13-.067-.281-.134-.383-.214-.146-.022-.218-.05-.298-.067-.08-.022-.14-.057-.326-.079-.303-.045-.618-.18-.911-.337-.14-.073-.264-.107-.382-.169-.27-.124-.506-.236-.686-.28a2.148 2.148 0 01-.568-.226c-.061-.034-.095-.06-.134-.073-.09-.022-.153.006-.192.022-.23.108-.438.203-.636.31-.18.09-.348.186-.528.286a7.971 7.971 0 01-.534.254s-.534.253-.832.348c-.26.197-.787.546-1.107.715-.158.073-.467.252-.608.292-.08.061-.371.258-.596.421-.18.124-.31.231-.31.231-.106.084-.101.13-.28.045a1.491 1.491 0 00-.13.096c-.14.095-.146.073-.202.067-.101.08-.113.04-.197.13-.061.084 0 .061-.118.106-.028.006-.04.04-.057.056-.094.073-.1.293-.325.304-.135.09-.107.203-.197.191 0 .102-.18.23-.214.23-.292.096-.304-.118-.646.035-.045.016-.113.072-.197.084-.152.022-.332-.006-.444-.102a1.93 1.93 0 01-.326-.398c-.051-.13-.017-.208.163-.332.073-.045.084-.079.208-.084.06-.024.045.01.15-.024.064-.016.064-.005.193-.005.028-.017.067-.022.124-.045.1-.034.196-.062.196-.062s.028-.023.124-.01c.078-.035.169-.08.214-.097-.012-.124.005-.124.06-.174.08-.062.09-.05.148-.01.022-.007.039-.013.027-.035-.01-.073-.061-.107-.045-.247-.022-.057-.061-.129-.05-.174.01-.045.028-.069.056-.079.029-.012.045.006.057.022.028.034.05.135.05.135.006.118.04.26.152.18.067-.062.084-.242.214-.203l.096.085c.084-.073.084-.073.14-.107 0 0-.08-.073-.012-.135.045-.039.108-.067.208-.175.276-.292.422-.42.714-.657a6.811 6.811 0 011.699-.939c.146-.174.28-.286.585-.304.377-.606 1.085-1.136 1.248-1.22.134-.23.19-.208.365-.247.135-.107.175-.107.23-.214.063-.23-.112-.86.383-.877.112-.146.078-.112.196-.248a2.19 2.19 0 01-.118-.5c-.005-.016-.196-.157-.13-.332a2.33 2.33 0 01-.268-.432.202.202 0 01-.063-.012c-.022-.005-.055-.005-.09-.005-.078.196-.163.208-.303.253-.26.512-.35.731-1.046 1.142-.28.298-.382.64-.382.634a.46.46 0 00-.012.321c-.045.107-.027.124-.027.124.01.045.056.106.106.112.079.023.169.023.158.118-.011.113-.163.09-.237.073-.275-.05-.185-.23-.365-.174-.141.085-.196.348-.416.31-.028-.023-.017-.074.006-.119.028-.06.084-.118.056-.14-.146.04-.433.123-.433.123-.135.04-.281-.039-.147-.124.063-.022.153-.05.265-.118 0 0 .062-.072-.057-.039a1.144 1.144 0 01-.416.045s-.257-.039-.292-.056c-.028-.022-.061-.107.017-.1a2.71 2.71 0 00.563-.068c.095-.035.28-.14.382-.186 0 0 .113-.157.18-.19.107-.114.19-.18.28-.299.09-.18.192-.46.5-.906a4.16 4.16 0 01.535-.646s.062-.338.343-.573c.063-.14.157-.31.259-.462a1.7 1.7 0 00.106-.168c.09-.13.186-.377.518-.41 0 0 .147-.102.197-.175.084-.073.074-.186.14-.259-.106-.106-.365-.309-.382-.573a.85.85 0 01.265-.692c.196-.185.398-.275.646-.258.309.055.366.157.455.258.09.101.13.04.163.146.259.073.248.045.237.236.045.057.106.108.1.214.085-.175.108-.208.344-.399.062-.157.1-.315.15-.478.052-.146.114-.298.154-.41-.04-.326.06-.377.196-.664-.022-.039-.016-.05-.006-.112.057-.192.136-.433.186-.596 0 0 .017-.063.085-.063.06-.202.157-.579.179-.663.062-.208.029-.287-.01-.41-.012-.04-.006-.09-.03-.136a5.483 5.483 0 01-.19-.41c-.028-.073-.08-.354-.08-.354-.004-.062-.004-.09-.004-.09z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.182 3.733c-.012-.039-.012-.039-.012-.072a.966.966 0 01.922-1.007.97.97 0 011.007.922.964.964 0 01-.917 1.007c-.027.004-.062 0-.101 0-.016.004-.04.004-.056.022-.056.084.14.073-.005.44 0 0 0 .038-.012.077-.012.14-.08.562-.096.793.029.04.04.05.029.13a6.003 6.003 0 01-.09.534c-.04.14-.096.174-.147.202-.073.298-.095.545-.281.905-.022.276-.045.35-.106.484-.017.4.01.46-.281 1.101-.08.3-.017.507.05.821.068.321.276.461.298.793.05.771.017 1.305-.163 1.907l.135.348c.18.084.618.326.36.675.343.19.865.394 1.28.781.176.147.35.315.513.5.316.057.276.08.506.231.675.438 1.749 1.304 2.373 1.906.112.067.147.112.236.163.01.023.017.034.01.04-.026.072-.026.072-.06.14.039.04.095.073.134.107.04.005.04-.006.096-.017.079.073.18.135.214.135.106-.022.084-.005.185-.1.029-.035.084 0 .084 0 .04-.04.113-.119.214-.176.079-.045.23-.045.23-.045.052.006.04.051.029.073-.057.023-.18.057-.247.108-.152.14-.276.353-.276.353.299-.033.484.045.719.023.136-.005.237.006.377-.09 0 0 .14-.096.265-.14.118-.05.23-.017.33.062.069.084.119.084 0 .196-.044.045-.1.096-.18.17-.133.123-.313.291-.5.432a3.11 3.11 0 01-.527.315c-.338.23-.26.174-.523.394-.03.022-.124.078-.163.106-.107.062-.135.006-.197-.118 0 0-.028-.045-.08-.14-.05-.107-.09-.23-.072-.23-.062-.007-.331-.344-.331-.41-.063-.013-.304-.26-.31-.31l-.214-.18c-.253.044-.31-.113-.961-.608-.08-.006-.197-.05-.36-.174-.298-.253-1.007-.815-1.124-.883-.13-.067-.281-.134-.383-.214-.146-.022-.218-.05-.298-.067-.08-.022-.14-.057-.326-.079-.303-.045-.618-.18-.911-.337-.14-.073-.264-.107-.382-.169-.27-.124-.506-.236-.686-.28a2.148 2.148 0 01-.568-.226c-.061-.034-.095-.06-.134-.073-.09-.022-.153.006-.192.022-.23.108-.438.203-.636.31-.18.09-.348.186-.528.286a7.971 7.971 0 01-.534.254s-.534.253-.832.348c-.26.197-.787.546-1.107.715-.158.073-.467.252-.608.292-.08.061-.371.258-.596.421-.18.124-.31.231-.31.231-.106.084-.101.13-.28.045a1.491 1.491 0 00-.13.096c-.14.095-.146.073-.202.067-.101.08-.113.04-.197.13-.061.084 0 .061-.118.106-.028.006-.04.04-.057.056-.094.073-.1.293-.325.304-.135.09-.107.203-.197.191 0 .102-.18.23-.214.23-.292.096-.304-.118-.646.035-.045.016-.113.072-.197.084-.152.022-.332-.006-.444-.102a1.93 1.93 0 01-.326-.398c-.051-.13-.017-.208.163-.332.073-.045.084-.079.208-.084.06-.024.045.01.15-.024.064-.016.064-.005.193-.005.028-.017.067-.022.124-.045.1-.034.196-.062.196-.062s.028-.023.124-.01c.078-.035.169-.08.214-.097-.012-.124.005-.124.06-.174.08-.062.09-.05.148-.01.022-.007.039-.013.027-.035-.01-.073-.061-.107-.045-.247-.022-.057-.061-.129-.05-.174.01-.045.028-.069.056-.079.029-.012.045.006.057.022.028.034.05.135.05.135.006.118.04.26.152.18.067-.062.084-.242.214-.203l.096.085c.084-.073.084-.073.14-.107 0 0-.08-.073-.012-.135.045-.039.108-.067.208-.175.276-.292.422-.42.714-.657a6.811 6.811 0 011.699-.939c.146-.174.28-.286.585-.304.377-.606 1.085-1.136 1.248-1.22.134-.23.19-.208.365-.247.135-.107.175-.107.23-.214.063-.23-.112-.86.383-.877.112-.146.078-.112.196-.248a2.19 2.19 0 01-.118-.5c-.005-.016-.196-.157-.13-.332a2.33 2.33 0 01-.268-.432.202.202 0 01-.063-.012c-.022-.005-.055-.005-.09-.005-.078.196-.163.208-.303.253-.26.512-.35.731-1.046 1.142-.28.298-.382.64-.382.634a.46.46 0 00-.012.321c-.045.107-.027.124-.027.124.01.045.056.106.106.112.079.023.169.023.158.118-.011.113-.163.09-.237.073-.275-.05-.185-.23-.365-.174-.141.085-.196.348-.416.31-.028-.023-.017-.074.006-.119.028-.06.084-.118.056-.14-.146.04-.433.123-.433.123-.135.04-.281-.039-.147-.124.063-.022.153-.05.265-.118 0 0 .062-.072-.057-.039a1.144 1.144 0 01-.416.045s-.257-.039-.292-.056c-.028-.022-.061-.107.017-.1a2.71 2.71 0 00.563-.068c.095-.035.28-.14.382-.186 0 0 .113-.157.18-.19.107-.114.19-.18.28-.299.09-.18.192-.46.5-.906a4.16 4.16 0 01.535-.646s.062-.338.343-.573c.063-.14.157-.31.259-.462a1.7 1.7 0 00.106-.168c.09-.13.186-.377.518-.41 0 0 .147-.102.197-.175.084-.073.074-.186.14-.259-.106-.106-.365-.309-.382-.573a.85.85 0 01.265-.692c.196-.185.398-.275.646-.258.309.055.366.157.455.258.09.101.13.04.163.146.259.073.248.045.237.236.045.057.106.108.1.214.085-.175.108-.208.344-.399.062-.157.1-.315.15-.478.052-.146.114-.298.154-.41-.04-.326.06-.377.196-.664-.022-.039-.016-.05-.006-.112.057-.192.136-.433.186-.596 0 0 .017-.063.085-.063.06-.202.157-.579.179-.663.062-.208.029-.287-.01-.41-.012-.04-.006-.09-.03-.136a5.483 5.483 0 01-.19-.41c-.028-.073-.08-.354-.08-.354-.004-.062-.004-.09-.004-.09z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M26.363 7.467c-.024-.078-.024-.078-.024-.144a1.933 1.933 0 011.844-2.014 1.94 1.94 0 012.014 1.844 1.927 1.927 0 01-1.834 2.014c-.054.008-.124 0-.202 0-.032.008-.078.008-.112.044-.112.168.28.146-.01.878 0 0 0 .078-.024.156-.024.28-.158 1.124-.192 1.586.058.08.08.1.058.26-.024.212-.102.73-.18 1.068-.08.28-.192.348-.294.404-.146.596-.19 1.09-.562 1.81-.044.552-.09.698-.212.968-.034.798.022.92-.562 2.202-.16.598-.034 1.014.1 1.642.136.642.552.922.596 1.586.102 1.542.034 2.61-.326 3.814l.27.696c.36.168 1.236.652.72 1.35.686.38 1.73.788 2.562 1.562.35.294.698.63 1.024 1 .632.114.552.158 1.012.462 1.35.876 3.498 2.608 4.746 3.812.224.134.294.224.472.326.022.046.034.068.022.078-.054.146-.054.146-.122.282.078.08.19.146.268.214.08.01.08-.012.192-.034.158.146.36.27.428.27.212-.044.168-.01.37-.202.058-.068.168 0 .168 0 .082-.078.226-.236.428-.35.158-.09.462-.09.462-.09.102.012.078.102.056.146-.114.046-.36.114-.494.216-.304.28-.552.706-.552.706.598-.066.968.09 1.438.046.272-.01.474.012.754-.18 0 0 .282-.192.53-.282.236-.1.46-.032.662.126.136.168.236.168 0 .392-.09.09-.202.192-.36.338-.268.248-.628.584-1 .866-.382.28-.798.516-1.056.63-.676.46-.518.348-1.046.788-.058.044-.248.156-.326.212-.214.124-.27.012-.394-.236 0 0-.056-.09-.158-.282-.102-.212-.18-.46-.146-.46-.124-.012-.662-.686-.662-.82-.126-.024-.608-.518-.62-.62l-.428-.36c-.506.09-.618-.224-1.922-1.214-.158-.012-.394-.102-.72-.348-.596-.506-2.014-1.63-2.248-1.766-.26-.134-.562-.268-.766-.428-.292-.044-.436-.1-.596-.134-.158-.044-.28-.114-.652-.158-.606-.09-1.236-.36-1.822-.674-.28-.146-.528-.214-.764-.338-.54-.248-1.012-.472-1.372-.562-.136-.012-.798-.236-1.136-.45-.122-.068-.19-.122-.268-.146-.18-.044-.306.012-.384.044-.46.216-.876.406-1.272.62-.358.18-.696.372-1.056.572-.314.17-.686.338-1.068.508 0 0-1.068.506-1.664.696-.518.394-1.574 1.092-2.214 1.43-.316.146-.934.504-1.216.584-.158.122-.742.516-1.192.842-.36.248-.618.462-.618.462-.214.168-.204.258-.562.09a2.983 2.983 0 00-.258.192c-.282.19-.294.146-.406.134-.202.158-.226.078-.394.258-.122.17 0 .124-.236.214-.056.012-.078.078-.114.112-.188.146-.2.586-.65.608-.27.178-.214.406-.394.382 0 .204-.36.46-.428.46-.584.192-.608-.236-1.292.07-.09.032-.226.144-.394.168-.304.044-.664-.012-.888-.204-.338-.282-.652-.796-.652-.796-.102-.26-.034-.416.326-.664.146-.09.168-.158.416-.168.122-.048.09.02.302-.048.126-.032.126-.01.384-.01.056-.034.134-.044.248-.09.2-.068.392-.124.392-.124s.056-.046.248-.022c.156-.068.338-.158.428-.192-.024-.248.01-.248.122-.348.16-.124.18-.1.294-.022.044-.012.078-.024.054-.068-.02-.146-.122-.214-.09-.494-.044-.114-.122-.258-.098-.348.02-.09.054-.138.11-.158.058-.024.09.012.114.044.056.068.102.27.102.27.01.236.078.518.302.36.134-.124.168-.484.428-.406l.192.17c.168-.146.168-.146.28-.214 0 0-.158-.146-.024-.27.09-.078.216-.134.416-.35.552-.584.844-.84 1.428-1.314a13.622 13.622 0 013.398-1.878c.292-.348.562-.572 1.17-.608.754-1.212 2.17-2.272 2.496-2.44.268-.46.382-.416.73-.494.27-.214.35-.214.46-.428.126-.46-.224-1.72.766-1.754.224-.292.156-.224.392-.496a4.382 4.382 0 01-.236-1c-.01-.032-.392-.314-.258-.664-.158-.2-.46-.652-.538-.864a.403.403 0 01-.126-.024c-.044-.01-.11-.01-.18-.01-.156.392-.326.416-.606.506-.518 1.024-.698 1.462-2.092 2.284-.56.596-.764 1.28-.764 1.268-.102.204-.078.486-.024.642-.09.214-.054.248-.054.248.022.09.112.212.212.224.158.046.338.046.316.236-.022.226-.326.18-.474.146-.55-.1-.37-.46-.73-.348-.282.17-.392.696-.832.618-.056-.044-.034-.146.012-.236.056-.122.168-.236.112-.282-.292.08-.866.248-.866.248-.27.08-.562-.078-.294-.248.126-.044.306-.1.53-.236 0 0 .124-.144-.114-.078a2.288 2.288 0 01-.832.09s-.514-.078-.584-.112c-.056-.044-.122-.214.034-.202.214.012.732-.046 1.126-.134.19-.07.562-.282.764-.372 0 0 .226-.314.36-.382.214-.226.382-.36.562-.596.18-.36.382-.922 1-1.812.282-.404.63-.876 1.068-1.292 0 0 .124-.676.686-1.146a6.53 6.53 0 01.518-.924 3.4 3.4 0 00.212-.336c.182-.26.372-.754 1.036-.822 0 0 .294-.202.394-.348.168-.146.148-.372.282-.518-.214-.212-.732-.618-.766-1.146-.032-.586.168-1.036.53-1.384.392-.37.796-.55 1.292-.516.618.11.732.314.91.516.18.202.26.08.326.292.518.146.496.09.474.472.09.114.212.216.202.428.168-.35.214-.416.686-.798.124-.314.202-.63.302-.956.102-.292.226-.596.306-.82-.08-.652.122-.754.392-1.328-.044-.078-.032-.102-.012-.224.114-.384.272-.866.372-1.192 0 0 .034-.126.17-.126.122-.404.314-1.158.358-1.326.124-.416.058-.574-.02-.82-.024-.08-.012-.18-.058-.272-.134-.246-.28-.584-.382-.82-.056-.146-.158-.708-.158-.708-.01-.124-.01-.18-.01-.18z",
    clipRule: "evenodd"
  }))
};
var Jordan = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$4i,
    fill: "none"
  }));
});
var compPaths$4h = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.98",
    d: "M11.27 5.97H4.32v13.883h13.863V12.9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".99",
    d: "M19.002 3.425s.833-.34 1.55.377c.717.717.377 1.55.377 1.55l-8.31 8.306a.994.994 0 01-.398.243l-2.606.835.835-2.606a.994.994 0 01.244-.399l8.308-8.306z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: ".99",
    d: "M12.601 13.693s.34-.834-.376-1.55c-.717-.717-1.55-.378-1.55-.378"
  }), /* @__PURE__ */ React__default.createElement("defs", null, /* @__PURE__ */ React__default.createElement("radialGradient", {
    id: "paint0_angular",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(6.93142 0 0 6.94133 11.251 12.911)",
    gradientUnits: "userSpaceOnUse"
  }, /* @__PURE__ */ React__default.createElement("stop", {
    stopColor: "#1390DD"
  }), /* @__PURE__ */ React__default.createElement("stop", {
    offset: ".257",
    stopColor: "#ED2324"
  }), /* @__PURE__ */ React__default.createElement("stop", {
    offset: ".476",
    stopColor: "#E59F1C"
  }), /* @__PURE__ */ React__default.createElement("stop", {
    offset: ".75",
    stopColor: "#5ABA47"
  })))),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.98",
    d: "M11.27 5.97H4.32v13.883h13.863V12.9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".99",
    d: "M19.002 3.425s.833-.34 1.55.377c.717.717.377 1.55.377 1.55l-8.31 8.306a.994.994 0 01-.398.243l-2.606.835.835-2.606a.994.994 0 01.244-.399l8.308-8.306z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: ".99",
    d: "M12.601 13.693s.34-.834-.376-1.55c-.717-.717-1.55-.378-1.55-.378"
  }), /* @__PURE__ */ React__default.createElement("defs", null, /* @__PURE__ */ React__default.createElement("radialGradient", {
    id: "paint0_angular",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(6.93142 0 0 6.94133 11.251 12.911)",
    gradientUnits: "userSpaceOnUse"
  }, /* @__PURE__ */ React__default.createElement("stop", {
    stopColor: "#1390DD"
  }), /* @__PURE__ */ React__default.createElement("stop", {
    offset: ".257",
    stopColor: "#ED2324"
  }), /* @__PURE__ */ React__default.createElement("stop", {
    offset: ".476",
    stopColor: "#E59F1C"
  }), /* @__PURE__ */ React__default.createElement("stop", {
    offset: ".75",
    stopColor: "#5ABA47"
  })))),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "3.96",
    d: "M21.54 12.94H7.64v27.765h27.726V26.801"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.98",
    d: "M37.005 7.85s1.666-.679 3.1.755c1.433 1.433.752 3.1.752 3.1L24.24 28.315c-.223.224-.497.39-.798.487l-5.212 1.67 1.67-5.212c.096-.301.264-.575.487-.798L37.005 7.851z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "1.98",
    d: "M24.203 28.385s.68-1.666-.753-3.1c-1.434-1.433-3.1-.754-3.1-.754"
  }), /* @__PURE__ */ React__default.createElement("defs", null, /* @__PURE__ */ React__default.createElement("radialGradient", {
    id: "paint0_angular",
    cx: "0",
    cy: "0",
    r: "1",
    gradientTransform: "matrix(13.8628 0 0 13.8827 21.503 26.823)",
    gradientUnits: "userSpaceOnUse"
  }, /* @__PURE__ */ React__default.createElement("stop", {
    stopColor: "#1390DD"
  }), /* @__PURE__ */ React__default.createElement("stop", {
    offset: ".257",
    stopColor: "#ED2324"
  }), /* @__PURE__ */ React__default.createElement("stop", {
    offset: ".476",
    stopColor: "#E59F1C"
  }), /* @__PURE__ */ React__default.createElement("stop", {
    offset: ".75",
    stopColor: "#5ABA47"
  }))))
};
var NBY = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$4h,
    fill: "none"
  }));
});
var compPaths$4g = {
  s: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M21 8.719L7.836 14.303C6.74 14.768 5.818 15 5.075 15c-.836 0-1.445-.295-1.819-.884-.485-.76-.273-1.982.559-3.272.494-.754 1.122-1.446 1.734-2.108-.144.234-1.415 2.349-.025 3.345.275.2.666.298 1.147.298.386 0 .829-.063 1.316-.19L21 8.719z",
      clipRule: "evenodd"
    })
  }),
  m: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M21 8.719L7.836 14.303C6.74 14.768 5.818 15 5.075 15c-.836 0-1.445-.295-1.819-.884-.485-.76-.273-1.982.559-3.272.494-.754 1.122-1.446 1.734-2.108-.144.234-1.415 2.349-.025 3.345.275.2.666.298 1.147.298.386 0 .829-.063 1.316-.19L21 8.719z",
      clipRule: "evenodd"
    })
  }),
  l: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M42 17.438L15.672 28.606C13.48 29.536 11.636 30 10.15 30c-1.672 0-2.89-.59-3.638-1.768-.97-1.518-.546-3.964 1.118-6.544.988-1.508 2.244-2.892 3.468-4.216-.288.468-2.83 4.698-.05 6.69.55.4 1.332.596 2.294.596.772 0 1.658-.126 2.632-.38L42 17.438z",
      clipRule: "evenodd"
    })
  })
};
var NikeApp = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ jsx$1(SvgIcon, {
    ...Object.assign({}, props, {
      paths: compPaths$4g,
      fill: "none"
    })
  });
});
NikeApp.displayName = "[Deprecated] NikeApp";
var compPaths$4f = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21 8.719L7.836 14.303C6.74 14.768 5.818 15 5.075 15c-.836 0-1.445-.295-1.819-.884-.485-.76-.273-1.982.559-3.272.494-.754 1.122-1.446 1.734-2.108-.144.234-1.415 2.349-.025 3.345.275.2.666.298 1.147.298.386 0 .829-.063 1.316-.19L21 8.719z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21 8.719L7.836 14.303C6.74 14.768 5.818 15 5.075 15c-.836 0-1.445-.295-1.819-.884-.485-.76-.273-1.982.559-3.272.494-.754 1.122-1.446 1.734-2.108-.144.234-1.415 2.349-.025 3.345.275.2.666.298 1.147.298.386 0 .829-.063 1.316-.19L21 8.719z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M42 17.438L15.672 28.606C13.48 29.536 11.636 30 10.15 30c-1.672 0-2.89-.59-3.638-1.768-.97-1.518-.546-3.964 1.118-6.544.988-1.508 2.244-2.892 3.468-4.216-.288.468-2.83 4.698-.05 6.69.55.4 1.332.596 2.294.596.772 0 1.658-.126 2.632-.38L42 17.438z",
    clipRule: "evenodd"
  }))
};
var NikeSwoosh = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$4f,
    fill: "none"
  }));
});
var compPaths$4e = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.196 12.105l2.442 1.313c.66.36 1.31.758 1.815 1.18.036.022.06.048.084.071.457.398.782.83.854 1.323a.89.89 0 01-.18.686c-.156.218-.505.495-1.214.567-.194.023-.867.072-1.36.023-.192-.01-.373-.035-.529-.048a9.552 9.552 0 01-.77-.107l.008.185c.007.523-.088.99-.344 1.343a.906.906 0 01-.613.348c-.265.037-.71-.012-1.262-.456-.145-.12-.662-.554-.975-.939-.426-.503-.684-.828-.79-.991l-.027-.045c-.397.458-.83.782-1.323.855a.895.895 0 01-.686-.18c-.217-.157-.493-.506-.565-1.216a7.688 7.688 0 01-.024-1.36c.072-.723.12-1.155.156-1.312.036-.013.073-.013.108-.013.012.098.06.796.157 1.024.216.505.48.783.793.854.554.109 1.239-.444 1.9-1.059l.072-.07c.322-.321 1.556-1.547 1.924-1.916 0 0 0 .013.013.013l.018.012.018.012-1.31 2.455c-.301.552-.619 1.095-.967 1.553l-.213.265c.072.06.601.516.83.613.517.206.902.229 1.167.049.438-.292.55-1.078.592-1.915l.009-.18v-2.816h.06l.817 2.647c.205.723.386 1.457.445 2.118l.004.013c.092-.013.79-.06 1.02-.157.504-.216.78-.481.852-.794.109-.553-.444-1.24-1.058-1.902l-.672-.672c-.355-.355-.775-.775-1.064-1.066l-.248-.248c0-.011.013-.011.013-.023.011-.012.023-.024.023-.037zm4.474-5.319s.012.011.036.024c.204.168.468.518.541 1.204.024.192.072.866.024 1.36-.07.704-.118 1.133-.154 1.3.596-.035 1.12.05 1.513.336.012.013.024.013.036.025.18.131.288.337.325.577.035.265-.012.71-.458 1.263-.12.145-.553.663-.938.976-.553.469-.889.734-1.034.818-.035-.023-.06-.048-.084-.072.06-.073.517-.603.613-.83.205-.518.23-.904.048-1.168-.313-.47-1.19-.566-2.092-.602h-2.813c0-.012 0-.036-.013-.06l2.659-.806c.72-.206 1.454-.386 2.115-.445l.01-.003.002.014c-.012-.095-.06-.793-.156-1.022-.217-.506-.481-.795-.794-.856-.553-.12-1.238.434-1.9 1.048-.06.06-.552.554-1.044 1.045l-.94.94c-.012-.01-.012-.023-.024-.023l-.018-.013-.018-.011 1.298-2.443c.362-.662.746-1.313 1.18-1.818.023-.036.048-.06.072-.085.396-.457.829-.781 1.322-.854a.895.895 0 01.686.181zM7.434 9.337c.037.025.06.048.084.072-.06.073-.517.603-.613.831-.204.518-.229.903-.048 1.167.292.439 1.077.552 1.913.595l.18.007h2.813c0 .008 0 .021.004.037l.008.024-2.657.818c-.601.17-1.211.324-1.78.405l-.337.04h-.108c-.601.036-1.142-.048-1.54-.337a.86.86 0 01-.348-.601c-.024-.265.024-.71.457-1.264l.107-.127c.184-.217.523-.598.831-.848.541-.458.89-.734 1.034-.82zm5.436-3.863c.144.12.66.553.973.938.47.554.734.891.819 1.036-.024.036-.049.06-.073.085-.072-.062-.6-.518-.83-.615-.517-.204-.901-.229-1.166-.048-.437.292-.55 1.077-.593 1.913l-.008.182v2.804l-.036.001-.036.01-.806-2.659c-.17-.603-.324-1.212-.406-1.781l-.039-.338v.013c-.096.012-.793.06-1.022.156-.505.216-.794.481-.854.794-.108.553.445 1.24 1.059 1.902l.602.603 1.134 1.136.248.246-.012.012-.012.02-.012.017-2.442-1.312c-.66-.362-1.31-.746-1.815-1.18a.468.468 0 01-.084-.072c-.458-.398-.783-.83-.854-1.323a.898.898 0 01.168-.674c.156-.217.504-.494 1.215-.566a7.676 7.676 0 011.359-.024c.721.072 1.154.12 1.31.157v-.013c-.035-.602.048-1.144.337-1.54a.906.906 0 01.613-.349c.277-.025.71.024 1.263.469z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.252 12.136l3.14 1.687c.849.465 1.684.976 2.333 1.517.047.03.077.062.108.092.588.512 1.006 1.068 1.098 1.702.047.31-.03.62-.232.882-.2.28-.649.636-1.56.728-.25.03-1.114.093-1.748.03-.247-.014-.48-.045-.68-.062-.526-.06-.851-.107-.99-.138l.01.239c.009.672-.114 1.272-.444 1.727a1.165 1.165 0 01-.787.447c-.34.047-.913-.015-1.623-.587-.186-.154-.851-.712-1.253-1.207-.549-.647-.88-1.064-1.017-1.274l-.034-.058c-.51.59-1.067 1.006-1.7 1.1-.31.046-.62-.032-.883-.232-.278-.202-.633-.65-.726-1.564-.03-.247-.093-1.113-.03-1.748.092-.929.154-1.486.2-1.687.046-.016.093-.016.139-.016.015.125.078 1.022.201 1.316.278.65.618 1.006 1.02 1.098.712.14 1.593-.57 2.444-1.362l.09-.09c.415-.412 2.002-1.99 2.475-2.463 0 0 0 .017.017.017l.023.015.023.016-1.685 3.156c-.387.709-.795 1.407-1.242 1.997l-.274.34c.093.077.773.664 1.067.789.665.264 1.16.294 1.5.062.563-.375.708-1.386.762-2.461l.01-.233v-3.62h.078l1.05 3.404c.265.929.496 1.872.573 2.723l.005.017c.119-.017 1.016-.077 1.31-.202.65-.278 1.005-.619 1.097-1.021.14-.712-.571-1.595-1.36-2.446l-.865-.864-1.368-1.37-.319-.32c0-.014.017-.014.017-.03.014-.015.03-.03.03-.046zm5.751-6.839s.016.015.047.03c.263.217.603.666.696 1.548.03.247.093 1.114.03 1.749-.09.906-.15 1.458-.198 1.671.767-.044 1.44.066 1.945.433.016.016.032.016.047.032.232.169.371.433.418.742.046.34-.016.912-.588 1.624-.155.186-.712.852-1.206 1.254-.712.604-1.144.944-1.33 1.052-.045-.03-.076-.062-.108-.092.077-.094.665-.775.789-1.068.262-.665.294-1.162.06-1.501-.401-.604-1.53-.727-2.688-.774h-3.618c0-.016 0-.046-.016-.078l3.418-1.036c.926-.264 1.87-.495 2.72-.572l.013-.004.003.018c-.016-.122-.078-1.02-.202-1.314-.278-.65-.618-1.022-1.02-1.1-.712-.154-1.592.558-2.443 1.347-.078.078-.71.712-1.343 1.344l-1.207 1.209c-.017-.015-.017-.03-.031-.03l-.024-.017-.023-.014 1.67-3.14c.463-.853.958-1.69 1.515-2.338.03-.047.062-.077.093-.11.51-.588 1.066-1.004 1.7-1.098.31-.046.619.032.881.233zM6.13 8.577c.046.032.076.062.108.092-.077.094-.665.775-.789 1.07-.263.664-.294 1.16-.061 1.5.374.563 1.384.709 2.459.764l.23.01h3.618c0 .009 0 .027.005.047l.01.03-3.416 1.053c-.772.218-1.557.416-2.29.52l-.431.051h-.14c-.772.047-1.468-.061-1.978-.433-.247-.17-.402-.448-.45-.773-.029-.34.032-.913.589-1.625l.137-.163c.237-.278.673-.768 1.069-1.09.696-.589 1.145-.944 1.33-1.053zm6.988-4.967c.185.155.85.712 1.252 1.206.604.713.943 1.146 1.052 1.332-.03.047-.062.077-.093.11-.093-.08-.773-.667-1.067-.792-.665-.261-1.16-.294-1.5-.06-.562.375-.708 1.384-.762 2.46l-.01.232v3.606l-.046.001-.047.013L10.86 8.3c-.22-.776-.416-1.56-.522-2.291l-.05-.435v.017c-.124.016-1.02.077-1.314.2-.65.279-1.021.62-1.098 1.022-.14.711.572 1.595 1.36 2.445l.774.776 1.46 1.46.318.317-.016.015-.015.024-.016.023-3.14-1.686c-.849-.465-1.684-.96-2.333-1.518a.603.603 0 01-.108-.092c-.588-.511-1.006-1.067-1.098-1.702-.047-.31.03-.618.216-.866.201-.279.649-.635 1.562-.727.247-.032 1.113-.094 1.747-.032.928.093 1.485.155 1.685.202v-.016c-.046-.775.061-1.47.433-1.98a1.16 1.16 0 01.789-.448c.355-.033.912.03 1.623.602z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M24.504 24.272l6.278 3.374c1.7.929 3.37 1.951 4.668 3.034.094.06.154.125.216.185 1.176 1.022 2.012 2.136 2.196 3.403.094.621-.06 1.24-.463 1.764-.4.559-1.298 1.272-3.122 1.457-.497.06-2.227.184-3.495.06-.494-.03-.96-.092-1.36-.125-1.052-.12-1.702-.214-1.98-.276l.019.477c.019 1.344-.226 2.544-.886 3.454-.37.494-.926.804-1.574.895-.682.094-1.827-.031-3.247-1.173-.372-.31-1.702-1.426-2.506-2.415-1.097-1.293-1.76-2.129-2.033-2.549l-.07-.115c-1.02 1.179-2.133 2.011-3.4 2.199a2.303 2.303 0 01-1.764-.464c-.557-.403-1.267-1.3-1.452-3.127-.063-.494-.187-2.227-.063-3.497.185-1.857.31-2.97.401-3.374.094-.031.188-.031.279-.031.03.25.156 2.045.403 2.633.554 1.298 1.236 2.01 2.04 2.196 1.423.278 3.185-1.143 4.886-2.724l.183-.183c.828-.823 4.003-3.977 4.948-4.925 0 0 0 .034.034.034l.046.031.045.032-3.37 6.311c-.772 1.419-1.588 2.816-2.483 3.994l-.547.682c.184.153 1.545 1.327 2.133 1.576 1.33.528 2.318.588 3 .125 1.126-.751 1.416-2.772 1.524-4.922l.022-.466v-7.24h.153l2.103 6.808c.528 1.858.99 3.744 1.144 5.446a.197.197 0 01.01.033c.238-.033 2.033-.153 2.62-.403 1.3-.557 2.01-1.238 2.194-2.042.279-1.423-1.142-3.19-2.721-4.891l-1.728-1.728-2.736-2.741-.639-.639c0-.028.034-.028.034-.06.029-.03.06-.06.06-.093zm11.503-13.678s.031.03.094.06c.525.435 1.205 1.332 1.392 3.096.06.495.185 2.227.06 3.497-.18 1.812-.303 2.916-.396 3.343 1.533-.088 2.88.132 3.89.867.031.03.063.03.094.062.463.339.741.867.835 1.486.091.679-.031 1.824-1.176 3.247-.31.372-1.423 1.704-2.412 2.508-1.423 1.207-2.287 1.889-2.66 2.105-.09-.06-.153-.125-.215-.185.153-.187 1.33-1.55 1.577-2.136.525-1.33.588-2.323.122-3.003-.804-1.207-3.06-1.454-5.378-1.547h-7.236c0-.032 0-.092-.032-.157l6.836-2.07c1.852-.529 3.739-.992 5.44-1.145l.027-.008.005.036c-.032-.244-.156-2.04-.404-2.628-.556-1.3-1.236-2.044-2.04-2.2-1.423-.308-3.184 1.116-4.886 2.695-.156.156-1.42 1.423-2.686 2.688l-2.414 2.417c-.034-.03-.034-.06-.062-.06l-.048-.034-.046-.029 3.338-6.28c.93-1.705 1.918-3.378 3.032-4.676.062-.093.124-.153.187-.218 1.017-1.176 2.131-2.01 3.4-2.196a2.291 2.291 0 011.762.465zm-23.748 6.56c.094.064.154.124.216.184-.153.188-1.33 1.55-1.576 2.139-.526 1.33-.588 2.32-.123 3 .749 1.128 2.767 1.418 4.918 1.529l.46.019h7.236c0 .019 0 .055.01.096l.022.06-6.833 2.104c-1.546.437-3.115.833-4.58 1.042l-.863.1h-.279c-1.545.095-2.937-.122-3.957-.866-.495-.34-.804-.895-.898-1.545-.06-.682.063-1.826 1.176-3.25l.274-.326c.475-.557 1.346-1.536 2.138-2.182 1.392-1.176 2.29-1.886 2.66-2.104zM26.237 7.22c.37.31 1.699 1.423 2.503 2.412 1.207 1.426 1.886 2.292 2.105 2.664-.063.094-.125.154-.187.218-.185-.158-1.546-1.332-2.134-1.581-1.33-.523-2.318-.588-3-.123-1.123.752-1.416 2.77-1.524 4.92l-.022.466v7.212l-.09.002-.094.027-2.072-6.838c-.439-1.55-.832-3.117-1.044-4.581l-.1-.87v.034c-.247.032-2.04.154-2.628.401-1.299.557-2.043 1.239-2.196 2.043-.279 1.423 1.144 3.19 2.721 4.89l1.548 1.551 2.919 2.92.636.635-.031.03-.032.049-.03.045-6.28-3.372c-1.698-.93-3.369-1.92-4.667-3.036a1.205 1.205 0 01-.216-.184c-1.176-1.023-2.011-2.134-2.196-3.404a2.309 2.309 0 01.432-1.732c.403-.557 1.298-1.27 3.124-1.455.495-.062 2.225-.187 3.495-.062 1.855.185 2.969.31 3.37.403v-.031c-.092-1.55.122-2.943.866-3.963.37-.494.926-.804 1.577-.895.71-.065 1.824.06 3.247 1.205z",
    clipRule: "evenodd"
  }))
};
var Sustainability = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$4e,
    fill: "none"
  }));
});
var compPaths$4d = {
  s: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      stroke: "currentColor",
      strokeWidth: "1.5",
      d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5zm8.75 0h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25zm-8.75 0h5.5v-12h-5.5v12z",
      clipRule: "evenodd"
    })
  }),
  m: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      stroke: "currentColor",
      strokeWidth: "1.5",
      d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5zm8.75 0h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25zm-8.75 0h5.5v-12h-5.5v12z",
      clipRule: "evenodd"
    })
  }),
  l: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      stroke: "currentColor",
      strokeWidth: "3",
      d: "M18.5 40.5H12A4.5 4.5 0 017.5 36V25.5h11v15zm17.5 0h-6.5v-33h11V36a4.5 4.5 0 01-4.5 4.5zm-17.5 0h11v-24h-11v24z",
      clipRule: "evenodd"
    })
  })
};
var Activity = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ jsx$1(SvgIcon, {
    ...Object.assign({}, props, {
      paths: compPaths$4d,
      fill: "none"
    })
  });
});
Activity.displayName = "[Deprecated] Activity";
var compPaths$4c = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 20.25h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.25 20.25h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 20.25h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.25 20.25h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.5 40.5H12A4.5 4.5 0 017.5 36V25.5h11v15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.5 40.5H12A4.5 4.5 0 017.5 36V25.5h11v15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M36 40.5h-6.5v-33h11V36a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 40.5h-6.5v-33h11V36a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.5 40.5h11v-24h-11v24z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.5 40.5h11v-24h-11v24z",
    clipRule: "evenodd"
  }))
};
var ActivityFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$4c,
    fill: "none"
  }));
});
var compPaths$4b = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5zm8.75 0h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25zm-8.75 0h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5zm8.75 0h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25zm-8.75 0h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M18.5 40.5H12A4.5 4.5 0 017.5 36V25.5h11v15zm17.5 0h-6.5v-33h11V36a4.5 4.5 0 01-4.5 4.5zm-17.5 0h11v-24h-11v24z",
    clipRule: "evenodd"
  }))
};
var ActivityStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$4b,
    fill: "none"
  }));
});
var compPaths$4a = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 21v-3A3.75 3.75 0 016 14.25h6A3.75 3.75 0 0115.75 18v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 15V7.5M15 11.25h7.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 21v-3A3.75 3.75 0 016 14.25h6A3.75 3.75 0 0115.75 18v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 15V7.5M15 11.25h7.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M4.5 42v-6a7.5 7.5 0 017.5-7.5h12a7.5 7.5 0 017.5 7.5v6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M25.5 15a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M37.5 30V15M30 22.5h15"
  }))
};
var AddFriends = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$4a,
    fill: "none"
  }));
});
var compPaths$49 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.25 16.5v-9A2.25 2.25 0 0018 5.25H6A2.25 2.25 0 003.75 7.5v9A2.25 2.25 0 006 18.75h6m-8.25-9h16.5m-3 5.25v7.5M21 18.75h-7.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.25 16.5v-9A2.25 2.25 0 0018 5.25H6A2.25 2.25 0 003.75 7.5v9A2.25 2.25 0 006 18.75h6m-8.25-9h16.5m-3 5.25v7.5M21 18.75h-7.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M40.5 33V15a4.5 4.5 0 00-4.5-4.5H12A4.5 4.5 0 007.5 15v18c0 2.484 2.016 4.5 4.5 4.5h12m-16.5-18h33m-6 10.5v15m7.5-7.5H27"
  }))
};
var AddPayment = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$49,
    fill: "none"
  }));
});
var compPaths$48 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 17v-1.5m0-1.5V7"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M11.99 15V6m0 12v-1.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M23.98 30V12m0 24v-3"
  }))
};
var Alert = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$48,
    fill: "none"
  }));
});
var compPaths$47 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 19.25c4 0 7.25-3.25 7.25-7.25S16 4.75 12 4.75 4.75 8 4.75 12 8 19.25 12 19.25zM12 17v-1.5m0-1.5V7"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M11.99 15V6m0 12v-1.5m.01 5.25c5.385 0 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25 2.25 6.615 2.25 12s4.365 9.75 9.75 9.75z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M23.98 30V12m0 24v-3M24 43.5c10.77 0 19.5-8.73 19.5-19.5S34.77 4.5 24 4.5 4.5 13.23 4.5 24 13.23 43.5 24 43.5z"
  }))
};
var AlertCircle = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$47,
    fill: "none"
  }));
});
var compPaths$46 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm.75 13h-1.5v-1.5h1.5V17zm0-3h-1.5V7h1.5v7z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 1.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5zm.74 16.5h-1.5v-1.5h1.5V18zm0-3h-1.5V6h1.5v9z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M24 3C12.42 3 3 12.42 3 24s9.42 21 21 21 21-9.42 21-21S35.58 3 24 3zm1.48 33h-3v-3h3v3zm0-6h-3V12h3v18z"
  }))
};
var AlertCircleFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$46,
    fill: "none"
  }));
});
var compPaths$45 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5zm8.75 0h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25zm-8.75 0h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5zm8.75 0h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25zm-8.75 0h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.5 40.5H12A4.5 4.5 0 017.5 36V25.5h11v15zm17.5 0h-6.5v-33h11V36a4.5 4.5 0 01-4.5 4.5zm-17.5 0h11v-24h-11v24z",
    clipRule: "evenodd"
  }))
};
var Analytics = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$45,
    fill: "none"
  }));
});
var compPaths$44 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 20.25h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.25 20.25h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 20.25h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.25 20.25h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 20.25h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.5 40.5H12A4.5 4.5 0 017.5 36V25.5h11v15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.5 40.5H12A4.5 4.5 0 017.5 36V25.5h11v15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M36 40.5h-6.5v-33h11V36a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 40.5h-6.5v-33h11V36a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.5 40.5h11v-24h-11v24z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.5 40.5h11v-24h-11v24z",
    clipRule: "evenodd"
  }))
};
var AnalyticsFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$44,
    fill: "none"
  }));
});
var compPaths$43 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5zm8.75 0h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25zm-8.75 0h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5zm8.75 0h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25zm-8.75 0h5.5v-12h-5.5v12z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M18.5 40.5H12A4.5 4.5 0 017.5 36V25.5h11v15zm17.5 0h-6.5v-33h11V36a4.5 4.5 0 01-4.5 4.5zm-17.5 0h11v-24h-11v24z",
    clipRule: "evenodd"
  }))
};
var AnalyticsStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$43,
    fill: "none"
  }));
});
var compPaths$42 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.389 10.5l2.61 1.5 2.613-1.5M12 12v2.5m0 2.5v2.814m6.75-3.897L16.308 14.5M5.25 15.917L7.692 14.5M12 7.314V4.5M5.25 8.397l2.442 1.417M18.75 8.397l-2.442 1.417m-6.875 8.518L12 19.814l2.567-1.482m0-12.35L12 4.5 9.433 5.982m6.75 11.418l2.567-1.483v-2.964m0-1.592V8.397l-2.567-1.482M7.817 17.4L5.25 15.916v-2.964m0-1.591V8.397l2.567-1.482"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.389 10.5l2.61 1.5 2.613-1.5M12 12v2.5m0 2.5v2.814m6.75-3.897L16.308 14.5M5.25 15.917L7.692 14.5M12 7.314V4.5M5.25 8.397l2.442 1.417M18.75 8.397l-2.442 1.417m-6.875 8.518L12 19.814l2.567-1.482m0-12.35L12 4.5 9.433 5.982m6.75 11.418l2.567-1.483v-2.964m0-1.592V8.397l-2.567-1.482M7.817 17.4L5.25 15.916v-2.964m0-1.591V8.397l2.567-1.482"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.777 21L24 24l5.224-3M24 24v5m0 5v5.628m13.5-7.794L32.616 29M10.5 31.834L15.384 29M24 14.629V9.001m-13.5 7.794l4.884 2.834M37.5 16.795l-4.884 2.834m-13.75 17.035L24 39.628l5.134-2.964m0-24.699L24 9l-5.134 2.964m13.5 22.835l5.134-2.964v-5.928m0-3.184v-5.928l-5.134-2.964M15.634 34.799L10.5 31.835v-5.928m0-3.184v-5.928l5.134-2.964"
  }))
};
var AR = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$42,
    fill: "none"
  }));
});
var compPaths$41 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 8.25V6a2.25 2.25 0 012.25-2.25h3a2.25 2.25 0 110 4.5H3.75v8.25a3.75 3.75 0 003.75 3.75h9a3.75 3.75 0 003.75-3.75V8.25H17.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 8.25V6a2.25 2.25 0 012.25-2.25h3a2.25 2.25 0 110 4.5H3.75v8.25a3.75 3.75 0 003.75 3.75h9a3.75 3.75 0 003.75-3.75V8.25H17.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.5 16.5V12A4.5 4.5 0 0121 7.5h6a4.5 4.5 0 014.5 4.5 4.5 4.5 0 01-4.5 4.5H7.5V33a7.5 7.5 0 007.5 7.5h18a7.5 7.5 0 007.5-7.5V16.5H35"
  }))
};
var Bag = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$41,
    fill: "none"
  }));
});
var compPaths$40 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 6c0-.827.673-1.5 1.5-1.5h3c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5H9V6zm7.083 1.5c.258-.443.417-.951.417-1.5 0-1.654-1.346-3-3-3h-3c-1.654 0-3 1.346-3 3v1.5H3v9C3 18.981 5.019 21 7.5 21h9c2.481 0 4.5-2.019 4.5-4.5v-9h-4.917z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 6c0-.827.673-1.5 1.5-1.5h3c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5H9V6zm7.083 1.5c.258-.443.417-.951.417-1.5 0-1.654-1.346-3-3-3h-3c-1.654 0-3 1.346-3 3v1.5H3v9C3 18.981 5.019 21 7.5 21h9c2.481 0 4.5-2.019 4.5-4.5v-9h-4.917z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 12c0-1.654 1.346-3 3-3h6c1.654 0 3 1.346 3 3s-1.346 3-3 3h-9v-3zm14.166 3c.516-.886.834-1.902.834-3 0-3.308-2.692-6-6-6h-6c-3.308 0-6 2.692-6 6v3H6v18c0 4.962 4.038 9 9 9h18c4.962 0 9-4.038 9-9V15h-9.834z",
    clipRule: "evenodd"
  }))
};
var BagFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$40,
    fill: "none"
  }));
});
var compPaths$3$ = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M8.25 8.25V6a2.25 2.25 0 012.25-2.25h3a2.25 2.25 0 110 4.5H3.75v8.25a3.75 3.75 0 003.75 3.75h9a3.75 3.75 0 003.75-3.75V8.25H17.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M8.25 8.25V6a2.25 2.25 0 012.25-2.25h3a2.25 2.25 0 110 4.5H3.75v8.25a3.75 3.75 0 003.75 3.75h9a3.75 3.75 0 003.75-3.75V8.25H17.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M16.5 16.5V12A4.5 4.5 0 0121 7.5h6a4.5 4.5 0 014.5 4.5 4.5 4.5 0 01-4.5 4.5H7.5V33a7.5 7.5 0 007.5 7.5h18a7.5 7.5 0 007.5-7.5V16.5H35"
  }))
};
var BagStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3$,
    fill: "none"
  }));
});
var compPaths$3_ = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 3.75h9A2.25 2.25 0 0118.75 6v13.499a.75.75 0 01-1.28.53L12 14.559l-5.47 5.47a.75.75 0 01-1.28-.53V6A2.25 2.25 0 017.5 3.75z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 3.75h9A2.25 2.25 0 0118.75 6v13.499a.75.75 0 01-1.28.53L12 14.559l-5.47 5.47a.75.75 0 01-1.28-.53V6A2.25 2.25 0 017.5 3.75z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 7.5h18a4.5 4.5 0 014.5 4.5v26.998c0 1.336-1.616 2.004-2.56 1.06L24 29.118l-10.94 10.94c-.944.944-2.56.276-2.56-1.06V12A4.5 4.5 0 0115 7.5z",
    clipRule: "evenodd"
  }))
};
var Bookmark = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3_,
    fill: "none"
  }));
});
var compPaths$3Z = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.999 21c-.39 0-.771-.154-1.06-.44L12 15.62l-4.939 4.94a1.497 1.497 0 01-1.635.325 1.495 1.495 0 01-.926-1.387V6c0-1.654 1.346-3 3-3h9c1.654 0 3 1.346 3 3v13.498A1.505 1.505 0 0117.999 21z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.999 21c-.39 0-.771-.154-1.06-.44L12 15.62l-4.939 4.94a1.497 1.497 0 01-1.635.325 1.495 1.495 0 01-.926-1.387V6c0-1.654 1.346-3 3-3h9c1.654 0 3 1.346 3 3v13.498A1.505 1.505 0 0117.999 21z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M35.998 41.999c-.78 0-1.542-.306-2.12-.88L24 31.239l-9.878 9.88a2.995 2.995 0 01-3.27.65A2.99 2.99 0 019 38.997V11.999c0-3.308 2.692-6 6-6h18c3.308 0 6 2.692 6 6v26.998a2.99 2.99 0 01-1.852 2.772 3.01 3.01 0 01-1.15.23z",
    clipRule: "evenodd"
  }))
};
var BookmarkFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3Z,
    fill: "none"
  }));
});
var compPaths$3Y = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M7.5 3.75h9A2.25 2.25 0 0118.75 6v13.499a.75.75 0 01-1.28.53L12 14.559l-5.47 5.47a.75.75 0 01-1.28-.53V6A2.25 2.25 0 017.5 3.75z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M7.5 3.75h9A2.25 2.25 0 0118.75 6v13.499a.75.75 0 01-1.28.53L12 14.559l-5.47 5.47a.75.75 0 01-1.28-.53V6A2.25 2.25 0 017.5 3.75z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M15 7.5h18a4.5 4.5 0 014.5 4.5v26.998c0 1.336-1.616 2.004-2.56 1.06L24 29.118l-10.94 10.94c-.944.944-2.56.276-2.56-1.06V12A4.5 4.5 0 0115 7.5z",
    clipRule: "evenodd"
  }))
};
var BookmarkStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3Y,
    fill: "none"
  }));
});
var compPaths$3X = {
  s: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      fill: "currentColor",
      d: "M19.5 18.44L5.56 4.5 4.5 5.56l1.7 1.7A7.442 7.442 0 004.5 12c0 4.14 3.36 7.5 7.5 7.5 1.8 0 3.45-.64 4.74-1.7l1.7 1.7 1.06-1.06zM12 18c-3.31 0-6-2.69-6-6 0-1.38.48-2.65 1.27-3.67l8.4 8.4A5.977 5.977 0 0112 18zm0-12c3.31 0 6 2.69 6 6 0 .83-.17 1.62-.48 2.34l1.12 1.12c.54-1.04.85-2.21.85-3.46 0-4.14-3.36-7.5-7.5-7.5-1.25 0-2.43.31-3.46.85l1.12 1.12C10.38 6.17 11.17 6 12 6z"
    })
  }),
  m: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      fill: "currentColor",
      d: "M19.5 18.44L5.56 4.5 4.5 5.56l1.7 1.7A7.442 7.442 0 004.5 12c0 4.14 3.36 7.5 7.5 7.5 1.8 0 3.45-.64 4.74-1.7l1.7 1.7 1.06-1.06zM12 18c-3.31 0-6-2.69-6-6 0-1.38.48-2.65 1.27-3.67l8.4 8.4A5.977 5.977 0 0112 18zm0-12c3.31 0 6 2.69 6 6 0 .83-.17 1.62-.48 2.34l1.12 1.12c.54-1.04.85-2.21.85-3.46 0-4.14-3.36-7.5-7.5-7.5-1.25 0-2.43.31-3.46.85l1.12 1.12C10.38 6.17 11.17 6 12 6z"
    })
  }),
  l: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      fill: "currentColor",
      d: "M39 36.88L11.12 9 9 11.12l3.4 3.4C10.28 17.1 9 20.4 9 24c0 8.28 6.72 15 15 15 3.6 0 6.9-1.28 9.48-3.4l3.4 3.4L39 36.88zM24 36c-6.62 0-12-5.38-12-12 0-2.76.96-5.3 2.54-7.34l16.8 16.8C29.3 35.04 26.76 36 24 36zm0-24c6.62 0 12 5.38 12 12 0 1.66-.34 3.24-.96 4.68l2.24 2.24c1.08-2.08 1.7-4.42 1.7-6.92 0-8.28-6.72-15-15-15-2.5 0-4.86.62-6.92 1.7l2.24 2.24c1.46-.6 3.04-.94 4.7-.94z"
    })
  })
};
var BrightnessNone = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ jsx$1(SvgIcon, {
    ...Object.assign({}, props, {
      paths: compPaths$3X,
      fill: "none"
    })
  });
});
BrightnessNone.displayName = "[Deprecated] BrightnessNone";
var compPaths$3W = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V7.5A2.25 2.25 0 016 5.25h12a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.25 9.75H3.75M8.25 3v4.5m7.5-4.5v4.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V7.5A2.25 2.25 0 016 5.25h12a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.25 9.75H3.75M8.25 3v4.5m7.5-4.5v4.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 40.5H12A4.5 4.5 0 017.5 36V15a4.5 4.5 0 014.5-4.5h24a4.5 4.5 0 014.5 4.5v21a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M40.5 19.5h-33m9-13.5v9m15-9v9"
  }))
};
var Calendar = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3W,
    fill: "none"
  }));
});
var compPaths$3V = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 13.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.5 6.75h2A2.25 2.25 0 0121.75 9v7.5A3.75 3.75 0 0118 20.25H6a3.75 3.75 0 01-3.75-3.75V9A2.25 2.25 0 014.5 6.75h9.75a1.5 1.5 0 100-3h-4.5a1.5 1.5 0 00-1.5 1.5V6M6 9.75H4.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 13.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.5 6.75h2A2.25 2.25 0 0121.75 9v7.5A3.75 3.75 0 0118 20.25H6a3.75 3.75 0 01-3.75-3.75V9A2.25 2.25 0 014.5 6.75h9.75a1.5 1.5 0 100-3h-4.5a1.5 1.5 0 00-1.5 1.5V6M6 9.75H4.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.5 27a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M35 13.5h4a4.5 4.5 0 014.5 4.5v15a7.5 7.5 0 01-7.5 7.5H12A7.5 7.5 0 014.5 33V18A4.5 4.5 0 019 13.5h19.5a3 3 0 100-6h-9a3 3 0 00-3 3V12M12 19.5H9"
  }))
};
var Camera = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3V,
    fill: "none"
  }));
});
var compPaths$3U = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 3.75h15A2.25 2.25 0 0123.25 6v9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.468 13.293c-.747-.548-.177-1.646.025-1.973-.364.402-.728.803-1.011 1.24-.446.685-.637 1.436-.335 1.919.54.868 1.84.466 2.668.117l7.685-3.242-7.594 2.005c-.636.166-1.147.144-1.438-.066z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 18.75H4.5a2.25 2.25 0 01-2.25-2.25V9A2.25 2.25 0 014.5 6.75H18A2.25 2.25 0 0120.25 9v7.5A2.25 2.25 0 0118 18.75z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 3.75h15A2.25 2.25 0 0123.25 6v9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.468 13.293c-.747-.548-.177-1.646.025-1.973-.364.402-.728.803-1.011 1.24-.446.685-.637 1.436-.335 1.919.54.868 1.84.466 2.668.117l7.685-3.242-7.594 2.005c-.636.166-1.147.144-1.438-.066z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 18.75H4.5a2.25 2.25 0 01-2.25-2.25V9A2.25 2.25 0 014.5 6.75H18A2.25 2.25 0 0120.25 9v7.5A2.25 2.25 0 0118 18.75z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M12 7.5h30c2.484 0 4.5 2.016 4.5 4.5v18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.936 26.586c-1.494-1.096-.354-3.292.05-3.946-.728.804-1.456 1.606-2.022 2.482-.892 1.368-1.274 2.87-.67 3.836 1.082 1.736 3.68.932 5.336.234L33 22.708l-15.188 4.01c-1.272.332-2.294.288-2.876-.132z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 37.5H9A4.502 4.502 0 014.5 33V18c0-2.484 2.016-4.5 4.5-4.5h27c2.484 0 4.5 2.016 4.5 4.5v15c0 2.484-2.016 4.5-4.5 4.5z",
    clipRule: "evenodd"
  }))
};
var Cards = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3U,
    fill: "none"
  }));
});
var compPaths$3T = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.5 11.5l3.75 3.75L17.5 8"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.03 11.69l4.753 4.754 9.186-9.188"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M10.06 23.382l9.507 9.506 18.372-18.376"
  }))
};
var Check = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3T,
    fill: "none"
  }));
});
var compPaths$3S = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15 10l-4 4-2-2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 19.25c4 0 7.25-3.25 7.25-7.25S16 4.75 12 4.75 4.75 8 4.75 12 8 19.25 12 19.25z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.712 9.663l-4.772 4.773-2.652-2.65"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 24c0 10.77-8.73 19.5-19.5 19.5S4.5 34.77 4.5 24 13.23 4.5 24 4.5 43.5 13.23 43.5 24z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.424 19.326l-9.544 9.546-5.304-5.302"
  }))
};
var CheckCircle = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3S,
    fill: "none"
  }));
});
var compPaths$3R = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm-1 11.06l-2.53-2.53 1.06-1.06L11 12.94l3.47-3.47 1.06 1.06L11 15.06z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 1.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5zm-1.06 14l-3.18-3.18 1.06-1.06 2.12 2.12 4.24-4.24 1.06 1.06-5.3 5.3z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M24 3C12.42 3 3 12.42 3 24s9.42 21 21 21 21-9.42 21-21S35.58 3 24 3zm-2.12 28l-6.36-6.36 2.12-2.12 4.24 4.24 8.48-8.48 2.12 2.12L21.88 31z"
  }))
};
var CheckCircleFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3R,
    fill: "none"
  }));
});
var compPaths$3Q = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 21v-3A3.75 3.75 0 016 14.25h6A3.75 3.75 0 0115.75 18v3M15 12.75h3a3.75 3.75 0 013.75 3.75v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zm7.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 21v-3A3.75 3.75 0 016 14.25h6A3.75 3.75 0 0115.75 18v3M15 12.75h3a3.75 3.75 0 013.75 3.75v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zm7.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M4.5 42v-6a7.5 7.5 0 017.5-7.5h12a7.5 7.5 0 017.5 7.5v6M30 25.5h6a7.5 7.5 0 017.5 7.5v6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M25.5 15a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0zm15 0a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z",
    clipRule: "evenodd"
  }))
};
var Club = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3Q,
    fill: "none"
  }));
});
var compPaths$3P = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 21H1.5v-3c0-2.481 2.019-4.5 4.5-4.5h6c2.481 0 4.5 2.019 4.5 4.5v3H15",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 19.5V12h3c2.481 0 4.5 2.019 4.5 4.5v3H21M9 12a4.505 4.505 0 01-4.5-4.5C4.5 5.019 6.519 3 9 3s4.5 2.019 4.5 4.5S11.481 12 9 12zm9-1.5c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 21H1.5v-3c0-2.481 2.019-4.5 4.5-4.5h6c2.481 0 4.5 2.019 4.5 4.5v3H15",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 19.5V12h3c2.481 0 4.5 2.019 4.5 4.5v3H21M9 12a4.505 4.505 0 01-4.5-4.5C4.5 5.019 6.519 3 9 3s4.5 2.019 4.5 4.5S11.481 12 9 12zm9-1.5c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 42H3v-6c0-4.962 4.038-9 9-9h12c4.962 0 9 4.038 9 9v6h-3",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M30 39V24h6c4.962 0 9 4.038 9 9v6h-3M18 24c-4.962 0-9-4.038-9-9s4.038-9 9-9 9 4.038 9 9-4.038 9-9 9zm18-3c-3.308 0-6-2.692-6-6s2.692-6 6-6 6 2.692 6 6-2.692 6-6 6z",
    clipRule: "evenodd"
  }))
};
var ClubFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3P,
    fill: "none"
  }));
});
var compPaths$3O = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M2.25 21v-3A3.75 3.75 0 016 14.25h6A3.75 3.75 0 0115.75 18v3M15 12.75h3a3.75 3.75 0 013.75 3.75v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M12.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zm7.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M2.25 21v-3A3.75 3.75 0 016 14.25h6A3.75 3.75 0 0115.75 18v3M15 12.75h3a3.75 3.75 0 013.75 3.75v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M12.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zm7.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M4.5 42v-6a7.5 7.5 0 017.5-7.5h12a7.5 7.5 0 017.5 7.5v6M30 25.5h6a7.5 7.5 0 017.5 7.5v6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M25.5 15a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0zm15 0a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z",
    clipRule: "evenodd"
  }))
};
var ClubStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3O,
    fill: "none"
  }));
});
var compPaths$3N = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M3.75 21v-3c0-2.07 1.68-3.75 3.75-3.75h9c2.07 0 3.75 1.68 3.75 3.75v3m-12-14.25H19.5m-7.5 4.5a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M3.75 21v-3c0-2.07 1.68-3.75 3.75-3.75h9c2.07 0 3.75 1.68 3.75 3.75v3m-12-14.25H19.5m-7.5 4.5a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M7.5 42v-6c0-4.14 3.36-7.5 7.5-7.5h18c4.14 0 7.5 3.36 7.5 7.5v6m-24-28.5H39m-15 9a7.5 7.5 0 100-15 7.5 7.5 0 000 15z"
  }))
};
var Coach = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3N,
    fill: "none"
  }));
});
var compPaths$3M = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.75 21v-6.75H3M14.25 3v6.75H21"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.75 21v-6.75H3M14.25 3v6.75H21"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M19.5 42V28.5H6M28.5 6v13.5H42"
  }))
};
var Collapse = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3M,
    fill: "none"
  }));
});
var compPaths$3L = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16 17.25h2A2.25 2.25 0 0020.25 15V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v9A2.25 2.25 0 006 17.25h6a2.25 2.25 0 012.25 2.25V21"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16 17.25h2A2.25 2.25 0 0020.25 15V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v9A2.25 2.25 0 006 17.25h6a2.25 2.25 0 012.25 2.25V21"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M32 34.5h4a4.5 4.5 0 004.5-4.5V12A4.5 4.5 0 0036 7.5H12A4.5 4.5 0 007.5 12v18a4.5 4.5 0 004.5 4.5h12a4.5 4.5 0 014.5 4.5v3"
  }))
};
var Comments = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3L,
    fill: "none"
  }));
});
var compPaths$3K = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20 8.25H4.5m3.27 11.21l-3.71-3.71 3.71-3.71m8.46-7.5l3.71 3.71-3.71 3.71M4 15.75h15.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20 8.25H4.5m3.27 11.21l-3.71-3.71 3.71-3.71m8.46-7.5l3.71 3.71-3.71 3.71M4 15.75h15.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M40 16.5H9m6.54 22.42L8.12 31.5l7.42-7.42m16.92-15l7.42 7.42-7.42 7.42M8 31.5h31"
  }))
};
var Compare = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3K,
    fill: "none"
  }));
});
var compPaths$3J = {
  s: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      stroke: "currentColor",
      strokeWidth: "1.5",
      d: "M19.25 12c0 4-3.24 7.25-7.25 7.25S4.75 16 4.75 12 7.99 4.75 12 4.75 19.25 8 19.25 12zM12 8v8m4-4H8"
    })
  }),
  m: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      stroke: "currentColor",
      strokeWidth: "1.5",
      d: "M21.75 12c0 5.39-4.36 9.75-9.75 9.75S2.25 17.39 2.25 12 6.61 2.25 12 2.25s9.75 4.36 9.75 9.75zM12 6v12m6-6H6"
    })
  }),
  l: /* @__PURE__ */ jsx$1(Fragment, {
    children: /* @__PURE__ */ jsx$1("path", {
      stroke: "currentColor",
      strokeWidth: "3",
      d: "M43.5 24c0 10.78-8.72 19.5-19.5 19.5S4.5 34.78 4.5 24 13.22 4.5 24 4.5 43.5 13.22 43.5 24zM24 12v24m12-12H12"
    })
  })
};
var CreateRule = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ jsx$1(SvgIcon, {
    ...Object.assign({}, props, {
      paths: compPaths$3J,
      fill: "none"
    })
  });
});
CreateRule.displayName = "[Deprecated] CreateRule";
var compPaths$3I = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm4 8.75h-3.25V16h-1.5v-3.25H8v-1.5h3.25V8h1.5v3.25H16v1.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 1.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5zm6 11.25h-5.25V18h-1.5v-5.25H6v-1.5h5.25V6h1.5v5.25H18v1.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M24 3C12.42 3 3 12.42 3 24s9.42 21 21 21 21-9.42 21-21S35.58 3 24 3zm12 22.5H25.5V36h-3V25.5H12v-3h10.5V12h3v10.5H36v3z"
  }))
};
var CreateRuleFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3I,
    fill: "none"
  }));
});
var compPaths$3H = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M13.75 10v7m-3.5-7v7m-3.5-8.5V17c0 1.24 1.01 2.25 2.25 2.25h6c1.24 0 2.25-1.01 2.25-2.25V7.75h2.25m-10-3h3.75c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5H4.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.25 7.5v12m-4.5-12v12M5.25 6v13.5c0 1.24 1.01 2.25 2.25 2.25h9c1.24 0 2.25-1.01 2.25-2.25V5.25h2.75m-2.75 0H21m-12-3h5.25c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5H3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M28.5 15v24m-9-24v24m-9-27v27c0 2.48 2.02 4.5 4.5 4.5h18c2.48 0 4.5-2.02 4.5-4.5V10.5H43m-5.5 0H42m-24-6h10.5c1.66 0 3 1.34 3 3s-1.34 3-3 3H6"
  }))
};
var Delete = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3H,
    fill: "none"
  }));
});
var compPaths$3G = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M7.51 20.25h9m-3-3h6c1.24 0 2.25-1.01 2.25-2.25V6c0-1.24-1.01-2.25-2.25-2.25h-15C3.27 3.75 2.26 4.76 2.26 6v9c0 1.24 1.01 2.25 2.25 2.25h5c1.24 0 2.25 1.01 2.25 2.25v.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M7.51 20.25h9m-3-3h6c1.24 0 2.25-1.01 2.25-2.25V6c0-1.24-1.01-2.25-2.25-2.25h-15C3.27 3.75 2.26 4.76 2.26 6v9c0 1.24 1.01 2.25 2.25 2.25h5c1.24 0 2.25 1.01 2.25 2.25v.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M15.02 40.5h18m-6-6h12c2.48 0 4.5-2.02 4.5-4.5V12c0-2.48-2.02-4.5-4.5-4.5h-30c-2.48 0-4.5 2.02-4.5 4.5v18c0 2.48 2.02 4.5 4.5 4.5h10c2.48 0 4.5 2.02 4.5 4.5v1.5"
  }))
};
var Desktop = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3G,
    fill: "none"
  }));
});
var compPaths$3F = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.55 9.55l-1.792 6.693 6.69-1.794 1.794-6.691L9.55 9.55z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.55 9.55l-1.792 6.693 6.69-1.794 1.794-6.691L9.55 9.55z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M19.102 19.102l-3.586 13.384 13.382-3.588 3.586-13.382-13.382 3.586z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 24c0 10.77-8.73 19.5-19.5 19.5S4.5 34.77 4.5 24 13.23 4.5 24 4.5 43.5 13.23 43.5 24z",
    clipRule: "evenodd"
  }))
};
var Discover = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3F,
    fill: "none"
  }));
});
var compPaths$3E = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.837 13.837l-5.02 1.345 1.346-5.02 5.019-1.344-1.345 5.019zM12 1.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.837 13.837l-5.02 1.345 1.346-5.02 5.019-1.344-1.345 5.019zM12 1.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M27.674 27.674l-10.038 2.69 2.69-10.038 10.038-2.69-2.69 10.038zM24 3C12.42 3 3 12.422 3 24c0 11.58 9.42 21 21 21s21-9.42 21-21c0-11.578-9.42-21-21-21z",
    clipRule: "evenodd"
  }))
};
var DiscoverFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3E,
    fill: "none"
  }));
});
var compPaths$3D = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M9.55 9.55l-1.792 6.693 6.69-1.794 1.794-6.691L9.55 9.55z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M9.55 9.55l-1.792 6.693 6.69-1.794 1.794-6.691L9.55 9.55z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M19.102 19.102l-3.586 13.384 13.382-3.588 3.586-13.382-13.382 3.586z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M43.5 24c0 10.77-8.73 19.5-19.5 19.5S4.5 34.77 4.5 24 13.23 4.5 24 4.5 43.5 13.23 43.5 24z",
    clipRule: "evenodd"
  }))
};
var DiscoverStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3D,
    fill: "none"
  }));
});
var compPaths$3C = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.125 14.25A4.125 4.125 0 1012 10.125m2.25 4.125h2m-9 0h2.5m-2.25 0a3.75 3.75 0 010-7.5m8.212 10.97L12 21.432 8.288 17.72M12 20.75V10M6.75 7.5a5.25 5.25 0 019.094-3.576"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.125 14.25A4.125 4.125 0 1012 10.125m2.25 4.125h2m-9 0h2.5m-2.25 0a3.75 3.75 0 010-7.5m8.212 10.97L12 21.432 8.288 17.72M12 20.75V10M6.75 7.5a5.25 5.25 0 019.094-3.576"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M32.25 28.5A8.25 8.25 0 1024 20.25m4.5 8.25h4m-18 0h5m-4.5 0a7.5 7.5 0 010-15m16.424 21.94L24 42.864l-7.424-7.424M24 41.5V20"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 15c0-5.798 4.702-10.5 10.5-10.5 3.036 0 5.77 1.288 7.688 3.348"
  }))
};
var Download = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3C,
    fill: "none"
  }));
});
var compPaths$3B = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M6.94 20.25H3.76v-3.18L16.77 4.06l3.18 3.18L6.94 20.25zm8.08-13.69l2.63 2.63"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M6.94 20.25H3.76v-3.18L16.77 4.06l3.18 3.18L6.94 20.25zm8.08-13.69l2.63 2.63"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M13.88 40.5H7.52v-6.36L33.54 8.12l6.36 6.36L13.88 40.5zm16.16-27.38l5.26 5.26"
  }))
};
var Edit = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3B,
    fill: "none"
  }));
});
var compPaths$3A = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.5 14.25a2.25 2.25 0 11.002-4.502A2.25 2.25 0 014.5 14.25zm7.5 0a2.25 2.25 0 11.002-4.502A2.25 2.25 0 0112 14.25zm7.5 0a2.25 2.25 0 11.002-4.502 2.25 2.25 0 01-.002 4.502z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.5 14.25a2.25 2.25 0 11.002-4.502A2.25 2.25 0 014.5 14.25zm7.5 0a2.25 2.25 0 11.002-4.502A2.25 2.25 0 0112 14.25zm7.5 0a2.25 2.25 0 11.002-4.502 2.25 2.25 0 01-.002 4.502z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M9 28.5A4.502 4.502 0 014.5 24c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5-2.016 4.5-4.5 4.5zm15 0a4.502 4.502 0 01-4.5-4.5c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5-2.016 4.5-4.5 4.5zm15 0a4.502 4.502 0 01-4.5-4.5c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5-2.016 4.5-4.5 4.5z",
    clipRule: "evenodd"
  }))
};
var Ellipsis = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3A,
    fill: "none"
  }));
});
var compPaths$3z = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.25 19.5a2.25 2.25 0 11-4.502-.002 2.25 2.25 0 014.502.002zm0-7.5a2.25 2.25 0 11-4.502-.002A2.25 2.25 0 0114.25 12zm0-7.5a2.25 2.25 0 11-4.502-.002 2.25 2.25 0 014.502.002z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.25 19.5a2.25 2.25 0 11-4.502-.002 2.25 2.25 0 014.502.002zm0-7.5a2.25 2.25 0 11-4.502-.002A2.25 2.25 0 0114.25 12zm0-7.5a2.25 2.25 0 11-4.502-.002 2.25 2.25 0 014.502.002z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M28.5 39c0 2.484-2.016 4.5-4.5 4.5a4.502 4.502 0 01-4.5-4.5c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5zm0-15c0 2.484-2.016 4.5-4.5 4.5a4.502 4.502 0 01-4.5-4.5c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5zm0-15c0 2.484-2.016 4.5-4.5 4.5A4.502 4.502 0 0119.5 9c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5z",
    clipRule: "evenodd"
  }))
};
var EllipsisVertical = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3z,
    fill: "none"
  }));
});
var compPaths$3y = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 13.5v6.75h6.75m9.75-9.75V3.75H13.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 13.5v6.75h6.75m9.75-9.75V3.75H13.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 27v13.5H21M40.5 21V7.5H27"
  }))
};
var Expand = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3y,
    fill: "none"
  }));
});
var compPaths$3x = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M7.5 3.75h9m-6.75.5v5.89c0 .6-.24 1.17-.66 1.59l-4.68 4.68C3 17.83 4 20.25 6 20.25h12c2 0 3.01-2.42 1.59-3.84l-4.68-4.68c-.42-.42-.66-.99-.66-1.59V4M6.5 14.25h11.12"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M7.5 3.75h9m-6.75.5v5.89c0 .6-.24 1.17-.66 1.59l-4.68 4.68C3 17.83 4 20.25 6 20.25h12c2 0 3.01-2.42 1.59-3.84l-4.68-4.68c-.42-.42-.66-.99-.66-1.59V4M6.5 14.25h11.12"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M15 7.5h18m-13.501 1v11.78c0 1.2-.48 2.34-1.32 3.18l-9.36 9.36c-2.82 2.84-.82 7.68 3.18 7.68h24c4 0 6.02-4.84 3.18-7.68l-9.36-9.36a4.496 4.496 0 01-1.32-3.18V8M13 28.5h22.24"
  }))
};
var Experiments = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3x,
    fill: "none"
  }));
});
var compPaths$3w = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.92 7.25h-5c-1.24 0-2.25 1.01-2.25 2.25V17c0 1.24 1.01 2.25 2.25 2.25h7.5c1.24 0 2.25-1.01 2.25-2.25v-4.5m2.5-2.5V4.75h-5.25m-2.25 7.5l7.5-7.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 5.25H6c-1.24 0-2.25 1.01-2.25 2.25V18c0 1.24 1.01 2.25 2.25 2.25h10.5c1.24 0 2.25-1.01 2.25-2.25v-6m3-3V2.25H15m-3.75 10.5l10.5-10.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 10.5H12c-2.48 0-4.5 2.02-4.5 4.5v21c0 2.48 2.02 4.5 4.5 4.5h21c2.48 0 4.5-2.02 4.5-4.5V24m6-6V4.5H30m-7.5 21l21-21"
  }))
};
var ExternalLink = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3w,
    fill: "none"
  }));
});
var compPaths$3v = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.566 5.75c.984 0 1.91.385 2.606 1.082a3.707 3.707 0 010 5.228L12 18.25l-6.172-6.19a3.707 3.707 0 010-5.227A3.656 3.656 0 018.434 5.75c.985 0 1.91.385 2.606 1.082l.565.567.395.396.394-.396.566-.567a3.658 3.658 0 012.606-1.082"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.794 3.75c1.324 0 2.568.516 3.504 1.451a4.96 4.96 0 010 7.008L12 20.508l-8.299-8.299a4.96 4.96 0 010-7.007A4.923 4.923 0 017.205 3.75c1.324 0 2.568.516 3.504 1.451l.76.76.531.531.53-.531.76-.76a4.926 4.926 0 013.504-1.451"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33.589 7.5a9.852 9.852 0 017.008 2.902c3.866 3.864 3.866 10.152 0 14.016L24 41.016 7.403 24.418c-3.864-3.864-3.864-10.152 0-14.014A9.846 9.846 0 0114.41 7.5a9.852 9.852 0 017.008 2.902l1.52 1.52L24 12.984l1.06-1.062 1.52-1.52A9.852 9.852 0 0133.589 7.5"
  }))
};
var Favorite = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3v,
    fill: "none"
  }));
});
var compPaths$3u = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.566 5.75c.984 0 1.91.385 2.606 1.082a3.707 3.707 0 010 5.228L12 18.25l-6.172-6.19a3.707 3.707 0 010-5.227A3.656 3.656 0 018.434 5.75c.985 0 1.91.385 2.606 1.082l.565.567.395.396.394-.396.566-.567a3.658 3.658 0 012.606-1.082z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.566 5.75c.984 0 1.91.385 2.606 1.082a3.707 3.707 0 010 5.228L12 18.25l-6.172-6.19a3.707 3.707 0 010-5.227A3.656 3.656 0 018.434 5.75c.985 0 1.91.385 2.606 1.082l.565.567.395.396.394-.396.566-.567a3.658 3.658 0 012.606-1.082"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.794 3.75c1.324 0 2.568.516 3.504 1.451a4.96 4.96 0 010 7.008L12 20.508l-8.299-8.299a4.96 4.96 0 010-7.007A4.923 4.923 0 017.205 3.75c1.324 0 2.568.516 3.504 1.451l.76.76.531.531.53-.531.76-.76a4.926 4.926 0 013.504-1.451z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.794 3.75c1.324 0 2.568.516 3.504 1.451a4.96 4.96 0 010 7.008L12 20.508l-8.299-8.299a4.96 4.96 0 010-7.007A4.923 4.923 0 017.205 3.75c1.324 0 2.568.516 3.504 1.451l.76.76.531.531.53-.531.76-.76a4.926 4.926 0 013.504-1.451"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M33.589 7.5a9.852 9.852 0 017.008 2.902c3.866 3.864 3.866 10.152 0 14.016L24 41.016 7.403 24.418c-3.864-3.864-3.864-10.152 0-14.014A9.846 9.846 0 0114.41 7.5a9.852 9.852 0 017.008 2.902l1.52 1.52L24 12.984l1.06-1.062 1.52-1.52A9.852 9.852 0 0133.589 7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33.589 7.5a9.852 9.852 0 017.008 2.902c3.866 3.864 3.866 10.152 0 14.016L24 41.016 7.403 24.418c-3.864-3.864-3.864-10.152 0-14.014A9.846 9.846 0 0114.41 7.5a9.852 9.852 0 017.008 2.902l1.52 1.52L24 12.984l1.06-1.062 1.52-1.52A9.852 9.852 0 0133.589 7.5"
  }))
};
var FavoriteFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3u,
    fill: "none"
  }));
});
var compPaths$3t = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M15.566 5.75c.984 0 1.91.385 2.606 1.082a3.707 3.707 0 010 5.228L12 18.25l-6.172-6.19a3.707 3.707 0 010-5.227A3.656 3.656 0 018.434 5.75c.985 0 1.91.385 2.606 1.082l.565.567.395.396.394-.396.566-.567a3.658 3.658 0 012.606-1.082"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M16.794 3.75c1.324 0 2.568.516 3.504 1.451a4.96 4.96 0 010 7.008L12 20.508l-8.299-8.299a4.96 4.96 0 010-7.007A4.923 4.923 0 017.205 3.75c1.324 0 2.568.516 3.504 1.451l.76.76.531.531.53-.531.76-.76a4.926 4.926 0 013.504-1.451"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M33.589 7.5a9.852 9.852 0 017.008 2.902c3.866 3.864 3.866 10.152 0 14.016L24 41.016 7.403 24.418c-3.864-3.864-3.864-10.152 0-14.014A9.846 9.846 0 0114.41 7.5a9.852 9.852 0 017.008 2.902l1.52 1.52L24 12.984l1.06-1.062 1.52-1.52A9.852 9.852 0 0133.589 7.5"
  }))
};
var FavoriteStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3t,
    fill: "none"
  }));
});
var compPaths$3s = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 8.25h9m-9 4.5H15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 8.25h9m-9 4.5H15"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 8.25h9m-9 4.5H15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 8.25h9m-9 4.5H15"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 40.5H12A4.5 4.5 0 017.5 36V12A4.5 4.5 0 0112 7.5h24a4.5 4.5 0 014.5 4.5v24a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 16.5h18m-18 9h15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 40.5H12A4.5 4.5 0 017.5 36V12A4.5 4.5 0 0112 7.5h24a4.5 4.5 0 014.5 4.5v24a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 16.5h18m-18 9h15"
  }))
};
var Feed = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3s,
    fill: "none"
  }));
});
var compPaths$3r = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 8.25h9m-9 4.5H15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M7.5 8.25h9m-9 4.5H15"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 8.25h9m-9 4.5H15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M7.5 8.25h9m-9 4.5H15"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 40.5H12A4.5 4.5 0 017.5 36V12A4.5 4.5 0 0112 7.5h24a4.5 4.5 0 014.5 4.5v24a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 16.5h18m-18 9h15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M36 40.5H12A4.5 4.5 0 017.5 36V12A4.5 4.5 0 0112 7.5h24a4.5 4.5 0 014.5 4.5v24a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M15 16.5h18m-18 9h15"
  }))
};
var FeedStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3r,
    fill: "none"
  }));
});
var compPaths$3q = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 8v0a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19 9.5h-9m-2 0H5m0 5h9m2 0h3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.75 13v0a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21 8.25H10m-5.25 0H3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 6v0a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3 15.75h10.75m5 0H21"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 13.5v0a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M42 16.5H20m-10.5 0H6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 12v0a4.5 4.5 0 100 9 4.5 4.5 0 000-9z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M6 31.5h21.5m10 0H42"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33 27v0a4.5 4.5 0 100 9 4.5 4.5 0 000-9z",
    clipRule: "evenodd"
  }))
};
var Filter = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3q,
    fill: "none"
  }));
});
var compPaths$3p = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.547",
    d: "M10.696 14.886a5.787 5.787 0 01-2.09.095 5.683 5.683 0 01-4.807-4.841 5.648 5.648 0 016.333-6.342 5.674 5.674 0 014.85 4.815 5.64 5.64 0 01-1.466 4.633 2.144 2.144 0 00.095 2.967l.99.99h1.735v1.734l1.301 1.302h2.603v-2.603l-4.286-4.286"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "bevel",
    strokeWidth: "1.5",
    d: "M8.75 10.5a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.547",
    d: "M10.696 14.886a5.787 5.787 0 01-2.09.095 5.683 5.683 0 01-4.807-4.841 5.648 5.648 0 016.333-6.342 5.674 5.674 0 014.85 4.815 5.64 5.64 0 01-1.466 4.633 2.144 2.144 0 00.095 2.967l.99.99h1.735v1.734l1.301 1.302h2.603v-2.603l-4.286-4.286"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "bevel",
    strokeWidth: "1.5",
    d: "M8.75 10.5a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3.094",
    d: "M21.393 29.771a11.561 11.561 0 01-4.182.191 11.366 11.366 0 01-9.613-9.682A11.296 11.296 0 0120.265 7.596a11.348 11.348 0 019.7 9.63 11.278 11.278 0 01-2.933 9.266 4.286 4.286 0 00.19 5.934l1.979 1.978h3.47v3.47l2.603 2.603h5.206v-5.205L31.908 26.7"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "bevel",
    strokeWidth: "3",
    d: "M17.5 21a3.5 3.5 0 100-7 3.5 3.5 0 000 7z"
  }))
};
var FirstAccess = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3p,
    fill: "none"
  }));
});
var compPaths$3o = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.25 13v6.5c0 1.24-1.01 2.25-2.25 2.25s-2.25-1.01-2.25-2.25v-8.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M10.829 11.25h2.342a3 3 0 002.809-1.947l1.267-3.377a.5.5 0 00-.468-.676H7.22a.5.5 0 00-.468.676L8.02 9.303a3 3 0 002.809 1.947z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15v1.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.25 13v6.5c0 1.24-1.01 2.25-2.25 2.25s-2.25-1.01-2.25-2.25v-8.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M10.829 11.25h2.342a3 3 0 002.809-1.947l1.267-3.377a.5.5 0 00-.468-.676H7.22a.5.5 0 00-.468.676L8.02 9.303a3 3 0 002.809 1.947z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15v1.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M28.5 26v13c0 2.48-2.02 4.5-4.5 4.5s-4.5-2.02-4.5-4.5V21.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M21.658 22.5h4.684a6 6 0 005.618-3.893l2.533-6.756a1 1 0 00-.936-1.351H14.443a1 1 0 00-.936 1.351l2.533 6.756a6 6 0 005.618 3.893z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 30v3"
  }))
};
var FlashlightOff = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3o,
    fill: "none"
  }));
});
var compPaths$3n = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.25 13v6.5c0 1.24-1.01 2.25-2.25 2.25s-2.25-1.01-2.25-2.25v-8.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M10.829 11.25h2.342a3 3 0 002.809-1.947l1.267-3.377a.5.5 0 00-.468-.676H7.22a.5.5 0 00-.468.676L8.02 9.303a3 3 0 002.809 1.947z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15v1.5M11.94 3V0M9.65 2.98L8.15.38m6.2 2.6l1.5-2.6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.25 13v6.5c0 1.24-1.01 2.25-2.25 2.25s-2.25-1.01-2.25-2.25v-8.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M10.829 11.25h2.342a3 3 0 002.809-1.947l1.267-3.377a.5.5 0 00-.468-.676H7.22a.5.5 0 00-.468.676L8.02 9.303a3 3 0 002.809 1.947z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15v1.5M11.94 3V0M9.65 2.98L8.15.38m6.2 2.6l1.5-2.6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M28.5 26v13c0 2.48-2.02 4.5-4.5 4.5s-4.5-2.02-4.5-4.5V21.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M21.658 22.5h4.684a6 6 0 005.618-3.893l2.533-6.756a1 1 0 00-.936-1.351H14.443a1 1 0 00-.936 1.351l2.533 6.756a6 6 0 005.618 3.893z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 30v3m-.12-27V0M19.3 5.96l-3-5.2m12.4 5.2l3-5.2"
  }))
};
var FlashlightOn = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3n,
    fill: "none"
  }));
});
var compPaths$3m = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 13.5v-2.25a1.5 1.5 0 10-3 0m0 2.25V9.75a1.5 1.5 0 10-3 0"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 13a1.5 1.5 0 113 0v2a6.726 6.726 0 01-1.977 4.773A6.732 6.732 0 0113.5 21.75a6.732 6.732 0 01-4.773-1.977l-6.059-6.059a1.501 1.501 0 012.122-2.121l2.18 2.18a.75.75 0 001.28-.531V5.25a1.5 1.5 0 113 0v8.25"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.013 2.166l1.591 1.591L14 5.334M5.487 2.166L3.896 3.757 5.5 5.334",
    opacity: ".2"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 13.5v-2.25a1.5 1.5 0 10-3 0m0 2.25V9.75a1.5 1.5 0 10-3 0"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 13a1.5 1.5 0 113 0v2a6.726 6.726 0 01-1.977 4.773A6.732 6.732 0 0113.5 21.75a6.732 6.732 0 01-4.773-1.977l-6.059-6.059a1.501 1.501 0 012.122-2.121l2.18 2.18a.75.75 0 001.28-.531V5.25a1.5 1.5 0 113 0v8.25"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.013 2.166l1.591 1.591L14 5.334M5.487 2.166L3.896 3.757 5.5 5.334",
    opacity: ".2"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 27v-4.5a3 3 0 10-6 0m0 4.5v-7.5a3 3 0 10-6 0"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 26a3 3 0 116 0v4c0 3.728-1.51 7.104-3.954 9.546A13.464 13.464 0 0127 43.5a13.464 13.464 0 01-9.546-3.954L5.336 27.428a3 3 0 014.244-4.242l4.36 4.36c.944.944 2.56.276 2.56-1.062V10.5a3 3 0 116 0V27"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M28.026 4.332l3.182 3.182L28 10.668M10.974 4.332L7.792 7.514 11 10.668",
    opacity: ".2"
  }))
};
var GestureSwipe = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3m,
    fill: "none"
  }));
});
var compPaths$3l = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.396 8.25a4.5 4.5 0 117.598-1.5",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 13.5v-2.25a1.5 1.5 0 00-3 0m0 2.25V9.75a1.5 1.5 0 00-3 0"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 13a1.5 1.5 0 013 0v2a6.73 6.73 0 01-1.977 4.773A6.73 6.73 0 0113.5 21.75a6.732 6.732 0 01-4.773-1.977l-6.059-6.059a1.501 1.501 0 012.122-2.121l2.18 2.18a.75.75 0 001.28-.531V5.25a1.5 1.5 0 113 0v8.25"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.396 8.25a4.5 4.5 0 117.598-1.5",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 13.5v-2.25a1.5 1.5 0 00-3 0m0 2.25V9.75a1.5 1.5 0 00-3 0"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 13a1.5 1.5 0 013 0v2a6.73 6.73 0 01-1.977 4.773A6.73 6.73 0 0113.5 21.75a6.732 6.732 0 01-4.773-1.977l-6.059-6.059a1.501 1.501 0 012.122-2.121l2.18 2.18a.75.75 0 001.28-.531V5.25a1.5 1.5 0 113 0v8.25"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M12.792 16.5a9 9 0 1115.196-3",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 27v-4.5a3.001 3.001 0 00-6 0m0 4.5v-7.5a3.001 3.001 0 00-6 0"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 26a3.001 3.001 0 016 0v4a13.46 13.46 0 01-3.954 9.546A13.46 13.46 0 0127 43.5a13.464 13.464 0 01-9.546-3.954L5.336 27.428a3 3 0 014.244-4.242l4.36 4.36c.944.944 2.56.276 2.56-1.062V10.5a3 3 0 116 0V27"
  }))
};
var GestureTap = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3l,
    fill: "none"
  }));
});
var compPaths$3k = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M3.76 10.5V8.25h16.5v3H6.76c-.83 0-1.5.67-1.5 1.5v6c0 .83.67 1.5 1.5 1.5h10.5c.83 0 1.5-.67 1.5-1.5v-7.5m-4.5-7.5c-1.24 0-2.25 1.01-2.25 2.25v2.25h2.25c1.24 0 2.25-1.01 2.25-2.25s-1.01-2.25-2.25-2.25zm-4.5 0c1.24 0 2.25 1.01 2.25 2.25v2.25H9.76C8.51 8.25 7.51 7.24 7.51 6s1-2.25 2.25-2.25zm2.25 4.78v11.72"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M3.76 10.5V8.25h16.5v3H6.76c-.83 0-1.5.67-1.5 1.5v6c0 .83.67 1.5 1.5 1.5h10.5c.83 0 1.5-.67 1.5-1.5v-7.5m-4.5-7.5c-1.24 0-2.25 1.01-2.25 2.25v2.25h2.25c1.24 0 2.25-1.01 2.25-2.25s-1.01-2.25-2.25-2.25zm-4.5 0c1.24 0 2.25 1.01 2.25 2.25v2.25H9.76C8.51 8.25 7.51 7.24 7.51 6s1-2.25 2.25-2.25zm2.25 4.78v11.72"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M7.52 21v-4.5h33v6h-27c-1.66 0-3 1.34-3 3v12c0 1.66 1.34 3 3 3h21c1.66 0 3-1.34 3-3v-15m-9-15c-2.48 0-4.5 2.02-4.5 4.5v4.5h4.5c2.48 0 4.5-2.02 4.5-4.5S31 7.5 28.52 7.5zm-9 0c2.48 0 4.5 2.02 4.5 4.5v4.5h-4.5c-2.5 0-4.5-2.02-4.5-4.5s2-4.5 4.5-4.5zm4.5 9.56V40.5"
  }))
};
var Gift = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3k,
    fill: "none"
  }));
});
var compPaths$3j = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.678 13.018c-.854-.627-.202-1.88.029-2.255-.417.459-.833.917-1.157 1.418-.51.782-.727 1.64-.383 2.19.618.995 2.104.536 3.05.136L18 10.8l-8.677 2.293c-.728.189-1.313.163-1.645-.076z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 16.5v-9A2.25 2.25 0 014.5 5.25h15a2.25 2.25 0 012.25 2.25v9a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.678 13.018c-.854-.627-.202-1.88.029-2.255-.417.459-.833.917-1.157 1.418-.51.782-.727 1.64-.383 2.19.618.995 2.104.536 3.05.136L18 10.8l-8.677 2.293c-.728.189-1.313.163-1.645-.076z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 16.5v-9A2.25 2.25 0 014.5 5.25h15a2.25 2.25 0 012.25 2.25v9a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.355 26.035c-1.708-1.254-.404-3.76.058-4.51-.834.918-1.666 1.834-2.314 2.836-1.018 1.564-1.454 3.282-.766 4.382 1.236 1.988 4.208 1.07 6.1.27L36 21.601l-17.354 4.586c-1.456.378-2.626.326-3.29-.152z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M39 37.5H9A4.502 4.502 0 014.5 33V15c0-2.484 2.016-4.5 4.5-4.5h30c2.484 0 4.5 2.016 4.5 4.5v18c0 2.484-2.016 4.5-4.5 4.5z",
    clipRule: "evenodd"
  }))
};
var GiftCard = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3j,
    fill: "none"
  }));
});
var compPaths$3i = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 21.75c5.385 0 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25 2.25 6.615 2.25 12s4.365 9.75 9.75 9.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 21.75c2.9 0 5.25-4.365 5.25-9.75S14.9 2.25 12 2.25 6.75 6.615 6.75 12 9.1 21.75 12 21.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15.75c5.385 0 9.75-1.679 9.75-3.75 0-2.071-4.365-3.75-9.75-3.75S2.25 9.929 2.25 12c0 2.071 4.365 3.75 9.75 3.75z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 21.75c5.385 0 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25 2.25 6.615 2.25 12s4.365 9.75 9.75 9.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 21.75c2.9 0 5.25-4.365 5.25-9.75S14.9 2.25 12 2.25 6.75 6.615 6.75 12 9.1 21.75 12 21.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15.75c5.385 0 9.75-1.679 9.75-3.75 0-2.071-4.365-3.75-9.75-3.75S2.25 9.929 2.25 12c0 2.071 4.365 3.75 9.75 3.75z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 43.5c10.77 0 19.5-8.73 19.5-19.5S34.77 4.5 24 4.5 4.5 13.23 4.5 24 13.23 43.5 24 43.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 43.5c5.799 0 10.5-8.73 10.5-19.5S29.799 4.5 24 4.5 13.5 13.23 13.5 24 18.201 43.5 24 43.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 31.5c10.77 0 19.5-3.358 19.5-7.5 0-4.142-8.73-7.5-19.5-7.5S4.5 19.858 4.5 24c0 4.142 8.73 7.5 19.5 7.5z"
  }))
};
var Global = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3i,
    fill: "none"
  }));
});
var compPaths$3h = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.5 19.5h6v-6h-6v6zm-9 0h6v-6h-6v6zm9-9h6v-6h-6v6zm-9 0h6v-6h-6v6z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.5 19.5h6v-6h-6v6zm-9 0h6v-6h-6v6zm9-9h6v-6h-6v6zm-9 0h6v-6h-6v6z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M27 39h12V27H27v12zM9 39h12V27H9v12zm18-18h12V9H27v12zM9 21h12V9H9v12z",
    clipRule: "evenodd"
  }))
};
var GridView = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3h,
    fill: "none"
  }));
});
var compPaths$3g = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.98 11.795l1.354 1.354c.098-.37.167-.75.167-1.149 0-2.481-2.02-4.5-4.5-4.5-.4 0-.78.069-1.15.167l1.355 1.354a2.986 2.986 0 012.774 2.774zM12 18c-4.37 0-7.979-4.594-8.982-5.998.568-.798 1.981-2.611 3.886-4.039l1.437 1.436A4.443 4.443 0 007.501 12a4.504 4.504 0 004.5 4.5 4.44 4.44 0 002.6-.842l1.224 1.225C14.661 17.545 13.37 18 12 18zm-2.577-7.52l4.096 4.097A2.938 2.938 0 0112 15c-1.654 0-3-1.346-3-3 0-.557.156-1.074.423-1.52zm8.744 6.624l-1.06-1.061-1.446-1.444v-.001l-1.085-1.085-4.089-4.089L9.402 8.34 8.175 7.112h.001L7.093 6.029 4.06 2.998 3 4.06l2.844 2.843c-1.999 1.537-3.451 3.391-4.048 4.23a1.495 1.495 0 000 1.735C2.903 14.424 6.912 19.5 12 19.5c1.8 0 3.461-.64 4.911-1.531l3.03 3.029L21 19.937l-2.834-2.833z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.213 11.131C21.103 9.575 17.086 4.5 12 4.5c-1.248 0-2.43.309-3.523.793l1.146 1.146A6.945 6.945 0 0112 6c4.367 0 7.984 4.59 8.99 6a20.26 20.26 0 01-2.725 3.08l1.056 1.057a21.717 21.717 0 002.892-3.268 1.5 1.5 0 000-1.738z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.98 11.795l1.354 1.354c.098-.37.167-.75.167-1.149 0-2.481-2.02-4.5-4.5-4.5-.4 0-.78.069-1.15.167l1.355 1.354a2.986 2.986 0 012.774 2.774zM12 18c-4.37 0-7.979-4.594-8.982-5.998.568-.798 1.981-2.611 3.886-4.039l1.437 1.436A4.443 4.443 0 007.501 12a4.504 4.504 0 004.5 4.5 4.44 4.44 0 002.6-.842l1.224 1.225C14.661 17.545 13.37 18 12 18zm-2.577-7.52l4.096 4.097A2.938 2.938 0 0112 15c-1.654 0-3-1.346-3-3 0-.557.156-1.074.423-1.52zm8.744 6.624l-1.06-1.061-1.446-1.444v-.001l-1.085-1.085-4.089-4.089L9.402 8.34 8.175 7.112h.001L7.093 6.029 4.06 2.998 3 4.06l2.844 2.843c-1.999 1.537-3.451 3.391-4.048 4.23a1.495 1.495 0 000 1.735C2.903 14.424 6.912 19.5 12 19.5c1.8 0 3.461-.64 4.911-1.531l3.03 3.029L21 19.937l-2.834-2.833z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.213 11.131C21.103 9.575 17.086 4.5 12 4.5c-1.248 0-2.43.309-3.523.793l1.146 1.146A6.945 6.945 0 0112 6c4.367 0 7.984 4.59 8.99 6a20.26 20.26 0 01-2.725 3.08l1.056 1.057a21.717 21.717 0 002.892-3.268 1.5 1.5 0 000-1.738z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M29.96 23.59l2.707 2.708c.196-.74.334-1.5.334-2.298 0-4.962-4.038-9-9-9-.8 0-1.56.138-2.298.334l2.708 2.708a5.973 5.973 0 015.548 5.548z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M44.426 22.262C42.206 19.15 34.172 9 24 9c-2.496 0-4.862.618-7.046 1.586l2.292 2.292C20.76 12.328 22.352 12 24 12c8.734 0 15.968 9.18 17.98 12-.894 1.254-2.822 3.76-5.45 6.16l2.112 2.114c2.802-2.57 4.83-5.2 5.784-6.536a2.999 2.999 0 000-3.476zM24 36c-8.742 0-15.958-9.188-17.964-11.996 1.136-1.596 3.962-5.222 7.772-8.078l2.874 2.872A8.886 8.886 0 0015 24c0 4.962 4.038 9 9 9a8.879 8.879 0 005.202-1.684l2.448 2.45C29.322 35.09 26.738 36 24 36zm-5.154-15.04l8.192 8.194A5.876 5.876 0 0124 30c-3.308 0-6-2.692-6-6 0-1.114.312-2.148.846-3.04zm17.488 13.248l-2.122-2.122-2.89-2.888v-.002l-2.17-2.17-8.178-8.178-2.17-2.17-2.454-2.454h.002l-2.166-2.166h-.002L8.122 5.996 6 8.118l5.688 5.686c-3.998 3.074-6.902 6.782-8.096 8.46a2.99 2.99 0 000 3.47C5.806 28.848 13.824 39 24 39c3.6 0 6.922-1.28 9.822-3.062l6.058 6.058L42 39.874l-5.666-5.666z",
    clipRule: "evenodd"
  }))
};
var Hide = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3g,
    fill: "none"
  }));
});
var compPaths$3f = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 7v5l2.64 2.64"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M4.25 6.02v3.73h3.73"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 4.75c4.01 0 7.25 3.24 7.25 7.25s-3.24 7.25-7.25 7.25S4.75 16.01 4.75 12m.34-2.2C6.02 6.88 8.77 4.75 12 4.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 6v6l3 3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M3.25 5.5v4.25H7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 3.75c4.56 0 8.25 3.69 8.25 8.25 0 4.56-3.69 8.25-8.25 8.25-4.56 0-8.25-3.69-8.25-8.25m.39-2.5A8.25 8.25 0 0112 3.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 12v12l6 6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M6.5 11v8.5H15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 7.5c9.12 0 16.5 7.38 16.5 16.5 0 9.12-7.38 16.5-16.5 16.5-9.12 0-16.5-7.38-16.5-16.5m.78-5C10.38 12.34 16.64 7.5 24 7.5"
  }))
};
var History = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3f,
    fill: "none"
  }));
});
var compPaths$3e = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 20.25h12A2.25 2.25 0 0020.25 18v-7.148L12 3.975l-8.25 6.877V21"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 20.25h12A2.25 2.25 0 0020.25 18v-7.148L12 3.975l-8.25 6.877V21"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M12 40.5h24a4.5 4.5 0 004.5-4.5V21.704L24 7.95 7.5 21.704V42"
  }))
};
var Home = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3e,
    fill: "none"
  }));
});
var compPaths$3d = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.999L3 10.5V21h15c1.654 0 3-1.346 3-3v-7.5L12 3z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.999L3 10.5V21h15c1.654 0 3-1.346 3-3v-7.5L12 3z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M24 5.997L6 21v20.998h30c3.308 0 6-2.69 6-6V21L24 5.997z",
    clipRule: "evenodd"
  }))
};
var HomeFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3d,
    fill: "none"
  }));
});
var compPaths$3c = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 21H6v-1.5h12c.827 0 1.5-.673 1.5-1.5v-6.797L12 4.952l-7.5 6.251V21H3V10.501l9-7.502 9 7.502V18c0 1.654-1.346 3-3 3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: ".5",
    d: "M18 21H6v-1.5h12c.827 0 1.5-.673 1.5-1.5v-6.797L12 4.952l-7.5 6.251V21H3V10.501l9-7.502 9 7.502V18c0 1.654-1.346 3-3 3z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 21H6v-1.5h12c.827 0 1.5-.673 1.5-1.5v-6.797L12 4.952l-7.5 6.251V21H3V10.501l9-7.502 9 7.502V18c0 1.654-1.346 3-3 3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: ".5",
    d: "M18 21H6v-1.5h12c.827 0 1.5-.673 1.5-1.5v-6.797L12 4.952l-7.5 6.251V21H3V10.501l9-7.502 9 7.502V18c0 1.654-1.346 3-3 3z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M36 42H12v-3h24c1.654 0 3-1.346 3-3V22.406L24 9.904 9 22.406V42H6V21.002L24 5.998l18 15.004V36c0 3.308-2.692 6-6 6z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    d: "M36 42H12v-3h24c1.654 0 3-1.346 3-3V22.406L24 9.904 9 22.406V42H6V21.002L24 5.998l18 15.004V36c0 3.308-2.692 6-6 6z",
    clipRule: "evenodd"
  }))
};
var HomeStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3c,
    fill: "none"
  }));
});
var compPaths$3b = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 9a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 18.324l3.746-3.746 2.342 2.342 6.666-6.665 3.75 3.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 9a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 18.324l3.746-3.746 2.342 2.342 6.666-6.665 3.75 3.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 18a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 36.648l7.492-7.492 4.684 4.684 13.332-13.33 7.5 7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 40.5H12A4.5 4.5 0 017.5 36V12A4.5 4.5 0 0112 7.5h24a4.5 4.5 0 014.5 4.5v24a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }))
};
var ImagenoImage = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3b,
    fill: "none"
  }));
});
var compPaths$3a = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.567 6.1l-5.979 5.98a2.251 2.251 0 01-3.181 0l-5.55-5.55a.75.75 0 01.53-1.28H18a2.25 2.25 0 012.25 2.25v9A2.25 2.25 0 0118 18.75H6a2.25 2.25 0 01-2.25-2.25V9"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.567 6.1l-5.979 5.98a2.251 2.251 0 01-3.181 0l-5.55-5.55a.75.75 0 01.53-1.28H18a2.25 2.25 0 012.25 2.25v9A2.25 2.25 0 0118 18.75H6a2.25 2.25 0 01-2.25-2.25V9"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M39.135 12.201L27.177 24.16a4.503 4.503 0 01-6.364 0l-11.1-11.098c-.944-.944-.276-2.562 1.062-2.562h25.226c2.484 0 4.5 2.016 4.5 4.5v18a4.5 4.5 0 01-4.5 4.5h-24a4.5 4.5 0 01-4.5-4.5V18"
  }))
};
var Inbox = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3a,
    fill: "none"
  }));
});
var compPaths$39 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.937 11.55a1.503 1.503 0 002.12 0l6.566-6.566A2.975 2.975 0 0018 4.5H6c-.6 0-1.157.181-1.626.486l6.563 6.563z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.118 12.61a2.994 2.994 0 01-2.121.877 2.992 2.992 0 01-2.121-.877L3.364 6.098A2.96 2.96 0 003 7.5v9c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3v-9c0-.511-.14-.984-.366-1.406l-6.516 6.516z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.937 11.55a1.503 1.503 0 002.12 0l6.566-6.566A2.975 2.975 0 0018 4.5H6c-.6 0-1.157.181-1.626.486l6.563 6.563z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.118 12.61a2.994 2.994 0 01-2.121.877 2.992 2.992 0 01-2.121-.877L3.364 6.098A2.96 2.96 0 003 7.5v9c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3v-9c0-.511-.14-.984-.366-1.406l-6.516 6.516z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.873 23.099a3.006 3.006 0 004.242 0l13.132-13.13A5.95 5.95 0 0036 9H12c-1.2 0-2.314.362-3.252.972l13.126 13.126z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M28.236 25.22a5.988 5.988 0 01-4.242 1.754 5.984 5.984 0 01-4.241-1.754L6.728 12.196C6.278 13.038 6 13.982 6 15v18c0 3.308 2.692 6 6 6h24c3.309 0 6-2.692 6-6V15c0-1.022-.28-1.968-.731-2.812L28.237 25.22z",
    clipRule: "evenodd"
  }))
};
var InboxFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$39,
    fill: "none"
  }));
});
var compPaths$38 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M19.567 6.1l-5.979 5.98a2.251 2.251 0 01-3.181 0l-5.55-5.55a.75.75 0 01.53-1.28H18a2.25 2.25 0 012.25 2.25v9A2.25 2.25 0 0118 18.75H6a2.25 2.25 0 01-2.25-2.25V9"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M19.567 6.1l-5.979 5.98a2.251 2.251 0 01-3.181 0l-5.55-5.55a.75.75 0 01.53-1.28H18a2.25 2.25 0 012.25 2.25v9A2.25 2.25 0 0118 18.75H6a2.25 2.25 0 01-2.25-2.25V9"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M39.135 12.201L27.177 24.16a4.503 4.503 0 01-6.364 0l-11.1-11.098c-.944-.944-.276-2.562 1.062-2.562h25.226c2.484 0 4.5 2.016 4.5 4.5v18a4.5 4.5 0 01-4.5 4.5h-24a4.5 4.5 0 01-4.5-4.5V18"
  }))
};
var InboxStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$38,
    fill: "none"
  }));
});
var compPaths$37 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 7v1.5m0 1.5v7"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 9v9m0-12v1.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 18v18m0-24v3"
  }))
};
var Info = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$37,
    fill: "none"
  }));
});
var compPaths$36 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 7v1.5m0 1.5v7m0 2.25c4 0 7.25-3.25 7.25-7.25S16 4.75 12 4.75 4.75 8 4.75 12 8 19.25 12 19.25z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 9v9m0-12v1.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 24c0 10.77-8.73 19.5-19.5 19.5S4.5 34.77 4.5 24 13.23 4.5 24 4.5 43.5 13.23 43.5 24z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 18v18m0-24v3"
  }))
};
var InfoCircle = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$36,
    fill: "none"
  }));
});
var compPaths$35 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm.75 13h-1.5v-7h1.5v7zm0-8.5h-1.5V7h1.5v1.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 1.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5zm.75 16.5h-1.5V9h1.5v9zm0-10.5h-1.5V6h1.5v1.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M24 3C12.42 3 3 12.42 3 24s9.42 21 21 21 21-9.42 21-21S35.58 3 24 3zm1.5 33h-3V18h3v18zm0-21h-3v-3h3v3z"
  }))
};
var InfoCircleFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$35,
    fill: "none"
  }));
});
var compPaths$34 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.5 3.75H5.75a2 2 0 00-2 2v14a2 2 0 002 2h12.5a2 2 0 002-2v-14a2 2 0 00-2-2H17"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M6 6.75h5.5m-5.5 3h4m.75 12h4a2.498 2.498 0 002.5-2.5m0 0a2.46 2.46 0 00-.732-1.75 2.518 2.518 0 00-1.768-.75h-1V2.25h1a2.5 2.5 0 012.5 2.5v14.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.5 3.75H5.75a2 2 0 00-2 2v14a2 2 0 002 2h12.5a2 2 0 002-2v-14a2 2 0 00-2-2H17"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M6 6.75h5.5m-5.5 3h4m.75 12h4a2.498 2.498 0 002.5-2.5m0 0a2.46 2.46 0 00-.732-1.75 2.518 2.518 0 00-1.768-.75h-1V2.25h1a2.5 2.5 0 012.5 2.5v14.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M23 7.5H11.5a4 4 0 00-4 4v28a4 4 0 004 4h25a4 4 0 004-4v-28a4 4 0 00-4-4H34"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M12 13.5h11m-11 6h8m1.5 24h8a4.995 4.995 0 005-5m0 0a4.918 4.918 0 00-1.465-3.5c-.937-.938-2.209-1.5-3.535-1.5h-2v-29h2a5 5 0 015 5v29z"
  }))
};
var Journal = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$34,
    fill: "none"
  }));
});
var compPaths$33 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.53 16.773l-2.12 2.121a3.752 3.752 0 01-5.305-5.304l3.182-3.18a3.75 3.75 0 015.304 0l1.061 1.06"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.47 7.227l2.12-2.122a3.752 3.752 0 015.305 5.304l-3.182 3.182a3.75 3.75 0 01-5.304 0l-1.061-1.06"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.53 16.773l-2.12 2.121a3.752 3.752 0 01-5.305-5.304l3.182-3.18a3.75 3.75 0 015.304 0l1.061 1.06"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.47 7.227l2.12-2.122a3.752 3.752 0 015.305 5.304l-3.182 3.182a3.75 3.75 0 01-5.304 0l-1.061-1.06"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M25.06 33.547l-4.241 4.242a7.503 7.503 0 01-10.608 0 7.503 7.503 0 010-10.608l6.364-6.362a7.5 7.5 0 0110.608 0l2.122 2.12"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M22.94 14.454l4.241-4.244a7.503 7.503 0 0110.608 0 7.503 7.503 0 010 10.608l-6.364 6.364a7.5 7.5 0 01-10.608 0l-2.122-2.122"
  }))
};
var Link = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$33,
    fill: "none"
  }));
});
var compPaths$32 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 2.25A9.75 9.75 0 0121.75 12"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 2.25A9.75 9.75 0 0121.75 12"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 24c0 10.77-8.73 19.5-19.5 19.5S4.5 34.77 4.5 24 13.23 4.5 24 4.5 43.5 13.23 43.5 24z",
    clipRule: "evenodd",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 4.5c10.77 0 19.5 8.73 19.5 19.5"
  }))
};
var Loading = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$32,
    fill: "none"
  }));
});
var compPaths$31 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 19.25l-.61.436a.75.75 0 001.22 0L12 19.25zm4.5-8.998c0 1.32-.854 2.947-2.006 4.577-.56.794-1.164 1.55-1.714 2.229-.54.666-1.052 1.282-1.39 1.756l1.22.872c.304-.425.77-.987 1.335-1.683a43.976 43.976 0 001.774-2.308C16.871 14.065 18 12.091 18 10.252h-1.5zm-3.89 8.562c-.338-.474-.85-1.09-1.39-1.756a42.613 42.613 0 01-1.714-2.229C8.354 13.2 7.5 11.572 7.5 10.252H6c0 1.84 1.129 3.813 2.281 5.443.591.836 1.22 1.625 1.774 2.308.565.696 1.031 1.258 1.335 1.683l1.22-.872zM7.5 10.252C7.5 7.594 9.547 5.5 12 5.5V4c-3.347 0-6 2.833-6 6.252h1.5zM12 5.5c2.453 0 4.5 2.094 4.5 4.752H18C18 6.832 15.347 4 12 4v1.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.5 10a2.5 2.5 0 11-5 .002 2.5 2.5 0 015-.001z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 21.747l-.468.586a.75.75 0 00.936 0L12 21.747zM18 9c0 .92-.303 2.081-.824 3.362-.515 1.269-1.222 2.6-1.974 3.843a38.411 38.411 0 01-2.217 3.274c-.695.914-1.223 1.498-1.453 1.682l.936 1.172c.395-.314 1.023-1.042 1.711-1.947a39.904 39.904 0 002.306-3.404c.78-1.288 1.526-2.691 2.08-4.055.55-1.352.935-2.723.935-3.927H18zm-5.532 12.16c-.23-.183-.758-.767-1.453-1.681a38.41 38.41 0 01-2.217-3.274c-.752-1.243-1.458-2.574-1.974-3.843C6.303 11.081 6 9.921 6 9H4.5c0 1.204.385 2.575.934 3.927.555 1.364 1.302 2.767 2.08 4.055.78 1.288 1.6 2.474 2.307 3.404.688.905 1.316 1.633 1.711 1.947l.936-1.172zM6 9a6 6 0 016-6V1.5A7.5 7.5 0 004.5 9H6zm6-6a6 6 0 016 6h1.5A7.5 7.5 0 0012 1.5V3z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.25 9a3.25 3.25 0 11-6.5 0 3.25 3.25 0 016.5 0z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M24 43.5l-.936 1.173a1.5 1.5 0 001.872 0L24 43.5zm12-25.498c0 1.841-.606 4.163-1.647 6.725-1.032 2.538-2.444 5.2-3.949 7.688a76.834 76.834 0 01-4.434 6.547c-1.39 1.83-2.445 2.998-2.905 3.365l1.87 2.346c.79-.63 2.048-2.085 3.423-3.895a79.802 79.802 0 004.613-6.81c1.558-2.576 3.052-5.383 4.16-8.111C38.232 23.153 39 20.41 39 18.002h-3zM24.936 42.327c-.461-.367-1.516-1.535-2.906-3.364a76.834 76.834 0 01-4.434-6.548c-1.505-2.488-2.917-5.15-3.949-7.688C12.606 22.165 12 19.843 12 18.002H9c0 2.41.77 5.151 1.868 7.855 1.11 2.728 2.603 5.535 4.161 8.11a79.802 79.802 0 004.613 6.81c1.375 1.81 2.633 3.266 3.422 3.896l1.872-2.346zM12 18.002C12 11.373 17.373 6 24 6V3C15.715 3 9 9.717 9 18.002h3zM24 6c6.627 0 12 5.373 12 12.002h3C39 9.717 32.285 3 24 3v3z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M30.5 18a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z",
    clipRule: "evenodd"
  }))
};
var LocationPin = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$31,
    fill: "none"
  }));
});
var compPaths$30 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 10.252C6 6.832 8.653 4 12 4s6 2.833 6 6.252c0 1.84-1.129 3.813-2.281 5.443a43.976 43.976 0 01-1.774 2.308l-.277.34c-.44.541-.805.99-1.058 1.343a.75.75 0 01-1.22 0 30.643 30.643 0 00-1.058-1.343l-.277-.34a44.003 44.003 0 01-1.774-2.308C7.129 14.065 6 12.091 6 10.252zm6 2.25a2.5 2.5 0 100-5 2.5 2.5 0 000 5z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 9.001a7.5 7.5 0 1115 0c0 1.205-.385 2.576-.934 3.928-.555 1.364-1.302 2.767-2.08 4.055a39.918 39.918 0 01-2.307 3.405c-.688.905-1.316 1.632-1.711 1.947a.75.75 0 01-.936 0c-.395-.315-1.023-1.042-1.711-1.947a39.916 39.916 0 01-2.306-3.405c-.78-1.288-1.526-2.691-2.08-4.056-.55-1.351-.935-2.722-.935-3.927zM12 12.25a3.25 3.25 0 100-6.5 3.25 3.25 0 000 6.5z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 18.002C9 9.717 15.715 3 24 3s15 6.717 15 15.002c0 2.41-.77 5.151-1.868 7.855-1.11 2.728-2.603 5.535-4.161 8.11a79.802 79.802 0 01-4.613 6.81c-1.375 1.81-2.633 3.266-3.422 3.896a1.5 1.5 0 01-1.872 0c-.789-.63-2.047-2.085-3.422-3.895a79.802 79.802 0 01-4.613-6.81c-1.558-2.576-3.052-5.383-4.16-8.111C9.768 23.153 9 20.41 9 18.002zM24 24.5a6.5 6.5 0 100-13 6.5 6.5 0 000 13z",
    clipRule: "evenodd"
  }))
};
var LocationPinFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$30,
    fill: "none"
  }));
});
var compPaths$2$ = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.25 20.25H6.75c-.83 0-1.5-.67-1.5-1.5v-7.5c0-.83.67-1.5 1.5-1.5h10.5c.83 0 1.5.67 1.5 1.5v7.5c0 .83-.67 1.5-1.5 1.5zm-1.5-11V7.5c0-2.07-1.68-3.75-3.75-3.75-2.07 0-3.75 1.68-3.75 3.75v2.25M12 16v2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15.75a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.25 20.25H6.75c-.83 0-1.5-.67-1.5-1.5v-7.5c0-.83.67-1.5 1.5-1.5h10.5c.83 0 1.5.67 1.5 1.5v7.5c0 .83-.67 1.5-1.5 1.5zm-1.5-11V7.5c0-2.07-1.68-3.75-3.75-3.75-2.07 0-3.75 1.68-3.75 3.75v2.25M12 16v2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15.75a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M34.5 40.5h-21c-1.66 0-3-1.34-3-3v-15c0-1.66 1.34-3 3-3h21c1.66 0 3 1.34 3 3v15c0 1.66-1.34 3-3 3zm-3-22V15c0-4.14-3.36-7.5-7.5-7.5-4.14 0-7.5 3.36-7.5 7.5v4.5M24 32v4"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 31.5a3 3 0 100-6 3 3 0 000 6z"
  }))
};
var Lock = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2$,
    fill: "none"
  }));
});
var compPaths$2_ = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M17.25 9h-.75V7.5C16.5 5.02 14.48 3 12 3S7.5 5.02 7.5 7.5V9h-.75C5.51 9 4.5 10.01 4.5 11.25v7.5C4.5 19.99 5.51 21 6.75 21h10.5c1.24 0 2.25-1.01 2.25-2.25v-7.5c0-1.24-1.01-2.25-2.25-2.25zM9 7.5c0-1.65 1.35-3 3-3s3 1.35 3 3V9H9V7.5zm3.75 8.86V18h-1.5v-1.64c-.87-.31-1.5-1.14-1.5-2.11C9.75 13.01 10.76 12 12 12s2.25 1.01 2.25 2.25c0 .98-.63 1.8-1.5 2.11z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M17.25 9h-.75V7.5C16.5 5.02 14.48 3 12 3S7.5 5.02 7.5 7.5V9h-.75C5.51 9 4.5 10.01 4.5 11.25v7.5C4.5 19.99 5.51 21 6.75 21h10.5c1.24 0 2.25-1.01 2.25-2.25v-7.5c0-1.24-1.01-2.25-2.25-2.25zM9 7.5c0-1.65 1.35-3 3-3s3 1.35 3 3V9H9V7.5zm3.75 8.86V18h-1.5v-1.64c-.87-.31-1.5-1.14-1.5-2.11C9.75 13.01 10.76 12 12 12s2.25 1.01 2.25 2.25c0 .98-.63 1.8-1.5 2.11z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M34.5 18H33v-3c0-4.96-4.04-9-9-9s-9 4.04-9 9v3h-1.5C11.02 18 9 20.02 9 22.5v15c0 2.48 2.02 4.5 4.5 4.5h21c2.48 0 4.5-2.02 4.5-4.5v-15c0-2.48-2.02-4.5-4.5-4.5zM18 15c0-3.3 2.7-6 6-6s6 2.7 6 6v3H18v-3zm7.5 17.72V36h-3v-3.28c-1.74-.62-3-2.28-3-4.22 0-2.48 2.02-4.5 4.5-4.5s4.5 2.02 4.5 4.5c0 1.96-1.26 3.6-3 4.22z"
  }))
};
var LockFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2_,
    fill: "none"
  }));
});
var compPaths$2Z = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 10.5v6.75a1.5 1.5 0 01-1.5 1.5H3.75a1.5 1.5 0 01-1.5-1.5V10.5m3.308-2.25h12.885"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.79 5.599l2.652 2.65-2.652 2.653M8.21 5.599l-2.652 2.65 2.652 2.653M17.25 19v-2.5M12 19v-2.5M6.75 19v-2.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 10.5v6.75a1.5 1.5 0 01-1.5 1.5H3.75a1.5 1.5 0 01-1.5-1.5V10.5m3.308-2.25h12.885"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.79 5.599l2.652 2.65-2.652 2.653M8.21 5.599l-2.652 2.65 2.652 2.653M17.25 19v-2.5M12 19v-2.5M6.75 19v-2.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 21v13.5a3 3 0 01-3 3h-33a3 3 0 01-3-3V21m6.615-4.5h25.77"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.581 11.197l5.304 5.302-5.304 5.304M16.419 11.197L11.115 16.5l5.304 5.304M34.5 38v-5M24 38v-5m-10.5 5v-5"
  }))
};
var Measure = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2Z,
    fill: "none"
  }));
});
var compPaths$2Y = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 9.75l1.5-6h13.5l1.5 6v7.5a3 3 0 01-3 3H3.75V9.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20.25 9.75H3.75M12 4v6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M9.26 14.694c-.64-.474-.154-1.414.02-1.694-.314.347-.628.687-.868 1.06-.38.587-.546 1.234-.286 1.647.466.747 1.58.4 2.287.1L17 13.027l-6.507 1.72c-.547.14-.987.127-1.234-.053z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 9.75l1.5-6h13.5l1.5 6v7.5a3 3 0 01-3 3H3.75V9.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20.25 9.75H3.75M12 4v6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M9.26 14.694c-.64-.474-.154-1.414.02-1.694-.314.347-.628.687-.868 1.06-.38.587-.546 1.234-.286 1.647.466.747 1.58.4 2.287.1L17 13.027l-6.507 1.72c-.547.14-.987.127-1.234-.053z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 19.5l3-12h27l3 12v15a6 6 0 01-6 6h-27v-21z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M40.5 19.5h-33M24 8v12"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M18.518 29.387c-1.28-.947-.306-2.827.04-3.387-.626.693-1.253 1.373-1.733 2.12-.76 1.174-1.094 2.467-.574 3.294.934 1.493 3.16.8 4.574.2L34 26.054l-13.015 3.44c-1.093.28-1.973.253-2.467-.107z"
  }))
};
var MemberProduct = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2Y,
    fill: "none"
  }));
});
var compPaths$2X = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 17v4.25a.5.5 0 01-.596.484c-.096-.019-.254-.134-.254-.134L12 19l-3.65 2.6s-.158.115-.254.134a.499.499 0 01-.596-.484V14"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M9.214 9.133c-.617-.457-.148-1.363.02-1.633-.303.334-.605.662-.836 1.022-.367.566-.527 1.19-.277 1.588.45.72 1.524.385 2.205.096l6.35-2.68-6.273 1.658c-.527.135-.951.122-1.19-.051z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 17v4.25a.5.5 0 01-.596.484c-.096-.019-.254-.134-.254-.134L12 19l-3.65 2.6s-.158.115-.254.134a.499.499 0 01-.596-.484V14"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M9.214 9.133c-.617-.457-.148-1.363.02-1.633-.303.334-.605.662-.836 1.022-.367.566-.527 1.19-.277 1.588.45.72 1.524.385 2.205.096l6.35-2.68-6.273 1.658c-.527.135-.951.122-1.19-.051z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33 34v8.5a1 1 0 01-1.191.968c-.192-.038-.509-.268-.509-.268L24 38l-7.3 5.2s-.317.23-.509.267A1 1 0 0115 42.5V28"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 31.5c7.456 0 13.5-6.044 13.5-13.5S31.456 4.5 24 4.5 10.5 10.544 10.5 18 16.544 31.5 24 31.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M18.428 18.265c-1.234-.913-.296-2.725.038-3.265-.604.668-1.208 1.324-1.67 2.044-.734 1.131-1.055 2.378-.554 3.175.9 1.44 3.047.772 4.41.193l12.7-5.36-12.546 3.316c-1.054.27-1.903.244-2.378-.103z"
  }))
};
var MemberRewards = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2X,
    fill: "none"
  }));
});
var compPaths$2W = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21 5.25H3M21 12H3m18 6.75H3"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21 5.25H3M21 12H3m18 6.75H3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M42 10.5H6M42 24H6m36 13.5H6"
  }))
};
var Menu$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2W,
    fill: "none"
  }));
});
var compPaths$2V = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3 8.25h18m-18 7.5h15"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3 8.25h18m-18 7.5h15"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M42 16.5H6m30 15H6"
  }))
};
var Menu2lines = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2V,
    fill: "none"
  }));
});
var compPaths$2U = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16 17.25h2A2.25 2.25 0 0020.25 15V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v9A2.25 2.25 0 006 17.25h6a2.25 2.25 0 012.25 2.25V21m.75-8.25H7.5m9-4.5h-9"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16 17.25h2A2.25 2.25 0 0020.25 15V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v9A2.25 2.25 0 006 17.25h6a2.25 2.25 0 012.25 2.25V21m.75-8.25H7.5m9-4.5h-9"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M32 34.5h4a4.5 4.5 0 004.5-4.5V12A4.5 4.5 0 0036 7.5H12A4.5 4.5 0 007.5 12v18a4.5 4.5 0 004.5 4.5h12a4.5 4.5 0 014.5 4.5v3M30 25.5H15m18-9H15"
  }))
};
var Message = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2U,
    fill: "none"
  }));
});
var compPaths$2T = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 10.5a3.75 3.75 0 007.5 0V6a3.75 3.75 0 00-7.5 0v4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.25 10.5a6.75 6.75 0 1013.5 0M12 22.5v-6m-3 5.25h6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 10.5a3.75 3.75 0 007.5 0V6a3.75 3.75 0 00-7.5 0v4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.25 10.5a6.75 6.75 0 1013.5 0M12 22.5v-6m-3 5.25h6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.5 21a7.5 7.5 0 0015 0v-9a7.5 7.5 0 00-15 0v9z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M10.5 21c0 7.456 6.044 13.5 13.5 13.5S37.5 28.456 37.5 21M24 45V33m-6 10.5h12"
  }))
};
var Microphone = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2T,
    fill: "none"
  }));
});
var compPaths$2S = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M5 20.25h14m-13.43-3L3.16 8.23c-.14-.49.47-.84.83-.48l4.45 4.45c.27.27.74.15.84-.22l2.24-8.35c.13-.49.83-.49.97 0l2.24 8.35c.1.37.56.5.84.22l4.45-4.45c.36-.36.97-.01.84.48l-2.42 9.02H5.57z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M5 20.25h14m-13.43-3L3.16 8.23c-.14-.49.47-.84.83-.48l4.45 4.45c.27.27.74.15.84-.22l2.24-8.35c.13-.49.83-.49.97 0l2.24 8.35c.1.37.56.5.84.22l4.45-4.45c.36-.36.97-.01.84.48l-2.42 9.02H5.57z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M10 40.5h28m-26.86-6L6.32 16.46c-.28-.98.94-1.68 1.66-.96l8.9 8.9c.54.54 1.48.3 1.68-.44l4.48-16.7c.26-.98 1.66-.98 1.94 0l4.48 16.7c.2.74 1.12 1 1.68.44l8.9-8.9c.72-.72 1.94-.02 1.68.96L36.88 34.5H11.14z"
  }))
};
var Monarch = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2S,
    fill: "none"
  }));
});
var compPaths$2R = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M13.5 20.25h-9c-1.24 0-2.25-1.01-2.25-2.25v-7.5c0-1.24 1.01-2.25 2.25-2.25h9c1.24 0 2.25 1.01 2.25 2.25V18c0 1.24-1.01 2.25-2.25 2.25z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8.25 8.25v-.76c0-1.24 1.01-2.25 2.25-2.25h9c1.24 0 2.25 1.01 2.25 2.25V15c0 1.24-1.01 2.25-2.25 2.25h-3.75m2.24-9h1.5m-1.5 3h1.5m-1.5 3h1.5m-12.74 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-1 5.95L12 13.95l3.75 3.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M13.5 20.25h-9c-1.24 0-2.25-1.01-2.25-2.25v-7.5c0-1.24 1.01-2.25 2.25-2.25h9c1.24 0 2.25 1.01 2.25 2.25V18c0 1.24-1.01 2.25-2.25 2.25z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8.25 8.25v-.76c0-1.24 1.01-2.25 2.25-2.25h9c1.24 0 2.25 1.01 2.25 2.25V15c0 1.24-1.01 2.25-2.25 2.25h-3.75m2.24-9h1.5m-1.5 3h1.5m-1.5 3h1.5m-12.74 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-1 5.95L12 13.95l3.75 3.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M27 40.5H9c-2.48 0-4.5-2.02-4.5-4.5V21c0-2.48 2.02-4.5 4.5-4.5h18c2.48 0 4.5 2.02 4.5 4.5v15c0 2.48-2.02 4.5-4.5 4.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M16.5 16.5v-1.52c0-2.48 2.02-4.5 4.5-4.5h18c2.48 0 4.5 2.02 4.5 4.5V30c0 2.48-2.02 4.5-4.5 4.5h-7.5m4.48-18h3m-3 6h3m-3 6h3m-25.48 0a3 3 0 100-6 3 3 0 000 6zm-2 11.9L24 27.9l7.5 7.5"
  }))
};
var Multimedia = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2R,
    fill: "none"
  }));
});
var compPaths$2Q = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20.25 6.75V9c0 .83-.67 1.5-1.5 1.5H8.25c-.83 0-1.5-.67-1.5-1.5V6.75c0-.83.67-1.5 1.5-1.5h10.5c.83 0 1.5.67 1.5 1.5zm0 8.25v2.25c0 .83-.67 1.5-1.5 1.5H8.25c-.83 0-1.5-.67-1.5-1.5V15c0-.83.67-1.5 1.5-1.5h10.5c.83 0 1.5.67 1.5 1.5zM3 16.25h1.5M3 7.75h1.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20.25 6.75V9c0 .83-.67 1.5-1.5 1.5H8.25c-.83 0-1.5-.67-1.5-1.5V6.75c0-.83.67-1.5 1.5-1.5h10.5c.83 0 1.5.67 1.5 1.5zm0 8.25v2.25c0 .83-.67 1.5-1.5 1.5H8.25c-.83 0-1.5-.67-1.5-1.5V15c0-.83.67-1.5 1.5-1.5h10.5c.83 0 1.5.67 1.5 1.5zM3 16.25h1.5M3 7.75h1.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M40.5 13.5V18c0 1.66-1.34 3-3 3h-21c-1.66 0-3-1.34-3-3v-4.5c0-1.66 1.34-3 3-3h21c1.66 0 3 1.34 3 3zm0 16.5v4.5c0 1.66-1.34 3-3 3h-21c-1.66 0-3-1.34-3-3V30c0-1.66 1.34-3 3-3h21c1.66 0 3 1.34 3 3zM6 32.5h3m-3-17h3"
  }))
};
var MultiSelect = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2Q,
    fill: "none"
  }));
});
var compPaths$2P = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.775 8.338L18.26 3.843c1.172-.391 2.288.725 1.898 1.897l-4.495 13.485c-.448 1.341-2.33 1.376-2.827.051l-2.313-5.798-5.799-2.313c-1.324-.496-1.289-2.38.052-2.827z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.775 8.338L18.26 3.843c1.172-.391 2.288.725 1.898 1.897l-4.495 13.485c-.448 1.341-2.33 1.376-2.827.051l-2.313-5.798-5.799-2.313c-1.324-.496-1.289-2.38.052-2.827z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M9.552 16.676l26.968-8.99c2.344-.782 4.576 1.45 3.794 3.794l-8.99 26.97c-.894 2.682-4.662 2.752-5.654.102l-4.624-11.596-11.6-4.626c-2.646-.992-2.576-4.76.106-5.654z",
    clipRule: "evenodd"
  }))
};
var Navigation = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2P,
    fill: "none"
  }));
});
var compPaths$2O = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 14v-.5A2.5 2.5 0 0110 11h4a2.5 2.5 0 012.5 2.5v.5M14 6.5a2 2 0 11-4 0 2 2 0 014 0v0z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M6 16h12M6 19h8"
  }), /* @__PURE__ */ React__default.createElement("rect", {
    width: "16.5",
    height: "20",
    x: "3.75",
    y: "2",
    stroke: "currentColor",
    strokeWidth: "1.5",
    rx: "2"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 14v-.5A2.5 2.5 0 0110 11h4a2.5 2.5 0 012.5 2.5v.5M14 6.5a2 2 0 11-4 0 2 2 0 014 0v0z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M6 16h12M6 19h8"
  }), /* @__PURE__ */ React__default.createElement("rect", {
    width: "16.5",
    height: "20",
    x: "3.75",
    y: "2",
    stroke: "currentColor",
    strokeWidth: "1.5",
    rx: "2"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 28v-1a5 5 0 015-5h8a5 5 0 015 5v1m-5-15a4 4 0 11-8 0 4 4 0 018 0v0z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M12 32h24m-24 6h16"
  }), /* @__PURE__ */ React__default.createElement("rect", {
    width: "33",
    height: "40",
    x: "7.5",
    y: "4",
    stroke: "currentColor",
    strokeWidth: "3",
    rx: "4"
  }))
};
var NikeMembership = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2O,
    fill: "none"
  }));
});
var compPaths$2N = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M10.12 6.62c-1.88.75-3.2 2.58-3.2 4.72V12c0 .62-.54 1.13-1.17 1.13v2.62h12.5v-2.62c-.62 0-1.17-.5-1.17-1.13v-.66c0-2.59-1.93-4.72-4.43-5.04a.745.745 0 01-.65-.74V4m1.69 13.56c0 .93-.76 1.69-1.69 1.69-.93 0-1.69-.76-1.69-1.69"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.5 4.98a6.751 6.751 0 00-4.25 6.27v1.5c0 .83-.67 1.5-1.5 1.5v3h16.5v-3c-.83 0-1.5-.67-1.5-1.5v-1.5c0-3.43-2.56-6.27-5.88-6.69-.5-.07-.87-.49-.87-.99V1.5m2.25 18c0 1.24-1.01 2.25-2.25 2.25s-2.25-1.01-2.25-2.25"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M19 9.96c-4.98 1.98-8.5 6.86-8.5 12.54v3c0 1.66-1.34 3-3 3v6h33v-6c-1.66 0-3-1.34-3-3v-3c0-6.86-5.12-12.54-11.76-13.38-1-.14-1.74-.98-1.74-1.98V3m4.5 36c0 2.48-2.02 4.5-4.5 4.5s-4.5-2.02-4.5-4.5"
  }))
};
var Notification = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2N,
    fill: "none"
  }));
});
var compPaths$2M = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M19.5 18.44L5.56 4.5 4.5 5.56l1.7 1.7A7.442 7.442 0 004.5 12c0 4.14 3.36 7.5 7.5 7.5 1.8 0 3.45-.64 4.74-1.7l1.7 1.7 1.06-1.06zM12 18c-3.31 0-6-2.69-6-6 0-1.38.48-2.65 1.27-3.67l8.4 8.4A5.977 5.977 0 0112 18zm0-12c3.31 0 6 2.69 6 6 0 .83-.17 1.62-.48 2.34l1.12 1.12c.54-1.04.85-2.21.85-3.46 0-4.14-3.36-7.5-7.5-7.5-1.25 0-2.43.31-3.46.85l1.12 1.12C10.38 6.17 11.17 6 12 6z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M19.5 18.44L5.56 4.5 4.5 5.56l1.7 1.7A7.442 7.442 0 004.5 12c0 4.14 3.36 7.5 7.5 7.5 1.8 0 3.45-.64 4.74-1.7l1.7 1.7 1.06-1.06zM12 18c-3.31 0-6-2.69-6-6 0-1.38.48-2.65 1.27-3.67l8.4 8.4A5.977 5.977 0 0112 18zm0-12c3.31 0 6 2.69 6 6 0 .83-.17 1.62-.48 2.34l1.12 1.12c.54-1.04.85-2.21.85-3.46 0-4.14-3.36-7.5-7.5-7.5-1.25 0-2.43.31-3.46.85l1.12 1.12C10.38 6.17 11.17 6 12 6z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M39 36.88L11.12 9 9 11.12l3.4 3.4C10.28 17.1 9 20.4 9 24c0 8.28 6.72 15 15 15 3.6 0 6.9-1.28 9.48-3.4l3.4 3.4L39 36.88zM24 36c-6.62 0-12-5.38-12-12 0-2.76.96-5.3 2.54-7.34l16.8 16.8C29.3 35.04 26.76 36 24 36zm0-24c6.62 0 12 5.38 12 12 0 1.66-.34 3.24-.96 4.68l2.24 2.24c1.08-2.08 1.7-4.42 1.7-6.92 0-8.28-6.72-15-15-15-2.5 0-4.86.62-6.92 1.7l2.24 2.24c1.46-.6 3.04-.94 4.7-.94z"
  }))
};
var Null = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2M,
    fill: "none"
  }));
});
var compPaths$2L = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.25 4.75C13.01 4.75 12 5.76 12 7.5v6m6.93-3.75H4.83"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.25 4.75h3.66l1.34 5v9.5H4.75v-9.5l1.34-5H10"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.25 3.75C13.01 3.75 12 4.76 12 6.5v7m8.25-3.75H3.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.25 3.75h4.39l1.61 6v10.5H3.75V9.75l1.61-6h5.14"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M28.5 7.5C26.02 7.5 24 9.52 24 13v14m16.5-7.5h-33"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M28.5 7.5h8.78l3.22 12v21h-33v-21l3.22-12H21"
  }))
};
var Orders = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2L,
    fill: "none"
  }));
});
var compPaths$2K = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 18.75H6a2.25 2.25 0 01-2.25-2.25v-9A2.25 2.25 0 016 5.25h12a2.25 2.25 0 012.25 2.25v9A2.25 2.25 0 0118 18.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 9.75h16.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 18.75H6a2.25 2.25 0 01-2.25-2.25v-9A2.25 2.25 0 016 5.25h12a2.25 2.25 0 012.25 2.25v9A2.25 2.25 0 0118 18.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 9.75h16.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 37.5H12A4.502 4.502 0 017.5 33V15a4.5 4.5 0 014.5-4.5h24a4.5 4.5 0 014.5 4.5v18c0 2.484-2.016 4.5-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 19.5h33"
  }))
};
var Payment = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2K,
    fill: "none"
  }));
});
var compPaths$2J = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 21v-3A3.75 3.75 0 016 14.25h6A3.75 3.75 0 0115.75 18v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M22.955 9.167l-4.773 4.773-2.652-2.651"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 21v-3A3.75 3.75 0 016 14.25h6A3.75 3.75 0 0115.75 18v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M22.955 9.167l-4.773 4.773-2.652-2.651"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M4.5 42v-6a7.5 7.5 0 017.5-7.5h12a7.5 7.5 0 017.5 7.5v6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M25.5 15a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M45.91 18.334l-9.546 9.546-5.304-5.302"
  }))
};
var Personalization = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2J,
    fill: "none"
  }));
});
var compPaths$2I = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.5 21.75h-15c-1.24 0-2.25-1.01-2.25-2.25V6c0-1.24 1.01-2.25 2.25-2.25h15c1.24 0 2.25 1.01 2.25 2.25v13.5c0 1.24-1.01 2.25-2.25 2.25zm2.25-13.5H2.25m6-6.75V6m7.5-4.5V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.05 16.97l4.42-4.42m-4.42 0l4.42 4.42m-7.57-4.48l-3.42 3.92-1.95-1.94"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.5 21.75h-15c-1.24 0-2.25-1.01-2.25-2.25V6c0-1.24 1.01-2.25 2.25-2.25h15c1.24 0 2.25 1.01 2.25 2.25v13.5c0 1.24-1.01 2.25-2.25 2.25zm2.25-13.5H2.25m6-6.75V6m7.5-4.5V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.05 16.97l4.42-4.42m-4.42 0l4.42 4.42m-7.57-4.48l-3.42 3.92-1.95-1.94"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M39 43.5H9c-2.48 0-4.5-2.02-4.5-4.5V12c0-2.48 2.02-4.5 4.5-4.5h30c2.48 0 4.5 2.02 4.5 4.5v27c0 2.48-2.02 4.5-4.5 4.5zm4.5-27h-39M16.5 3v9m15-9v9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M28.1 33.94l8.84-8.84m-8.84 0l8.84 8.84M21.8 24.98l-6.84 7.84-3.9-3.88"
  }))
};
var Plan = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2I,
    fill: "none"
  }));
});
var compPaths$2H = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.25 12c0 4-3.24 7.25-7.25 7.25S4.75 16 4.75 12 7.99 4.75 12 4.75 19.25 8 19.25 12zM12 8v8m4-4H8"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12c0 5.39-4.36 9.75-9.75 9.75S2.25 17.39 2.25 12 6.61 2.25 12 2.25s9.75 4.36 9.75 9.75zM12 6v12m6-6H6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 24c0 10.78-8.72 19.5-19.5 19.5S4.5 34.78 4.5 24 13.22 4.5 24 4.5 43.5 13.22 43.5 24zM24 12v24m12-12H12"
  }))
};
var PlusCircle = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2H,
    fill: "none"
  }));
});
var compPaths$2G = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm4 8.75h-3.25V16h-1.5v-3.25H8v-1.5h3.25V8h1.5v3.25H16v1.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 1.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5zm6 11.25h-5.25V18h-1.5v-5.25H6v-1.5h5.25V6h1.5v5.25H18v1.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M24 3C12.42 3 3 12.42 3 24s9.42 21 21 21 21-9.42 21-21S35.58 3 24 3zm12 22.5H25.5V36h-3V25.5H12v-3h10.5V12h3v10.5H36v3z"
  }))
};
var PlusCircleFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2G,
    fill: "none"
  }));
});
var compPaths$2F = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15.75 14.25h-7.5v6h7.5v-6zm-7.5-6.5v-4h7.5v4"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8 17.25H6c-1.24 0-2.25-1.01-2.25-2.25v-4.5c0-1.24 1.01-2.25 2.25-2.25h12c1.24 0 2.25 1.01 2.25 2.25V15c0 1.24-1.01 2.25-2.25 2.25m-12-6h1.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15.75 14.25h-7.5v6h7.5v-6zm-7.5-6.5v-4h7.5v4"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8 17.25H6c-1.24 0-2.25-1.01-2.25-2.25v-4.5c0-1.24 1.01-2.25 2.25-2.25h12c1.24 0 2.25 1.01 2.25 2.25V15c0 1.24-1.01 2.25-2.25 2.25m-12-6h1.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M31.5 28.5h-15v12h15v-12zm-15-13v-8h15v8"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M16 34.5h-4c-2.48 0-4.5-2.02-4.5-4.5v-9c0-2.48 2.02-4.5 4.5-4.5h24c2.48 0 4.5 2.02 4.5 4.5v9c0 2.48-2.02 4.5-4.5 4.5m-24-12h3"
  }))
};
var Print = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2F,
    fill: "none"
  }));
});
var compPaths$2E = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 3a4.5 4.5 0 00-4.5 4.5H9a3 3 0 013-3V3zM7.5 7.5A4.5 4.5 0 0012 12v-1.5a3 3 0 01-3-3H7.5zM12 12a4.5 4.5 0 004.5-4.5H15a3 3 0 01-3 3V12zm4.5-4.5A4.5 4.5 0 0012 3v1.5a3 3 0 013 3h1.5zM4.5 21v-3H3v3h1.5zm0-3a3 3 0 013-3v-1.5A4.5 4.5 0 003 18h1.5zm3-3h9v-1.5h-9V15zm9 0a3 3 0 013 3H21a4.5 4.5 0 00-4.5-4.5V15zm3 3v3H21v-3h-1.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 3a4.5 4.5 0 00-4.5 4.5H9a3 3 0 013-3V3zM7.5 7.5A4.5 4.5 0 0012 12v-1.5a3 3 0 01-3-3H7.5zM12 12a4.5 4.5 0 004.5-4.5H15a3 3 0 01-3 3V12zm4.5-4.5A4.5 4.5 0 0012 3v1.5a3 3 0 013 3h1.5zM4.5 21v-3H3v3h1.5zm0-3a3 3 0 013-3v-1.5A4.5 4.5 0 003 18h1.5zm3-3h9v-1.5h-9V15zm9 0a3 3 0 013 3H21a4.5 4.5 0 00-4.5-4.5V15zm3 3v3H21v-3h-1.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 42v-6a7.5 7.5 0 017.5-7.5h18a7.5 7.5 0 017.5 7.5v6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.5 15a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z",
    clipRule: "evenodd"
  }))
};
var Profile = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2E,
    fill: "none"
  }));
});
var compPaths$2D = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 21H3v-3c0-2.481 2.019-4.5 4.5-4.5h9c2.481 0 4.5 2.019 4.5 4.5v3h-1.5M12 12a4.505 4.505 0 01-4.5-4.5C7.5 5.019 9.519 3 12 3s4.5 2.019 4.5 4.5S14.481 12 12 12z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 21H3v-3c0-2.481 2.019-4.5 4.5-4.5h9c2.481 0 4.5 2.019 4.5 4.5v3h-1.5M12 12a4.505 4.505 0 01-4.5-4.5C7.5 5.019 9.519 3 12 3s4.5 2.019 4.5 4.5S14.481 12 12 12z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 42H6v-6c0-4.962 4.038-9 9-9h18c4.962 0 9 4.038 9 9v6h-3M24 24c-4.962 0-9-4.038-9-9s4.038-9 9-9 9 4.038 9 9-4.038 9-9 9z",
    clipRule: "evenodd"
  }))
};
var ProfileFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2D,
    fill: "none"
  }));
});
var compPaths$2C = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M3.75 21v-3a3.75 3.75 0 013.75-3.75h9A3.75 3.75 0 0120.25 18v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M15.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M3.75 21v-3a3.75 3.75 0 013.75-3.75h9A3.75 3.75 0 0120.25 18v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M15.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M7.5 42v-6a7.5 7.5 0 017.5-7.5h18a7.5 7.5 0 017.5 7.5v6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M31.5 15a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z",
    clipRule: "evenodd"
  }))
};
var ProfileStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2C,
    fill: "none"
  }));
});
var compPaths$2B = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 3a4.5 4.5 0 00-4.5 4.5H9a3 3 0 013-3V3zM7.5 7.5A4.5 4.5 0 0012 12v-1.5a3 3 0 01-3-3H7.5zM12 12a4.5 4.5 0 004.5-4.5H15a3 3 0 01-3 3V12zm4.5-4.5A4.5 4.5 0 0012 3v1.5a3 3 0 013 3h1.5zM4.5 21v-3H3v3h1.5zm0-3a3 3 0 013-3v-1.5A4.5 4.5 0 003 18h1.5zm3-3H17v-1.5H7.5V15z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.5 17l-8.41 3.568c-.7.297-1.29.445-1.764.445-.534 0-.923-.189-1.162-.565-.31-.485-.175-1.266.357-2.09.316-.482.717-.924 1.108-1.347-.092.15-.904 1.5-.016 2.137.176.128.425.19.733.19.246 0 .53-.04.84-.121L22.5 17z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 3a4.5 4.5 0 00-4.5 4.5H9a3 3 0 013-3V3zM7.5 7.5A4.5 4.5 0 0012 12v-1.5a3 3 0 01-3-3H7.5zM12 12a4.5 4.5 0 004.5-4.5H15a3 3 0 01-3 3V12zm4.5-4.5A4.5 4.5 0 0012 3v1.5a3 3 0 013 3h1.5zM4.5 21v-3H3v3h1.5zm0-3a3 3 0 013-3v-1.5A4.5 4.5 0 003 18h1.5zm3-3H17v-1.5H7.5V15z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.5 17l-8.41 3.568c-.7.297-1.29.445-1.764.445-.534 0-.923-.189-1.162-.565-.31-.485-.175-1.266.357-2.09.316-.482.717-.924 1.108-1.347-.092.15-.904 1.5-.016 2.137.176.128.425.19.733.19.246 0 .53-.04.84-.121L22.5 17z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M24 6a9 9 0 00-9 9h3a6 6 0 016-6V6zm-9 9a9 9 0 009 9v-3a6 6 0 01-6-6h-3zm9 9a9 9 0 009-9h-3a6 6 0 01-6 6v3zm9-9a9 9 0 00-9-9v3a6 6 0 016 6h3zM9 42v-6H6v6h3zm0-6a6 6 0 016-6v-3a9 9 0 00-9 9h3zm6-6h19v-3H15v3z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M45 34l-16.82 7.135c-1.4.594-2.579.89-3.528.89-1.068 0-1.846-.376-2.324-1.129-.62-.97-.35-2.532.714-4.18.631-.964 1.434-1.848 2.216-2.694-.184.299-1.808 3.001-.032 4.274.351.255.85.38 1.465.38.494 0 1.06-.08 1.682-.242L45 34z",
    clipRule: "evenodd"
  }))
};
var ProfileSwoosh = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2B,
    fill: "none"
  }));
});
var compPaths$2A = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 2.75A4.75 4.75 0 007.25 7.5h2A2.75 2.75 0 0112 4.75v-2zM7.25 7.5A4.75 4.75 0 0012 12.25v-2A2.75 2.75 0 019.25 7.5h-2zM12 12.25a4.75 4.75 0 004.75-4.75h-2A2.75 2.75 0 0112 10.25v2zm4.75-4.75A4.75 4.75 0 0012 2.75v2a2.75 2.75 0 012.75 2.75h2zM4.75 21v-3h-2v3h2zm0-3a2.75 2.75 0 012.75-2.75v-2A4.75 4.75 0 002.75 18h2zm2.75-2.75H17v-2H7.5v2z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.5 17l-8.41 3.568c-.7.297-1.29.445-1.764.445-.534 0-.923-.189-1.162-.565-.31-.485-.175-1.266.357-2.09.316-.482.717-.924 1.108-1.347-.092.15-.904 1.5-.016 2.137.176.128.425.19.733.19.246 0 .53-.04.84-.121L22.5 17z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 2.75A4.75 4.75 0 007.25 7.5h2A2.75 2.75 0 0112 4.75v-2zM7.25 7.5A4.75 4.75 0 0012 12.25v-2A2.75 2.75 0 019.25 7.5h-2zM12 12.25a4.75 4.75 0 004.75-4.75h-2A2.75 2.75 0 0112 10.25v2zm4.75-4.75A4.75 4.75 0 0012 2.75v2a2.75 2.75 0 012.75 2.75h2zM4.75 21v-3h-2v3h2zm0-3a2.75 2.75 0 012.75-2.75v-2A4.75 4.75 0 002.75 18h2zm2.75-2.75H17v-2H7.5v2z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.5 17l-8.41 3.568c-.7.297-1.29.445-1.764.445-.534 0-.923-.189-1.162-.565-.31-.485-.175-1.266.357-2.09.316-.482.717-.924 1.108-1.347-.092.15-.904 1.5-.016 2.137.176.128.425.19.733.19.246 0 .53-.04.84-.121L22.5 17z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M24 6a9 9 0 00-9 9h3a6 6 0 016-6V6zm-9 9a9 9 0 009 9v-3a6 6 0 01-6-6h-3zm9 9a9 9 0 009-9h-3a6 6 0 01-6 6v3zm9-9a9 9 0 00-9-9v3a6 6 0 016 6h3zM9 42v-6H6v6h3zm0-6a6 6 0 016-6v-3a9 9 0 00-9 9h3zm6-6h19v-3H15v3z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M45 34l-16.82 7.135c-1.4.594-2.579.89-3.528.89-1.068 0-1.846-.376-2.324-1.129-.62-.97-.35-2.532.714-4.18.631-.964 1.434-1.848 2.216-2.694-.184.299-1.808 3.001-.032 4.274.351.255.85.38 1.465.38.494 0 1.06-.08 1.682-.242L45 34z",
    clipRule: "evenodd"
  }))
};
var ProfileSwooshStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2A,
    fill: "none"
  }));
});
var compPaths$2z = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.75 10.75h5v-5h-5v5zm0 7.5h5v-5h-5v5zm7.5-7.5h5v-5h-5v5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.5 13.25H16m1 0h2m-6.5 2.5H14m5 2.5h-3.25v-2.5H19"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.5 10.5h6v-6h-6v6zm0 9h6v-6h-6v6zm9-9h6v-6h-6v6z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.75 13.5h4.5m1.5 0h1.5m-7.5 3h1.5m6 3H16.5v-3h3.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M9 21h12V9H9v12zm0 18h12V27H9v12zm18-18h12V9H27v12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M25.5 27h9m3 0h3m-15 6h3m-3 6h3m12 0H33v-6h7.5"
  }))
};
var QRCode = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2z,
    fill: "none"
  }));
});
var compPaths$2y = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 17v-1.5M9.75 10a2.25 2.25 0 113.217 2.032c-.585.278-.967.87-.967 1.523V14"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M11.99 18v-1.5M9 9.75a3 3 0 114.29 2.71c-.78.37-1.29 1.16-1.29 2.03V15"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M23.98 36v-3M18 19.5c0-3.66 3.3-6.58 7.08-5.9 2.42.42 4.4 2.4 4.82 4.82.5 2.84-1 5.4-3.32 6.5A4.51 4.51 0 0024 28.98V30"
  }))
};
var Question = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2y,
    fill: "none"
  }));
});
var compPaths$2x = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 17v-1.5M9.75 10c0-1.37 1.24-2.47 2.65-2.21.91.16 1.65.9 1.81 1.81.19 1.07-.38 2.03-1.24 2.44-.59.27-.97.86-.97 1.51V14"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 19.25c4 0 7.25-3.25 7.25-7.25S16 4.75 12 4.75 4.75 8 4.75 12 8 19.25 12 19.25z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 21.75c5.385 0 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25 2.25 6.615 2.25 12s4.365 9.75 9.75 9.75zM11.99 18v-1.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9 9.75a3 3 0 114.29 2.71c-.78.37-1.29 1.16-1.29 2.03V15"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 43.5c10.77 0 19.5-8.73 19.5-19.5S34.77 4.5 24 4.5 4.5 13.23 4.5 24 13.23 43.5 24 43.5zm-.02-7.5v-3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M18 19.5c0-3.66 3.3-6.58 7.08-5.9 2.42.42 4.4 2.4 4.82 4.82.5 2.84-1 5.4-3.32 6.5A4.51 4.51 0 0024 28.98V30"
  }))
};
var QuestionCircle = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2x,
    fill: "none"
  }));
});
var compPaths$2w = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm.75 13h-1.5v-1.5h1.5V17zm.54-4.29c-.33.16-.54.49-.54.84V14h-1.5v-.45c0-.93.55-1.8 1.4-2.2.51-.24.97-.84.83-1.63-.1-.59-.61-1.1-1.2-1.2A1.498 1.498 0 0010.5 10H9c0-.89.39-1.73 1.08-2.3a2.993 2.993 0 014.87 1.77c.24 1.33-.45 2.66-1.66 3.24z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M12 1.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5zm.74 16.5h-1.5v-1.5h1.5V18zm.87-4.86c-.52.25-.86.78-.86 1.35V15h-1.5v-.51c0-1.15.67-2.21 1.72-2.71.92-.44 1.42-1.42 1.24-2.44-.16-.9-.9-1.64-1.8-1.8-.68-.12-1.33.05-1.85.48s-.81 1.06-.81 1.73h-1.5c0-1.11.49-2.16 1.35-2.88.85-.71 1.97-1.01 3.07-.81 1.51.26 2.75 1.5 3.02 3.02.3 1.7-.54 3.33-2.08 4.06z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M24 3C12.42 3 3 12.42 3 24s9.42 21 21 21 21-9.42 21-21S35.58 3 24 3zm1.48 33h-3v-3h3v3zm1.74-9.72c-1.04.5-1.72 1.56-1.72 2.7V30h-3v-1.02c0-2.3 1.34-4.42 3.44-5.42 1.84-.88 2.84-2.84 2.48-4.88-.32-1.8-1.8-3.28-3.6-3.6-1.36-.24-2.66.1-3.7.96a4.462 4.462 0 00-1.62 3.46h-3c0-2.22.98-4.32 2.7-5.76a7.476 7.476 0 016.14-1.62c3.02.52 5.5 3 6.04 6.04.6 3.4-1.08 6.66-4.16 8.12z"
  }))
};
var QuestionCircleFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2w,
    fill: "none"
  }));
});
var compPaths$2v = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.223 10.726l3.675 2.695-1.403 4.363c-.162.502.408.92.83.61L12 15.697l3.675 2.697c.422.31.992-.108.83-.61l-1.403-4.363 3.675-2.695c.422-.31.205-.987-.318-.987h-4.542l-1.404-4.362a.538.538 0 00-1.026 0l-1.404 4.362H5.54c-.523 0-.74.676-.318.986z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.56 10.346l5.12 3.694-1.955 5.978c-.225.688.568 1.261 1.157.836L12 17.159l5.12 3.695c.587.425 1.381-.148 1.155-.836l-1.954-5.978 5.118-3.694c.589-.425.286-1.352-.442-1.352H14.67l-.166-.507-1.789-5.47c-.225-.69-1.205-.69-1.43 0L9.33 8.993H3.003c-.728 0-1.03.927-.442 1.352z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M5.122 20.692l10.236 7.389-3.909 11.955c-.449 1.377 1.137 2.523 2.315 1.672L24 34.318l10.238 7.39c1.175.85 2.764-.295 2.313-1.672l-3.91-11.955 10.237-7.389c1.177-.85.572-2.704-.884-2.704H29.34L25.43 6.033c-.45-1.377-2.41-1.377-2.86 0l-3.91 11.955H6.005c-1.456 0-2.061 1.853-.884 2.704z",
    clipRule: "evenodd"
  }))
};
var Rating = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2v,
    fill: "none"
  }));
});
var compPaths$2u = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.223 10.726l3.675 2.695-1.403 4.363c-.162.502.408.92.83.61L12 15.697l3.675 2.697c.422.31.992-.108.83-.61l-1.403-4.363 3.675-2.695c.422-.31.205-.987-.318-.987h-4.542l-1.404-4.362a.538.538 0 00-1.026 0l-1.404 4.362H5.54c-.523 0-.74.676-.318.986z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.56 10.346l5.12 3.694-1.955 5.978c-.225.688.568 1.261 1.157.836L12 17.159l5.12 3.695c.587.425 1.381-.148 1.155-.836l-1.954-5.978 5.118-3.694c.589-.425.286-1.352-.442-1.352H14.67l-.166-.507-1.789-5.47c-.225-.69-1.205-.69-1.43 0L9.33 8.993H3.003c-.728 0-1.03.927-.442 1.352z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M5.122 20.692l10.236 7.389-3.909 11.955c-.449 1.377 1.137 2.523 2.315 1.672L24 34.318l10.238 7.39c1.175.85 2.764-.295 2.313-1.672l-3.91-11.955 10.237-7.389c1.177-.85.572-2.704-.884-2.704H29.34l-.333-1.014L25.43 6.033c-.45-1.377-2.41-1.377-2.86 0l-3.91 11.955H6.005c-1.456 0-2.061 1.853-.884 2.704z",
    clipRule: "evenodd"
  }))
};
var RatingFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2u,
    fill: "none"
  }));
});
var compPaths$2t = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M5.223 10.726l3.675 2.695-1.403 4.363c-.162.502.408.92.83.61L12 15.697l3.675 2.697c.422.31.992-.108.83-.61l-1.403-4.363 3.675-2.695c.422-.31.205-.987-.318-.987h-4.542l-1.404-4.362a.538.538 0 00-1.026 0l-1.404 4.362H5.54c-.523 0-.74.676-.318.986z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M2.56 10.346l5.12 3.694-1.955 5.978c-.225.688.568 1.261 1.157.836L12 17.159l5.12 3.695c.587.425 1.381-.148 1.155-.836l-1.954-5.978 5.118-3.694c.589-.425.286-1.352-.442-1.352H14.67l-1.955-5.978c-.225-.688-1.205-.688-1.43 0L9.33 8.994H3.003c-.728 0-1.03.927-.442 1.352z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M5.122 20.692l10.236 7.389-3.909 11.955c-.449 1.377 1.137 2.523 2.315 1.672L24 34.318l10.238 7.39c1.175.85 2.764-.295 2.313-1.672l-3.91-11.955 10.237-7.389c1.177-.85.572-2.704-.884-2.704H29.34l-.333-1.014L25.43 6.033c-.45-1.377-2.41-1.377-2.86 0l-3.91 11.955H6.005c-1.456 0-2.061 1.853-.884 2.704z",
    clipRule: "evenodd"
  }))
};
var RatingStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2t,
    fill: "none"
  }));
});
var compPaths$2s = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M10.5 6.75H18m-7.5 3H18m-7.5 3h6M6 20.25h12c1.24 0 2.25-1.01 2.25-2.25V3.75h-12V18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8.25 18c0 1.24-1.01 2.25-2.25 2.25S3.75 19.24 3.75 18v-5.25H6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M10.5 6.75H18m-7.5 3H18m-7.5 3h6M6 20.25h12c1.24 0 2.25-1.01 2.25-2.25V3.75h-12V18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8.25 18c0 1.24-1.01 2.25-2.25 2.25S3.75 19.24 3.75 18v-5.25H6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M21 13.5h15m-15 6h15m-15 6h12m-21 15h24c2.48 0 4.5-2.02 4.5-4.5V7.5h-24V36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M16.5 36c0 2.48-2.02 4.5-4.5 4.5S7.5 38.48 7.5 36V25.5H12"
  }))
};
var Receipt = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2s,
    fill: "none"
  }));
});
var compPaths$2r = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.354 22.476L2.994 5.116l1.014-1.014 17.36 17.36-1.014 1.014z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21 3H7.5v2.48L9 6.98V4.5h10.5v12.98l1.376 1.375c.08-.27.124-.558.124-.855V3zm-.93 17.17l-1.062-1.061c-.267.243-.62.391-1.008.391H8.597c.256-.442.403-.954.403-1.5V9.1L7.5 7.6V18c0 .826-.674 1.5-1.5 1.5s-1.5-.674-1.5-1.5v-4.5H6V12H3v6c0 1.654 1.346 3 3 3h12a2.99 2.99 0 002.07-.83zM11.9 12h-1.4v.5l1 1h1.9L11.9 12zm3.62 1.5h.98V12h-2.48l1.5 1.5zm-3-3H18V9h-6.98l1.5 1.5zm-2.02-3H18V6h-7.5v1.5z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.354 22.476L2.994 5.116l1.014-1.014 17.36 17.36-1.014 1.014z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21 3H7.5v2.48L9 6.98V4.5h10.5v12.98l1.376 1.375c.08-.27.124-.558.124-.855V3zm-.93 17.17l-1.062-1.061c-.267.243-.62.391-1.008.391H8.597c.256-.442.403-.954.403-1.5V9.1L7.5 7.6V18c0 .826-.674 1.5-1.5 1.5s-1.5-.674-1.5-1.5v-4.5H6V12H3v6c0 1.654 1.346 3 3 3h12a2.99 2.99 0 002.07-.83zM11.9 12h-1.4v.5l1 1h1.9L11.9 12zm3.62 1.5h.98V12h-2.48l1.5 1.5zm-3-3H18V9h-6.98l1.5 1.5zm-2.02-3H18V6h-7.5v1.5z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M40.71 44.953L5.988 10.232l2.028-2.028 34.72 34.72-2.028 2.029z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M42 6H15v4.959l3 3V9h21v25.959l2.752 2.752A5.985 5.985 0 0042 36V6zm-1.861 34.34l-2.123-2.122A2.988 2.988 0 0136 39H17.195A5.964 5.964 0 0018 36V18.201l-3-3V36c0 1.652-1.348 3-3 3s-3-1.348-3-3v-9h3v-3H6v12c0 3.308 2.692 6 6 6h24a5.98 5.98 0 004.139-1.66zM23.799 24H21v1l2 2h3.799l-3-3zm7.242 3H33v-3h-4.959l3 3zm-6-6H36v-3H22.041l3 3zM21 15h15v-3H21v3z",
    clipRule: "evenodd"
  }))
};
var ReceiptNone = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2r,
    fill: "none"
  }));
});
var compPaths$2q = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M4.27 6.02v3.73H8m10.98 4.23A7.256 7.256 0 0112 19.25c-4.01 0-7.25-3.24-7.25-7.25M12 4.75c4.01 0 7.25 3.24 7.25 7.25M5.15 9.8a7.238 7.238 0 016.91-5.05"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M19.73 17.98v-3.73H16"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M3.25 5.5v4.25H7.5m12.44 4.5c-.98 3.46-4.16 6-7.94 6-4.56 0-8.25-3.69-8.25-8.25M12 3.75c4.56 0 8.25 3.69 8.25 8.25M4.14 9.5A8.25 8.25 0 0112 3.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20.75 18.5v-4.25H16.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M6.5 11v8.5H15m24.88 9c-1.96 6.92-8.32 12-15.88 12-9.12 0-16.5-7.38-16.5-16.5M24 7.5c9.12 0 16.5 7.38 16.5 16.5M8.28 19C10.38 12.34 16.64 7.5 24 7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M41.5 37v-8.5H33"
  }))
};
var Repeat = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2q,
    fill: "none"
  }));
});
var compPaths$2p = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M4.25 6.02v3.73h3.73"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 4.75c4.01 0 7.25 3.24 7.25 7.25s-3.24 7.25-7.25 7.25S4.75 16.01 4.75 12m.34-2.2C6.02 6.88 8.77 4.75 12 4.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.5 19.86A8.25 8.25 0 0020.25 12m-17-6.5v4.25H7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 3.75c4.56 0 8.25 3.69 8.25 8.25 0 4.56-3.69 8.25-8.25 8.25-4.56 0-8.25-3.69-8.25-8.25m.39-2.5A8.25 8.25 0 0112 3.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M6.5 11v8.5H15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 7.5c9.12 0 16.5 7.38 16.5 16.5 0 9.12-7.38 16.5-16.5 16.5-9.12 0-16.5-7.38-16.5-16.5m.78-5C10.38 12.34 16.64 7.5 24 7.5"
  }))
};
var Replay = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2p,
    fill: "none"
  }));
});
var compPaths$2o = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 21.75h-9c-1.242 0-2.25-1.191-2.25-2.66V4.91c0-1.469 1.008-2.66 2.25-2.66h6.75l4.5 4.5v12.34c0 1.469-1.008 2.66-2.25 2.66z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18.75 6.75H15.5a1.5 1.5 0 01-1.5-1.5V2m2.25 10.5l-3 3-1.5-1.5L8 17.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 21.75h-9c-1.242 0-2.25-1.191-2.25-2.66V4.91c0-1.469 1.008-2.66 2.25-2.66h6.75l4.5 4.5v12.34c0 1.469-1.008 2.66-2.25 2.66z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18.75 6.75H15.5a1.5 1.5 0 01-1.5-1.5V2m2.25 10.5l-3 3-1.5-1.5L8 17.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33 43.5H15c-2.484 0-4.5-2.383-4.5-5.318V9.818C10.5 6.883 12.516 4.5 15 4.5h13.5l9 9v24.682c0 2.935-2.016 5.318-4.5 5.318z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M37.5 13.5H31a3 3 0 01-3-3V4m4.5 21l-6 6-3-3-7.5 7.5"
  }))
};
var Report = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2o,
    fill: "none"
  }));
});
var compPaths$2n = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M10.26 21.35l-2.19-2.1 2.19-2.15M12 4.75v8.75m6.93-3.75H4.83"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M4.75 20V9.75l1.34-5h11.82l1.34 5V17c0 1.24-1.01 2.25-2.25 2.25H8.08"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M3.75 21V9.75l1.61-6h13.28l1.61 6V18c0 1.24-1.01 2.25-2.25 2.25m0 0H8m12.25-10.5H3.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.71 22.9l-2.65-2.65 2.65-2.65M12 3.75v9.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M7.5 42V19.5l3.22-12h26.56l3.22 12V36c0 2.48-2.02 4.5-4.5 4.5m0 0H16m24.5-21h-33"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M19.42 45.8l-5.3-5.3 5.3-5.3M24 7.5V27"
  }))
};
var Return = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2n,
    fill: "none"
  }));
});
var compPaths$2m = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.5 9.5l5 5m0-5l-5 5m-3.75-5L6.25 14 4.5 12.25"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18.75H.75V5.25H12m0 0h11.25v13.5H12"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M14.5 9.5l5 5m0-5l-5 5m-3.75-5L6.25 14 4.5 12.25"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18.75H.75V5.25H12m0 0h11.25v13.5H12"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M29 19l10 10m0-10L29 29m-7.5-10l-9 9L9 24.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 37.5H1.5v-27H24m0 0h22.5v27H24"
  }))
};
var Review = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2m,
    fill: "none"
  }));
});
var compPaths$2l = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18.75 14.8l2.8-2.8-2.8-2.8V5.25H14.8L12 2.45l-2.8 2.8H5.25V9.2L2.45 12l2.8 2.8v3.95H9.2l2.8 2.8 2.8-2.8h3.95V14.8z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15.45 9.35l-4.77 4.77-2.65-2.65"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18.75 14.8l2.8-2.8-2.8-2.8V5.25H14.8L12 2.45l-2.8 2.8H5.25V9.2L2.45 12l2.8 2.8v3.95H9.2l2.8 2.8 2.8-2.8h3.95V14.8z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15.45 9.35l-4.77 4.77-2.65-2.65"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M37.5 29.6l5.6-5.6-5.6-5.6v-7.9h-7.9L24 4.9l-5.6 5.6h-7.9v7.9L4.9 24l5.6 5.6v7.9h7.9l5.6 5.6 5.6-5.6h7.9v-7.9z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M30.9 18.7l-9.54 9.54-5.3-5.3"
  }))
};
var Rewards = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2l,
    fill: "none"
  }));
});
var compPaths$2k = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8.29 15.71a5.245 5.245 0 010-7.42m7.42 0a5.245 5.245 0 010 7.42m-9.54 2.12c-3.22-3.22-3.22-8.45 0-11.67m11.66.01c3.22 3.22 3.22 8.45 0 11.67M12 14.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8.29 15.71a5.245 5.245 0 010-7.42m7.42 0a5.245 5.245 0 010 7.42m-9.54 2.12c-3.22-3.22-3.22-8.45 0-11.67m11.66.01c3.22 3.22 3.22 8.45 0 11.67M12 14.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M16.58 31.42a10.49 10.49 0 010-14.84m14.84 0c4.1 4.1 4.1 10.74 0 14.84m-19.08 4.24c-6.44-6.44-6.44-16.9 0-23.34m23.32.02c6.44 6.44 6.44 16.9 0 23.34M24 28.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9z"
  }))
};
var Rfid = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2k,
    fill: "none"
  }));
});
var compPaths$2j = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M2.25 18v1.75a2 2 0 002 2H6m12 0h1.75a2 2 0 002-2V18m0-12V4.25a2 2 0 00-2-2H18m-12 0H4.25a2 2 0 00-2 2V6m11.5 0v12m-7-12v12m10.5-12v12m-7-12v12"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M2.25 18v1.75a2 2 0 002 2H6m12 0h1.75a2 2 0 002-2V18m0-12V4.25a2 2 0 00-2-2H18m-12 0H4.25a2 2 0 00-2 2V6m11.5 0v12m-7-12v12m10.5-12v12m-7-12v12"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M4.5 36v3.5a4 4 0 004 4H12m24 0h3.5a4 4 0 004-4V36m0-24V8.5a4 4 0 00-4-4H36m-24 0H8.5a4 4 0 00-4 4V12m23 0v24m-14-24v24m21-24v24m-14-24v24"
  }))
};
var Scan = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2j,
    fill: "none"
  }));
});
var compPaths$2i = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.962 16.296a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 013.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0110.5 3.75c1.864 0 3.551.755 4.773 1.977A6.728 6.728 0 0117.25 10.5a6.726 6.726 0 01-.921 3.407c-.517.882-.434 1.988.289 2.711l3.853 3.853"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.962 16.296a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 013.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0110.5 3.75c1.864 0 3.551.755 4.773 1.977A6.728 6.728 0 0117.25 10.5a6.726 6.726 0 01-.921 3.407c-.517.882-.434 1.988.289 2.711l3.853 3.853"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M27.924 32.592A13.432 13.432 0 0121 34.5c-3.728 0-7.102-1.51-9.546-3.954A13.455 13.455 0 017.5 21c0-3.728 1.51-7.102 3.954-9.546A13.455 13.455 0 0121 7.5c3.728 0 7.102 1.51 9.546 3.954A13.455 13.455 0 0134.5 21c0 2.486-.672 4.814-1.842 6.814-1.034 1.764-.868 3.976.578 5.422l7.706 7.706"
  }))
};
var Search = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2i,
    fill: "none"
  }));
});
var compPaths$2h = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.248 10.125a3.75 3.75 0 11-6.495 3.75 3.75 3.75 0 016.495-3.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.729 5.857h3.1l1.406 2.434-1.55 2.685a2.25 2.25 0 000 2.25l1.433 2.482-1.406 2.434h-2.866a2.25 2.25 0 00-1.95 1.125l-1.432 2.483h-2.81L9.22 19.267a2.25 2.25 0 00-1.95-1.125h-3.1L2.766 15.71l1.55-2.687a2.25 2.25 0 000-2.25L2.883 8.291l1.406-2.434h2.866a2.25 2.25 0 001.949-1.125l1.433-2.482h2.81l1.433 2.482a2.25 2.25 0 001.949 1.125z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.248 10.125a3.75 3.75 0 11-6.495 3.75 3.75 3.75 0 016.495-3.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.729 5.857h3.1l1.406 2.434-1.55 2.685a2.25 2.25 0 000 2.25l1.433 2.482-1.406 2.434h-2.866a2.25 2.25 0 00-1.95 1.125l-1.432 2.483h-2.81L9.22 19.267a2.25 2.25 0 00-1.95-1.125h-3.1L2.766 15.71l1.55-2.687a2.25 2.25 0 000-2.25L2.883 8.291l1.406-2.434h2.866a2.25 2.25 0 001.949-1.125l1.433-2.482h2.81l1.433 2.482a2.25 2.25 0 001.949 1.125z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M30.495 20.25a7.5 7.5 0 11-12.99 7.5 7.5 7.5 0 0112.99-7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33.457 11.715h6.202l2.81 4.868-3.1 5.37a4.5 4.5 0 000 4.5l2.866 4.964-2.812 4.868H33.69a4.502 4.502 0 00-3.898 2.25L26.927 43.5h-5.62l-2.866-4.966a4.502 4.502 0 00-3.898-2.25H8.34l-2.81-4.866 3.1-5.372a4.5 4.5 0 000-4.5l-2.866-4.964 2.812-4.868h5.732a4.502 4.502 0 003.898-2.25L21.073 4.5h5.62l2.866 4.964a4.502 4.502 0 003.898 2.25z",
    clipRule: "evenodd"
  }))
};
var Settings = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2h,
    fill: "none"
  }));
});
var compPaths$2g = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M20.33 11.35l1.77-3.06-1.84-3.18h-3.53c-.53 0-1.03-.29-1.3-.75L13.78 1.5H10.1L8.45 4.36c-.27.46-.76.75-1.3.75h-3.3L2.02 8.29l1.65 2.86c.27.46.27 1.04 0 1.5L1.9 15.71l1.84 3.18h3.53c.53 0 1.03.29 1.3.75l1.65 2.86h3.68l1.65-2.86c.27-.46.76-.75 1.3-.75h3.3l1.84-3.18-1.65-2.86c-.27-.46-.27-1.04-.01-1.5zM13.5 14.6c-1.43.83-3.27.33-4.1-1.1-.83-1.43-.33-3.27 1.1-4.1.46-.27.97-.4 1.49-.4.26 0 .52.04.78.1.77.21 1.42.7 1.82 1.4.84 1.43.34 3.27-1.09 4.1z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M20.33 11.35l1.77-3.06-1.84-3.18h-3.53c-.53 0-1.03-.29-1.3-.75L13.78 1.5H10.1L8.45 4.36c-.27.46-.76.75-1.3.75h-3.3L2.02 8.29l1.65 2.86c.27.46.27 1.04 0 1.5L1.9 15.71l1.84 3.18h3.53c.53 0 1.03.29 1.3.75l1.65 2.86h3.68l1.65-2.86c.27-.46.76-.75 1.3-.75h3.3l1.84-3.18-1.65-2.86c-.27-.46-.27-1.04-.01-1.5zM13.5 14.6c-1.43.83-3.27.33-4.1-1.1-.83-1.43-.33-3.27 1.1-4.1.46-.27.97-.4 1.49-.4.26 0 .52.04.78.1.77.21 1.42.7 1.82 1.4.84 1.43.34 3.27-1.09 4.1z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M40.66 22.7l3.54-6.12-3.68-6.36h-7.06a3.04 3.04 0 01-2.6-1.5L27.56 3H20.2l-3.3 5.72c-.54.92-1.52 1.5-2.6 1.5H7.7l-3.66 6.36 3.3 5.72c.54.92.54 2.08 0 3L3.8 31.42l3.68 6.36h7.06c1.06 0 2.06.58 2.6 1.5l3.3 5.72h7.36l3.3-5.72c.54-.92 1.52-1.5 2.6-1.5h6.6l3.68-6.36-3.3-5.72a3.03 3.03 0 01-.02-3zM27 29.2c-2.86 1.66-6.54.66-8.2-2.2-1.66-2.86-.66-6.54 2.2-8.2.92-.54 1.94-.8 2.98-.8.52 0 1.04.08 1.56.2 1.54.42 2.84 1.4 3.64 2.8 1.68 2.86.68 6.54-2.18 8.2z"
  }))
};
var SettingsFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2g,
    fill: "none"
  }));
});
var compPaths$2f = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 13v6A2.25 2.25 0 006 21.25h12A2.25 2.25 0 0020.25 19v-6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.552",
    d: "M12 19V4"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.773 8.834l-4.772-4.773-4.774 4.773"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 13v6A2.25 2.25 0 006 21.25h12A2.25 2.25 0 0020.25 19v-6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.552",
    d: "M12 19V4"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.773 8.834l-4.772-4.773-4.774 4.773"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 26v12a4.5 4.5 0 004.5 4.5h24a4.5 4.5 0 004.5-4.5V26"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3.103",
    d: "M24 38V8"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33.547 17.668l-9.546-9.546-9.548 9.546"
  }))
};
var Share = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2f,
    fill: "none"
  }));
});
var compPaths$2e = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.25 6a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm0 12a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-12-6a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.013 13.006L16 17m-.013-9.994l-7.975 3.987"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.25 6a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm0 12a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-12-6a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.013 13.006L16 17m-.013-9.994l-7.975 3.987"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M40.5 12a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm0 24a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-24-12a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.025 26.013L32 34m-.025-19.987l-15.95 7.974"
  }))
};
var Shareaos = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2e,
    fill: "none"
  }));
});
var compPaths$2d = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 16.5a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm12 .033a2.25 2.25 0 11-4.502-.001 2.25 2.25 0 014.502.001z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 16.565H8.5M.75 11.5V14A2.25 2.25 0 003 16.25h.25m16.25-6.5H3A2.25 2.25 0 01.75 7.5V5.25h17.189c.2 0 .39.079.531.22l4.56 4.56a.75.75 0 01.22.531v3.689A2.25 2.25 0 0121 16.5h-.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 16.5a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm12 .033a2.25 2.25 0 11-4.502-.001 2.25 2.25 0 014.502.001z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 16.565H8.5M.75 11.5V14A2.25 2.25 0 003 16.25h.25m16.25-6.5H3A2.25 2.25 0 01.75 7.5V5.25h17.189c.2 0 .39.079.531.22l4.56 4.56a.75.75 0 01.22.531v3.689A2.25 2.25 0 0121 16.5h-.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.5 33a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm24 .066c0 2.484-2.016 4.5-4.5 4.5a4.5 4.5 0 114.5-4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.5 33.13H17M1.5 23v5A4.5 4.5 0 006 32.5h.5m32.5-13H6A4.5 4.5 0 011.5 15v-4.5h34.378c.4 0 .78.158 1.062.44l9.12 9.12c.282.282.44.662.44 1.062V28.5c0 2.484-2.016 4.5-4.5 4.5h-1.5"
  }))
};
var Shipping = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2d,
    fill: "none"
  }));
});
var compPaths$2c = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.366 6.5l1.51 2.636a2.819 2.819 0 01-1.02 3.835l-7.865 4.574a5.203 5.203 0 01-2.614.705H5.859c-1.11 0-1.53-1.462-.59-2.057a4.284 4.284 0 001.422-1.488l4.093-7.143c2.482.67 5.032-.813 5.698-3.312"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.259 12.835c-.57-.063-.604-.828-.597-1.065-.071.328-.142.655-.159.977-.026.505.104.967.414 1.132.56.298 1.132-.32 1.467-.763L15.5 9l-3.45 3.425c-.29.286-.57.432-.791.41z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.872 13.976c-.789-.087-.836-1.146-.826-1.475-.099.454-.197.908-.22 1.354-.037.699.143 1.339.573 1.567.775.413 1.567-.442 2.032-1.056l4.315-5.701-4.777 4.744c-.402.396-.79.598-1.097.567z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.222 4.556l2.032 3.52a3.75 3.75 0 01-1.372 5.123L9.3 19.308a7.039 7.039 0 01-3.517.942H3.742c-1.494 0-2.057-1.952-.793-2.747a5.74 5.74 0 001.913-1.987l5.506-9.54a6.258 6.258 0 007.665-4.424"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.744 27.951c-1.578-.174-1.672-2.292-1.652-2.95-.198.908-.394 1.816-.44 2.708-.074 1.398.286 2.678 1.146 3.134 1.55.826 3.134-.884 4.064-2.112l8.63-11.402-9.554 9.488c-.804.792-1.582 1.196-2.194 1.134z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M38.443 9.112l4.064 7.042a7.499 7.499 0 01-2.744 10.244L18.601 38.614a14.077 14.077 0 01-7.034 1.884H7.483c-2.988 0-4.114-3.904-1.586-5.494a11.48 11.48 0 003.826-3.974l11.012-19.08c6.678 1.79 13.54-2.171 15.33-8.847"
  }))
};
var Shoe = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2c,
    fill: "none"
  }));
});
var compPaths$2b = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.366 6.5l1.51 2.636a2.819 2.819 0 01-1.02 3.835l-7.865 4.574a5.203 5.203 0 01-2.614.705H5.859c-1.11 0-1.53-1.462-.59-2.057a4.284 4.284 0 001.422-1.488l4.093-7.143c2.482.67 5.032-.813 5.698-3.312"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.259 12.835c-.57-.063-.604-.828-.597-1.065-.071.328-.142.655-.159.977-.026.505.104.967.414 1.132.56.298 1.132-.32 1.467-.763L15.5 9l-3.45 3.425c-.29.286-.57.432-.791.41z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.43 14.366c-.464.614-1.256 1.469-2.03 1.056-.431-.228-.611-.868-.573-1.567.022-.447.12-.901.219-1.355-.01.33.037 1.389.827 1.476.305.03.695-.172 1.096-.568l4.777-4.743-4.315 5.7zM21.905 7.7L19.87 4.18l-1.217-2.11c.034-.11.074-.214.103-.325l-1.45-.39a5.514 5.514 0 01-6.744 3.896l-.557-.15L4.211 15.14a4.999 4.999 0 01-1.663 1.727 2.222 2.222 0 00-.96 2.514A2.221 2.221 0 003.743 21h2.042a7.8 7.8 0 003.892-1.043l10.58-6.11a4.473 4.473 0 002.098-2.731 4.476 4.476 0 00-.45-3.415z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.861 28.731c-.93 1.228-2.514 2.938-4.062 2.112-.862-.456-1.222-1.736-1.146-3.134.044-.894.242-1.802.438-2.71-.02.66.074 2.778 1.654 2.952.61.062 1.39-.344 2.192-1.136l9.554-9.486-8.63 11.402zm20.946-13.33l-4.066-7.04-2.434-4.22c.068-.218.148-.428.206-.65l-2.898-.778c-1.57 5.868-7.626 9.36-13.49 7.79l-1.114-.298L8.423 30.281a9.998 9.998 0 01-3.326 3.454 4.443 4.443 0 00-1.918 5.028A4.442 4.442 0 007.483 42h4.084c2.728 0 5.42-.722 7.784-2.086l21.162-12.218a8.947 8.947 0 004.194-5.464 8.953 8.953 0 00-.9-6.83z",
    clipRule: "evenodd"
  }))
};
var ShoeFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2b,
    fill: "none"
  }));
});
var compPaths$2a = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.366 6.5l1.51 2.636a2.819 2.819 0 01-1.02 3.835l-7.865 4.574a5.203 5.203 0 01-2.614.705H5.859c-1.11 0-1.53-1.462-.59-2.057a4.284 4.284 0 001.422-1.488l4.093-7.143c2.482.67 5.032-.813 5.698-3.312"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.259 12.835c-.57-.063-.604-.828-.597-1.065-.071.328-.142.655-.159.977-.026.505.104.967.414 1.132.56.298 1.132-.32 1.467-.763L15.5 9l-3.45 3.425c-.29.286-.57.432-.791.41z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.872 13.976c-.789-.087-.836-1.146-.826-1.475-.099.454-.197.908-.22 1.354-.037.699.143 1.339.573 1.567.775.413 1.567-.442 2.032-1.056l4.315-5.701-4.777 4.744c-.402.396-.79.598-1.097.567z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M19.222 4.556l2.032 3.52a3.75 3.75 0 01-1.372 5.123L9.3 19.308a7.039 7.039 0 01-3.517.942H3.742c-1.494 0-2.057-1.952-.793-2.747a5.74 5.74 0 001.913-1.987l5.506-9.54a6.258 6.258 0 007.665-4.424"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.744 27.951c-1.578-.174-1.672-2.292-1.652-2.95-.198.908-.394 1.816-.44 2.708-.074 1.398.286 2.678 1.146 3.134 1.55.826 3.134-.884 4.064-2.112l8.63-11.402-9.554 9.488c-.804.792-1.582 1.196-2.194 1.134z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M38.443 9.112l4.064 7.042a7.499 7.499 0 01-2.744 10.244L18.601 38.614a14.077 14.077 0 01-7.034 1.884H7.483c-2.988 0-4.114-3.904-1.586-5.494a11.48 11.48 0 003.826-3.974l11.012-19.08c6.678 1.79 13.54-2.171 15.33-8.847"
  }))
};
var ShoeStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2a,
    fill: "none"
  }));
});
var compPaths$29 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M0 8.25h4.5M0 12.75h4.5m12.462 3.546a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 016.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0113.5 3.75c1.864 0 3.551.755 4.773 1.977A6.728 6.728 0 0120.25 10.5a6.726 6.726 0 01-.921 3.407c-.517.882-.434 1.988.289 2.711l3.853 3.853"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M0 8.25h4.5M0 12.75h4.5m12.462 3.546a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 016.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0113.5 3.75c1.864 0 3.551.755 4.773 1.977A6.728 6.728 0 0120.25 10.5a6.726 6.726 0 01-.921 3.407c-.517.882-.434 1.988.289 2.711l3.853 3.853"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M0 16.5h9m-9 9h9m24.924 7.092A13.432 13.432 0 0127 34.5c-3.728 0-7.102-1.51-9.546-3.954A13.455 13.455 0 0113.5 21c0-3.728 1.51-7.102 3.954-9.546A13.455 13.455 0 0127 7.5c3.728 0 7.102 1.51 9.546 3.954A13.455 13.455 0 0140.5 21c0 2.486-.672 4.814-1.842 6.814-1.034 1.764-.868 3.976.578 5.422l7.706 7.706"
  }))
};
var ShopnikeApp = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$29,
    fill: "none"
  }));
});
var compPaths$28 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 9h4.5V7.501H0V9zm0 4.5h4.5v-1.499H0V13.5zm20.148 2.587c-.463-.463-.532-1.187-.172-1.801.016-.028.027-.057.043-.085a7.51 7.51 0 00.398-.799l.008-.022c.112-.269.203-.545.284-.827.021-.075.039-.15.058-.227a7.69 7.69 0 00.137-.681c.012-.08.026-.157.036-.237.036-.298.06-.6.06-.907 0-.255-.013-.509-.038-.76-.006-.06-.019-.118-.026-.179a7.597 7.597 0 00-.087-.564c-.01-.048-.024-.093-.034-.14a7.637 7.637 0 00-.15-.582l-.032-.087a7.165 7.165 0 00-.221-.605c-.007-.018-.016-.034-.024-.05a7.16 7.16 0 00-.292-.606l-.031-.053a7.35 7.35 0 00-.343-.563c-.032-.05-.071-.095-.105-.142-.105-.147-.209-.294-.325-.435a7.502 7.502 0 00-1.028-1.027 7.103 7.103 0 00-.434-.325c-.048-.034-.093-.073-.142-.106a8.117 8.117 0 00-.563-.342c-.019-.01-.035-.022-.053-.032a7.17 7.17 0 00-.606-.29l-.05-.026a7.675 7.675 0 00-.605-.22c-.03-.01-.058-.023-.087-.032a7.886 7.886 0 00-.582-.15c-.047-.01-.093-.025-.14-.035a8.158 8.158 0 00-.564-.086c-.061-.007-.119-.02-.18-.026a7.618 7.618 0 00-1.516 0c-.061.006-.119.02-.179.026-.19.024-.379.05-.565.086-.047.01-.093.025-.14.035-.195.044-.39.091-.582.15-.029.01-.057.022-.086.031a7.393 7.393 0 00-.605.221l-.051.025a7.32 7.32 0 00-.606.291l-.052.032a7.907 7.907 0 00-.564.342c-.049.033-.094.072-.142.106a7.103 7.103 0 00-.434.325 7.502 7.502 0 00-1.028 1.027c-.116.141-.22.288-.325.435-.034.047-.072.092-.105.142a7.034 7.034 0 00-.342.563l-.032.053a7.16 7.16 0 00-.292.605c-.007.017-.017.033-.024.051-.084.198-.155.4-.221.605l-.032.087a7.631 7.631 0 00-.149.582c-.011.047-.025.092-.035.14a7.103 7.103 0 00-.086.564c-.008.061-.021.12-.027.18a7.654 7.654 0 000 1.516c.006.06.019.12.027.18.023.19.048.378.086.564.01.047.024.092.035.14.044.196.09.39.149.582.01.03.022.057.032.086.066.205.137.407.221.605.007.019.017.035.024.052.089.205.184.407.292.604l.032.053c.106.192.218.381.342.564.033.05.071.095.105.143.105.146.209.293.325.434.309.374.653.718 1.028 1.027.14.115.287.22.434.324.048.035.093.073.142.107.183.123.372.236.564.341.018.01.034.023.052.032.198.107.4.203.606.291l.051.026c.197.082.4.154.605.22.029.01.057.023.086.032.192.059.387.105.582.15.047.01.093.024.14.034.186.038.375.063.565.087.06.006.118.02.179.026.25.024.503.038.758.038.312 0 .617-.024.919-.061.082-.01.162-.026.243-.038.236-.037.467-.084.695-.142.074-.02.148-.035.221-.056.295-.085.584-.183.862-.302.016-.006.03-.015.045-.021a7.42 7.42 0 00.759-.389c.034-.018.07-.032.103-.052l-.004-.006a7.59 7.59 0 001.103-.805c.14.377.348.727.641 1.02l3.854 3.854 1.061-1.06-3.854-3.855z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 9h4.5V7.501H0V9zm0 4.5h4.5v-1.499H0V13.5zm20.148 2.587c-.463-.463-.532-1.187-.172-1.801.016-.028.027-.057.043-.085a7.51 7.51 0 00.398-.799l.008-.022c.112-.269.203-.545.284-.827.021-.075.039-.15.058-.227a7.69 7.69 0 00.137-.681c.012-.08.026-.157.036-.237.036-.298.06-.6.06-.907 0-.255-.013-.509-.038-.76-.006-.06-.019-.118-.026-.179a7.597 7.597 0 00-.087-.564c-.01-.048-.024-.093-.034-.14a7.637 7.637 0 00-.15-.582l-.032-.087a7.165 7.165 0 00-.221-.605c-.007-.018-.016-.034-.024-.05a7.16 7.16 0 00-.292-.606l-.031-.053a7.35 7.35 0 00-.343-.563c-.032-.05-.071-.095-.105-.142-.105-.147-.209-.294-.325-.435a7.502 7.502 0 00-1.028-1.027 7.103 7.103 0 00-.434-.325c-.048-.034-.093-.073-.142-.106a8.117 8.117 0 00-.563-.342c-.019-.01-.035-.022-.053-.032a7.17 7.17 0 00-.606-.29l-.05-.026a7.675 7.675 0 00-.605-.22c-.03-.01-.058-.023-.087-.032a7.886 7.886 0 00-.582-.15c-.047-.01-.093-.025-.14-.035a8.158 8.158 0 00-.564-.086c-.061-.007-.119-.02-.18-.026a7.618 7.618 0 00-1.516 0c-.061.006-.119.02-.179.026-.19.024-.379.05-.565.086-.047.01-.093.025-.14.035-.195.044-.39.091-.582.15-.029.01-.057.022-.086.031a7.393 7.393 0 00-.605.221l-.051.025a7.32 7.32 0 00-.606.291l-.052.032a7.907 7.907 0 00-.564.342c-.049.033-.094.072-.142.106a7.103 7.103 0 00-.434.325 7.502 7.502 0 00-1.028 1.027c-.116.141-.22.288-.325.435-.034.047-.072.092-.105.142a7.034 7.034 0 00-.342.563l-.032.053a7.16 7.16 0 00-.292.605c-.007.017-.017.033-.024.051-.084.198-.155.4-.221.605l-.032.087a7.631 7.631 0 00-.149.582c-.011.047-.025.092-.035.14a7.103 7.103 0 00-.086.564c-.008.061-.021.12-.027.18a7.654 7.654 0 000 1.516c.006.06.019.12.027.18.023.19.048.378.086.564.01.047.024.092.035.14.044.196.09.39.149.582.01.03.022.057.032.086.066.205.137.407.221.605.007.019.017.035.024.052.089.205.184.407.292.604l.032.053c.106.192.218.381.342.564.033.05.071.095.105.143.105.146.209.293.325.434.309.374.653.718 1.028 1.027.14.115.287.22.434.324.048.035.093.073.142.107.183.123.372.236.564.341.018.01.034.023.052.032.198.107.4.203.606.291l.051.026c.197.082.4.154.605.22.029.01.057.023.086.032.192.059.387.105.582.15.047.01.093.024.14.034.186.038.375.063.565.087.06.006.118.02.179.026.25.024.503.038.758.038.312 0 .617-.024.919-.061.082-.01.162-.026.243-.038.236-.037.467-.084.695-.142.074-.02.148-.035.221-.056.295-.085.584-.183.862-.302.016-.006.03-.015.045-.021a7.42 7.42 0 00.759-.389c.034-.018.07-.032.103-.052l-.004-.006a7.59 7.59 0 001.103-.805c.14.377.348.727.641 1.02l3.854 3.854 1.061-1.06-3.854-3.855z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 18h9v-2.998H0V18zm0 9h9v-2.998H0V27zm40.296 5.175c-.926-.926-1.064-2.374-.344-3.604.032-.056.054-.114.086-.17a15.02 15.02 0 00.796-1.596c.006-.016.01-.032.016-.046a15.03 15.03 0 00.568-1.652c.042-.15.078-.302.116-.454.112-.448.202-.902.274-1.364.024-.158.052-.314.072-.474.072-.596.12-1.2.12-1.814 0-.51-.026-1.016-.076-1.518-.012-.12-.038-.236-.052-.358a15.195 15.195 0 00-.174-1.128c-.02-.096-.048-.186-.068-.28a15.273 15.273 0 00-.3-1.164c-.02-.058-.044-.116-.064-.174a14.33 14.33 0 00-.442-1.21c-.014-.036-.032-.068-.048-.102a14.319 14.319 0 00-.584-1.21l-.062-.106a14.7 14.7 0 00-.686-1.126c-.064-.1-.142-.19-.21-.284-.21-.294-.418-.588-.65-.87a15.001 15.001 0 00-2.056-2.054c-.28-.232-.574-.442-.868-.65-.096-.068-.186-.146-.284-.212-.366-.246-.744-.47-1.126-.684-.038-.02-.07-.044-.106-.064-.394-.214-.8-.406-1.212-.582l-.1-.05a15.35 15.35 0 00-1.21-.442c-.06-.018-.116-.044-.174-.062a15.772 15.772 0 00-1.164-.3c-.094-.02-.186-.05-.28-.07-.372-.074-.75-.124-1.128-.172-.122-.014-.238-.04-.36-.052a15.236 15.236 0 00-3.032 0c-.122.012-.238.038-.358.052-.38.048-.758.098-1.13.172-.094.02-.186.05-.28.07-.39.088-.78.182-1.164.3-.058.018-.114.044-.172.062-.41.132-.816.276-1.21.442-.036.016-.068.034-.102.05a14.64 14.64 0 00-1.212.582c-.036.02-.068.044-.104.064-.384.214-.762.438-1.128.684-.098.066-.188.144-.284.212-.294.208-.588.418-.868.65a15.001 15.001 0 00-2.056 2.054c-.232.282-.44.576-.65.87-.068.094-.144.184-.21.284-.248.364-.472.742-.684 1.126-.022.036-.044.07-.064.106-.216.394-.406.798-.584 1.21-.014.034-.034.066-.048.102-.168.396-.31.8-.442 1.21-.02.058-.044.116-.064.174-.118.382-.21.772-.298 1.164-.022.094-.05.184-.07.28-.076.372-.126.75-.172 1.128-.016.122-.042.238-.054.358a15.307 15.307 0 000 3.034c.012.12.038.238.054.358.046.38.096.758.172 1.13.02.094.048.184.07.278.088.392.18.782.298 1.164.02.06.044.116.064.174.132.41.274.814.442 1.21.014.036.034.068.048.102.178.412.368.816.584 1.21.02.036.042.07.064.106.212.384.436.762.684 1.128.066.098.142.188.21.284.21.294.418.588.65.868.618.75 1.306 1.438 2.056 2.056.28.23.574.44.868.648.096.068.186.146.284.212.366.246.744.472 1.128.684.036.02.068.044.104.064.396.214.8.406 1.212.582.034.016.066.034.102.05.394.166.8.31 1.21.442.058.02.114.044.172.062.384.118.774.212 1.164.3.094.02.186.05.28.07.372.074.75.124 1.13.172.12.014.236.04.358.054.5.048 1.006.076 1.516.076.624 0 1.234-.05 1.838-.124.164-.02.324-.05.486-.076.472-.072.934-.168 1.39-.284.148-.038.296-.07.442-.112.59-.17 1.168-.366 1.724-.604.032-.012.06-.03.09-.042a14.84 14.84 0 001.518-.776c.068-.038.14-.064.206-.104l-.008-.014a15.181 15.181 0 002.206-1.608c.28.752.696 1.452 1.282 2.04l7.708 7.706 2.122-2.12-7.708-7.708z",
    clipRule: "evenodd"
  }))
};
var ShopnikeAppFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$28,
    fill: "none"
  }));
});
var compPaths$27 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M0 8.25h4.5M0 12.75h4.5m12.462 3.546a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 016.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0113.5 3.75c1.864 0 3.551.755 4.773 1.977A6.728 6.728 0 0120.25 10.5a6.726 6.726 0 01-.921 3.407c-.517.882-.434 1.988.289 2.711l3.632 3.632"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M0 8.25h4.5M0 12.75h4.5m12.462 3.546a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 016.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0113.5 3.75c1.864 0 3.551.755 4.773 1.977A6.728 6.728 0 0120.25 10.5a6.726 6.726 0 01-.921 3.407c-.517.882-.434 1.988.289 2.711l3.632 3.632"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M0 16.5h9m-9 9h9m24.924 7.092A13.432 13.432 0 0127 34.5c-3.728 0-7.102-1.51-9.546-3.954A13.455 13.455 0 0113.5 21c0-3.728 1.51-7.102 3.954-9.546A13.455 13.455 0 0127 7.5c3.728 0 7.102 1.51 9.546 3.954A13.455 13.455 0 0140.5 21c0 2.486-.672 4.814-1.842 6.814-1.034 1.764-.868 3.976.578 5.422L46.5 40.5"
  }))
};
var ShopnikeAppStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$27,
    fill: "none"
  }));
});
var compPaths$26 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.845 12.852l3.352-5.757-2.665 6.554c-.288.706-.826 1.726-1.671 1.53-.47-.109-.806-.674-.95-1.351-.092-.433-.115-.893-.136-1.351.075.317.39 1.317 1.168 1.198.299-.049.62-.342.902-.823z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.99 6.75a4.521 4.521 0 004.312-3.164c.17-.542.841-.723 1.244-.32l3.541 3.54a2.245 2.245 0 010 3.174l-10.27 10.27H4.138a1.888 1.888 0 01-.609-3.676l2.567-.873a2.651 2.651 0 001.706-1.823L11 1.94"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.845 12.852l3.352-5.757-2.665 6.554c-.288.706-.826 1.726-1.671 1.53-.47-.109-.806-.674-.95-1.351-.092-.433-.115-.893-.136-1.351.075.317.39 1.317 1.168 1.198.299-.049.62-.342.902-.823z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.99 6.75a4.521 4.521 0 004.312-3.164c.17-.542.841-.723 1.244-.32l3.541 3.54a2.245 2.245 0 010 3.174l-10.27 10.27H4.138a1.888 1.888 0 01-.609-3.676l2.567-.873a2.651 2.651 0 001.706-1.823L11 1.94"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M25.69 25.704l6.704-11.514-5.33 13.108c-.576 1.412-1.652 3.452-3.342 3.06-.94-.218-1.612-1.348-1.9-2.702-.184-.866-.23-1.786-.272-2.702.15.634.78 2.634 2.336 2.396.598-.098 1.24-.684 1.804-1.646z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M23.98 13.5a9.044 9.044 0 008.625-6.328c.34-1.084 1.681-1.446 2.488-.64l7.081 7.08a4.49 4.49 0 010 6.348L21.635 40.5H8.276A3.775 3.775 0 014.5 36.724a3.779 3.779 0 012.558-3.576l5.135-1.746a5.303 5.303 0 003.412-3.646L22 3.882"
  }))
};
var Shopnrc = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$26,
    fill: "none"
  }));
});
var compPaths$25 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.845 12.852l3.352-5.757-2.665 6.554c-.288.706-.826 1.726-1.671 1.53-.47-.109-.806-.674-.95-1.351-.092-.433-.115-.893-.136-1.351.075.317.39 1.317 1.168 1.198.299-.049.62-.342.902-.823z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M11.99 6.75a4.521 4.521 0 004.312-3.164c.17-.542.841-.723 1.244-.32l3.541 3.54a2.245 2.245 0 010 3.174l-10.27 10.27H4.138a1.888 1.888 0 01-.609-3.676l2.567-.873a2.651 2.651 0 001.706-1.823L11 1.94"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.845 12.852l3.352-5.757-2.665 6.554c-.288.706-.826 1.726-1.671 1.53-.47-.109-.806-.674-.95-1.351-.092-.433-.115-.893-.136-1.351.075.317.39 1.317 1.168 1.198.299-.049.62-.342.902-.823z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M11.99 6.75a4.521 4.521 0 004.312-3.164c.17-.542.841-.723 1.244-.32l3.541 3.54a2.245 2.245 0 010 3.174l-10.27 10.27H4.138a1.888 1.888 0 01-.609-3.676l2.567-.873a2.651 2.651 0 001.706-1.823L11 1.94"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M25.69 25.704l6.704-11.514-5.33 13.108c-.576 1.412-1.652 3.452-3.342 3.06-.94-.218-1.612-1.348-1.9-2.702-.184-.866-.23-1.786-.272-2.702.15.634.78 2.634 2.336 2.396.598-.098 1.24-.684 1.804-1.646z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M23.98 13.5a9.044 9.044 0 008.625-6.328c.34-1.084 1.681-1.446 2.488-.64l7.081 7.08a4.49 4.49 0 010 6.348L21.635 40.5H8.276A3.775 3.775 0 014.5 36.724a3.779 3.779 0 012.558-3.576l5.135-1.746a5.303 5.303 0 003.412-3.646L22 3.882"
  }))
};
var ShopnrcStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$25,
    fill: "none"
  }));
});
var compPaths$24 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M9.39 14.31c-.96-.71-.23-2.12.03-2.54-.47.52-.94 1.03-1.3 1.59-.57.88-.82 1.85-.43 2.47.7 1.12 2.37.6 3.43.15L21 11.81l-9.76 2.58c-.82.21-1.48.19-1.85-.08z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M23.25 4.5v12c0 1.24-1.01 2.25-2.25 2.25H3c-1.24 0-2.25-1.01-2.25-2.25v-1.93l8.76-5.06c.17-.1.33-.22.47-.36l3.9-3.9h4.13c1.24 0 2.25 1.01 2.25 2.25V9"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M9.39 14.31c-.96-.71-.23-2.12.03-2.54-.47.52-.94 1.03-1.3 1.59-.57.88-.82 1.85-.43 2.47.7 1.12 2.37.6 3.43.15L21 11.81l-9.76 2.58c-.82.21-1.48.19-1.85-.08z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M23.25 4.5v12c0 1.24-1.01 2.25-2.25 2.25H3c-1.24 0-2.25-1.01-2.25-2.25v-1.93l8.76-5.06c.17-.1.33-.22.47-.36l3.9-3.9h4.13c1.24 0 2.25 1.01 2.25 2.25V9"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M18.78 28.62c-1.92-1.42-.46-4.24.06-5.08-.94 1.04-1.88 2.06-2.6 3.18-1.14 1.76-1.64 3.7-.86 4.94 1.4 2.24 4.74 1.2 6.86.3L42 23.62l-19.52 5.16c-1.64.42-2.96.38-3.7-.16z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M46.5 9v24c0 2.48-2.02 4.5-4.5 4.5H6c-2.48 0-4.5-2.02-4.5-4.5v-3.86l17.52-10.12c.34-.2.66-.44.94-.72l7.8-7.8h8.26c2.48 0 4.5 2.02 4.5 4.5v3"
  }))
};
var ShopSNKRS = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$24,
    fill: "none"
  }));
});
var compPaths$23 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.602 11.566a.74.74 0 010 .867C20.54 13.924 16.73 18.75 12 18.75s-8.532-4.828-9.593-6.318a.74.74 0 010-.864C3.468 10.078 7.27 5.25 12 5.25c4.73 0 8.54 4.826 9.602 6.316z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.602 11.566a.74.74 0 010 .867C20.54 13.924 16.73 18.75 12 18.75s-8.532-4.828-9.593-6.318a.74.74 0 010-.864C3.468 10.078 7.27 5.25 12 5.25c4.73 0 8.54 4.826 9.602 6.316z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.5 24a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.204 23.133a1.48 1.48 0 010 1.734C41.078 27.847 33.46 37.5 24 37.5c-9.462 0-17.064-9.656-19.186-12.636a1.48 1.48 0 010-1.73C6.936 20.155 14.538 10.5 24 10.5c9.46 0 17.078 9.652 19.204 12.632z",
    clipRule: "evenodd"
  }))
};
var Show = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$23,
    fill: "none"
  }));
});
var compPaths$22 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.28 18.4l2.65-2.65-2.65-2.65m0-2.2l2.65-2.65-2.65-2.65"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M19.5 8.25h-4.14c-.62 0-1.18.25-1.59.66l-6.18 6.18c-.41.41-.97.66-1.59.66H3m6.09-5.34l-1.5-1.5c-.41-.41-.97-.66-1.59-.66H3m16.5 7.5h-4.14c-.62 0-1.18-.25-1.59-.66l-1.5-1.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.28 18.4l2.65-2.65-2.65-2.65m0-2.2l2.65-2.65-2.65-2.65"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M19.5 8.25h-4.14c-.62 0-1.18.25-1.59.66l-6.18 6.18c-.41.41-.97.66-1.59.66H3m6.09-5.34l-1.5-1.5c-.41-.41-.97-.66-1.59-.66H3m16.5 7.5h-4.14c-.62 0-1.18-.25-1.59-.66l-1.5-1.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M34.559 36.8l5.3-5.3-5.3-5.3m0-4.4l5.3-5.3-5.3-5.3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M39 16.5h-8.28c-1.24 0-2.36.5-3.18 1.32L15.18 30.18c-.82.82-1.94 1.32-3.18 1.32H6m12.18-10.68l-3-3A4.474 4.474 0 0012 16.5H6m33 15h-8.28c-1.24 0-2.36-.5-3.18-1.32l-3-3"
  }))
};
var Shuffle = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$22,
    fill: "none"
  }));
});
var compPaths$21 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20.25 7.5v9c0 1.24-1.01 2.25-2.25 2.25H9c-1.24 0-2.25-1.01-2.25-2.25v-9c0-1.24 1.01-2.25 2.25-2.25h9c1.24 0 2.25 1.01 2.25 2.25zm-16.5 3.75v1.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20.25 7.5v9c0 1.24-1.01 2.25-2.25 2.25H9c-1.24 0-2.25-1.01-2.25-2.25v-9c0-1.24 1.01-2.25 2.25-2.25h9c1.24 0 2.25 1.01 2.25 2.25zm-16.5 3.75v1.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M40.5 15v18c0 2.48-2.02 4.5-4.5 4.5H18c-2.48 0-4.5-2.02-4.5-4.5V15c0-2.48 2.02-4.5 4.5-4.5h18c2.48 0 4.5 2.02 4.5 4.5zm-33 7.5v3"
  }))
};
var SingleSelect = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$21,
    fill: "none"
  }));
});
var compPaths$20 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.925 16.229l-3.712 3.713-3.713-3.713M17.212 20V4.5M3.075 7.772l3.712-3.713L10.5 7.772M6.788 4v15.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.925 16.229l-3.712 3.713-3.713-3.713M17.212 20V4.5M3.075 7.772l3.712-3.713L10.5 7.772M6.788 4v15.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M41.85 32.457l-7.427 7.426L27 32.457M34.424 40V9M6.15 15.543l7.426-7.426L21 15.543M13.576 8v31"
  }))
};
var Sort = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$20,
    fill: "none"
  }));
});
var compPaths$1$ = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 14.25H3m4.5-4.5H3m13.5 9H3m10.5-9.46l3.71-3.71 3.71 3.71M17.25 15V6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 14.25H3m4.5-4.5H3m13.5 9H3m10.5-9.46l3.71-3.71 3.71 3.71M17.25 15V6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 28.5H6m9-9H6m27 18H6m21-18.92l7.42-7.42 7.42 7.42M34.5 30V12"
  }))
};
var SortAscending$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1$,
    fill: "none"
  }));
});
var compPaths$1_ = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12.01 9.75h-9m4.5 4.5h-4.5m13.5-9H3.01M17.26 9v9m3.71-3.27l-3.71 3.71-3.71-3.71"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12.01 9.75h-9m4.5 4.5h-4.5m13.5-9H3.01M17.26 9v9m3.71-3.27l-3.71 3.71-3.71-3.71"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24.02 19.5h-18m9 9h-9m27-18h-27m28.5 7.5v18m7.422-6.54l-7.42 7.42-7.42-7.42"
  }))
};
var SortDescending$1 = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1_,
    fill: "none"
  }));
});
var compPaths$1Z = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18.25 6v9.75c0 .827-.765 1.5-1.704 1.5H7.455c-.94 0-1.705-.673-1.705-1.5V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9 17v-6h6v6m-3-5.5V17M4 6.75h16"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M20.25 5.25V16.5c0 1.24-1.01 2.25-2.25 2.25H6c-1.24 0-2.25-1.01-2.25-2.25V5.25"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8.25 18.5v-7.25h7.5v7.25M12 11.25v7.25M1.5 5.25h21"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M40.5 10.5V33c0 2.48-2.02 4.5-4.5 4.5H12c-2.48 0-4.5-2.02-4.5-4.5V10.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M16.5 37V22.5h15V37M24 22.5V37M3 10.5h42"
  }))
};
var Store = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1Z,
    fill: "none"
  }));
});
var compPaths$1Y = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M2.25 16.51v-9c0-1.24 1.01-2.25 2.25-2.25h15c1.24 0 2.25 1.01 2.25 2.25v9c0 1.24-1.01 2.25-2.25 2.25h-15c-1.24 0-2.25-1.01-2.25-2.25zm3-6.01v3"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M2.25 16.51v-9c0-1.24 1.01-2.25 2.25-2.25h15c1.24 0 2.25 1.01 2.25 2.25v9c0 1.24-1.01 2.25-2.25 2.25h-15c-1.24 0-2.25-1.01-2.25-2.25zm3-6.01v3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M4.5 33.02v-18c0-2.48 2.02-4.5 4.5-4.5h30c2.48 0 4.5 2.02 4.5 4.5v18c0 2.48-2.02 4.5-4.5 4.5H9c-2.48 0-4.5-2.02-4.5-4.5zm6-12.02v6"
  }))
};
var TabletHorizontal = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1Y,
    fill: "none"
  }));
});
var compPaths$1X = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.51 21.75h-9c-1.24 0-2.25-1.01-2.25-2.25v-15c0-1.24 1.01-2.25 2.25-2.25h9c1.24 0 2.25 1.01 2.25 2.25v15c0 1.24-1.01 2.25-2.25 2.25zm-6.01-3h3"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.51 21.75h-9c-1.24 0-2.25-1.01-2.25-2.25v-15c0-1.24 1.01-2.25 2.25-2.25h9c1.24 0 2.25 1.01 2.25 2.25v15c0 1.24-1.01 2.25-2.25 2.25zm-6.01-3h3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M33.02 43.5h-18c-2.48 0-4.5-2.02-4.5-4.5V9c0-2.48 2.02-4.5 4.5-4.5h18c2.48 0 4.5 2.02 4.5 4.5v30c0 2.48-2.02 4.5-4.5 4.5zM21 37.5h6"
  }))
};
var TabletVertical = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1X,
    fill: "none"
  }));
});
var compPaths$1W = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M3.75 3.75h7.42l9.93 9.93c.86.86.86 2.25 0 3.11l-4.31 4.31c-.86.86-2.25.86-3.11 0l-9.93-9.93V3.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9 11.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M3.75 3.75h7.42l9.93 9.93c.86.86.86 2.25 0 3.11l-4.31 4.31c-.86.86-2.25.86-3.11 0l-9.93-9.93V3.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9 11.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M7.5 7.5h14.84L42.2 27.36a4.394 4.394 0 010 6.22l-8.62 8.62a4.394 4.394 0 01-6.22 0L7.5 22.34V7.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M18 22.5a4.5 4.5 0 100-9 4.5 4.5 0 000 9z"
  }))
};
var Tag = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1W,
    fill: "none"
  }));
});
var compPaths$1V = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.25 9c0-1.86.76-3.55 1.98-4.77A6.735 6.735 0 0111 2.25h6.25c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-.75 1.75c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5H16.5h1.75c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5H16.5h1.75c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-7.68c-.38 0-.63.42-.43.75l1.73 3c.41.72.17 1.63-.55 2.05-.72.41-1.63.17-2.05-.55l-4.15-7.2A6.58 6.58 0 014.25 9zm0 0c0-3.73 3.02-6.75 6.75-6.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.25 9c0-1.86.76-3.55 1.98-4.77A6.735 6.735 0 0111 2.25h6.25c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-.75 1.75c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5H16.5h1.75c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5H16.5h1.75c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-7.68c-.38 0-.63.42-.43.75l1.73 3c.41.72.17 1.63-.55 2.05-.72.41-1.63.17-2.05-.55l-4.15-7.2A6.58 6.58 0 014.25 9zm0 0c0-3.73 3.02-6.75 6.75-6.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M8.5 18c0-3.72 1.52-7.1 3.96-9.54A13.47 13.47 0 0122 4.5h12.5c1.66 0 3 1.34 3 3s-1.34 3-3 3H33h3.5c1.66 0 3 1.34 3 3s-1.34 3-3 3H33h3.5c1.66 0 3 1.34 3 3s-1.34 3-3 3H33h3.5c1.66 0 3 1.34 3 3s-1.34 3-3 3H21.14c-.76 0-1.26.84-.86 1.5l3.46 6c.82 1.44.34 3.26-1.1 4.1-1.44.82-3.26.34-4.1-1.1l-8.3-14.4C9.12 22.66 8.5 20.4 8.5 18zm0 0c0-7.46 6.04-13.5 13.5-13.5"
  }))
};
var ThumbsDown = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1V,
    fill: "none"
  }));
});
var compPaths$1U = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.25 13.5c0 1.86.76 3.55 1.98 4.77A6.735 6.735 0 0011 20.25h6.25c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-.75 1.75c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5H16.5h1.75c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5H16.5h1.75c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-7.68c-.38 0-.63-.42-.43-.75l1.73-3A1.501 1.501 0 009.27 3l-4.15 7.2c-.56.97-.87 2.1-.87 3.3zm0 0c0 3.73 3.02 6.75 6.75 6.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.25 13.5c0 1.86.76 3.55 1.98 4.77A6.735 6.735 0 0011 20.25h6.25c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-.75 1.75c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5H16.5h1.75c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5H16.5h1.75c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-7.68c-.38 0-.63-.42-.43-.75l1.73-3A1.501 1.501 0 009.27 3l-4.15 7.2c-.56.97-.87 2.1-.87 3.3zm0 0c0 3.73 3.02 6.75 6.75 6.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M8.5 27c0 3.72 1.52 7.1 3.96 9.54A13.47 13.47 0 0022 40.5h12.5c1.66 0 3-1.34 3-3s-1.34-3-3-3H33h3.5c1.66 0 3-1.34 3-3s-1.34-3-3-3H33h3.5c1.66 0 3-1.34 3-3s-1.34-3-3-3H33h3.5c1.66 0 3-1.34 3-3s-1.34-3-3-3H21.14c-.76 0-1.26-.84-.86-1.5l3.46-6c.82-1.44.34-3.26-1.1-4.1-1.44-.82-3.28-.34-4.1 1.1l-8.3 14.4C9.12 22.34 8.5 24.6 8.5 27zm0 0c0 7.46 6.04 13.5 13.5 13.5"
  }))
};
var ThumbsUp = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1U,
    fill: "none"
  }));
});
var compPaths$1T = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 7v5h5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.25 12a7.25 7.25 0 11-14.5 0 7.25 7.25 0 0114.5 0z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 6v6h5.25"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.25 12a8.25 8.25 0 11-16.5 0 8.25 8.25 0 1116.5 0z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 12v12h10.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M40.5 24c0 9.114-7.388 16.5-16.5 16.5S7.5 33.114 7.5 24 14.888 7.5 24 7.5 40.5 14.886 40.5 24z",
    clipRule: "evenodd"
  }))
};
var Time = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1T,
    fill: "none"
  }));
});
var compPaths$1S = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M10.285 16.131h-.75v.75h.75v-.75zm3.429 0v.75h.75v-.75h-.75zm-3.429-1.352h.75v-.432l-.374-.217-.376.65zm3.429 0l-.376-.649-.374.217v.432h.75zM11.249 4v2.286h1.5V4h-1.5zM4 12.75h2.286v-1.5H4v1.5zm13.714 0H20v-1.5h-2.286v1.5zM5.834 6.928L7.45 8.544l1.06-1.06-1.616-1.617-1.06 1.06zm11.27-1.061L15.49 7.483l1.06 1.06 1.617-1.615-1.061-1.061zM9.553 20h4.894v-1.5H9.552V20zm-.23-8.19a2.678 2.678 0 012.678-2.679v-1.5a4.179 4.179 0 00-4.179 4.178h1.5zM12 9.13c1.479 0 2.678 1.2 2.678 2.678h1.5A4.179 4.179 0 0012 7.631v1.5zm-1.715 7.75h3.429v-1.5h-3.429v1.5zm.376-2.75a2.677 2.677 0 01-1.34-2.322h-1.5a4.18 4.18 0 002.089 3.62l.75-1.299zm-1.126.648v1.352h1.5v-1.352h-1.5zm5.143-2.97c0 .991-.537 1.857-1.34 2.321l.752 1.299a4.177 4.177 0 002.088-3.62h-1.5zm-1.714 2.97v1.352h1.5v-1.352h-1.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M9.75 17.75H9v.75h.75v-.75zm4.5 0v.75H15v-.75h-.75zm-4.5-2.102h.75v-.433L10.126 15l-.376.649zm4.5 0l-.376-.65-.374.217v.433h.75zm-3-14.148v3h1.5v-3h-1.5zM1.5 12.75h3v-1.5h-3v1.5zm18 0h3v-1.5h-3v1.5zM4.073 5.177l2.121 2.121 1.061-1.06-2.121-2.122-1.06 1.06zm14.793-1.06l-2.12 2.12 1.06 1.061 2.121-2.121-1.06-1.06zM9 21h6v-1.5H9V21zm-.75-9.25A3.75 3.75 0 0112 8V6.5a5.25 5.25 0 00-5.25 5.25h1.5zM12 8a3.75 3.75 0 013.75 3.75h1.5c0-2.9-2.35-5.25-5.25-5.25V8zM9.75 18.5h4.5V17h-4.5v1.5zm.376-3.501A3.748 3.748 0 018.25 11.75h-1.5a5.248 5.248 0 002.625 4.547l.75-1.298zM9 15.648v2.102h1.5v-2.102H9zm6.75-3.898c0 1.387-.753 2.6-1.876 3.249l.752 1.298a5.248 5.248 0 002.624-4.547h-1.5zm-2.25 3.898v2.102H15v-2.102h-1.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M19.5 35.5H18V37h1.5v-1.5zm9 0V37H30v-1.5h-1.5zm-9-4.204H21v-.865l-.75-.433-.75 1.298zm9 0l-.752-1.298-.749.433v.865h1.5zM22.498 3v6h3V3h-3zM3 25.5h6v-3H3v3zm36 0h6v-3h-6v3zM8.145 10.354l4.243 4.242 2.121-2.121-4.242-4.243-2.122 2.122zm29.587-2.122l-4.243 4.243 2.122 2.121 4.242-4.242-2.121-2.122zM17.999 42h12v-3H18v3zm-1.5-18.5A7.5 7.5 0 0124 16v-3c-5.799 0-10.5 4.701-10.5 10.5h3zM24 16a7.5 7.5 0 017.5 7.5h3C34.5 17.701 29.8 13 24 13v3zm-4.5 21h9v-3h-9v3zm.751-7.002A7.497 7.497 0 0116.5 23.5h-3c0 3.888 2.114 7.281 5.248 9.094l1.502-2.596zM18 31.296V35.5h3v-4.204h-3zM31.5 23.5a7.497 7.497 0 01-3.752 6.498l1.502 2.596A10.496 10.496 0 0034.5 23.5h-3zM27 31.296V35.5h3v-4.204h-3z"
  }))
};
var Tip = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1S,
    fill: "none"
  }));
});
var compPaths$1R = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M4.25 14.25H18c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25h-7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M6.71 16.9l-2.65-2.65 2.65-2.65m13.04-1.85H6c-1.24 0-2.25-1.01-2.25-2.25S4.76 5.25 6 5.25h7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.29 7.1l2.65 2.65-2.65 2.65"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M4.25 14.25H18c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25h-7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M6.71 16.9l-2.65-2.65 2.65-2.65m13.04-1.85H6c-1.24 0-2.25-1.01-2.25-2.25S4.76 5.25 6 5.25h7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.29 7.1l2.65 2.65-2.65 2.65"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M8.5 28.5H36c2.48 0 4.5 2.02 4.5 4.5s-2.02 4.5-4.5 4.5H21"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M13.42 33.8l-5.3-5.3 5.3-5.3m26.08-3.7H12c-2.48 0-4.5-2.02-4.5-4.5s2.02-4.5 4.5-4.5h15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M34.58 14.2l5.3 5.3-5.3 5.3"
  }))
};
var Transfers = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1R,
    fill: "none"
  }));
});
var compPaths$1Q = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18.75H.75V5.25H12m0 0h11.25v13.5H12"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M6.68 8.25h1.77l2.65 7.5H9.4l-.49-1.54H6.15l-.51 1.54H4l2.68-7.5zm-.11 4.67h1.92l-.94-2.96-.98 2.96z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 10c0 .746-.183 1.461-.514 2.108a5.516 5.516 0 01-1.403 1.728A6.672 6.672 0 0114 15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15.014 12.108c.33.647.807 1.233 1.403 1.728.597.494 1.294.89 2.083 1.164m-2.25-6.75V10"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.5 10H20"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18.75H.75V5.25H12m0 0h11.25v13.5H12"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M6.68 8.25h1.77l2.65 7.5H9.4l-.49-1.54H6.15l-.51 1.54H4l2.68-7.5zm-.11 4.67h1.92l-.94-2.96-.98 2.96z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 10c0 .746-.183 1.461-.514 2.108a5.516 5.516 0 01-1.403 1.728A6.672 6.672 0 0114 15"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15.014 12.108c.33.647.807 1.233 1.403 1.728.597.494 1.294.89 2.083 1.164m-2.25-6.75V10"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.5 10H20"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 37.5H1.5v-27H24m0 0h22.5v27H24"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M13.36 16.5h3.54l5.3 15h-3.4l-.98-3.08H12.3l-1.02 3.08H8l5.36-15zm-.22 9.34h3.84l-1.88-5.92-1.96 5.92z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M36 20a9.245 9.245 0 01-1.028 4.216c-.66 1.294-1.614 2.466-2.807 3.455A13.34 13.34 0 0128 30"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M30.027 24.216c.661 1.294 1.615 2.466 2.808 3.455A13.356 13.356 0 0037 30.001M32.5 16.5V20"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M25 20h15"
  }))
};
var Translation = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1Q,
    fill: "none"
  }));
});
var compPaths$1P = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15 8.25h5.25V3m0 5.25L14 2.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.75 20.25h5.5v-4.5h-5.5v4.5zm-8.75 0h3.25V3.75h-5.5V18c0 1.24 1.01 2.25 2.25 2.25zm3.25 0h5.5v-9h-5.5v9z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15 8.25h5.25V3m0 5.25L14 2.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.75 20.25h5.5v-4.5h-5.5v4.5zm-8.75 0h3.25V3.75h-5.5V18c0 1.24 1.01 2.25 2.25 2.25zm3.25 0h5.5v-9h-5.5v9z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M30 16.5h10.5V6m0 10.5L28 5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M29.5 40.5h11v-9h-11v9zm-17.5 0h6.5v-33h-11V36c0 2.48 2.02 4.5 4.5 4.5zm6.5 0h11v-18h-11v18z"
  }))
};
var TrendingDown = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1P,
    fill: "none"
  }));
});
var compPaths$1O = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.25 9V3.75H4m5.25 0L3 9.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 15.75h-5.5v4.49h5.5v-4.49zm8.75 4.5h-3.25V3.75h5.5V18c0 1.24-1.01 2.25-2.25 2.25zm-3.25-9h-5.5v9h5.5v-9z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.25 9V3.75H4m5.25 0L3 9.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 15.75h-5.5v4.49h5.5v-4.49zm8.75 4.5h-3.25V3.75h5.5V18c0 1.24-1.01 2.25-2.25 2.25zm-3.25-9h-5.5v9h5.5v-9z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M18.5 18V7.5H8m10.5 0L6 19"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.5 31.5h-11v8.98h11V31.5zm17.5 9h-6.5v-33h11V36c0 2.48-2.02 4.5-4.5 4.5zm-6.5-18h-11v18h11v-18z"
  }))
};
var TrendingUp = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1O,
    fill: "none"
  }));
});
var compPaths$1N = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15.75V18m0-2.25a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.25 20.25H6.75c-.83 0-1.5-.67-1.5-1.5v-7.5c0-.83.67-1.5 1.5-1.5h10.5c.83 0 1.5.67 1.5 1.5v7.5c0 .83-.67 1.5-1.5 1.5zM15.75 6c0-2.07-1.68-3.75-3.75-3.75-2.07 0-3.75 1.68-3.75 3.75v3.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 15.75V18m0-2.25a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.25 20.25H6.75c-.83 0-1.5-.67-1.5-1.5v-7.5c0-.83.67-1.5 1.5-1.5h10.5c.83 0 1.5.67 1.5 1.5v7.5c0 .83-.67 1.5-1.5 1.5zM15.75 6c0-2.07-1.68-3.75-3.75-3.75-2.07 0-3.75 1.68-3.75 3.75v3.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 31.5V36m0-4.5a3 3 0 100-6 3 3 0 000 6z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M34.5 40.5h-21c-1.66 0-3-1.34-3-3v-15c0-1.66 1.34-3 3-3h21c1.66 0 3 1.34 3 3v15c0 1.66-1.34 3-3 3zm-3-28.5c0-4.14-3.36-7.5-7.5-7.5-4.14 0-7.5 3.36-7.5 7.5v7.5"
  }))
};
var Unlock = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1N,
    fill: "none"
  }));
});
var compPaths$1M = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 11.25A2.248 2.248 0 016.75 9h10.5a2.248 2.248 0 012.25 2.25v7.5A2.248 2.248 0 0117.25 21H6.75a2.248 2.248 0 01-2.25-2.25v-7.5zm5.25 3a2.25 2.25 0 113 2.122V18h-1.5v-1.628a2.251 2.251 0 01-1.5-2.122z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15.75 6c0-2.07-1.68-3.75-3.75-3.75-2.07 0-3.75 1.68-3.75 3.75v3.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 11.25A2.248 2.248 0 016.75 9h10.5a2.248 2.248 0 012.25 2.25v7.5A2.248 2.248 0 0117.25 21H6.75a2.248 2.248 0 01-2.25-2.25v-7.5zm5.25 3a2.25 2.25 0 113 2.122V18h-1.5v-1.628a2.251 2.251 0 01-1.5-2.122z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M15.75 6c0-2.07-1.68-3.75-3.75-3.75-2.07 0-3.75 1.68-3.75 3.75v3.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 22.5c0-2.488 2.012-4.5 4.5-4.5h21c2.488 0 4.5 2.012 4.5 4.5v15c0 2.488-2.012 4.5-4.5 4.5h-21A4.496 4.496 0 019 37.5v-15zm10.5 6a4.5 4.5 0 116 4.244V36h-3v-3.256a4.502 4.502 0 01-3-4.244z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M31.5 12c0-4.14-3.36-7.5-7.5-7.5-4.14 0-7.5 3.36-7.5 7.5v7.5"
  }))
};
var UnlockFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1M,
    fill: "none"
  }));
});
var compPaths$1L = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 7.5v9c0 2.07-1.68 3.75-3.75 3.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.25 7.51a5.254 5.254 0 00-5.24-5.26c-2.9-.01-5.25 2.34-5.26 5.24"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M7.49 6.75c-2.07 0-3.75 1.68-3.75 3.75 0 2.07 1.68 3.75 3.75 3.75h2.26m4.5 0h2.24c2.07 0 3.75-1.68 3.75-3.75 0-2.07-1.68-3.75-3.75-3.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8.29 10.78L12 7.07l3.71 3.71"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 7.5v9c0 2.07-1.68 3.75-3.75 3.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.25 7.51a5.254 5.254 0 00-5.24-5.26c-2.9-.01-5.25 2.34-5.26 5.24"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M7.49 6.75c-2.07 0-3.75 1.68-3.75 3.75 0 2.07 1.68 3.75 3.75 3.75h2.26m4.5 0h2.24c2.07 0 3.75-1.68 3.75-3.75 0-2.07-1.68-3.75-3.75-3.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M8.29 10.78L12 7.07l3.71 3.71"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 15v18c0 4.14-3.36 7.5-7.5 7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M34.5 15.02A10.508 10.508 0 0024.02 4.5c-5.8-.02-10.5 4.68-10.52 10.48"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M14.98 13.5c-4.14 0-7.5 3.36-7.5 7.5 0 4.14 3.36 7.5 7.5 7.5h4.52m9 0h4.48c4.14 0 7.5-3.36 7.5-7.5 0-4.14-3.36-7.5-7.5-7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M16.578 21.56l7.42-7.42 7.42 7.42"
  }))
};
var Upload = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1L,
    fill: "none"
  }));
});
var compPaths$1K = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.39 11.35L10.28 8.4a.75.75 0 00-1.125.649v5.903a.75.75 0 001.125.649l5.11-2.951a.75.75 0 000-1.3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.5 18.75a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25h15z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.39 11.35L10.28 8.4a.75.75 0 00-1.125.649v5.903a.75.75 0 001.125.649l5.11-2.951a.75.75 0 000-1.3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.5 18.75a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25h15z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M30.781 22.701L20.56 16.8c-1-.576-2.25.144-2.25 1.298v11.806c0 1.154 1.25 1.874 2.25 1.298L30.781 25.3a1.5 1.5 0 000-2.598z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M39 37.5a4.5 4.5 0 004.5-4.5V15a4.5 4.5 0 00-4.5-4.5H9A4.5 4.5 0 004.5 15v18A4.5 4.5 0 009 37.5h30z",
    clipRule: "evenodd"
  }))
};
var VideoPlayer = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1K,
    fill: "none"
  }));
});
var compPaths$1J = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.396 10.527l2.61 1.5 2.612-1.5m-2.611 1.5v2.5m0 2.5v2.814m6.75-3.897l-2.442-1.417M5.257 15.944l2.442-1.417m4.308-7.186V4.527m-6.75 3.897l2.442 1.417m11.058-1.417l-2.442 1.417M9.44 18.36l2.567 1.481 2.567-1.482m0-12.349l-2.567-1.483L9.44 6.01m6.75 11.417l2.567-1.482V12.98m0-1.592V8.424L16.19 6.942M7.824 17.427l-2.567-1.482V12.98m0-1.592V8.424l2.567-1.482"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M23.257 12.004c0 6.214-5.039 11.254-11.253 11.254C5.788 23.258.75 18.218.75 12.004.75 5.789 5.788.75 12.004.75c6.214 0 11.253 5.039 11.253 11.254z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.396 10.527l2.61 1.5 2.612-1.5m-2.611 1.5v2.5m0 2.5v2.814m6.75-3.897l-2.442-1.417M5.257 15.944l2.442-1.417m4.308-7.186V4.527m-6.75 3.897l2.442 1.417m11.058-1.417l-2.442 1.417M9.44 18.36l2.567 1.481 2.567-1.482m0-12.349l-2.567-1.483L9.44 6.01m6.75 11.417l2.567-1.482V12.98m0-1.592V8.424L16.19 6.942M7.824 17.427l-2.567-1.482V12.98m0-1.592V8.424l2.567-1.482"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M23.257 12.004c0 6.214-5.039 11.254-11.253 11.254C5.788 23.258.75 18.218.75 12.004.75 5.789 5.788.75 12.004.75c6.214 0 11.253 5.039 11.253 11.254z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.791 21.054l5.223 3 5.224-3m-5.223 3v5m0 5v5.628m13.499-7.794l-4.884-2.834m-22.115 2.834l4.884-2.834m8.616-14.371V9.055m-13.5 7.794l4.884 2.834m22.115-2.834l-4.884 2.834M18.88 36.718l5.135 2.964 5.134-2.964m-.001-24.699l-5.134-2.964-5.134 2.964m13.5 22.834l5.135-2.964V25.96m-.001-3.184V16.85l-5.134-2.965M15.648 34.853l-5.134-2.964V25.96m.001-3.184V16.85l5.134-2.965"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M46.514 24.007c0 12.43-10.078 22.508-22.506 22.508-12.43 0-22.508-10.078-22.508-22.508S11.576 1.499 24.01 1.499c12.428 0 22.505 10.078 22.505 22.508z",
    clipRule: "evenodd"
  }))
};
var VR = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1J,
    fill: "none"
  }));
});
var compPaths$1I = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 8.25H6A2.25 2.25 0 013.75 6v12A2.25 2.25 0 006 20.25h12A2.25 2.25 0 0020.25 18v-7.5A2.25 2.25 0 0018 8.25h-2.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 6.5V3.75H6A2.25 2.25 0 003.75 6v1.25"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.25 15.75h-3a1.5 1.5 0 010-3h3v3z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 8.25H6A2.25 2.25 0 013.75 6v12A2.25 2.25 0 006 20.25h12A2.25 2.25 0 0020.25 18v-7.5A2.25 2.25 0 0018 8.25h-2.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 6.5V3.75H6A2.25 2.25 0 003.75 6v1.25"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.25 15.75h-3a1.5 1.5 0 010-3h3v3z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.5 16.5H12A4.5 4.5 0 017.5 12v24c0 2.484 2.016 4.5 4.5 4.5h24c2.484 0 4.5-2.016 4.5-4.5V21c0-2.484-2.016-4.5-4.5-4.5h-4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M37.5 13V7.5H12A4.5 4.5 0 007.5 12v2.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M40.5 31.5h-6a3.001 3.001 0 010-6h6v6z",
    clipRule: "evenodd"
  }))
};
var Wallet = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1I,
    fill: "none"
  }));
});
var compPaths$1H = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.962 16.296a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 013.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0110.5 3.75a6.73 6.73 0 014.773 1.977A6.728 6.728 0 0117.25 10.5a6.726 6.726 0 01-.921 3.407c-.517.882-.434 1.988.289 2.711l3.853 3.853M10.5 13.5v-6m-3 3h6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.962 16.296a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 013.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0110.5 3.75a6.73 6.73 0 014.773 1.977A6.728 6.728 0 0117.25 10.5a6.726 6.726 0 01-.921 3.407c-.517.882-.434 1.988.289 2.711l3.853 3.853M10.5 13.5v-6m-3 3h6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M27.924 32.592A13.432 13.432 0 0121 34.5c-3.728 0-7.102-1.51-9.546-3.954A13.455 13.455 0 017.5 21c0-3.728 1.51-7.102 3.954-9.546A13.455 13.455 0 0121 7.5c3.728 0 7.102 1.51 9.546 3.954A13.455 13.455 0 0134.5 21c0 2.486-.672 4.814-1.842 6.814-1.034 1.764-.868 3.976.578 5.422l7.706 7.706M21 27V15m-6 6h12"
  }))
};
var Zoomin = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1H,
    fill: "none"
  }));
});
var compPaths$1G = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.962 16.296a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 013.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0110.5 3.75a6.73 6.73 0 014.774 1.977A6.735 6.735 0 0117.25 10.5a6.717 6.717 0 01-.922 3.407c-.516.882-.433 1.988.29 2.711l3.854 3.853M7.5 10.5h6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.962 16.296a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 013.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0110.5 3.75a6.73 6.73 0 014.774 1.977A6.735 6.735 0 0117.25 10.5a6.717 6.717 0 01-.922 3.407c-.516.882-.433 1.988.29 2.711l3.854 3.853M7.5 10.5h6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M27.924 32.592A13.432 13.432 0 0121 34.5c-3.728 0-7.102-1.51-9.546-3.954A13.455 13.455 0 017.5 21c0-3.728 1.51-7.102 3.954-9.546A13.455 13.455 0 0121 7.5a13.46 13.46 0 019.548 3.954A13.47 13.47 0 0134.5 21c0 2.486-.672 4.814-1.844 6.814-1.032 1.764-.866 3.976.58 5.422l7.708 7.706M15 21h12"
  }))
};
var Zoomout = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1G,
    fill: "none"
  }));
});
var compPaths$1F = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 5.75H5.75v12.5H12m0-12.5v12.5m0-12.5h6.25v12.5H12"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 3.75H3.75v16.5H12m0-16.5v16.5m0-16.5h8.25v16.5H12"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 7.5H7.5v33H24m0-33v33m0-33h16.5v33H24"
  }))
};
var Columns = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1F,
    fill: "none"
  }));
});
var compPaths$1E = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 3.75h6m-9 0h-.25a2 2 0 00-2 2V6M18 3.75h.25a2 2 0 012 2V6M15 20.25H9m9 0h.25a2 2 0 002-2V18M6 20.25h-.25a2 2 0 01-2-2V18m0-3V9m16.5 6V9.375"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 3.75h6m-9 0h-.25a2 2 0 00-2 2V6M18 3.75h.25a2 2 0 012 2V6M15 20.25H9m9 0h.25a2 2 0 002-2V18M6 20.25h-.25a2 2 0 01-2-2V18m0-3V9m16.5 6V9.375"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18 7.5h12m-18 0h-.5a4 4 0 00-4 4v.5M36 7.5h.5a4 4 0 014 4v.5M30 40.5H18m18 0h.5a4 4 0 004-4V36M12 40.5h-.5a4 4 0 01-4-4V36m0-6V18m33 12V18.75"
  }))
};
var Container = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1E,
    fill: "none"
  }));
});
var compPaths$1D = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7 9.25h5.5c1.24 0 2.25 1.01 2.25 2.25V17c0 1.24-1.01 2.25-2.25 2.25H7c-1.24 0-2.25-1.01-2.25-2.25v-5.5c0-1.24 1.01-2.25 2.25-2.25zM9.25 7c0-1.24 1.01-2.25 2.25-2.25m5.5 10c1.24 0 2.25-1.01 2.25-2.25m0-5.5c0-1.24-1.01-2.25-2.25-2.25m2.25 3.75V11M13 4.75h2.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 8.25h7.5c1.24 0 2.25 1.01 2.25 2.25V18c0 1.24-1.01 2.25-2.25 2.25H6c-1.24 0-2.25-1.01-2.25-2.25v-7.5c0-1.24 1.01-2.25 2.25-2.25zM8.25 6c0-1.24 1.01-2.25 2.25-2.25m7.5 12c1.24 0 2.25-1.01 2.25-2.25m0-7.5c0-1.24-1.01-2.25-2.25-2.25m2.25 3.75V12M12 3.75h4.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M12 16.5h15c2.48 0 4.5 2.02 4.5 4.5v15c0 2.48-2.02 4.5-4.5 4.5H12c-2.48 0-4.5-2.02-4.5-4.5V21c0-2.48 2.02-4.5 4.5-4.5zm4.5-4.5c0-2.48 2.02-4.5 4.5-4.5m15 24c2.48 0 4.5-2.02 4.5-4.5m0-15c0-2.48-2.02-4.5-4.5-4.5m4.5 7.5v9M24 7.5h9"
  }))
};
var CopyPaste = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1D,
    fill: "none"
  }));
});
var compPaths$1C = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.25 8.5V11"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7 9.25h5.5c1.24 0 2.25 1.01 2.25 2.25V17c0 1.24-1.01 2.25-2.25 2.25H7c-1.24 0-2.25-1.01-2.25-2.25v-5.5c0-1.24 1.01-2.25 2.25-2.25z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 7c0-1.24 1.01-2.25 2.25-2.25m5.5 10c1.24 0 2.25-1.01 2.25-2.25m0-5.5c0-1.24-1.01-2.25-2.25-2.25m-4 0h2.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 8.25h7.5c1.24 0 2.25 1.01 2.25 2.25V18c0 1.24-1.01 2.25-2.25 2.25H6c-1.24 0-2.25-1.01-2.25-2.25v-7.5c0-1.24 1.01-2.25 2.25-2.25z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 6c0-1.24 1.01-2.25 2.25-2.25m7.5 12c1.24 0 2.25-1.01 2.25-2.25m0-7.5c0-1.24-1.01-2.25-2.25-2.25m2.25 3.75V12M12 3.75h4.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M12 16.5h15c2.48 0 4.5 2.02 4.5 4.5v15c0 2.48-2.02 4.5-4.5 4.5H12c-2.48 0-4.5-2.02-4.5-4.5V21c0-2.48 2.02-4.5 4.5-4.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.5 12c0-2.48 2.02-4.5 4.5-4.5m15 24c2.48 0 4.5-2.02 4.5-4.5m0-15c0-2.48-2.02-4.5-4.5-4.5m4.5 7.5v9M24 7.5h9"
  }))
};
var CopyPasteFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1C,
    fill: "none"
  }));
});
var compPaths$1B = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.323 5.75h5.486c1.883 0 3.405 1.4 3.405 3.125 0 1.726-1.522 3.125-3.404 3.125M7.322 5.75V12m0-6.25H5.5m1.823 12.5h7.264c1.883 0 3.413-1.4 3.413-3.125C18 13.399 16.47 12 14.587 12H7.323m0 6.25V12m0 6.25H5.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.798 3.75h6.912c2.372 0 4.29 1.847 4.29 4.125S16.082 12 13.71 12M6.798 3.75V12m0-8.25H4.5m2.298 16.5h9.152c2.372 0 4.3-1.847 4.3-4.125S18.322 12 15.95 12H6.798m0 8.25V12m0 8.25H4.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M12.595 7.5H26.42c4.743 0 8.58 3.694 8.58 8.25S31.163 24 26.42 24M12.595 7.5V24m0-16.5H8m4.595 33H30.9c4.743 0 8.6-3.694 8.6-8.25S35.643 24 30.9 24H12.595m0 16.5V24m0 16.5H8"
  }))
};
var FormatBold = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1B,
    fill: "none"
  }));
});
var compPaths$1A = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M21 4.5H9V6h12V4.5zm-16.5 0H3V6h1.5V4.5zM21 11.25H9v1.5h12v-1.5zm-16.5 0H3v1.5h1.5v-1.5zM21 18H9v1.5h12V18zM4.5 18H3v1.5h1.5V18z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M21 4.5H9V6h12V4.5zm-16.5 0H3V6h1.5V4.5zM21 11.25H9v1.5h12v-1.5zm-16.5 0H3v1.5h1.5v-1.5zM21 18H9v1.5h12V18zM4.5 18H3v1.5h1.5V18z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M42 9H18v3h24V9zM9 9H6v3h3V9zm33 13.5H18v3h24v-3zm-33 0H6v3h3v-3zM42 36H18v3h24v-3zM9 36H6v3h3v-3z"
  }))
};
var FormatBullet = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1A,
    fill: "none"
  }));
});
var compPaths$1z = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10.032 5.75h6.06M7 18.25h6.06m-3.35 0l3.352-12.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10 3.75h8M5.998 20.25h8m-4.422 0L14 3.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M20.004 7.5h16M12 40.5h16m-8.844 0l8.848-33"
  }))
};
var FormatItalics = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1z,
    fill: "none"
  }));
});
var compPaths$1y = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M3.75 20.25H3V21h.75v-.75zm0-1h.75-.75zm1.5-2l.238.712-.237-.712zM5 3.75v.75-.75zM7.5 19.5H3.75V21H7.5v-1.5zm-3-.25c0-.2.1-.481.314-.76.213-.277.473-.461.674-.528l-.474-1.424c-.55.183-1.04.585-1.389 1.038-.348.452-.624 1.046-.624 1.674h1.5zm0 1v-1H3v1h1.5zm1.5-4.5c0 .15-.055.268-.206.397-.173.147-.44.278-.78.392l.474 1.422c.41-.136.891-.341 1.28-.674.412-.351.732-.86.732-1.537H6zM5.25 15a.75.75 0 01.75.75h1.5a2.25 2.25 0 00-2.25-2.25V15zm0-1.5H3V15h2.25v-1.5zm5.25-.75H21v-1.5H10.5v1.5zm0-8.25H21V3H10.5v1.5zm0 16.5H21v-1.5H10.5V21zM4.75 4.25v6.25h1.5V4.25h-1.5zM3 4.5h2V3H3v1.5zm3.25-.25C6.25 3.56 5.69 3 5 3v1.5a.25.25 0 01-.25-.25h1.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M3.75 20.25H3V21h.75v-.75zm0-1h.75-.75zm1.5-2l.238.712-.237-.712zM5 3.75v.75-.75zM7.5 19.5H3.75V21H7.5v-1.5zm-3-.25c0-.2.1-.481.314-.76.213-.277.473-.461.674-.528l-.474-1.424c-.55.183-1.04.585-1.389 1.038-.348.452-.624 1.046-.624 1.674h1.5zm0 1v-1H3v1h1.5zm1.5-4.5c0 .15-.055.268-.206.397-.173.147-.44.278-.78.392l.474 1.422c.41-.136.891-.341 1.28-.674.412-.351.732-.86.732-1.537H6zM5.25 15a.75.75 0 01.75.75h1.5a2.25 2.25 0 00-2.25-2.25V15zm0-1.5H3V15h2.25v-1.5zm5.25-.75H21v-1.5H10.5v1.5zm0-8.25H21V3H10.5v1.5zm0 16.5H21v-1.5H10.5V21zM4.75 4.25v6.25h1.5V4.25h-1.5zM3 4.5h2V3H3v1.5zm3.25-.25C6.25 3.56 5.69 3 5 3v1.5a.25.25 0 01-.25-.25h1.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M7.5 40.5L6 40.499 5.999 42H7.5v-1.5zm.002-2l1.5.001V38.5h-1.5zm3-4l.474 1.423-.474-1.423zM10 7.5V9 7.5zM15.002 39H7.5v3h7.502v-3zm-6-.5c0-.4.197-.962.625-1.519.427-.555.947-.924 1.349-1.058l-.948-2.846c-1.1.366-2.08 1.168-2.778 2.074-.696.904-1.248 2.093-1.248 3.349h3zM9 40.501l.002-2-3-.002-.002 2 3 .002zm3-9.001c0 .302-.11.535-.412.793-.345.296-.882.557-1.561.784l.95 2.846c.818-.273 1.781-.684 2.56-1.349C14.36 33.872 15 32.855 15 31.5h-3zM10.5 30a1.5 1.5 0 011.5 1.5h3a4.5 4.5 0 00-4.5-4.5v3zm0-3H6v3h4.5v-3zM21 25.5h21v-3H21v3zM21 12h21V9H21v3zm0 27h21v-3H21v3zM9.5 8.5V21h3V8.5h-3zM6 9h4V6H6v3zm6.5-.5A2.5 2.5 0 0010 6v3a.5.5 0 01-.5-.5h3z"
  }))
};
var FormatNumberedList = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1y,
    fill: "none"
  }));
});
var compPaths$1x = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M14.84 11.818h.75-.75zm3.031 1.705v.75-.75zM5 5v6.818h1.5V5H5zm0 6.818v7.068h1.5v-7.068H5zM14.09 5v6.818h1.5V5h-1.5zm0 6.818v7.068h1.5v-7.068h-1.5zm-8.34.75h9.09v-1.5H5.75v1.5zm11.75 1.334v4.984H19v-4.984h-1.5zm-.954.37h1.325v-1.5h-1.326v1.5zm2.454-.37a1.13 1.13 0 00-1.129-1.13v1.5a.371.371 0 01-.371-.37H19z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15.75 12h.75-.75zm4 2.25V15v-.75zM3 3v9h1.5V3H3zm0 9v9h1.5v-9H3zm12-9v9h1.5V3H15zm0 9v9h1.5v-9H15zm-11.25.75h12v-1.5h-12v1.5zm15.75 2V21H21v-6.25h-1.5zM18 15h1.75v-1.5H18V15zm3-.25c0-.69-.56-1.25-1.25-1.25V15a.25.25 0 01-.25-.25H21z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M31.5 24H33h-1.5zm8 4.5V30v-1.5zM6 6v18h3V6H6zm0 18v18h3V24H6zM30 6v18h3V6h-3zm0 18v18h3V24h-3zM7.5 25.5h24v-3h-24v3zm31.5 4V42h3V29.5h-3zm-3 .5h3.5v-3H36v3zm6-.5a2.5 2.5 0 00-2.5-2.5v3a.5.5 0 01-.5-.5h3z"
  }))
};
var Heading = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1x,
    fill: "none"
  }));
});
var compPaths$1w = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M9 9.75H7.5v1.5H9v-1.5zm7.5 3h-9v1.5h9v-1.5zm-5-3H10v1.5h1.5v-1.5zm2.5 0h-1.5v1.5H14v-1.5zm2.5 0H15v1.5h1.5v-1.5z"
  }), /* @__PURE__ */ React__default.createElement("rect", {
    width: "14.5",
    height: "10.5",
    x: "4.75",
    y: "6.75",
    stroke: "currentColor",
    strokeWidth: "1.5",
    rx: "2.25"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("rect", {
    width: "19.5",
    height: "13.5",
    x: "2.25",
    y: "5.25",
    stroke: "currentColor",
    strokeWidth: "1.5",
    rx: "3.25"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.75 9.75h1.5m-1.5 4h1.5m1.75 0h8m-8-4h1.5m1.75 0h1.5m1.75 0H16m1.75 0h1.5m-1.5 4h1.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("rect", {
    width: "39",
    height: "27",
    x: "4.5",
    y: "10.5",
    stroke: "currentColor",
    strokeWidth: "3",
    rx: "6.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M9.5 19.5h3m-3 8h3m3.5 0h16m-16-8h3m3.5 0h3m3.5 0h3m3.5 0h3m-3 8h3"
  }))
};
var Keyboard = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1w,
    fill: "none"
  }));
});
var compPaths$1v = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M18.22 7.858l.532.53.528-.53-.528-.53-.531.53zm-7.29.001v.75-.75zm-5.18 5.196h.75-.75zm5.18 5.195v-.75.75zm4.972-7.005l2.85-2.858-1.062-1.059-2.85 2.857 1.062 1.06zm2.85-3.917l-2.85-2.858-1.062 1.06 2.85 2.857 1.062-1.059zm-.532-.22l-7.29.001v1.5l7.29-.001v-1.5zM5 13.055C5 16.336 7.653 19 10.93 19v-1.5a4.438 4.438 0 01-4.43-4.445H5zm5.93-5.946C7.653 7.11 5 9.773 5 13.055h1.5a4.438 4.438 0 014.43-4.446v-1.5zM17.837 17.5H10.93V19h6.907v-1.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M20 6.748l.53.53.53-.53-.53-.53-.53.53zm-9.5.002v.75-.75zM3.75 13.5h.75-.75zm6.75 6.75v-.75.75zm6.317-9.26l3.713-3.71-1.06-1.061-3.713 3.712 1.06 1.06zm3.713-4.772l-3.713-3.713-1.06 1.06 3.713 3.713 1.06-1.06zm-.53-.22L10.5 6v1.5l9.5-.002v-1.5zM3 13.5a7.5 7.5 0 007.5 7.5v-1.5a6 6 0 01-6-6H3zM10.5 6A7.5 7.5 0 003 13.5h1.5a6 6 0 016-6V6zm9 13.5h-9V21h9v-1.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M39.833 13.637l1.062 1.06 1.056-1.06-1.056-1.059-1.062 1.06zm-18.845.004v1.5-1.5zm-13.39 13.43h1.5-1.5zM20.988 40.5V39v1.5zm12.541-18.418l7.366-7.386-2.124-2.118-7.366 7.385 2.124 2.119zm7.366-9.504L33.53 5.191l-2.125 2.118 7.366 7.387 2.124-2.118zm-1.062-.44l-18.846.003.001 3 18.845-.004v-3zM6.098 27.07c0 8.24 6.662 14.93 14.89 14.93v-3c-6.563 0-11.89-5.337-11.89-11.93h-3zm14.89-14.93c-8.228 0-14.89 6.688-14.89 14.93h3c0-6.593 5.327-11.93 11.89-11.93v-3zM38.84 39H20.988v3H38.84v-3z"
  }))
};
var Redo = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1v,
    fill: "none"
  }));
});
var compPaths$1u = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.773 7.457V5.75H17.25v1.707M8.981 18.25h6.06m-3.03 0V5.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.25 6.004V3.75h13.5v2.254M8 20.25h8m-4 0V3.75"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M10.5 12.008V7.5h27v4.508M16 40.5h16m-8 0v-33"
  }))
};
var Text = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1u,
    fill: "none"
  }));
});
var compPaths$1t = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M5.75 7.856l-.53-.53-.53.53.53.53.53-.53zm7.308.002v.75-.75zm5.192 5.192h-.75.75zm-5.192 5.192v-.75.75zm-3.922-8.06L6.28 7.325l-1.06 1.06 2.856 2.856 1.06-1.06zM6.28 8.385L9.136 5.53l-1.06-1.06L5.22 7.326l1.06 1.06zm-.53.22l7.307.002v-1.5L5.75 7.106v1.5zM17.5 13.05a4.442 4.442 0 01-4.442 4.442v1.5A5.942 5.942 0 0019 13.05h-1.5zm-4.442-4.442A4.442 4.442 0 0117.5 13.05H19a5.942 5.942 0 00-5.942-5.942v1.5zM6.135 18.992h6.923v-1.5H6.135v1.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M4 6.748l-.53-.53-.53.53.53.53.53-.53zm9.5.002v.75-.75zm6.75 6.75h-.75.75zm-6.75 6.75v-.75.75zM8.243 9.93L4.53 6.218l-1.06 1.06 3.713 3.713 1.06-1.061zM4.53 7.278l3.713-3.713-1.06-1.06L3.47 6.218l1.06 1.06zm-.53.22l9.5.002V6L4 5.998v1.5zM19.5 13.5a6 6 0 01-6 6V21a7.5 7.5 0 007.5-7.5h-1.5zm-6-6a6 6 0 016 6H21A7.5 7.5 0 0013.5 6v1.5zM4.5 21h9v-1.5h-9V21z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15.465 21.022L8.1 13.637m0 0l7.365-7.387M8.1 13.637l18.845.004c7.395 0 13.39 6.013 13.39 13.43 0 7.416-5.995 13.429-13.39 13.429H9.09"
  }))
};
var Undo = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1t,
    fill: "none"
  }));
});
var compPaths$1s = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.5 12.809l-.007.106a3.75 3.75 0 01-.303 1.287 3.093 3.093 0 01-1.741 1.669 3.6 3.6 0 01-1.308.232 3.723 3.723 0 01-1.578-.325 3.52 3.52 0 01-1.185-.887 3.966 3.966 0 01-.741-1.307A4.835 4.835 0 0112.381 12c0-.552.086-1.082.256-1.574.17-.493.419-.933.74-1.306a3.557 3.557 0 011.185-.892c.463-.22.995-.331 1.579-.331.434 0 .851.061 1.237.181.393.123.739.301 1.033.531.297.23.542.516.727.848.184.331.3.715.344 1.141l.012.11h-1.526l-.02-.075a2.618 2.618 0 00-.226-.587 1.573 1.573 0 00-.364-.453 1.61 1.61 0 00-.519-.298 2.112 2.112 0 00-.698-.106c-.388 0-.727.078-1.007.233a1.995 1.995 0 00-.688.627 2.87 2.87 0 00-.397.905 4.224 4.224 0 000 2.091c.085.336.219.64.397.905.175.26.407.471.688.627.28.155.619.233 1.007.233.283 0 .536-.048.751-.146.213-.097.401-.233.554-.403.155-.171.278-.375.366-.606.089-.232.149-.486.176-.756l.009-.09H19.5zm-9.384 0h1.503l-.007.106c-.03.469-.132.902-.302 1.287a3.093 3.093 0 01-1.742 1.669 3.6 3.6 0 01-1.308.232 3.723 3.723 0 01-1.578-.325 3.52 3.52 0 01-1.185-.887 3.966 3.966 0 01-.741-1.307A4.835 4.835 0 014.5 12c0-.552.086-1.082.256-1.574.17-.493.419-.933.74-1.306a3.557 3.557 0 011.185-.892c.464-.22.995-.331 1.579-.331.435 0 .852.061 1.238.181.392.123.739.301 1.032.531.297.23.542.516.727.848.184.331.3.715.345 1.141l.011.11h-1.526l-.02-.075a2.618 2.618 0 00-.226-.587 1.615 1.615 0 00-.362-.453 1.632 1.632 0 00-.52-.298c-.2-.07-.435-.106-.699-.106-.388 0-.727.078-1.006.233a1.988 1.988 0 00-.689.627 2.879 2.879 0 00-.397.905 4.224 4.224 0 000 2.091c.086.338.22.643.397.905.175.26.408.471.689.627.279.155.618.233 1.006.233.283 0 .536-.048.751-.146.214-.096.4-.232.554-.403.157-.173.28-.377.366-.605.09-.233.149-.487.176-.757l.009-.09z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.5 18.75h-15a2.25 2.25 0 01-2.25-2.25v-9A2.25 2.25 0 014.5 5.25h15a2.25 2.25 0 012.25 2.25v9a2.25 2.25 0 01-2.25 2.25z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.5 12.809l-.007.106a3.75 3.75 0 01-.303 1.287 3.093 3.093 0 01-1.741 1.669 3.6 3.6 0 01-1.308.232 3.723 3.723 0 01-1.578-.325 3.52 3.52 0 01-1.185-.887 3.966 3.966 0 01-.741-1.307A4.835 4.835 0 0112.381 12c0-.552.086-1.082.256-1.574.17-.493.419-.933.74-1.306a3.557 3.557 0 011.185-.892c.463-.22.995-.331 1.579-.331.434 0 .851.061 1.237.181.393.123.739.301 1.033.531.297.23.542.516.727.848.184.331.3.715.344 1.141l.012.11h-1.526l-.02-.075a2.618 2.618 0 00-.226-.587 1.573 1.573 0 00-.364-.453 1.61 1.61 0 00-.519-.298 2.112 2.112 0 00-.698-.106c-.388 0-.727.078-1.007.233a1.995 1.995 0 00-.688.627 2.87 2.87 0 00-.397.905 4.224 4.224 0 000 2.091c.085.336.219.64.397.905.175.26.407.471.688.627.28.155.619.233 1.007.233.283 0 .536-.048.751-.146.213-.097.401-.233.554-.403.155-.171.278-.375.366-.606.089-.232.149-.486.176-.756l.009-.09H19.5zm-9.384 0h1.503l-.007.106c-.03.469-.132.902-.302 1.287a3.093 3.093 0 01-1.742 1.669 3.6 3.6 0 01-1.308.232 3.723 3.723 0 01-1.578-.325 3.52 3.52 0 01-1.185-.887 3.966 3.966 0 01-.741-1.307A4.835 4.835 0 014.5 12c0-.552.086-1.082.256-1.574.17-.493.419-.933.74-1.306a3.557 3.557 0 011.185-.892c.464-.22.995-.331 1.579-.331.435 0 .852.061 1.238.181.392.123.739.301 1.032.531.297.23.542.516.727.848.184.331.3.715.345 1.141l.011.11h-1.526l-.02-.075a2.618 2.618 0 00-.226-.587 1.615 1.615 0 00-.362-.453 1.632 1.632 0 00-.52-.298c-.2-.07-.435-.106-.699-.106-.388 0-.727.078-1.006.233a1.988 1.988 0 00-.689.627 2.879 2.879 0 00-.397.905 4.224 4.224 0 000 2.091c.086.338.22.643.397.905.175.26.408.471.689.627.279.155.618.233 1.006.233.283 0 .536-.048.751-.146.214-.096.4-.232.554-.403.157-.173.28-.377.366-.605.09-.233.149-.487.176-.757l.009-.09z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.5 18.75h-15a2.25 2.25 0 01-2.25-2.25v-9A2.25 2.25 0 014.5 5.25h15a2.25 2.25 0 012.25 2.25v9a2.25 2.25 0 01-2.25 2.25z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M39 25.618l-.014.212c-.06.938-.264 1.804-.606 2.574a6.304 6.304 0 01-1.404 2.022 6.186 6.186 0 01-2.078 1.316c-.792.308-1.674.464-2.616.464-1.162 0-2.226-.218-3.156-.65a7.04 7.04 0 01-2.37-1.774 7.932 7.932 0 01-1.482-2.614A9.67 9.67 0 0124.762 24a9.62 9.62 0 01.512-3.148 7.954 7.954 0 011.48-2.612 7.114 7.114 0 012.37-1.784c.926-.44 1.99-.662 3.158-.662.868 0 1.702.122 2.474.362a6.453 6.453 0 012.066 1.062 5.55 5.55 0 011.454 1.696c.368.662.6 1.43.688 2.282l.024.22h-3.052l-.04-.15a5.236 5.236 0 00-.452-1.174 3.147 3.147 0 00-.728-.906 3.222 3.222 0 00-1.038-.596c-.398-.14-.868-.212-1.396-.212-.776 0-1.454.156-2.014.466a3.99 3.99 0 00-1.376 1.254 5.742 5.742 0 00-.794 1.81 8.447 8.447 0 000 4.182c.17.672.438 1.28.794 1.81.35.52.814.942 1.376 1.254.56.31 1.238.466 2.014.466.566 0 1.072-.096 1.502-.292a3.352 3.352 0 001.108-.806c.31-.342.556-.75.732-1.212.178-.464.298-.972.352-1.512l.018-.18H39zm-18.768 0h3.006l-.014.212a7.545 7.545 0 01-.604 2.574 6.373 6.373 0 01-1.406 2.022 6.186 6.186 0 01-2.078 1.316c-.792.308-1.674.464-2.616.464-1.162 0-2.226-.218-3.156-.65a7.04 7.04 0 01-2.37-1.774 7.932 7.932 0 01-1.482-2.614A9.67 9.67 0 019 24a9.62 9.62 0 01.512-3.148 7.954 7.954 0 011.48-2.612 7.114 7.114 0 012.37-1.784c.928-.44 1.99-.662 3.158-.662.87 0 1.704.122 2.476.362a6.443 6.443 0 012.064 1.062 5.55 5.55 0 011.454 1.696c.368.662.6 1.43.69 2.282l.022.22h-3.052l-.04-.15a5.236 5.236 0 00-.452-1.174 3.23 3.23 0 00-.724-.906 3.265 3.265 0 00-1.04-.596c-.4-.14-.87-.212-1.398-.212-.776 0-1.454.156-2.012.466a3.977 3.977 0 00-1.378 1.254 5.757 5.757 0 00-.794 1.81 8.447 8.447 0 000 4.182c.172.676.44 1.286.794 1.81.35.52.816.942 1.378 1.254.558.31 1.236.466 2.012.466.566 0 1.072-.096 1.502-.292.428-.192.8-.464 1.108-.806a3.77 3.77 0 00.732-1.21c.18-.466.298-.974.352-1.514l.018-.18z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M39 37.5H9A4.5 4.5 0 014.5 33V15A4.5 4.5 0 019 10.5h30a4.5 4.5 0 014.5 4.5v18a4.5 4.5 0 01-4.5 4.5z",
    clipRule: "evenodd"
  }))
};
var ClosedCaption = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1s,
    fill: "none"
  }));
});
var compPaths$1r = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.493 12.915c-.03.469-.132.902-.303 1.288a3.179 3.179 0 01-.702 1.01 3.124 3.124 0 01-1.039.659 3.622 3.622 0 01-1.309.232 3.73 3.73 0 01-1.578-.326 3.49 3.49 0 01-1.184-.888 3.934 3.934 0 01-.74-1.306A4.841 4.841 0 0112.38 12a4.8 4.8 0 01.256-1.572 3.95 3.95 0 01.74-1.306 3.54 3.54 0 011.184-.892c.464-.22.995-.332 1.58-.332.434 0 .851.06 1.237.182.392.122.74.3 1.033.53.297.23.542.517.727.849.184.33.3.713.344 1.14l.012.11h-1.526l-.02-.075a2.695 2.695 0 00-.226-.587 1.6 1.6 0 00-.883-.75 2.091 2.091 0 00-.699-.107c-.387 0-.726.079-1.006.234a1.986 1.986 0 00-.688.627c-.18.263-.312.568-.397.904a4.216 4.216 0 000 2.091c.085.337.218.64.397.905.175.26.406.47.688.628.28.154.62.232 1.006.232.284 0 .537-.049.751-.146.214-.096.402-.232.555-.403.154-.171.277-.374.365-.605.09-.232.15-.488.177-.758l.01-.088H19.5l-.007.105zm-7.88 0c-.03.469-.133.902-.304 1.288a3.179 3.179 0 01-.702 1.01 3.124 3.124 0 01-1.039.659 3.62 3.62 0 01-1.308.232 3.73 3.73 0 01-1.579-.326 3.5 3.5 0 01-1.184-.888 3.951 3.951 0 01-.74-1.306A4.841 4.841 0 014.5 12a4.8 4.8 0 01.256-1.572c.17-.494.42-.933.74-1.306A3.55 3.55 0 016.68 8.23c.464-.22.996-.332 1.58-.332.435 0 .852.06 1.238.182a3.25 3.25 0 011.032.53c.297.23.542.517.727.849.184.33.3.713.344 1.14l.012.11h-1.526l-.02-.075a2.645 2.645 0 00-.226-.587 1.615 1.615 0 00-.363-.453 1.633 1.633 0 00-.519-.297 2.096 2.096 0 00-.699-.107c-.388 0-.727.079-1.006.234a1.97 1.97 0 00-.689.627 2.879 2.879 0 00-.397.904 4.216 4.216 0 000 2.091c.086.338.22.643.397.905.175.26.407.47.69.628.278.154.617.232 1.005.232.283 0 .536-.049.751-.146.213-.096.4-.232.554-.403.157-.173.28-.377.365-.605.09-.232.15-.488.177-.758l.01-.088h1.502l-.007.105zM19.5 4.5h-15c-1.654 0-3 1.346-3 3v9c0 1.654 1.346 3 3 3h15c1.654 0 3-1.346 3-3v-9c0-1.654-1.346-3-3-3z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.493 12.915c-.03.469-.132.902-.303 1.288a3.179 3.179 0 01-.702 1.01 3.124 3.124 0 01-1.039.659 3.622 3.622 0 01-1.309.232 3.73 3.73 0 01-1.578-.326 3.49 3.49 0 01-1.184-.888 3.934 3.934 0 01-.74-1.306A4.841 4.841 0 0112.38 12a4.8 4.8 0 01.256-1.572 3.95 3.95 0 01.74-1.306 3.54 3.54 0 011.184-.892c.464-.22.995-.332 1.58-.332.434 0 .851.06 1.237.182.392.122.74.3 1.033.53.297.23.542.517.727.849.184.33.3.713.344 1.14l.012.11h-1.526l-.02-.075a2.695 2.695 0 00-.226-.587 1.6 1.6 0 00-.883-.75 2.091 2.091 0 00-.699-.107c-.387 0-.726.079-1.006.234a1.986 1.986 0 00-.688.627c-.18.263-.312.568-.397.904a4.216 4.216 0 000 2.091c.085.337.218.64.397.905.175.26.406.47.688.628.28.154.62.232 1.006.232.284 0 .537-.049.751-.146.214-.096.402-.232.555-.403.154-.171.277-.374.365-.605.09-.232.15-.488.177-.758l.01-.088H19.5l-.007.105zm-7.88 0c-.03.469-.133.902-.304 1.288a3.179 3.179 0 01-.702 1.01 3.124 3.124 0 01-1.039.659 3.62 3.62 0 01-1.308.232 3.73 3.73 0 01-1.579-.326 3.5 3.5 0 01-1.184-.888 3.951 3.951 0 01-.74-1.306A4.841 4.841 0 014.5 12a4.8 4.8 0 01.256-1.572c.17-.494.42-.933.74-1.306A3.55 3.55 0 016.68 8.23c.464-.22.996-.332 1.58-.332.435 0 .852.06 1.238.182a3.25 3.25 0 011.032.53c.297.23.542.517.727.849.184.33.3.713.344 1.14l.012.11h-1.526l-.02-.075a2.645 2.645 0 00-.226-.587 1.615 1.615 0 00-.363-.453 1.633 1.633 0 00-.519-.297 2.096 2.096 0 00-.699-.107c-.388 0-.727.079-1.006.234a1.97 1.97 0 00-.689.627 2.879 2.879 0 00-.397.904 4.216 4.216 0 000 2.091c.086.338.22.643.397.905.175.26.407.47.69.628.278.154.617.232 1.005.232.283 0 .536-.049.751-.146.213-.096.4-.232.554-.403.157-.173.28-.377.365-.605.09-.232.15-.488.177-.758l.01-.088h1.502l-.007.105zM19.5 4.5h-15c-1.654 0-3 1.346-3 3v9c0 1.654 1.346 3 3 3h15c1.654 0 3-1.346 3-3v-9c0-1.654-1.346-3-3-3z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M38.986 25.831a7.522 7.522 0 01-.606 2.574 6.358 6.358 0 01-1.404 2.022 6.249 6.249 0 01-2.078 1.316 7.244 7.244 0 01-2.618.464c-1.162 0-2.224-.22-3.156-.652a6.98 6.98 0 01-2.368-1.774 7.868 7.868 0 01-1.482-2.612 9.682 9.682 0 01-.512-3.17c0-1.104.172-2.164.512-3.146a7.898 7.898 0 011.48-2.612 7.08 7.08 0 012.368-1.784c.928-.44 1.99-.664 3.158-.664.87 0 1.704.122 2.476.364a6.47 6.47 0 012.066 1.06 5.58 5.58 0 011.454 1.698c.368.662.6 1.428.688 2.282l.024.22h-3.052l-.04-.15a5.39 5.39 0 00-.452-1.176 3.181 3.181 0 00-1.766-1.5c-.4-.142-.868-.214-1.398-.214-.774 0-1.452.158-2.012.468a3.972 3.972 0 00-1.376 1.254 5.658 5.658 0 00-.794 1.81 8.431 8.431 0 000 4.182c.17.672.436 1.28.794 1.81.35.518.812.94 1.376 1.254.56.308 1.238.466 2.012.466.568 0 1.074-.098 1.502-.292a3.318 3.318 0 001.11-.808c.308-.342.554-.748.73-1.21.18-.464.3-.974.354-1.514l.018-.178H39l-.014.212zm-15.762 0a7.522 7.522 0 01-.606 2.574 6.358 6.358 0 01-1.404 2.022 6.249 6.249 0 01-2.078 1.316 7.241 7.241 0 01-2.616.464c-1.162 0-2.226-.22-3.158-.652a7 7 0 01-2.368-1.774 7.903 7.903 0 01-1.482-2.612A9.682 9.682 0 019 23.999c0-1.104.172-2.164.512-3.146a7.933 7.933 0 011.48-2.612 7.1 7.1 0 012.368-1.784c.928-.44 1.992-.664 3.16-.664.87 0 1.704.122 2.476.364a6.5 6.5 0 012.064 1.06 5.58 5.58 0 011.454 1.698c.368.662.598 1.428.688 2.282l.024.22h-3.052l-.04-.15a5.29 5.29 0 00-.452-1.176 3.23 3.23 0 00-.726-.906 3.266 3.266 0 00-1.038-.594c-.4-.142-.87-.214-1.398-.214-.776 0-1.454.158-2.012.468a3.94 3.94 0 00-1.378 1.254 5.757 5.757 0 00-.794 1.81 8.431 8.431 0 000 4.182c.172.676.44 1.284.794 1.81.35.52.814.94 1.378 1.254.558.308 1.236.466 2.012.466.566 0 1.072-.098 1.502-.292.426-.194.8-.464 1.108-.808.314-.346.56-.752.73-1.21.18-.464.3-.974.354-1.514l.018-.178h3.006l-.014.212zM39 8.999H9c-3.308 0-6 2.692-6 6v18c0 3.31 2.692 6 6 6h30c3.308 0 6-2.69 6-6v-18c0-3.308-2.692-6-6-6z",
    clipRule: "evenodd"
  }))
};
var ClosedCaptionFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1r,
    fill: "none"
  }));
});
var compPaths$1q = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.01 12V7.242a.75.75 0 011.126-.65l8.239 4.757a.75.75 0 010 1.3l-8.24 4.757a.75.75 0 01-1.125-.65v-1.828"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.644 11.365a.732.732 0 010 1.268l-8.268 4.773a.75.75 0 01-1.126-.65v-1.76"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 15.172v-7.93a.751.751 0 011.126-.65l6.632 3.83"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.01 12V7.242a.75.75 0 011.126-.65l8.239 4.757a.75.75 0 010 1.3l-8.24 4.757a.75.75 0 01-1.125-.65v-1.828"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.644 11.365a.732.732 0 010 1.268l-8.268 4.773a.75.75 0 01-1.126-.65v-1.76"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 15.172v-7.93a.751.751 0 011.126-.65l6.632 3.83"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24.02 24v-9.516c0-1.156 1.25-1.876 2.252-1.3l16.478 9.514c1 .578 1 2.022 0 2.6l-16.478 9.514a1.5 1.5 0 01-2.252-1.3v-3.656"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M23.287 22.73a1.464 1.464 0 010 2.537L6.751 34.813a1.501 1.501 0 01-2.252-1.3v-3.52"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M4.5 30.344v-15.86c0-1.156 1.252-1.876 2.252-1.3l13.264 7.658"
  }))
};
var FastForward = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1q,
    fill: "none"
  }));
});
var compPaths$1p = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.259 14.926V7.39a.75.75 0 011.125-.65l7.98 4.609a.75.75 0 010 1.299l-7.98 4.608a.75.75 0 01-1.125-.65v-1.751",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.259 14.926V7.39a.75.75 0 011.125-.65l7.98 4.609a.75.75 0 010 1.299l-7.98 4.608a.75.75 0 01-1.125-.65v-1.751"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.268 14.923V7.397a.75.75 0 011.125-.65l7.973 4.603a.75.75 0 010 1.299L3.393 17.25a.75.75 0 01-1.125-.65v-1.748",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.268 14.923V7.397a.75.75 0 011.125-.65l7.973 4.603a.75.75 0 010 1.299L3.393 17.25a.75.75 0 01-1.125-.65v-1.748"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.259 14.926V7.39a.75.75 0 011.125-.65l7.98 4.609a.75.75 0 010 1.299l-7.98 4.608a.75.75 0 01-1.125-.65v-1.751",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.259 14.926V7.39a.75.75 0 011.125-.65l7.98 4.609a.75.75 0 010 1.299l-7.98 4.608a.75.75 0 01-1.125-.65v-1.751"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.268 14.923V7.397a.75.75 0 011.125-.65l7.973 4.603a.75.75 0 010 1.299L3.393 17.25a.75.75 0 01-1.125-.65v-1.748",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.268 14.923V7.397a.75.75 0 011.125-.65l7.973 4.603a.75.75 0 010 1.299L3.393 17.25a.75.75 0 01-1.125-.65v-1.748"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M43.48 21.4l-15.962-9.216a2.967 2.967 0 00-2.998-.002 2.966 2.966 0 00-1.502 2.598v6.352L7.534 12.194a2.98 2.98 0 00-3-.002 2.978 2.978 0 00-1.5 2.6v18.41c0 1.086.562 2.058 1.5 2.6.472.27.986.406 1.5.406a2.98 2.98 0 001.5-.408l15.484-8.94v6.354c0 1.086.56 2.058 1.5 2.6.468.27.984.406 1.5.406a2.99 2.99 0 001.5-.408l15.96-9.216a2.964 2.964 0 001.502-2.594c0-1.086-.56-2.06-1.5-2.602z",
    clipRule: "evenodd"
  }))
};
var FastForwardFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1p,
    fill: "none"
  }));
});
var compPaths$1o = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 18V6m10.5 10.5V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 8.25H8.25v-3a1.5 1.5 0 011.5-1.5h7.5a1.5 1.5 0 011.5 1.5v3zM8.25 18a2.25 2.25 0 11-4.502-.002A2.25 2.25 0 018.25 18zm10.5-1.5a2.25 2.25 0 11-4.502-.002 2.25 2.25 0 014.502.002z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 18V6m10.5 10.5V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 8.25H8.25v-3a1.5 1.5 0 011.5-1.5h7.5a1.5 1.5 0 011.5 1.5v3zM8.25 18a2.25 2.25 0 11-4.502-.002A2.25 2.25 0 018.25 18zm10.5-1.5a2.25 2.25 0 11-4.502-.002 2.25 2.25 0 014.502.002z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.5 36V12m21 21V12"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M37.5 16.5h-21v-6c0-1.656 1.344-3 3-3h15c1.656 0 3 1.344 3 3v6zM16.5 36c0 2.484-2.016 4.5-4.5 4.5A4.502 4.502 0 017.5 36c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5zm21-3c0 2.484-2.016 4.5-4.5 4.5a4.502 4.502 0 01-4.5-4.5c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5z",
    clipRule: "evenodd"
  }))
};
var Music = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1o,
    fill: "none"
  }));
});
var compPaths$1n = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.25 3h-7.5C8.51 3 7.5 4.01 7.5 5.25v10.167A2.968 2.968 0 006 15c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3V9h9v4.917a2.968 2.968 0 00-1.5-.417c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3V5.25C19.5 4.01 18.49 3 17.25 3z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.25 3h-7.5C8.51 3 7.5 4.01 7.5 5.25v10.167A2.968 2.968 0 006 15c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3V9h9v4.917a2.968 2.968 0 00-1.5-.417c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3V5.25C19.5 4.01 18.49 3 17.25 3z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M34.5 6h-15C17.02 6 15 8.02 15 10.5v20.334c-.886-.516-1.902-.834-3-.834-3.308 0-6 2.692-6 6s2.692 6 6 6 6-2.692 6-6V18h18v9.834c-.886-.516-1.902-.834-3-.834-3.308 0-6 2.692-6 6s2.692 6 6 6 6-2.692 6-6V10.5C39 8.02 36.98 6 34.5 6z",
    clipRule: "evenodd"
  }))
};
var MusicFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1n,
    fill: "none"
  }));
});
var compPaths$1m = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.5 18a1.498 1.498 0 01-.814-2.756l2.07 2.07c-.267.412-.73.686-1.256.686zM6 19.5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5zm16.5.437l-3.04-3.041-3.356-3.356h-.001L11.563 9l-1.5-1.5L9 6.437 7.529 4.965v.001L5.561 2.998 4.5 4.06l3 3v8.358A2.968 2.968 0 006 15c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3V8.559l5.62 5.619A2.967 2.967 0 0013.5 16.5c0 1.654 1.346 3 3 3 .941 0 1.776-.438 2.322-1.119l2.618 2.617 1.06-1.061zM9.75 4.5h7.5a.75.75 0 01.75.75V7.5h-5.815l1.5 1.5H18v4.315l1.5 1.5V5.25C19.5 4.01 18.491 3 17.25 3h-7.5c-.573 0-1.091.222-1.489.576l1.069 1.07a.73.73 0 01.42-.146z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.5 18a1.498 1.498 0 01-.814-2.756l2.07 2.07c-.267.412-.73.686-1.256.686zM6 19.5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5zm16.5.437l-3.04-3.041-3.356-3.356h-.001L11.563 9l-1.5-1.5L9 6.437 7.529 4.965v.001L5.561 2.998 4.5 4.06l3 3v8.358A2.968 2.968 0 006 15c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3V8.559l5.62 5.619A2.967 2.967 0 0013.5 16.5c0 1.654 1.346 3 3 3 .941 0 1.776-.438 2.322-1.119l2.618 2.617 1.06-1.061zM9.75 4.5h7.5a.75.75 0 01.75.75V7.5h-5.815l1.5 1.5H18v4.315l1.5 1.5V5.25C19.5 4.01 18.491 3 17.25 3h-7.5c-.573 0-1.091.222-1.489.576l1.069 1.07a.73.73 0 01.42-.146z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M33 36c-1.654 0-3-1.346-3-3 0-1.052.548-1.976 1.372-2.512l4.14 4.14A2.993 2.993 0 0133 36zm-21 3c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm33 .874l-6.08-6.082-6.712-6.712h-.002L23.126 18l-3-3L18 12.874 15.058 9.93v.002l-3.936-3.936L9 8.118l6 6v16.716c-.886-.516-1.902-.834-3-.834-3.308 0-6 2.692-6 6s2.692 6 6 6 6-2.692 6-6V17.118l11.24 11.238A5.934 5.934 0 0027 33c0 3.308 2.692 6 6 6a5.935 5.935 0 004.644-2.238l5.236 5.234L45 39.874zM19.5 9h15c.828 0 1.5.674 1.5 1.5V15H24.37l3 3H36v8.63l3 3V10.5C39 8.02 36.982 6 34.5 6h-15a4.467 4.467 0 00-2.978 1.152l2.138 2.14c.244-.17.522-.292.84-.292z",
    clipRule: "evenodd"
  }))
};
var MusicNone = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1m,
    fill: "none"
  }));
});
var compPaths$1l = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 9v4.315l1.5 1.5V5.25C19.5 4.01 18.491 3 17.25 3h-7.5c-.574 0-1.096.218-1.492.574L13.685 9H18zm1.46 7.896l-3.356-3.356h-.001L11.563 9h.001L7.529 4.967 5.561 2.999l-1.06 1.06 2.999 3v8.359A2.968 2.968 0 006 15c-1.654 0-3 1.345-3 3 0 1.653 1.346 3 3 3s3-1.347 3-3V8.558l5.622 5.62A2.984 2.984 0 0013.5 16.5c0 1.654 1.346 3 3 3 .94 0 1.77-.444 2.32-1.122l2.62 2.62 1.061-1.06-3.041-3.041z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 9v4.315l1.5 1.5V5.25C19.5 4.01 18.491 3 17.25 3h-7.5c-.574 0-1.096.218-1.492.574L13.685 9H18zm1.46 7.896l-3.356-3.356h-.001L11.563 9h.001L7.529 4.967 5.561 2.999l-1.06 1.06 2.999 3v8.359A2.968 2.968 0 006 15c-1.654 0-3 1.345-3 3 0 1.653 1.346 3 3 3s3-1.347 3-3V8.558l5.622 5.62A2.984 2.984 0 0013.5 16.5c0 1.654 1.346 3 3 3 .94 0 1.77-.444 2.32-1.122l2.62 2.62 1.061-1.06-3.041-3.041z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M36 18v8.63l3 3V10.5C39 8.02 36.982 6 34.5 6h-15a4.448 4.448 0 00-2.984 1.148L27.37 18H36zm2.92 15.793l-6.712-6.712h-.002l-9.08-9.08h.002l-8.07-8.07-3.936-3.934-2.12 2.12 5.998 6v16.718c-.886-.516-1.902-.834-3-.834-3.308 0-6 2.69-6 6 0 3.308 2.692 6 6 6s6-2.692 6-6V17.117L29.244 28.36C27.886 29.461 27 31.121 27 33.001c0 3.308 2.692 6 6 6 1.88 0 3.54-.888 4.64-2.246l5.24 5.242 2.122-2.122-6.082-6.082z",
    clipRule: "evenodd"
  }))
};
var MusicNoneFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1l,
    fill: "none"
  }));
});
var compPaths$1k = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 15.75h4.5v-7.5h-4.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72m8.775-6.401l5.303 5.303m0-5.303l-5.303 5.303"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 15.75h4.5v-7.5h-4.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72m8.775-6.401l5.303 5.303m0-5.303l-5.303 5.303"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 31.5h9v-15h-9v15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.5 16.5l9.44-9.44c.944-.944 2.56-.274 2.56 1.062v31.756c0 1.336-1.616 2.006-2.56 1.062L16.5 31.5m17.55-12.803l10.607 10.606m-.001-10.606L34.05 29.303"
  }))
};
var Mute = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1k,
    fill: "none"
  }));
});
var compPaths$1j = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.074 2.675A1.5 1.5 0 0012.44 3l-4.5 4.5H3v9h4.94l4.5 4.5a1.497 1.497 0 001.634.325c.562-.233.926-.777.926-1.385V4.06c0-.608-.364-1.152-.926-1.385zm8.784 7.204l-1.06-1.061-2.122 2.122-2.12-2.122-1.06 1.06L18.615 12l-2.12 2.12 1.06 1.062 2.12-2.121 2.121 2.12 1.061-1.06L20.738 12l2.12-2.121z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.074 2.675A1.5 1.5 0 0012.44 3l-4.5 4.5H3v9h4.94l4.5 4.5a1.497 1.497 0 001.634.325c.562-.233.926-.777.926-1.385V4.06c0-.608-.364-1.152-.926-1.385zm8.784 7.204l-1.06-1.061-2.122 2.122-2.12-2.122-1.06 1.06L18.615 12l-2.12 2.12 1.06 1.062 2.12-2.121 2.121 2.12 1.061-1.06L20.738 12l2.12-2.121z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M28.148 5.35a2.998 2.998 0 00-3.27.65l-9 9H6v18h9.879l9 9a2.983 2.983 0 003.27.65A2.992 2.992 0 0030 39.88V8.12a2.993 2.993 0 00-1.853-2.772zm17.569 14.408l-2.122-2.122-4.242 4.244-4.242-4.244-2.12 2.122L37.233 24l-4.242 4.242 2.12 2.122 4.242-4.242 4.242 4.242 2.122-2.122L41.475 24l4.242-4.242z",
    clipRule: "evenodd"
  }))
};
var MuteFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1j,
    fill: "none"
  }));
});
var compPaths$1i = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 20.25v0A2.25 2.25 0 0114.25 18V6a2.25 2.25 0 014.5 0v12a2.25 2.25 0 01-2.25 2.25zm-9 0v0A2.25 2.25 0 015.25 18V6a2.25 2.25 0 014.5 0v12a2.25 2.25 0 01-2.25 2.25z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 20.25v0A2.25 2.25 0 0114.25 18V6a2.25 2.25 0 014.5 0v12a2.25 2.25 0 01-2.25 2.25zm-9 0v0A2.25 2.25 0 015.25 18V6a2.25 2.25 0 014.5 0v12a2.25 2.25 0 01-2.25 2.25z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33 40.5v0a4.502 4.502 0 01-4.5-4.5V12c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5v24c0 2.484-2.016 4.5-4.5 4.5zm-18 0v0a4.502 4.502 0 01-4.5-4.5V12c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5v24c0 2.484-2.016 4.5-4.5 4.5z",
    clipRule: "evenodd"
  }))
};
var Pause = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1i,
    fill: "none"
  }));
});
var compPaths$1h = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.75 20.25a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 20.25v0a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.25 20.25a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 20.25v0a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.75 20.25a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 20.25v0a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.25 20.25a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 20.25v0a1.5 1.5 0 01-1.5-1.5V5.25a1.5 1.5 0 013 0v13.5a1.5 1.5 0 01-1.5 1.5z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M33 6c-3.308 0-6 2.692-6 6v24c0 3.308 2.692 6 6 6s6-2.692 6-6V12c0-3.308-2.692-6-6-6zM15 6c-3.308 0-6 2.692-6 6v24c0 3.308 2.692 6 6 6s6-2.692 6-6V12c0-3.308-2.692-6-6-6z",
    clipRule: "evenodd"
  }))
};
var PauseFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1h,
    fill: "none"
  }));
});
var compPaths$1g = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 7.5v9.794a1 1 0 001.489.872l9.45-5.292a1 1 0 00-.002-1.746L6.25 4.75"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.248 5.09V19.5a.75.75 0 001.125.65l13.487-7.787a.75.75 0 000-1.3L6.374 3.278v0l-1.5-.867"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M10.496 10.182v28.816c0 1.154 1.25 1.878 2.25 1.3L39.72 24.724c1-.578 1-2.02 0-2.598L12.748 6.554v-.001l-3-1.732"
  }))
};
var Play = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1g,
    fill: "none"
  }));
});
var compPaths$1f = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.692 12.872a1 1 0 000-1.745L8.239 5.834a1 1 0 00-1.489.872v10.588a1 1 0 001.489.872l9.453-5.294z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.314 11.35L6.367 3.877a.75.75 0 00-1.125.65v14.949a.75.75 0 001.125.649l12.947-7.474a.75.75 0 000-1.3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M19.314 11.35L6.367 3.877a.75.75 0 00-1.125.65v14.949a.75.75 0 001.125.649l12.947-7.474a.75.75 0 000-1.3z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M39.377 21.402L13.485 6.452a2.98 2.98 0 00-3-.002 2.971 2.971 0 00-1.5 2.6v29.898c0 1.086.56 2.058 1.5 2.6.47.27.984.406 1.5.406s1.03-.136 1.5-.408l25.892-14.948A2.964 2.964 0 0040.88 24c0-1.086-.56-2.056-1.502-2.598z",
    clipRule: "evenodd"
  }))
};
var PlayFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1f,
    fill: "none"
  }));
});
var compPaths$1e = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.99 12V7.242a.75.75 0 00-1.126-.65L2.625 11.35a.75.75 0 000 1.3l8.239 4.757a.75.75 0 001.126-.65v-1.828"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.356 11.365a.732.732 0 000 1.268l8.268 4.773a.75.75 0 001.126-.65v-1.76"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 15.172v-7.93a.751.751 0 00-1.126-.65l-6.632 3.83"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.99 12V7.242a.75.75 0 00-1.126-.65L2.625 11.35a.75.75 0 000 1.3l8.239 4.757a.75.75 0 001.126-.65v-1.828"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.356 11.365a.732.732 0 000 1.268l8.268 4.773a.75.75 0 001.126-.65v-1.76"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 15.172v-7.93a.751.751 0 00-1.126-.65l-6.632 3.83"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M23.98 24v-9.516c0-1.156-1.25-1.876-2.252-1.3L5.25 22.698c-1 .578-1 2.022 0 2.6l16.479 9.514a1.5 1.5 0 002.252-1.3v-3.656"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24.713 22.73a1.464 1.464 0 000 2.537l16.536 9.546c1 .578 2.252-.145 2.252-1.3v-3.52"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 30.344v-15.86c0-1.156-1.252-1.876-2.252-1.3l-13.264 7.658"
  }))
};
var Rewind = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1e,
    fill: "none"
  }));
});
var compPaths$1d = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.625 6.741L2.643 11.35a.75.75 0 000 1.3l7.982 4.608a.75.75 0 001.125-.65V7.39a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10.625 6.741L2.643 11.35a.75.75 0 000 1.3l7.982 4.608a.75.75 0 001.125-.65V7.39a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.615 6.747l-7.972 4.603a.75.75 0 000 1.298l7.972 4.603a.75.75 0 001.125-.65V7.396a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.615 6.747l-7.972 4.603a.75.75 0 000 1.298l7.972 4.603a.75.75 0 001.125-.65V7.396a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.625 6.741L2.643 11.35a.75.75 0 000 1.3l7.982 4.608a.75.75 0 001.125-.65V7.39a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10.625 6.741L2.643 11.35a.75.75 0 000 1.3l7.982 4.608a.75.75 0 001.125-.65V7.39a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.615 6.747l-7.972 4.603a.75.75 0 000 1.298l7.972 4.603a.75.75 0 001.125-.65V7.396a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M20.615 6.747l-7.972 4.603a.75.75 0 000 1.298l7.972 4.603a.75.75 0 001.125-.65V7.396a.75.75 0 00-1.125-.649z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M43.48 12.193a2.97 2.97 0 00-3 .002L25 21.133v-6.352a2.976 2.976 0 00-1.502-2.6 2.977 2.977 0 00-2.998.002L4.534 21.401a2.973 2.973 0 00-1.5 2.6c0 1.084.564 2.054 1.5 2.594L20.5 35.813c.468.27.984.408 1.502.408.514 0 1.028-.138 1.498-.406a2.975 2.975 0 001.5-2.6v-6.352l15.48 8.938c.468.27.984.408 1.502.408.514 0 1.03-.138 1.498-.406a2.971 2.971 0 001.5-2.6v-18.41c0-1.084-.56-2.058-1.5-2.6z",
    clipRule: "evenodd"
  }))
};
var RewindFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1d,
    fill: "none"
  }));
});
var compPaths$1c = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 6v12A2.25 2.25 0 006 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H3"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 6v12A2.25 2.25 0 006 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 12v24c0 2.484 2.016 4.5 4.5 4.5h24c2.484 0 4.5-2.016 4.5-4.5V12c0-2.484-2.016-4.5-4.5-4.5H6"
  }))
};
var Stop = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1c,
    fill: "none"
  }));
});
var compPaths$1b = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.75 6v12A2.25 2.25 0 006 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 6v12A2.25 2.25 0 006 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.75 6v12A2.25 2.25 0 006 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 6v12A2.25 2.25 0 006 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M36 6H12c-3.308 0-6 2.692-6 6v24c0 3.308 2.692 6 6 6h24c3.308 0 6-2.692 6-6V12c0-3.308-2.692-6-6-6z",
    clipRule: "evenodd"
  }))
};
var StopFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1b,
    fill: "none"
  }));
});
var compPaths$1a = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 15.75h4.5v-7.5h-4.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72m9-6.75v6m3-7.5v9"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 15.75h4.5v-7.5h-4.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72m9-6.75v6m3-7.5v9"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 31.5h9v-15h-9v15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.5 16.5l9.44-9.44c.944-.944 2.56-.274 2.56 1.062v31.756c0 1.336-1.616 2.006-2.56 1.062L16.5 31.5m18-13.5v12m6-15v18"
  }))
};
var VolumeHigh = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1a,
    fill: "none"
  }));
});
var compPaths$19 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.074 2.675A1.499 1.499 0 0012.44 3l-4.5 4.5H3v9h4.94l4.5 4.5a1.497 1.497 0 001.634.325c.562-.233.926-.777.926-1.385V4.06c0-.608-.364-1.152-.926-1.385zM16.5 15H18V9h-1.5v6zm3 1.5H21v-9h-1.5v9z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.074 2.675A1.499 1.499 0 0012.44 3l-4.5 4.5H3v9h4.94l4.5 4.5a1.497 1.497 0 001.634.325c.562-.233.926-.777.926-1.385V4.06c0-.608-.364-1.152-.926-1.385zM16.5 15H18V9h-1.5v6zm3 1.5H21v-9h-1.5v9z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M28.148 5.35a2.998 2.998 0 00-3.27.65l-9 9H6v18h9.878l9 9a2.983 2.983 0 003.27.65A2.992 2.992 0 0030 39.88V8.12a2.993 2.993 0 00-1.852-2.772zM33 30h3V18h-3v12zm6 3h3V15h-3v18z",
    clipRule: "evenodd"
  }))
};
var VolumeHighFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$19,
    fill: "none"
  }));
});
var compPaths$18 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 15.75h4.5v-7.5h-4.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72m9-6.75v6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 15.75h4.5v-7.5h-4.5v7.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.25 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72m9-6.75v6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 31.5h9v-15h-9v15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.5 16.5l9.44-9.44c.944-.944 2.56-.274 2.56 1.062v31.756c0 1.336-1.616 2.006-2.56 1.062L16.5 31.5m18-13.5v12"
  }))
};
var VolumeLow = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$18,
    fill: "none"
  }));
});
var compPaths$17 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.074 2.675A1.5 1.5 0 0012.44 3l-4.5 4.5H3v9h4.94l4.5 4.5a1.497 1.497 0 001.634.325c.562-.233.926-.777.926-1.385V4.06c0-.608-.364-1.152-.926-1.385zM16.5 15H18V9h-1.5v6z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.074 2.675A1.5 1.5 0 0012.44 3l-4.5 4.5H3v9h4.94l4.5 4.5a1.497 1.497 0 001.634.325c.562-.233.926-.777.926-1.385V4.06c0-.608-.364-1.152-.926-1.385zM16.5 15H18V9h-1.5v6z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M28.148 5.35a2.999 2.999 0 00-3.27.65l-9 9H6v18h9.878l9 9a2.983 2.983 0 003.27.65A2.992 2.992 0 0030 39.88V8.12a2.993 2.993 0 00-1.852-2.772zM33 30h3V18h-3v12z",
    clipRule: "evenodd"
  }))
};
var VolumeLowFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$17,
    fill: "none"
  }));
});
var compPaths$16 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 17.28a5.28 5.28 0 000-10.56H7.529a5.28 5.28 0 000 10.56H16.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.5 12a3 3 0 11-6 0 3 3 0 016 0zm9 0a3 3 0 11-6 0 3 3 0 016 0z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.5 17.28a5.28 5.28 0 000-10.56H7.529a5.28 5.28 0 000 10.56H16.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.5 12a3 3 0 11-6 0 3 3 0 016 0zm9 0a3 3 0 11-6 0 3 3 0 016 0z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33 34.559c5.83 0 10.558-4.728 10.558-10.558S38.83 13.44 33 13.44H15.058C9.226 13.44 4.5 18.17 4.5 24s4.726 10.558 10.558 10.558H33z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21 24a6 6 0 11-12 0 6 6 0 0112 0zm18 0a6 6 0 11-12 0 6 6 0 0112 0z",
    clipRule: "evenodd"
  }))
};
var Adapt = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$16,
    fill: "none"
  }));
});
var compPaths$15 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.5 12c0 4.143-3.357 7.5-7.5 7.5A7.499 7.499 0 014.5 12c0-4.143 3.357-7.5 7.5-7.5s7.5 3.357 7.5 7.5z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.5 12c0 4.143-3.357 7.5-7.5 7.5A7.499 7.499 0 014.5 12c0-4.143 3.357-7.5 7.5-7.5s7.5 3.357 7.5 7.5z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 24c0 10.77-8.73 19.5-19.5 19.5S4.5 34.77 4.5 24 13.23 4.5 24 4.5 43.5 13.23 43.5 24z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M39 24c0 8.286-6.714 15-15 15S9 32.286 9 24 15.714 9 24 9s15 6.714 15 15z",
    clipRule: "evenodd"
  }))
};
var AdaptLight = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$15,
    fill: "none"
  }));
});
var compPaths$14 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 18.75h-7.5a3 3 0 01-3-3v-7.5a3 3 0 013-3h7.5a3 3 0 013 3v7.5a3 3 0 01-3 3zm-2.25 3h-3a2.25 2.25 0 01-2.25-2.25v-.75h7.5v.75a2.25 2.25 0 01-2.25 2.25zm-3-19.5h3a2.25 2.25 0 012.25 2.25v.75h-7.5V4.5a2.25 2.25 0 012.25-2.25z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 18.75h-7.5a3 3 0 01-3-3v-7.5a3 3 0 013-3h7.5a3 3 0 013 3v7.5a3 3 0 01-3 3zm-2.25 3h-3a2.25 2.25 0 01-2.25-2.25v-.75h7.5v.75a2.25 2.25 0 01-2.25 2.25zm-3-19.5h3a2.25 2.25 0 012.25 2.25v.75h-7.5V4.5a2.25 2.25 0 012.25-2.25z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.5 37.5h-15a6 6 0 01-6-6v-15a6 6 0 016-6h15a6 6 0 016 6v15a6 6 0 01-6 6zm-4.5 6h-6a4.502 4.502 0 01-4.5-4.5v-1.5h15V39c0 2.484-2.016 4.5-4.5 4.5zm-6-39h6c2.484 0 4.5 2.016 4.5 4.5v1.5h-15V9c0-2.484 2.016-4.5 4.5-4.5z",
    clipRule: "evenodd"
  }))
};
var AppleWatch = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$14,
    fill: "none"
  }));
});
var compPaths$13 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.59 10.41a2.25 2.25 0 010 3.181m-3.18-.001a2.25 2.25 0 010-3.181m5.302-2.121a5.248 5.248 0 010 7.424m-7.424 0a5.248 5.248 0 010-7.424m9.546-2.122a8.25 8.25 0 010 11.668m-11.668 0a8.25 8.25 0 010-11.668"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.59 10.41a2.25 2.25 0 010 3.181m-3.18-.001a2.25 2.25 0 010-3.181m5.302-2.121a5.248 5.248 0 010 7.424m-7.424 0a5.248 5.248 0 010-7.424m9.546-2.122a8.25 8.25 0 010 11.668m-11.668 0a8.25 8.25 0 010-11.668"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M27.182 20.818a4.499 4.499 0 010 6.364m-6.364 0a4.499 4.499 0 010-6.364m10.606-4.242c4.102 4.1 4.102 10.748 0 14.848m-14.848 0c-4.102-4.1-4.102-10.748 0-14.848m19.092-4.244c6.444 6.446 6.444 16.89 0 23.336m-23.336 0c-6.444-6.446-6.444-16.89 0-23.336"
  }))
};
var AudioFeedback = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$13,
    fill: "none"
  }));
});
var compPaths$12 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.75 19.25a1 1 0 01-1 1h-7.5a1 1 0 01-1-1V7.75a1 1 0 011-1h7.5a1 1 0 011 1v11.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M14.5 9h-5v9h5V9z",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.805 14.054H10.25L13.168 9l-1.051 3.947h1.555L10.754 18l1.05-3.946z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.5 3.75h5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.75 19.25a1 1 0 01-1 1h-7.5a1 1 0 01-1-1V7.75a1 1 0 011-1h7.5a1 1 0 011 1v11.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M14.5 9h-5v9h5V9z",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.805 14.054H10.25L13.168 9l-1.051 3.947h1.555L10.754 18l1.05-3.946z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.5 3.75h5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M33.5 38.5a2 2 0 01-2 2h-15a2 2 0 01-2-2v-23a2 2 0 012-2h15a2 2 0 012 2v23z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M29 18H19v18h10V18z",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23.61 28.108H20.5L26.336 18l-2.102 7.894h3.11L21.508 36l2.102-7.892z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M19 7.5h10"
  }))
};
var BatteryChargingFull = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$12,
    fill: "none"
  }));
});
var compPaths$11 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.75 19.25a1 1 0 01-1 1h-7.5a1 1 0 01-1-1V7.75a1 1 0 011-1h7.5a1 1 0 011 1v11.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M14.5 13.5h-5V18h5v-4.5z",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.805 14.054H10.25L13.168 9l-1.05 3.947h1.554L10.754 18l1.051-3.946z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.5 3.75h5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.75 19.25a1 1 0 01-1 1h-7.5a1 1 0 01-1-1V7.75a1 1 0 011-1h7.5a1 1 0 011 1v11.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M14.5 13.5h-5V18h5v-4.5z",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.805 14.054H10.25L13.168 9l-1.05 3.947h1.554L10.754 18l1.051-3.946z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.5 3.75h5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M33.5 38.5a2 2 0 01-2 2h-15a2 2 0 01-2-2v-23a2 2 0 012-2h15a2 2 0 012 2v23z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M29 27H19v9h10v-9z",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23.61 28.108H20.5L26.336 18l-2.102 7.894h3.11L21.508 36l2.102-7.892z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M19 7.5h10"
  }))
};
var BatteryChargingLow = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$11,
    fill: "none"
  }));
});
var compPaths$10 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.75 19.25a1 1 0 01-1 1h-7.5a1 1 0 01-1-1V7.75a1 1 0 011-1h7.5a1 1 0 011 1v11.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M14.5 9h-5v9h5V9z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.5 3.75h5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.75 19.25a1 1 0 01-1 1h-7.5a1 1 0 01-1-1V7.75a1 1 0 011-1h7.5a1 1 0 011 1v11.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M14.5 9h-5v9h5V9z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.5 3.75h5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M33.5 38.5a2 2 0 01-2 2h-15a2 2 0 01-2-2v-23a2 2 0 012-2h15a2 2 0 012 2v23z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M29 18H19v18h10V18z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M19 7.5h10"
  }))
};
var BatteryFull = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$10,
    fill: "none"
  }));
});
var compPaths$$ = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.75 19.25a1 1 0 01-1 1h-7.5a1 1 0 01-1-1V7.75a1 1 0 011-1h7.5a1 1 0 011 1v11.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M14.5 13.5h-5V18h5v-4.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.5 3.75h5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.75 19.25a1 1 0 01-1 1h-7.5a1 1 0 01-1-1V7.75a1 1 0 011-1h7.5a1 1 0 011 1v11.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M14.5 13.5h-5V18h5v-4.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.5 3.75h5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M33.5 38.5a2 2 0 01-2 2h-15a2 2 0 01-2-2v-23a2 2 0 012-2h15a2 2 0 012 2v23z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M29 27H19v9h10v-9z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M19 7.5h10"
  }))
};
var BatteryLow = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$$,
    fill: "none"
  }));
});
var compPaths$_ = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.757 16.242l-3.182 3.183m14.85-14.85l-3.182 3.183M6 12H1.5m21 0H18M7.757 7.758L4.575 4.575m14.85 14.85l-3.182-3.183"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.757 16.242l-3.182 3.183m14.85-14.85l-3.182 3.183M6 12H1.5m21 0H18M7.757 7.758L4.575 4.575m14.85 14.85l-3.182-3.183"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 36v9m0-42v9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.5 24a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15.515 32.484L9.15 38.85m29.7-29.7l-6.364 6.366M12 24H3m42 0h-9m-20.485-8.484L9.15 9.15m29.7 29.7l-6.364-6.366"
  }))
};
var Brightness = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$_,
    fill: "none"
  }));
});
var compPaths$Z = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15 11.25c-2.077 0-2.716-4.312-2.912-8.211-.04-.787-1.093-.998-1.426-.285C8.694 6.964 5.25 12.321 5.25 15a6.75 6.75 0 1013.5 0c0-3.75-3.5-6.75-3.5-10.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.876 18.626c0-1.277 1.693-3.214 2.587-4.146a.736.736 0 011.074 0c.894.932 2.587 2.87 2.587 4.146a3.123 3.123 0 11-6.248 0z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15 11.25c-2.077 0-2.716-4.312-2.912-8.211-.04-.787-1.093-.998-1.426-.285C8.694 6.964 5.25 12.321 5.25 15a6.75 6.75 0 1013.5 0c0-3.75-3.5-6.75-3.5-10.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.876 18.626c0-1.277 1.693-3.214 2.587-4.146a.736.736 0 011.074 0c.894.932 2.587 2.87 2.587 4.146a3.123 3.123 0 11-6.248 0z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M30 22.5c-4.154 0-5.432-8.624-5.824-16.422-.08-1.574-2.186-1.996-2.852-.57C17.388 13.928 10.5 24.642 10.5 30c0 7.456 6.044 13.5 13.5 13.5S37.5 37.456 37.5 30c0-7.5-7-13.5-7-21"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M17.752 37.252c0-2.554 3.386-6.428 5.174-8.292a1.473 1.473 0 012.148 0c1.788 1.864 5.174 5.738 5.174 8.292A6.246 6.246 0 0124 43.5a6.246 6.246 0 01-6.248-6.248z",
    clipRule: "evenodd"
  }))
};
var Burn = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$Z,
    fill: "none"
  }));
});
var compPaths$Y = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 20.25h9m-3-3.002h6a2.25 2.25 0 002.25-2.25V6a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 002.25 6v8.998a2.25 2.25 0 002.25 2.25h5a2.25 2.25 0 012.25 2.25v.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.827 10.068L10.5 7.57a.5.5 0 00-.75.433v4.996a.5.5 0 00.75.433l4.327-2.498a.5.5 0 000-.866z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 20.25h9m-3-3.002h6a2.25 2.25 0 002.25-2.25V6a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 002.25 6v8.998a2.25 2.25 0 002.25 2.25h5a2.25 2.25 0 012.25 2.25v.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.827 10.068L10.5 7.57a.5.5 0 00-.75.433v4.996a.5.5 0 00.75.433l4.327-2.498a.5.5 0 000-.866z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 40.5h18m-6-6.004h12a4.5 4.5 0 004.5-4.5V12c0-2.484-2.016-4.5-4.5-4.5H9A4.502 4.502 0 004.5 12v17.996a4.5 4.5 0 004.5 4.5h10c2.484 0 4.5 2.016 4.5 4.5v1.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M29.654 20.135L21 15.139a1 1 0 00-1.5.866v9.994a1 1 0 001.5.866l8.654-4.998a.999.999 0 000-1.732z",
    clipRule: "evenodd"
  }))
};
var ClassWorkout = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$Y,
    fill: "none"
  }));
});
var compPaths$X = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15 21.75H9a2.25 2.25 0 01-2.25-2.25v-15A2.25 2.25 0 019 2.25h6a2.25 2.25 0 012.25 2.25v15A2.25 2.25 0 0115 21.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10.5 18.75h3"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15 21.75H9a2.25 2.25 0 01-2.25-2.25v-15A2.25 2.25 0 019 2.25h6a2.25 2.25 0 012.25 2.25v15A2.25 2.25 0 0115 21.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10.5 18.75h3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M30 43.5H18a4.502 4.502 0 01-4.5-4.5V9c0-2.484 2.016-4.5 4.5-4.5h12c2.484 0 4.5 2.016 4.5 4.5v30c0 2.484-2.016 4.5-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M21 37.5h6"
  }))
};
var Device = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$X,
    fill: "none"
  }));
});
var compPaths$W = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 19.5A2.25 2.25 0 0115 21.75H9a2.25 2.25 0 01-2.25-2.25m0-15A2.25 2.25 0 019 2.25h6a2.25 2.25 0 012.25 2.25",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 15V9A2.25 2.25 0 014.5 6.75h15A2.25 2.25 0 0121.75 9v6a2.25 2.25 0 01-2.25 2.25h-15A2.25 2.25 0 012.25 15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.25 10.5v3"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 19.5A2.25 2.25 0 0115 21.75H9a2.25 2.25 0 01-2.25-2.25m0-15A2.25 2.25 0 019 2.25h6a2.25 2.25 0 012.25 2.25",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 15V9A2.25 2.25 0 014.5 6.75h15A2.25 2.25 0 0121.75 9v6a2.25 2.25 0 01-2.25 2.25h-15A2.25 2.25 0 012.25 15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.25 10.5v3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 39c0 2.484-2.016 4.5-4.5 4.5H18a4.502 4.502 0 01-4.5-4.5m0-30c0-2.484 2.016-4.5 4.5-4.5h12c2.484 0 4.5 2.016 4.5 4.5",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M4.5 30V18c0-2.484 2.016-4.5 4.5-4.5h30c2.484 0 4.5 2.016 4.5 4.5v12c0 2.484-2.016 4.5-4.5 4.5H9A4.502 4.502 0 014.5 30z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M10.5 21v6"
  }))
};
var DeviceLeft = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$W,
    fill: "none"
  }));
});
var compPaths$V = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 19.5A2.25 2.25 0 0115 21.75H9a2.25 2.25 0 01-2.25-2.25m0-15A2.25 2.25 0 019 2.25h6a2.25 2.25 0 012.25 2.25",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 15V9a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 002.25 9v6a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 10.5v3"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 19.5A2.25 2.25 0 0115 21.75H9a2.25 2.25 0 01-2.25-2.25m0-15A2.25 2.25 0 019 2.25h6a2.25 2.25 0 012.25 2.25",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 15V9a2.25 2.25 0 00-2.25-2.25h-15A2.25 2.25 0 002.25 9v6a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 15z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 10.5v3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 39a4.5 4.5 0 01-4.5 4.5H18a4.5 4.5 0 01-4.5-4.5m0-30A4.5 4.5 0 0118 4.5h12A4.5 4.5 0 0134.5 9",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 30V18a4.5 4.5 0 00-4.5-4.5H9A4.5 4.5 0 004.5 18v12A4.5 4.5 0 009 34.5h30a4.5 4.5 0 004.5-4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M37.5 21v6"
  }))
};
var DeviceRight = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$V,
    fill: "none"
  }));
});
var compPaths$U = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.5 17.25A2.25 2.25 0 012.25 15V9A2.25 2.25 0 014.5 6.75m15 0A2.25 2.25 0 0121.75 9v6a2.25 2.25 0 01-2.25 2.25",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 21.75h6a2.25 2.25 0 002.25-2.25v-15A2.25 2.25 0 0015 2.25H9A2.25 2.25 0 006.75 4.5v15A2.25 2.25 0 009 21.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.5 18.75h-3"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.5 17.25A2.25 2.25 0 012.25 15V9A2.25 2.25 0 014.5 6.75m15 0A2.25 2.25 0 0121.75 9v6a2.25 2.25 0 01-2.25 2.25",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 21.75h6a2.25 2.25 0 002.25-2.25v-15A2.25 2.25 0 0015 2.25H9A2.25 2.25 0 006.75 4.5v15A2.25 2.25 0 009 21.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M13.5 18.75h-3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M9 34.5A4.5 4.5 0 014.5 30V18A4.5 4.5 0 019 13.5m30 0a4.5 4.5 0 014.5 4.5v12a4.5 4.5 0 01-4.5 4.5",
    opacity: ".2"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18 43.5h12a4.5 4.5 0 004.5-4.5V9A4.5 4.5 0 0030 4.5H18A4.5 4.5 0 0013.5 9v30a4.5 4.5 0 004.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M27 37.5h-6"
  }))
};
var DeviceVertical = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$U,
    fill: "none"
  }));
});
var compPaths$T = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15.18 8.82a4.503 4.503 0 00-6.37 0 4.503 4.503 0 000 6.37"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M8.82 15.18a4.503 4.503 0 006.37 0 4.503 4.503 0 000-6.37"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15.18 8.82a4.503 4.503 0 00-6.37 0 4.503 4.503 0 000 6.37"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M8.82 15.18a4.503 4.503 0 006.37 0 4.503 4.503 0 000-6.37"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 37.5c7.456 0 13.5-6.044 13.5-13.5S31.456 10.5 24 10.5 10.5 16.544 10.5 24 16.544 37.5 24 37.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M30.36 17.64a9.005 9.005 0 00-12.74 0 9.005 9.005 0 000 12.74"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M17.64 30.36a9.005 9.005 0 0012.74 0 9.005 9.005 0 000-12.74"
  }))
};
var DualLightsColorChip = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$T,
    fill: "none"
  }));
});
var compPaths$S = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M7.5 12c0-2.72 1.22-5.16 3.13-6.81A7.43 7.43 0 007.5 4.5C3.36 4.5 0 7.86 0 12c0 4.14 3.36 7.5 7.5 7.5 1.12 0 2.18-.25 3.13-.69A8.987 8.987 0 017.5 12z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.5 18.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M7.5 12c0-2.72 1.22-5.16 3.13-6.81A7.43 7.43 0 007.5 4.5C3.36 4.5 0 7.86 0 12c0 4.14 3.36 7.5 7.5 7.5 1.12 0 2.18-.25 3.13-.69A8.987 8.987 0 017.5 12z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.5 18.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15 24c0-5.44 2.44-10.32 6.26-13.62C19.36 9.5 17.24 9 15 9 6.72 9 0 15.72 0 24c0 8.28 6.72 15 15 15 2.24 0 4.36-.5 6.26-1.38C17.44 34.32 15 29.44 15 24z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M33 37.5c7.456 0 13.5-6.044 13.5-13.5S40.456 10.5 33 10.5 19.5 16.544 19.5 24 25.544 37.5 33 37.5z"
  }))
};
var EffectActive = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$S,
    fill: "none"
  }));
});
var compPaths$R = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.5 18.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M7.5 19.5c-.31 0-.62-.02-.93-.06l.19-1.49c.5.06.99.06 1.48 0l.18 1.49c-.31.04-.61.06-.92.06zm-2.89-.58l-.05-.02a7.33 7.33 0 01-1.58-.92l.9-1.2c.39.29.81.54 1.27.73l.09.05-.34.57-.29.79zm5.8-.01l-.58-1.38c.46-.19.89-.44 1.28-.74l.9 1.2c-.49.37-1.03.68-1.6.92zm-8.89-2.39a7.47 7.47 0 01-.92-1.6l1.38-.59c.19.46.44.89.74 1.28l-1.2.91zM.06 12.93a6.953 6.953 0 010-1.84l1.49.18c-.04.24-.05.48-.05.73s.02.5.05.75l-1.49.18zm1.92-3.28L.58 9.1l.02-.05c.23-.55.54-1.07.9-1.55l1.2.9c-.28.38-.53.8-.72 1.25zm1.89-2.43l-.91-1.19c.49-.37 1.03-.68 1.6-.93l.59 1.38c-.46.19-.89.44-1.28.74zm7.23-.02c-.38-.29-.8-.53-1.24-.71l.58-1.38c.56.24 1.09.54 1.56.9l-.9 1.19zM6.74 6.05l-.19-1.49c.31-.04.63-.07.96-.06.29 0 .59.02.89.05l-.18 1.49c-.24-.03-.48-.03-.73-.04-.25 0-.5.02-.75.05z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.5 18.75a6.75 6.75 0 100-13.5 6.75 6.75 0 000 13.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M7.5 19.5c-.31 0-.62-.02-.93-.06l.19-1.49c.5.06.99.06 1.48 0l.18 1.49c-.31.04-.61.06-.92.06zm-2.89-.58l-.05-.02a7.33 7.33 0 01-1.58-.92l.9-1.2c.39.29.81.54 1.27.73l.09.05-.34.57-.29.79zm5.8-.01l-.58-1.38c.46-.19.89-.44 1.28-.74l.9 1.2c-.49.37-1.03.68-1.6.92zm-8.89-2.39a7.47 7.47 0 01-.92-1.6l1.38-.59c.19.46.44.89.74 1.28l-1.2.91zM.06 12.93a6.953 6.953 0 010-1.84l1.49.18c-.04.24-.05.48-.05.73s.02.5.05.75l-1.49.18zm1.92-3.28L.58 9.1l.02-.05c.23-.55.54-1.07.9-1.55l1.2.9c-.28.38-.53.8-.72 1.25zm1.89-2.43l-.91-1.19c.49-.37 1.03-.68 1.6-.93l.59 1.38c-.46.19-.89.44-1.28.74zm7.23-.02c-.38-.29-.8-.53-1.24-.71l.58-1.38c.56.24 1.09.54 1.56.9l-.9 1.19zM6.74 6.05l-.19-1.49c.31-.04.63-.07.96-.06.29 0 .59.02.89.05l-.18 1.49c-.24-.03-.48-.03-.73-.04-.25 0-.5.02-.75.05z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M33 37.5c7.456 0 13.5-6.044 13.5-13.5S40.456 10.5 33 10.5 19.5 16.544 19.5 24 25.544 37.5 33 37.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15 39c-.62 0-1.24-.04-1.86-.12l.38-2.98c1 .12 1.98.12 2.96 0l.36 2.98c-.62.08-1.22.12-1.84.12zm-5.78-1.16l-.1-.04c-1.12-.48-2.2-1.1-3.16-1.84l1.8-2.4c.78.58 1.62 1.08 2.54 1.46l.18.1-.68 1.14-.58 1.58zm11.6-.02l-1.16-2.76c.92-.38 1.78-.88 2.56-1.48l1.8 2.4c-.98.74-2.06 1.36-3.2 1.84zM3.04 33.04c-.74-.98-1.36-2.06-1.84-3.2l2.76-1.18c.38.92.88 1.78 1.48 2.56l-2.4 1.82zM.12 25.86C.04 25.24 0 24.62 0 24c0-.6.04-1.22.12-1.82l2.98.36c-.08.48-.1.96-.1 1.46s.04 1 .1 1.5l-2.98.36zm3.84-6.56l-2.8-1.1.04-.1C1.66 17 2.28 15.96 3 15l2.4 1.8c-.56.76-1.06 1.6-1.44 2.5zm3.78-4.86l-1.82-2.38c.98-.74 2.06-1.36 3.2-1.86l1.18 2.76c-.92.38-1.78.88-2.56 1.48zm14.46-.04c-.76-.58-1.6-1.06-2.48-1.42l1.16-2.76c1.12.48 2.18 1.08 3.12 1.8l-1.8 2.38zm-8.72-2.3l-.38-2.98c.62-.08 1.26-.14 1.92-.12.58 0 1.18.04 1.78.1l-.36 2.98c-.48-.06-.96-.06-1.46-.08-.5 0-1 .04-1.5.1z"
  }))
};
var EffectInactive = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$R,
    fill: "none"
  }));
});
var compPaths$Q = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.284 9.349l2.651 2.65-2.65 2.653M9.716 9.349l-2.651 2.65 2.65 2.653"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.284 9.349l2.651 2.65-2.65 2.653M9.716 9.349l-2.651 2.65 2.65 2.653"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M43.5 24c0 10.77-8.73 19.5-19.5 19.5S4.5 34.77 4.5 24 13.23 4.5 24 4.5 43.5 13.23 43.5 24z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M28.568 18.697L33.87 24l-5.302 5.304m-9.136-10.607L14.13 24l5.302 5.304"
  }))
};
var Effort = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$Q,
    fill: "none"
  }));
});
var compPaths$P = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 8.913L7.625 5.81a2.25 2.25 0 012.25 0l4.25 2.455a2.254 2.254 0 002.25 0L21.75 5.16"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10.306 18.75H4.75a2.5 2.5 0 01-2.5-2.5v-3.87l5.375-3.103a2.25 2.25 0 012.25 0l4.25 2.453a2.245 2.245 0 002.25 0l4.25-2.453a.75.75 0 011.125.65v6.323a2.5 2.5 0 01-2.5 2.5h-8.944z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 8.913L7.625 5.81a2.25 2.25 0 012.25 0l4.25 2.455a2.254 2.254 0 002.25 0L21.75 5.16"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10.306 18.75H4.75a2.5 2.5 0 01-2.5-2.5v-3.87l5.375-3.103a2.25 2.25 0 012.25 0l4.25 2.453a2.245 2.245 0 002.25 0l4.25-2.453a.75.75 0 011.125.65v6.323a2.5 2.5 0 01-2.5 2.5h-8.944z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M4.5 17.826l10.75-6.208a4.5 4.5 0 014.5 0l8.5 4.91a4.509 4.509 0 004.5 0L43.5 10.32"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M9.5 37.5a5 5 0 01-5-5v-7.74l10.75-6.206a4.5 4.5 0 014.5 0l8.5 4.906a4.49 4.49 0 004.5 0l8.5-4.906c1-.578 2.25.146 2.25 1.3V32.5a5 5 0 01-5 5h-29z",
    clipRule: "evenodd"
  }))
};
var ElevationChange = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$P,
    fill: "none"
  }));
});
var compPaths$O = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.153 11.434A5.251 5.251 0 0019.8 4.917c-2.11-1.72-5.225-1.417-7.15.508l-.657.657-.78-.794C8.76 2.837 4.49 3.316 2.75 6.723c-1.014 1.985-.54 4.414 1.036 5.989l.038.038h3.158l2.517-2.5 4 4 1.5-1.5h4.042a.5.5 0 01.353.854L11.99 21 5.9 14.9"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21.153 11.434A5.251 5.251 0 0019.8 4.917c-2.11-1.72-5.225-1.417-7.15.508l-.657.657-.78-.794C8.76 2.837 4.49 3.316 2.75 6.723c-1.014 1.985-.54 4.414 1.036 5.989l.038.038h3.158l2.517-2.5 4 4 1.5-1.5h4.042a.5.5 0 01.353.854L11.99 21 5.9 14.9"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M42.307 22.867A10.503 10.503 0 0039.6 9.833C35.38 6.395 29.15 7 25.3 10.85l-1.314 1.314-1.562-1.588c-4.902-4.902-13.442-3.944-16.922 2.87-2.028 3.97-1.08 8.828 2.072 11.978l.076.076h6.316l5.034-5 8 8 3-3h8.084c.89 0 1.336 1.078.706 1.708L23.979 42 11.8 29.801"
  }))
};
var HeartRate = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$O,
    fill: "none"
  }));
});
var compPaths$N = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 18.752h12"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 14.253h12M6 9.75h12M6 5.25h12",
    opacity: ".2"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 18.752h12"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6 14.253h12M6 9.75h12M6 5.25h12",
    opacity: ".2"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M12 37.504h24"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M12 28.506h24M12 19.5h24m-24-9h24",
    opacity: ".2"
  }))
};
var LaceDown = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$N,
    fill: "none"
  }));
});
var compPaths$M = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 5.25H6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 14.25H6m12-4.5H6m12 9H6",
    opacity: ".2"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 5.25H6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 14.25H6m12-4.5H6m12 9H6",
    opacity: ".2"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M36 10.5H12"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M36 28.5H12m24-9H12m24 18H12",
    opacity: ".2"
  }))
};
var LaceUp = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$M,
    fill: "none"
  }));
});
var compPaths$L = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M5.03 5.03l13.94 13.94"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M5.03 5.03l13.94 13.94"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M18.65 15.46c.54-1.04.85-2.21.85-3.46 0-4.14-3.36-7.5-7.5-7.5-1.25 0-2.43.31-3.46.85l10.11 10.11zM5.36 8.54A7.358 7.358 0 004.5 12c0 4.14 3.36 7.5 7.5 7.5 1.25 0 2.42-.31 3.46-.86L5.36 8.54z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M5.03 5.03l13.94 13.94"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M5.03 5.03l13.94 13.94"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M18.65 15.46c.54-1.04.85-2.21.85-3.46 0-4.14-3.36-7.5-7.5-7.5-1.25 0-2.43.31-3.46.85l10.11 10.11zM5.36 8.54A7.358 7.358 0 004.5 12c0 4.14 3.36 7.5 7.5 7.5 1.25 0 2.42-.31 3.46-.86L5.36 8.54z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M10.06 10.06l27.88 27.88"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M10.06 10.06l27.88 27.88"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M37.3 30.92C38.38 28.84 39 26.5 39 24c0-8.28-6.72-15-15-15-2.5 0-4.86.62-6.92 1.7L37.3 30.92zM10.72 17.08C9.62 19.16 9 21.5 9 24c0 8.28 6.72 15 15 15 2.5 0 4.84-.62 6.92-1.72l-20.2-20.2z"
  }))
};
var LightsOff = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$L,
    fill: "none"
  }));
});
var compPaths$K = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 18.75H6m9-9H9m6 4.5H9m6-9H9"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 18.75H6m9-9H9m6 4.5H9m6-9H9"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M36 37.5H12m18-18H18m12 9H18m12-18H18"
  }))
};
var Loosen = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$K,
    fill: "none"
  }));
});
var compPaths$J = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 5.25a3 3 0 11-6 0 3 3 0 016 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.793 22.112l4.966-8.602a1.5 1.5 0 00-1.299-2.25H3m10.974 4.365l-3.75 6.495M14 11.25h7"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.75 5.25a3 3 0 11-6 0 3 3 0 016 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.793 22.112l4.966-8.602a1.5 1.5 0 00-1.299-2.25H3m10.974 4.365l-3.75 6.495M14 11.25h7"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.5 10.5a6 6 0 11-12 0 6 6 0 0112 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.586 44.224l9.932-17.203c1.154-2-.29-4.5-2.598-4.5H6m21.947 8.729l-7.5 12.99M28 22.5h14"
  }))
};
var MuscleGroup = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$J,
    fill: "none"
  }));
});
var compPaths$I = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.5 9h9V7.5h-9V9zm0-3h9V4.5h-9V6zm0 6h6v-1.5h-6V12zm4.52 4.299v3.18h3.18l2.8-2.797.933-.931h-.002l4.308-4.308-3.18-3.182-8.04 8.039zm6.977-4.857l1.061-1.061 1.061 1.06-1.06 1.06-1.062-1.06zM13.52 16.92l4.416-4.418L19 13.562l-4.418 4.419H13.52V16.92z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 19.5c0 .827-.673 1.5-1.5 1.5h-9c-.827 0-1.5-.673-1.5-1.5v-15C6 3.673 6.673 3 7.5 3h9c.827 0 1.5.673 1.5 1.5v3.697l1.5-1.5V4.5c0-1.654-1.346-3-3-3h-9c-1.654 0-3 1.346-3 3v15c0 1.654 1.346 3 3 3h9c1.654 0 3-1.346 3-3v-2.197l-1.5 1.5v.697z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.5 9h9V7.5h-9V9zm0-3h9V4.5h-9V6zm0 6h6v-1.5h-6V12zm4.52 4.299v3.18h3.18l2.8-2.797.933-.931h-.002l4.308-4.308-3.18-3.182-8.04 8.039zm6.977-4.857l1.061-1.061 1.061 1.06-1.06 1.06-1.062-1.06zM13.52 16.92l4.416-4.418L19 13.562l-4.418 4.419H13.52V16.92z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18 19.5c0 .827-.673 1.5-1.5 1.5h-9c-.827 0-1.5-.673-1.5-1.5v-15C6 3.673 6.673 3 7.5 3h9c.827 0 1.5.673 1.5 1.5v3.697l1.5-1.5V4.5c0-1.654-1.346-3-3-3h-9c-1.654 0-3 1.346-3 3v15c0 1.654 1.346 3 3 3h9c1.654 0 3-1.346 3-3v-2.197l-1.5 1.5v.697z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 18h18v-3H15v3zm0-6h18V9H15v3zm0 12h12v-3H15v3zm9.04 8.597v6.362h6.363L36 33.361l1.866-1.862h-.002l8.616-8.616-6.362-6.364L24.04 32.597zm13.955-9.714l2.122-2.122 2.122 2.122-2.122 2.12-2.122-2.12zM27.04 33.84l8.834-8.836 2.124 2.122-8.836 8.836H27.04V33.84z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M36 39c0 1.654-1.346 3-3 3H15c-1.654 0-3-1.346-3-3V9c0-1.654 1.346-3 3-3h18c1.654 0 3 1.346 3 3v7.394l3-3V9c0-3.308-2.692-6-6-6H15c-3.308 0-6 2.692-6 6v30c0 3.308 2.692 6 6 6h18c3.308 0 6-2.692 6-6v-4.394l-3 3V39z",
    clipRule: "evenodd"
  }))
};
var Notes = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$I,
    fill: "none"
  }));
});
var compPaths$H = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.75 3.75h-2.5v3h-4v3h-4v3h-3.5V18A2.25 2.25 0 006 20.25h12A2.25 2.25 0 0020.25 18V3.75h-2.5z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.75 3.75h-2.5v3h-4v3h-4v3h-3.5V18A2.25 2.25 0 006 20.25h12A2.25 2.25 0 0020.25 18V3.75h-2.5z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M35.5 7.5h-5v6h-8v6h-8v6h-7V36c0 2.484 2.016 4.5 4.5 4.5h24c2.484 0 4.5-2.016 4.5-4.5V7.5h-5z",
    clipRule: "evenodd"
  }))
};
var ProgramIntensity = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$H,
    fill: "none"
  }));
});
var compPaths$G = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.25 5.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25H6A2.25 2.25 0 013.75 18V7.5A2.25 2.25 0 016 5.25h2.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 6.75h6v-3H9v3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.712 10.667L10.94 15.44l-2.652-2.651"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.25 5.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25H6A2.25 2.25 0 013.75 18V7.5A2.25 2.25 0 016 5.25h2.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 6.75h6v-3H9v3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.712 10.667L10.94 15.44l-2.652-2.651"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M30.5 10.5H36a4.5 4.5 0 014.5 4.5v21a4.5 4.5 0 01-4.5 4.5H12A4.5 4.5 0 017.5 36V15a4.5 4.5 0 014.5-4.5h5.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18 13.5h12v-6H18v6z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.425 21.334l-9.546 9.546-5.304-5.302"
  }))
};
var Programs = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$G,
    fill: "none"
  }));
});
var compPaths$F = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.94 16.5l-3.182-3.18 1.06-1.06 2.122 2.12 4.242-4.242 1.06 1.06L10.94 16.5zM9.75 6h4.5V4.5h-4.5V6zM18 4.5h-2.25V3h-7.5v1.5H6c-1.654 0-3 1.345-3 3V18c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V7.5c0-1.655-1.346-3-3-3z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.94 16.5l-3.182-3.18 1.06-1.06 2.122 2.12 4.242-4.242 1.06 1.06L10.94 16.5zM9.75 6h4.5V4.5h-4.5V6zM18 4.5h-2.25V3h-7.5v1.5H6c-1.654 0-3 1.345-3 3V18c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V7.5c0-1.655-1.346-3-3-3z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.879 33.001l-6.364-6.364 2.12-2.12 4.244 4.242 8.486-8.486 2.12 2.122-10.606 10.606zm-2.378-21h9v-3h-9v3zm16.5-3h-4.5v-3h-15v3h-4.5c-3.31 0-6 2.69-6 6v21c0 3.308 2.69 6 6 6h24c3.308 0 6-2.692 6-6v-21c0-3.31-2.692-6-6-6z",
    clipRule: "evenodd"
  }))
};
var ProgramsFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$F,
    fill: "none"
  }));
});
var compPaths$E = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M15.25 5.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25H6A2.25 2.25 0 013.75 18V7.5A2.25 2.25 0 016 5.25h2.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M9 6.75h6v-3H9v3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M15.712 10.667L10.94 15.44l-2.652-2.651"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M15.25 5.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25H6A2.25 2.25 0 013.75 18V7.5A2.25 2.25 0 016 5.25h2.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M9 6.75h6v-3H9v3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M15.712 10.667L10.94 15.44l-2.652-2.651"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M30.5 10.5H36a4.5 4.5 0 014.5 4.5v21a4.5 4.5 0 01-4.5 4.5H12A4.5 4.5 0 017.5 36V15a4.5 4.5 0 014.5-4.5h5.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M18 13.5h12v-6H18v6z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M31.425 21.334l-9.546 9.546-5.304-5.302"
  }))
};
var ProgramsStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$E,
    fill: "none"
  }));
});
var compPaths$D = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15.18 8.82a4.509 4.509 0 00-6.36 0 4.509 4.509 0 000 6.36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M7.76 16.24l-3.18 3.18M19.42 4.58l-3.18 3.18M6 12H1.5m21 0H18M7.76 7.76L4.58 4.58m14.84 14.84l-3.18-3.18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M8.82 15.18a4.509 4.509 0 006.36 0 4.509 4.509 0 000-6.36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15.18 8.82a4.509 4.509 0 00-6.36 0 4.509 4.509 0 000 6.36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M7.76 16.24l-3.18 3.18M19.42 4.58l-3.18 3.18M6 12H1.5m21 0H18M7.76 7.76L4.58 4.58m14.84 14.84l-3.18-3.18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M8.82 15.18a4.509 4.509 0 006.36 0 4.509 4.509 0 000-6.36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 36v9m0-42v9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M30.36 17.64c-3.5-3.5-9.22-3.5-12.72 0s-3.5 9.22 0 12.72"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M15.52 32.48l-6.36 6.36M38.84 9.16l-6.36 6.36M12 24H3m42 0h-9m-20.48-8.48L9.16 9.16m29.68 29.68l-6.36-6.36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M17.64 30.36c3.5 3.5 9.22 3.5 12.72 0s3.5-9.22 0-12.72"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 36v9m0-42v9"
  }))
};
var PulsingDualLights = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$D,
    fill: "none"
  }));
});
var compPaths$C = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15.18 8.82a4.509 4.509 0 00-6.36 0 4.509 4.509 0 000 6.36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M7.76 16.24l-3.18 3.18M19.42 4.58l-3.18 3.18M6 12H1.5m21 0H18M7.76 7.76L4.58 4.58m14.84 14.84l-3.18-3.18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M8.82 15.18a4.509 4.509 0 006.36 0 4.509 4.509 0 000-6.36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15.18 8.82a4.509 4.509 0 00-6.36 0 4.509 4.509 0 000 6.36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M7.76 16.24l-3.18 3.18M19.42 4.58l-3.18 3.18M6 12H1.5m21 0H18M7.76 7.76L4.58 4.58m14.84 14.84l-3.18-3.18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M8.82 15.18a4.509 4.509 0 006.36 0 4.509 4.509 0 000-6.36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M12 18v4.5m0-21V6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 36v9m0-42v9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M30.36 17.64c-3.5-3.5-9.22-3.5-12.72 0s-3.5 9.22 0 12.72"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M15.52 32.48l-6.36 6.36M38.84 9.16l-6.36 6.36M12 24H3m42 0h-9m-20.48-8.48L9.16 9.16m29.68 29.68l-6.36-6.36"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M17.64 30.36c3.5 3.5 9.22 3.5 12.72 0s3.5-9.22 0-12.72"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M24 36v9m0-42v9"
  }))
};
var PulsingLights = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$C,
    fill: "none"
  }));
});
var compPaths$B = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 1.5v21m10.5 0v-21M12 19.5v3m0-7.5v3m0-7.5v3M12 6v3m0-7.5v3"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 1.5v21m10.5 0v-21M12 19.5v3m0-7.5v3m0-7.5v3M12 6v3m0-7.5v3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 3v42m21 0V3M24 39v6m0-15v6m0-15v6m0-15v6m0-15v6"
  }))
};
var Road = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$B,
    fill: "none"
  }));
});
var compPaths$A = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21 20.25h-7m10-4.504l-5.5.004"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.845 12.852l3.352-5.757-2.665 6.554c-.288.706-.826 1.726-1.671 1.53-.47-.109-.806-.674-.95-1.351-.092-.433-.115-.893-.136-1.351.075.317.39 1.317 1.168 1.198.299-.049.62-.342.902-.823z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.99 6.75a4.521 4.521 0 004.312-3.164c.17-.542.841-.723 1.244-.32l3.541 3.54a2.245 2.245 0 010 3.174l-10.27 10.27H4.138a1.888 1.888 0 01-.609-3.676l2.567-.873a2.651 2.651 0 001.706-1.823L11 1.94"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M21 20.25h-7m10-4.504l-5.5.004"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.845 12.852l3.352-5.757-2.665 6.554c-.288.706-.826 1.726-1.671 1.53-.47-.109-.806-.674-.95-1.351-.092-.433-.115-.893-.136-1.351.075.317.39 1.317 1.168 1.198.299-.049.62-.342.902-.823z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.99 6.75a4.521 4.521 0 004.312-3.164c.17-.542.841-.723 1.244-.32l3.541 3.54a2.245 2.245 0 010 3.174l-10.27 10.27H4.138a1.888 1.888 0 01-.609-3.676l2.567-.873a2.651 2.651 0 001.706-1.823L11 1.94"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M42 40.5H28m20-9.008L37 31.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M25.69 25.704l6.703-11.514-5.33 13.108c-.576 1.412-1.652 3.452-3.342 3.06-.94-.218-1.612-1.348-1.9-2.702-.184-.866-.23-1.786-.272-2.702.15.634.78 2.634 2.336 2.396.598-.098 1.24-.684 1.804-1.646z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M23.98 13.5c4.046 0 7.472-2.66 8.624-6.328.34-1.084 1.682-1.446 2.488-.64l7.082 7.08a4.49 4.49 0 010 6.348L21.634 40.5H8.276A3.775 3.775 0 014.5 36.724a3.779 3.779 0 012.558-3.576l5.134-1.746a5.303 5.303 0 003.412-3.646L22 3.882"
  }))
};
var Run = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$A,
    fill: "none"
  }));
});
var compPaths$z = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14 21h7v-1.5h-7V21zm4.5-4.5l5.5-.004v-1.5L18.5 15v1.5zm-4.969-2.851c-.287.706-.825 1.726-1.67 1.53-.47-.11-.807-.674-.95-1.351-.093-.433-.115-.892-.137-1.351.075.318.391 1.318 1.168 1.198.3-.048.62-.342.902-.823l3.352-5.757-2.665 6.554zm8.086-7.373l-3.54-3.541a1.477 1.477 0 00-1.407-.395 1.503 1.503 0 00-1.082 1.022A3.756 3.756 0 0111.99 6h-1.3l1.034-3.865-1.449-.388-3.197 11.937a1.9 1.9 0 01-1.224 1.307l-2.566.873A2.638 2.638 0 004.138 21h6.99l10.49-10.49a2.996 2.996 0 000-4.234z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14 21h7v-1.5h-7V21zm4.5-4.5l5.5-.004v-1.5L18.5 15v1.5zm-4.969-2.851c-.287.706-.825 1.726-1.67 1.53-.47-.11-.807-.674-.95-1.351-.093-.433-.115-.892-.137-1.351.075.318.391 1.318 1.168 1.198.3-.048.62-.342.902-.823l3.352-5.757-2.665 6.554zm8.086-7.373l-3.54-3.541a1.477 1.477 0 00-1.407-.395 1.503 1.503 0 00-1.082 1.022A3.756 3.756 0 0111.99 6h-1.3l1.034-3.865-1.449-.388-3.197 11.937a1.9 1.9 0 01-1.224 1.307l-2.566.873A2.638 2.638 0 004.138 21h6.99l10.49-10.49a2.996 2.996 0 000-4.234z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M28 42h14v-3H28v3zm9-12v3l11-.008v-3L37 30zm-9.937-2.702c-.575 1.412-1.65 3.452-3.342 3.06-.94-.218-1.613-1.348-1.898-2.702-.186-.866-.23-1.784-.274-2.702.15.636.782 2.636 2.335 2.396.6-.096 1.24-.684 1.805-1.646l6.703-11.514-5.33 13.108zm16.171-14.746L36.153 5.47a2.954 2.954 0 00-2.813-.79 3.006 3.006 0 00-2.164 2.044A7.512 7.512 0 0123.982 12h-2.603l2.07-7.73-2.898-.776-6.394 23.874a3.8 3.8 0 01-2.447 2.614l-5.133 1.746A5.276 5.276 0 008.276 42h13.979l20.98-20.98a5.992 5.992 0 000-8.468z",
    clipRule: "evenodd"
  }))
};
var RunFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$z,
    fill: "none"
  }));
});
var compPaths$y = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.25 8.25a3 3 0 100-6 3 3 0 000 6zM9 15l-6.97 6.97m6.47-1.72h6.43c.67 0 1.01-.81.53-1.29l-4.15-4.15a1.49 1.49 0 010-2.12l1.66-1.66c.47-.47.14-1.28-.53-1.28H7.5L5.25 12m10.23-.95l2.21 2.2c.59.58 1.53.58 2.12 0l2.21-2.2"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M17.25 8.25a3 3 0 100-6 3 3 0 000 6zM9 15l-6.97 6.97m6.47-1.72h6.43c.67 0 1.01-.81.53-1.29l-4.15-4.15a1.49 1.49 0 010-2.12l1.66-1.66c.47-.47.14-1.28-.53-1.28H7.5L5.25 12m10.23-.95l2.21 2.2c.59.58 1.53.58 2.12 0l2.21-2.2"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M34.5 16.5a6 6 0 100-12 6 6 0 000 12zM18 30L4.06 43.94M17 40.5h12.86c1.34 0 2.02-1.62 1.06-2.58l-8.3-8.3c-1.18-1.18-1.18-3.08 0-4.24l3.32-3.32c.94-.94.28-2.56-1.06-2.56H15L10.5 24m20.46-1.9l4.42 4.4a3.018 3.018 0 004.24 0l4.42-4.4"
  }))
};
var Runner = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$y,
    fill: "none"
  }));
});
var compPaths$x = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2",
    d: "M17.25 8.25a3 3 0 100-6 3 3 0 000 6zM9 15l-6.97 6.97m6.47-1.72h6.43c.67 0 1.01-.81.53-1.29l-4.15-4.15a1.49 1.49 0 010-2.12l1.66-1.66c.47-.47.14-1.28-.53-1.28H7.5L5.25 12m10.23-.95l2.21 2.2c.59.58 1.53.58 2.12 0l2.21-2.2"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "2",
    d: "M17.25 8.25a3 3 0 100-6 3 3 0 000 6zM9 15l-6.97 6.97m6.47-1.72h6.43c.67 0 1.01-.81.53-1.29l-4.15-4.15a1.49 1.49 0 010-2.12l1.66-1.66c.47-.47.14-1.28-.53-1.28H7.5L5.25 12m10.23-.95l2.21 2.2c.59.58 1.53.58 2.12 0l2.21-2.2"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "4",
    d: "M34.5 16.5a6 6 0 100-12 6 6 0 000 12zM18 30L4.06 43.94M17 40.5h12.86c1.34 0 2.02-1.62 1.06-2.58l-8.3-8.3c-1.18-1.18-1.18-3.08 0-4.24l3.32-3.32c.94-.94.28-2.56-1.06-2.56H15L10.5 24m20.46-1.9l4.42 4.4a3.018 3.018 0 004.24 0l4.42-4.4"
  }))
};
var RunnerStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$x,
    fill: "none"
  }));
});
var compPaths$w = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M21 20.25h-7m10-4.504l-5.5.004"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.845 12.852l3.352-5.757-2.665 6.554c-.288.706-.826 1.726-1.671 1.53-.47-.109-.806-.674-.95-1.351-.092-.433-.115-.893-.136-1.351.075.317.39 1.317 1.168 1.198.299-.049.62-.342.902-.823z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M11.99 6.75a4.521 4.521 0 004.312-3.164c.17-.542.841-.723 1.244-.32l3.541 3.54a2.245 2.245 0 010 3.174l-10.27 10.27H4.138a1.888 1.888 0 01-.609-3.676l2.567-.873a2.651 2.651 0 001.706-1.823L11 1.94"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M21 20.25h-7m10-4.504l-5.5.004"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.845 12.852l3.352-5.757-2.665 6.554c-.288.706-.826 1.726-1.671 1.53-.47-.109-.806-.674-.95-1.351-.092-.433-.115-.893-.136-1.351.075.317.39 1.317 1.168 1.198.299-.049.62-.342.902-.823z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M11.99 6.75a4.521 4.521 0 004.312-3.164c.17-.542.841-.723 1.244-.32l3.541 3.54a2.245 2.245 0 010 3.174l-10.27 10.27H4.138a1.888 1.888 0 01-.609-3.676l2.567-.873a2.651 2.651 0 001.706-1.823L11 1.94"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M42 40.5H28m20-9.008L37 31.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M25.69 25.704l6.703-11.514-5.33 13.108c-.576 1.412-1.652 3.452-3.342 3.06-.94-.218-1.612-1.348-1.9-2.702-.184-.866-.23-1.786-.272-2.702.15.634.78 2.634 2.336 2.396.598-.098 1.24-.684 1.804-1.646z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M23.98 13.5c4.046 0 7.472-2.66 8.624-6.328.34-1.084 1.682-1.446 2.488-.64l7.082 7.08a4.49 4.49 0 010 6.348L21.634 40.5H8.276A3.775 3.775 0 014.5 36.724a3.779 3.779 0 012.558-3.576l5.134-1.746a5.303 5.303 0 003.412-3.646L22 3.882"
  }))
};
var RunStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$w,
    fill: "none"
  }));
});
var compPaths$v = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.75 6.75a3 3 0 11-6 0 3 3 0 016 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.25 16.5A3.75 3.75 0 1118 20.25h-7.5a3.75 3.75 0 010-7.5m-.75.75a3.75 3.75 0 016-3m.33.277A3.736 3.736 0 0013.5 9.75M6.75 2V.5m3.359 2.892l1.06-1.061M2.33 11.169l1.062-1.061M11.5 6.75H13m-12.5 0H2m.33-4.419l1.062 1.061"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.75 6.75a3 3 0 11-6 0 3 3 0 016 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.25 16.5A3.75 3.75 0 1118 20.25h-7.5a3.75 3.75 0 010-7.5m-.75.75a3.75 3.75 0 016-3m.33.277A3.736 3.736 0 0013.5 9.75M6.75 2V.5m3.359 2.892l1.06-1.061M2.33 11.169l1.062-1.061M11.5 6.75H13m-12.5 0H2m.33-4.419l1.062 1.061"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M19.5 13.5a6 6 0 11-12 0 6 6 0 0112 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M28.5 33a7.5 7.5 0 117.5 7.5H21a7.5 7.5 0 010-15M19.5 27a7.5 7.5 0 0112-6m.658.555A7.472 7.472 0 0027 19.5M13.5 4V1m6.718 5.783l2.122-2.122M4.661 22.338l2.122-2.122M23 13.5h3m-25 0h3m.661-8.838l2.122 2.122"
  }))
};
var Sport = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$v,
    fill: "none"
  }));
});
var compPaths$u = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 2.25H18a2.25 2.25 0 012.25 2.25V18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15 21.75H6a2.25 2.25 0 01-2.25-2.25v-12A2.25 2.25 0 016 5.25h9a2.25 2.25 0 012.25 2.25v12A2.25 2.25 0 0115 21.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.209 10.667L9.436 15.44l-2.652-2.652"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 2.25H18a2.25 2.25 0 012.25 2.25V18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15 21.75H6a2.25 2.25 0 01-2.25-2.25v-12A2.25 2.25 0 016 5.25h9a2.25 2.25 0 012.25 2.25v12A2.25 2.25 0 0115 21.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.209 10.667L9.436 15.44l-2.652-2.652"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 4.5h21c2.484 0 4.5 2.016 4.5 4.5v27"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M30 43.5H12A4.502 4.502 0 017.5 39V15c0-2.484 2.016-4.5 4.5-4.5h18c2.484 0 4.5 2.016 4.5 4.5v24c0 2.484-2.016 4.5-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M28.418 21.334l-9.546 9.546-5.304-5.304"
  }))
};
var Stages = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$u,
    fill: "none"
  }));
});
var compPaths$t = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 5.25H6m9 4.5H9m6 4.5H9m6 4.5H9"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 5.25H6m9 4.5H9m6 4.5H9m6 4.5H9"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M36 10.5H12m18 9H18m12 9H18m12 9H18"
  }))
};
var Tighten = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$t,
    fill: "none"
  }));
});
var compPaths$s = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 21.75v0a6.002 6.002 0 01-6.002-6.002V8.252a6.002 6.002 0 0112.004 0v7.496A6.002 6.002 0 0112 21.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.998 18.75v0a3 3 0 01-3-3V8.249a3 3 0 016 0v7.501a3 3 0 01-3 3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "1.5",
    d: "M5.998 15.75h2.887m.17-2.25h2.887m.113-3h2.887m.363-2.25h2.583"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.961 7.5l.037 9"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 21.75v0a6.002 6.002 0 01-6.002-6.002V8.252a6.002 6.002 0 0112.004 0v7.496A6.002 6.002 0 0112 21.75z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.998 18.75v0a3 3 0 01-3-3V8.249a3 3 0 016 0v7.501a3 3 0 01-3 3z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "1.5",
    d: "M5.998 15.75h2.887m.17-2.25h2.887m.113-3h2.887m.363-2.25h2.583"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.961 7.5l.037 9"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 43.5v0c-6.63 0-12.004-5.376-12.004-12.004V16.504C11.996 9.876 17.37 4.5 24 4.5s12.004 5.376 12.004 12.004v14.992C36.004 38.124 30.63 43.5 24 43.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M23.995 37.5v0a6 6 0 01-6-6V16.498a6 6 0 0112 0V31.5a6 6 0 01-6 6z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "3",
    d: "M11.996 31.5h5.774m.34-4.5h5.773m.227-6h5.773m.727-4.5h5.165"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M23.923 15l.072 18"
  }))
};
var Track = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$s,
    fill: "none"
  }));
});
var compPaths$r = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.5 17.25H3M3.75 15V7.5a3.75 3.75 0 017.5 0v8.25a4.5 4.5 0 009 0V7.5a2.25 2.25 0 00-4.5 0V14a3.25 3.25 0 01-3.25 3.25H6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.5 17.25H3M3.75 15V7.5a3.75 3.75 0 017.5 0v8.25a4.5 4.5 0 009 0V7.5a2.25 2.25 0 00-4.5 0V14a3.25 3.25 0 01-3.25 3.25H6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M9 34.5H6M7.5 30V15a7.5 7.5 0 0115 0v16.5a9 9 0 0018 0V15c0-2.484-2.016-4.5-4.5-4.5a4.502 4.502 0 00-4.5 4.5v13a6.5 6.5 0 01-6.5 6.5H12"
  }))
};
var Trail = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$r,
    fill: "none"
  }));
});
var compPaths$q = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 20.25a1.5 1.5 0 000-3H5.25a1.5 1.5 0 000 3h13.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.265 16.958L20 6.75h-8.75a1.5 1.5 0 000 3h5.25m.744-2.7l1.05-3.917"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 18.75a1.5 1.5 0 11-3.001-.001 1.5 1.5 0 013.001.001zm13.5 0a1.5 1.5 0 11-3.001-.001 1.5 1.5 0 013.001.001z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.75 20.25a1.5 1.5 0 000-3H5.25a1.5 1.5 0 000 3h13.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.265 16.958L20 6.75h-8.75a1.5 1.5 0 000 3h5.25m.744-2.7l1.05-3.917"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 18.75a1.5 1.5 0 11-3.001-.001 1.5 1.5 0 013.001.001zm13.5 0a1.5 1.5 0 11-3.001-.001 1.5 1.5 0 013.001.001z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M37.5 40.5a3.001 3.001 0 000-6h-27a3.001 3.001 0 000 6h27z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.529 33.916l5.47-20.416h-17.5a3.001 3.001 0 000 6h10.5m1.489-5.398l2.1-7.836"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 37.5a3.001 3.001 0 01-6 0 3.001 3.001 0 016 0zm27 0a3.001 3.001 0 01-6 0 3.001 3.001 0 016 0z",
    clipRule: "evenodd"
  }))
};
var Treadmill = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$q,
    fill: "none"
  }));
});
var compPaths$p = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 6.75a4.5 4.5 0 000 9h10.5a4.49 4.49 0 003.182-1.318 4.49 4.49 0 001.318-3.182 4.49 4.49 0 00-1.318-3.182A4.49 4.49 0 0017.25 6.75a4.49 4.49 0 00-3.182 1.318 4.49 4.49 0 00-1.318 3.182m-6-3.75a5.25 5.25 0 019.645-2.873M15.25 20.821l-.75 1.3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M9.35 20.446l-.75 1.3 1.3.75.75-1.3-1.3-.75zm2.995-5.188L10.1 19.146l1.3.75 2.245-3.888-1.3-.75zM4.1 20.446l-.75 1.3 1.3.75.75-1.3-1.3-.75zm2.994-5.187L4.85 19.146l1.3.75 2.244-3.887-1.3-.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.326 15.493L16 19.521"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 6.75a4.5 4.5 0 000 9h10.5a4.49 4.49 0 003.182-1.318 4.49 4.49 0 001.318-3.182 4.49 4.49 0 00-1.318-3.182A4.49 4.49 0 0017.25 6.75a4.49 4.49 0 00-3.182 1.318 4.49 4.49 0 00-1.318 3.182m-6-3.75a5.25 5.25 0 019.645-2.873M15.25 20.821l-.75 1.3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M9.35 20.446l-.75 1.3 1.3.75.75-1.3-1.3-.75zm2.995-5.188L10.1 19.146l1.3.75 2.245-3.888-1.3-.75zM4.1 20.446l-.75 1.3 1.3.75.75-1.3-1.3-.75zm2.994-5.187L4.85 19.146l1.3.75 2.244-3.887-1.3-.75z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.326 15.493L16 19.521"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 13.5a9 9 0 000 18h21a8.98 8.98 0 006.364-2.636A8.98 8.98 0 0043.5 22.5a8.98 8.98 0 00-2.636-6.364A8.98 8.98 0 0034.5 13.5a8.98 8.98 0 00-6.364 2.636A8.98 8.98 0 0025.5 22.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 15c0-5.798 4.702-10.5 10.5-10.5a10.49 10.49 0 018.79 4.754M30.5 41.643L29 44.24"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M18.701 40.893l-1.5 2.598 2.598 1.5 1.5-2.598-2.598-1.5zm5.99-10.377l-4.49 7.776 2.598 1.5 4.49-7.775-2.598-1.5zM8.201 40.892l-1.5 2.598 2.598 1.5 1.5-2.597-2.598-1.5zm5.988-10.373L9.7 38.293l2.598 1.5 4.488-7.774-2.598-1.5z"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36.652 30.986L32 39.042"
  }))
};
var WeatherHail = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$p,
    fill: "none"
  }));
});
var compPaths$o = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 6.75a1.5 1.5 0 11-3.001-.001 1.5 1.5 0 013.001.001zM8.25 9c0-2.293.736-4.413 1.983-6.14.134-.185-.018-.445-.241-.398-4.647.974-8.08 5.252-7.716 10.267.331 4.557 3.921 8.366 8.454 8.94a9.72 9.72 0 007.02-1.8c.184-.135.092-.42-.135-.443C12.352 18.859 8.25 14.414 8.25 9z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.72 10.72l1.06 1.06m1.94-1.06l1.06 1.06m-1.06-4.09l1.06 1.06"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 6.75a1.5 1.5 0 11-3.001-.001 1.5 1.5 0 013.001.001zM8.25 9c0-2.293.736-4.413 1.983-6.14.134-.185-.018-.445-.241-.398-4.647.974-8.08 5.252-7.716 10.267.331 4.557 3.921 8.366 8.454 8.94a9.72 9.72 0 007.02-1.8c.184-.135.092-.42-.135-.443C12.352 18.859 8.25 14.414 8.25 9z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.72 10.72l1.06 1.06m1.94-1.06l1.06 1.06m-1.06-4.09l1.06 1.06"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 13.5a3.001 3.001 0 01-6 0 3.001 3.001 0 016 0zm-18 4.5c0-4.586 1.472-8.826 3.966-12.28.268-.37-.036-.89-.482-.796C10.69 6.872 3.824 15.428 4.552 25.458c.662 9.114 7.842 16.732 16.908 17.88 5.274.67 10.19-.78 14.04-3.6.368-.27.184-.838-.27-.886C24.704 37.718 16.5 28.828 16.5 18z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M33.44 21.44l2.121 2.121m3.879-2.121l2.121 2.121m-2.121-8.182l2.12 2.121"
  }))
};
var WeatherNightClear = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$o,
    fill: "none"
  }));
});
var compPaths$n = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.75 16.5a3.75 3.75 0 113.75 3.75H6a3.75 3.75 0 010-7.5m-.75.75a3.75 3.75 0 016-3m.33.277A3.736 3.736 0 009 9.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.223 6.325c0-.65.134-1.27.374-1.833.19-.444-.27-.907-.7-.685a4.342 4.342 0 00-2.293 4.531c.286 1.89 1.864 3.407 3.763 3.631a4.347 4.347 0 002.069-.253c.448-.17.404-.819-.05-.973a4.669 4.669 0 01-3.163-4.418z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.75 16.5a3.75 3.75 0 113.75 3.75H6a3.75 3.75 0 010-7.5m-.75.75a3.75 3.75 0 016-3m.33.277A3.736 3.736 0 009 9.75"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.223 6.325c0-.65.134-1.27.374-1.833.19-.444-.27-.907-.7-.685a4.342 4.342 0 00-2.293 4.531c.286 1.89 1.864 3.407 3.763 3.631a4.347 4.347 0 002.069-.253c.448-.17.404-.819-.05-.973a4.669 4.669 0 01-3.163-4.418z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M19.5 33a7.5 7.5 0 117.5 7.5H12a7.5 7.5 0 010-15M10.5 27a7.5 7.5 0 0112-6m.658.555A7.472 7.472 0 0018 19.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36.445 12.65c0-1.302.268-2.542.748-3.666.38-.888-.54-1.814-1.398-1.37a8.683 8.683 0 00-4.588 9.062c.572 3.78 3.728 6.814 7.526 7.262a8.693 8.693 0 004.138-.506c.896-.342.808-1.638-.1-1.946-3.678-1.254-6.326-4.732-6.326-8.836z",
    clipRule: "evenodd"
  }))
};
var WeatherNightOvercast = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$n,
    fill: "none"
  }));
});
var compPaths$m = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 9.75a4.5 4.5 0 000 9h10.5a4.5 4.5 0 10-4.5-4.5m-6-3.75a5.25 5.25 0 019.645-2.873"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 9.75a4.5 4.5 0 000 9h10.5a4.5 4.5 0 10-4.5-4.5m-6-3.75a5.25 5.25 0 019.645-2.873"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 19.5a9 9 0 000 18h21a9 9 0 10-9-9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 21c0-5.798 4.702-10.5 10.5-10.5a10.49 10.49 0 018.79 4.754"
  }))
};
var WeatherOvercast = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$m,
    fill: "none"
  }));
});
var compPaths$l = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 21.75h10.5m-6-3h-12m11.25-7.5a4.5 4.5 0 114.5 4.5H6.75a4.5 4.5 0 010-9m0 .75a5.25 5.25 0 019.645-2.873M21.75 19.5a2.25 2.25 0 01-2.25 2.25"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 21.75h10.5m-6-3h-12m11.25-7.5a4.5 4.5 0 114.5 4.5H6.75a4.5 4.5 0 010-9m0 .75a5.25 5.25 0 019.645-2.873M21.75 19.5a2.25 2.25 0 01-2.25 2.25"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18 43.5h21m-12-6H3m22.5-15a9 9 0 119 9h-21a9 9 0 010-18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 15c0-5.798 4.702-10.5 10.5-10.5a10.49 10.49 0 018.79 4.754M43.5 39c0 2.484-2.016 4.5-4.5 4.5"
  }))
};
var WeatherOvercastWind = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$l,
    fill: "none"
  }));
});
var compPaths$k = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 6.75a4.5 4.5 0 000 9h10.5a4.5 4.5 0 10-4.5-4.5m-6-3.75a5.25 5.25 0 019.645-2.873"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.995 15.633l-2.245 3.889-1.5 2.598m-1.506-6.485L5.5 19.522 4 22.12m14.326-6.627L16 19.521l-1.5 2.6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.75 6.75a4.5 4.5 0 000 9h10.5a4.5 4.5 0 10-4.5-4.5m-6-3.75a5.25 5.25 0 019.645-2.873"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.995 15.633l-2.245 3.889-1.5 2.598m-1.506-6.485L5.5 19.522 4 22.12m14.326-6.627L16 19.521l-1.5 2.6"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 13.5a9 9 0 000 18h21a9 9 0 10-9-9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.5 15c0-5.798 4.702-10.5 10.5-10.5a10.49 10.49 0 018.79 4.754m-6.8 22.012l-4.49 7.778-3 5.196m-3.012-12.97L11 39.044 8 44.24m28.653-13.254L32 39.042l-3 5.198"
  }))
};
var WeatherRain = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$k,
    fill: "none"
  }));
});
var compPaths$j = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.5 12h-5m14.75 0H14.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.25 12a2.25 2.25 0 11-4.502-.002A2.25 2.25 0 0114.25 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 21v-3.75H21M9.349 21.977l2.65-2.65 2.653 2.65M6.75 21v-3.75H3M6.75 3v3.75H3M17.25 3v3.75H21"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.349 21.974l2.65-2.651 2.653 2.65m-.001-19.947l-2.65 2.651-2.653-2.65M2.026 9.349l2.651 2.65-2.65 2.653m19.947-.001l-2.651-2.65 2.65-2.653m-11.778.972L6.66 6.785m10.43 10.43l-3.358-3.358m-1.857-4.232v-5m0 14.75v-4.75m1.68-4.305l3.535-3.535M6.66 17.215l3.358-3.358"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.5 12h-5m14.75 0H14.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.25 12a2.25 2.25 0 11-4.502-.002A2.25 2.25 0 0114.25 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 21v-3.75H21M9.349 21.977l2.65-2.65 2.653 2.65M6.75 21v-3.75H3M6.75 3v3.75H3M17.25 3v3.75H21"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.349 21.974l2.65-2.651 2.653 2.65m-.001-19.947l-2.65 2.651-2.653-2.65M2.026 9.349l2.651 2.65-2.65 2.653m19.947-.001l-2.651-2.65 2.65-2.653m-11.778.972L6.66 6.785m10.43 10.43l-3.358-3.358m-1.857-4.232v-5m0 14.75v-4.75m1.68-4.305l3.535-3.535M6.66 17.215l3.358-3.358"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M19 24H9m29.5 0H29"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M28.5 24c0 2.484-2.016 4.5-4.5 4.5a4.502 4.502 0 01-4.5-4.5c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 42v-7.5H42m-23.303 9.455l5.302-5.302 5.304 5.302M13.5 42v-7.5H6M13.5 6v7.5H6M34.5 6v7.5H42"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.697 43.947l5.302-5.302 5.304 5.302m0-39.894L24 9.355l-5.304-5.302M4.053 18.697l5.302 5.302-5.302 5.304m39.894 0L38.645 24l5.302-5.304M20.39 20.64l-7.07-7.07m20.86 20.86l-6.716-6.716M23.75 19.25v-10m0 29.5v-9.5m3.36-8.61l7.07-7.07M13.32 34.43l6.716-6.716"
  }))
};
var WeatherSnow = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$j,
    fill: "none"
  }));
});
var compPaths$i = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 19.5v3m0-21v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 12a5.25 5.25 0 11-10.501-.001A5.25 5.25 0 0117.25 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.697 17.304l-2.122 2.12m14.85-14.849l-2.122 2.121M4.5 12h-3m21 0h-3M6.697 6.696l-2.122-2.12m14.85 14.849l-2.122-2.121"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 19.5v3m0-21v3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 12a5.25 5.25 0 11-10.501-.001A5.25 5.25 0 0117.25 12z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.697 17.304l-2.122 2.12m14.85-14.849l-2.122 2.121M4.5 12h-3m21 0h-3M6.697 6.696l-2.122-2.12m14.85 14.849l-2.122-2.121"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M24 39v6m0-42v6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 24c0 5.798-4.702 10.5-10.5 10.5S13.5 29.798 13.5 24 18.202 13.5 24 13.5 34.5 18.202 34.5 24z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M13.394 34.607L9.15 38.85m29.7-29.7l-4.244 4.242M9 24H3m42 0h-6M13.394 13.393L9.15 9.15m29.7 29.7l-4.244-4.242"
  }))
};
var WeatherSunny = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$i,
    fill: "none"
  }));
});
var compPaths$h = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.25 6a3.75 3.75 0 01-3.75 3.75h-9m15.75.75a2.25 2.25 0 112.25 2.25h-18M12.75 18A2.25 2.25 0 1015 15.75H1.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.25 6a3.75 3.75 0 01-3.75 3.75h-9m15.75.75a2.25 2.25 0 112.25 2.25h-18M12.75 18A2.25 2.25 0 1015 15.75H1.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M28.5 12a7.5 7.5 0 01-7.5 7.5H3M34.5 21a4.5 4.5 0 114.5 4.5H3M25.5 36a4.5 4.5 0 104.5-4.5H3"
  }))
};
var WeatherWind = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$h,
    fill: "none"
  }));
});
var compPaths$g = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M10.5 8.25h6m-6 3.75h6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 8.25H7.5M9 12H7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M10.5 15.75h6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 15.75H7.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M10.5 8.25h6m-6 3.75h6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18 20.25H6A2.25 2.25 0 013.75 18V6A2.25 2.25 0 016 3.75h12A2.25 2.25 0 0120.25 6v12A2.25 2.25 0 0118 20.25z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 8.25H7.5M9 12H7.5"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M10.5 15.75h6"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 15.75H7.5"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "3",
    d: "M21 16.5h12M21 24h12"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M36 40.5H12A4.5 4.5 0 017.5 36V12A4.5 4.5 0 0112 7.5h24c2.484 0 4.5 2.016 4.5 4.5v24c0 2.484-2.016 4.5-4.5 4.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18 16.5h-3m3 7.5h-3"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "3",
    d: "M21 31.5h12"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18 31.5h-3"
  }))
};
var Whiteboard = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$g,
    fill: "none"
  }));
});
var compPaths$f = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 18.75h3V5.25h-3v13.5zm13.5 0h3V5.25h-3v13.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 12h8.25M20 12h2.5m-21 0H4"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 18.75h3V5.25h-3v13.5zm13.5 0h3V5.25h-3v13.5z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 12h8.25M20 12h2.5m-21 0H4"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 37.5h6v-27h-6v27zm27 0h6v-27h-6v27z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18 24h16.5m5.5 0h5M3 24h5"
  }))
};
var WorkoutEquipment = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$f,
    fill: "none"
  }));
});
var compPaths$e = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15.712 8.72l-4.242 4.243 1.06 1.06 4.243-4.243-1.061-1.06zm-3.181 5.303l4.242-4.243-1.061-1.06-4.242 4.243 1.06 1.06zM7.5 3h9V1.5h-9V3zm9-1.5h-9V3h9V1.5zm3 12A7.5 7.5 0 0112 21v1.5a9 9 0 009-9h-1.5zM12 21a7.5 7.5 0 01-7.5-7.5H3a9 9 0 009 9V21zm-7.5-7.5A7.5 7.5 0 0112 6V4.5a9 9 0 00-9 9h1.5zM12 6a7.5 7.5 0 017.5 7.5H21a9 9 0 00-9-9V6z"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    d: "M15.712 8.72l-4.242 4.243 1.06 1.06 4.243-4.243-1.061-1.06zm-3.181 5.303l4.242-4.243-1.061-1.06-4.242 4.243 1.06 1.06zM7.5 3h9V1.5h-9V3zm9-1.5h-9V3h9V1.5zm3 12A7.5 7.5 0 0112 21v1.5a9 9 0 009-9h-1.5zM12 21a7.5 7.5 0 01-7.5-7.5H3a9 9 0 009 9V21zm-7.5-7.5A7.5 7.5 0 0112 6V4.5a9 9 0 00-9 9h1.5zM12 6a7.5 7.5 0 017.5 7.5H21a9 9 0 00-9-9V6z"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M40.5 27c0 9.112-7.386 16.5-16.5 16.5S7.5 36.112 7.5 27 14.886 10.5 24 10.5 40.5 17.888 40.5 27z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 4.5h18m-.516 14L24 26.986"
  }))
};
var Workouts = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$e,
    fill: "none"
  }));
});
var compPaths$d = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 2.25h9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.53 14.023l-1.06-1.061 4.242-4.242 1.06 1.06-4.241 4.243zM12 4.5c-4.963 0-9 4.038-9 9s4.037 9 9 9 9-4.038 9-9-4.037-9-9-9z",
    clipRule: "evenodd"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M7.5 2.25h9"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.53 14.023l-1.06-1.061 4.242-4.242 1.06 1.06-4.241 4.243zM12 4.5c-4.963 0-9 4.038-9 9s4.037 9 9 9 9-4.038 9-9-4.037-9-9-9z",
    clipRule: "evenodd"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15 4.5h18"
  }), /* @__PURE__ */ React__default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M25.06 28.046l-2.121-2.122 8.485-8.484 2.12 2.12-8.483 8.486zM24 9C14.075 9 6 17.076 6 27s8.075 18 18 18c9.926 0 18-8.076 18-18S33.927 9 24 9z",
    clipRule: "evenodd"
  }))
};
var WorkoutsFilled = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$d,
    fill: "none"
  }));
});
var compPaths$c = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M20.25 13.5a8.25 8.25 0 11-16.5 0 8.25 8.25 0 1116.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M7.5 2.25h9m-.258 7L12 13.493"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M20.25 13.5a8.25 8.25 0 11-16.5 0 8.25 8.25 0 1116.5 0z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    d: "M7.5 2.25h9m-.258 7L12 13.493"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M40.5 27c0 9.112-7.386 16.5-16.5 16.5S7.5 36.112 7.5 27 14.886 10.5 24 10.5 40.5 17.888 40.5 27z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "4",
    d: "M15 4.5h18m-.516 14L24 26.986"
  }))
};
var WorkoutsStroke = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$c,
    fill: "none"
  }));
});
var compPaths$b = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 17.5V5m-5.5 7.5L12 18l5.5-5.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.966 12.979L12 19.945 5.033 12.98M12 20V3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M37.933 25.957L24 39.891 10.067 25.957M24 40V6"
  }))
};
var ArrowDown = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$b,
    fill: "none"
  }));
});
var compPaths$a = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.5 12H19m-7.5 5.5L6 12l5.5-5.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.021 18.967L4.055 12l6.966-6.967M4 12h17"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M22.042 37.933L8.11 24l13.932-13.934M8 24h34"
  }))
};
var ArrowLeft = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$a,
    fill: "none"
  }));
});
var compPaths$9 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.5 12H5m7.5 5.5L18 12l-5.5-5.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.979 18.967L19.945 12 12.98 5.033M20 12H3"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M25.957 37.933L39.891 24 25.957 10.065M40 24H6"
  }))
};
var ArrowRight = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$9,
    fill: "none"
  }));
});
var compPaths$8 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12 6.5V19m-5.5-7.5L12 6l5.5 5.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.033 11.022L12 4.055l6.967 6.967M12 4v17"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M10.066 22.043L24 8.109l13.934 13.934M24 8v34"
  }))
};
var ArrowUp = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$8,
    fill: "none"
  }));
});
var compPaths$7 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.5 9.25l-5.5 5.5-5.5-5.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.966 8.476L12 15.443 5.033 8.476"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M37.933 16.951L24 30.885 10.067 16.951"
  }))
};
var CaretDown = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$7,
    fill: "none"
  }));
});
var compPaths$6 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.75 17.5L9.25 12l5.5-5.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.525 18.966L8.558 12l6.967-6.967"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M31.05 37.932L17.118 24 31.05 10.066"
  }))
};
var CaretLeft = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$6,
    fill: "none"
  }));
});
var compPaths$5 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.25 17.5l5.5-5.5-5.5-5.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M8.474 18.966L15.44 12 8.474 5.033"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M16.947 37.932L30.881 24 16.947 10.066"
  }))
};
var CaretRight = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$5,
    fill: "none"
  }));
});
var compPaths$4 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.5 14.75L12 9.25l-5.5 5.5"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.034 15.527L12 8.561l6.967 6.966"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M10.067 31.054L24 17.122l13.934 13.932"
  }))
};
var CaretUp = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$4,
    fill: "none"
  }));
});
var compPaths$3 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.5 6.5l-11 11m0-11l11 11"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M18.973 5.027L5.028 18.972M5.027 5.027l13.945 13.945"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M37.945 10.055l-27.89 27.89m0-27.89l27.89 27.89"
  }))
};
var Close = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$3,
    fill: "none"
  }));
});
var compPaths$2 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 12H6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M19.5 12h-15"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M39 24H9"
  }))
};
var Minus = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$2,
    fill: "none"
  }));
});
var compPaths$1 = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M18 12H6m6 6V6"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M19.5 12h-15m7.5 7.5v-15"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M39 24H9m15 15V9"
  }))
};
var Plus = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths$1,
    fill: "none"
  }));
});
var compPaths = {
  s: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M10 10H5m14 4.5h-5m-6.5-2v-5M7.958 19l8.084-14"
  })),
  m: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9 10.5H3m18 3.75h-6m-9-.75v-6m1.5 12.294l9-15.588"
  })),
  l: /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18 21H6m36 7.5H30M12 27V15m3 24.588L33 8.412"
  }))
};
var PlusMinus = /* @__PURE__ */ React__default.memo(function(props) {
  return /* @__PURE__ */ React__default.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});
var DSIcons = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Converse,
  Hurley,
  Jordan,
  NBY,
  NikeApp,
  NikeSwoosh,
  Sustainability,
  Activity,
  ActivityFilled,
  ActivityStroke,
  AddFriends,
  AddPayment,
  Alert,
  AlertCircle,
  AlertCircleFilled,
  Analytics,
  AnalyticsFilled,
  AnalyticsStroke,
  AR,
  Bag,
  BagFilled,
  BagStroke,
  Bookmark,
  BookmarkFilled,
  BookmarkStroke,
  BrightnessNone,
  Calendar,
  Camera,
  Cards,
  Check,
  CheckCircle,
  CheckCircleFilled,
  Club,
  ClubFilled,
  ClubStroke,
  Coach,
  Collapse,
  Comments,
  Compare,
  CreateRule,
  CreateRuleFilled,
  Delete,
  Desktop,
  Discover,
  DiscoverFilled,
  DiscoverStroke,
  Download,
  Edit,
  Ellipsis,
  EllipsisVertical,
  Expand,
  Experiments,
  ExternalLink,
  Favorite,
  FavoriteFilled,
  FavoriteStroke,
  Feed,
  FeedStroke,
  Filter,
  FirstAccess,
  FlashlightOff,
  FlashlightOn,
  GestureSwipe,
  GestureTap,
  Gift,
  GiftCard,
  Global,
  GridView,
  Hide,
  History,
  Home,
  HomeFilled,
  HomeStroke,
  ImagenoImage,
  Inbox,
  InboxFilled,
  InboxStroke,
  Info,
  InfoCircle,
  InfoCircleFilled,
  Journal,
  Link,
  Loading,
  LocationPin,
  LocationPinFilled,
  Lock,
  LockFilled,
  Measure,
  MemberProduct,
  MemberRewards,
  Menu: Menu$1,
  Menu2lines,
  Message,
  Microphone,
  Monarch,
  Multimedia,
  MultiSelect,
  Navigation,
  NikeMembership,
  Notification,
  Null,
  Orders,
  Payment,
  Personalization,
  Plan,
  PlusCircle,
  PlusCircleFilled,
  Print,
  Profile,
  ProfileFilled,
  ProfileStroke,
  ProfileSwoosh,
  ProfileSwooshStroke,
  QRCode,
  Question,
  QuestionCircle,
  QuestionCircleFilled,
  Rating,
  RatingFilled,
  RatingStroke,
  Receipt,
  ReceiptNone,
  Repeat,
  Replay,
  Report,
  Return,
  Review,
  Rewards,
  Rfid,
  Scan,
  Search,
  Settings,
  SettingsFilled,
  Share,
  Shareaos,
  Shipping,
  Shoe,
  ShoeFilled,
  ShoeStroke,
  ShopnikeApp,
  ShopnikeAppFilled,
  ShopnikeAppStroke,
  Shopnrc,
  ShopnrcStroke,
  ShopSNKRS,
  Show,
  Shuffle,
  SingleSelect,
  Sort,
  SortAscending: SortAscending$1,
  SortDescending: SortDescending$1,
  Store,
  TabletHorizontal,
  TabletVertical,
  Tag,
  ThumbsDown,
  ThumbsUp,
  Time,
  Tip,
  Transfers,
  Translation,
  TrendingDown,
  TrendingUp,
  Unlock,
  UnlockFilled,
  Upload,
  VideoPlayer,
  VR,
  Wallet,
  Zoomin,
  Zoomout,
  Columns,
  Container,
  CopyPaste,
  CopyPasteFilled,
  FormatBold,
  FormatBullet,
  FormatItalics,
  FormatNumberedList,
  Heading,
  Keyboard,
  Redo,
  Text,
  Undo,
  ClosedCaption,
  ClosedCaptionFilled,
  FastForward,
  FastForwardFilled,
  Music,
  MusicFilled,
  MusicNone,
  MusicNoneFilled,
  Mute,
  MuteFilled,
  Pause,
  PauseFilled,
  Play,
  PlayFilled,
  Rewind,
  RewindFilled,
  Stop,
  StopFilled,
  VolumeHigh,
  VolumeHighFilled,
  VolumeLow,
  VolumeLowFilled,
  Adapt,
  AdaptLight,
  AppleWatch,
  AudioFeedback,
  BatteryChargingFull,
  BatteryChargingLow,
  BatteryFull,
  BatteryLow,
  Brightness,
  Burn,
  ClassWorkout,
  Device,
  DeviceLeft,
  DeviceRight,
  DeviceVertical,
  DualLightsColorChip,
  EffectActive,
  EffectInactive,
  Effort,
  ElevationChange,
  HeartRate,
  LaceDown,
  LaceUp,
  LightsOff,
  Loosen,
  MuscleGroup,
  Notes,
  ProgramIntensity,
  Programs,
  ProgramsFilled,
  ProgramsStroke,
  PulsingDualLights,
  PulsingLights,
  Road,
  Run,
  RunFilled,
  Runner,
  RunnerStroke,
  RunStroke,
  Sport,
  Stages,
  Tighten,
  Track,
  Trail,
  Treadmill,
  WeatherHail,
  WeatherNightClear,
  WeatherNightOvercast,
  WeatherOvercast,
  WeatherOvercastWind,
  WeatherRain,
  WeatherSnow,
  WeatherSunny,
  WeatherWind,
  Whiteboard,
  WorkoutEquipment,
  Workouts,
  WorkoutsFilled,
  WorkoutsStroke,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  CaretDown,
  CaretLeft,
  CaretRight,
  CaretUp,
  Close,
  Minus,
  Plus,
  PlusMinus,
  CheckboxIcon,
  RadioIcon,
  SuccessIcon,
  SvgIcon
}, Symbol.toStringTag, { value: "Module" }));
const DSIcon = ({
  type,
  ...rest
}) => {
  const IconComponent = DSIcons[type];
  if (!IconComponent)
    return null;
  return /* @__PURE__ */ jsx$1(IconComponent, {
    ...rest
  });
};
const DSTypes = Object.keys(DSIcons).filter((type) => {
  return type !== "CheckboxIcon" && type !== "SuccessIcon" && type !== "SvgIcon" && type !== "RadioIcon";
});
DSIcon.propTypes = {
  className: PropTypes$1.string,
  type: PropTypes$1.oneOf(DSTypes).isRequired,
  size: PropTypes$1.oneOf(["s", "m", "l"])
};
const Icon = ({
  type,
  className,
  fontSize,
  ...props
}) => {
  if (CXTypes.includes(type)) {
    return /* @__PURE__ */ jsx$1(CXIcon, {
      type,
      className,
      ...props
    });
  }
  if (DSTypes.includes(type)) {
    return /* @__PURE__ */ jsx$1(DSIcon, {
      type,
      className,
      ...props
    });
  }
  return /* @__PURE__ */ jsx$1("i", {
    className: `epic-icon epic-icon-${type} ${className}`,
    style: {
      fontSize
    },
    ...props
  });
};
Icon.propTypes = {
  className: PropTypes$1.string,
  size: PropTypes$1.oneOf(["s", "m", "l"]),
  type: PropTypes$1.oneOf([...DSTypes, ...CXTypes, "add", "arrow-backward", "arrow-down", "arrow-forward", "arrow-up", "bookmark", "calendar", "checkmark", "chevron-back", "chevron-circle-back", "chevron-circle-forward", "chevron-down", "chevron-forward", "chevron-up", "close-x", "collaborate", "confluence", "contact", "delete", "edit", "filter-x", "filter", "github", "information", "jira", "map-pin", "nike-logo", "preview-eye", "preview", "profile", "quotes", "search", "share", "slack-with-name", "slack", "steps", "up-and-running", "user-profile", "walkthrough", "warning"]).isRequired,
  fontSize: PropTypes$1.string
};
Icon.defaultProps = {
  className: "",
  fontSize: "14px"
};
const icon$b = "epic__icon__e6b";
const ripple$b = "epic__ripple__a1f";
const listItem = "epic__listItem__1ad";
const inner = "epic__inner__5c4";
const title$2 = "epic__title__b6b";
const subtitle$1 = "epic__subtitle__96a";
const noBorder = "epic__noBorder__52f";
const thumbnail = "epic__thumbnail__770";
const info = "epic__info__700";
const content = "epic__content__c61";
var styles$a = {
  icon: icon$b,
  "epic-icon": "epic__epic-icon__db4",
  "epic-icon-add": "epic__epic-icon-add__215",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__050",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__99b",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__013",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__57a",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__b11",
  "epic-icon-calendar": "epic__epic-icon-calendar__124",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__e58",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__036",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__cb9",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__2ae",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__bf3",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__ddd",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__5c9",
  "epic-icon-close-x": "epic__epic-icon-close-x__86a",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__2dc",
  "epic-icon-confluence": "epic__epic-icon-confluence__cea",
  "epic-icon-contact": "epic__epic-icon-contact__97b",
  "epic-icon-delete": "epic__epic-icon-delete__8c3",
  "epic-icon-edit": "epic__epic-icon-edit__96f",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__387",
  "epic-icon-filter": "epic__epic-icon-filter__a27",
  "epic-icon-github": "epic__epic-icon-github__8cc",
  "epic-icon-information": "epic__epic-icon-information__ce0",
  "epic-icon-jira": "epic__epic-icon-jira__bbf",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__eca",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__3a4",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__ed6",
  "epic-icon-preview": "epic__epic-icon-preview__034",
  "epic-icon-profile": "epic__epic-icon-profile__26e",
  "epic-icon-quotes": "epic__epic-icon-quotes__19f",
  "epic-icon-search": "epic__epic-icon-search__7af",
  "epic-icon-share": "epic__epic-icon-share__b63",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__172",
  "epic-icon-slack": "epic__epic-icon-slack__f23",
  "epic-icon-steps": "epic__epic-icon-steps__f86",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__a55",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__3c4",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__b0f",
  "epic-icon-warning": "epic__epic-icon-warning__6a2",
  "epic-font-base": "epic__epic-font-base__05f",
  "epic-font-base-md": "epic__epic-font-base-md__a57",
  "epic-font-marketing": "epic__epic-font-marketing__b2f",
  "epic-font-brand": "epic__epic-font-brand__315",
  ripple: ripple$b,
  "epic-display-base": "epic__epic-display-base__c15",
  "epic-display-1": "epic__epic-display-1__ee4",
  "epic-display-2": "epic__epic-display-2__395",
  "epic-display-3": "epic__epic-display-3__b80",
  "epic-display-4": "epic__epic-display-4__f81",
  "epic-display-5": "epic__epic-display-5__eb2",
  "epic-title-base": "epic__epic-title-base__4ac",
  "epic-title-1": "epic__epic-title-1__9f4",
  "epic-title-2": "epic__epic-title-2__6da",
  "epic-title-3": "epic__epic-title-3__c87",
  "epic-title-4": "epic__epic-title-4__356",
  "epic-title-5": "epic__epic-title-5__1ae",
  "epic-title-6": "epic__epic-title-6__85a",
  "epic-subtitle-base": "epic__epic-subtitle-base__11f",
  "epic-subtitle-1": "epic__epic-subtitle-1__93b",
  "epic-subtitle-2": "epic__epic-subtitle-2__6c5",
  "epic-subtitle-3": "epic__epic-subtitle-3__40e",
  "epic-body-text-base": "epic__epic-body-text-base__953",
  "epic-body-text-1": "epic__epic-body-text-1__6e0",
  "epic-body-text-2": "epic__epic-body-text-2__c94",
  "epic-body-text": "epic__epic-body-text__638",
  "epic-body-text-3": "epic__epic-body-text-3__93f",
  listItem,
  inner,
  title: title$2,
  subtitle: subtitle$1,
  "epic-legal-text": "epic__epic-legal-text__cb9",
  "epic-label-text": "epic__epic-label-text__81d",
  "epic-button-base": "epic__epic-button-base__14d",
  "epic-button-1": "epic__epic-button-1__344",
  "epic-button-2": "epic__epic-button-2__f95",
  "epic-button-3": "epic__epic-button-3__c99",
  noBorder,
  thumbnail,
  info,
  content
};
function ListItem({
  iconType,
  onAction,
  thumbnail: thumbnail2,
  title: title2,
  subtitle: subtitle2,
  content: content2,
  className,
  noBorder: noBorder2
}) {
  let containerClass = classnames$2(styles$a.listItem, className);
  if (noBorder2) {
    containerClass = classnames$2(containerClass, styles$a.noBorder);
  }
  return /* @__PURE__ */ jsx$1("div", {
    className: containerClass,
    children: /* @__PURE__ */ jsxs("div", {
      className: styles$a.inner,
      children: [/* @__PURE__ */ jsxs("div", {
        className: styles$a.title,
        children: [/* @__PURE__ */ jsx$1("div", {
          className: styles$a.thumbnail,
          children: thumbnail2 && thumbnail2
        }), /* @__PURE__ */ jsxs("div", {
          className: styles$a.info,
          children: [/* @__PURE__ */ jsx$1("div", {
            className: styles$a.title,
            children: title2
          }), subtitle2 && /* @__PURE__ */ jsx$1("div", {
            className: styles$a.subtitle,
            children: subtitle2
          })]
        })]
      }), /* @__PURE__ */ jsx$1("div", {
        className: styles$a.content,
        children: content2
      }), iconType && /* @__PURE__ */ jsx$1("div", {
        children: /* @__PURE__ */ jsx$1(IconButton, {
          icon: iconType,
          variant: "ghost",
          onClick: onAction
        })
      })]
    })
  });
}
ListItem.propTypes = {
  iconType: PropTypes$1.string,
  onAction: PropTypes$1.func,
  content: PropTypes$1.oneOf([PropTypes$1.string, PropTypes$1.node, PropTypes$1.func]),
  thumbnail: PropTypes$1.node,
  title: PropTypes$1.string,
  subtitle: PropTypes$1.string,
  className: PropTypes$1.string
};
ListItem.defaultProps = {
  className: "",
  title: "",
  onAction: () => void 0
};
const ChildrenFocusBlur = ({
  children,
  onBlur,
  onFocus: onFocus2,
  ...props
}) => {
  const handleBlur = useCallback(({
    currentTarget
  }) => {
    requestAnimationFrame(() => {
      if (!currentTarget.contains(document.activeElement)) {
        onBlur();
      }
    });
  }, [onBlur]);
  const handleFocus = useCallback(() => {
    requestAnimationFrame(() => {
      onFocus2();
    });
  }, [onFocus2]);
  return /* @__PURE__ */ jsx$1("div", {
    ...props,
    onBlur: handleBlur,
    onFocus: handleFocus,
    children
  });
};
ChildrenFocusBlur.propTypes = {
  onBlur: PropTypes$1.func,
  onFocus: PropTypes$1.func
};
ChildrenFocusBlur.defaultProps = {};
const icon$a = "epic__icon__2cd";
const navbar = "epic__navbar__445";
const ripple$a = "epic__ripple__3a0";
const navigation$1 = "epic__navigation__2bc";
const logo = "epic__logo__493";
const title$1 = "epic__title__5d0";
const innerNav = "epic__innerNav__1de";
const link = "epic__link__f29";
const subNavWrapper = "epic__subNavWrapper__307";
const hover = "epic__hover__b51";
const subNavBg = "epic__subNavBg__b31";
const subNavTitle = "epic__subNavTitle__b74";
const subNavContent = "epic__subNavContent__638";
const subNavColumn = "epic__subNavColumn__7ce";
const inverse$1 = "epic__inverse__5e9";
const asideContainer = "epic__asideContainer__ba1";
const asideSidePad = "epic__asideSidePad__840";
const searchContainer = "epic__searchContainer__fc9";
const fixed = "epic__fixed__06a";
const nikeLogo = "epic__nikeLogo__6f7";
const underline = "epic__underline__831";
const active$2 = "epic__active__d86";
const subNavBgOverlay = "epic__subNavBgOverlay__aaa";
const subNavExpand = "epic__subNavExpand__63a";
const subNavMega = "epic__subNavMega__850";
var styles$9 = {
  icon: icon$a,
  "epic-icon": "epic__epic-icon__1f9",
  "epic-icon-add": "epic__epic-icon-add__994",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__add",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__f2d",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__98e",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__1e4",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__3d2",
  "epic-icon-calendar": "epic__epic-icon-calendar__826",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__782",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__997",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__1e6",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__dd4",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__aa7",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__c58",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__656",
  "epic-icon-close-x": "epic__epic-icon-close-x__fee",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__c80",
  "epic-icon-confluence": "epic__epic-icon-confluence__bf3",
  "epic-icon-contact": "epic__epic-icon-contact__d32",
  "epic-icon-delete": "epic__epic-icon-delete__a2e",
  "epic-icon-edit": "epic__epic-icon-edit__9fd",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__8f6",
  "epic-icon-filter": "epic__epic-icon-filter__ba2",
  "epic-icon-github": "epic__epic-icon-github__401",
  "epic-icon-information": "epic__epic-icon-information__b23",
  "epic-icon-jira": "epic__epic-icon-jira__1b6",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__3c3",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__637",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__4ea",
  "epic-icon-preview": "epic__epic-icon-preview__310",
  "epic-icon-profile": "epic__epic-icon-profile__350",
  "epic-icon-quotes": "epic__epic-icon-quotes__cb1",
  "epic-icon-search": "epic__epic-icon-search__a95",
  "epic-icon-share": "epic__epic-icon-share__0de",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__2c3",
  "epic-icon-slack": "epic__epic-icon-slack__9dc",
  "epic-icon-steps": "epic__epic-icon-steps__9ad",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__4ac",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__196",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__57a",
  "epic-icon-warning": "epic__epic-icon-warning__118",
  "epic-font-base": "epic__epic-font-base__35d",
  navbar,
  "epic-font-base-md": "epic__epic-font-base-md__19f",
  "epic-font-marketing": "epic__epic-font-marketing__1dc",
  "epic-font-brand": "epic__epic-font-brand__8f8",
  ripple: ripple$a,
  "epic-display-base": "epic__epic-display-base__c5f",
  "epic-display-1": "epic__epic-display-1__8e5",
  "epic-display-2": "epic__epic-display-2__6d2",
  "epic-display-3": "epic__epic-display-3__112",
  "epic-display-4": "epic__epic-display-4__23a",
  "epic-display-5": "epic__epic-display-5__4ee",
  "epic-title-base": "epic__epic-title-base__628",
  "epic-title-1": "epic__epic-title-1__799",
  "epic-title-2": "epic__epic-title-2__5e4",
  "epic-title-3": "epic__epic-title-3__155",
  "epic-title-4": "epic__epic-title-4__6e7",
  "epic-title-5": "epic__epic-title-5__82d",
  "epic-title-6": "epic__epic-title-6__9ba",
  navigation: navigation$1,
  logo,
  title: title$1,
  "epic-subtitle-base": "epic__epic-subtitle-base__6f3",
  "epic-subtitle-1": "epic__epic-subtitle-1__592",
  "epic-subtitle-2": "epic__epic-subtitle-2__b04",
  "epic-subtitle-3": "epic__epic-subtitle-3__43a",
  innerNav,
  link,
  subNavWrapper,
  hover,
  subNavBg,
  subNavTitle,
  "epic-body-text-base": "epic__epic-body-text-base__0b7",
  "epic-body-text-1": "epic__epic-body-text-1__6e2",
  "epic-body-text-2": "epic__epic-body-text-2__804",
  "epic-body-text": "epic__epic-body-text__6a0",
  "epic-body-text-3": "epic__epic-body-text-3__b1d",
  subNavContent,
  subNavColumn,
  "epic-legal-text": "epic__epic-legal-text__e79",
  "epic-label-text": "epic__epic-label-text__3d8",
  "epic-button-base": "epic__epic-button-base__7c2",
  "epic-button-1": "epic__epic-button-1__278",
  "epic-button-2": "epic__epic-button-2__ad7",
  "epic-button-3": "epic__epic-button-3__559",
  inverse: inverse$1,
  asideContainer,
  asideSidePad,
  searchContainer,
  fixed,
  nikeLogo,
  underline,
  active: active$2,
  subNavBgOverlay,
  subNavExpand,
  subNavMega
};
const keyGen = (...args) => args.join("-").trim();
const ExternalNavLink = ({
  path,
  children,
  className = null
}) => /* @__PURE__ */ jsx$1("a", {
  href: path,
  className,
  target: "_blank",
  rel: "noopener noreferrer",
  children
});
function NavBarLinks({
  routes,
  RouterLink,
  activeRoute,
  fixed: fixed2,
  menuType
}) {
  const [focusedLink, setFocusedLink] = useState("");
  return routes.map(({
    path,
    text,
    external,
    exact,
    title: title2,
    menuItems,
    className,
    secondColumnItems
  }) => {
    const uniqueId2 = keyGen(text, path);
    let activeClass = "";
    if (exact) {
      activeClass = activeRoute === path ? styles$9.active : "";
    } else if (path) {
      const pathName = path.split("?");
      activeClass = activeRoute.includes(pathName[0]) ? styles$9.active : "";
    }
    const handleFocus = () => {
      setFocusedLink(uniqueId2);
    };
    const handleFocusClear = () => {
      setFocusedLink("");
    };
    const isExternal = !!external;
    const isSubMenu = !!menuType && !!menuItems;
    const isDefault = !isExternal && !isSubMenu;
    return /* @__PURE__ */ jsxs(ChildrenFocusBlur, {
      onFocus: handleFocus,
      onBlur: handleFocusClear,
      onClick: handleFocusClear,
      children: [isExternal && /* @__PURE__ */ jsx$1(ExternalNavLink, {
        path,
        className,
        children: /* @__PURE__ */ jsx$1("span", {
          className: styles$9.link,
          children: text
        })
      }), isSubMenu && /* @__PURE__ */ jsx$1("div", {
        className: classnames$2({
          [styles$9.subNavMega]: menuType === "mega"
        }, {
          [styles$9.subNavExpand]: menuType === "expand"
        }),
        children: /* @__PURE__ */ jsx$1(SubNav, {
          title: title2,
          menuItems,
          RouterLink,
          fixed: fixed2,
          isMega: menuType === "mega",
          isParentFocused: focusedLink === uniqueId2,
          secondColumnItems,
          children: /* @__PURE__ */ jsx$1(RouterLink, {
            href: path,
            className,
            children: /* @__PURE__ */ jsx$1("span", {
              className: classnames$2(styles$9.underline, styles$9.link, activeClass),
              children: text
            })
          })
        })
      }), isDefault && /* @__PURE__ */ jsx$1(RouterLink, {
        href: path,
        className,
        children: /* @__PURE__ */ jsx$1("span", {
          className: classnames$2(styles$9.underline, styles$9.link, activeClass),
          children: text
        })
      })]
    }, uniqueId2);
  });
}
function SubNav({
  title: title2,
  menuItems,
  RouterLink,
  children,
  fixed: fixed2,
  isMega,
  isParentFocused,
  secondColumnItems
}) {
  const [scrollOffset, setScrollOffset] = useState(0);
  const [subNavOpen, setSubNavOpen] = useState(false);
  const handleOpenSubNav = () => {
    setSubNavOpen(true);
    if (!fixed2) {
      document.body.style.overflowY = "hidden";
      setScrollOffset(window.scrollY);
    }
  };
  const handleCloseSubNav = () => {
    setSubNavOpen(false);
    if (!fixed2) {
      document.body.style.overflowY = "auto";
    }
  };
  const groupedMenuItems = [];
  for (let i2 = 0; i2 < menuItems.length; i2 += 10) {
    groupedMenuItems.push(menuItems.slice(i2, i2 + 10));
  }
  return /* @__PURE__ */ jsxs("div", {
    className: classnames$2(styles$9.subNavWrapper, {
      [styles$9.hover]: subNavOpen || isParentFocused
    }),
    onMouseEnter: handleOpenSubNav,
    onMouseLeave: handleCloseSubNav,
    onClick: handleCloseSubNav,
    children: [children, /* @__PURE__ */ jsx$1("div", {
      className: classnames$2(styles$9.subNavBg, {
        [styles$9.subNavBgOverlay]: isMega
      }),
      children: /* @__PURE__ */ jsx$1("div", {
        className: classnames$2({
          [styles$9.subNavBg]: isMega
        }),
        style: {
          transform: `translateY(-${scrollOffset}px)`
        },
        children: /* @__PURE__ */ jsxs("div", {
          className: styles$9.subNavContent,
          children: [groupedMenuItems.map((group, i2) => {
            return /* @__PURE__ */ jsxs("div", {
              className: styles$9.subNavColumn,
              children: [title2 && /* @__PURE__ */ jsx$1("div", {
                className: styles$9.subNavTitle,
                children: i2 === 0 && /* @__PURE__ */ jsx$1("h4", {
                  children: title2
                })
              }), group.map(({
                text,
                path
              }) => {
                return /* @__PURE__ */ jsx$1(RouterLink, {
                  className: styles$9.subNavLink,
                  href: path,
                  children: /* @__PURE__ */ jsx$1("span", {
                    children: text
                  })
                }, keyGen(text, path));
              })]
            }, i2);
          }), secondColumnItems && /* @__PURE__ */ jsx$1("div", {
            className: styles$9.subNavColumn,
            children: secondColumnItems.map(({
              isTitle,
              text,
              path
            }, index2) => {
              return /* @__PURE__ */ jsx$1(Fragment$1, {
                children: isTitle ? /* @__PURE__ */ jsx$1("div", {
                  className: styles$9.subNavTitle,
                  children: /* @__PURE__ */ jsx$1("h4", {
                    children: text
                  })
                }, keyGen(text, path)) : /* @__PURE__ */ jsx$1(RouterLink, {
                  className: styles$9.subNavLink,
                  href: path,
                  children: /* @__PURE__ */ jsx$1("span", {
                    children: text
                  })
                }, keyGen(text, path))
              }, index2);
            })
          })]
        })
      })
    })]
  });
}
function NavBar({
  aside,
  className,
  fixed: fixed2,
  inverse: inverse2,
  logo: logo2,
  menuType,
  name,
  onSearch,
  rootPath,
  RouterLink,
  routes,
  searchCleanup,
  searchPlaceholder
}) {
  const fullPath = `${window.location.pathname}${window.location.search}`;
  const [activeRoute, setActiveRoute] = useState(fullPath);
  const [searchValue, setSearchValue] = useState("");
  useEffect(() => {
    setActiveRoute(fullPath);
  }, [window.location.pathname]);
  const searchInputRef = useRef();
  const navClassName = classnames$2(styles$9.navbar, className, {
    [styles$9.inverse]: inverse2
  });
  function NavLink(props) {
    let Component2 = RouterLink || DefaultLink;
    return /* @__PURE__ */ jsx$1(Component2, {
      ...props
    });
  }
  function handleSearch() {
    onSearch == null ? void 0 : onSearch(searchValue);
    if (searchCleanup) {
      setSearchValue("");
      searchInputRef.current.value = "";
    }
  }
  function handleChange(e2) {
    var _a;
    setSearchValue(((_a = e2 == null ? void 0 : e2.currentTarget) == null ? void 0 : _a.value) || "");
  }
  return /* @__PURE__ */ jsx$1("div", {
    className: classnames$2(navClassName, {
      [styles$9.fixed]: fixed2
    }),
    children: /* @__PURE__ */ jsxs("nav", {
      className: styles$9.navigation,
      children: [/* @__PURE__ */ jsxs(NavLink, {
        className: styles$9.logo,
        href: rootPath,
        "aria-label": "home link",
        children: [logo2 && (typeof logo2 === "string" ? /* @__PURE__ */ jsx$1("img", {
          className,
          src: logo2,
          alt: `${name} logo`
        }) : logo2), name ? /* @__PURE__ */ jsx$1("span", {
          className: styles$9.title,
          children: name
        }) : null]
      }), /* @__PURE__ */ jsx$1("div", {
        className: styles$9.innerNav,
        children: /* @__PURE__ */ jsx$1(NavBarLinks, {
          activeRoute,
          fixed: fixed2,
          menuType,
          rootPath,
          RouterLink: NavLink,
          routes
        })
      }), (onSearch || aside) && /* @__PURE__ */ jsxs("div", {
        className: styles$9.asideContainer,
        children: [onSearch && /* @__PURE__ */ jsx$1("div", {
          className: classnames$2(styles$9.searchContainer, {
            [styles$9.asideSidePad]: !aside
          }),
          children: /* @__PURE__ */ jsx$1(ActionInput, {
            ariaLabel: "Search",
            onAction: handleSearch,
            onChange: handleChange,
            placeholder: searchPlaceholder,
            submitOnEnter: true,
            ref: searchInputRef
          })
        }), aside && /* @__PURE__ */ jsx$1("div", {
          children: aside
        })]
      })]
    })
  });
}
NavBar.propTypes = {
  name: PropTypes$1.string,
  logo: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.node]),
  routes: PropTypes$1.arrayOf(PropTypes$1.shape({
    path: PropTypes$1.string,
    text: PropTypes$1.string.isRequired,
    search: PropTypes$1.string,
    exact: PropTypes$1.bool,
    external: PropTypes$1.bool,
    className: PropTypes$1.string,
    title: PropTypes$1.string,
    menuItems: PropTypes$1.arrayOf(PropTypes$1.shape({
      text: PropTypes$1.string.isRequired,
      path: PropTypes$1.string.isRequired
    })),
    secondColumnItems: PropTypes$1.arrayOf(PropTypes$1.shape({
      isTitle: PropTypes$1.bool.isRequired,
      text: PropTypes$1.string.isRequired,
      path: PropTypes$1.string.isRequired
    }))
  })).isRequired,
  rootPath: PropTypes$1.string,
  className: PropTypes$1.string,
  RouterLink: PropTypes$1.elementType,
  aside: PropTypes$1.object,
  inverse: PropTypes$1.bool,
  onSearch: PropTypes$1.func,
  searchPlaceholder: PropTypes$1.string,
  searchCleanup: PropTypes$1.bool,
  fixed: PropTypes$1.bool,
  menuType: PropTypes$1.oneOf([false, "expand", "mega"])
};
NavBar.defaultProps = {
  menuType: "mega",
  rootPath: "/",
  routes: [],
  searchCleanup: true,
  searchPlaceholder: "Search"
};
const icon$9 = "epic__icon__ac8";
const ripple$9 = "epic__ripple__03f";
const overlayContainer = "epic__overlayContainer__c46";
const show = "epic__show__c80";
const overlay = "epic__overlay__8f4";
var styles$8 = {
  icon: icon$9,
  "epic-icon": "epic__epic-icon__3be",
  "epic-icon-add": "epic__epic-icon-add__213",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__d4c",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__0e6",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__660",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__eef",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__049",
  "epic-icon-calendar": "epic__epic-icon-calendar__657",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__526",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__cea",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__e62",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__785",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__ff5",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__c47",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__dac",
  "epic-icon-close-x": "epic__epic-icon-close-x__799",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__cbd",
  "epic-icon-confluence": "epic__epic-icon-confluence__bc5",
  "epic-icon-contact": "epic__epic-icon-contact__244",
  "epic-icon-delete": "epic__epic-icon-delete__a75",
  "epic-icon-edit": "epic__epic-icon-edit__0ce",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__ce9",
  "epic-icon-filter": "epic__epic-icon-filter__e7f",
  "epic-icon-github": "epic__epic-icon-github__27e",
  "epic-icon-information": "epic__epic-icon-information__95d",
  "epic-icon-jira": "epic__epic-icon-jira__951",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__095",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__e0d",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__e71",
  "epic-icon-preview": "epic__epic-icon-preview__f08",
  "epic-icon-profile": "epic__epic-icon-profile__194",
  "epic-icon-quotes": "epic__epic-icon-quotes__478",
  "epic-icon-search": "epic__epic-icon-search__269",
  "epic-icon-share": "epic__epic-icon-share__33d",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__91b",
  "epic-icon-slack": "epic__epic-icon-slack__515",
  "epic-icon-steps": "epic__epic-icon-steps__113",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__693",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__4ec",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__b6e",
  "epic-icon-warning": "epic__epic-icon-warning__441",
  "epic-font-base": "epic__epic-font-base__d31",
  "epic-font-base-md": "epic__epic-font-base-md__348",
  "epic-font-marketing": "epic__epic-font-marketing__d78",
  "epic-font-brand": "epic__epic-font-brand__157",
  ripple: ripple$9,
  overlayContainer,
  show,
  overlay
};
const Overlay$1 = ({
  show: show2,
  onClick,
  className,
  children
}) => /* @__PURE__ */ jsxs("div", {
  className: `${styles$8.overlayContainer}  ${className || ""} ${show2 ? styles$8.show : ""}`,
  children: [/* @__PURE__ */ jsx$1("div", {
    className: styles$8.overlay,
    onClick
  }), children]
});
Overlay$1.propTypes = {
  show: PropTypes$1.bool.isRequired,
  onClick: PropTypes$1.func,
  className: PropTypes$1.string
};
const icon$8 = "epic__icon__e36";
const ripple$8 = "epic__ripple__cf4";
const stepFormProgress = "epic__stepFormProgress__dfc";
const item = "epic__item__62f";
const itemTitleDefault = "epic__itemTitleDefault__623";
const itemTitleHighlighted = "epic__itemTitleHighlighted__6a9";
const barContainer = "epic__barContainer__cd7";
const bar = "epic__bar__119";
const barDefault = "epic__barDefault__057";
const barHighlighted = "epic__barHighlighted__866";
var styles$7 = {
  icon: icon$8,
  "epic-icon": "epic__epic-icon__f21",
  "epic-icon-add": "epic__epic-icon-add__f0c",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__4c1",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__710",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__407",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__027",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__048",
  "epic-icon-calendar": "epic__epic-icon-calendar__71e",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__e40",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__33a",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__597",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__1b0",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__9dc",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__8df",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__f7f",
  "epic-icon-close-x": "epic__epic-icon-close-x__46a",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__dc2",
  "epic-icon-confluence": "epic__epic-icon-confluence__63b",
  "epic-icon-contact": "epic__epic-icon-contact__beb",
  "epic-icon-delete": "epic__epic-icon-delete__2f9",
  "epic-icon-edit": "epic__epic-icon-edit__e6c",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__f67",
  "epic-icon-filter": "epic__epic-icon-filter__fb1",
  "epic-icon-github": "epic__epic-icon-github__725",
  "epic-icon-information": "epic__epic-icon-information__6ac",
  "epic-icon-jira": "epic__epic-icon-jira__a3e",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__86f",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__3d5",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__e14",
  "epic-icon-preview": "epic__epic-icon-preview__55c",
  "epic-icon-profile": "epic__epic-icon-profile__cba",
  "epic-icon-quotes": "epic__epic-icon-quotes__bcc",
  "epic-icon-search": "epic__epic-icon-search__dc7",
  "epic-icon-share": "epic__epic-icon-share__b62",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__d12",
  "epic-icon-slack": "epic__epic-icon-slack__19b",
  "epic-icon-steps": "epic__epic-icon-steps__819",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__68e",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__187",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__66c",
  "epic-icon-warning": "epic__epic-icon-warning__7af",
  "epic-font-base": "epic__epic-font-base__ff4",
  "epic-font-base-md": "epic__epic-font-base-md__472",
  "epic-font-marketing": "epic__epic-font-marketing__098",
  "epic-font-brand": "epic__epic-font-brand__ace",
  ripple: ripple$8,
  stepFormProgress,
  item,
  itemTitleDefault,
  itemTitleHighlighted,
  barContainer,
  bar,
  barDefault,
  barHighlighted
};
const StepFormProgressBars = ({
  steps,
  activeStepIndex
}) => /* @__PURE__ */ jsx$1("div", {
  className: styles$7.stepFormProgress,
  children: steps.map((step, index2) => {
    const isActiveStep = activeStepIndex >= index2;
    return /* @__PURE__ */ jsxs("div", {
      className: styles$7.item,
      children: [/* @__PURE__ */ jsx$1("div", {
        className: styles$7.barContainer,
        children: /* @__PURE__ */ jsx$1("div", {
          className: classnames$2(styles$7.bar, {
            [styles$7.barHighlighted]: isActiveStep,
            [styles$7.barDefault]: !isActiveStep
          })
        })
      }), /* @__PURE__ */ jsx$1("span", {
        className: classnames$2({
          [styles$7.itemTitleHighlighted]: isActiveStep,
          [styles$7.itemTitleDefault]: !isActiveStep
        }),
        children: step.title
      })]
    }, step.title);
  })
});
StepFormProgressBars.propTypes = {
  steps: PropTypes$1.arrayOf(PropTypes$1.shape({
    title: PropTypes$1.string.isRequired
  })).isRequired,
  activeStepIndex: PropTypes$1.number
};
const icon$7 = "epic__icon__884";
const ripple$7 = "epic__ripple__e56";
const input$1 = "epic__input__b7f";
const component$1 = "epic__component__129";
const button$1 = "epic__button__ffa";
const clearButton$1 = "epic__clearButton__ef9";
const closeHidden$1 = "epic__closeHidden__104";
const buttonRight$1 = "epic__buttonRight__920";
const inputRight$1 = "epic__inputRight__983";
const select$1 = "epic__select__ebf";
const withHorizontalMargin$1 = "epic__withHorizontalMargin__021";
var stylesDefault = {
  icon: icon$7,
  "epic-icon": "epic__epic-icon__4b6",
  "epic-icon-add": "epic__epic-icon-add__745",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__891",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__878",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__6ed",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__83e",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__514",
  "epic-icon-calendar": "epic__epic-icon-calendar__bcb",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__9c0",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__ed7",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__bf4",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__ace",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__8b9",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__9ce",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__937",
  "epic-icon-close-x": "epic__epic-icon-close-x__ac9",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__4c1",
  "epic-icon-confluence": "epic__epic-icon-confluence__64d",
  "epic-icon-contact": "epic__epic-icon-contact__948",
  "epic-icon-delete": "epic__epic-icon-delete__273",
  "epic-icon-edit": "epic__epic-icon-edit__054",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__2e3",
  "epic-icon-filter": "epic__epic-icon-filter__643",
  "epic-icon-github": "epic__epic-icon-github__9fa",
  "epic-icon-information": "epic__epic-icon-information__e75",
  "epic-icon-jira": "epic__epic-icon-jira__02b",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__079",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__eb7",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__9bd",
  "epic-icon-preview": "epic__epic-icon-preview__50e",
  "epic-icon-profile": "epic__epic-icon-profile__45a",
  "epic-icon-quotes": "epic__epic-icon-quotes__c19",
  "epic-icon-search": "epic__epic-icon-search__83b",
  "epic-icon-share": "epic__epic-icon-share__881",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__216",
  "epic-icon-slack": "epic__epic-icon-slack__ce7",
  "epic-icon-steps": "epic__epic-icon-steps__5c4",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__d07",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__14f",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__f33",
  "epic-icon-warning": "epic__epic-icon-warning__da6",
  "epic-font-base": "epic__epic-font-base__39e",
  "epic-font-base-md": "epic__epic-font-base-md__f61",
  "epic-font-marketing": "epic__epic-font-marketing__78f",
  "epic-font-brand": "epic__epic-font-brand__f85",
  ripple: ripple$7,
  "epic-display-base": "epic__epic-display-base__202",
  "epic-display-1": "epic__epic-display-1__2b8",
  "epic-display-2": "epic__epic-display-2__137",
  "epic-display-3": "epic__epic-display-3__89c",
  "epic-display-4": "epic__epic-display-4__a6b",
  "epic-display-5": "epic__epic-display-5__932",
  "epic-title-base": "epic__epic-title-base__e40",
  "epic-title-1": "epic__epic-title-1__ac0",
  "epic-title-2": "epic__epic-title-2__5bc",
  "epic-title-3": "epic__epic-title-3__191",
  "epic-title-4": "epic__epic-title-4__3dd",
  "epic-title-5": "epic__epic-title-5__979",
  "epic-title-6": "epic__epic-title-6__acd",
  "epic-subtitle-base": "epic__epic-subtitle-base__7a1",
  "epic-subtitle-1": "epic__epic-subtitle-1__442",
  "epic-subtitle-2": "epic__epic-subtitle-2__7da",
  "epic-subtitle-3": "epic__epic-subtitle-3__3df",
  "default": "epic__default__281",
  input: input$1,
  "epic-body-text-base": "epic__epic-body-text-base__921",
  "epic-body-text-1": "epic__epic-body-text-1__1a1",
  "epic-body-text-2": "epic__epic-body-text-2__b2f",
  "epic-body-text": "epic__epic-body-text__6b0",
  "epic-body-text-3": "epic__epic-body-text-3__d50",
  "epic-legal-text": "epic__epic-legal-text__139",
  "epic-label-text": "epic__epic-label-text__959",
  "epic-button-base": "epic__epic-button-base__ddf",
  "epic-button-1": "epic__epic-button-1__1a0",
  "epic-button-2": "epic__epic-button-2__427",
  "epic-button-3": "epic__epic-button-3__8ef",
  component: component$1,
  button: button$1,
  clearButton: clearButton$1,
  closeHidden: closeHidden$1,
  buttonRight: buttonRight$1,
  inputRight: inputRight$1,
  select: select$1,
  withHorizontalMargin: withHorizontalMargin$1
};
const icon$6 = "epic__icon__28e";
const ripple$6 = "epic__ripple__3ed";
const input = "epic__input__0ac";
const component = "epic__component__d22";
const button = "epic__button__583";
const clearButton = "epic__clearButton__a9f";
const closeHidden = "epic__closeHidden__4af";
const buttonRight = "epic__buttonRight__1ce";
const inputRight = "epic__inputRight__42e";
const select = "epic__select__9d5";
const withHorizontalMargin = "epic__withHorizontalMargin__10a";
const inverted = "epic__inverted__f45";
const dropdownOpen = "epic__dropdownOpen__e5c";
const withSelect = "epic__withSelect__af0";
const buttonLeft = "epic__buttonLeft__6d1";
const inputLeft = "epic__inputLeft__fe2";
const large = "epic__large__849";
const withBorder = "epic__withBorder__11b";
const hasErrors = "epic__hasErrors__cd0";
const selected$1 = "epic__selected__861";
const dropdownList = "epic__dropdownList__e48";
var stylesInverse = {
  icon: icon$6,
  "epic-icon": "epic__epic-icon__190",
  "epic-icon-add": "epic__epic-icon-add__ddb",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__3e6",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__285",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__6d5",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__5b1",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__1a2",
  "epic-icon-calendar": "epic__epic-icon-calendar__633",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__9ab",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__5e5",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__cad",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__091",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__f50",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__540",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__3fc",
  "epic-icon-close-x": "epic__epic-icon-close-x__45c",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__cff",
  "epic-icon-confluence": "epic__epic-icon-confluence__8fa",
  "epic-icon-contact": "epic__epic-icon-contact__1b8",
  "epic-icon-delete": "epic__epic-icon-delete__2f7",
  "epic-icon-edit": "epic__epic-icon-edit__4f0",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__354",
  "epic-icon-filter": "epic__epic-icon-filter__a8b",
  "epic-icon-github": "epic__epic-icon-github__b00",
  "epic-icon-information": "epic__epic-icon-information__69f",
  "epic-icon-jira": "epic__epic-icon-jira__847",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__ba1",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__961",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__ead",
  "epic-icon-preview": "epic__epic-icon-preview__257",
  "epic-icon-profile": "epic__epic-icon-profile__325",
  "epic-icon-quotes": "epic__epic-icon-quotes__442",
  "epic-icon-search": "epic__epic-icon-search__0ef",
  "epic-icon-share": "epic__epic-icon-share__843",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__5fe",
  "epic-icon-slack": "epic__epic-icon-slack__fbd",
  "epic-icon-steps": "epic__epic-icon-steps__e35",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__16b",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__ee8",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__702",
  "epic-icon-warning": "epic__epic-icon-warning__0d6",
  "epic-font-base": "epic__epic-font-base__648",
  "epic-font-base-md": "epic__epic-font-base-md__eb7",
  "epic-font-marketing": "epic__epic-font-marketing__ace",
  "epic-font-brand": "epic__epic-font-brand__04c",
  ripple: ripple$6,
  "epic-display-base": "epic__epic-display-base__a9d",
  "epic-display-1": "epic__epic-display-1__533",
  "epic-display-2": "epic__epic-display-2__f96",
  "epic-display-3": "epic__epic-display-3__77b",
  "epic-display-4": "epic__epic-display-4__c56",
  "epic-display-5": "epic__epic-display-5__88e",
  "epic-title-base": "epic__epic-title-base__43b",
  "epic-title-1": "epic__epic-title-1__fe2",
  "epic-title-2": "epic__epic-title-2__1d3",
  "epic-title-3": "epic__epic-title-3__9ef",
  "epic-title-4": "epic__epic-title-4__037",
  "epic-title-5": "epic__epic-title-5__7e3",
  "epic-title-6": "epic__epic-title-6__db5",
  "epic-subtitle-base": "epic__epic-subtitle-base__bbc",
  "epic-subtitle-1": "epic__epic-subtitle-1__d27",
  "epic-subtitle-2": "epic__epic-subtitle-2__b82",
  "epic-subtitle-3": "epic__epic-subtitle-3__452",
  "default": "epic__default__e97",
  input,
  "epic-body-text-base": "epic__epic-body-text-base__450",
  "epic-body-text-1": "epic__epic-body-text-1__cf2",
  "epic-body-text-2": "epic__epic-body-text-2__2b3",
  "epic-body-text": "epic__epic-body-text__699",
  "epic-body-text-3": "epic__epic-body-text-3__6df",
  "epic-legal-text": "epic__epic-legal-text__1c3",
  "epic-label-text": "epic__epic-label-text__7aa",
  "epic-button-base": "epic__epic-button-base__16a",
  "epic-button-1": "epic__epic-button-1__a21",
  "epic-button-2": "epic__epic-button-2__fc6",
  "epic-button-3": "epic__epic-button-3__14b",
  component,
  button,
  clearButton,
  closeHidden,
  buttonRight,
  inputRight,
  select,
  withHorizontalMargin,
  inverted,
  dropdownOpen,
  withSelect,
  buttonLeft,
  inputLeft,
  large,
  withBorder,
  hasErrors,
  selected: selected$1,
  dropdownList
};
const styles$6 = {
  ...stylesDefault,
  ...stylesInverse
};
const ActionInput = forwardRef(function ActionInput2({
  className,
  type,
  inverse: inverse2,
  onAction,
  large: large2,
  rightButton,
  ariaLabel,
  icon: icon2,
  iconSize,
  isPending,
  selectProps,
  value,
  onClear,
  dropdownItems,
  onListItemClick,
  dropdownIsOpen,
  renderListItem,
  submitOnEnter,
  ...other
}, ref) {
  const componentClassName = classnames$2(className, styles$6.component, inverse2 || selectProps || dropdownItems.length ? styles$6.inverted : styles$6.default, {
    [styles$6.large]: large2,
    [styles$6.dropdownOpen]: dropdownIsOpen
  }, "EPIC-action-input");
  const buttonClassName = classnames$2(styles$6.button, rightButton ? styles$6.buttonRight : styles$6.buttonLeft);
  const IconButtonClassName = classnames$2(styles$6.clearButton, styles$6.button, {
    [styles$6.closeHidden]: !value,
    [styles$6.buttonRight]: !rightButton
  });
  const iconClassName = `${large2 ? styles$6.largeIcon : ""}`;
  const inputClassName = classnames$2(styles$6.input, {
    [styles$6.inputRight]: rightButton,
    [styles$6.inputLeft]: !rightButton,
    [styles$6.withSelect]: selectProps,
    [styles$6.dropdownOpen]: dropdownIsOpen
  });
  function onResultClick(result, i2) {
    if (typeof onResultClick === "function") {
      onListItemClick(result, i2);
    }
  }
  function fireOnAction(e2) {
    if (typeof onAction === "function") {
      onAction(e2);
    }
  }
  function handleKeypress({
    key
  }) {
    if (key === "Enter" && submitOnEnter) {
      onAction == null ? void 0 : onAction();
    }
  }
  function renderDefaultListItem(result, i2) {
    return dropdownItems.length === 0 ? /* @__PURE__ */ jsx$1("li", {
      children: "No results"
    }) : /* @__PURE__ */ jsx$1("li", {
      onClick: () => onResultClick(result, i2),
      children: result
    }, result);
  }
  return /* @__PURE__ */ jsxs("div", {
    className: componentClassName,
    children: [/* @__PURE__ */ jsx$1("input", {
      ...other,
      value,
      className: inputClassName,
      "aria-label": `${ariaLabel} field`,
      type: "text",
      ref,
      onKeyPress: handleKeypress
    }), onClear && /* @__PURE__ */ jsx$1(IconButton, {
      size: "small",
      onClick: onClear,
      icon: "Close",
      variant: "ghost",
      className: IconButtonClassName
    }), /* @__PURE__ */ jsx$1("button", {
      "aria-label": `${ariaLabel} action`,
      type,
      className: buttonClassName,
      onClick: fireOnAction,
      children: isPending ? /* @__PURE__ */ jsx$1(Spinner, {
        className: styles$6.withHorizontalMargin
      }) : /* @__PURE__ */ jsx$1(Icon, {
        type: icon2,
        size: iconSize,
        className: iconClassName
      })
    }), selectProps && /* @__PURE__ */ jsx$1(Select, {
      formatOptionLabel: ({
        value: value2,
        label
      }, props) => {
        return selectProps.value.value !== value2 ? label : /* @__PURE__ */ jsxs("div", {
          className: props.context === "menu" ? styles$6.selected : "",
          children: [props.context === "menu" && /* @__PURE__ */ jsx$1(Icon, {
            type: "Check",
            size: "s"
          }), label]
        });
      },
      ...selectProps,
      classNamePrefix: "ActionInput",
      className: classnames$2(styles$6.select, selectProps.className)
    }), dropdownIsOpen && /* @__PURE__ */ jsx$1("ul", {
      className: classnames$2(styles$6.dropdownList, selectProps ? styles$6.withSelect : ""),
      children: dropdownItems.map((result, i2) => {
        return renderListItem ? renderListItem(result, i2) : renderDefaultListItem(result, i2);
      })
    })]
  });
});
ActionInput.propTypes = {
  className: PropTypes$1.string,
  type: PropTypes$1.string,
  onChange: PropTypes$1.func,
  onAction: PropTypes$1.func,
  onClear: PropTypes$1.func,
  renderListItem: PropTypes$1.func,
  onListItemClick: PropTypes$1.func,
  large: PropTypes$1.bool,
  rightButton: PropTypes$1.bool,
  ariaLabel: PropTypes$1.string.isRequired,
  icon: PropTypes$1.string,
  iconSize: PropTypes$1.oneOf(["s", "m", "l"]),
  isPending: PropTypes$1.bool,
  selectProps: PropTypes$1.object,
  dropdownItems: PropTypes$1.array,
  dropdownIsOpen: PropTypes$1.bool,
  submitOnEnter: PropTypes$1.bool
};
ActionInput.defaultProps = {
  className: "",
  rightButton: false,
  icon: "Search",
  iconSize: "m",
  dropdownItems: [],
  isPending: false,
  submitOnEnter: false
};
const icon$5 = "epic__icon__ee5";
const ripple$5 = "epic__ripple__25c";
const activeBtn = "epic__activeBtn__077";
const fileInput = "epic__fileInput__430";
const disabled = "epic__disabled__b4d";
const fileInputBtn = "epic__fileInputBtn__5d3";
const fileInputLabel = "epic__fileInputLabel__396";
const active$1 = "epic__active__141";
const helperTextContainer = "epic__helperTextContainer__279";
const fileInputText = "epic__fileInputText__ce5";
var styles$5 = {
  icon: icon$5,
  "epic-icon": "epic__epic-icon__955",
  "epic-icon-add": "epic__epic-icon-add__a98",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__55b",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__38a",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__088",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__222",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__550",
  "epic-icon-calendar": "epic__epic-icon-calendar__677",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__40e",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__e58",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__0ba",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__fd7",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__354",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__24f",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__714",
  "epic-icon-close-x": "epic__epic-icon-close-x__cde",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__1ad",
  "epic-icon-confluence": "epic__epic-icon-confluence__8cd",
  "epic-icon-contact": "epic__epic-icon-contact__e6f",
  "epic-icon-delete": "epic__epic-icon-delete__992",
  "epic-icon-edit": "epic__epic-icon-edit__a17",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__ead",
  "epic-icon-filter": "epic__epic-icon-filter__3fd",
  "epic-icon-github": "epic__epic-icon-github__523",
  "epic-icon-information": "epic__epic-icon-information__28f",
  "epic-icon-jira": "epic__epic-icon-jira__ac3",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__3a0",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__182",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__1d5",
  "epic-icon-preview": "epic__epic-icon-preview__f73",
  "epic-icon-profile": "epic__epic-icon-profile__a54",
  "epic-icon-quotes": "epic__epic-icon-quotes__d4a",
  "epic-icon-search": "epic__epic-icon-search__8f1",
  "epic-icon-share": "epic__epic-icon-share__5f9",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__ead",
  "epic-icon-slack": "epic__epic-icon-slack__b8c",
  "epic-icon-steps": "epic__epic-icon-steps__9be",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__954",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__bd6",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__518",
  "epic-icon-warning": "epic__epic-icon-warning__6f0",
  "epic-font-base": "epic__epic-font-base__ce3",
  "epic-font-base-md": "epic__epic-font-base-md__ab7",
  "epic-font-marketing": "epic__epic-font-marketing__8b4",
  "epic-font-brand": "epic__epic-font-brand__637",
  ripple: ripple$5,
  activeBtn,
  fileInput,
  disabled,
  fileInputBtn,
  fileInputLabel,
  active: active$1,
  helperTextContainer,
  fileInputText
};
const removeFakePath = (v2) => v2.replace("C:\\fakepath\\", "");
const imageTypes = ["image/bmp", "image/gif", "image/jpeg", "image/tiff", "image/png"];
const FileInput = forwardRef(({
  hasErrors: hasErrors2,
  accept,
  className,
  onChange: onChange2,
  onFileChange,
  onRemove,
  placeholder,
  multiple,
  ...props
}, ref) => {
  const [value, setValue] = useState("");
  const [files, setFiles] = useState([]);
  const [inputKey, setInputKey] = useState(Date.now());
  const input2 = useRef();
  const active2 = !!value;
  let classList = classnames$2(styles$5.fileInput, className);
  if (props.disabled)
    classList = classnames$2(classList, styles$5.disabled);
  if (active2)
    classList = classnames$2(classList, styles$5.active);
  if (hasErrors2)
    classList = classnames$2(classList, styles$5.hasErrors);
  const clearInput = useCallback(() => {
    setInputKey(Date.now());
    if (input2.current) {
      input2.current.focus();
      setTimeout(() => input2.current.blur(), 100);
    }
  }, []);
  const onInputChange = useCallback((e2) => {
    setFiles((files2) => {
      const newFiles = Array.from(e2.target.files).filter((file) => !files2.find((f2) => f2.name === file.name));
      return files2.concat(newFiles);
    });
    onChange2 && onChange2(e2);
    if (!multiple) {
      setValue(e2.target && e2.target.value);
    } else {
      clearInput();
    }
  }, [multiple]);
  const onInputRemove = useCallback(() => {
    clearInput();
    setValue("");
    setFiles([]);
    onRemove && onRemove();
  }, [onRemove]);
  function onDeleteFile(name) {
    setFiles(files.filter((file) => file.name !== name));
  }
  useEffect(() => {
    onFileChange && onFileChange(files);
  }, [files]);
  useImperativeHandle(ref, () => ({
    launchFileWindow: () => {
      var _a;
      (_a = input2 == null ? void 0 : input2.current) == null ? void 0 : _a.click();
    }
  }));
  const label = value ? removeFakePath(value) : placeholder;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [multiple && files && /* @__PURE__ */ jsx$1("div", {
      children: files.map((file) => {
        const thumbnail2 = imageTypes.includes(file.type) ? /* @__PURE__ */ jsx$1("img", {
          height: "auto",
          src: URL.createObjectURL(file)
        }) : /* @__PURE__ */ jsx$1(Icon, {
          type: "Hide"
        });
        return /* @__PURE__ */ jsx$1(ListItem, {
          thumbnail: thumbnail2,
          subtitle: new Date(Date.now()).toDateString(),
          name: file.name,
          iconType: "Delete",
          onAction: () => onDeleteFile(file.name)
        }, file.name);
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: classList,
      children: [/* @__PURE__ */ jsx$1("label", {
        className: styles$5.fileInputLabel,
        children: label
      }), /* @__PURE__ */ jsx$1(TextField, {
        className: styles$5.fileInputText,
        ref: input2,
        placeholder: "",
        accept: accept || "*",
        type: "file",
        hasErrors: hasErrors2,
        onChange: onInputChange,
        multiple: multiple ? "multiple" : "",
        ...props
      }, inputKey), /* @__PURE__ */ jsx$1("button", {
        type: "button",
        className: styles$5.fileInputBtn,
        onClick: active2 ? onInputRemove : void 0,
        children: /* @__PURE__ */ jsx$1(Icon, {
          type: active2 ? "Close" : "Plus",
          size: "m"
        })
      })]
    })]
  });
});
FileInput.propTypes = {
  name: PropTypes$1.string,
  accept: PropTypes$1.string,
  className: PropTypes$1.string,
  onRemove: PropTypes$1.func,
  onChange: PropTypes$1.func,
  onFileChange: PropTypes$1.func,
  disabled: PropTypes$1.bool,
  helperText: PropTypes$1.string,
  hasErrors: PropTypes$1.bool,
  errorMessage: PropTypes$1.string
};
FileInput.defaultProps = {
  className: "",
  placeholder: "Select a file",
  disabled: false
};
const icon$4 = "epic__icon__689";
const ripple$4 = "epic__ripple__b1c";
const noData = "epic__noData__beb";
const title = "epic__title__855";
const filterDropdownWrapper = "epic__filterDropdownWrapper__9d6";
const filterDropdown = "epic__filterDropdown__269";
const filterCount = "epic__filterCount__80b";
const columnFilterWrapper = "epic__columnFilterWrapper__d9f";
const columnFilterDropdown = "epic__columnFilterDropdown__d12";
const paginationControls = "epic__paginationControls__a9e";
const table = "epic__table__0f1";
const tbody = "epic__tbody__799";
const tr = "epic__tr__b50";
const td = "epic__td__5f9";
const isSorted = "epic__isSorted__283";
const filterCheckboxes = "epic__filterCheckboxes__11a";
const checkboxFilter = "epic__checkboxFilter__1b9";
const bulkSelect = "epic__bulkSelect__7af";
const selected = "epic__selected__5f3";
const subtitle = "epic__subtitle__b50";
const pageSizeSelect = "epic__pageSizeSelect__d52";
const filtersSection = "epic__filtersSection__edc";
const filtersInfo = "epic__filtersInfo__112";
const filtersClearSelected = "epic__filtersClearSelected__2a7";
const section = "epic__section__741";
const selectionSection = "epic__selectionSection__4c7";
const hideSelectionSection = "epic__hideSelectionSection__7f5";
const caretButton = "epic__caretButton__900";
const navigation = "epic__navigation__6fe";
const firstLast = "epic__firstLast__bc1";
const colorActive = "epic__colorActive__64d";
const colorDisabled = "epic__colorDisabled__b3e";
const pageNumbers = "epic__pageNumbers__a43";
const active = "epic__active__97a";
const inverse = "epic__inverse__93c";
const thead = "epic__thead__34e";
const th = "epic__th__354";
const sortAsc = "epic__sortAsc__e02";
const sortDesc = "epic__sortDesc__17d";
const sortIcon = "epic__sortIcon__197";
const compactCell = "epic__compactCell__5dd";
const expander = "epic__expander__8c8";
const canSort = "epic__canSort__2dd";
const searchFilterSection = "epic__searchFilterSection__51e";
const searchBarSectionLabel = "epic__searchBarSectionLabel__282";
const searchBarSection = "epic__searchBarSection__7e5";
const filters = "epic__filters__24b";
const filterDropdownButton = "epic__filterDropdownButton__615";
const actionInput = "epic__actionInput__ba2";
const resetDisabled = "epic__resetDisabled__bd2";
const indeterminateInput = "epic__indeterminateInput__0ba";
const columnFilterDropdownVisible = "epic__columnFilterDropdownVisible__4da";
const isLoading = "epic__isLoading__823";
const scrollTable = "epic__scrollTable__da8";
const additionalSection = "epic__additionalSection__bcc";
const withCheckboxColumn = "epic__withCheckboxColumn__121";
const bulkSelectRowActive = "epic__bulkSelectRowActive__474";
const iconButton = "epic__iconButton__8aa";
var styles$4 = {
  icon: icon$4,
  "epic-icon": "epic__epic-icon__44e",
  "epic-icon-add": "epic__epic-icon-add__e50",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__244",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__633",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__2d9",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__2e6",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__bbb",
  "epic-icon-calendar": "epic__epic-icon-calendar__cf7",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__d00",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__a0f",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__106",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__e67",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__ccf",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__936",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__4de",
  "epic-icon-close-x": "epic__epic-icon-close-x__aba",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__75f",
  "epic-icon-confluence": "epic__epic-icon-confluence__335",
  "epic-icon-contact": "epic__epic-icon-contact__53c",
  "epic-icon-delete": "epic__epic-icon-delete__f0f",
  "epic-icon-edit": "epic__epic-icon-edit__dc3",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__bec",
  "epic-icon-filter": "epic__epic-icon-filter__78b",
  "epic-icon-github": "epic__epic-icon-github__bab",
  "epic-icon-information": "epic__epic-icon-information__4b0",
  "epic-icon-jira": "epic__epic-icon-jira__186",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__db5",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__c50",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__10e",
  "epic-icon-preview": "epic__epic-icon-preview__fa5",
  "epic-icon-profile": "epic__epic-icon-profile__72a",
  "epic-icon-quotes": "epic__epic-icon-quotes__879",
  "epic-icon-search": "epic__epic-icon-search__101",
  "epic-icon-share": "epic__epic-icon-share__0a0",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__0fd",
  "epic-icon-slack": "epic__epic-icon-slack__aba",
  "epic-icon-steps": "epic__epic-icon-steps__941",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__629",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__867",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__720",
  "epic-icon-warning": "epic__epic-icon-warning__949",
  "epic-font-base": "epic__epic-font-base__403",
  "epic-font-base-md": "epic__epic-font-base-md__50b",
  "epic-font-marketing": "epic__epic-font-marketing__884",
  "epic-font-brand": "epic__epic-font-brand__996",
  ripple: ripple$4,
  "epic-display-base": "epic__epic-display-base__26a",
  "epic-display-1": "epic__epic-display-1__918",
  "epic-display-2": "epic__epic-display-2__694",
  "epic-display-3": "epic__epic-display-3__17f",
  "epic-display-4": "epic__epic-display-4__68a",
  "epic-display-5": "epic__epic-display-5__15b",
  "epic-title-base": "epic__epic-title-base__ee1",
  "epic-title-1": "epic__epic-title-1__9dd",
  "epic-title-2": "epic__epic-title-2__574",
  "epic-title-3": "epic__epic-title-3__7b5",
  "epic-title-4": "epic__epic-title-4__d27",
  "epic-title-5": "epic__epic-title-5__a38",
  "epic-title-6": "epic__epic-title-6__976",
  noData,
  title,
  filterDropdownWrapper,
  filterDropdown,
  filterCount,
  columnFilterWrapper,
  columnFilterDropdown,
  "epic-subtitle-base": "epic__epic-subtitle-base__6a0",
  "epic-subtitle-1": "epic__epic-subtitle-1__32f",
  "epic-subtitle-2": "epic__epic-subtitle-2__662",
  "epic-subtitle-3": "epic__epic-subtitle-3__149",
  paginationControls,
  table,
  tbody,
  tr,
  td,
  isSorted,
  filterCheckboxes,
  checkboxFilter,
  bulkSelect,
  selected,
  "epic-body-text-base": "epic__epic-body-text-base__f11",
  "epic-body-text-1": "epic__epic-body-text-1__3db",
  "epic-body-text-2": "epic__epic-body-text-2__9ae",
  "epic-body-text": "epic__epic-body-text__31c",
  "epic-body-text-3": "epic__epic-body-text-3__366",
  subtitle,
  "epic-legal-text": "epic__epic-legal-text__e27",
  "epic-label-text": "epic__epic-label-text__139",
  "epic-button-base": "epic__epic-button-base__bfb",
  "epic-button-1": "epic__epic-button-1__0e5",
  "epic-button-2": "epic__epic-button-2__c0f",
  "epic-button-3": "epic__epic-button-3__8c3",
  pageSizeSelect,
  filtersSection,
  filtersInfo,
  filtersClearSelected,
  section,
  selectionSection,
  hideSelectionSection,
  caretButton,
  navigation,
  firstLast,
  colorActive,
  colorDisabled,
  pageNumbers,
  active,
  inverse,
  thead,
  th,
  sortAsc,
  sortDesc,
  sortIcon,
  compactCell,
  expander,
  canSort,
  searchFilterSection,
  searchBarSectionLabel,
  searchBarSection,
  filters,
  filterDropdownButton,
  actionInput,
  resetDisabled,
  indeterminateInput,
  columnFilterDropdownVisible,
  isLoading,
  scrollTable,
  additionalSection,
  withCheckboxColumn,
  bulkSelectRowActive,
  iconButton
};
function SearchBar({
  globalFilter,
  setGlobalFilter,
  searchBarPlaceholder,
  searchBarLabel,
  maxLength
}) {
  return /* @__PURE__ */ jsx$1(GlobalFilter, {
    filter: globalFilter,
    setFilter: setGlobalFilter,
    placeholderText: searchBarPlaceholder,
    label: searchBarLabel,
    maxLength
  });
}
function FilterButton({
  filterCount: filterCount2,
  handleFilterBtnClick
}) {
  return /* @__PURE__ */ jsx$1(Button$1, {
    afterSlot: /* @__PURE__ */ jsx$1(Filter, {}),
    onClick: handleFilterBtnClick,
    children: `Filters${filterCount2 > 0 ? ` ${filterCount2}` : ""}`
  });
}
function FilterSection({
  showAllFilters,
  setShowAllFilters,
  filters: filters2,
  selectedFilters,
  handleChangeSelectedFilters,
  handleSelectAllFilters,
  handleClearSelectedFilters,
  filterFilterQueries,
  handleUpdateFilterFilterQuery
}) {
  const firstLevelNum = 5;
  const visibleFilters = showAllFilters ? filters2 : filters2.slice(0, firstLevelNum);
  return /* @__PURE__ */ jsxs("div", {
    className: styles$4.filtersSection,
    children: [/* @__PURE__ */ jsx$1("div", {
      className: styles$4.filtersInfo,
      children: /* @__PURE__ */ jsx$1("p", {
        children: /* @__PURE__ */ jsx$1("a", {
          onClick: () => handleClearSelectedFilters(),
          children: "Clear Filters"
        })
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: styles$4.filters,
      children: [visibleFilters.map((v2) => {
        const filterGroupName = v2.name;
        const filterGroup = v2.accessor;
        const selected2 = selectedFilters[filterGroup] || [];
        const selectedCount = selected2.length;
        const filterFilterQuery = filterFilterQueries[filterGroup] || "";
        return /* @__PURE__ */ jsx$1(FilterDropdown, {
          dropdownFilters: v2,
          selected: selected2,
          selectedCount,
          handleChangeSelectedFilters,
          handleSelectAllFilters,
          handleClearSelectedFilters,
          filterFilterQuery,
          handleUpdateFilterFilterQuery,
          filterGroup,
          filterGroupName,
          children: /* @__PURE__ */ jsxs(Button$1, {
            inverse: true,
            className: styles$4.filterDropdownButton,
            children: [`${filterGroupName}${selectedCount > 0 ? ` (${selectedCount})` : ""}`, /* @__PURE__ */ jsx$1(Icon, {
              type: "CaretDown",
              size: "m"
            })]
          })
        }, v2.accessor);
      }), filters2.length > firstLevelNum && /* @__PURE__ */ jsx$1(Button$1, {
        onClick: () => setShowAllFilters(!showAllFilters),
        inverse: true,
        children: `Show ${filters2.length - firstLevelNum} ${showAllFilters ? "Less" : "More"}`
      })]
    })]
  });
}
function FilterDropdown({
  children,
  dropdownFilters,
  selected: selected2,
  selectedCount,
  handleChangeSelectedFilters,
  handleSelectAllFilters,
  handleClearSelectedFilters,
  filterFilterQuery,
  handleUpdateFilterFilterQuery,
  filterGroup,
  filterGroupName
}) {
  const dropdownFilterCount = dropdownFilters.filters.length;
  const hasFilterFilters = dropdownFilters.isControlled || dropdownFilterCount >= 15;
  const hasActiveFilterQuery = !!filterFilterQuery.length;
  const visibleFilterValues = dropdownFilters.isControlled ? dropdownFilters.filters : hasFilterFilters && hasActiveFilterQuery ? dropdownFilters.filters.filter((filter) => filter.name.toLowerCase().includes(filterFilterQuery.toLowerCase())) : dropdownFilters.filters || [];
  const dropdownVisibleFilterCount = visibleFilterValues.length;
  return /* @__PURE__ */ jsxs("div", {
    className: styles$4.filterDropdownWrapper,
    children: [children, /* @__PURE__ */ jsxs("div", {
      className: styles$4.filterDropdown,
      children: [/* @__PURE__ */ jsx$1("p", {
        className: styles$4.filterCount,
        children: `${filterGroupName} (${selectedCount}/${dropdownFilterCount})`
      }), hasFilterFilters && /* @__PURE__ */ jsx$1(ActionInput, {
        className: styles$4.actionInput,
        ariaLabel: "dropdownFilter",
        value: filterFilterQuery,
        onChange: (e2) => handleUpdateFilterFilterQuery(filterGroup, e2),
        isPending: dropdownFilters.isFetching,
        placeholder: dropdownFilters.searchBarPlaceholder
      }), /* @__PURE__ */ jsxs("div", {
        className: styles$4.filterCheckboxes,
        children: [dropdownVisibleFilterCount > 0 ? /* @__PURE__ */ jsx$1(Checkbox, {
          className: styles$4.checkboxFilter,
          label: hasActiveFilterQuery ? `Select ${dropdownVisibleFilterCount} Matched` : `Select All ${dropdownVisibleFilterCount}`,
          checked: !visibleFilterValues.filter((x2) => !selected2.includes(x2.accessor)).length,
          onChange: () => handleSelectAllFilters(filterGroup, visibleFilterValues)
        }) : /* @__PURE__ */ jsx$1("p", {
          children: "No matches"
        }), visibleFilterValues.map((v2) => {
          return /* @__PURE__ */ jsx$1(Checkbox, {
            className: styles$4.checkboxFilter,
            label: v2.name,
            name: v2.accessor,
            checked: selected2.includes(v2.accessor) || false,
            onChange: (e2) => handleChangeSelectedFilters(filterGroup, e2)
          }, `${filterGroup}-${v2.accessor}`);
        })]
      }), /* @__PURE__ */ jsx$1("div", {
        className: styles$4.filtersClearSelected,
        children: /* @__PURE__ */ jsx$1("p", {
          children: selectedCount > 0 ? /* @__PURE__ */ jsx$1("a", {
            onClick: () => handleClearSelectedFilters(filterGroup),
            children: `Clear ${selectedCount} Selected`
          }) : "Clear Selected"
        })
      })]
    })]
  });
}
function ColumnFilterButton({
  columns,
  toggleAll,
  columnFilterVisible,
  setColumnFilterVisible,
  columnFilterQuery,
  setColumnFilterQuery,
  withSelectableRows
}) {
  const handleClick = () => {
    setColumnFilterVisible(!columnFilterVisible);
  };
  const handleOnClear = () => {
    setColumnFilterQuery("");
  };
  const handleBlur = () => {
    setColumnFilterVisible(false);
  };
  const usableColumns = withSelectableRows ? columns.slice(1) : columns;
  const queryFilteredColumns = columnFilterQuery ? usableColumns.filter((c2) => {
    var _a;
    return (_a = c2.Header) == null ? void 0 : _a.toLowerCase().includes(columnFilterQuery.toLowerCase());
  }) : usableColumns || [];
  const visibleColumnsCount = usableColumns.reduce((a, b2) => {
    return b2.isVisible ? a : a - 1;
  }, usableColumns.length);
  const allColumnsVisible = visibleColumnsCount === usableColumns.length;
  return /* @__PURE__ */ jsxs("div", {
    className: styles$4.columnFilterWrapper,
    children: [/* @__PURE__ */ jsx$1(Button$1, {
      afterSlot: /* @__PURE__ */ jsx$1(PlusMinus, {}),
      onClick: handleClick,
      children: "Columns"
    }), /* @__PURE__ */ jsxs("div", {
      className: classnames$2(styles$4.columnFilterDropdown, columnFilterVisible && styles$4.columnFilterDropdownVisible),
      tabIndex: "0",
      onMouseLeave: handleBlur,
      children: [/* @__PURE__ */ jsxs("div", {
        children: [/* @__PURE__ */ jsxs("div", {
          children: ["Columns (", visibleColumnsCount, "/", usableColumns.length, ")"]
        }), columns.length > 15 && /* @__PURE__ */ jsx$1(ActionInput, {
          className: styles$4.actionInput,
          ariaLabel: "columnFilter",
          value: columnFilterQuery,
          onChange: (e2) => setColumnFilterQuery(e2.target.value),
          onClear: handleOnClear
        }), /* @__PURE__ */ jsx$1("div", {
          className: styles$4.filterCheckboxes,
          children: queryFilteredColumns.map((c2) => /* @__PURE__ */ jsx$1(Checkbox, {
            className: styles$4.checkboxFilter,
            label: c2.Header,
            name: c2.id,
            ...c2.getToggleHiddenProps()
          }, c2.id))
        })]
      }), /* @__PURE__ */ jsx$1("div", {
        children: /* @__PURE__ */ jsxs("label", {
          className: allColumnsVisible && styles$4.resetDisabled,
          children: [/* @__PURE__ */ jsx$1(IndeterminateCheckboxAlt, {
            className: styles$4.indeterminateInput,
            ...toggleAll(),
            disabled: allColumnsVisible
          }), /* @__PURE__ */ jsx$1("span", {
            children: "Reset"
          })]
        })
      })]
    })]
  });
}
function GlobalFilter({
  filter,
  setFilter,
  placeholderText,
  maxLength,
  label
}) {
  return /* @__PURE__ */ jsxs("div", {
    className: styles$4.searchBarSection,
    children: [/* @__PURE__ */ jsx$1(ActionInput, {
      value: filter || "",
      onChange: (e2) => setFilter(e2.target.value),
      placeholder: placeholderText,
      ariaLabel: "GlobalTableFilter",
      id: "GlobalTableFilter",
      maxLength
    }), label && /* @__PURE__ */ jsx$1(Label, {
      className: styles$4.searchBarSectionLabel,
      htmlFor: "GlobalTableFilter",
      children: label
    })]
  });
}
function getPagingRange(currentPage, {
  minLink = 1,
  pageCount = 10,
  linkCount = 5
} = {}) {
  if (linkCount > pageCount)
    linkCount = pageCount;
  let start2 = currentPage - Math.floor(linkCount / 2);
  start2 = Math.max(start2, minLink);
  start2 = Math.min(start2, minLink + pageCount - linkCount);
  return Array.from({
    length: linkCount
  }, (_, i2) => start2 + i2);
}
function PaginationNumbers({
  gotoPage,
  pageIndex,
  pageCount,
  onPageClick
}) {
  return /* @__PURE__ */ jsx$1(Fragment, {
    children: getPagingRange(pageIndex + 1, {
      pageCount
    }).map((gotoPageNum) => {
      const isActive = gotoPageNum === pageIndex + 1;
      return /* @__PURE__ */ jsx$1("div", {
        "data-testid": `page-number-${gotoPageNum}`,
        className: classnames$2(styles$4.pageNumbers, isActive && styles$4.active),
        onClick: () => {
          gotoPage(gotoPageNum - 1);
          onPageClick({
            pageIndex: gotoPageNum - 1
          });
        },
        children: gotoPageNum
      }, gotoPageNum);
    })
  });
}
function PaginationControls({
  canPreviousPage,
  previousPage,
  canNextPage,
  nextPage,
  pageIndex,
  totalRowCount,
  gotoPage,
  pageCount,
  pageSize,
  setPageSize,
  pageSizeOptions,
  onPageClick = (pageIndex2) => pageIndex2,
  inverse: inverse2 = false,
  className,
  pageSizeLabel = "Rows Per Page:",
  allowPageSizeChange = true,
  selectDropdownMenuPlacement
}) {
  const paginationNumbersProps = {
    gotoPage,
    pageIndex,
    pageCount,
    onPageClick
  };
  const goToFirstPage = () => gotoPage(0);
  const goToLastPage = () => gotoPage(pageCount - 1);
  const currentPageStart = pageIndex * pageSize + 1;
  const currentPageEnd = pageIndex * pageSize + pageSize;
  return /* @__PURE__ */ jsxs("div", {
    className: classnames$2(className, styles$4.paginationControls, inverse2 && styles$4.inverse),
    children: [/* @__PURE__ */ jsx$1("div", {
      className: styles$4.section,
      children: /* @__PURE__ */ jsxs("div", {
        children: [currentPageStart && currentPageEnd ? `${currentPageStart}-${currentPageEnd}` : null, currentPageStart && currentPageEnd && totalRowCount ? " of " : null, totalRowCount ? `${totalRowCount} Results` : null]
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: classnames$2(styles$4.section, styles$4.navigation),
      children: [/* @__PURE__ */ jsx$1("div", {
        className: styles$4.firstLast,
        onClick: goToFirstPage,
        children: "First"
      }), /* @__PURE__ */ jsx$1(IconButton, {
        icon: "CaretLeft",
        variant: "ghost",
        className: chevronColor(canPreviousPage),
        onClick: () => previousPage(),
        disabled: !canPreviousPage
      }), /* @__PURE__ */ jsx$1(PaginationNumbers, {
        ...paginationNumbersProps
      }), /* @__PURE__ */ jsx$1(IconButton, {
        icon: "CaretRight",
        variant: "ghost",
        className: chevronColor(canNextPage),
        onClick: () => nextPage(),
        disabled: !canNextPage
      }), /* @__PURE__ */ jsx$1("div", {
        className: styles$4.firstLast,
        onClick: goToLastPage,
        children: "Last"
      })]
    }), /* @__PURE__ */ jsx$1("div", {
      className: classnames$2(styles$4.section, styles$4.selectionSection, !allowPageSizeChange && styles$4.hideSelectionSection),
      children: /* @__PURE__ */ jsxs("div", {
        children: [/* @__PURE__ */ jsx$1("div", {
          className: styles$4.label,
          children: pageSizeLabel
        }), /* @__PURE__ */ jsx$1("div", {
          className: styles$4.pageSizeSelect,
          children: /* @__PURE__ */ jsx$1(Select, {
            inverse: inverse2,
            border: false,
            options: pageSizeOptions.map((sizeOpt) => ({
              value: sizeOpt,
              label: sizeOpt.toString()
            })),
            value: {
              value: Number(pageSize),
              label: pageSize.toString()
            },
            onChange: (selected2) => setPageSize(selected2.value),
            menuPlacement: selectDropdownMenuPlacement
          })
        })]
      })
    })]
  });
}
PaginationControls.propTypes = {
  canPreviousPage: PropTypes$1.bool,
  previousPage: PropTypes$1.func,
  canNextPage: PropTypes$1.bool,
  nextPage: PropTypes$1.func,
  pageIndex: PropTypes$1.number,
  totalRowCount: PropTypes$1.number,
  gotoPage: PropTypes$1.func,
  onPageClick: PropTypes$1.func,
  pageCount: PropTypes$1.number,
  pageSize: PropTypes$1.number,
  setPageSize: PropTypes$1.func,
  pageSizeOptions: PropTypes$1.arrayOf(PropTypes$1.number),
  inverse: PropTypes$1.bool,
  pageSizeLabel: PropTypes$1.string,
  allowPageSizeChange: PropTypes$1.bool,
  selectDropdownMenuPlacement: PropTypes$1.string
};
function Pagination({
  page,
  prepareRow,
  isCompact
}) {
  return page.map((row, rowIx) => {
    prepareRow(row);
    return /* @__PURE__ */ jsx$1(Tr, {
      ...row.getRowProps(),
      children: row.cells.map((cell, cellIx) => {
        return /* @__PURE__ */ jsx$1(Td, {
          ...cell.getCellProps(),
          className: isCompact && styles$4.compactCell,
          children: cell.render("Cell")
        }, `body-cell-${cellIx}`);
      })
    }, `body-row-${rowIx}`);
  });
}
function NoPagination({
  rows,
  prepareRow,
  isCompact,
  getChildRows,
  expanderCell,
  onRowClick
}) {
  return rows.map((row, rowIx) => {
    prepareRow(row);
    const {
      key: rowKey,
      ...rowProps
    } = row.getRowProps();
    return /* @__PURE__ */ jsxs(React__default.Fragment, {
      children: [/* @__PURE__ */ jsx$1(Tr, {
        rowindex: rowIx,
        rowRecord: row.original,
        onClick: onRowClick,
        ...rowProps,
        children: row.cells.map((cell, cellIx) => {
          return /* @__PURE__ */ jsx$1(Td, {
            ...cell.getCellProps(),
            className: classnames$2({
              [styles$4.compactCell]: isCompact,
              [cell.column.className]: cell.column.className,
              [styles$4.isSorted]: cell.column.isSorted || cell.column.isSortedDesc
            }),
            children: cell.render("Cell")
          }, `body-cell-${cellIx}`);
        })
      }, `body-row-${rowIx}`), row.isExpanded ? getChildRows({
        row,
        expanderCell
      }) : null]
    }, rowKey);
  });
}
function NoDataRow({
  title: title2 = "No Data Found",
  subtitle: subtitle2 = "Try to adjust your search or filters"
}) {
  return /* @__PURE__ */ jsxs("div", {
    className: styles$4.noData,
    children: [/* @__PURE__ */ jsx$1("div", {
      className: styles$4.title,
      children: title2
    }), /* @__PURE__ */ jsx$1("div", {
      className: styles$4.subtitle,
      children: subtitle2
    })]
  });
}
function LoadingRow({
  message = "Loading...",
  isCompact
}) {
  return /* @__PURE__ */ jsx$1(Tr, {
    children: /* @__PURE__ */ jsx$1(Td, {
      className: classnames$2(styles$4.isLoading, isCompact && styles$4.compactCell),
      colSpan: "10000",
      children: message
    })
  });
}
function TableContainer({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx$1(Table$1, {
    ...props,
    className: styles$4.table
  });
}
function Thead({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx$1("thead", {
    ...props
  });
}
function Th({
  isSorted: isSorted2,
  isSortedDesc,
  className,
  ...props
}) {
  const mergedClassname = `${styles$4.th} ${isSorted2 ? isSortedDesc ? styles$4.sortDesc : styles$4.sortAsc : ""} ${className || ""}`;
  return /* @__PURE__ */ jsx$1(TableHeading, {
    ...props,
    className: mergedClassname
  });
}
function Tbody({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx$1("tbody", {
    ...props
  });
}
function Tr({
  className,
  onClick,
  rowRecord,
  ...props
}) {
  let cursorStyle = onClick ? {
    cursor: "pointer"
  } : {};
  return /* @__PURE__ */ jsx$1("tr", {
    style: cursorStyle,
    onClick: () => onClick == null ? void 0 : onClick(rowRecord),
    ...props
  });
}
function Td({
  ...props
}) {
  return /* @__PURE__ */ jsx$1(TableCell, {
    ...props
  });
}
const chevronColor = (isActive) => {
  return isActive ? styles$4.colorActive : styles$4.colorDisabled;
};
const SortAscending = /* @__PURE__ */ jsx$1(Icon, {
  type: "SortAscending",
  size: "s",
  className: styles$4.sortIcon
});
const SortDescending = /* @__PURE__ */ jsx$1(Icon, {
  type: "SortDescending",
  size: "s",
  className: styles$4.sortIcon
});
function createHeaderCell(column2) {
  const {
    render,
    isSorted: isSorted2,
    isSortedDesc,
    canSort: canSort2
  } = column2;
  if (!canSort2)
    return render("Header");
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [isSorted2 ? isSortedDesc ? SortDescending : SortAscending : "", render("Header")]
  });
}
function TableHeader({
  headerGroups,
  isCompact
}) {
  return /* @__PURE__ */ jsx$1(Thead, {
    children: headerGroups.map((headerGroup, rowIx) => /* @__PURE__ */ jsx$1(Tr, {
      ...headerGroup.getHeaderGroupProps(),
      children: headerGroup.headers.map((column2, cellIx) => /* @__PURE__ */ createElement(Th, {
        ...column2.getHeaderProps(column2.getSortByToggleProps()),
        isSorted: column2.isSorted,
        isSortedDesc: column2.isSortedDesc,
        key: `head-cell-${cellIx}`,
        className: classnames$2({
          [styles$4.canSort]: column2.canSort,
          [styles$4.compactCell]: isCompact,
          [column2.className]: column2.className
        })
      }, /* @__PURE__ */ jsx$1("span", {
        children: createHeaderCell(column2)
      })))
    }, `head-row-${rowIx}`))
  });
}
function BulkSelectRow({
  children,
  selectedFlatRows,
  toggleAllRowsSelected
}) {
  return /* @__PURE__ */ jsxs("div", {
    className: styles$4.bulkSelect,
    children: [/* @__PURE__ */ jsxs("div", {
      className: styles$4.selected,
      children: [/* @__PURE__ */ jsx$1(Icon, {
        type: "Close",
        onClick: () => toggleAllRowsSelected(false)
      }), selectedFlatRows.length, " Selected"]
    }), /* @__PURE__ */ jsx$1("div", {
      className: styles$4.additionalSection,
      children
    })]
  });
}
const IndeterminateCheckbox = React__default.forwardRef(({
  indeterminate,
  ...rest
}) => {
  return /* @__PURE__ */ jsx$1(Checkbox, {
    type: "checkbox",
    ...rest,
    indeterminate
  });
});
const IndeterminateCheckboxAlt = React__default.forwardRef(({
  indeterminate,
  ...rest
}, ref) => {
  const defaultRef = React__default.useRef();
  const resolvedRef = ref || defaultRef;
  React__default.useEffect(() => {
    resolvedRef.current.indeterminate = indeterminate;
  }, [resolvedRef, indeterminate]);
  return /* @__PURE__ */ jsx$1("input", {
    type: "checkbox",
    ref: resolvedRef,
    ...rest
  });
});
function StaticTable({
  className,
  columns,
  data,
  isCompact
}) {
  const rowOrder = columns.map(({
    accessor
  }) => accessor);
  if (columns.length === 0)
    return null;
  return /* @__PURE__ */ jsxs(TableContainer, {
    ...className,
    children: [/* @__PURE__ */ jsx$1(Thead, {
      children: /* @__PURE__ */ jsx$1(Tr, {
        children: columns.map(({
          Header
        }, i2) => /* @__PURE__ */ jsx$1(Th, {
          className: isCompact && styles$4.compactCell,
          children: Header
        }, i2))
      })
    }), /* @__PURE__ */ jsx$1(Tbody, {
      children: data.map((rowData, ix) => {
        return /* @__PURE__ */ jsx$1(Tr, {
          children: rowOrder.map((cellData, jx) => /* @__PURE__ */ jsx$1(Td, {
            className: isCompact && styles$4.compactCell,
            children: rowData[cellData]
          }, `${ix}-${jx}`))
        }, `${ix}`);
      })
    })]
  });
}
StaticTable.propTypes = {
  className: PropTypes$1.string,
  columns: PropTypes$1.arrayOf(PropTypes$1.shape({
    Header: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.object]),
    accessor: PropTypes$1.string
  })).isRequired,
  data: PropTypes$1.arrayOf(PropTypes$1.object).isRequired,
  isCompact: PropTypes$1.bool
};
StaticTable.defaultProps = {
  columns: [],
  data: [],
  className: "",
  isCompact: false
};
var lodash = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
(function(module, exports) {
  (function() {
    var undefined$1;
    var VERSION = "4.17.21";
    var LARGE_ARRAY_SIZE = 200;
    var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT2 = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var MAX_MEMOIZE_SIZE = 500;
    var PLACEHOLDER = "__lodash_placeholder__";
    var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    var HOT_COUNT = 800, HOT_SPAN = 16;
    var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN2 = 0 / 0;
    var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    var wrapFlags = [
      ["ary", WRAP_ARY_FLAG],
      ["bind", WRAP_BIND_FLAG],
      ["bindKey", WRAP_BIND_KEY_FLAG],
      ["curry", WRAP_CURRY_FLAG],
      ["curryRight", WRAP_CURRY_RIGHT_FLAG],
      ["flip", WRAP_FLIP_FLAG],
      ["partial", WRAP_PARTIAL_FLAG],
      ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
      ["rearg", WRAP_REARG_FLAG]
    ];
    var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag2 = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    var reTrimStart = /^\s+/;
    var reWhitespace = /\s/;
    var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    var reEscapeChar = /\\(\\)?/g;
    var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    var reFlags = /\w*$/;
    var reIsBadHex2 = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary2 = /^0b[01]+$/i;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var reIsOctal2 = /^0o[0-7]+$/i;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    var reNoMatch = /($^)/;
    var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
    var reApos = RegExp(rsApos, "g");
    var reComboMark = RegExp(rsCombo, "g");
    var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    var reUnicodeWord = RegExp([
      rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
      rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
      rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
      rsUpper + "+" + rsOptContrUpper,
      rsOrdUpper,
      rsOrdLower,
      rsDigits,
      rsEmoji
    ].join("|"), "g");
    var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    var contextProps = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ];
    var templateCounter = -1;
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag2] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    var deburredLetters = {
      "\xC0": "A",
      "\xC1": "A",
      "\xC2": "A",
      "\xC3": "A",
      "\xC4": "A",
      "\xC5": "A",
      "\xE0": "a",
      "\xE1": "a",
      "\xE2": "a",
      "\xE3": "a",
      "\xE4": "a",
      "\xE5": "a",
      "\xC7": "C",
      "\xE7": "c",
      "\xD0": "D",
      "\xF0": "d",
      "\xC8": "E",
      "\xC9": "E",
      "\xCA": "E",
      "\xCB": "E",
      "\xE8": "e",
      "\xE9": "e",
      "\xEA": "e",
      "\xEB": "e",
      "\xCC": "I",
      "\xCD": "I",
      "\xCE": "I",
      "\xCF": "I",
      "\xEC": "i",
      "\xED": "i",
      "\xEE": "i",
      "\xEF": "i",
      "\xD1": "N",
      "\xF1": "n",
      "\xD2": "O",
      "\xD3": "O",
      "\xD4": "O",
      "\xD5": "O",
      "\xD6": "O",
      "\xD8": "O",
      "\xF2": "o",
      "\xF3": "o",
      "\xF4": "o",
      "\xF5": "o",
      "\xF6": "o",
      "\xF8": "o",
      "\xD9": "U",
      "\xDA": "U",
      "\xDB": "U",
      "\xDC": "U",
      "\xF9": "u",
      "\xFA": "u",
      "\xFB": "u",
      "\xFC": "u",
      "\xDD": "Y",
      "\xFD": "y",
      "\xFF": "y",
      "\xC6": "Ae",
      "\xE6": "ae",
      "\xDE": "Th",
      "\xFE": "th",
      "\xDF": "ss",
      "\u0100": "A",
      "\u0102": "A",
      "\u0104": "A",
      "\u0101": "a",
      "\u0103": "a",
      "\u0105": "a",
      "\u0106": "C",
      "\u0108": "C",
      "\u010A": "C",
      "\u010C": "C",
      "\u0107": "c",
      "\u0109": "c",
      "\u010B": "c",
      "\u010D": "c",
      "\u010E": "D",
      "\u0110": "D",
      "\u010F": "d",
      "\u0111": "d",
      "\u0112": "E",
      "\u0114": "E",
      "\u0116": "E",
      "\u0118": "E",
      "\u011A": "E",
      "\u0113": "e",
      "\u0115": "e",
      "\u0117": "e",
      "\u0119": "e",
      "\u011B": "e",
      "\u011C": "G",
      "\u011E": "G",
      "\u0120": "G",
      "\u0122": "G",
      "\u011D": "g",
      "\u011F": "g",
      "\u0121": "g",
      "\u0123": "g",
      "\u0124": "H",
      "\u0126": "H",
      "\u0125": "h",
      "\u0127": "h",
      "\u0128": "I",
      "\u012A": "I",
      "\u012C": "I",
      "\u012E": "I",
      "\u0130": "I",
      "\u0129": "i",
      "\u012B": "i",
      "\u012D": "i",
      "\u012F": "i",
      "\u0131": "i",
      "\u0134": "J",
      "\u0135": "j",
      "\u0136": "K",
      "\u0137": "k",
      "\u0138": "k",
      "\u0139": "L",
      "\u013B": "L",
      "\u013D": "L",
      "\u013F": "L",
      "\u0141": "L",
      "\u013A": "l",
      "\u013C": "l",
      "\u013E": "l",
      "\u0140": "l",
      "\u0142": "l",
      "\u0143": "N",
      "\u0145": "N",
      "\u0147": "N",
      "\u014A": "N",
      "\u0144": "n",
      "\u0146": "n",
      "\u0148": "n",
      "\u014B": "n",
      "\u014C": "O",
      "\u014E": "O",
      "\u0150": "O",
      "\u014D": "o",
      "\u014F": "o",
      "\u0151": "o",
      "\u0154": "R",
      "\u0156": "R",
      "\u0158": "R",
      "\u0155": "r",
      "\u0157": "r",
      "\u0159": "r",
      "\u015A": "S",
      "\u015C": "S",
      "\u015E": "S",
      "\u0160": "S",
      "\u015B": "s",
      "\u015D": "s",
      "\u015F": "s",
      "\u0161": "s",
      "\u0162": "T",
      "\u0164": "T",
      "\u0166": "T",
      "\u0163": "t",
      "\u0165": "t",
      "\u0167": "t",
      "\u0168": "U",
      "\u016A": "U",
      "\u016C": "U",
      "\u016E": "U",
      "\u0170": "U",
      "\u0172": "U",
      "\u0169": "u",
      "\u016B": "u",
      "\u016D": "u",
      "\u016F": "u",
      "\u0171": "u",
      "\u0173": "u",
      "\u0174": "W",
      "\u0175": "w",
      "\u0176": "Y",
      "\u0177": "y",
      "\u0178": "Y",
      "\u0179": "Z",
      "\u017B": "Z",
      "\u017D": "Z",
      "\u017A": "z",
      "\u017C": "z",
      "\u017E": "z",
      "\u0132": "IJ",
      "\u0133": "ij",
      "\u0152": "Oe",
      "\u0153": "oe",
      "\u0149": "'n",
      "\u017F": "s"
    };
    var htmlEscapes = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    };
    var htmlUnescapes = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    };
    var stringEscapes = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    };
    var freeParseFloat = parseFloat, freeParseInt2 = parseInt;
    var freeGlobal2 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
    var freeSelf2 = typeof self == "object" && self && self.Object === Object && self;
    var root2 = freeGlobal2 || freeSelf2 || Function("return this")();
    var freeExports = exports && !exports.nodeType && exports;
    var freeModule = freeExports && true && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal2.process;
    var nodeUtil = function() {
      try {
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) {
          return types;
        }
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e2) {
      }
    }();
    var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }
    function arrayAggregator(array, setter, iteratee, accumulator) {
      var index2 = -1, length2 = array == null ? 0 : array.length;
      while (++index2 < length2) {
        var value = array[index2];
        setter(accumulator, value, iteratee(value), array);
      }
      return accumulator;
    }
    function arrayEach(array, iteratee) {
      var index2 = -1, length2 = array == null ? 0 : array.length;
      while (++index2 < length2) {
        if (iteratee(array[index2], index2, array) === false) {
          break;
        }
      }
      return array;
    }
    function arrayEachRight(array, iteratee) {
      var length2 = array == null ? 0 : array.length;
      while (length2--) {
        if (iteratee(array[length2], length2, array) === false) {
          break;
        }
      }
      return array;
    }
    function arrayEvery(array, predicate) {
      var index2 = -1, length2 = array == null ? 0 : array.length;
      while (++index2 < length2) {
        if (!predicate(array[index2], index2, array)) {
          return false;
        }
      }
      return true;
    }
    function arrayFilter(array, predicate) {
      var index2 = -1, length2 = array == null ? 0 : array.length, resIndex = 0, result = [];
      while (++index2 < length2) {
        var value = array[index2];
        if (predicate(value, index2, array)) {
          result[resIndex++] = value;
        }
      }
      return result;
    }
    function arrayIncludes(array, value) {
      var length2 = array == null ? 0 : array.length;
      return !!length2 && baseIndexOf(array, value, 0) > -1;
    }
    function arrayIncludesWith(array, value, comparator) {
      var index2 = -1, length2 = array == null ? 0 : array.length;
      while (++index2 < length2) {
        if (comparator(value, array[index2])) {
          return true;
        }
      }
      return false;
    }
    function arrayMap(array, iteratee) {
      var index2 = -1, length2 = array == null ? 0 : array.length, result = Array(length2);
      while (++index2 < length2) {
        result[index2] = iteratee(array[index2], index2, array);
      }
      return result;
    }
    function arrayPush(array, values) {
      var index2 = -1, length2 = values.length, offset2 = array.length;
      while (++index2 < length2) {
        array[offset2 + index2] = values[index2];
      }
      return array;
    }
    function arrayReduce(array, iteratee, accumulator, initAccum) {
      var index2 = -1, length2 = array == null ? 0 : array.length;
      if (initAccum && length2) {
        accumulator = array[++index2];
      }
      while (++index2 < length2) {
        accumulator = iteratee(accumulator, array[index2], index2, array);
      }
      return accumulator;
    }
    function arrayReduceRight(array, iteratee, accumulator, initAccum) {
      var length2 = array == null ? 0 : array.length;
      if (initAccum && length2) {
        accumulator = array[--length2];
      }
      while (length2--) {
        accumulator = iteratee(accumulator, array[length2], length2, array);
      }
      return accumulator;
    }
    function arraySome(array, predicate) {
      var index2 = -1, length2 = array == null ? 0 : array.length;
      while (++index2 < length2) {
        if (predicate(array[index2], index2, array)) {
          return true;
        }
      }
      return false;
    }
    var asciiSize = baseProperty("length");
    function asciiToArray(string) {
      return string.split("");
    }
    function asciiWords(string) {
      return string.match(reAsciiWord) || [];
    }
    function baseFindKey(collection, predicate, eachFunc) {
      var result;
      eachFunc(collection, function(value, key, collection2) {
        if (predicate(value, key, collection2)) {
          result = key;
          return false;
        }
      });
      return result;
    }
    function baseFindIndex(array, predicate, fromIndex, fromRight) {
      var length2 = array.length, index2 = fromIndex + (fromRight ? 1 : -1);
      while (fromRight ? index2-- : ++index2 < length2) {
        if (predicate(array[index2], index2, array)) {
          return index2;
        }
      }
      return -1;
    }
    function baseIndexOf(array, value, fromIndex) {
      return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    function baseIndexOfWith(array, value, fromIndex, comparator) {
      var index2 = fromIndex - 1, length2 = array.length;
      while (++index2 < length2) {
        if (comparator(array[index2], value)) {
          return index2;
        }
      }
      return -1;
    }
    function baseIsNaN(value) {
      return value !== value;
    }
    function baseMean(array, iteratee) {
      var length2 = array == null ? 0 : array.length;
      return length2 ? baseSum(array, iteratee) / length2 : NAN2;
    }
    function baseProperty(key) {
      return function(object) {
        return object == null ? undefined$1 : object[key];
      };
    }
    function basePropertyOf(object) {
      return function(key) {
        return object == null ? undefined$1 : object[key];
      };
    }
    function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
      eachFunc(collection, function(value, index2, collection2) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index2, collection2);
      });
      return accumulator;
    }
    function baseSortBy(array, comparer) {
      var length2 = array.length;
      array.sort(comparer);
      while (length2--) {
        array[length2] = array[length2].value;
      }
      return array;
    }
    function baseSum(array, iteratee) {
      var result, index2 = -1, length2 = array.length;
      while (++index2 < length2) {
        var current = iteratee(array[index2]);
        if (current !== undefined$1) {
          result = result === undefined$1 ? current : result + current;
        }
      }
      return result;
    }
    function baseTimes(n2, iteratee) {
      var index2 = -1, result = Array(n2);
      while (++index2 < n2) {
        result[index2] = iteratee(index2);
      }
      return result;
    }
    function baseToPairs(object, props) {
      return arrayMap(props, function(key) {
        return [key, object[key]];
      });
    }
    function baseTrim(string) {
      return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    function baseUnary(func) {
      return function(value) {
        return func(value);
      };
    }
    function baseValues(object, props) {
      return arrayMap(props, function(key) {
        return object[key];
      });
    }
    function cacheHas(cache, key) {
      return cache.has(key);
    }
    function charsStartIndex(strSymbols, chrSymbols) {
      var index2 = -1, length2 = strSymbols.length;
      while (++index2 < length2 && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
      }
      return index2;
    }
    function charsEndIndex(strSymbols, chrSymbols) {
      var index2 = strSymbols.length;
      while (index2-- && baseIndexOf(chrSymbols, strSymbols[index2], 0) > -1) {
      }
      return index2;
    }
    function countHolders(array, placeholder) {
      var length2 = array.length, result = 0;
      while (length2--) {
        if (array[length2] === placeholder) {
          ++result;
        }
      }
      return result;
    }
    var deburrLetter = basePropertyOf(deburredLetters);
    var escapeHtmlChar = basePropertyOf(htmlEscapes);
    function escapeStringChar(chr) {
      return "\\" + stringEscapes[chr];
    }
    function getValue(object, key) {
      return object == null ? undefined$1 : object[key];
    }
    function hasUnicode(string) {
      return reHasUnicode.test(string);
    }
    function hasUnicodeWord(string) {
      return reHasUnicodeWord.test(string);
    }
    function iteratorToArray(iterator) {
      var data, result = [];
      while (!(data = iterator.next()).done) {
        result.push(data.value);
      }
      return result;
    }
    function mapToArray(map2) {
      var index2 = -1, result = Array(map2.size);
      map2.forEach(function(value, key) {
        result[++index2] = [key, value];
      });
      return result;
    }
    function overArg(func, transform) {
      return function(arg) {
        return func(transform(arg));
      };
    }
    function replaceHolders(array, placeholder) {
      var index2 = -1, length2 = array.length, resIndex = 0, result = [];
      while (++index2 < length2) {
        var value = array[index2];
        if (value === placeholder || value === PLACEHOLDER) {
          array[index2] = PLACEHOLDER;
          result[resIndex++] = index2;
        }
      }
      return result;
    }
    function setToArray(set) {
      var index2 = -1, result = Array(set.size);
      set.forEach(function(value) {
        result[++index2] = value;
      });
      return result;
    }
    function setToPairs(set) {
      var index2 = -1, result = Array(set.size);
      set.forEach(function(value) {
        result[++index2] = [value, value];
      });
      return result;
    }
    function strictIndexOf(array, value, fromIndex) {
      var index2 = fromIndex - 1, length2 = array.length;
      while (++index2 < length2) {
        if (array[index2] === value) {
          return index2;
        }
      }
      return -1;
    }
    function strictLastIndexOf(array, value, fromIndex) {
      var index2 = fromIndex + 1;
      while (index2--) {
        if (array[index2] === value) {
          return index2;
        }
      }
      return index2;
    }
    function stringSize(string) {
      return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    function stringToArray(string) {
      return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    function trimmedEndIndex(string) {
      var index2 = string.length;
      while (index2-- && reWhitespace.test(string.charAt(index2))) {
      }
      return index2;
    }
    var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    function unicodeSize(string) {
      var result = reUnicode.lastIndex = 0;
      while (reUnicode.test(string)) {
        ++result;
      }
      return result;
    }
    function unicodeToArray(string) {
      return string.match(reUnicode) || [];
    }
    function unicodeWords(string) {
      return string.match(reUnicodeWord) || [];
    }
    var runInContext = function runInContext2(context) {
      context = context == null ? root2 : _.defaults(root2.Object(), context, _.pick(root2, contextProps));
      var Array2 = context.Array, Date2 = context.Date, Error2 = context.Error, Function2 = context.Function, Math2 = context.Math, Object2 = context.Object, RegExp2 = context.RegExp, String2 = context.String, TypeError2 = context.TypeError;
      var arrayProto = Array2.prototype, funcProto = Function2.prototype, objectProto2 = Object2.prototype;
      var coreJsData = context["__core-js_shared__"];
      var funcToString = funcProto.toString;
      var hasOwnProperty2 = objectProto2.hasOwnProperty;
      var idCounter2 = 0;
      var maskSrcKey = function() {
        var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
        return uid ? "Symbol(src)_1." + uid : "";
      }();
      var nativeObjectToString = objectProto2.toString;
      var objectCtorString = funcToString.call(Object2);
      var oldDash = root2._;
      var reIsNative = RegExp2("^" + funcToString.call(hasOwnProperty2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
      var Buffer2 = moduleExports ? context.Buffer : undefined$1, Symbol2 = context.Symbol, Uint8Array2 = context.Uint8Array, allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : undefined$1, getPrototype = overArg(Object2.getPrototypeOf, Object2), objectCreate = Object2.create, propertyIsEnumerable = objectProto2.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : undefined$1, symIterator = Symbol2 ? Symbol2.iterator : undefined$1, symToStringTag = Symbol2 ? Symbol2.toStringTag : undefined$1;
      var defineProperty = function() {
        try {
          var func = getNative(Object2, "defineProperty");
          func({}, "", {});
          return func;
        } catch (e2) {
        }
      }();
      var ctxClearTimeout = context.clearTimeout !== root2.clearTimeout && context.clearTimeout, ctxNow = Date2 && Date2.now !== root2.Date.now && Date2.now, ctxSetTimeout = context.setTimeout !== root2.setTimeout && context.setTimeout;
      var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols = Object2.getOwnPropertySymbols, nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : undefined$1, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object2.keys, Object2), nativeMax2 = Math2.max, nativeMin2 = Math2.min, nativeNow = Date2.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto.reverse;
      var DataView = getNative(context, "DataView"), Map2 = getNative(context, "Map"), Promise2 = getNative(context, "Promise"), Set2 = getNative(context, "Set"), WeakMap2 = getNative(context, "WeakMap"), nativeCreate = getNative(Object2, "create");
      var metaMap = WeakMap2 && new WeakMap2();
      var realNames = {};
      var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map2), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set2), weakMapCtorString = toSource(WeakMap2);
      var symbolProto = Symbol2 ? Symbol2.prototype : undefined$1, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1, symbolToString = symbolProto ? symbolProto.toString : undefined$1;
      function lodash2(value) {
        if (isObjectLike2(value) && !isArray2(value) && !(value instanceof LazyWrapper)) {
          if (value instanceof LodashWrapper) {
            return value;
          }
          if (hasOwnProperty2.call(value, "__wrapped__")) {
            return wrapperClone(value);
          }
        }
        return new LodashWrapper(value);
      }
      var baseCreate = function() {
        function object() {
        }
        return function(proto) {
          if (!isObject2(proto)) {
            return {};
          }
          if (objectCreate) {
            return objectCreate(proto);
          }
          object.prototype = proto;
          var result2 = new object();
          object.prototype = undefined$1;
          return result2;
        };
      }();
      function baseLodash() {
      }
      function LodashWrapper(value, chainAll) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__chain__ = !!chainAll;
        this.__index__ = 0;
        this.__values__ = undefined$1;
      }
      lodash2.templateSettings = {
        "escape": reEscape,
        "evaluate": reEvaluate,
        "interpolate": reInterpolate,
        "variable": "",
        "imports": {
          "_": lodash2
        }
      };
      lodash2.prototype = baseLodash.prototype;
      lodash2.prototype.constructor = lodash2;
      LodashWrapper.prototype = baseCreate(baseLodash.prototype);
      LodashWrapper.prototype.constructor = LodashWrapper;
      function LazyWrapper(value) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__dir__ = 1;
        this.__filtered__ = false;
        this.__iteratees__ = [];
        this.__takeCount__ = MAX_ARRAY_LENGTH;
        this.__views__ = [];
      }
      function lazyClone() {
        var result2 = new LazyWrapper(this.__wrapped__);
        result2.__actions__ = copyArray(this.__actions__);
        result2.__dir__ = this.__dir__;
        result2.__filtered__ = this.__filtered__;
        result2.__iteratees__ = copyArray(this.__iteratees__);
        result2.__takeCount__ = this.__takeCount__;
        result2.__views__ = copyArray(this.__views__);
        return result2;
      }
      function lazyReverse() {
        if (this.__filtered__) {
          var result2 = new LazyWrapper(this);
          result2.__dir__ = -1;
          result2.__filtered__ = true;
        } else {
          result2 = this.clone();
          result2.__dir__ *= -1;
        }
        return result2;
      }
      function lazyValue() {
        var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray2(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start2 = view.start, end2 = view.end, length2 = end2 - start2, index2 = isRight ? end2 : start2 - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin2(length2, this.__takeCount__);
        if (!isArr || !isRight && arrLength == length2 && takeCount == length2) {
          return baseWrapperValue(array, this.__actions__);
        }
        var result2 = [];
        outer:
          while (length2-- && resIndex < takeCount) {
            index2 += dir;
            var iterIndex = -1, value = array[index2];
            while (++iterIndex < iterLength) {
              var data = iteratees[iterIndex], iteratee2 = data.iteratee, type = data.type, computed = iteratee2(value);
              if (type == LAZY_MAP_FLAG) {
                value = computed;
              } else if (!computed) {
                if (type == LAZY_FILTER_FLAG) {
                  continue outer;
                } else {
                  break outer;
                }
              }
            }
            result2[resIndex++] = value;
          }
        return result2;
      }
      LazyWrapper.prototype = baseCreate(baseLodash.prototype);
      LazyWrapper.prototype.constructor = LazyWrapper;
      function Hash(entries) {
        var index2 = -1, length2 = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length2) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function hashClear() {
        this.__data__ = nativeCreate ? nativeCreate(null) : {};
        this.size = 0;
      }
      function hashDelete(key) {
        var result2 = this.has(key) && delete this.__data__[key];
        this.size -= result2 ? 1 : 0;
        return result2;
      }
      function hashGet(key) {
        var data = this.__data__;
        if (nativeCreate) {
          var result2 = data[key];
          return result2 === HASH_UNDEFINED ? undefined$1 : result2;
        }
        return hasOwnProperty2.call(data, key) ? data[key] : undefined$1;
      }
      function hashHas(key) {
        var data = this.__data__;
        return nativeCreate ? data[key] !== undefined$1 : hasOwnProperty2.call(data, key);
      }
      function hashSet(key, value) {
        var data = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data[key] = nativeCreate && value === undefined$1 ? HASH_UNDEFINED : value;
        return this;
      }
      Hash.prototype.clear = hashClear;
      Hash.prototype["delete"] = hashDelete;
      Hash.prototype.get = hashGet;
      Hash.prototype.has = hashHas;
      Hash.prototype.set = hashSet;
      function ListCache(entries) {
        var index2 = -1, length2 = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length2) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function listCacheClear() {
        this.__data__ = [];
        this.size = 0;
      }
      function listCacheDelete(key) {
        var data = this.__data__, index2 = assocIndexOf(data, key);
        if (index2 < 0) {
          return false;
        }
        var lastIndex = data.length - 1;
        if (index2 == lastIndex) {
          data.pop();
        } else {
          splice.call(data, index2, 1);
        }
        --this.size;
        return true;
      }
      function listCacheGet(key) {
        var data = this.__data__, index2 = assocIndexOf(data, key);
        return index2 < 0 ? undefined$1 : data[index2][1];
      }
      function listCacheHas(key) {
        return assocIndexOf(this.__data__, key) > -1;
      }
      function listCacheSet(key, value) {
        var data = this.__data__, index2 = assocIndexOf(data, key);
        if (index2 < 0) {
          ++this.size;
          data.push([key, value]);
        } else {
          data[index2][1] = value;
        }
        return this;
      }
      ListCache.prototype.clear = listCacheClear;
      ListCache.prototype["delete"] = listCacheDelete;
      ListCache.prototype.get = listCacheGet;
      ListCache.prototype.has = listCacheHas;
      ListCache.prototype.set = listCacheSet;
      function MapCache(entries) {
        var index2 = -1, length2 = entries == null ? 0 : entries.length;
        this.clear();
        while (++index2 < length2) {
          var entry = entries[index2];
          this.set(entry[0], entry[1]);
        }
      }
      function mapCacheClear() {
        this.size = 0;
        this.__data__ = {
          "hash": new Hash(),
          "map": new (Map2 || ListCache)(),
          "string": new Hash()
        };
      }
      function mapCacheDelete(key) {
        var result2 = getMapData(this, key)["delete"](key);
        this.size -= result2 ? 1 : 0;
        return result2;
      }
      function mapCacheGet(key) {
        return getMapData(this, key).get(key);
      }
      function mapCacheHas(key) {
        return getMapData(this, key).has(key);
      }
      function mapCacheSet(key, value) {
        var data = getMapData(this, key), size2 = data.size;
        data.set(key, value);
        this.size += data.size == size2 ? 0 : 1;
        return this;
      }
      MapCache.prototype.clear = mapCacheClear;
      MapCache.prototype["delete"] = mapCacheDelete;
      MapCache.prototype.get = mapCacheGet;
      MapCache.prototype.has = mapCacheHas;
      MapCache.prototype.set = mapCacheSet;
      function SetCache(values2) {
        var index2 = -1, length2 = values2 == null ? 0 : values2.length;
        this.__data__ = new MapCache();
        while (++index2 < length2) {
          this.add(values2[index2]);
        }
      }
      function setCacheAdd(value) {
        this.__data__.set(value, HASH_UNDEFINED);
        return this;
      }
      function setCacheHas(value) {
        return this.__data__.has(value);
      }
      SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
      SetCache.prototype.has = setCacheHas;
      function Stack(entries) {
        var data = this.__data__ = new ListCache(entries);
        this.size = data.size;
      }
      function stackClear() {
        this.__data__ = new ListCache();
        this.size = 0;
      }
      function stackDelete(key) {
        var data = this.__data__, result2 = data["delete"](key);
        this.size = data.size;
        return result2;
      }
      function stackGet(key) {
        return this.__data__.get(key);
      }
      function stackHas(key) {
        return this.__data__.has(key);
      }
      function stackSet(key, value) {
        var data = this.__data__;
        if (data instanceof ListCache) {
          var pairs = data.__data__;
          if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([key, value]);
            this.size = ++data.size;
            return this;
          }
          data = this.__data__ = new MapCache(pairs);
        }
        data.set(key, value);
        this.size = data.size;
        return this;
      }
      Stack.prototype.clear = stackClear;
      Stack.prototype["delete"] = stackDelete;
      Stack.prototype.get = stackGet;
      Stack.prototype.has = stackHas;
      Stack.prototype.set = stackSet;
      function arrayLikeKeys(value, inherited) {
        var isArr = isArray2(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes(value.length, String2) : [], length2 = result2.length;
        for (var key in value) {
          if ((inherited || hasOwnProperty2.call(value, key)) && !(skipIndexes && (key == "length" || isBuff && (key == "offset" || key == "parent") || isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || isIndex(key, length2)))) {
            result2.push(key);
          }
        }
        return result2;
      }
      function arraySample(array) {
        var length2 = array.length;
        return length2 ? array[baseRandom(0, length2 - 1)] : undefined$1;
      }
      function arraySampleSize(array, n2) {
        return shuffleSelf(copyArray(array), baseClamp(n2, 0, array.length));
      }
      function arrayShuffle(array) {
        return shuffleSelf(copyArray(array));
      }
      function assignMergeValue(object, key, value) {
        if (value !== undefined$1 && !eq(object[key], value) || value === undefined$1 && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }
      function assignValue(object, key, value) {
        var objValue = object[key];
        if (!(hasOwnProperty2.call(object, key) && eq(objValue, value)) || value === undefined$1 && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }
      function assocIndexOf(array, key) {
        var length2 = array.length;
        while (length2--) {
          if (eq(array[length2][0], key)) {
            return length2;
          }
        }
        return -1;
      }
      function baseAggregator(collection, setter, iteratee2, accumulator) {
        baseEach(collection, function(value, key, collection2) {
          setter(accumulator, value, iteratee2(value), collection2);
        });
        return accumulator;
      }
      function baseAssign(object, source) {
        return object && copyObject(source, keys(source), object);
      }
      function baseAssignIn(object, source) {
        return object && copyObject(source, keysIn(source), object);
      }
      function baseAssignValue(object, key, value) {
        if (key == "__proto__" && defineProperty) {
          defineProperty(object, key, {
            "configurable": true,
            "enumerable": true,
            "value": value,
            "writable": true
          });
        } else {
          object[key] = value;
        }
      }
      function baseAt(object, paths2) {
        var index2 = -1, length2 = paths2.length, result2 = Array2(length2), skip = object == null;
        while (++index2 < length2) {
          result2[index2] = skip ? undefined$1 : get(object, paths2[index2]);
        }
        return result2;
      }
      function baseClamp(number, lower, upper) {
        if (number === number) {
          if (upper !== undefined$1) {
            number = number <= upper ? number : upper;
          }
          if (lower !== undefined$1) {
            number = number >= lower ? number : lower;
          }
        }
        return number;
      }
      function baseClone(value, bitmask, customizer, key, object, stack) {
        var result2, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
        if (customizer) {
          result2 = object ? customizer(value, key, object, stack) : customizer(value);
        }
        if (result2 !== undefined$1) {
          return result2;
        }
        if (!isObject2(value)) {
          return value;
        }
        var isArr = isArray2(value);
        if (isArr) {
          result2 = initCloneArray(value);
          if (!isDeep) {
            return copyArray(value, result2);
          }
        } else {
          var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
          if (isBuffer(value)) {
            return cloneBuffer(value, isDeep);
          }
          if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result2 = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) {
              return isFlat ? copySymbolsIn(value, baseAssignIn(result2, value)) : copySymbols(value, baseAssign(result2, value));
            }
          } else {
            if (!cloneableTags[tag]) {
              return object ? value : {};
            }
            result2 = initCloneByTag(value, tag, isDeep);
          }
        }
        stack || (stack = new Stack());
        var stacked = stack.get(value);
        if (stacked) {
          return stacked;
        }
        stack.set(value, result2);
        if (isSet(value)) {
          value.forEach(function(subValue) {
            result2.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
          });
        } else if (isMap(value)) {
          value.forEach(function(subValue, key2) {
            result2.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
          });
        }
        var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
        var props = isArr ? undefined$1 : keysFunc(value);
        arrayEach(props || value, function(subValue, key2) {
          if (props) {
            key2 = subValue;
            subValue = value[key2];
          }
          assignValue(result2, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
        });
        return result2;
      }
      function baseConforms(source) {
        var props = keys(source);
        return function(object) {
          return baseConformsTo(object, source, props);
        };
      }
      function baseConformsTo(object, source, props) {
        var length2 = props.length;
        if (object == null) {
          return !length2;
        }
        object = Object2(object);
        while (length2--) {
          var key = props[length2], predicate = source[key], value = object[key];
          if (value === undefined$1 && !(key in object) || !predicate(value)) {
            return false;
          }
        }
        return true;
      }
      function baseDelay(func, wait, args) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        return setTimeout2(function() {
          func.apply(undefined$1, args);
        }, wait);
      }
      function baseDifference(array, values2, iteratee2, comparator) {
        var index2 = -1, includes2 = arrayIncludes, isCommon = true, length2 = array.length, result2 = [], valuesLength = values2.length;
        if (!length2) {
          return result2;
        }
        if (iteratee2) {
          values2 = arrayMap(values2, baseUnary(iteratee2));
        }
        if (comparator) {
          includes2 = arrayIncludesWith;
          isCommon = false;
        } else if (values2.length >= LARGE_ARRAY_SIZE) {
          includes2 = cacheHas;
          isCommon = false;
          values2 = new SetCache(values2);
        }
        outer:
          while (++index2 < length2) {
            var value = array[index2], computed = iteratee2 == null ? value : iteratee2(value);
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed === computed) {
              var valuesIndex = valuesLength;
              while (valuesIndex--) {
                if (values2[valuesIndex] === computed) {
                  continue outer;
                }
              }
              result2.push(value);
            } else if (!includes2(values2, computed, comparator)) {
              result2.push(value);
            }
          }
        return result2;
      }
      var baseEach = createBaseEach(baseForOwn);
      var baseEachRight = createBaseEach(baseForOwnRight, true);
      function baseEvery(collection, predicate) {
        var result2 = true;
        baseEach(collection, function(value, index2, collection2) {
          result2 = !!predicate(value, index2, collection2);
          return result2;
        });
        return result2;
      }
      function baseExtremum(array, iteratee2, comparator) {
        var index2 = -1, length2 = array.length;
        while (++index2 < length2) {
          var value = array[index2], current = iteratee2(value);
          if (current != null && (computed === undefined$1 ? current === current && !isSymbol2(current) : comparator(current, computed))) {
            var computed = current, result2 = value;
          }
        }
        return result2;
      }
      function baseFill(array, value, start2, end2) {
        var length2 = array.length;
        start2 = toInteger(start2);
        if (start2 < 0) {
          start2 = -start2 > length2 ? 0 : length2 + start2;
        }
        end2 = end2 === undefined$1 || end2 > length2 ? length2 : toInteger(end2);
        if (end2 < 0) {
          end2 += length2;
        }
        end2 = start2 > end2 ? 0 : toLength(end2);
        while (start2 < end2) {
          array[start2++] = value;
        }
        return array;
      }
      function baseFilter(collection, predicate) {
        var result2 = [];
        baseEach(collection, function(value, index2, collection2) {
          if (predicate(value, index2, collection2)) {
            result2.push(value);
          }
        });
        return result2;
      }
      function baseFlatten(array, depth, predicate, isStrict, result2) {
        var index2 = -1, length2 = array.length;
        predicate || (predicate = isFlattenable);
        result2 || (result2 = []);
        while (++index2 < length2) {
          var value = array[index2];
          if (depth > 0 && predicate(value)) {
            if (depth > 1) {
              baseFlatten(value, depth - 1, predicate, isStrict, result2);
            } else {
              arrayPush(result2, value);
            }
          } else if (!isStrict) {
            result2[result2.length] = value;
          }
        }
        return result2;
      }
      var baseFor = createBaseFor();
      var baseForRight = createBaseFor(true);
      function baseForOwn(object, iteratee2) {
        return object && baseFor(object, iteratee2, keys);
      }
      function baseForOwnRight(object, iteratee2) {
        return object && baseForRight(object, iteratee2, keys);
      }
      function baseFunctions(object, props) {
        return arrayFilter(props, function(key) {
          return isFunction2(object[key]);
        });
      }
      function baseGet(object, path) {
        path = castPath(path, object);
        var index2 = 0, length2 = path.length;
        while (object != null && index2 < length2) {
          object = object[toKey(path[index2++])];
        }
        return index2 && index2 == length2 ? object : undefined$1;
      }
      function baseGetAllKeys(object, keysFunc, symbolsFunc) {
        var result2 = keysFunc(object);
        return isArray2(object) ? result2 : arrayPush(result2, symbolsFunc(object));
      }
      function baseGetTag(value) {
        if (value == null) {
          return value === undefined$1 ? undefinedTag : nullTag;
        }
        return symToStringTag && symToStringTag in Object2(value) ? getRawTag(value) : objectToString2(value);
      }
      function baseGt(value, other) {
        return value > other;
      }
      function baseHas(object, key) {
        return object != null && hasOwnProperty2.call(object, key);
      }
      function baseHasIn(object, key) {
        return object != null && key in Object2(object);
      }
      function baseInRange(number, start2, end2) {
        return number >= nativeMin2(start2, end2) && number < nativeMax2(start2, end2);
      }
      function baseIntersection(arrays, iteratee2, comparator) {
        var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length2 = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result2 = [];
        while (othIndex--) {
          var array = arrays[othIndex];
          if (othIndex && iteratee2) {
            array = arrayMap(array, baseUnary(iteratee2));
          }
          maxLength = nativeMin2(array.length, maxLength);
          caches[othIndex] = !comparator && (iteratee2 || length2 >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined$1;
        }
        array = arrays[0];
        var index2 = -1, seen = caches[0];
        outer:
          while (++index2 < length2 && result2.length < maxLength) {
            var value = array[index2], computed = iteratee2 ? iteratee2(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (!(seen ? cacheHas(seen, computed) : includes2(result2, computed, comparator))) {
              othIndex = othLength;
              while (--othIndex) {
                var cache = caches[othIndex];
                if (!(cache ? cacheHas(cache, computed) : includes2(arrays[othIndex], computed, comparator))) {
                  continue outer;
                }
              }
              if (seen) {
                seen.push(computed);
              }
              result2.push(value);
            }
          }
        return result2;
      }
      function baseInverter(object, setter, iteratee2, accumulator) {
        baseForOwn(object, function(value, key, object2) {
          setter(accumulator, iteratee2(value), key, object2);
        });
        return accumulator;
      }
      function baseInvoke(object, path, args) {
        path = castPath(path, object);
        object = parent(object, path);
        var func = object == null ? object : object[toKey(last(path))];
        return func == null ? undefined$1 : apply(func, object, args);
      }
      function baseIsArguments(value) {
        return isObjectLike2(value) && baseGetTag(value) == argsTag;
      }
      function baseIsArrayBuffer(value) {
        return isObjectLike2(value) && baseGetTag(value) == arrayBufferTag;
      }
      function baseIsDate(value) {
        return isObjectLike2(value) && baseGetTag(value) == dateTag;
      }
      function baseIsEqual(value, other, bitmask, customizer, stack) {
        if (value === other) {
          return true;
        }
        if (value == null || other == null || !isObjectLike2(value) && !isObjectLike2(other)) {
          return value !== value && other !== other;
        }
        return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
      }
      function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
        var objIsArr = isArray2(object), othIsArr = isArray2(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
        objTag = objTag == argsTag ? objectTag : objTag;
        othTag = othTag == argsTag ? objectTag : othTag;
        var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
        if (isSameTag && isBuffer(object)) {
          if (!isBuffer(other)) {
            return false;
          }
          objIsArr = true;
          objIsObj = false;
        }
        if (isSameTag && !objIsObj) {
          stack || (stack = new Stack());
          return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
        }
        if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
          var objIsWrapped = objIsObj && hasOwnProperty2.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");
          if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack());
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
          }
        }
        if (!isSameTag) {
          return false;
        }
        stack || (stack = new Stack());
        return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
      }
      function baseIsMap(value) {
        return isObjectLike2(value) && getTag(value) == mapTag;
      }
      function baseIsMatch(object, source, matchData, customizer) {
        var index2 = matchData.length, length2 = index2, noCustomizer = !customizer;
        if (object == null) {
          return !length2;
        }
        object = Object2(object);
        while (index2--) {
          var data = matchData[index2];
          if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
            return false;
          }
        }
        while (++index2 < length2) {
          data = matchData[index2];
          var key = data[0], objValue = object[key], srcValue = data[1];
          if (noCustomizer && data[2]) {
            if (objValue === undefined$1 && !(key in object)) {
              return false;
            }
          } else {
            var stack = new Stack();
            if (customizer) {
              var result2 = customizer(objValue, srcValue, key, object, source, stack);
            }
            if (!(result2 === undefined$1 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result2)) {
              return false;
            }
          }
        }
        return true;
      }
      function baseIsNative(value) {
        if (!isObject2(value) || isMasked(value)) {
          return false;
        }
        var pattern = isFunction2(value) ? reIsNative : reIsHostCtor;
        return pattern.test(toSource(value));
      }
      function baseIsRegExp(value) {
        return isObjectLike2(value) && baseGetTag(value) == regexpTag;
      }
      function baseIsSet(value) {
        return isObjectLike2(value) && getTag(value) == setTag;
      }
      function baseIsTypedArray(value) {
        return isObjectLike2(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
      }
      function baseIteratee(value) {
        if (typeof value == "function") {
          return value;
        }
        if (value == null) {
          return identity;
        }
        if (typeof value == "object") {
          return isArray2(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
        }
        return property(value);
      }
      function baseKeys(object) {
        if (!isPrototype(object)) {
          return nativeKeys(object);
        }
        var result2 = [];
        for (var key in Object2(object)) {
          if (hasOwnProperty2.call(object, key) && key != "constructor") {
            result2.push(key);
          }
        }
        return result2;
      }
      function baseKeysIn(object) {
        if (!isObject2(object)) {
          return nativeKeysIn(object);
        }
        var isProto = isPrototype(object), result2 = [];
        for (var key in object) {
          if (!(key == "constructor" && (isProto || !hasOwnProperty2.call(object, key)))) {
            result2.push(key);
          }
        }
        return result2;
      }
      function baseLt(value, other) {
        return value < other;
      }
      function baseMap(collection, iteratee2) {
        var index2 = -1, result2 = isArrayLike(collection) ? Array2(collection.length) : [];
        baseEach(collection, function(value, key, collection2) {
          result2[++index2] = iteratee2(value, key, collection2);
        });
        return result2;
      }
      function baseMatches(source) {
        var matchData = getMatchData(source);
        if (matchData.length == 1 && matchData[0][2]) {
          return matchesStrictComparable(matchData[0][0], matchData[0][1]);
        }
        return function(object) {
          return object === source || baseIsMatch(object, source, matchData);
        };
      }
      function baseMatchesProperty(path, srcValue) {
        if (isKey(path) && isStrictComparable(srcValue)) {
          return matchesStrictComparable(toKey(path), srcValue);
        }
        return function(object) {
          var objValue = get(object, path);
          return objValue === undefined$1 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
        };
      }
      function baseMerge(object, source, srcIndex, customizer, stack) {
        if (object === source) {
          return;
        }
        baseFor(source, function(srcValue, key) {
          stack || (stack = new Stack());
          if (isObject2(srcValue)) {
            baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
          } else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined$1;
            if (newValue === undefined$1) {
              newValue = srcValue;
            }
            assignMergeValue(object, key, newValue);
          }
        }, keysIn);
      }
      function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
        var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
        if (stacked) {
          assignMergeValue(object, key, stacked);
          return;
        }
        var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined$1;
        var isCommon = newValue === undefined$1;
        if (isCommon) {
          var isArr = isArray2(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
          newValue = srcValue;
          if (isArr || isBuff || isTyped) {
            if (isArray2(objValue)) {
              newValue = objValue;
            } else if (isArrayLikeObject(objValue)) {
              newValue = copyArray(objValue);
            } else if (isBuff) {
              isCommon = false;
              newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
              isCommon = false;
              newValue = cloneTypedArray(srcValue, true);
            } else {
              newValue = [];
            }
          } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) {
              newValue = toPlainObject(objValue);
            } else if (!isObject2(objValue) || isFunction2(objValue)) {
              newValue = initCloneObject(srcValue);
            }
          } else {
            isCommon = false;
          }
        }
        if (isCommon) {
          stack.set(srcValue, newValue);
          mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
          stack["delete"](srcValue);
        }
        assignMergeValue(object, key, newValue);
      }
      function baseNth(array, n2) {
        var length2 = array.length;
        if (!length2) {
          return;
        }
        n2 += n2 < 0 ? length2 : 0;
        return isIndex(n2, length2) ? array[n2] : undefined$1;
      }
      function baseOrderBy(collection, iteratees, orders) {
        if (iteratees.length) {
          iteratees = arrayMap(iteratees, function(iteratee2) {
            if (isArray2(iteratee2)) {
              return function(value) {
                return baseGet(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
              };
            }
            return iteratee2;
          });
        } else {
          iteratees = [identity];
        }
        var index2 = -1;
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        var result2 = baseMap(collection, function(value, key, collection2) {
          var criteria = arrayMap(iteratees, function(iteratee2) {
            return iteratee2(value);
          });
          return { "criteria": criteria, "index": ++index2, "value": value };
        });
        return baseSortBy(result2, function(object, other) {
          return compareMultiple(object, other, orders);
        });
      }
      function basePick(object, paths2) {
        return basePickBy(object, paths2, function(value, path) {
          return hasIn(object, path);
        });
      }
      function basePickBy(object, paths2, predicate) {
        var index2 = -1, length2 = paths2.length, result2 = {};
        while (++index2 < length2) {
          var path = paths2[index2], value = baseGet(object, path);
          if (predicate(value, path)) {
            baseSet(result2, castPath(path, object), value);
          }
        }
        return result2;
      }
      function basePropertyDeep(path) {
        return function(object) {
          return baseGet(object, path);
        };
      }
      function basePullAll(array, values2, iteratee2, comparator) {
        var indexOf2 = comparator ? baseIndexOfWith : baseIndexOf, index2 = -1, length2 = values2.length, seen = array;
        if (array === values2) {
          values2 = copyArray(values2);
        }
        if (iteratee2) {
          seen = arrayMap(array, baseUnary(iteratee2));
        }
        while (++index2 < length2) {
          var fromIndex = 0, value = values2[index2], computed = iteratee2 ? iteratee2(value) : value;
          while ((fromIndex = indexOf2(seen, computed, fromIndex, comparator)) > -1) {
            if (seen !== array) {
              splice.call(seen, fromIndex, 1);
            }
            splice.call(array, fromIndex, 1);
          }
        }
        return array;
      }
      function basePullAt(array, indexes) {
        var length2 = array ? indexes.length : 0, lastIndex = length2 - 1;
        while (length2--) {
          var index2 = indexes[length2];
          if (length2 == lastIndex || index2 !== previous) {
            var previous = index2;
            if (isIndex(index2)) {
              splice.call(array, index2, 1);
            } else {
              baseUnset(array, index2);
            }
          }
        }
        return array;
      }
      function baseRandom(lower, upper) {
        return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
      }
      function baseRange(start2, end2, step, fromRight) {
        var index2 = -1, length2 = nativeMax2(nativeCeil((end2 - start2) / (step || 1)), 0), result2 = Array2(length2);
        while (length2--) {
          result2[fromRight ? length2 : ++index2] = start2;
          start2 += step;
        }
        return result2;
      }
      function baseRepeat(string, n2) {
        var result2 = "";
        if (!string || n2 < 1 || n2 > MAX_SAFE_INTEGER) {
          return result2;
        }
        do {
          if (n2 % 2) {
            result2 += string;
          }
          n2 = nativeFloor(n2 / 2);
          if (n2) {
            string += string;
          }
        } while (n2);
        return result2;
      }
      function baseRest(func, start2) {
        return setToString(overRest(func, start2, identity), func + "");
      }
      function baseSample(collection) {
        return arraySample(values(collection));
      }
      function baseSampleSize(collection, n2) {
        var array = values(collection);
        return shuffleSelf(array, baseClamp(n2, 0, array.length));
      }
      function baseSet(object, path, value, customizer) {
        if (!isObject2(object)) {
          return object;
        }
        path = castPath(path, object);
        var index2 = -1, length2 = path.length, lastIndex = length2 - 1, nested = object;
        while (nested != null && ++index2 < length2) {
          var key = toKey(path[index2]), newValue = value;
          if (key === "__proto__" || key === "constructor" || key === "prototype") {
            return object;
          }
          if (index2 != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
            if (newValue === undefined$1) {
              newValue = isObject2(objValue) ? objValue : isIndex(path[index2 + 1]) ? [] : {};
            }
          }
          assignValue(nested, key, newValue);
          nested = nested[key];
        }
        return object;
      }
      var baseSetData = !metaMap ? identity : function(func, data) {
        metaMap.set(func, data);
        return func;
      };
      var baseSetToString = !defineProperty ? identity : function(func, string) {
        return defineProperty(func, "toString", {
          "configurable": true,
          "enumerable": false,
          "value": constant(string),
          "writable": true
        });
      };
      function baseShuffle(collection) {
        return shuffleSelf(values(collection));
      }
      function baseSlice(array, start2, end2) {
        var index2 = -1, length2 = array.length;
        if (start2 < 0) {
          start2 = -start2 > length2 ? 0 : length2 + start2;
        }
        end2 = end2 > length2 ? length2 : end2;
        if (end2 < 0) {
          end2 += length2;
        }
        length2 = start2 > end2 ? 0 : end2 - start2 >>> 0;
        start2 >>>= 0;
        var result2 = Array2(length2);
        while (++index2 < length2) {
          result2[index2] = array[index2 + start2];
        }
        return result2;
      }
      function baseSome(collection, predicate) {
        var result2;
        baseEach(collection, function(value, index2, collection2) {
          result2 = predicate(value, index2, collection2);
          return !result2;
        });
        return !!result2;
      }
      function baseSortedIndex(array, value, retHighest) {
        var low = 0, high = array == null ? low : array.length;
        if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
          while (low < high) {
            var mid = low + high >>> 1, computed = array[mid];
            if (computed !== null && !isSymbol2(computed) && (retHighest ? computed <= value : computed < value)) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return high;
        }
        return baseSortedIndexBy(array, value, identity, retHighest);
      }
      function baseSortedIndexBy(array, value, iteratee2, retHighest) {
        var low = 0, high = array == null ? 0 : array.length;
        if (high === 0) {
          return 0;
        }
        value = iteratee2(value);
        var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol2(value), valIsUndefined = value === undefined$1;
        while (low < high) {
          var mid = nativeFloor((low + high) / 2), computed = iteratee2(array[mid]), othIsDefined = computed !== undefined$1, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol2(computed);
          if (valIsNaN) {
            var setLow = retHighest || othIsReflexive;
          } else if (valIsUndefined) {
            setLow = othIsReflexive && (retHighest || othIsDefined);
          } else if (valIsNull) {
            setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
          } else if (valIsSymbol) {
            setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
          } else if (othIsNull || othIsSymbol) {
            setLow = false;
          } else {
            setLow = retHighest ? computed <= value : computed < value;
          }
          if (setLow) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return nativeMin2(high, MAX_ARRAY_INDEX);
      }
      function baseSortedUniq(array, iteratee2) {
        var index2 = -1, length2 = array.length, resIndex = 0, result2 = [];
        while (++index2 < length2) {
          var value = array[index2], computed = iteratee2 ? iteratee2(value) : value;
          if (!index2 || !eq(computed, seen)) {
            var seen = computed;
            result2[resIndex++] = value === 0 ? 0 : value;
          }
        }
        return result2;
      }
      function baseToNumber(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol2(value)) {
          return NAN2;
        }
        return +value;
      }
      function baseToString(value) {
        if (typeof value == "string") {
          return value;
        }
        if (isArray2(value)) {
          return arrayMap(value, baseToString) + "";
        }
        if (isSymbol2(value)) {
          return symbolToString ? symbolToString.call(value) : "";
        }
        var result2 = value + "";
        return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
      }
      function baseUniq(array, iteratee2, comparator) {
        var index2 = -1, includes2 = arrayIncludes, length2 = array.length, isCommon = true, result2 = [], seen = result2;
        if (comparator) {
          isCommon = false;
          includes2 = arrayIncludesWith;
        } else if (length2 >= LARGE_ARRAY_SIZE) {
          var set2 = iteratee2 ? null : createSet(array);
          if (set2) {
            return setToArray(set2);
          }
          isCommon = false;
          includes2 = cacheHas;
          seen = new SetCache();
        } else {
          seen = iteratee2 ? [] : result2;
        }
        outer:
          while (++index2 < length2) {
            var value = array[index2], computed = iteratee2 ? iteratee2(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed === computed) {
              var seenIndex = seen.length;
              while (seenIndex--) {
                if (seen[seenIndex] === computed) {
                  continue outer;
                }
              }
              if (iteratee2) {
                seen.push(computed);
              }
              result2.push(value);
            } else if (!includes2(seen, computed, comparator)) {
              if (seen !== result2) {
                seen.push(computed);
              }
              result2.push(value);
            }
          }
        return result2;
      }
      function baseUnset(object, path) {
        path = castPath(path, object);
        object = parent(object, path);
        return object == null || delete object[toKey(last(path))];
      }
      function baseUpdate(object, path, updater, customizer) {
        return baseSet(object, path, updater(baseGet(object, path)), customizer);
      }
      function baseWhile(array, predicate, isDrop, fromRight) {
        var length2 = array.length, index2 = fromRight ? length2 : -1;
        while ((fromRight ? index2-- : ++index2 < length2) && predicate(array[index2], index2, array)) {
        }
        return isDrop ? baseSlice(array, fromRight ? 0 : index2, fromRight ? index2 + 1 : length2) : baseSlice(array, fromRight ? index2 + 1 : 0, fromRight ? length2 : index2);
      }
      function baseWrapperValue(value, actions) {
        var result2 = value;
        if (result2 instanceof LazyWrapper) {
          result2 = result2.value();
        }
        return arrayReduce(actions, function(result3, action) {
          return action.func.apply(action.thisArg, arrayPush([result3], action.args));
        }, result2);
      }
      function baseXor(arrays, iteratee2, comparator) {
        var length2 = arrays.length;
        if (length2 < 2) {
          return length2 ? baseUniq(arrays[0]) : [];
        }
        var index2 = -1, result2 = Array2(length2);
        while (++index2 < length2) {
          var array = arrays[index2], othIndex = -1;
          while (++othIndex < length2) {
            if (othIndex != index2) {
              result2[index2] = baseDifference(result2[index2] || array, arrays[othIndex], iteratee2, comparator);
            }
          }
        }
        return baseUniq(baseFlatten(result2, 1), iteratee2, comparator);
      }
      function baseZipObject(props, values2, assignFunc) {
        var index2 = -1, length2 = props.length, valsLength = values2.length, result2 = {};
        while (++index2 < length2) {
          var value = index2 < valsLength ? values2[index2] : undefined$1;
          assignFunc(result2, props[index2], value);
        }
        return result2;
      }
      function castArrayLikeObject(value) {
        return isArrayLikeObject(value) ? value : [];
      }
      function castFunction(value) {
        return typeof value == "function" ? value : identity;
      }
      function castPath(value, object) {
        if (isArray2(value)) {
          return value;
        }
        return isKey(value, object) ? [value] : stringToPath(toString(value));
      }
      var castRest = baseRest;
      function castSlice(array, start2, end2) {
        var length2 = array.length;
        end2 = end2 === undefined$1 ? length2 : end2;
        return !start2 && end2 >= length2 ? array : baseSlice(array, start2, end2);
      }
      var clearTimeout2 = ctxClearTimeout || function(id) {
        return root2.clearTimeout(id);
      };
      function cloneBuffer(buffer, isDeep) {
        if (isDeep) {
          return buffer.slice();
        }
        var length2 = buffer.length, result2 = allocUnsafe ? allocUnsafe(length2) : new buffer.constructor(length2);
        buffer.copy(result2);
        return result2;
      }
      function cloneArrayBuffer(arrayBuffer) {
        var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
        new Uint8Array2(result2).set(new Uint8Array2(arrayBuffer));
        return result2;
      }
      function cloneDataView(dataView, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
        return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
      }
      function cloneRegExp(regexp) {
        var result2 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
        result2.lastIndex = regexp.lastIndex;
        return result2;
      }
      function cloneSymbol(symbol) {
        return symbolValueOf ? Object2(symbolValueOf.call(symbol)) : {};
      }
      function cloneTypedArray(typedArray, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
        return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
      }
      function compareAscending(value, other) {
        if (value !== other) {
          var valIsDefined = value !== undefined$1, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol2(value);
          var othIsDefined = other !== undefined$1, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol2(other);
          if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
            return 1;
          }
          if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
            return -1;
          }
        }
        return 0;
      }
      function compareMultiple(object, other, orders) {
        var index2 = -1, objCriteria = object.criteria, othCriteria = other.criteria, length2 = objCriteria.length, ordersLength = orders.length;
        while (++index2 < length2) {
          var result2 = compareAscending(objCriteria[index2], othCriteria[index2]);
          if (result2) {
            if (index2 >= ordersLength) {
              return result2;
            }
            var order2 = orders[index2];
            return result2 * (order2 == "desc" ? -1 : 1);
          }
        }
        return object.index - other.index;
      }
      function composeArgs(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax2(argsLength - holdersLength, 0), result2 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
        while (++leftIndex < leftLength) {
          result2[leftIndex] = partials[leftIndex];
        }
        while (++argsIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result2[holders[argsIndex]] = args[argsIndex];
          }
        }
        while (rangeLength--) {
          result2[leftIndex++] = args[argsIndex++];
        }
        return result2;
      }
      function composeArgsRight(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax2(argsLength - holdersLength, 0), result2 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
        while (++argsIndex < rangeLength) {
          result2[argsIndex] = args[argsIndex];
        }
        var offset2 = argsIndex;
        while (++rightIndex < rightLength) {
          result2[offset2 + rightIndex] = partials[rightIndex];
        }
        while (++holdersIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result2[offset2 + holders[holdersIndex]] = args[argsIndex++];
          }
        }
        return result2;
      }
      function copyArray(source, array) {
        var index2 = -1, length2 = source.length;
        array || (array = Array2(length2));
        while (++index2 < length2) {
          array[index2] = source[index2];
        }
        return array;
      }
      function copyObject(source, props, object, customizer) {
        var isNew = !object;
        object || (object = {});
        var index2 = -1, length2 = props.length;
        while (++index2 < length2) {
          var key = props[index2];
          var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined$1;
          if (newValue === undefined$1) {
            newValue = source[key];
          }
          if (isNew) {
            baseAssignValue(object, key, newValue);
          } else {
            assignValue(object, key, newValue);
          }
        }
        return object;
      }
      function copySymbols(source, object) {
        return copyObject(source, getSymbols(source), object);
      }
      function copySymbolsIn(source, object) {
        return copyObject(source, getSymbolsIn(source), object);
      }
      function createAggregator(setter, initializer) {
        return function(collection, iteratee2) {
          var func = isArray2(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
          return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
        };
      }
      function createAssigner(assigner) {
        return baseRest(function(object, sources) {
          var index2 = -1, length2 = sources.length, customizer = length2 > 1 ? sources[length2 - 1] : undefined$1, guard = length2 > 2 ? sources[2] : undefined$1;
          customizer = assigner.length > 3 && typeof customizer == "function" ? (length2--, customizer) : undefined$1;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length2 < 3 ? undefined$1 : customizer;
            length2 = 1;
          }
          object = Object2(object);
          while (++index2 < length2) {
            var source = sources[index2];
            if (source) {
              assigner(object, source, index2, customizer);
            }
          }
          return object;
        });
      }
      function createBaseEach(eachFunc, fromRight) {
        return function(collection, iteratee2) {
          if (collection == null) {
            return collection;
          }
          if (!isArrayLike(collection)) {
            return eachFunc(collection, iteratee2);
          }
          var length2 = collection.length, index2 = fromRight ? length2 : -1, iterable = Object2(collection);
          while (fromRight ? index2-- : ++index2 < length2) {
            if (iteratee2(iterable[index2], index2, iterable) === false) {
              break;
            }
          }
          return collection;
        };
      }
      function createBaseFor(fromRight) {
        return function(object, iteratee2, keysFunc) {
          var index2 = -1, iterable = Object2(object), props = keysFunc(object), length2 = props.length;
          while (length2--) {
            var key = props[fromRight ? length2 : ++index2];
            if (iteratee2(iterable[key], key, iterable) === false) {
              break;
            }
          }
          return object;
        };
      }
      function createBind(func, bitmask, thisArg) {
        var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
        function wrapper() {
          var fn3 = this && this !== root2 && this instanceof wrapper ? Ctor : func;
          return fn3.apply(isBind ? thisArg : this, arguments);
        }
        return wrapper;
      }
      function createCaseFirst(methodName) {
        return function(string) {
          string = toString(string);
          var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined$1;
          var chr = strSymbols ? strSymbols[0] : string.charAt(0);
          var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
          return chr[methodName]() + trailing;
        };
      }
      function createCompounder(callback) {
        return function(string) {
          return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
        };
      }
      function createCtor(Ctor) {
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return new Ctor();
            case 1:
              return new Ctor(args[0]);
            case 2:
              return new Ctor(args[0], args[1]);
            case 3:
              return new Ctor(args[0], args[1], args[2]);
            case 4:
              return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
              return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
          }
          var thisBinding = baseCreate(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
          return isObject2(result2) ? result2 : thisBinding;
        };
      }
      function createCurry(func, bitmask, arity) {
        var Ctor = createCtor(func);
        function wrapper() {
          var length2 = arguments.length, args = Array2(length2), index2 = length2, placeholder = getHolder(wrapper);
          while (index2--) {
            args[index2] = arguments[index2];
          }
          var holders = length2 < 3 && args[0] !== placeholder && args[length2 - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
          length2 -= holders.length;
          if (length2 < arity) {
            return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined$1, args, holders, undefined$1, undefined$1, arity - length2);
          }
          var fn3 = this && this !== root2 && this instanceof wrapper ? Ctor : func;
          return apply(fn3, this, args);
        }
        return wrapper;
      }
      function createFind(findIndexFunc) {
        return function(collection, predicate, fromIndex) {
          var iterable = Object2(collection);
          if (!isArrayLike(collection)) {
            var iteratee2 = getIteratee(predicate, 3);
            collection = keys(collection);
            predicate = function(key) {
              return iteratee2(iterable[key], key, iterable);
            };
          }
          var index2 = findIndexFunc(collection, predicate, fromIndex);
          return index2 > -1 ? iterable[iteratee2 ? collection[index2] : index2] : undefined$1;
        };
      }
      function createFlow(fromRight) {
        return flatRest(function(funcs) {
          var length2 = funcs.length, index2 = length2, prereq = LodashWrapper.prototype.thru;
          if (fromRight) {
            funcs.reverse();
          }
          while (index2--) {
            var func = funcs[index2];
            if (typeof func != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT2);
            }
            if (prereq && !wrapper && getFuncName(func) == "wrapper") {
              var wrapper = new LodashWrapper([], true);
            }
          }
          index2 = wrapper ? index2 : length2;
          while (++index2 < length2) {
            func = funcs[index2];
            var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined$1;
            if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
              wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
            } else {
              wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
            }
          }
          return function() {
            var args = arguments, value = args[0];
            if (wrapper && args.length == 1 && isArray2(value)) {
              return wrapper.plant(value).value();
            }
            var index3 = 0, result2 = length2 ? funcs[index3].apply(this, args) : value;
            while (++index3 < length2) {
              result2 = funcs[index3].call(this, result2);
            }
            return result2;
          };
        });
      }
      function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
        var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined$1 : createCtor(func);
        function wrapper() {
          var length2 = arguments.length, args = Array2(length2), index2 = length2;
          while (index2--) {
            args[index2] = arguments[index2];
          }
          if (isCurried) {
            var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
          }
          if (partials) {
            args = composeArgs(args, partials, holders, isCurried);
          }
          if (partialsRight) {
            args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
          }
          length2 -= holdersCount;
          if (isCurried && length2 < arity) {
            var newHolders = replaceHolders(args, placeholder);
            return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary2, arity - length2);
          }
          var thisBinding = isBind ? thisArg : this, fn3 = isBindKey ? thisBinding[func] : func;
          length2 = args.length;
          if (argPos) {
            args = reorder(args, argPos);
          } else if (isFlip && length2 > 1) {
            args.reverse();
          }
          if (isAry && ary2 < length2) {
            args.length = ary2;
          }
          if (this && this !== root2 && this instanceof wrapper) {
            fn3 = Ctor || createCtor(fn3);
          }
          return fn3.apply(thisBinding, args);
        }
        return wrapper;
      }
      function createInverter(setter, toIteratee) {
        return function(object, iteratee2) {
          return baseInverter(object, setter, toIteratee(iteratee2), {});
        };
      }
      function createMathOperation(operator, defaultValue) {
        return function(value, other) {
          var result2;
          if (value === undefined$1 && other === undefined$1) {
            return defaultValue;
          }
          if (value !== undefined$1) {
            result2 = value;
          }
          if (other !== undefined$1) {
            if (result2 === undefined$1) {
              return other;
            }
            if (typeof value == "string" || typeof other == "string") {
              value = baseToString(value);
              other = baseToString(other);
            } else {
              value = baseToNumber(value);
              other = baseToNumber(other);
            }
            result2 = operator(value, other);
          }
          return result2;
        };
      }
      function createOver(arrayFunc) {
        return flatRest(function(iteratees) {
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          return baseRest(function(args) {
            var thisArg = this;
            return arrayFunc(iteratees, function(iteratee2) {
              return apply(iteratee2, thisArg, args);
            });
          });
        });
      }
      function createPadding(length2, chars) {
        chars = chars === undefined$1 ? " " : baseToString(chars);
        var charsLength = chars.length;
        if (charsLength < 2) {
          return charsLength ? baseRepeat(chars, length2) : chars;
        }
        var result2 = baseRepeat(chars, nativeCeil(length2 / stringSize(chars)));
        return hasUnicode(chars) ? castSlice(stringToArray(result2), 0, length2).join("") : result2.slice(0, length2);
      }
      function createPartial(func, bitmask, thisArg, partials) {
        var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
        function wrapper() {
          var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn3 = this && this !== root2 && this instanceof wrapper ? Ctor : func;
          while (++leftIndex < leftLength) {
            args[leftIndex] = partials[leftIndex];
          }
          while (argsLength--) {
            args[leftIndex++] = arguments[++argsIndex];
          }
          return apply(fn3, isBind ? thisArg : this, args);
        }
        return wrapper;
      }
      function createRange(fromRight) {
        return function(start2, end2, step) {
          if (step && typeof step != "number" && isIterateeCall(start2, end2, step)) {
            end2 = step = undefined$1;
          }
          start2 = toFinite(start2);
          if (end2 === undefined$1) {
            end2 = start2;
            start2 = 0;
          } else {
            end2 = toFinite(end2);
          }
          step = step === undefined$1 ? start2 < end2 ? 1 : -1 : toFinite(step);
          return baseRange(start2, end2, step, fromRight);
        };
      }
      function createRelationalOperation(operator) {
        return function(value, other) {
          if (!(typeof value == "string" && typeof other == "string")) {
            value = toNumber2(value);
            other = toNumber2(other);
          }
          return operator(value, other);
        };
      }
      function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
        var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined$1, newHoldersRight = isCurry ? undefined$1 : holders, newPartials = isCurry ? partials : undefined$1, newPartialsRight = isCurry ? undefined$1 : partials;
        bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
        bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
        if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
          bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
        }
        var newData = [
          func,
          bitmask,
          thisArg,
          newPartials,
          newHolders,
          newPartialsRight,
          newHoldersRight,
          argPos,
          ary2,
          arity
        ];
        var result2 = wrapFunc.apply(undefined$1, newData);
        if (isLaziable(func)) {
          setData(result2, newData);
        }
        result2.placeholder = placeholder;
        return setWrapToString(result2, func, bitmask);
      }
      function createRound(methodName) {
        var func = Math2[methodName];
        return function(number, precision) {
          number = toNumber2(number);
          precision = precision == null ? 0 : nativeMin2(toInteger(precision), 292);
          if (precision && nativeIsFinite(number)) {
            var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
            pair = (toString(value) + "e").split("e");
            return +(pair[0] + "e" + (+pair[1] - precision));
          }
          return func(number);
        };
      }
      var createSet = !(Set2 && 1 / setToArray(new Set2([, -0]))[1] == INFINITY) ? noop4 : function(values2) {
        return new Set2(values2);
      };
      function createToPairs(keysFunc) {
        return function(object) {
          var tag = getTag(object);
          if (tag == mapTag) {
            return mapToArray(object);
          }
          if (tag == setTag) {
            return setToPairs(object);
          }
          return baseToPairs(object, keysFunc(object));
        };
      }
      function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
        var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
        if (!isBindKey && typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        var length2 = partials ? partials.length : 0;
        if (!length2) {
          bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
          partials = holders = undefined$1;
        }
        ary2 = ary2 === undefined$1 ? ary2 : nativeMax2(toInteger(ary2), 0);
        arity = arity === undefined$1 ? arity : toInteger(arity);
        length2 -= holders ? holders.length : 0;
        if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
          var partialsRight = partials, holdersRight = holders;
          partials = holders = undefined$1;
        }
        var data = isBindKey ? undefined$1 : getData(func);
        var newData = [
          func,
          bitmask,
          thisArg,
          partials,
          holders,
          partialsRight,
          holdersRight,
          argPos,
          ary2,
          arity
        ];
        if (data) {
          mergeData(newData, data);
        }
        func = newData[0];
        bitmask = newData[1];
        thisArg = newData[2];
        partials = newData[3];
        holders = newData[4];
        arity = newData[9] = newData[9] === undefined$1 ? isBindKey ? 0 : func.length : nativeMax2(newData[9] - length2, 0);
        if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
          bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
        }
        if (!bitmask || bitmask == WRAP_BIND_FLAG) {
          var result2 = createBind(func, bitmask, thisArg);
        } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
          result2 = createCurry(func, bitmask, arity);
        } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
          result2 = createPartial(func, bitmask, thisArg, partials);
        } else {
          result2 = createHybrid.apply(undefined$1, newData);
        }
        var setter = data ? baseSetData : setData;
        return setWrapToString(setter(result2, newData), func, bitmask);
      }
      function customDefaultsAssignIn(objValue, srcValue, key, object) {
        if (objValue === undefined$1 || eq(objValue, objectProto2[key]) && !hasOwnProperty2.call(object, key)) {
          return srcValue;
        }
        return objValue;
      }
      function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
        if (isObject2(objValue) && isObject2(srcValue)) {
          stack.set(srcValue, objValue);
          baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
          stack["delete"](srcValue);
        }
        return objValue;
      }
      function customOmitClone(value) {
        return isPlainObject(value) ? undefined$1 : value;
      }
      function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
        if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
          return false;
        }
        var arrStacked = stack.get(array);
        var othStacked = stack.get(other);
        if (arrStacked && othStacked) {
          return arrStacked == other && othStacked == array;
        }
        var index2 = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined$1;
        stack.set(array, other);
        stack.set(other, array);
        while (++index2 < arrLength) {
          var arrValue = array[index2], othValue = other[index2];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, arrValue, index2, other, array, stack) : customizer(arrValue, othValue, index2, array, other, stack);
          }
          if (compared !== undefined$1) {
            if (compared) {
              continue;
            }
            result2 = false;
            break;
          }
          if (seen) {
            if (!arraySome(other, function(othValue2, othIndex) {
              if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                return seen.push(othIndex);
              }
            })) {
              result2 = false;
              break;
            }
          } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result2 = false;
            break;
          }
        }
        stack["delete"](array);
        stack["delete"](other);
        return result2;
      }
      function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
        switch (tag) {
          case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
              return false;
            }
            object = object.buffer;
            other = other.buffer;
          case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
              return false;
            }
            return true;
          case boolTag:
          case dateTag:
          case numberTag:
            return eq(+object, +other);
          case errorTag:
            return object.name == other.name && object.message == other.message;
          case regexpTag:
          case stringTag:
            return object == other + "";
          case mapTag:
            var convert = mapToArray;
          case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) {
              return false;
            }
            var stacked = stack.get(object);
            if (stacked) {
              return stacked == other;
            }
            bitmask |= COMPARE_UNORDERED_FLAG;
            stack.set(object, other);
            var result2 = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result2;
          case symbolTag2:
            if (symbolValueOf) {
              return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
        }
        return false;
      }
      function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
        if (objLength != othLength && !isPartial) {
          return false;
        }
        var index2 = objLength;
        while (index2--) {
          var key = objProps[index2];
          if (!(isPartial ? key in other : hasOwnProperty2.call(other, key))) {
            return false;
          }
        }
        var objStacked = stack.get(object);
        var othStacked = stack.get(other);
        if (objStacked && othStacked) {
          return objStacked == other && othStacked == object;
        }
        var result2 = true;
        stack.set(object, other);
        stack.set(other, object);
        var skipCtor = isPartial;
        while (++index2 < objLength) {
          key = objProps[index2];
          var objValue = object[key], othValue = other[key];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
          }
          if (!(compared === undefined$1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result2 = false;
            break;
          }
          skipCtor || (skipCtor = key == "constructor");
        }
        if (result2 && !skipCtor) {
          var objCtor = object.constructor, othCtor = other.constructor;
          if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
            result2 = false;
          }
        }
        stack["delete"](object);
        stack["delete"](other);
        return result2;
      }
      function flatRest(func) {
        return setToString(overRest(func, undefined$1, flatten), func + "");
      }
      function getAllKeys(object) {
        return baseGetAllKeys(object, keys, getSymbols);
      }
      function getAllKeysIn(object) {
        return baseGetAllKeys(object, keysIn, getSymbolsIn);
      }
      var getData = !metaMap ? noop4 : function(func) {
        return metaMap.get(func);
      };
      function getFuncName(func) {
        var result2 = func.name + "", array = realNames[result2], length2 = hasOwnProperty2.call(realNames, result2) ? array.length : 0;
        while (length2--) {
          var data = array[length2], otherFunc = data.func;
          if (otherFunc == null || otherFunc == func) {
            return data.name;
          }
        }
        return result2;
      }
      function getHolder(func) {
        var object = hasOwnProperty2.call(lodash2, "placeholder") ? lodash2 : func;
        return object.placeholder;
      }
      function getIteratee() {
        var result2 = lodash2.iteratee || iteratee;
        result2 = result2 === iteratee ? baseIteratee : result2;
        return arguments.length ? result2(arguments[0], arguments[1]) : result2;
      }
      function getMapData(map3, key) {
        var data = map3.__data__;
        return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
      }
      function getMatchData(object) {
        var result2 = keys(object), length2 = result2.length;
        while (length2--) {
          var key = result2[length2], value = object[key];
          result2[length2] = [key, value, isStrictComparable(value)];
        }
        return result2;
      }
      function getNative(object, key) {
        var value = getValue(object, key);
        return baseIsNative(value) ? value : undefined$1;
      }
      function getRawTag(value) {
        var isOwn = hasOwnProperty2.call(value, symToStringTag), tag = value[symToStringTag];
        try {
          value[symToStringTag] = undefined$1;
          var unmasked = true;
        } catch (e2) {
        }
        var result2 = nativeObjectToString.call(value);
        if (unmasked) {
          if (isOwn) {
            value[symToStringTag] = tag;
          } else {
            delete value[symToStringTag];
          }
        }
        return result2;
      }
      var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
        if (object == null) {
          return [];
        }
        object = Object2(object);
        return arrayFilter(nativeGetSymbols(object), function(symbol) {
          return propertyIsEnumerable.call(object, symbol);
        });
      };
      var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
        var result2 = [];
        while (object) {
          arrayPush(result2, getSymbols(object));
          object = getPrototype(object);
        }
        return result2;
      };
      var getTag = baseGetTag;
      if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
        getTag = function(value) {
          var result2 = baseGetTag(value), Ctor = result2 == objectTag ? value.constructor : undefined$1, ctorString = Ctor ? toSource(Ctor) : "";
          if (ctorString) {
            switch (ctorString) {
              case dataViewCtorString:
                return dataViewTag;
              case mapCtorString:
                return mapTag;
              case promiseCtorString:
                return promiseTag;
              case setCtorString:
                return setTag;
              case weakMapCtorString:
                return weakMapTag;
            }
          }
          return result2;
        };
      }
      function getView(start2, end2, transforms) {
        var index2 = -1, length2 = transforms.length;
        while (++index2 < length2) {
          var data = transforms[index2], size2 = data.size;
          switch (data.type) {
            case "drop":
              start2 += size2;
              break;
            case "dropRight":
              end2 -= size2;
              break;
            case "take":
              end2 = nativeMin2(end2, start2 + size2);
              break;
            case "takeRight":
              start2 = nativeMax2(start2, end2 - size2);
              break;
          }
        }
        return { "start": start2, "end": end2 };
      }
      function getWrapDetails(source) {
        var match2 = source.match(reWrapDetails);
        return match2 ? match2[1].split(reSplitDetails) : [];
      }
      function hasPath(object, path, hasFunc) {
        path = castPath(path, object);
        var index2 = -1, length2 = path.length, result2 = false;
        while (++index2 < length2) {
          var key = toKey(path[index2]);
          if (!(result2 = object != null && hasFunc(object, key))) {
            break;
          }
          object = object[key];
        }
        if (result2 || ++index2 != length2) {
          return result2;
        }
        length2 = object == null ? 0 : object.length;
        return !!length2 && isLength(length2) && isIndex(key, length2) && (isArray2(object) || isArguments(object));
      }
      function initCloneArray(array) {
        var length2 = array.length, result2 = new array.constructor(length2);
        if (length2 && typeof array[0] == "string" && hasOwnProperty2.call(array, "index")) {
          result2.index = array.index;
          result2.input = array.input;
        }
        return result2;
      }
      function initCloneObject(object) {
        return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
      }
      function initCloneByTag(object, tag, isDeep) {
        var Ctor = object.constructor;
        switch (tag) {
          case arrayBufferTag:
            return cloneArrayBuffer(object);
          case boolTag:
          case dateTag:
            return new Ctor(+object);
          case dataViewTag:
            return cloneDataView(object, isDeep);
          case float32Tag:
          case float64Tag:
          case int8Tag:
          case int16Tag:
          case int32Tag:
          case uint8Tag:
          case uint8ClampedTag:
          case uint16Tag:
          case uint32Tag:
            return cloneTypedArray(object, isDeep);
          case mapTag:
            return new Ctor();
          case numberTag:
          case stringTag:
            return new Ctor(object);
          case regexpTag:
            return cloneRegExp(object);
          case setTag:
            return new Ctor();
          case symbolTag2:
            return cloneSymbol(object);
        }
      }
      function insertWrapDetails(source, details) {
        var length2 = details.length;
        if (!length2) {
          return source;
        }
        var lastIndex = length2 - 1;
        details[lastIndex] = (length2 > 1 ? "& " : "") + details[lastIndex];
        details = details.join(length2 > 2 ? ", " : " ");
        return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
      }
      function isFlattenable(value) {
        return isArray2(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
      }
      function isIndex(value, length2) {
        var type = typeof value;
        length2 = length2 == null ? MAX_SAFE_INTEGER : length2;
        return !!length2 && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length2);
      }
      function isIterateeCall(value, index2, object) {
        if (!isObject2(object)) {
          return false;
        }
        var type = typeof index2;
        if (type == "number" ? isArrayLike(object) && isIndex(index2, object.length) : type == "string" && index2 in object) {
          return eq(object[index2], value);
        }
        return false;
      }
      function isKey(value, object) {
        if (isArray2(value)) {
          return false;
        }
        var type = typeof value;
        if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol2(value)) {
          return true;
        }
        return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object2(object);
      }
      function isKeyable(value) {
        var type = typeof value;
        return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
      }
      function isLaziable(func) {
        var funcName = getFuncName(func), other = lodash2[funcName];
        if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
          return false;
        }
        if (func === other) {
          return true;
        }
        var data = getData(other);
        return !!data && func === data[0];
      }
      function isMasked(func) {
        return !!maskSrcKey && maskSrcKey in func;
      }
      var isMaskable = coreJsData ? isFunction2 : stubFalse;
      function isPrototype(value) {
        var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto2;
        return value === proto;
      }
      function isStrictComparable(value) {
        return value === value && !isObject2(value);
      }
      function matchesStrictComparable(key, srcValue) {
        return function(object) {
          if (object == null) {
            return false;
          }
          return object[key] === srcValue && (srcValue !== undefined$1 || key in Object2(object));
        };
      }
      function memoizeCapped(func) {
        var result2 = memoize2(func, function(key) {
          if (cache.size === MAX_MEMOIZE_SIZE) {
            cache.clear();
          }
          return key;
        });
        var cache = result2.cache;
        return result2;
      }
      function mergeData(data, source) {
        var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
        var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
        if (!(isCommon || isCombo)) {
          return data;
        }
        if (srcBitmask & WRAP_BIND_FLAG) {
          data[2] = source[2];
          newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
        }
        var value = source[3];
        if (value) {
          var partials = data[3];
          data[3] = partials ? composeArgs(partials, value, source[4]) : value;
          data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
        }
        value = source[5];
        if (value) {
          partials = data[5];
          data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
          data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
        }
        value = source[7];
        if (value) {
          data[7] = value;
        }
        if (srcBitmask & WRAP_ARY_FLAG) {
          data[8] = data[8] == null ? source[8] : nativeMin2(data[8], source[8]);
        }
        if (data[9] == null) {
          data[9] = source[9];
        }
        data[0] = source[0];
        data[1] = newBitmask;
        return data;
      }
      function nativeKeysIn(object) {
        var result2 = [];
        if (object != null) {
          for (var key in Object2(object)) {
            result2.push(key);
          }
        }
        return result2;
      }
      function objectToString2(value) {
        return nativeObjectToString.call(value);
      }
      function overRest(func, start2, transform2) {
        start2 = nativeMax2(start2 === undefined$1 ? func.length - 1 : start2, 0);
        return function() {
          var args = arguments, index2 = -1, length2 = nativeMax2(args.length - start2, 0), array = Array2(length2);
          while (++index2 < length2) {
            array[index2] = args[start2 + index2];
          }
          index2 = -1;
          var otherArgs = Array2(start2 + 1);
          while (++index2 < start2) {
            otherArgs[index2] = args[index2];
          }
          otherArgs[start2] = transform2(array);
          return apply(func, this, otherArgs);
        };
      }
      function parent(object, path) {
        return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
      }
      function reorder(array, indexes) {
        var arrLength = array.length, length2 = nativeMin2(indexes.length, arrLength), oldArray = copyArray(array);
        while (length2--) {
          var index2 = indexes[length2];
          array[length2] = isIndex(index2, arrLength) ? oldArray[index2] : undefined$1;
        }
        return array;
      }
      function safeGet(object, key) {
        if (key === "constructor" && typeof object[key] === "function") {
          return;
        }
        if (key == "__proto__") {
          return;
        }
        return object[key];
      }
      var setData = shortOut(baseSetData);
      var setTimeout2 = ctxSetTimeout || function(func, wait) {
        return root2.setTimeout(func, wait);
      };
      var setToString = shortOut(baseSetToString);
      function setWrapToString(wrapper, reference2, bitmask) {
        var source = reference2 + "";
        return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
      }
      function shortOut(func) {
        var count = 0, lastCalled = 0;
        return function() {
          var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
          lastCalled = stamp;
          if (remaining > 0) {
            if (++count >= HOT_COUNT) {
              return arguments[0];
            }
          } else {
            count = 0;
          }
          return func.apply(undefined$1, arguments);
        };
      }
      function shuffleSelf(array, size2) {
        var index2 = -1, length2 = array.length, lastIndex = length2 - 1;
        size2 = size2 === undefined$1 ? length2 : size2;
        while (++index2 < size2) {
          var rand = baseRandom(index2, lastIndex), value = array[rand];
          array[rand] = array[index2];
          array[index2] = value;
        }
        array.length = size2;
        return array;
      }
      var stringToPath = memoizeCapped(function(string) {
        var result2 = [];
        if (string.charCodeAt(0) === 46) {
          result2.push("");
        }
        string.replace(rePropName, function(match2, number, quote, subString) {
          result2.push(quote ? subString.replace(reEscapeChar, "$1") : number || match2);
        });
        return result2;
      });
      function toKey(value) {
        if (typeof value == "string" || isSymbol2(value)) {
          return value;
        }
        var result2 = value + "";
        return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
      }
      function toSource(func) {
        if (func != null) {
          try {
            return funcToString.call(func);
          } catch (e2) {
          }
          try {
            return func + "";
          } catch (e2) {
          }
        }
        return "";
      }
      function updateWrapDetails(details, bitmask) {
        arrayEach(wrapFlags, function(pair) {
          var value = "_." + pair[0];
          if (bitmask & pair[1] && !arrayIncludes(details, value)) {
            details.push(value);
          }
        });
        return details.sort();
      }
      function wrapperClone(wrapper) {
        if (wrapper instanceof LazyWrapper) {
          return wrapper.clone();
        }
        var result2 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
        result2.__actions__ = copyArray(wrapper.__actions__);
        result2.__index__ = wrapper.__index__;
        result2.__values__ = wrapper.__values__;
        return result2;
      }
      function chunk(array, size2, guard) {
        if (guard ? isIterateeCall(array, size2, guard) : size2 === undefined$1) {
          size2 = 1;
        } else {
          size2 = nativeMax2(toInteger(size2), 0);
        }
        var length2 = array == null ? 0 : array.length;
        if (!length2 || size2 < 1) {
          return [];
        }
        var index2 = 0, resIndex = 0, result2 = Array2(nativeCeil(length2 / size2));
        while (index2 < length2) {
          result2[resIndex++] = baseSlice(array, index2, index2 += size2);
        }
        return result2;
      }
      function compact(array) {
        var index2 = -1, length2 = array == null ? 0 : array.length, resIndex = 0, result2 = [];
        while (++index2 < length2) {
          var value = array[index2];
          if (value) {
            result2[resIndex++] = value;
          }
        }
        return result2;
      }
      function concat() {
        var length2 = arguments.length;
        if (!length2) {
          return [];
        }
        var args = Array2(length2 - 1), array = arguments[0], index2 = length2;
        while (index2--) {
          args[index2 - 1] = arguments[index2];
        }
        return arrayPush(isArray2(array) ? copyArray(array) : [array], baseFlatten(args, 1));
      }
      var difference = baseRest(function(array, values2) {
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true)) : [];
      });
      var differenceBy = baseRest(function(array, values2) {
        var iteratee2 = last(values2);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2)) : [];
      });
      var differenceWith = baseRest(function(array, values2) {
        var comparator = last(values2);
        if (isArrayLikeObject(comparator)) {
          comparator = undefined$1;
        }
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), undefined$1, comparator) : [];
      });
      function drop(array, n2, guard) {
        var length2 = array == null ? 0 : array.length;
        if (!length2) {
          return [];
        }
        n2 = guard || n2 === undefined$1 ? 1 : toInteger(n2);
        return baseSlice(array, n2 < 0 ? 0 : n2, length2);
      }
      function dropRight(array, n2, guard) {
        var length2 = array == null ? 0 : array.length;
        if (!length2) {
          return [];
        }
        n2 = guard || n2 === undefined$1 ? 1 : toInteger(n2);
        n2 = length2 - n2;
        return baseSlice(array, 0, n2 < 0 ? 0 : n2);
      }
      function dropRightWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
      }
      function dropWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
      }
      function fill(array, value, start2, end2) {
        var length2 = array == null ? 0 : array.length;
        if (!length2) {
          return [];
        }
        if (start2 && typeof start2 != "number" && isIterateeCall(array, value, start2)) {
          start2 = 0;
          end2 = length2;
        }
        return baseFill(array, value, start2, end2);
      }
      function findIndex3(array, predicate, fromIndex) {
        var length2 = array == null ? 0 : array.length;
        if (!length2) {
          return -1;
        }
        var index2 = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index2 < 0) {
          index2 = nativeMax2(length2 + index2, 0);
        }
        return baseFindIndex(array, getIteratee(predicate, 3), index2);
      }
      function findLastIndex(array, predicate, fromIndex) {
        var length2 = array == null ? 0 : array.length;
        if (!length2) {
          return -1;
        }
        var index2 = length2 - 1;
        if (fromIndex !== undefined$1) {
          index2 = toInteger(fromIndex);
          index2 = fromIndex < 0 ? nativeMax2(length2 + index2, 0) : nativeMin2(index2, length2 - 1);
        }
        return baseFindIndex(array, getIteratee(predicate, 3), index2, true);
      }
      function flatten(array) {
        var length2 = array == null ? 0 : array.length;
        return length2 ? baseFlatten(array, 1) : [];
      }
      function flattenDeep(array) {
        var length2 = array == null ? 0 : array.length;
        return length2 ? baseFlatten(array, INFINITY) : [];
      }
      function flattenDepth(array, depth) {
        var length2 = array == null ? 0 : array.length;
        if (!length2) {
          return [];
        }
        depth = depth === undefined$1 ? 1 : toInteger(depth);
        return baseFlatten(array, depth);
      }
      function fromPairs(pairs) {
        var index2 = -1, length2 = pairs == null ? 0 : pairs.length, result2 = {};
        while (++index2 < length2) {
          var pair = pairs[index2];
          result2[pair[0]] = pair[1];
        }
        return result2;
      }
      function head(array) {
        return array && array.length ? array[0] : undefined$1;
      }
      function indexOf(array, value, fromIndex) {
        var length2 = array == null ? 0 : array.length;
        if (!length2) {
          return -1;
        }
        var index2 = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index2 < 0) {
          index2 = nativeMax2(length2 + index2, 0);
        }
        return baseIndexOf(array, value, index2);
      }
      function initial(array) {
        var length2 = array == null ? 0 : array.length;
        return length2 ? baseSlice(array, 0, -1) : [];
      }
      var intersection = baseRest(function(arrays) {
        var mapped = arrayMap(arrays, castArrayLikeObject);
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
      });
      var intersectionBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
        if (iteratee2 === last(mapped)) {
          iteratee2 = undefined$1;
        } else {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
      });
      var intersectionWith = baseRest(function(arrays) {
        var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        if (comparator) {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined$1, comparator) : [];
      });
      function join(array, separator) {
        return array == null ? "" : nativeJoin.call(array, separator);
      }
      function last(array) {
        var length2 = array == null ? 0 : array.length;
        return length2 ? array[length2 - 1] : undefined$1;
      }
      function lastIndexOf(array, value, fromIndex) {
        var length2 = array == null ? 0 : array.length;
        if (!length2) {
          return -1;
        }
        var index2 = length2;
        if (fromIndex !== undefined$1) {
          index2 = toInteger(fromIndex);
          index2 = index2 < 0 ? nativeMax2(length2 + index2, 0) : nativeMin2(index2, length2 - 1);
        }
        return value === value ? strictLastIndexOf(array, value, index2) : baseFindIndex(array, baseIsNaN, index2, true);
      }
      function nth(array, n2) {
        return array && array.length ? baseNth(array, toInteger(n2)) : undefined$1;
      }
      var pull = baseRest(pullAll);
      function pullAll(array, values2) {
        return array && array.length && values2 && values2.length ? basePullAll(array, values2) : array;
      }
      function pullAllBy(array, values2, iteratee2) {
        return array && array.length && values2 && values2.length ? basePullAll(array, values2, getIteratee(iteratee2, 2)) : array;
      }
      function pullAllWith(array, values2, comparator) {
        return array && array.length && values2 && values2.length ? basePullAll(array, values2, undefined$1, comparator) : array;
      }
      var pullAt = flatRest(function(array, indexes) {
        var length2 = array == null ? 0 : array.length, result2 = baseAt(array, indexes);
        basePullAt(array, arrayMap(indexes, function(index2) {
          return isIndex(index2, length2) ? +index2 : index2;
        }).sort(compareAscending));
        return result2;
      });
      function remove(array, predicate) {
        var result2 = [];
        if (!(array && array.length)) {
          return result2;
        }
        var index2 = -1, indexes = [], length2 = array.length;
        predicate = getIteratee(predicate, 3);
        while (++index2 < length2) {
          var value = array[index2];
          if (predicate(value, index2, array)) {
            result2.push(value);
            indexes.push(index2);
          }
        }
        basePullAt(array, indexes);
        return result2;
      }
      function reverse(array) {
        return array == null ? array : nativeReverse.call(array);
      }
      function slice2(array, start2, end2) {
        var length2 = array == null ? 0 : array.length;
        if (!length2) {
          return [];
        }
        if (end2 && typeof end2 != "number" && isIterateeCall(array, start2, end2)) {
          start2 = 0;
          end2 = length2;
        } else {
          start2 = start2 == null ? 0 : toInteger(start2);
          end2 = end2 === undefined$1 ? length2 : toInteger(end2);
        }
        return baseSlice(array, start2, end2);
      }
      function sortedIndex(array, value) {
        return baseSortedIndex(array, value);
      }
      function sortedIndexBy(array, value, iteratee2) {
        return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2));
      }
      function sortedIndexOf(array, value) {
        var length2 = array == null ? 0 : array.length;
        if (length2) {
          var index2 = baseSortedIndex(array, value);
          if (index2 < length2 && eq(array[index2], value)) {
            return index2;
          }
        }
        return -1;
      }
      function sortedLastIndex(array, value) {
        return baseSortedIndex(array, value, true);
      }
      function sortedLastIndexBy(array, value, iteratee2) {
        return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2), true);
      }
      function sortedLastIndexOf(array, value) {
        var length2 = array == null ? 0 : array.length;
        if (length2) {
          var index2 = baseSortedIndex(array, value, true) - 1;
          if (eq(array[index2], value)) {
            return index2;
          }
        }
        return -1;
      }
      function sortedUniq(array) {
        return array && array.length ? baseSortedUniq(array) : [];
      }
      function sortedUniqBy(array, iteratee2) {
        return array && array.length ? baseSortedUniq(array, getIteratee(iteratee2, 2)) : [];
      }
      function tail(array) {
        var length2 = array == null ? 0 : array.length;
        return length2 ? baseSlice(array, 1, length2) : [];
      }
      function take(array, n2, guard) {
        if (!(array && array.length)) {
          return [];
        }
        n2 = guard || n2 === undefined$1 ? 1 : toInteger(n2);
        return baseSlice(array, 0, n2 < 0 ? 0 : n2);
      }
      function takeRight(array, n2, guard) {
        var length2 = array == null ? 0 : array.length;
        if (!length2) {
          return [];
        }
        n2 = guard || n2 === undefined$1 ? 1 : toInteger(n2);
        n2 = length2 - n2;
        return baseSlice(array, n2 < 0 ? 0 : n2, length2);
      }
      function takeRightWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
      }
      function takeWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
      }
      var union = baseRest(function(arrays) {
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
      });
      var unionBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2));
      });
      var unionWith = baseRest(function(arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
      });
      function uniq(array) {
        return array && array.length ? baseUniq(array) : [];
      }
      function uniqBy(array, iteratee2) {
        return array && array.length ? baseUniq(array, getIteratee(iteratee2, 2)) : [];
      }
      function uniqWith(array, comparator) {
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return array && array.length ? baseUniq(array, undefined$1, comparator) : [];
      }
      function unzip(array) {
        if (!(array && array.length)) {
          return [];
        }
        var length2 = 0;
        array = arrayFilter(array, function(group) {
          if (isArrayLikeObject(group)) {
            length2 = nativeMax2(group.length, length2);
            return true;
          }
        });
        return baseTimes(length2, function(index2) {
          return arrayMap(array, baseProperty(index2));
        });
      }
      function unzipWith(array, iteratee2) {
        if (!(array && array.length)) {
          return [];
        }
        var result2 = unzip(array);
        if (iteratee2 == null) {
          return result2;
        }
        return arrayMap(result2, function(group) {
          return apply(iteratee2, undefined$1, group);
        });
      }
      var without = baseRest(function(array, values2) {
        return isArrayLikeObject(array) ? baseDifference(array, values2) : [];
      });
      var xor = baseRest(function(arrays) {
        return baseXor(arrayFilter(arrays, isArrayLikeObject));
      });
      var xorBy = baseRest(function(arrays) {
        var iteratee2 = last(arrays);
        if (isArrayLikeObject(iteratee2)) {
          iteratee2 = undefined$1;
        }
        return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee2, 2));
      });
      var xorWith = baseRest(function(arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
      });
      var zip = baseRest(unzip);
      function zipObject(props, values2) {
        return baseZipObject(props || [], values2 || [], assignValue);
      }
      function zipObjectDeep(props, values2) {
        return baseZipObject(props || [], values2 || [], baseSet);
      }
      var zipWith = baseRest(function(arrays) {
        var length2 = arrays.length, iteratee2 = length2 > 1 ? arrays[length2 - 1] : undefined$1;
        iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined$1;
        return unzipWith(arrays, iteratee2);
      });
      function chain(value) {
        var result2 = lodash2(value);
        result2.__chain__ = true;
        return result2;
      }
      function tap(value, interceptor) {
        interceptor(value);
        return value;
      }
      function thru(value, interceptor) {
        return interceptor(value);
      }
      var wrapperAt = flatRest(function(paths2) {
        var length2 = paths2.length, start2 = length2 ? paths2[0] : 0, value = this.__wrapped__, interceptor = function(object) {
          return baseAt(object, paths2);
        };
        if (length2 > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start2)) {
          return this.thru(interceptor);
        }
        value = value.slice(start2, +start2 + (length2 ? 1 : 0));
        value.__actions__.push({
          "func": thru,
          "args": [interceptor],
          "thisArg": undefined$1
        });
        return new LodashWrapper(value, this.__chain__).thru(function(array) {
          if (length2 && !array.length) {
            array.push(undefined$1);
          }
          return array;
        });
      });
      function wrapperChain() {
        return chain(this);
      }
      function wrapperCommit() {
        return new LodashWrapper(this.value(), this.__chain__);
      }
      function wrapperNext() {
        if (this.__values__ === undefined$1) {
          this.__values__ = toArray(this.value());
        }
        var done = this.__index__ >= this.__values__.length, value = done ? undefined$1 : this.__values__[this.__index__++];
        return { "done": done, "value": value };
      }
      function wrapperToIterator() {
        return this;
      }
      function wrapperPlant(value) {
        var result2, parent2 = this;
        while (parent2 instanceof baseLodash) {
          var clone2 = wrapperClone(parent2);
          clone2.__index__ = 0;
          clone2.__values__ = undefined$1;
          if (result2) {
            previous.__wrapped__ = clone2;
          } else {
            result2 = clone2;
          }
          var previous = clone2;
          parent2 = parent2.__wrapped__;
        }
        previous.__wrapped__ = value;
        return result2;
      }
      function wrapperReverse() {
        var value = this.__wrapped__;
        if (value instanceof LazyWrapper) {
          var wrapped = value;
          if (this.__actions__.length) {
            wrapped = new LazyWrapper(this);
          }
          wrapped = wrapped.reverse();
          wrapped.__actions__.push({
            "func": thru,
            "args": [reverse],
            "thisArg": undefined$1
          });
          return new LodashWrapper(wrapped, this.__chain__);
        }
        return this.thru(reverse);
      }
      function wrapperValue() {
        return baseWrapperValue(this.__wrapped__, this.__actions__);
      }
      var countBy = createAggregator(function(result2, value, key) {
        if (hasOwnProperty2.call(result2, key)) {
          ++result2[key];
        } else {
          baseAssignValue(result2, key, 1);
        }
      });
      function every(collection, predicate, guard) {
        var func = isArray2(collection) ? arrayEvery : baseEvery;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      function filter(collection, predicate) {
        var func = isArray2(collection) ? arrayFilter : baseFilter;
        return func(collection, getIteratee(predicate, 3));
      }
      var find = createFind(findIndex3);
      var findLast = createFind(findLastIndex);
      function flatMap(collection, iteratee2) {
        return baseFlatten(map2(collection, iteratee2), 1);
      }
      function flatMapDeep(collection, iteratee2) {
        return baseFlatten(map2(collection, iteratee2), INFINITY);
      }
      function flatMapDepth(collection, iteratee2, depth) {
        depth = depth === undefined$1 ? 1 : toInteger(depth);
        return baseFlatten(map2(collection, iteratee2), depth);
      }
      function forEach(collection, iteratee2) {
        var func = isArray2(collection) ? arrayEach : baseEach;
        return func(collection, getIteratee(iteratee2, 3));
      }
      function forEachRight(collection, iteratee2) {
        var func = isArray2(collection) ? arrayEachRight : baseEachRight;
        return func(collection, getIteratee(iteratee2, 3));
      }
      var groupBy = createAggregator(function(result2, value, key) {
        if (hasOwnProperty2.call(result2, key)) {
          result2[key].push(value);
        } else {
          baseAssignValue(result2, key, [value]);
        }
      });
      function includes(collection, value, fromIndex, guard) {
        collection = isArrayLike(collection) ? collection : values(collection);
        fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
        var length2 = collection.length;
        if (fromIndex < 0) {
          fromIndex = nativeMax2(length2 + fromIndex, 0);
        }
        return isString2(collection) ? fromIndex <= length2 && collection.indexOf(value, fromIndex) > -1 : !!length2 && baseIndexOf(collection, value, fromIndex) > -1;
      }
      var invokeMap = baseRest(function(collection, path, args) {
        var index2 = -1, isFunc = typeof path == "function", result2 = isArrayLike(collection) ? Array2(collection.length) : [];
        baseEach(collection, function(value) {
          result2[++index2] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
        });
        return result2;
      });
      var keyBy = createAggregator(function(result2, value, key) {
        baseAssignValue(result2, key, value);
      });
      function map2(collection, iteratee2) {
        var func = isArray2(collection) ? arrayMap : baseMap;
        return func(collection, getIteratee(iteratee2, 3));
      }
      function orderBy(collection, iteratees, orders, guard) {
        if (collection == null) {
          return [];
        }
        if (!isArray2(iteratees)) {
          iteratees = iteratees == null ? [] : [iteratees];
        }
        orders = guard ? undefined$1 : orders;
        if (!isArray2(orders)) {
          orders = orders == null ? [] : [orders];
        }
        return baseOrderBy(collection, iteratees, orders);
      }
      var partition = createAggregator(function(result2, value, key) {
        result2[key ? 0 : 1].push(value);
      }, function() {
        return [[], []];
      });
      function reduce(collection, iteratee2, accumulator) {
        var func = isArray2(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach);
      }
      function reduceRight(collection, iteratee2, accumulator) {
        var func = isArray2(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
      }
      function reject(collection, predicate) {
        var func = isArray2(collection) ? arrayFilter : baseFilter;
        return func(collection, negate(getIteratee(predicate, 3)));
      }
      function sample(collection) {
        var func = isArray2(collection) ? arraySample : baseSample;
        return func(collection);
      }
      function sampleSize(collection, n2, guard) {
        if (guard ? isIterateeCall(collection, n2, guard) : n2 === undefined$1) {
          n2 = 1;
        } else {
          n2 = toInteger(n2);
        }
        var func = isArray2(collection) ? arraySampleSize : baseSampleSize;
        return func(collection, n2);
      }
      function shuffle(collection) {
        var func = isArray2(collection) ? arrayShuffle : baseShuffle;
        return func(collection);
      }
      function size(collection) {
        if (collection == null) {
          return 0;
        }
        if (isArrayLike(collection)) {
          return isString2(collection) ? stringSize(collection) : collection.length;
        }
        var tag = getTag(collection);
        if (tag == mapTag || tag == setTag) {
          return collection.size;
        }
        return baseKeys(collection).length;
      }
      function some(collection, predicate, guard) {
        var func = isArray2(collection) ? arraySome : baseSome;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      var sortBy = baseRest(function(collection, iteratees) {
        if (collection == null) {
          return [];
        }
        var length2 = iteratees.length;
        if (length2 > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
          iteratees = [];
        } else if (length2 > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
          iteratees = [iteratees[0]];
        }
        return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
      });
      var now2 = ctxNow || function() {
        return root2.Date.now();
      };
      function after(n2, func) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        n2 = toInteger(n2);
        return function() {
          if (--n2 < 1) {
            return func.apply(this, arguments);
          }
        };
      }
      function ary(func, n2, guard) {
        n2 = guard ? undefined$1 : n2;
        n2 = func && n2 == null ? func.length : n2;
        return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n2);
      }
      function before(n2, func) {
        var result2;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        n2 = toInteger(n2);
        return function() {
          if (--n2 > 0) {
            result2 = func.apply(this, arguments);
          }
          if (n2 <= 1) {
            func = undefined$1;
          }
          return result2;
        };
      }
      var bind = baseRest(function(func, thisArg, partials) {
        var bitmask = WRAP_BIND_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bind));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(func, bitmask, thisArg, partials, holders);
      });
      var bindKey = baseRest(function(object, key, partials) {
        var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bindKey));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(key, bitmask, object, partials, holders);
      });
      function curry(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result2 = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result2.placeholder = curry.placeholder;
        return result2;
      }
      function curryRight(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result2 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result2.placeholder = curryRight.placeholder;
        return result2;
      }
      function debounce2(func, wait, options) {
        var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        wait = toNumber2(wait) || 0;
        if (isObject2(options)) {
          leading = !!options.leading;
          maxing = "maxWait" in options;
          maxWait = maxing ? nativeMax2(toNumber2(options.maxWait) || 0, wait) : maxWait;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }
        function invokeFunc(time) {
          var args = lastArgs, thisArg = lastThis;
          lastArgs = lastThis = undefined$1;
          lastInvokeTime = time;
          result2 = func.apply(thisArg, args);
          return result2;
        }
        function leadingEdge(time) {
          lastInvokeTime = time;
          timerId = setTimeout2(timerExpired, wait);
          return leading ? invokeFunc(time) : result2;
        }
        function remainingWait(time) {
          var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
          return maxing ? nativeMin2(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
        }
        function shouldInvoke(time) {
          var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
          return lastCallTime === undefined$1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }
        function timerExpired() {
          var time = now2();
          if (shouldInvoke(time)) {
            return trailingEdge(time);
          }
          timerId = setTimeout2(timerExpired, remainingWait(time));
        }
        function trailingEdge(time) {
          timerId = undefined$1;
          if (trailing && lastArgs) {
            return invokeFunc(time);
          }
          lastArgs = lastThis = undefined$1;
          return result2;
        }
        function cancel() {
          if (timerId !== undefined$1) {
            clearTimeout2(timerId);
          }
          lastInvokeTime = 0;
          lastArgs = lastCallTime = lastThis = timerId = undefined$1;
        }
        function flush() {
          return timerId === undefined$1 ? result2 : trailingEdge(now2());
        }
        function debounced() {
          var time = now2(), isInvoking = shouldInvoke(time);
          lastArgs = arguments;
          lastThis = this;
          lastCallTime = time;
          if (isInvoking) {
            if (timerId === undefined$1) {
              return leadingEdge(lastCallTime);
            }
            if (maxing) {
              clearTimeout2(timerId);
              timerId = setTimeout2(timerExpired, wait);
              return invokeFunc(lastCallTime);
            }
          }
          if (timerId === undefined$1) {
            timerId = setTimeout2(timerExpired, wait);
          }
          return result2;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
      }
      var defer = baseRest(function(func, args) {
        return baseDelay(func, 1, args);
      });
      var delay3 = baseRest(function(func, wait, args) {
        return baseDelay(func, toNumber2(wait) || 0, args);
      });
      function flip2(func) {
        return createWrap(func, WRAP_FLIP_FLAG);
      }
      function memoize2(func, resolver) {
        if (typeof func != "function" || resolver != null && typeof resolver != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        var memoized = function() {
          var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
          if (cache.has(key)) {
            return cache.get(key);
          }
          var result2 = func.apply(this, args);
          memoized.cache = cache.set(key, result2) || cache;
          return result2;
        };
        memoized.cache = new (memoize2.Cache || MapCache)();
        return memoized;
      }
      memoize2.Cache = MapCache;
      function negate(predicate) {
        if (typeof predicate != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return !predicate.call(this);
            case 1:
              return !predicate.call(this, args[0]);
            case 2:
              return !predicate.call(this, args[0], args[1]);
            case 3:
              return !predicate.call(this, args[0], args[1], args[2]);
          }
          return !predicate.apply(this, args);
        };
      }
      function once(func) {
        return before(2, func);
      }
      var overArgs = castRest(function(func, transforms) {
        transforms = transforms.length == 1 && isArray2(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
        var funcsLength = transforms.length;
        return baseRest(function(args) {
          var index2 = -1, length2 = nativeMin2(args.length, funcsLength);
          while (++index2 < length2) {
            args[index2] = transforms[index2].call(this, args[index2]);
          }
          return apply(func, this, args);
        });
      });
      var partial = baseRest(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partial));
        return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
      });
      var partialRight = baseRest(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partialRight));
        return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
      });
      var rearg = flatRest(function(func, indexes) {
        return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
      });
      function rest(func, start2) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        start2 = start2 === undefined$1 ? start2 : toInteger(start2);
        return baseRest(func, start2);
      }
      function spread(func, start2) {
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        start2 = start2 == null ? 0 : nativeMax2(toInteger(start2), 0);
        return baseRest(function(args) {
          var array = args[start2], otherArgs = castSlice(args, 0, start2);
          if (array) {
            arrayPush(otherArgs, array);
          }
          return apply(func, this, otherArgs);
        });
      }
      function throttle(func, wait, options) {
        var leading = true, trailing = true;
        if (typeof func != "function") {
          throw new TypeError2(FUNC_ERROR_TEXT2);
        }
        if (isObject2(options)) {
          leading = "leading" in options ? !!options.leading : leading;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }
        return debounce2(func, wait, {
          "leading": leading,
          "maxWait": wait,
          "trailing": trailing
        });
      }
      function unary(func) {
        return ary(func, 1);
      }
      function wrap(value, wrapper) {
        return partial(castFunction(wrapper), value);
      }
      function castArray() {
        if (!arguments.length) {
          return [];
        }
        var value = arguments[0];
        return isArray2(value) ? value : [value];
      }
      function clone(value) {
        return baseClone(value, CLONE_SYMBOLS_FLAG);
      }
      function cloneWith(value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
      }
      function cloneDeep(value) {
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
      }
      function cloneDeepWith(value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
      }
      function conformsTo(object, source) {
        return source == null || baseConformsTo(object, source, keys(source));
      }
      function eq(value, other) {
        return value === other || value !== value && other !== other;
      }
      var gt = createRelationalOperation(baseGt);
      var gte = createRelationalOperation(function(value, other) {
        return value >= other;
      });
      var isArguments = baseIsArguments(function() {
        return arguments;
      }()) ? baseIsArguments : function(value) {
        return isObjectLike2(value) && hasOwnProperty2.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
      };
      var isArray2 = Array2.isArray;
      var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
      function isArrayLike(value) {
        return value != null && isLength(value.length) && !isFunction2(value);
      }
      function isArrayLikeObject(value) {
        return isObjectLike2(value) && isArrayLike(value);
      }
      function isBoolean(value) {
        return value === true || value === false || isObjectLike2(value) && baseGetTag(value) == boolTag;
      }
      var isBuffer = nativeIsBuffer || stubFalse;
      var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
      function isElement2(value) {
        return isObjectLike2(value) && value.nodeType === 1 && !isPlainObject(value);
      }
      function isEmpty(value) {
        if (value == null) {
          return true;
        }
        if (isArrayLike(value) && (isArray2(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
          return !value.length;
        }
        var tag = getTag(value);
        if (tag == mapTag || tag == setTag) {
          return !value.size;
        }
        if (isPrototype(value)) {
          return !baseKeys(value).length;
        }
        for (var key in value) {
          if (hasOwnProperty2.call(value, key)) {
            return false;
          }
        }
        return true;
      }
      function isEqual3(value, other) {
        return baseIsEqual(value, other);
      }
      function isEqualWith(value, other, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        var result2 = customizer ? customizer(value, other) : undefined$1;
        return result2 === undefined$1 ? baseIsEqual(value, other, undefined$1, customizer) : !!result2;
      }
      function isError(value) {
        if (!isObjectLike2(value)) {
          return false;
        }
        var tag = baseGetTag(value);
        return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
      }
      function isFinite(value) {
        return typeof value == "number" && nativeIsFinite(value);
      }
      function isFunction2(value) {
        if (!isObject2(value)) {
          return false;
        }
        var tag = baseGetTag(value);
        return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
      }
      function isInteger(value) {
        return typeof value == "number" && value == toInteger(value);
      }
      function isLength(value) {
        return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
      }
      function isObject2(value) {
        var type = typeof value;
        return value != null && (type == "object" || type == "function");
      }
      function isObjectLike2(value) {
        return value != null && typeof value == "object";
      }
      var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
      function isMatch2(object, source) {
        return object === source || baseIsMatch(object, source, getMatchData(source));
      }
      function isMatchWith(object, source, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseIsMatch(object, source, getMatchData(source), customizer);
      }
      function isNaN2(value) {
        return isNumber(value) && value != +value;
      }
      function isNative(value) {
        if (isMaskable(value)) {
          throw new Error2(CORE_ERROR_TEXT);
        }
        return baseIsNative(value);
      }
      function isNull(value) {
        return value === null;
      }
      function isNil(value) {
        return value == null;
      }
      function isNumber(value) {
        return typeof value == "number" || isObjectLike2(value) && baseGetTag(value) == numberTag;
      }
      function isPlainObject(value) {
        if (!isObjectLike2(value) || baseGetTag(value) != objectTag) {
          return false;
        }
        var proto = getPrototype(value);
        if (proto === null) {
          return true;
        }
        var Ctor = hasOwnProperty2.call(proto, "constructor") && proto.constructor;
        return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
      }
      var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
      function isSafeInteger(value) {
        return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
      }
      var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
      function isString2(value) {
        return typeof value == "string" || !isArray2(value) && isObjectLike2(value) && baseGetTag(value) == stringTag;
      }
      function isSymbol2(value) {
        return typeof value == "symbol" || isObjectLike2(value) && baseGetTag(value) == symbolTag2;
      }
      var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
      function isUndefined(value) {
        return value === undefined$1;
      }
      function isWeakMap(value) {
        return isObjectLike2(value) && getTag(value) == weakMapTag;
      }
      function isWeakSet(value) {
        return isObjectLike2(value) && baseGetTag(value) == weakSetTag;
      }
      var lt = createRelationalOperation(baseLt);
      var lte = createRelationalOperation(function(value, other) {
        return value <= other;
      });
      function toArray(value) {
        if (!value) {
          return [];
        }
        if (isArrayLike(value)) {
          return isString2(value) ? stringToArray(value) : copyArray(value);
        }
        if (symIterator && value[symIterator]) {
          return iteratorToArray(value[symIterator]());
        }
        var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
        return func(value);
      }
      function toFinite(value) {
        if (!value) {
          return value === 0 ? value : 0;
        }
        value = toNumber2(value);
        if (value === INFINITY || value === -INFINITY) {
          var sign = value < 0 ? -1 : 1;
          return sign * MAX_INTEGER;
        }
        return value === value ? value : 0;
      }
      function toInteger(value) {
        var result2 = toFinite(value), remainder = result2 % 1;
        return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
      }
      function toLength(value) {
        return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
      }
      function toNumber2(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol2(value)) {
          return NAN2;
        }
        if (isObject2(value)) {
          var other = typeof value.valueOf == "function" ? value.valueOf() : value;
          value = isObject2(other) ? other + "" : other;
        }
        if (typeof value != "string") {
          return value === 0 ? value : +value;
        }
        value = baseTrim(value);
        var isBinary = reIsBinary2.test(value);
        return isBinary || reIsOctal2.test(value) ? freeParseInt2(value.slice(2), isBinary ? 2 : 8) : reIsBadHex2.test(value) ? NAN2 : +value;
      }
      function toPlainObject(value) {
        return copyObject(value, keysIn(value));
      }
      function toSafeInteger(value) {
        return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
      }
      function toString(value) {
        return value == null ? "" : baseToString(value);
      }
      var assign2 = createAssigner(function(object, source) {
        if (isPrototype(source) || isArrayLike(source)) {
          copyObject(source, keys(source), object);
          return;
        }
        for (var key in source) {
          if (hasOwnProperty2.call(source, key)) {
            assignValue(object, key, source[key]);
          }
        }
      });
      var assignIn = createAssigner(function(object, source) {
        copyObject(source, keysIn(source), object);
      });
      var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
        copyObject(source, keysIn(source), object, customizer);
      });
      var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
        copyObject(source, keys(source), object, customizer);
      });
      var at = flatRest(baseAt);
      function create(prototype, properties) {
        var result2 = baseCreate(prototype);
        return properties == null ? result2 : baseAssign(result2, properties);
      }
      var defaults = baseRest(function(object, sources) {
        object = Object2(object);
        var index2 = -1;
        var length2 = sources.length;
        var guard = length2 > 2 ? sources[2] : undefined$1;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          length2 = 1;
        }
        while (++index2 < length2) {
          var source = sources[index2];
          var props = keysIn(source);
          var propsIndex = -1;
          var propsLength = props.length;
          while (++propsIndex < propsLength) {
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined$1 || eq(value, objectProto2[key]) && !hasOwnProperty2.call(object, key)) {
              object[key] = source[key];
            }
          }
        }
        return object;
      });
      var defaultsDeep = baseRest(function(args) {
        args.push(undefined$1, customDefaultsMerge);
        return apply(mergeWith, undefined$1, args);
      });
      function findKey(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
      }
      function findLastKey(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
      }
      function forIn(object, iteratee2) {
        return object == null ? object : baseFor(object, getIteratee(iteratee2, 3), keysIn);
      }
      function forInRight(object, iteratee2) {
        return object == null ? object : baseForRight(object, getIteratee(iteratee2, 3), keysIn);
      }
      function forOwn(object, iteratee2) {
        return object && baseForOwn(object, getIteratee(iteratee2, 3));
      }
      function forOwnRight(object, iteratee2) {
        return object && baseForOwnRight(object, getIteratee(iteratee2, 3));
      }
      function functions(object) {
        return object == null ? [] : baseFunctions(object, keys(object));
      }
      function functionsIn(object) {
        return object == null ? [] : baseFunctions(object, keysIn(object));
      }
      function get(object, path, defaultValue) {
        var result2 = object == null ? undefined$1 : baseGet(object, path);
        return result2 === undefined$1 ? defaultValue : result2;
      }
      function has(object, path) {
        return object != null && hasPath(object, path, baseHas);
      }
      function hasIn(object, path) {
        return object != null && hasPath(object, path, baseHasIn);
      }
      var invert = createInverter(function(result2, value, key) {
        if (value != null && typeof value.toString != "function") {
          value = nativeObjectToString.call(value);
        }
        result2[value] = key;
      }, constant(identity));
      var invertBy = createInverter(function(result2, value, key) {
        if (value != null && typeof value.toString != "function") {
          value = nativeObjectToString.call(value);
        }
        if (hasOwnProperty2.call(result2, value)) {
          result2[value].push(key);
        } else {
          result2[value] = [key];
        }
      }, getIteratee);
      var invoke = baseRest(baseInvoke);
      function keys(object) {
        return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
      }
      function keysIn(object) {
        return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
      }
      function mapKeys(object, iteratee2) {
        var result2 = {};
        iteratee2 = getIteratee(iteratee2, 3);
        baseForOwn(object, function(value, key, object2) {
          baseAssignValue(result2, iteratee2(value, key, object2), value);
        });
        return result2;
      }
      function mapValues(object, iteratee2) {
        var result2 = {};
        iteratee2 = getIteratee(iteratee2, 3);
        baseForOwn(object, function(value, key, object2) {
          baseAssignValue(result2, key, iteratee2(value, key, object2));
        });
        return result2;
      }
      var merge = createAssigner(function(object, source, srcIndex) {
        baseMerge(object, source, srcIndex);
      });
      var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
        baseMerge(object, source, srcIndex, customizer);
      });
      var omit = flatRest(function(object, paths2) {
        var result2 = {};
        if (object == null) {
          return result2;
        }
        var isDeep = false;
        paths2 = arrayMap(paths2, function(path) {
          path = castPath(path, object);
          isDeep || (isDeep = path.length > 1);
          return path;
        });
        copyObject(object, getAllKeysIn(object), result2);
        if (isDeep) {
          result2 = baseClone(result2, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
        }
        var length2 = paths2.length;
        while (length2--) {
          baseUnset(result2, paths2[length2]);
        }
        return result2;
      });
      function omitBy(object, predicate) {
        return pickBy(object, negate(getIteratee(predicate)));
      }
      var pick2 = flatRest(function(object, paths2) {
        return object == null ? {} : basePick(object, paths2);
      });
      function pickBy(object, predicate) {
        if (object == null) {
          return {};
        }
        var props = arrayMap(getAllKeysIn(object), function(prop) {
          return [prop];
        });
        predicate = getIteratee(predicate);
        return basePickBy(object, props, function(value, path) {
          return predicate(value, path[0]);
        });
      }
      function result(object, path, defaultValue) {
        path = castPath(path, object);
        var index2 = -1, length2 = path.length;
        if (!length2) {
          length2 = 1;
          object = undefined$1;
        }
        while (++index2 < length2) {
          var value = object == null ? undefined$1 : object[toKey(path[index2])];
          if (value === undefined$1) {
            index2 = length2;
            value = defaultValue;
          }
          object = isFunction2(value) ? value.call(object) : value;
        }
        return object;
      }
      function set(object, path, value) {
        return object == null ? object : baseSet(object, path, value);
      }
      function setWith(object, path, value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return object == null ? object : baseSet(object, path, value, customizer);
      }
      var toPairs = createToPairs(keys);
      var toPairsIn = createToPairs(keysIn);
      function transform(object, iteratee2, accumulator) {
        var isArr = isArray2(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
        iteratee2 = getIteratee(iteratee2, 4);
        if (accumulator == null) {
          var Ctor = object && object.constructor;
          if (isArrLike) {
            accumulator = isArr ? new Ctor() : [];
          } else if (isObject2(object)) {
            accumulator = isFunction2(Ctor) ? baseCreate(getPrototype(object)) : {};
          } else {
            accumulator = {};
          }
        }
        (isArrLike ? arrayEach : baseForOwn)(object, function(value, index2, object2) {
          return iteratee2(accumulator, value, index2, object2);
        });
        return accumulator;
      }
      function unset(object, path) {
        return object == null ? true : baseUnset(object, path);
      }
      function update(object, path, updater) {
        return object == null ? object : baseUpdate(object, path, castFunction(updater));
      }
      function updateWith(object, path, updater, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
      }
      function values(object) {
        return object == null ? [] : baseValues(object, keys(object));
      }
      function valuesIn(object) {
        return object == null ? [] : baseValues(object, keysIn(object));
      }
      function clamp(number, lower, upper) {
        if (upper === undefined$1) {
          upper = lower;
          lower = undefined$1;
        }
        if (upper !== undefined$1) {
          upper = toNumber2(upper);
          upper = upper === upper ? upper : 0;
        }
        if (lower !== undefined$1) {
          lower = toNumber2(lower);
          lower = lower === lower ? lower : 0;
        }
        return baseClamp(toNumber2(number), lower, upper);
      }
      function inRange(number, start2, end2) {
        start2 = toFinite(start2);
        if (end2 === undefined$1) {
          end2 = start2;
          start2 = 0;
        } else {
          end2 = toFinite(end2);
        }
        number = toNumber2(number);
        return baseInRange(number, start2, end2);
      }
      function random(lower, upper, floating) {
        if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) {
          upper = floating = undefined$1;
        }
        if (floating === undefined$1) {
          if (typeof upper == "boolean") {
            floating = upper;
            upper = undefined$1;
          } else if (typeof lower == "boolean") {
            floating = lower;
            lower = undefined$1;
          }
        }
        if (lower === undefined$1 && upper === undefined$1) {
          lower = 0;
          upper = 1;
        } else {
          lower = toFinite(lower);
          if (upper === undefined$1) {
            upper = lower;
            lower = 0;
          } else {
            upper = toFinite(upper);
          }
        }
        if (lower > upper) {
          var temp = lower;
          lower = upper;
          upper = temp;
        }
        if (floating || lower % 1 || upper % 1) {
          var rand = nativeRandom();
          return nativeMin2(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
        }
        return baseRandom(lower, upper);
      }
      var camelCase = createCompounder(function(result2, word, index2) {
        word = word.toLowerCase();
        return result2 + (index2 ? capitalize(word) : word);
      });
      function capitalize(string) {
        return upperFirst(toString(string).toLowerCase());
      }
      function deburr(string) {
        string = toString(string);
        return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
      }
      function endsWith(string, target, position2) {
        string = toString(string);
        target = baseToString(target);
        var length2 = string.length;
        position2 = position2 === undefined$1 ? length2 : baseClamp(toInteger(position2), 0, length2);
        var end2 = position2;
        position2 -= target.length;
        return position2 >= 0 && string.slice(position2, end2) == target;
      }
      function escape(string) {
        string = toString(string);
        return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
      }
      function escapeRegExp(string) {
        string = toString(string);
        return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
      }
      var kebabCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? "-" : "") + word.toLowerCase();
      });
      var lowerCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + word.toLowerCase();
      });
      var lowerFirst = createCaseFirst("toLowerCase");
      function pad(string, length2, chars) {
        string = toString(string);
        length2 = toInteger(length2);
        var strLength = length2 ? stringSize(string) : 0;
        if (!length2 || strLength >= length2) {
          return string;
        }
        var mid = (length2 - strLength) / 2;
        return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
      }
      function padEnd(string, length2, chars) {
        string = toString(string);
        length2 = toInteger(length2);
        var strLength = length2 ? stringSize(string) : 0;
        return length2 && strLength < length2 ? string + createPadding(length2 - strLength, chars) : string;
      }
      function padStart(string, length2, chars) {
        string = toString(string);
        length2 = toInteger(length2);
        var strLength = length2 ? stringSize(string) : 0;
        return length2 && strLength < length2 ? createPadding(length2 - strLength, chars) + string : string;
      }
      function parseInt2(string, radix, guard) {
        if (guard || radix == null) {
          radix = 0;
        } else if (radix) {
          radix = +radix;
        }
        return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
      }
      function repeat(string, n2, guard) {
        if (guard ? isIterateeCall(string, n2, guard) : n2 === undefined$1) {
          n2 = 1;
        } else {
          n2 = toInteger(n2);
        }
        return baseRepeat(toString(string), n2);
      }
      function replace2() {
        var args = arguments, string = toString(args[0]);
        return args.length < 3 ? string : string.replace(args[1], args[2]);
      }
      var snakeCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? "_" : "") + word.toLowerCase();
      });
      function split(string, separator, limit) {
        if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) {
          separator = limit = undefined$1;
        }
        limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
        if (!limit) {
          return [];
        }
        string = toString(string);
        if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
          separator = baseToString(separator);
          if (!separator && hasUnicode(string)) {
            return castSlice(stringToArray(string), 0, limit);
          }
        }
        return string.split(separator, limit);
      }
      var startCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + upperFirst(word);
      });
      function startsWith(string, target, position2) {
        string = toString(string);
        position2 = position2 == null ? 0 : baseClamp(toInteger(position2), 0, string.length);
        target = baseToString(target);
        return string.slice(position2, position2 + target.length) == target;
      }
      function template(string, options, guard) {
        var settings = lodash2.templateSettings;
        if (guard && isIterateeCall(string, options, guard)) {
          options = undefined$1;
        }
        string = toString(string);
        options = assignInWith({}, options, settings, customDefaultsAssignIn);
        var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
        var isEscaping, isEvaluating, index2 = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
        var reDelimiters = RegExp2((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
        var sourceURL = "//# sourceURL=" + (hasOwnProperty2.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
        string.replace(reDelimiters, function(match2, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset2) {
          interpolateValue || (interpolateValue = esTemplateValue);
          source += string.slice(index2, offset2).replace(reUnescapedString, escapeStringChar);
          if (escapeValue) {
            isEscaping = true;
            source += "' +\n__e(" + escapeValue + ") +\n'";
          }
          if (evaluateValue) {
            isEvaluating = true;
            source += "';\n" + evaluateValue + ";\n__p += '";
          }
          if (interpolateValue) {
            source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
          }
          index2 = offset2 + match2.length;
          return match2;
        });
        source += "';\n";
        var variable = hasOwnProperty2.call(options, "variable") && options.variable;
        if (!variable) {
          source = "with (obj) {\n" + source + "\n}\n";
        } else if (reForbiddenIdentifierChars.test(variable)) {
          throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
        }
        source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
        source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
        var result2 = attempt(function() {
          return Function2(importsKeys, sourceURL + "return " + source).apply(undefined$1, importsValues);
        });
        result2.source = source;
        if (isError(result2)) {
          throw result2;
        }
        return result2;
      }
      function toLower(value) {
        return toString(value).toLowerCase();
      }
      function toUpper(value) {
        return toString(value).toUpperCase();
      }
      function trim2(string, chars, guard) {
        string = toString(string);
        if (string && (guard || chars === undefined$1)) {
          return baseTrim(string);
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start2 = charsStartIndex(strSymbols, chrSymbols), end2 = charsEndIndex(strSymbols, chrSymbols) + 1;
        return castSlice(strSymbols, start2, end2).join("");
      }
      function trimEnd(string, chars, guard) {
        string = toString(string);
        if (string && (guard || chars === undefined$1)) {
          return string.slice(0, trimmedEndIndex(string) + 1);
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string), end2 = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
        return castSlice(strSymbols, 0, end2).join("");
      }
      function trimStart(string, chars, guard) {
        string = toString(string);
        if (string && (guard || chars === undefined$1)) {
          return string.replace(reTrimStart, "");
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string), start2 = charsStartIndex(strSymbols, stringToArray(chars));
        return castSlice(strSymbols, start2).join("");
      }
      function truncate(string, options) {
        var length2 = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
        if (isObject2(options)) {
          var separator = "separator" in options ? options.separator : separator;
          length2 = "length" in options ? toInteger(options.length) : length2;
          omission = "omission" in options ? baseToString(options.omission) : omission;
        }
        string = toString(string);
        var strLength = string.length;
        if (hasUnicode(string)) {
          var strSymbols = stringToArray(string);
          strLength = strSymbols.length;
        }
        if (length2 >= strLength) {
          return string;
        }
        var end2 = length2 - stringSize(omission);
        if (end2 < 1) {
          return omission;
        }
        var result2 = strSymbols ? castSlice(strSymbols, 0, end2).join("") : string.slice(0, end2);
        if (separator === undefined$1) {
          return result2 + omission;
        }
        if (strSymbols) {
          end2 += result2.length - end2;
        }
        if (isRegExp(separator)) {
          if (string.slice(end2).search(separator)) {
            var match2, substring = result2;
            if (!separator.global) {
              separator = RegExp2(separator.source, toString(reFlags.exec(separator)) + "g");
            }
            separator.lastIndex = 0;
            while (match2 = separator.exec(substring)) {
              var newEnd = match2.index;
            }
            result2 = result2.slice(0, newEnd === undefined$1 ? end2 : newEnd);
          }
        } else if (string.indexOf(baseToString(separator), end2) != end2) {
          var index2 = result2.lastIndexOf(separator);
          if (index2 > -1) {
            result2 = result2.slice(0, index2);
          }
        }
        return result2 + omission;
      }
      function unescape(string) {
        string = toString(string);
        return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
      }
      var upperCase = createCompounder(function(result2, word, index2) {
        return result2 + (index2 ? " " : "") + word.toUpperCase();
      });
      var upperFirst = createCaseFirst("toUpperCase");
      function words(string, pattern, guard) {
        string = toString(string);
        pattern = guard ? undefined$1 : pattern;
        if (pattern === undefined$1) {
          return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
        }
        return string.match(pattern) || [];
      }
      var attempt = baseRest(function(func, args) {
        try {
          return apply(func, undefined$1, args);
        } catch (e2) {
          return isError(e2) ? e2 : new Error2(e2);
        }
      });
      var bindAll = flatRest(function(object, methodNames) {
        arrayEach(methodNames, function(key) {
          key = toKey(key);
          baseAssignValue(object, key, bind(object[key], object));
        });
        return object;
      });
      function cond(pairs) {
        var length2 = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
        pairs = !length2 ? [] : arrayMap(pairs, function(pair) {
          if (typeof pair[1] != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT2);
          }
          return [toIteratee(pair[0]), pair[1]];
        });
        return baseRest(function(args) {
          var index2 = -1;
          while (++index2 < length2) {
            var pair = pairs[index2];
            if (apply(pair[0], this, args)) {
              return apply(pair[1], this, args);
            }
          }
        });
      }
      function conforms(source) {
        return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
      }
      function constant(value) {
        return function() {
          return value;
        };
      }
      function defaultTo(value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
      }
      var flow = createFlow();
      var flowRight = createFlow(true);
      function identity(value) {
        return value;
      }
      function iteratee(func) {
        return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
      }
      function matches2(source) {
        return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
      }
      function matchesProperty(path, srcValue) {
        return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
      }
      var method = baseRest(function(path, args) {
        return function(object) {
          return baseInvoke(object, path, args);
        };
      });
      var methodOf = baseRest(function(object, args) {
        return function(path) {
          return baseInvoke(object, path, args);
        };
      });
      function mixin(object, source, options) {
        var props = keys(source), methodNames = baseFunctions(source, props);
        if (options == null && !(isObject2(source) && (methodNames.length || !props.length))) {
          options = source;
          source = object;
          object = this;
          methodNames = baseFunctions(source, keys(source));
        }
        var chain2 = !(isObject2(options) && "chain" in options) || !!options.chain, isFunc = isFunction2(object);
        arrayEach(methodNames, function(methodName) {
          var func = source[methodName];
          object[methodName] = func;
          if (isFunc) {
            object.prototype[methodName] = function() {
              var chainAll = this.__chain__;
              if (chain2 || chainAll) {
                var result2 = object(this.__wrapped__), actions = result2.__actions__ = copyArray(this.__actions__);
                actions.push({ "func": func, "args": arguments, "thisArg": object });
                result2.__chain__ = chainAll;
                return result2;
              }
              return func.apply(object, arrayPush([this.value()], arguments));
            };
          }
        });
        return object;
      }
      function noConflict() {
        if (root2._ === this) {
          root2._ = oldDash;
        }
        return this;
      }
      function noop4() {
      }
      function nthArg(n2) {
        n2 = toInteger(n2);
        return baseRest(function(args) {
          return baseNth(args, n2);
        });
      }
      var over = createOver(arrayMap);
      var overEvery = createOver(arrayEvery);
      var overSome = createOver(arraySome);
      function property(path) {
        return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
      }
      function propertyOf(object) {
        return function(path) {
          return object == null ? undefined$1 : baseGet(object, path);
        };
      }
      var range = createRange();
      var rangeRight = createRange(true);
      function stubArray() {
        return [];
      }
      function stubFalse() {
        return false;
      }
      function stubObject() {
        return {};
      }
      function stubString() {
        return "";
      }
      function stubTrue() {
        return true;
      }
      function times(n2, iteratee2) {
        n2 = toInteger(n2);
        if (n2 < 1 || n2 > MAX_SAFE_INTEGER) {
          return [];
        }
        var index2 = MAX_ARRAY_LENGTH, length2 = nativeMin2(n2, MAX_ARRAY_LENGTH);
        iteratee2 = getIteratee(iteratee2);
        n2 -= MAX_ARRAY_LENGTH;
        var result2 = baseTimes(length2, iteratee2);
        while (++index2 < n2) {
          iteratee2(index2);
        }
        return result2;
      }
      function toPath(value) {
        if (isArray2(value)) {
          return arrayMap(value, toKey);
        }
        return isSymbol2(value) ? [value] : copyArray(stringToPath(toString(value)));
      }
      function uniqueId2(prefix2) {
        var id = ++idCounter2;
        return toString(prefix2) + id;
      }
      var add = createMathOperation(function(augend, addend) {
        return augend + addend;
      }, 0);
      var ceil = createRound("ceil");
      var divide = createMathOperation(function(dividend, divisor) {
        return dividend / divisor;
      }, 1);
      var floor = createRound("floor");
      function max2(array) {
        return array && array.length ? baseExtremum(array, identity, baseGt) : undefined$1;
      }
      function maxBy(array, iteratee2) {
        return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseGt) : undefined$1;
      }
      function mean(array) {
        return baseMean(array, identity);
      }
      function meanBy(array, iteratee2) {
        return baseMean(array, getIteratee(iteratee2, 2));
      }
      function min2(array) {
        return array && array.length ? baseExtremum(array, identity, baseLt) : undefined$1;
      }
      function minBy(array, iteratee2) {
        return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseLt) : undefined$1;
      }
      var multiply = createMathOperation(function(multiplier, multiplicand) {
        return multiplier * multiplicand;
      }, 1);
      var round2 = createRound("round");
      var subtract = createMathOperation(function(minuend, subtrahend) {
        return minuend - subtrahend;
      }, 0);
      function sum(array) {
        return array && array.length ? baseSum(array, identity) : 0;
      }
      function sumBy(array, iteratee2) {
        return array && array.length ? baseSum(array, getIteratee(iteratee2, 2)) : 0;
      }
      lodash2.after = after;
      lodash2.ary = ary;
      lodash2.assign = assign2;
      lodash2.assignIn = assignIn;
      lodash2.assignInWith = assignInWith;
      lodash2.assignWith = assignWith;
      lodash2.at = at;
      lodash2.before = before;
      lodash2.bind = bind;
      lodash2.bindAll = bindAll;
      lodash2.bindKey = bindKey;
      lodash2.castArray = castArray;
      lodash2.chain = chain;
      lodash2.chunk = chunk;
      lodash2.compact = compact;
      lodash2.concat = concat;
      lodash2.cond = cond;
      lodash2.conforms = conforms;
      lodash2.constant = constant;
      lodash2.countBy = countBy;
      lodash2.create = create;
      lodash2.curry = curry;
      lodash2.curryRight = curryRight;
      lodash2.debounce = debounce2;
      lodash2.defaults = defaults;
      lodash2.defaultsDeep = defaultsDeep;
      lodash2.defer = defer;
      lodash2.delay = delay3;
      lodash2.difference = difference;
      lodash2.differenceBy = differenceBy;
      lodash2.differenceWith = differenceWith;
      lodash2.drop = drop;
      lodash2.dropRight = dropRight;
      lodash2.dropRightWhile = dropRightWhile;
      lodash2.dropWhile = dropWhile;
      lodash2.fill = fill;
      lodash2.filter = filter;
      lodash2.flatMap = flatMap;
      lodash2.flatMapDeep = flatMapDeep;
      lodash2.flatMapDepth = flatMapDepth;
      lodash2.flatten = flatten;
      lodash2.flattenDeep = flattenDeep;
      lodash2.flattenDepth = flattenDepth;
      lodash2.flip = flip2;
      lodash2.flow = flow;
      lodash2.flowRight = flowRight;
      lodash2.fromPairs = fromPairs;
      lodash2.functions = functions;
      lodash2.functionsIn = functionsIn;
      lodash2.groupBy = groupBy;
      lodash2.initial = initial;
      lodash2.intersection = intersection;
      lodash2.intersectionBy = intersectionBy;
      lodash2.intersectionWith = intersectionWith;
      lodash2.invert = invert;
      lodash2.invertBy = invertBy;
      lodash2.invokeMap = invokeMap;
      lodash2.iteratee = iteratee;
      lodash2.keyBy = keyBy;
      lodash2.keys = keys;
      lodash2.keysIn = keysIn;
      lodash2.map = map2;
      lodash2.mapKeys = mapKeys;
      lodash2.mapValues = mapValues;
      lodash2.matches = matches2;
      lodash2.matchesProperty = matchesProperty;
      lodash2.memoize = memoize2;
      lodash2.merge = merge;
      lodash2.mergeWith = mergeWith;
      lodash2.method = method;
      lodash2.methodOf = methodOf;
      lodash2.mixin = mixin;
      lodash2.negate = negate;
      lodash2.nthArg = nthArg;
      lodash2.omit = omit;
      lodash2.omitBy = omitBy;
      lodash2.once = once;
      lodash2.orderBy = orderBy;
      lodash2.over = over;
      lodash2.overArgs = overArgs;
      lodash2.overEvery = overEvery;
      lodash2.overSome = overSome;
      lodash2.partial = partial;
      lodash2.partialRight = partialRight;
      lodash2.partition = partition;
      lodash2.pick = pick2;
      lodash2.pickBy = pickBy;
      lodash2.property = property;
      lodash2.propertyOf = propertyOf;
      lodash2.pull = pull;
      lodash2.pullAll = pullAll;
      lodash2.pullAllBy = pullAllBy;
      lodash2.pullAllWith = pullAllWith;
      lodash2.pullAt = pullAt;
      lodash2.range = range;
      lodash2.rangeRight = rangeRight;
      lodash2.rearg = rearg;
      lodash2.reject = reject;
      lodash2.remove = remove;
      lodash2.rest = rest;
      lodash2.reverse = reverse;
      lodash2.sampleSize = sampleSize;
      lodash2.set = set;
      lodash2.setWith = setWith;
      lodash2.shuffle = shuffle;
      lodash2.slice = slice2;
      lodash2.sortBy = sortBy;
      lodash2.sortedUniq = sortedUniq;
      lodash2.sortedUniqBy = sortedUniqBy;
      lodash2.split = split;
      lodash2.spread = spread;
      lodash2.tail = tail;
      lodash2.take = take;
      lodash2.takeRight = takeRight;
      lodash2.takeRightWhile = takeRightWhile;
      lodash2.takeWhile = takeWhile;
      lodash2.tap = tap;
      lodash2.throttle = throttle;
      lodash2.thru = thru;
      lodash2.toArray = toArray;
      lodash2.toPairs = toPairs;
      lodash2.toPairsIn = toPairsIn;
      lodash2.toPath = toPath;
      lodash2.toPlainObject = toPlainObject;
      lodash2.transform = transform;
      lodash2.unary = unary;
      lodash2.union = union;
      lodash2.unionBy = unionBy;
      lodash2.unionWith = unionWith;
      lodash2.uniq = uniq;
      lodash2.uniqBy = uniqBy;
      lodash2.uniqWith = uniqWith;
      lodash2.unset = unset;
      lodash2.unzip = unzip;
      lodash2.unzipWith = unzipWith;
      lodash2.update = update;
      lodash2.updateWith = updateWith;
      lodash2.values = values;
      lodash2.valuesIn = valuesIn;
      lodash2.without = without;
      lodash2.words = words;
      lodash2.wrap = wrap;
      lodash2.xor = xor;
      lodash2.xorBy = xorBy;
      lodash2.xorWith = xorWith;
      lodash2.zip = zip;
      lodash2.zipObject = zipObject;
      lodash2.zipObjectDeep = zipObjectDeep;
      lodash2.zipWith = zipWith;
      lodash2.entries = toPairs;
      lodash2.entriesIn = toPairsIn;
      lodash2.extend = assignIn;
      lodash2.extendWith = assignInWith;
      mixin(lodash2, lodash2);
      lodash2.add = add;
      lodash2.attempt = attempt;
      lodash2.camelCase = camelCase;
      lodash2.capitalize = capitalize;
      lodash2.ceil = ceil;
      lodash2.clamp = clamp;
      lodash2.clone = clone;
      lodash2.cloneDeep = cloneDeep;
      lodash2.cloneDeepWith = cloneDeepWith;
      lodash2.cloneWith = cloneWith;
      lodash2.conformsTo = conformsTo;
      lodash2.deburr = deburr;
      lodash2.defaultTo = defaultTo;
      lodash2.divide = divide;
      lodash2.endsWith = endsWith;
      lodash2.eq = eq;
      lodash2.escape = escape;
      lodash2.escapeRegExp = escapeRegExp;
      lodash2.every = every;
      lodash2.find = find;
      lodash2.findIndex = findIndex3;
      lodash2.findKey = findKey;
      lodash2.findLast = findLast;
      lodash2.findLastIndex = findLastIndex;
      lodash2.findLastKey = findLastKey;
      lodash2.floor = floor;
      lodash2.forEach = forEach;
      lodash2.forEachRight = forEachRight;
      lodash2.forIn = forIn;
      lodash2.forInRight = forInRight;
      lodash2.forOwn = forOwn;
      lodash2.forOwnRight = forOwnRight;
      lodash2.get = get;
      lodash2.gt = gt;
      lodash2.gte = gte;
      lodash2.has = has;
      lodash2.hasIn = hasIn;
      lodash2.head = head;
      lodash2.identity = identity;
      lodash2.includes = includes;
      lodash2.indexOf = indexOf;
      lodash2.inRange = inRange;
      lodash2.invoke = invoke;
      lodash2.isArguments = isArguments;
      lodash2.isArray = isArray2;
      lodash2.isArrayBuffer = isArrayBuffer;
      lodash2.isArrayLike = isArrayLike;
      lodash2.isArrayLikeObject = isArrayLikeObject;
      lodash2.isBoolean = isBoolean;
      lodash2.isBuffer = isBuffer;
      lodash2.isDate = isDate;
      lodash2.isElement = isElement2;
      lodash2.isEmpty = isEmpty;
      lodash2.isEqual = isEqual3;
      lodash2.isEqualWith = isEqualWith;
      lodash2.isError = isError;
      lodash2.isFinite = isFinite;
      lodash2.isFunction = isFunction2;
      lodash2.isInteger = isInteger;
      lodash2.isLength = isLength;
      lodash2.isMap = isMap;
      lodash2.isMatch = isMatch2;
      lodash2.isMatchWith = isMatchWith;
      lodash2.isNaN = isNaN2;
      lodash2.isNative = isNative;
      lodash2.isNil = isNil;
      lodash2.isNull = isNull;
      lodash2.isNumber = isNumber;
      lodash2.isObject = isObject2;
      lodash2.isObjectLike = isObjectLike2;
      lodash2.isPlainObject = isPlainObject;
      lodash2.isRegExp = isRegExp;
      lodash2.isSafeInteger = isSafeInteger;
      lodash2.isSet = isSet;
      lodash2.isString = isString2;
      lodash2.isSymbol = isSymbol2;
      lodash2.isTypedArray = isTypedArray;
      lodash2.isUndefined = isUndefined;
      lodash2.isWeakMap = isWeakMap;
      lodash2.isWeakSet = isWeakSet;
      lodash2.join = join;
      lodash2.kebabCase = kebabCase;
      lodash2.last = last;
      lodash2.lastIndexOf = lastIndexOf;
      lodash2.lowerCase = lowerCase;
      lodash2.lowerFirst = lowerFirst;
      lodash2.lt = lt;
      lodash2.lte = lte;
      lodash2.max = max2;
      lodash2.maxBy = maxBy;
      lodash2.mean = mean;
      lodash2.meanBy = meanBy;
      lodash2.min = min2;
      lodash2.minBy = minBy;
      lodash2.stubArray = stubArray;
      lodash2.stubFalse = stubFalse;
      lodash2.stubObject = stubObject;
      lodash2.stubString = stubString;
      lodash2.stubTrue = stubTrue;
      lodash2.multiply = multiply;
      lodash2.nth = nth;
      lodash2.noConflict = noConflict;
      lodash2.noop = noop4;
      lodash2.now = now2;
      lodash2.pad = pad;
      lodash2.padEnd = padEnd;
      lodash2.padStart = padStart;
      lodash2.parseInt = parseInt2;
      lodash2.random = random;
      lodash2.reduce = reduce;
      lodash2.reduceRight = reduceRight;
      lodash2.repeat = repeat;
      lodash2.replace = replace2;
      lodash2.result = result;
      lodash2.round = round2;
      lodash2.runInContext = runInContext2;
      lodash2.sample = sample;
      lodash2.size = size;
      lodash2.snakeCase = snakeCase;
      lodash2.some = some;
      lodash2.sortedIndex = sortedIndex;
      lodash2.sortedIndexBy = sortedIndexBy;
      lodash2.sortedIndexOf = sortedIndexOf;
      lodash2.sortedLastIndex = sortedLastIndex;
      lodash2.sortedLastIndexBy = sortedLastIndexBy;
      lodash2.sortedLastIndexOf = sortedLastIndexOf;
      lodash2.startCase = startCase;
      lodash2.startsWith = startsWith;
      lodash2.subtract = subtract;
      lodash2.sum = sum;
      lodash2.sumBy = sumBy;
      lodash2.template = template;
      lodash2.times = times;
      lodash2.toFinite = toFinite;
      lodash2.toInteger = toInteger;
      lodash2.toLength = toLength;
      lodash2.toLower = toLower;
      lodash2.toNumber = toNumber2;
      lodash2.toSafeInteger = toSafeInteger;
      lodash2.toString = toString;
      lodash2.toUpper = toUpper;
      lodash2.trim = trim2;
      lodash2.trimEnd = trimEnd;
      lodash2.trimStart = trimStart;
      lodash2.truncate = truncate;
      lodash2.unescape = unescape;
      lodash2.uniqueId = uniqueId2;
      lodash2.upperCase = upperCase;
      lodash2.upperFirst = upperFirst;
      lodash2.each = forEach;
      lodash2.eachRight = forEachRight;
      lodash2.first = head;
      mixin(lodash2, function() {
        var source = {};
        baseForOwn(lodash2, function(func, methodName) {
          if (!hasOwnProperty2.call(lodash2.prototype, methodName)) {
            source[methodName] = func;
          }
        });
        return source;
      }(), { "chain": false });
      lodash2.VERSION = VERSION;
      arrayEach(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
        lodash2[methodName].placeholder = lodash2;
      });
      arrayEach(["drop", "take"], function(methodName, index2) {
        LazyWrapper.prototype[methodName] = function(n2) {
          n2 = n2 === undefined$1 ? 1 : nativeMax2(toInteger(n2), 0);
          var result2 = this.__filtered__ && !index2 ? new LazyWrapper(this) : this.clone();
          if (result2.__filtered__) {
            result2.__takeCount__ = nativeMin2(n2, result2.__takeCount__);
          } else {
            result2.__views__.push({
              "size": nativeMin2(n2, MAX_ARRAY_LENGTH),
              "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
            });
          }
          return result2;
        };
        LazyWrapper.prototype[methodName + "Right"] = function(n2) {
          return this.reverse()[methodName](n2).reverse();
        };
      });
      arrayEach(["filter", "map", "takeWhile"], function(methodName, index2) {
        var type = index2 + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
        LazyWrapper.prototype[methodName] = function(iteratee2) {
          var result2 = this.clone();
          result2.__iteratees__.push({
            "iteratee": getIteratee(iteratee2, 3),
            "type": type
          });
          result2.__filtered__ = result2.__filtered__ || isFilter;
          return result2;
        };
      });
      arrayEach(["head", "last"], function(methodName, index2) {
        var takeName = "take" + (index2 ? "Right" : "");
        LazyWrapper.prototype[methodName] = function() {
          return this[takeName](1).value()[0];
        };
      });
      arrayEach(["initial", "tail"], function(methodName, index2) {
        var dropName = "drop" + (index2 ? "" : "Right");
        LazyWrapper.prototype[methodName] = function() {
          return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
        };
      });
      LazyWrapper.prototype.compact = function() {
        return this.filter(identity);
      };
      LazyWrapper.prototype.find = function(predicate) {
        return this.filter(predicate).head();
      };
      LazyWrapper.prototype.findLast = function(predicate) {
        return this.reverse().find(predicate);
      };
      LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
        if (typeof path == "function") {
          return new LazyWrapper(this);
        }
        return this.map(function(value) {
          return baseInvoke(value, path, args);
        });
      });
      LazyWrapper.prototype.reject = function(predicate) {
        return this.filter(negate(getIteratee(predicate)));
      };
      LazyWrapper.prototype.slice = function(start2, end2) {
        start2 = toInteger(start2);
        var result2 = this;
        if (result2.__filtered__ && (start2 > 0 || end2 < 0)) {
          return new LazyWrapper(result2);
        }
        if (start2 < 0) {
          result2 = result2.takeRight(-start2);
        } else if (start2) {
          result2 = result2.drop(start2);
        }
        if (end2 !== undefined$1) {
          end2 = toInteger(end2);
          result2 = end2 < 0 ? result2.dropRight(-end2) : result2.take(end2 - start2);
        }
        return result2;
      };
      LazyWrapper.prototype.takeRightWhile = function(predicate) {
        return this.reverse().takeWhile(predicate).reverse();
      };
      LazyWrapper.prototype.toArray = function() {
        return this.take(MAX_ARRAY_LENGTH);
      };
      baseForOwn(LazyWrapper.prototype, function(func, methodName) {
        var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash2[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
        if (!lodashFunc) {
          return;
        }
        lodash2.prototype[methodName] = function() {
          var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray2(value);
          var interceptor = function(value2) {
            var result3 = lodashFunc.apply(lodash2, arrayPush([value2], args));
            return isTaker && chainAll ? result3[0] : result3;
          };
          if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
            isLazy = useLazy = false;
          }
          var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
          if (!retUnwrapped && useLazy) {
            value = onlyLazy ? value : new LazyWrapper(this);
            var result2 = func.apply(value, args);
            result2.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined$1 });
            return new LodashWrapper(result2, chainAll);
          }
          if (isUnwrapped && onlyLazy) {
            return func.apply(this, args);
          }
          result2 = this.thru(interceptor);
          return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
        };
      });
      arrayEach(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
        var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
        lodash2.prototype[methodName] = function() {
          var args = arguments;
          if (retUnwrapped && !this.__chain__) {
            var value = this.value();
            return func.apply(isArray2(value) ? value : [], args);
          }
          return this[chainName](function(value2) {
            return func.apply(isArray2(value2) ? value2 : [], args);
          });
        };
      });
      baseForOwn(LazyWrapper.prototype, function(func, methodName) {
        var lodashFunc = lodash2[methodName];
        if (lodashFunc) {
          var key = lodashFunc.name + "";
          if (!hasOwnProperty2.call(realNames, key)) {
            realNames[key] = [];
          }
          realNames[key].push({ "name": methodName, "func": lodashFunc });
        }
      });
      realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
        "name": "wrapper",
        "func": undefined$1
      }];
      LazyWrapper.prototype.clone = lazyClone;
      LazyWrapper.prototype.reverse = lazyReverse;
      LazyWrapper.prototype.value = lazyValue;
      lodash2.prototype.at = wrapperAt;
      lodash2.prototype.chain = wrapperChain;
      lodash2.prototype.commit = wrapperCommit;
      lodash2.prototype.next = wrapperNext;
      lodash2.prototype.plant = wrapperPlant;
      lodash2.prototype.reverse = wrapperReverse;
      lodash2.prototype.toJSON = lodash2.prototype.valueOf = lodash2.prototype.value = wrapperValue;
      lodash2.prototype.first = lodash2.prototype.head;
      if (symIterator) {
        lodash2.prototype[symIterator] = wrapperToIterator;
      }
      return lodash2;
    };
    var _ = runInContext();
    if (freeModule) {
      (freeModule.exports = _)._ = _;
      freeExports._ = _;
    } else {
      root2._ = _;
    }
  }).call(commonjsGlobal);
})(lodash, lodash.exports);
var reactTable = { exports: {} };
var reactTable_production_min = { exports: {} };
(function(module, exports) {
  !function(e2, t2) {
    t2(exports, React__default);
  }(commonjsGlobal, function(e2, t2) {
    function n2(e3, t3, n3, o2, r3, i3, u2) {
      try {
        var l3 = e3[i3](u2), s2 = l3.value;
      } catch (e4) {
        return void n3(e4);
      }
      l3.done ? t3(s2) : Promise.resolve(s2).then(o2, r3);
    }
    function o(e3) {
      return function() {
        var t3 = this, o2 = arguments;
        return new Promise(function(r3, i3) {
          var u2 = e3.apply(t3, o2);
          function l3(e4) {
            n2(u2, r3, i3, l3, s2, "next", e4);
          }
          function s2(e4) {
            n2(u2, r3, i3, l3, s2, "throw", e4);
          }
          l3(void 0);
        });
      };
    }
    function r2() {
      return (r2 = Object.assign || function(e3) {
        for (var t3 = 1; t3 < arguments.length; t3++) {
          var n3 = arguments[t3];
          for (var o2 in n3)
            Object.prototype.hasOwnProperty.call(n3, o2) && (e3[o2] = n3[o2]);
        }
        return e3;
      }).apply(this, arguments);
    }
    function i2(e3, t3) {
      if (null == e3)
        return {};
      var n3, o2, r3 = {}, i3 = Object.keys(e3);
      for (o2 = 0; o2 < i3.length; o2++)
        n3 = i3[o2], t3.indexOf(n3) >= 0 || (r3[n3] = e3[n3]);
      return r3;
    }
    function u(e3) {
      var t3 = function(e4, t4) {
        if ("object" != typeof e4 || null === e4)
          return e4;
        var n3 = e4[Symbol.toPrimitive];
        if (void 0 !== n3) {
          var o2 = n3.call(e4, t4 || "default");
          if ("object" != typeof o2)
            return o2;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === t4 ? String : Number)(e4);
      }(e3, "string");
      return "symbol" == typeof t3 ? t3 : String(t3);
    }
    t2 = t2 && Object.prototype.hasOwnProperty.call(t2, "default") ? t2.default : t2;
    var l2 = { init: "init" }, s = function(e3) {
      var t3 = e3.value;
      return void 0 === t3 ? "" : t3;
    }, a = function() {
      return t2.createElement(t2.Fragment, null, "\xA0");
    }, c2 = { Cell: s, width: 150, minWidth: 0, maxWidth: Number.MAX_SAFE_INTEGER };
    function d2() {
      for (var e3 = arguments.length, t3 = new Array(e3), n3 = 0; n3 < e3; n3++)
        t3[n3] = arguments[n3];
      return t3.reduce(function(e4, t4) {
        var n4 = t4.style, o2 = t4.className;
        return e4 = r2({}, e4, {}, i2(t4, ["style", "className"])), n4 && (e4.style = e4.style ? r2({}, e4.style || {}, {}, n4 || {}) : n4), o2 && (e4.className = e4.className ? e4.className + " " + o2 : o2), "" === e4.className && delete e4.className, e4;
      }, {});
    }
    var f2 = function(e3, t3) {
      return void 0 === t3 && (t3 = {}), function(n3) {
        return void 0 === n3 && (n3 = {}), [].concat(e3, [n3]).reduce(function(e4, o2) {
          return function e5(t4, n4, o3) {
            return "function" == typeof n4 ? e5({}, n4(t4, o3)) : Array.isArray(n4) ? d2.apply(void 0, [t4].concat(n4)) : d2(t4, n4);
          }(e4, o2, r2({}, t3, { userProps: n3 }));
        }, {});
      };
    }, p2 = function(e3, t3, n3, o2) {
      return void 0 === n3 && (n3 = {}), e3.reduce(function(e4, t4) {
        return t4(e4, n3);
      }, t3);
    }, g2 = function(e3, t3, n3) {
      return void 0 === n3 && (n3 = {}), e3.forEach(function(e4) {
        e4(t3, n3);
      });
    };
    function v2(e3, t3, n3, o2) {
      e3.findIndex(function(e4) {
        return e4.pluginName === n3;
      });
      t3.forEach(function(t4) {
        e3.findIndex(function(e4) {
          return e4.pluginName === t4;
        });
      });
    }
    function m2(e3, t3) {
      return "function" == typeof e3 ? e3(t3) : e3;
    }
    function h2(e3) {
      var n3 = t2.useRef();
      return n3.current = e3, t2.useCallback(function() {
        return n3.current;
      }, []);
    }
    var y2 = "undefined" != typeof document ? t2.useLayoutEffect : t2.useEffect;
    function w2(e3, n3) {
      var o2 = t2.useRef(false);
      y2(function() {
        o2.current && e3(), o2.current = true;
      }, n3);
    }
    function R(e3, t3, n3) {
      return void 0 === n3 && (n3 = {}), function(o2, i3) {
        void 0 === i3 && (i3 = {});
        var u2 = "string" == typeof o2 ? t3[o2] : o2;
        if (void 0 === u2)
          throw console.info(t3), new Error("Renderer Error \u261D\uFE0F");
        return b2(u2, r2({}, e3, { column: t3 }, n3, {}, i3));
      };
    }
    function b2(e3, n3) {
      return function(e4) {
        return "function" == typeof e4 && ((t3 = Object.getPrototypeOf(e4)).prototype && t3.prototype.isReactComponent);
        var t3;
      }(o2 = e3) || "function" == typeof o2 || function(e4) {
        return "object" == typeof e4 && "symbol" == typeof e4.$$typeof && ["react.memo", "react.forward_ref"].includes(e4.$$typeof.description);
      }(o2) ? t2.createElement(e3, n3) : e3;
      var o2;
    }
    function S(e3, t3, n3) {
      return void 0 === n3 && (n3 = 0), e3.map(function(e4) {
        return x2(e4 = r2({}, e4, { parent: t3, depth: n3 })), e4.columns && (e4.columns = S(e4.columns, e4, n3 + 1)), e4;
      });
    }
    function C(e3) {
      return G(e3, "columns");
    }
    function x2(e3) {
      var t3 = e3.id, n3 = e3.accessor, o2 = e3.Header;
      if ("string" == typeof n3) {
        t3 = t3 || n3;
        var r3 = n3.split(".");
        n3 = function(e4) {
          return function(e5, t4, n4) {
            if (!t4)
              return e5;
            var o3, r4 = "function" == typeof t4 ? t4 : JSON.stringify(t4), i3 = E.get(r4) || function() {
              var e6 = function(e7) {
                return function e8(t5, n5) {
                  void 0 === n5 && (n5 = []);
                  if (Array.isArray(t5))
                    for (var o4 = 0; o4 < t5.length; o4 += 1)
                      e8(t5[o4], n5);
                  else
                    n5.push(t5);
                  return n5;
                }(e7).map(function(e8) {
                  return String(e8).replace(".", "_");
                }).join(".").replace(W, ".").replace(O, "").split(".");
              }(t4);
              return E.set(r4, e6), e6;
            }();
            try {
              o3 = i3.reduce(function(e6, t5) {
                return e6[t5];
              }, e5);
            } catch (e6) {
            }
            return void 0 !== o3 ? o3 : n4;
          }(e4, r3);
        };
      }
      if (!t3 && "string" == typeof o2 && o2 && (t3 = o2), !t3 && e3.columns)
        throw console.error(e3), new Error('A column ID (or unique "Header" value) is required!');
      if (!t3)
        throw console.error(e3), new Error("A column ID (or string accessor) is required!");
      return Object.assign(e3, { id: t3, accessor: n3 }), e3;
    }
    function P(e3, t3) {
      if (!t3)
        throw new Error();
      return Object.assign(e3, r2({ Header: a, Footer: a }, c2, {}, t3, {}, e3)), Object.assign(e3, { originalWidth: e3.width }), e3;
    }
    function B(e3, t3, n3) {
      void 0 === n3 && (n3 = function() {
        return {};
      });
      for (var o2 = [], i3 = e3, u2 = 0, l3 = function() {
        return u2++;
      }, s2 = function() {
        var e4 = { headers: [] }, u3 = [], s3 = i3.some(function(e5) {
          return e5.parent;
        });
        i3.forEach(function(o3) {
          var i4, a2 = [].concat(u3).reverse()[0];
          if (s3) {
            if (o3.parent)
              i4 = r2({}, o3.parent, { originalId: o3.parent.id, id: o3.parent.id + "_" + l3(), headers: [o3] }, n3(o3));
            else
              i4 = P(r2({ originalId: o3.id + "_placeholder", id: o3.id + "_placeholder_" + l3(), placeholderOf: o3, headers: [o3] }, n3(o3)), t3);
            a2 && a2.originalId === i4.originalId ? a2.headers.push(o3) : u3.push(i4);
          }
          e4.headers.push(o3);
        }), o2.push(e4), i3 = u3;
      }; i3.length; )
        s2();
      return o2.reverse();
    }
    var E = /* @__PURE__ */ new Map();
    function I() {
      for (var e3 = arguments.length, t3 = new Array(e3), n3 = 0; n3 < e3; n3++)
        t3[n3] = arguments[n3];
      for (var o2 = 0; o2 < t3.length; o2 += 1)
        if (void 0 !== t3[o2])
          return t3[o2];
    }
    function F(e3) {
      if ("function" == typeof e3)
        return e3;
    }
    function G(e3, t3) {
      var n3 = [];
      return function e4(o2) {
        o2.forEach(function(o3) {
          o3[t3] ? e4(o3[t3]) : n3.push(o3);
        });
      }(e3), n3;
    }
    function A2(e3, t3) {
      var n3 = t3.manualExpandedKey, o2 = t3.expanded, r3 = t3.expandSubRows, i3 = void 0 === r3 || r3, u2 = [];
      return e3.forEach(function(e4) {
        return function e5(t4, r4) {
          void 0 === r4 && (r4 = true), t4.isExpanded = t4.original && t4.original[n3] || o2[t4.id], t4.canExpand = t4.subRows && !!t4.subRows.length, r4 && u2.push(t4), t4.subRows && t4.subRows.length && t4.isExpanded && t4.subRows.forEach(function(t5) {
            return e5(t5, i3);
          });
        }(e4);
      }), u2;
    }
    function k2(e3, t3, n3) {
      return F(e3) || t3[e3] || n3[e3] || n3.text;
    }
    function H(e3, t3, n3) {
      return e3 ? e3(t3, n3) : void 0 === t3;
    }
    function T() {
      throw new Error("React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.");
    }
    var z2 = null;
    var W = /\[/g, O = /\]/g;
    var M = function(e3) {
      return r2({ role: "table" }, e3);
    }, j = function(e3) {
      return r2({ role: "rowgroup" }, e3);
    }, N = function(e3, t3) {
      var n3 = t3.column;
      return r2({ key: "header_" + n3.id, colSpan: n3.totalVisibleHeaderCount, role: "columnheader" }, e3);
    }, L = function(e3, t3) {
      var n3 = t3.column;
      return r2({ key: "footer_" + n3.id, colSpan: n3.totalVisibleHeaderCount }, e3);
    }, D = function(e3, t3) {
      return r2({ key: "headerGroup_" + t3.index, role: "row" }, e3);
    }, V = function(e3, t3) {
      return r2({ key: "footerGroup_" + t3.index }, e3);
    }, _ = function(e3, t3) {
      return r2({ key: "row_" + t3.row.id, role: "row" }, e3);
    }, X = function(e3, t3) {
      var n3 = t3.cell;
      return r2({ key: "cell_" + n3.row.id + "_" + n3.column.id, role: "cell" }, e3);
    };
    function q2() {
      return { useOptions: [], stateReducers: [], useControlledState: [], columns: [], columnsDeps: [], allColumns: [], allColumnsDeps: [], accessValue: [], materializedColumns: [], materializedColumnsDeps: [], useInstanceAfterData: [], visibleColumns: [], visibleColumnsDeps: [], headerGroups: [], headerGroupsDeps: [], useInstanceBeforeDimensions: [], useInstance: [], prepareRow: [], getTableProps: [M], getTableBodyProps: [j], getHeaderGroupProps: [D], getFooterGroupProps: [V], getHeaderProps: [N], getFooterProps: [L], getRowProps: [_], getCellProps: [X], useFinalInstance: [] };
    }
    l2.resetHiddenColumns = "resetHiddenColumns", l2.toggleHideColumn = "toggleHideColumn", l2.setHiddenColumns = "setHiddenColumns", l2.toggleHideAllColumns = "toggleHideAllColumns";
    var K = function(e3) {
      e3.getToggleHiddenProps = [U], e3.getToggleHideAllColumnsProps = [$], e3.stateReducers.push(J), e3.useInstanceBeforeDimensions.push(Y), e3.headerGroupsDeps.push(function(e4, t3) {
        var n3 = t3.instance;
        return [].concat(e4, [n3.state.hiddenColumns]);
      }), e3.useInstance.push(Q);
    };
    K.pluginName = "useColumnVisibility";
    var U = function(e3, t3) {
      var n3 = t3.column;
      return [e3, { onChange: function(e4) {
        n3.toggleHidden(!e4.target.checked);
      }, style: { cursor: "pointer" }, checked: n3.isVisible, title: "Toggle Column Visible" }];
    }, $ = function(e3, t3) {
      var n3 = t3.instance;
      return [e3, { onChange: function(e4) {
        n3.toggleHideAllColumns(!e4.target.checked);
      }, style: { cursor: "pointer" }, checked: !n3.allColumnsHidden && !n3.state.hiddenColumns.length, title: "Toggle All Columns Hidden", indeterminate: !n3.allColumnsHidden && n3.state.hiddenColumns.length }];
    };
    function J(e3, t3, n3, o2) {
      if (t3.type === l2.init)
        return r2({ hiddenColumns: [] }, e3);
      if (t3.type === l2.resetHiddenColumns)
        return r2({}, e3, { hiddenColumns: o2.initialState.hiddenColumns || [] });
      if (t3.type === l2.toggleHideColumn) {
        var i3 = (void 0 !== t3.value ? t3.value : !e3.hiddenColumns.includes(t3.columnId)) ? [].concat(e3.hiddenColumns, [t3.columnId]) : e3.hiddenColumns.filter(function(e4) {
          return e4 !== t3.columnId;
        });
        return r2({}, e3, { hiddenColumns: i3 });
      }
      return t3.type === l2.setHiddenColumns ? r2({}, e3, { hiddenColumns: m2(t3.value, e3.hiddenColumns) }) : t3.type === l2.toggleHideAllColumns ? r2({}, e3, { hiddenColumns: (void 0 !== t3.value ? t3.value : !e3.hiddenColumns.length) ? o2.allColumns.map(function(e4) {
        return e4.id;
      }) : [] }) : void 0;
    }
    function Y(e3) {
      var n3 = e3.headers, o2 = e3.state.hiddenColumns;
      t2.useRef(false).current;
      var r3 = 0;
      n3.forEach(function(e4) {
        return r3 += function e5(t3, n4) {
          t3.isVisible = n4 && !o2.includes(t3.id);
          var r4 = 0;
          return t3.headers && t3.headers.length ? t3.headers.forEach(function(n5) {
            return r4 += e5(n5, t3.isVisible);
          }) : r4 = t3.isVisible ? 1 : 0, t3.totalVisibleHeaderCount = r4, r4;
        }(e4, true);
      });
    }
    function Q(e3) {
      var n3 = e3.columns, o2 = e3.flatHeaders, r3 = e3.dispatch, i3 = e3.allColumns, u2 = e3.getHooks, s2 = e3.state.hiddenColumns, a2 = e3.autoResetHiddenColumns, c3 = void 0 === a2 || a2, d3 = h2(e3), p3 = i3.length === s2.length, g3 = t2.useCallback(function(e4, t3) {
        return r3({ type: l2.toggleHideColumn, columnId: e4, value: t3 });
      }, [r3]), v3 = t2.useCallback(function(e4) {
        return r3({ type: l2.setHiddenColumns, value: e4 });
      }, [r3]), m3 = t2.useCallback(function(e4) {
        return r3({ type: l2.toggleHideAllColumns, value: e4 });
      }, [r3]), y3 = f2(u2().getToggleHideAllColumnsProps, { instance: d3() });
      o2.forEach(function(e4) {
        e4.toggleHidden = function(t3) {
          r3({ type: l2.toggleHideColumn, columnId: e4.id, value: t3 });
        }, e4.getToggleHiddenProps = f2(u2().getToggleHiddenProps, { instance: d3(), column: e4 });
      });
      var R2 = h2(c3);
      w2(function() {
        R2() && r3({ type: l2.resetHiddenColumns });
      }, [r3, n3]), Object.assign(e3, { allColumnsHidden: p3, toggleHideColumn: g3, setHiddenColumns: v3, toggleHideAllColumns: m3, getToggleHideAllColumnsProps: y3 });
    }
    var Z = {}, ee = {}, te = function(e3, t3, n3) {
      return e3;
    }, ne = function(e3, t3) {
      return e3.subRows || [];
    }, oe = function(e3, t3, n3) {
      return "" + (n3 ? [n3.id, t3].join(".") : t3);
    }, re = function(e3) {
      return e3;
    };
    function ie(e3) {
      var t3 = e3.initialState, n3 = void 0 === t3 ? Z : t3, o2 = e3.defaultColumn, u2 = void 0 === o2 ? ee : o2, l3 = e3.getSubRows, s2 = void 0 === l3 ? ne : l3, a2 = e3.getRowId, c3 = void 0 === a2 ? oe : a2, d3 = e3.stateReducer, f3 = void 0 === d3 ? te : d3, p3 = e3.useControlledState, g3 = void 0 === p3 ? re : p3;
      return r2({}, i2(e3, ["initialState", "defaultColumn", "getSubRows", "getRowId", "stateReducer", "useControlledState"]), { initialState: n3, defaultColumn: u2, getSubRows: s2, getRowId: c3, stateReducer: f3, useControlledState: g3 });
    }
    function ue(e3, t3) {
      void 0 === t3 && (t3 = 0);
      var n3 = 0, o2 = 0, r3 = 0, i3 = 0;
      return e3.forEach(function(e4) {
        var u2 = e4.headers;
        if (e4.totalLeft = t3, u2 && u2.length) {
          var l3 = ue(u2, t3), s2 = l3[0], a2 = l3[1], c3 = l3[2], d3 = l3[3];
          e4.totalMinWidth = s2, e4.totalWidth = a2, e4.totalMaxWidth = c3, e4.totalFlexWidth = d3;
        } else
          e4.totalMinWidth = e4.minWidth, e4.totalWidth = Math.min(Math.max(e4.minWidth, e4.width), e4.maxWidth), e4.totalMaxWidth = e4.maxWidth, e4.totalFlexWidth = e4.canResize ? e4.totalWidth : 0;
        e4.isVisible && (t3 += e4.totalWidth, n3 += e4.totalMinWidth, o2 += e4.totalWidth, r3 += e4.totalMaxWidth, i3 += e4.totalFlexWidth);
      }), [n3, o2, r3, i3];
    }
    function le(e3) {
      var t3 = e3.data, n3 = e3.rows, o2 = e3.flatRows, r3 = e3.rowsById, i3 = e3.column, u2 = e3.getRowId, l3 = e3.getSubRows, s2 = e3.accessValueHooks, a2 = e3.getInstance;
      t3.forEach(function(e4, c3) {
        return function e5(n4, c4, d3, f3, g3) {
          void 0 === d3 && (d3 = 0);
          var v3 = n4, m3 = u2(n4, c4, f3), h3 = r3[m3];
          if (h3)
            h3.subRows && h3.originalSubRows.forEach(function(t4, n5) {
              return e5(t4, n5, d3 + 1, h3);
            });
          else if ((h3 = { id: m3, original: v3, index: c4, depth: d3, cells: [{}] }).cells.map = T, h3.cells.filter = T, h3.cells.forEach = T, h3.cells[0].getCellProps = T, h3.values = {}, g3.push(h3), o2.push(h3), r3[m3] = h3, h3.originalSubRows = l3(n4, c4), h3.originalSubRows) {
            var y3 = [];
            h3.originalSubRows.forEach(function(t4, n5) {
              return e5(t4, n5, d3 + 1, h3, y3);
            }), h3.subRows = y3;
          }
          i3.accessor && (h3.values[i3.id] = i3.accessor(n4, c4, h3, g3, t3)), h3.values[i3.id] = p2(s2, h3.values[i3.id], { row: h3, column: i3, instance: a2() });
        }(e4, c3, 0, void 0, n3);
      });
    }
    l2.resetExpanded = "resetExpanded", l2.toggleRowExpanded = "toggleRowExpanded", l2.toggleAllRowsExpanded = "toggleAllRowsExpanded";
    var se = function(e3) {
      e3.getToggleAllRowsExpandedProps = [ae], e3.getToggleRowExpandedProps = [ce], e3.stateReducers.push(de), e3.useInstance.push(fe), e3.prepareRow.push(pe);
    };
    se.pluginName = "useExpanded";
    var ae = function(e3, t3) {
      var n3 = t3.instance;
      return [e3, { onClick: function(e4) {
        n3.toggleAllRowsExpanded();
      }, style: { cursor: "pointer" }, title: "Toggle All Rows Expanded" }];
    }, ce = function(e3, t3) {
      var n3 = t3.row;
      return [e3, { onClick: function() {
        n3.toggleRowExpanded();
      }, style: { cursor: "pointer" }, title: "Toggle Row Expanded" }];
    };
    function de(e3, t3, n3, o2) {
      if (t3.type === l2.init)
        return r2({ expanded: {} }, e3);
      if (t3.type === l2.resetExpanded)
        return r2({}, e3, { expanded: o2.initialState.expanded || {} });
      if (t3.type === l2.toggleAllRowsExpanded) {
        var s2 = t3.value, a2 = o2.isAllRowsExpanded, c3 = o2.rowsById;
        if (void 0 !== s2 ? s2 : !a2) {
          var d3 = {};
          return Object.keys(c3).forEach(function(e4) {
            d3[e4] = true;
          }), r2({}, e3, { expanded: d3 });
        }
        return r2({}, e3, { expanded: {} });
      }
      if (t3.type === l2.toggleRowExpanded) {
        var f3, p3 = t3.id, g3 = t3.value, v3 = e3.expanded[p3], m3 = void 0 !== g3 ? g3 : !v3;
        if (!v3 && m3)
          return r2({}, e3, { expanded: r2({}, e3.expanded, (f3 = {}, f3[p3] = true, f3)) });
        if (v3 && !m3) {
          var h3 = e3.expanded;
          h3[p3];
          return r2({}, e3, { expanded: i2(h3, [p3].map(u)) });
        }
        return e3;
      }
    }
    function fe(e3) {
      var n3 = e3.data, o2 = e3.rows, r3 = e3.rowsById, i3 = e3.manualExpandedKey, u2 = void 0 === i3 ? "expanded" : i3, s2 = e3.paginateExpandedRows, a2 = void 0 === s2 || s2, c3 = e3.expandSubRows, d3 = void 0 === c3 || c3, p3 = e3.autoResetExpanded, g3 = void 0 === p3 || p3, m3 = e3.getHooks, y3 = e3.plugins, R2 = e3.state.expanded, b3 = e3.dispatch;
      v2(y3, ["useSortBy", "useGroupBy", "usePivotColumns", "useGlobalFilter"], "useExpanded");
      var S2 = h2(g3), C2 = Boolean(Object.keys(r3).length && Object.keys(R2).length);
      C2 && Object.keys(r3).some(function(e4) {
        return !R2[e4];
      }) && (C2 = false), w2(function() {
        S2() && b3({ type: l2.resetExpanded });
      }, [b3, n3]);
      var x3 = t2.useCallback(function(e4, t3) {
        b3({ type: l2.toggleRowExpanded, id: e4, value: t3 });
      }, [b3]), P2 = t2.useCallback(function(e4) {
        return b3({ type: l2.toggleAllRowsExpanded, value: e4 });
      }, [b3]), B2 = t2.useMemo(function() {
        return a2 ? A2(o2, { manualExpandedKey: u2, expanded: R2, expandSubRows: d3 }) : o2;
      }, [a2, o2, u2, R2, d3]), E2 = t2.useMemo(function() {
        return function(e4) {
          var t3 = 0;
          return Object.keys(e4).forEach(function(e5) {
            var n4 = e5.split(".");
            t3 = Math.max(t3, n4.length);
          }), t3;
        }(R2);
      }, [R2]), I2 = h2(e3), F2 = f2(m3().getToggleAllRowsExpandedProps, { instance: I2() });
      Object.assign(e3, { preExpandedRows: o2, expandedRows: B2, rows: B2, expandedDepth: E2, isAllRowsExpanded: C2, toggleRowExpanded: x3, toggleAllRowsExpanded: P2, getToggleAllRowsExpandedProps: F2 });
    }
    function pe(e3, t3) {
      var n3 = t3.instance.getHooks, o2 = t3.instance;
      e3.toggleRowExpanded = function(t4) {
        return o2.toggleRowExpanded(e3.id, t4);
      }, e3.getToggleRowExpandedProps = f2(n3().getToggleRowExpandedProps, { instance: o2, row: e3 });
    }
    var ge = function(e3, t3, n3) {
      return e3 = e3.filter(function(e4) {
        return t3.some(function(t4) {
          var o2 = e4.values[t4];
          return String(o2).toLowerCase().includes(String(n3).toLowerCase());
        });
      });
    };
    ge.autoRemove = function(e3) {
      return !e3;
    };
    var ve = function(e3, t3, n3) {
      return e3.filter(function(e4) {
        return t3.some(function(t4) {
          var o2 = e4.values[t4];
          return void 0 === o2 || String(o2).toLowerCase() === String(n3).toLowerCase();
        });
      });
    };
    ve.autoRemove = function(e3) {
      return !e3;
    };
    var me = function(e3, t3, n3) {
      return e3.filter(function(e4) {
        return t3.some(function(t4) {
          var o2 = e4.values[t4];
          return void 0 === o2 || String(o2) === String(n3);
        });
      });
    };
    me.autoRemove = function(e3) {
      return !e3;
    };
    var he = function(e3, t3, n3) {
      return e3.filter(function(e4) {
        return t3.some(function(t4) {
          return e4.values[t4].includes(n3);
        });
      });
    };
    he.autoRemove = function(e3) {
      return !e3 || !e3.length;
    };
    var ye = function(e3, t3, n3) {
      return e3.filter(function(e4) {
        return t3.some(function(t4) {
          var o2 = e4.values[t4];
          return o2 && o2.length && n3.every(function(e5) {
            return o2.includes(e5);
          });
        });
      });
    };
    ye.autoRemove = function(e3) {
      return !e3 || !e3.length;
    };
    var we = function(e3, t3, n3) {
      return e3.filter(function(e4) {
        return t3.some(function(t4) {
          var o2 = e4.values[t4];
          return o2 && o2.length && n3.some(function(e5) {
            return o2.includes(e5);
          });
        });
      });
    };
    we.autoRemove = function(e3) {
      return !e3 || !e3.length;
    };
    var Re = function(e3, t3, n3) {
      return e3.filter(function(e4) {
        return t3.some(function(t4) {
          var o2 = e4.values[t4];
          return n3.includes(o2);
        });
      });
    };
    Re.autoRemove = function(e3) {
      return !e3 || !e3.length;
    };
    var be = function(e3, t3, n3) {
      return e3.filter(function(e4) {
        return t3.some(function(t4) {
          return e4.values[t4] === n3;
        });
      });
    };
    be.autoRemove = function(e3) {
      return void 0 === e3;
    };
    var Se = function(e3, t3, n3) {
      return e3.filter(function(e4) {
        return t3.some(function(t4) {
          return e4.values[t4] == n3;
        });
      });
    };
    Se.autoRemove = function(e3) {
      return null == e3;
    };
    var Ce = function(e3, t3, n3) {
      var o2 = n3 || [], r3 = o2[0], i3 = o2[1];
      if ((r3 = "number" == typeof r3 ? r3 : -1 / 0) > (i3 = "number" == typeof i3 ? i3 : 1 / 0)) {
        var u2 = r3;
        r3 = i3, i3 = u2;
      }
      return e3.filter(function(e4) {
        return t3.some(function(t4) {
          var n4 = e4.values[t4];
          return n4 >= r3 && n4 <= i3;
        });
      });
    };
    Ce.autoRemove = function(e3) {
      return !e3 || "number" != typeof e3[0] && "number" != typeof e3[1];
    };
    var xe = Object.freeze({ __proto__: null, text: ge, exactText: ve, exactTextCase: me, includes: he, includesAll: ye, includesSome: we, includesValue: Re, exact: be, equals: Se, between: Ce });
    l2.resetFilters = "resetFilters", l2.setFilter = "setFilter", l2.setAllFilters = "setAllFilters";
    var Pe = function(e3) {
      e3.stateReducers.push(Be), e3.useInstance.push(Ee);
    };
    function Be(e3, t3, n3, o2) {
      if (t3.type === l2.init)
        return r2({ filters: [] }, e3);
      if (t3.type === l2.resetFilters)
        return r2({}, e3, { filters: o2.initialState.filters || [] });
      if (t3.type === l2.setFilter) {
        var i3 = t3.columnId, u2 = t3.filterValue, s2 = o2.allColumns, a2 = o2.filterTypes, c3 = s2.find(function(e4) {
          return e4.id === i3;
        });
        if (!c3)
          throw new Error("React-Table: Could not find a column with id: " + i3);
        var d3 = k2(c3.filter, a2 || {}, xe), f3 = e3.filters.find(function(e4) {
          return e4.id === i3;
        }), p3 = m2(u2, f3 && f3.value);
        return H(d3.autoRemove, p3, c3) ? r2({}, e3, { filters: e3.filters.filter(function(e4) {
          return e4.id !== i3;
        }) }) : r2({}, e3, f3 ? { filters: e3.filters.map(function(e4) {
          return e4.id === i3 ? { id: i3, value: p3 } : e4;
        }) } : { filters: [].concat(e3.filters, [{ id: i3, value: p3 }]) });
      }
      if (t3.type === l2.setAllFilters) {
        var g3 = t3.filters, v3 = o2.allColumns, h3 = o2.filterTypes;
        return r2({}, e3, { filters: m2(g3, e3.filters).filter(function(e4) {
          var t4 = v3.find(function(t5) {
            return t5.id === e4.id;
          });
          return !H(k2(t4.filter, h3 || {}, xe).autoRemove, e4.value, t4);
        }) });
      }
    }
    function Ee(e3) {
      var n3 = e3.data, o2 = e3.rows, r3 = e3.flatRows, i3 = e3.rowsById, u2 = e3.allColumns, s2 = e3.filterTypes, a2 = e3.manualFilters, c3 = e3.defaultCanFilter, d3 = void 0 !== c3 && c3, f3 = e3.disableFilters, p3 = e3.state.filters, g3 = e3.dispatch, v3 = e3.autoResetFilters, m3 = void 0 === v3 || v3, y3 = t2.useCallback(function(e4, t3) {
        g3({ type: l2.setFilter, columnId: e4, filterValue: t3 });
      }, [g3]), R2 = t2.useCallback(function(e4) {
        g3({ type: l2.setAllFilters, filters: e4 });
      }, [g3]);
      u2.forEach(function(e4) {
        var t3 = e4.id, n4 = e4.accessor, o3 = e4.defaultCanFilter, r4 = e4.disableFilters;
        e4.canFilter = n4 ? I(true !== r4 && void 0, true !== f3 && void 0, true) : I(o3, d3, false), e4.setFilter = function(t4) {
          return y3(e4.id, t4);
        };
        var i4 = p3.find(function(e5) {
          return e5.id === t3;
        });
        e4.filterValue = i4 && i4.value;
      });
      var b3 = t2.useMemo(function() {
        if (a2 || !p3.length)
          return [o2, r3, i3];
        var e4 = [], t3 = {};
        return [function n4(o3, r4) {
          void 0 === r4 && (r4 = 0);
          var i4 = o3;
          return (i4 = p3.reduce(function(e5, t4) {
            var n5 = t4.id, o4 = t4.value, i5 = u2.find(function(e6) {
              return e6.id === n5;
            });
            if (!i5)
              return e5;
            0 === r4 && (i5.preFilteredRows = e5);
            var l3 = k2(i5.filter, s2 || {}, xe);
            return l3 ? (i5.filteredRows = l3(e5, [n5], o4), i5.filteredRows) : (console.warn("Could not find a valid 'column.filter' for column with the ID: " + i5.id + "."), e5);
          }, o3)).forEach(function(o4) {
            e4.push(o4), t3[o4.id] = o4, o4.subRows && (o4.subRows = o4.subRows && o4.subRows.length > 0 ? n4(o4.subRows, r4 + 1) : o4.subRows);
          }), i4;
        }(o2), e4, t3];
      }, [a2, p3, o2, r3, i3, u2, s2]), S2 = b3[0], C2 = b3[1], x3 = b3[2];
      t2.useMemo(function() {
        u2.filter(function(e4) {
          return !p3.find(function(t3) {
            return t3.id === e4.id;
          });
        }).forEach(function(e4) {
          e4.preFilteredRows = S2, e4.filteredRows = S2;
        });
      }, [S2, p3, u2]);
      var P2 = h2(m3);
      w2(function() {
        P2() && g3({ type: l2.resetFilters });
      }, [g3, a2 ? null : n3]), Object.assign(e3, { preFilteredRows: o2, preFilteredFlatRows: r3, preFilteredRowsById: i3, filteredRows: S2, filteredFlatRows: C2, filteredRowsById: x3, rows: S2, flatRows: C2, rowsById: x3, setFilter: y3, setAllFilters: R2 });
    }
    Pe.pluginName = "useFilters", l2.resetGlobalFilter = "resetGlobalFilter", l2.setGlobalFilter = "setGlobalFilter";
    var Ie = function(e3) {
      e3.stateReducers.push(Fe), e3.useInstance.push(Ge);
    };
    function Fe(e3, t3, n3, o2) {
      if (t3.type === l2.resetGlobalFilter)
        return r2({}, e3, { globalFilter: o2.initialState.globalFilter || void 0 });
      if (t3.type === l2.setGlobalFilter) {
        var u2 = t3.filterValue, s2 = o2.userFilterTypes, a2 = k2(o2.globalFilter, s2 || {}, xe), c3 = m2(u2, e3.globalFilter);
        if (H(a2.autoRemove, c3)) {
          e3.globalFilter;
          return i2(e3, ["globalFilter"]);
        }
        return r2({}, e3, { globalFilter: c3 });
      }
    }
    function Ge(e3) {
      var n3 = e3.data, o2 = e3.rows, r3 = e3.flatRows, i3 = e3.rowsById, u2 = e3.allColumns, s2 = e3.filterTypes, a2 = e3.globalFilter, c3 = e3.manualGlobalFilter, d3 = e3.state.globalFilter, f3 = e3.dispatch, p3 = e3.autoResetGlobalFilter, g3 = void 0 === p3 || p3, v3 = e3.disableGlobalFilter, m3 = t2.useCallback(function(e4) {
        f3({ type: l2.setGlobalFilter, filterValue: e4 });
      }, [f3]), y3 = t2.useMemo(function() {
        if (c3 || void 0 === d3)
          return [o2, r3, i3];
        var e4 = [], t3 = {}, n4 = k2(a2, s2 || {}, xe);
        if (!n4)
          return console.warn("Could not find a valid 'globalFilter' option."), o2;
        u2.forEach(function(e5) {
          var t4 = e5.disableGlobalFilter;
          e5.canFilter = I(true !== t4 && void 0, true !== v3 && void 0, true);
        });
        var l3 = u2.filter(function(e5) {
          return true === e5.canFilter;
        });
        return [function o3(r4) {
          return (r4 = n4(r4, l3.map(function(e5) {
            return e5.id;
          }), d3)).forEach(function(n5) {
            e4.push(n5), t3[n5.id] = n5, n5.subRows = n5.subRows && n5.subRows.length ? o3(n5.subRows) : n5.subRows;
          }), r4;
        }(o2), e4, t3];
      }, [c3, d3, a2, s2, u2, o2, r3, i3, v3]), R2 = y3[0], b3 = y3[1], S2 = y3[2], C2 = h2(g3);
      w2(function() {
        C2() && f3({ type: l2.resetGlobalFilter });
      }, [f3, c3 ? null : n3]), Object.assign(e3, { preGlobalFilteredRows: o2, preGlobalFilteredFlatRows: r3, preGlobalFilteredRowsById: i3, globalFilteredRows: R2, globalFilteredFlatRows: b3, globalFilteredRowsById: S2, rows: R2, flatRows: b3, rowsById: S2, setGlobalFilter: m3, disableGlobalFilter: v3 });
    }
    function Ae(e3, t3) {
      return t3.reduce(function(e4, t4) {
        return e4 + ("number" == typeof t4 ? t4 : 0);
      }, 0);
    }
    Ie.pluginName = "useGlobalFilter";
    var ke = Object.freeze({ __proto__: null, sum: Ae, min: function(e3) {
      var t3 = e3[0] || 0;
      return e3.forEach(function(e4) {
        "number" == typeof e4 && (t3 = Math.min(t3, e4));
      }), t3;
    }, max: function(e3) {
      var t3 = e3[0] || 0;
      return e3.forEach(function(e4) {
        "number" == typeof e4 && (t3 = Math.max(t3, e4));
      }), t3;
    }, minMax: function(e3) {
      var t3 = e3[0] || 0, n3 = e3[0] || 0;
      return e3.forEach(function(e4) {
        "number" == typeof e4 && (t3 = Math.min(t3, e4), n3 = Math.max(n3, e4));
      }), t3 + ".." + n3;
    }, average: function(e3) {
      return Ae(0, e3) / e3.length;
    }, median: function(e3) {
      if (!e3.length)
        return null;
      var t3 = Math.floor(e3.length / 2), n3 = [].concat(e3).sort(function(e4, t4) {
        return e4 - t4;
      });
      return e3.length % 2 != 0 ? n3[t3] : (n3[t3 - 1] + n3[t3]) / 2;
    }, unique: function(e3) {
      return Array.from(new Set(e3).values());
    }, uniqueCount: function(e3) {
      return new Set(e3).size;
    }, count: function(e3) {
      return e3.length;
    } }), He = [], Te = {};
    l2.resetGroupBy = "resetGroupBy", l2.setGroupBy = "setGroupBy", l2.toggleGroupBy = "toggleGroupBy";
    var ze = function(e3) {
      e3.getGroupByToggleProps = [We], e3.stateReducers.push(Oe), e3.visibleColumnsDeps.push(function(e4, t3) {
        var n3 = t3.instance;
        return [].concat(e4, [n3.state.groupBy]);
      }), e3.visibleColumns.push(Me), e3.useInstance.push(Ne), e3.prepareRow.push(Le);
    };
    ze.pluginName = "useGroupBy";
    var We = function(e3, t3) {
      var n3 = t3.header;
      return [e3, { onClick: n3.canGroupBy ? function(e4) {
        e4.persist(), n3.toggleGroupBy();
      } : void 0, style: { cursor: n3.canGroupBy ? "pointer" : void 0 }, title: "Toggle GroupBy" }];
    };
    function Oe(e3, t3, n3, o2) {
      if (t3.type === l2.init)
        return r2({ groupBy: [] }, e3);
      if (t3.type === l2.resetGroupBy)
        return r2({}, e3, { groupBy: o2.initialState.groupBy || [] });
      if (t3.type === l2.setGroupBy)
        return r2({}, e3, { groupBy: t3.value });
      if (t3.type === l2.toggleGroupBy) {
        var i3 = t3.columnId, u2 = t3.value, s2 = void 0 !== u2 ? u2 : !e3.groupBy.includes(i3);
        return r2({}, e3, s2 ? { groupBy: [].concat(e3.groupBy, [i3]) } : { groupBy: e3.groupBy.filter(function(e4) {
          return e4 !== i3;
        }) });
      }
    }
    function Me(e3, t3) {
      var n3 = t3.instance.state.groupBy, o2 = n3.map(function(t4) {
        return e3.find(function(e4) {
          return e4.id === t4;
        });
      }).filter(Boolean), r3 = e3.filter(function(e4) {
        return !n3.includes(e4.id);
      });
      return (e3 = [].concat(o2, r3)).forEach(function(e4) {
        e4.isGrouped = n3.includes(e4.id), e4.groupedIndex = n3.indexOf(e4.id);
      }), e3;
    }
    var je = {};
    function Ne(e3) {
      var n3 = e3.data, o2 = e3.rows, r3 = e3.flatRows, i3 = e3.rowsById, u2 = e3.allColumns, s2 = e3.flatHeaders, a2 = e3.groupByFn, c3 = void 0 === a2 ? De : a2, d3 = e3.manualGroupBy, p3 = e3.aggregations, g3 = void 0 === p3 ? je : p3, m3 = e3.plugins, y3 = e3.state.groupBy, R2 = e3.dispatch, b3 = e3.autoResetGroupBy, S2 = void 0 === b3 || b3, C2 = e3.disableGroupBy, x3 = e3.defaultCanGroupBy, P2 = e3.getHooks;
      v2(m3, ["useColumnOrder", "useFilters"], "useGroupBy");
      var B2 = h2(e3);
      u2.forEach(function(t3) {
        var n4 = t3.accessor, o3 = t3.defaultGroupBy, r4 = t3.disableGroupBy;
        t3.canGroupBy = n4 ? I(t3.canGroupBy, true !== r4 && void 0, true !== C2 && void 0, true) : I(t3.canGroupBy, o3, x3, false), t3.canGroupBy && (t3.toggleGroupBy = function() {
          return e3.toggleGroupBy(t3.id);
        }), t3.Aggregated = t3.Aggregated || t3.Cell;
      });
      var E2 = t2.useCallback(function(e4, t3) {
        R2({ type: l2.toggleGroupBy, columnId: e4, value: t3 });
      }, [R2]), F2 = t2.useCallback(function(e4) {
        R2({ type: l2.setGroupBy, value: e4 });
      }, [R2]);
      s2.forEach(function(e4) {
        e4.getGroupByToggleProps = f2(P2().getGroupByToggleProps, { instance: B2(), header: e4 });
      });
      var A3 = t2.useMemo(function() {
        if (d3 || !y3.length)
          return [o2, r3, i3, He, Te, r3, i3];
        var e4 = y3.filter(function(e5) {
          return u2.find(function(t4) {
            return t4.id === e5;
          });
        }), t3 = [], n4 = {}, l3 = [], s3 = {}, a3 = [], f3 = {}, p4 = function o3(r4, i4, d4) {
          if (void 0 === i4 && (i4 = 0), i4 === e4.length)
            return r4;
          var p5 = e4[i4], v3 = c3(r4, p5);
          return Object.entries(v3).map(function(r5, c4) {
            var v4 = r5[0], m4 = r5[1], h3 = p5 + ":" + v4, y4 = o3(m4, i4 + 1, h3 = d4 ? d4 + ">" + h3 : h3), w3 = i4 ? G(m4, "leafRows") : m4, R3 = function(t4, n5, o4) {
              var r6 = {};
              return u2.forEach(function(i5) {
                if (e4.includes(i5.id))
                  r6[i5.id] = n5[0] ? n5[0].values[i5.id] : null;
                else {
                  var u3 = "function" == typeof i5.aggregate ? i5.aggregate : g3[i5.aggregate] || ke[i5.aggregate];
                  if (u3) {
                    var l4 = n5.map(function(e5) {
                      return e5.values[i5.id];
                    }), s4 = t4.map(function(e5) {
                      var t5 = e5.values[i5.id];
                      if (!o4 && i5.aggregateValue) {
                        var n6 = "function" == typeof i5.aggregateValue ? i5.aggregateValue : g3[i5.aggregateValue] || ke[i5.aggregateValue];
                        if (!n6)
                          throw console.info({ column: i5 }), new Error("React Table: Invalid column.aggregateValue option for column listed above");
                        t5 = n6(t5, e5, i5);
                      }
                      return t5;
                    });
                    r6[i5.id] = u3(s4, l4);
                  } else {
                    if (i5.aggregate)
                      throw console.info({ column: i5 }), new Error("React Table: Invalid column.aggregate option for column listed above");
                    r6[i5.id] = null;
                  }
                }
              }), r6;
            }(w3, m4, i4), b4 = { id: h3, isGrouped: true, groupByID: p5, groupByVal: v4, values: R3, subRows: y4, leafRows: w3, depth: i4, index: c4 };
            return y4.forEach(function(e5) {
              t3.push(e5), n4[e5.id] = e5, e5.isGrouped ? (l3.push(e5), s3[e5.id] = e5) : (a3.push(e5), f3[e5.id] = e5);
            }), b4;
          });
        }(o2);
        return p4.forEach(function(e5) {
          t3.push(e5), n4[e5.id] = e5, e5.isGrouped ? (l3.push(e5), s3[e5.id] = e5) : (a3.push(e5), f3[e5.id] = e5);
        }), [p4, t3, n4, l3, s3, a3, f3];
      }, [d3, y3, o2, r3, i3, u2, g3, c3]), k3 = A3[0], H2 = A3[1], T2 = A3[2], z3 = A3[3], W2 = A3[4], O2 = A3[5], M2 = A3[6], j2 = h2(S2);
      w2(function() {
        j2() && R2({ type: l2.resetGroupBy });
      }, [R2, d3 ? null : n3]), Object.assign(e3, { preGroupedRows: o2, preGroupedFlatRow: r3, preGroupedRowsById: i3, groupedRows: k3, groupedFlatRows: H2, groupedRowsById: T2, onlyGroupedFlatRows: z3, onlyGroupedRowsById: W2, nonGroupedFlatRows: O2, nonGroupedRowsById: M2, rows: k3, flatRows: H2, rowsById: T2, toggleGroupBy: E2, setGroupBy: F2 });
    }
    function Le(e3) {
      e3.allCells.forEach(function(t3) {
        var n3;
        t3.isGrouped = t3.column.isGrouped && t3.column.id === e3.groupByID, t3.isPlaceholder = !t3.isGrouped && t3.column.isGrouped, t3.isAggregated = !t3.isGrouped && !t3.isPlaceholder && (null == (n3 = e3.subRows) ? void 0 : n3.length);
      });
    }
    function De(e3, t3) {
      return e3.reduce(function(e4, n3, o2) {
        var r3 = "" + n3.values[t3];
        return e4[r3] = Array.isArray(e4[r3]) ? e4[r3] : [], e4[r3].push(n3), e4;
      }, {});
    }
    var Ve = /([0-9]+)/gm;
    function _e(e3, t3) {
      return e3 === t3 ? 0 : e3 > t3 ? 1 : -1;
    }
    function Xe(e3, t3, n3) {
      return [e3.values[n3], t3.values[n3]];
    }
    function qe(e3) {
      return "number" == typeof e3 ? isNaN(e3) || e3 === 1 / 0 || e3 === -1 / 0 ? "" : String(e3) : "string" == typeof e3 ? e3 : "";
    }
    var Ke = Object.freeze({ __proto__: null, alphanumeric: function(e3, t3, n3) {
      var o2 = Xe(e3, t3, n3), r3 = o2[0], i3 = o2[1];
      for (r3 = qe(r3), i3 = qe(i3), r3 = r3.split(Ve).filter(Boolean), i3 = i3.split(Ve).filter(Boolean); r3.length && i3.length; ) {
        var u2 = r3.shift(), l3 = i3.shift(), s2 = parseInt(u2, 10), a2 = parseInt(l3, 10), c3 = [s2, a2].sort();
        if (isNaN(c3[0])) {
          if (u2 > l3)
            return 1;
          if (l3 > u2)
            return -1;
        } else {
          if (isNaN(c3[1]))
            return isNaN(s2) ? -1 : 1;
          if (s2 > a2)
            return 1;
          if (a2 > s2)
            return -1;
        }
      }
      return r3.length - i3.length;
    }, datetime: function(e3, t3, n3) {
      var o2 = Xe(e3, t3, n3), r3 = o2[0], i3 = o2[1];
      return _e(r3 = r3.getTime(), i3 = i3.getTime());
    }, basic: function(e3, t3, n3) {
      var o2 = Xe(e3, t3, n3);
      return _e(o2[0], o2[1]);
    }, string: function(e3, t3, n3) {
      var o2 = Xe(e3, t3, n3), r3 = o2[0], i3 = o2[1];
      for (r3 = r3.split("").filter(Boolean), i3 = i3.split("").filter(Boolean); r3.length && i3.length; ) {
        var u2 = r3.shift(), l3 = i3.shift(), s2 = u2.toLowerCase(), a2 = l3.toLowerCase();
        if (s2 > a2)
          return 1;
        if (a2 > s2)
          return -1;
        if (u2 > l3)
          return 1;
        if (l3 > u2)
          return -1;
      }
      return r3.length - i3.length;
    }, number: function(e3, t3, n3) {
      var o2 = Xe(e3, t3, n3), r3 = o2[0], i3 = o2[1], u2 = /[^0-9.]/gi;
      return _e(r3 = Number(String(r3).replace(u2, "")), i3 = Number(String(i3).replace(u2, "")));
    } });
    l2.resetSortBy = "resetSortBy", l2.setSortBy = "setSortBy", l2.toggleSortBy = "toggleSortBy", l2.clearSortBy = "clearSortBy", c2.sortType = "alphanumeric", c2.sortDescFirst = false;
    var Ue = function(e3) {
      e3.getSortByToggleProps = [$e], e3.stateReducers.push(Je), e3.useInstance.push(Ye);
    };
    Ue.pluginName = "useSortBy";
    var $e = function(e3, t3) {
      var n3 = t3.instance, o2 = t3.column, r3 = n3.isMultiSortEvent, i3 = void 0 === r3 ? function(e4) {
        return e4.shiftKey;
      } : r3;
      return [e3, { onClick: o2.canSort ? function(e4) {
        e4.persist(), o2.toggleSortBy(void 0, !n3.disableMultiSort && i3(e4));
      } : void 0, style: { cursor: o2.canSort ? "pointer" : void 0 }, title: o2.canSort ? "Toggle SortBy" : void 0 }];
    };
    function Je(e3, t3, n3, o2) {
      if (t3.type === l2.init)
        return r2({ sortBy: [] }, e3);
      if (t3.type === l2.resetSortBy)
        return r2({}, e3, { sortBy: o2.initialState.sortBy || [] });
      if (t3.type === l2.clearSortBy)
        return r2({}, e3, { sortBy: e3.sortBy.filter(function(e4) {
          return e4.id !== t3.columnId;
        }) });
      if (t3.type === l2.setSortBy)
        return r2({}, e3, { sortBy: t3.sortBy });
      if (t3.type === l2.toggleSortBy) {
        var i3, u2 = t3.columnId, s2 = t3.desc, a2 = t3.multi, c3 = o2.allColumns, d3 = o2.disableMultiSort, f3 = o2.disableSortRemove, p3 = o2.disableMultiRemove, g3 = o2.maxMultiSortColCount, v3 = void 0 === g3 ? Number.MAX_SAFE_INTEGER : g3, m3 = e3.sortBy, h3 = c3.find(function(e4) {
          return e4.id === u2;
        }).sortDescFirst, y3 = m3.find(function(e4) {
          return e4.id === u2;
        }), w3 = m3.findIndex(function(e4) {
          return e4.id === u2;
        }), R2 = null != s2, b3 = [];
        return "toggle" !== (i3 = !d3 && a2 ? y3 ? "toggle" : "add" : w3 !== m3.length - 1 || 1 !== m3.length ? "replace" : y3 ? "toggle" : "replace") || f3 || R2 || a2 && p3 || !(y3 && y3.desc && !h3 || !y3.desc && h3) || (i3 = "remove"), "replace" === i3 ? b3 = [{ id: u2, desc: R2 ? s2 : h3 }] : "add" === i3 ? (b3 = [].concat(m3, [{ id: u2, desc: R2 ? s2 : h3 }])).splice(0, b3.length - v3) : "toggle" === i3 ? b3 = m3.map(function(e4) {
          return e4.id === u2 ? r2({}, e4, { desc: R2 ? s2 : !y3.desc }) : e4;
        }) : "remove" === i3 && (b3 = m3.filter(function(e4) {
          return e4.id !== u2;
        })), r2({}, e3, { sortBy: b3 });
      }
    }
    function Ye(e3) {
      var n3 = e3.data, o2 = e3.rows, r3 = e3.flatRows, i3 = e3.allColumns, u2 = e3.orderByFn, s2 = void 0 === u2 ? Qe : u2, a2 = e3.sortTypes, c3 = e3.manualSortBy, d3 = e3.defaultCanSort, p3 = e3.disableSortBy, g3 = e3.flatHeaders, m3 = e3.state.sortBy, y3 = e3.dispatch, R2 = e3.plugins, b3 = e3.getHooks, S2 = e3.autoResetSortBy, C2 = void 0 === S2 || S2;
      v2(R2, ["useFilters", "useGlobalFilter", "useGroupBy", "usePivotColumns"], "useSortBy");
      var x3 = t2.useCallback(function(e4) {
        y3({ type: l2.setSortBy, sortBy: e4 });
      }, [y3]), P2 = t2.useCallback(function(e4, t3, n4) {
        y3({ type: l2.toggleSortBy, columnId: e4, desc: t3, multi: n4 });
      }, [y3]), B2 = h2(e3);
      g3.forEach(function(e4) {
        var t3 = e4.accessor, n4 = e4.canSort, o3 = e4.disableSortBy, r4 = e4.id, i4 = t3 ? I(true !== o3 && void 0, true !== p3 && void 0, true) : I(d3, n4, false);
        e4.canSort = i4, e4.canSort && (e4.toggleSortBy = function(t4, n5) {
          return P2(e4.id, t4, n5);
        }, e4.clearSortBy = function() {
          y3({ type: l2.clearSortBy, columnId: e4.id });
        }), e4.getSortByToggleProps = f2(b3().getSortByToggleProps, { instance: B2(), column: e4 });
        var u3 = m3.find(function(e5) {
          return e5.id === r4;
        });
        e4.isSorted = !!u3, e4.sortedIndex = m3.findIndex(function(e5) {
          return e5.id === r4;
        }), e4.isSortedDesc = e4.isSorted ? u3.desc : void 0;
      });
      var E2 = t2.useMemo(function() {
        if (c3 || !m3.length)
          return [o2, r3];
        var e4 = [], t3 = m3.filter(function(e5) {
          return i3.find(function(t4) {
            return t4.id === e5.id;
          });
        });
        return [function n4(o3) {
          var r4 = s2(o3, t3.map(function(e5) {
            var t4 = i3.find(function(t5) {
              return t5.id === e5.id;
            });
            if (!t4)
              throw new Error("React-Table: Could not find a column with id: " + e5.id + " while sorting");
            var n5 = t4.sortType, o4 = F(n5) || (a2 || {})[n5] || Ke[n5];
            if (!o4)
              throw new Error("React-Table: Could not find a valid sortType of '" + n5 + "' for column '" + e5.id + "'.");
            return function(t5, n6) {
              return o4(t5, n6, e5.id, e5.desc);
            };
          }), t3.map(function(e5) {
            var t4 = i3.find(function(t5) {
              return t5.id === e5.id;
            });
            return t4 && t4.sortInverted ? e5.desc : !e5.desc;
          }));
          return r4.forEach(function(t4) {
            e4.push(t4), t4.subRows && 0 !== t4.subRows.length && (t4.subRows = n4(t4.subRows));
          }), r4;
        }(o2), e4];
      }, [c3, m3, o2, r3, i3, s2, a2]), G2 = E2[0], A3 = E2[1], k3 = h2(C2);
      w2(function() {
        k3() && y3({ type: l2.resetSortBy });
      }, [c3 ? null : n3]), Object.assign(e3, { preSortedRows: o2, preSortedFlatRows: r3, sortedRows: G2, sortedFlatRows: A3, rows: G2, flatRows: A3, setSortBy: x3, toggleSortBy: P2 });
    }
    function Qe(e3, t3, n3) {
      return [].concat(e3).sort(function(e4, o2) {
        for (var r3 = 0; r3 < t3.length; r3 += 1) {
          var i3 = t3[r3], u2 = false === n3[r3] || "desc" === n3[r3], l3 = i3(e4, o2);
          if (0 !== l3)
            return u2 ? -l3 : l3;
        }
        return n3[0] ? e4.index - o2.index : o2.index - e4.index;
      });
    }
    l2.resetPage = "resetPage", l2.gotoPage = "gotoPage", l2.setPageSize = "setPageSize";
    var Ze = function(e3) {
      e3.stateReducers.push(et), e3.useInstance.push(tt);
    };
    function et(e3, t3, n3, o2) {
      if (t3.type === l2.init)
        return r2({ pageSize: 10, pageIndex: 0 }, e3);
      if (t3.type === l2.resetPage)
        return r2({}, e3, { pageIndex: o2.initialState.pageIndex || 0 });
      if (t3.type === l2.gotoPage) {
        var i3 = o2.pageCount, u2 = o2.page, s2 = m2(t3.pageIndex, e3.pageIndex), a2 = false;
        return s2 > e3.pageIndex ? a2 = -1 === i3 ? u2.length >= e3.pageSize : s2 < i3 : s2 < e3.pageIndex && (a2 = s2 > -1), a2 ? r2({}, e3, { pageIndex: s2 }) : e3;
      }
      if (t3.type === l2.setPageSize) {
        var c3 = t3.pageSize, d3 = e3.pageSize * e3.pageIndex;
        return r2({}, e3, { pageIndex: Math.floor(d3 / c3), pageSize: c3 });
      }
    }
    function tt(e3) {
      var n3 = e3.rows, o2 = e3.autoResetPage, r3 = void 0 === o2 || o2, i3 = e3.manualExpandedKey, u2 = void 0 === i3 ? "expanded" : i3, s2 = e3.plugins, a2 = e3.pageCount, c3 = e3.paginateExpandedRows, d3 = void 0 === c3 || c3, f3 = e3.expandSubRows, p3 = void 0 === f3 || f3, g3 = e3.state, m3 = g3.pageSize, y3 = g3.pageIndex, R2 = g3.expanded, b3 = g3.globalFilter, S2 = g3.filters, C2 = g3.groupBy, x3 = g3.sortBy, P2 = e3.dispatch, B2 = e3.data, E2 = e3.manualPagination;
      v2(s2, ["useGlobalFilter", "useFilters", "useGroupBy", "useSortBy", "useExpanded"], "usePagination");
      var I2 = h2(r3);
      w2(function() {
        I2() && P2({ type: l2.resetPage });
      }, [P2, E2 ? null : B2, b3, S2, C2, x3]);
      var F2 = E2 ? a2 : Math.ceil(n3.length / m3), G2 = t2.useMemo(function() {
        return F2 > 0 ? [].concat(new Array(F2)).fill(null).map(function(e4, t3) {
          return t3;
        }) : [];
      }, [F2]), k3 = t2.useMemo(function() {
        var e4;
        if (E2)
          e4 = n3;
        else {
          var t3 = m3 * y3, o3 = t3 + m3;
          e4 = n3.slice(t3, o3);
        }
        return d3 ? e4 : A2(e4, { manualExpandedKey: u2, expanded: R2, expandSubRows: p3 });
      }, [p3, R2, u2, E2, y3, m3, d3, n3]), H2 = y3 > 0, T2 = -1 === F2 ? k3.length >= m3 : y3 < F2 - 1, z3 = t2.useCallback(function(e4) {
        P2({ type: l2.gotoPage, pageIndex: e4 });
      }, [P2]), W2 = t2.useCallback(function() {
        return z3(function(e4) {
          return e4 - 1;
        });
      }, [z3]), O2 = t2.useCallback(function() {
        return z3(function(e4) {
          return e4 + 1;
        });
      }, [z3]), M2 = t2.useCallback(function(e4) {
        P2({ type: l2.setPageSize, pageSize: e4 });
      }, [P2]);
      Object.assign(e3, { pageOptions: G2, pageCount: F2, page: k3, canPreviousPage: H2, canNextPage: T2, gotoPage: z3, previousPage: W2, nextPage: O2, setPageSize: M2 });
    }
    Ze.pluginName = "usePagination", l2.resetPivot = "resetPivot", l2.togglePivot = "togglePivot";
    var nt = function(e3) {
      e3.getPivotToggleProps = [rt], e3.stateReducers.push(it), e3.useInstanceAfterData.push(ut), e3.allColumns.push(lt), e3.accessValue.push(st), e3.materializedColumns.push(at), e3.materializedColumnsDeps.push(ct), e3.visibleColumns.push(dt), e3.visibleColumnsDeps.push(ft), e3.useInstance.push(pt), e3.prepareRow.push(gt);
    };
    nt.pluginName = "usePivotColumns";
    var ot = [], rt = function(e3, t3) {
      var n3 = t3.header;
      return [e3, { onClick: n3.canPivot ? function(e4) {
        e4.persist(), n3.togglePivot();
      } : void 0, style: { cursor: n3.canPivot ? "pointer" : void 0 }, title: "Toggle Pivot" }];
    };
    function it(e3, t3, n3, o2) {
      if (t3.type === l2.init)
        return r2({ pivotColumns: ot }, e3);
      if (t3.type === l2.resetPivot)
        return r2({}, e3, { pivotColumns: o2.initialState.pivotColumns || ot });
      if (t3.type === l2.togglePivot) {
        var i3 = t3.columnId, u2 = t3.value, s2 = void 0 !== u2 ? u2 : !e3.pivotColumns.includes(i3);
        return r2({}, e3, s2 ? { pivotColumns: [].concat(e3.pivotColumns, [i3]) } : { pivotColumns: e3.pivotColumns.filter(function(e4) {
          return e4 !== i3;
        }) });
      }
    }
    function ut(e3) {
      e3.allColumns.forEach(function(t3) {
        t3.isPivotSource = e3.state.pivotColumns.includes(t3.id);
      });
    }
    function lt(e3, t3) {
      var n3 = t3.instance;
      return e3.forEach(function(e4) {
        e4.isPivotSource = n3.state.pivotColumns.includes(e4.id), e4.uniqueValues = /* @__PURE__ */ new Set();
      }), e3;
    }
    function st(e3, t3) {
      var n3 = t3.column;
      return n3.uniqueValues && void 0 !== e3 && n3.uniqueValues.add(e3), e3;
    }
    function at(e3, t3) {
      var n3 = t3.instance, o2 = n3.allColumns, i3 = n3.state;
      if (!i3.pivotColumns.length || !i3.groupBy || !i3.groupBy.length)
        return e3;
      var u2 = i3.pivotColumns.map(function(e4) {
        return o2.find(function(t4) {
          return t4.id === e4;
        });
      }).filter(Boolean), l3 = o2.filter(function(e4) {
        return !e4.isPivotSource && !i3.groupBy.includes(e4.id) && !i3.pivotColumns.includes(e4.id);
      }), s2 = C(function e4(t4, n4, o3) {
        void 0 === t4 && (t4 = 0), void 0 === o3 && (o3 = []);
        var i4 = u2[t4];
        return i4 ? Array.from(i4.uniqueValues).sort().map(function(u3) {
          var l4 = r2({}, i4, { Header: i4.PivotHeader || "string" == typeof i4.header ? i4.Header + ": " + u3 : u3, isPivotGroup: true, parent: n4, depth: t4, id: n4 ? n4.id + "." + i4.id + "." + u3 : i4.id + "." + u3, pivotValue: u3 });
          return l4.columns = e4(t4 + 1, l4, [].concat(o3, [function(e5) {
            return e5.values[i4.id] === u3;
          }])), l4;
        }) : l3.map(function(e5) {
          return r2({}, e5, { canPivot: false, isPivoted: true, parent: n4, depth: t4, id: "" + (n4 ? n4.id + "." + e5.id : e5.id), accessor: function(t5, n5, r3) {
            if (o3.every(function(e6) {
              return e6(r3);
            }))
              return r3.values[e5.id];
          } });
        });
      }());
      return [].concat(e3, s2);
    }
    function ct(e3, t3) {
      var n3 = t3.instance.state, o2 = n3.pivotColumns, r3 = n3.groupBy;
      return [].concat(e3, [o2, r3]);
    }
    function dt(e3, t3) {
      var n3 = t3.instance.state;
      return e3 = e3.filter(function(e4) {
        return !e4.isPivotSource;
      }), n3.pivotColumns.length && n3.groupBy && n3.groupBy.length && (e3 = e3.filter(function(e4) {
        return e4.isGrouped || e4.isPivoted;
      })), e3;
    }
    function ft(e3, t3) {
      var n3 = t3.instance;
      return [].concat(e3, [n3.state.pivotColumns, n3.state.groupBy]);
    }
    function pt(e3) {
      var t3 = e3.columns, n3 = e3.allColumns, o2 = e3.flatHeaders, r3 = e3.getHooks, i3 = e3.plugins, u2 = e3.dispatch, s2 = e3.autoResetPivot, a2 = void 0 === s2 || s2, c3 = e3.manaulPivot, d3 = e3.disablePivot, p3 = e3.defaultCanPivot;
      v2(i3, ["useGroupBy"], "usePivotColumns");
      var g3 = h2(e3);
      n3.forEach(function(t4) {
        var n4 = t4.accessor, o3 = t4.defaultPivot, r4 = t4.disablePivot;
        t4.canPivot = n4 ? I(t4.canPivot, true !== r4 && void 0, true !== d3 && void 0, true) : I(t4.canPivot, o3, p3, false), t4.canPivot && (t4.togglePivot = function() {
          return e3.togglePivot(t4.id);
        }), t4.Aggregated = t4.Aggregated || t4.Cell;
      });
      o2.forEach(function(e4) {
        e4.getPivotToggleProps = f2(r3().getPivotToggleProps, { instance: g3(), header: e4 });
      });
      var m3 = h2(a2);
      w2(function() {
        m3() && u2({ type: l2.resetPivot });
      }, [u2, c3 ? null : t3]), Object.assign(e3, { togglePivot: function(e4, t4) {
        u2({ type: l2.togglePivot, columnId: e4, value: t4 });
      } });
    }
    function gt(e3) {
      e3.allCells.forEach(function(e4) {
        e4.isPivoted = e4.column.isPivoted;
      });
    }
    l2.resetSelectedRows = "resetSelectedRows", l2.toggleAllRowsSelected = "toggleAllRowsSelected", l2.toggleRowSelected = "toggleRowSelected", l2.toggleAllPageRowsSelected = "toggleAllPageRowsSelected";
    var vt = function(e3) {
      e3.getToggleRowSelectedProps = [mt], e3.getToggleAllRowsSelectedProps = [ht], e3.getToggleAllPageRowsSelectedProps = [yt], e3.stateReducers.push(wt), e3.useInstance.push(Rt), e3.prepareRow.push(bt);
    };
    vt.pluginName = "useRowSelect";
    var mt = function(e3, t3) {
      var n3 = t3.instance, o2 = t3.row, r3 = n3.manualRowSelectedKey, i3 = void 0 === r3 ? "isSelected" : r3;
      return [e3, { onChange: function(e4) {
        o2.toggleRowSelected(e4.target.checked);
      }, style: { cursor: "pointer" }, checked: !(!o2.original || !o2.original[i3]) || o2.isSelected, title: "Toggle Row Selected", indeterminate: o2.isSomeSelected }];
    }, ht = function(e3, t3) {
      var n3 = t3.instance;
      return [e3, { onChange: function(e4) {
        n3.toggleAllRowsSelected(e4.target.checked);
      }, style: { cursor: "pointer" }, checked: n3.isAllRowsSelected, title: "Toggle All Rows Selected", indeterminate: Boolean(!n3.isAllRowsSelected && Object.keys(n3.state.selectedRowIds).length) }];
    }, yt = function(e3, t3) {
      var n3 = t3.instance;
      return [e3, { onChange: function(e4) {
        n3.toggleAllPageRowsSelected(e4.target.checked);
      }, style: { cursor: "pointer" }, checked: n3.isAllPageRowsSelected, title: "Toggle All Current Page Rows Selected", indeterminate: Boolean(!n3.isAllPageRowsSelected && n3.page.some(function(e4) {
        var t4 = e4.id;
        return n3.state.selectedRowIds[t4];
      })) }];
    };
    function wt(e3, t3, n3, o2) {
      if (t3.type === l2.init)
        return r2({ selectedRowIds: {} }, e3);
      if (t3.type === l2.resetSelectedRows)
        return r2({}, e3, { selectedRowIds: o2.initialState.selectedRowIds || {} });
      if (t3.type === l2.toggleAllRowsSelected) {
        var i3 = t3.value, u2 = o2.isAllRowsSelected, s2 = o2.rowsById, a2 = o2.nonGroupedRowsById, c3 = void 0 === a2 ? s2 : a2, d3 = void 0 !== i3 ? i3 : !u2, f3 = Object.assign({}, e3.selectedRowIds);
        return d3 ? Object.keys(c3).forEach(function(e4) {
          f3[e4] = true;
        }) : Object.keys(c3).forEach(function(e4) {
          delete f3[e4];
        }), r2({}, e3, { selectedRowIds: f3 });
      }
      if (t3.type === l2.toggleRowSelected) {
        var p3 = t3.id, g3 = t3.value, v3 = o2.rowsById, m3 = o2.selectSubRows, h3 = void 0 === m3 || m3, y3 = o2.getSubRows, w3 = e3.selectedRowIds[p3], R2 = void 0 !== g3 ? g3 : !w3;
        if (w3 === R2)
          return e3;
        var b3 = r2({}, e3.selectedRowIds);
        return function e4(t4) {
          var n4 = v3[t4];
          if (n4.isGrouped || (R2 ? b3[t4] = true : delete b3[t4]), h3 && y3(n4))
            return y3(n4).forEach(function(t5) {
              return e4(t5.id);
            });
        }(p3), r2({}, e3, { selectedRowIds: b3 });
      }
      if (t3.type === l2.toggleAllPageRowsSelected) {
        var S2 = t3.value, C2 = o2.page, x3 = o2.rowsById, P2 = o2.selectSubRows, B2 = void 0 === P2 || P2, E2 = o2.isAllPageRowsSelected, I2 = o2.getSubRows, F2 = void 0 !== S2 ? S2 : !E2, G2 = r2({}, e3.selectedRowIds);
        return C2.forEach(function(e4) {
          return function e5(t4) {
            var n4 = x3[t4];
            if (n4.isGrouped || (F2 ? G2[t4] = true : delete G2[t4]), B2 && I2(n4))
              return I2(n4).forEach(function(t5) {
                return e5(t5.id);
              });
          }(e4.id);
        }), r2({}, e3, { selectedRowIds: G2 });
      }
      return e3;
    }
    function Rt(e3) {
      var n3 = e3.data, o2 = e3.rows, r3 = e3.getHooks, i3 = e3.plugins, u2 = e3.rowsById, s2 = e3.nonGroupedRowsById, a2 = void 0 === s2 ? u2 : s2, c3 = e3.autoResetSelectedRows, d3 = void 0 === c3 || c3, p3 = e3.state.selectedRowIds, g3 = e3.selectSubRows, m3 = void 0 === g3 || g3, y3 = e3.dispatch, R2 = e3.page, b3 = e3.getSubRows;
      v2(i3, ["useFilters", "useGroupBy", "useSortBy", "useExpanded", "usePagination"], "useRowSelect");
      var S2 = t2.useMemo(function() {
        var e4 = [];
        return o2.forEach(function(t3) {
          var n4 = m3 ? function e5(t4, n5, o3) {
            if (n5[t4.id])
              return true;
            var r4 = o3(t4);
            if (r4 && r4.length) {
              var i4 = true, u3 = false;
              return r4.forEach(function(t5) {
                u3 && !i4 || (e5(t5, n5, o3) ? u3 = true : i4 = false);
              }), !!i4 || !!u3 && null;
            }
            return false;
          }(t3, p3, b3) : !!p3[t3.id];
          t3.isSelected = !!n4, t3.isSomeSelected = null === n4, n4 && e4.push(t3);
        }), e4;
      }, [o2, m3, p3, b3]), C2 = Boolean(Object.keys(a2).length && Object.keys(p3).length), x3 = C2;
      C2 && Object.keys(a2).some(function(e4) {
        return !p3[e4];
      }) && (C2 = false), C2 || R2 && R2.length && R2.some(function(e4) {
        var t3 = e4.id;
        return !p3[t3];
      }) && (x3 = false);
      var P2 = h2(d3);
      w2(function() {
        P2() && y3({ type: l2.resetSelectedRows });
      }, [y3, n3]);
      var B2 = t2.useCallback(function(e4) {
        return y3({ type: l2.toggleAllRowsSelected, value: e4 });
      }, [y3]), E2 = t2.useCallback(function(e4) {
        return y3({ type: l2.toggleAllPageRowsSelected, value: e4 });
      }, [y3]), I2 = t2.useCallback(function(e4, t3) {
        return y3({ type: l2.toggleRowSelected, id: e4, value: t3 });
      }, [y3]), F2 = h2(e3), G2 = f2(r3().getToggleAllRowsSelectedProps, { instance: F2() }), A3 = f2(r3().getToggleAllPageRowsSelectedProps, { instance: F2() });
      Object.assign(e3, { selectedFlatRows: S2, isAllRowsSelected: C2, isAllPageRowsSelected: x3, toggleRowSelected: I2, toggleAllRowsSelected: B2, getToggleAllRowsSelectedProps: G2, getToggleAllPageRowsSelectedProps: A3, toggleAllPageRowsSelected: E2 });
    }
    function bt(e3, t3) {
      var n3 = t3.instance;
      e3.toggleRowSelected = function(t4) {
        return n3.toggleRowSelected(e3.id, t4);
      }, e3.getToggleRowSelectedProps = f2(n3.getHooks().getToggleRowSelectedProps, { instance: n3, row: e3 });
    }
    var St = function(e3) {
      return {};
    }, Ct = function(e3) {
      return {};
    };
    l2.setRowState = "setRowState", l2.setCellState = "setCellState", l2.resetRowState = "resetRowState";
    var xt = function(e3) {
      e3.stateReducers.push(Pt), e3.useInstance.push(Bt), e3.prepareRow.push(Et);
    };
    function Pt(e3, t3, n3, o2) {
      var i3 = o2.initialRowStateAccessor, u2 = void 0 === i3 ? St : i3, s2 = o2.initialCellStateAccessor, a2 = void 0 === s2 ? Ct : s2, c3 = o2.rowsById;
      if (t3.type === l2.init)
        return r2({ rowState: {} }, e3);
      if (t3.type === l2.resetRowState)
        return r2({}, e3, { rowState: o2.initialState.rowState || {} });
      if (t3.type === l2.setRowState) {
        var d3, f3 = t3.rowId, p3 = t3.value, g3 = void 0 !== e3.rowState[f3] ? e3.rowState[f3] : u2(c3[f3]);
        return r2({}, e3, { rowState: r2({}, e3.rowState, (d3 = {}, d3[f3] = m2(p3, g3), d3)) });
      }
      if (t3.type === l2.setCellState) {
        var v3, h3, y3, w3, R2, b3 = t3.rowId, S2 = t3.columnId, C2 = t3.value, x3 = void 0 !== e3.rowState[b3] ? e3.rowState[b3] : u2(c3[b3]), P2 = void 0 !== (null == x3 ? void 0 : null == (v3 = x3.cellState) ? void 0 : v3[S2]) ? x3.cellState[S2] : a2(null == (h3 = c3[b3]) ? void 0 : null == (y3 = h3.cells) ? void 0 : y3.find(function(e4) {
          return e4.column.id === S2;
        }));
        return r2({}, e3, { rowState: r2({}, e3.rowState, (R2 = {}, R2[b3] = r2({}, x3, { cellState: r2({}, x3.cellState || {}, (w3 = {}, w3[S2] = m2(C2, P2), w3)) }), R2)) });
      }
    }
    function Bt(e3) {
      var n3 = e3.autoResetRowState, o2 = void 0 === n3 || n3, r3 = e3.data, i3 = e3.dispatch, u2 = t2.useCallback(function(e4, t3) {
        return i3({ type: l2.setRowState, rowId: e4, value: t3 });
      }, [i3]), s2 = t2.useCallback(function(e4, t3, n4) {
        return i3({ type: l2.setCellState, rowId: e4, columnId: t3, value: n4 });
      }, [i3]), a2 = h2(o2);
      w2(function() {
        a2() && i3({ type: l2.resetRowState });
      }, [r3]), Object.assign(e3, { setRowState: u2, setCellState: s2 });
    }
    function Et(e3, t3) {
      var n3 = t3.instance, o2 = n3.initialRowStateAccessor, r3 = void 0 === o2 ? St : o2, i3 = n3.initialCellStateAccessor, u2 = void 0 === i3 ? Ct : i3, l3 = n3.state.rowState;
      e3 && (e3.state = void 0 !== l3[e3.id] ? l3[e3.id] : r3(e3), e3.setState = function(t4) {
        return n3.setRowState(e3.id, t4);
      }, e3.cells.forEach(function(t4) {
        e3.state.cellState || (e3.state.cellState = {}), t4.state = void 0 !== e3.state.cellState[t4.column.id] ? e3.state.cellState[t4.column.id] : u2(t4), t4.setState = function(o3) {
          return n3.setCellState(e3.id, t4.column.id, o3);
        };
      }));
    }
    xt.pluginName = "useRowState", l2.resetColumnOrder = "resetColumnOrder", l2.setColumnOrder = "setColumnOrder";
    var It = function(e3) {
      e3.stateReducers.push(Ft), e3.visibleColumnsDeps.push(function(e4, t3) {
        var n3 = t3.instance;
        return [].concat(e4, [n3.state.columnOrder]);
      }), e3.visibleColumns.push(Gt), e3.useInstance.push(At);
    };
    function Ft(e3, t3, n3, o2) {
      return t3.type === l2.init ? r2({ columnOrder: [] }, e3) : t3.type === l2.resetColumnOrder ? r2({}, e3, { columnOrder: o2.initialState.columnOrder || [] }) : t3.type === l2.setColumnOrder ? r2({}, e3, { columnOrder: m2(t3.columnOrder, e3.columnOrder) }) : void 0;
    }
    function Gt(e3, t3) {
      var n3 = t3.instance.state.columnOrder;
      if (!n3 || !n3.length)
        return e3;
      for (var o2 = [].concat(n3), r3 = [].concat(e3), i3 = [], u2 = function() {
        var e4 = o2.shift(), t4 = r3.findIndex(function(t5) {
          return t5.id === e4;
        });
        t4 > -1 && i3.push(r3.splice(t4, 1)[0]);
      }; r3.length && o2.length; )
        u2();
      return [].concat(i3, r3);
    }
    function At(e3) {
      var n3 = e3.dispatch;
      e3.setColumnOrder = t2.useCallback(function(e4) {
        return n3({ type: l2.setColumnOrder, columnOrder: e4 });
      }, [n3]);
    }
    It.pluginName = "useColumnOrder", c2.canResize = true, l2.columnStartResizing = "columnStartResizing", l2.columnResizing = "columnResizing", l2.columnDoneResizing = "columnDoneResizing", l2.resetResize = "resetResize";
    var kt = function(e3) {
      e3.getResizerProps = [Ht], e3.getHeaderProps.push({ style: { position: "relative" } }), e3.stateReducers.push(Tt), e3.useInstance.push(Wt), e3.useInstanceBeforeDimensions.push(zt);
    }, Ht = function(e3, t3) {
      var n3 = t3.instance, o2 = t3.header, r3 = n3.dispatch, i3 = function(e4, t4) {
        var n4 = false;
        if ("touchstart" === e4.type) {
          if (e4.touches && e4.touches.length > 1)
            return;
          n4 = true;
        }
        var o3 = function(e5) {
          var t5 = [];
          return function e6(n5) {
            n5.columns && n5.columns.length && n5.columns.map(e6);
            t5.push(n5);
          }(e5), t5;
        }(t4).map(function(e5) {
          return [e5.id, e5.totalWidth];
        }), i4 = n4 ? Math.round(e4.touches[0].clientX) : e4.clientX, u2 = function(e5) {
          r3({ type: l2.columnResizing, clientX: e5 });
        }, s2 = function() {
          return r3({ type: l2.columnDoneResizing });
        }, a2 = { mouse: { moveEvent: "mousemove", moveHandler: function(e5) {
          return u2(e5.clientX);
        }, upEvent: "mouseup", upHandler: function(e5) {
          document.removeEventListener("mousemove", a2.mouse.moveHandler), document.removeEventListener("mouseup", a2.mouse.upHandler), s2();
        } }, touch: { moveEvent: "touchmove", moveHandler: function(e5) {
          return e5.cancelable && (e5.preventDefault(), e5.stopPropagation()), u2(e5.touches[0].clientX), false;
        }, upEvent: "touchend", upHandler: function(e5) {
          document.removeEventListener(a2.touch.moveEvent, a2.touch.moveHandler), document.removeEventListener(a2.touch.upEvent, a2.touch.moveHandler), s2();
        } } }, c3 = n4 ? a2.touch : a2.mouse, d3 = !!function() {
          if ("boolean" == typeof z2)
            return z2;
          var e5 = false;
          try {
            var t5 = { get passive() {
              return e5 = true, false;
            } };
            window.addEventListener("test", null, t5), window.removeEventListener("test", null, t5);
          } catch (t6) {
            e5 = false;
          }
          return z2 = e5;
        }() && { passive: false };
        document.addEventListener(c3.moveEvent, c3.moveHandler, d3), document.addEventListener(c3.upEvent, c3.upHandler, d3), r3({ type: l2.columnStartResizing, columnId: t4.id, columnWidth: t4.totalWidth, headerIdWidths: o3, clientX: i4 });
      };
      return [e3, { onMouseDown: function(e4) {
        return e4.persist() || i3(e4, o2);
      }, onTouchStart: function(e4) {
        return e4.persist() || i3(e4, o2);
      }, style: { cursor: "col-resize" }, draggable: false, role: "separator" }];
    };
    function Tt(e3, t3) {
      if (t3.type === l2.init)
        return r2({ columnResizing: { columnWidths: {} } }, e3);
      if (t3.type === l2.resetResize)
        return r2({}, e3, { columnResizing: { columnWidths: {} } });
      if (t3.type === l2.columnStartResizing) {
        var n3 = t3.clientX, o2 = t3.columnId, i3 = t3.columnWidth, u2 = t3.headerIdWidths;
        return r2({}, e3, { columnResizing: r2({}, e3.columnResizing, { startX: n3, headerIdWidths: u2, columnWidth: i3, isResizingColumn: o2 }) });
      }
      if (t3.type === l2.columnResizing) {
        var s2 = t3.clientX, a2 = e3.columnResizing, c3 = a2.startX, d3 = a2.columnWidth, f3 = a2.headerIdWidths, p3 = (s2 - c3) / d3, g3 = {};
        return (void 0 === f3 ? [] : f3).forEach(function(e4) {
          var t4 = e4[0], n4 = e4[1];
          g3[t4] = Math.max(n4 + n4 * p3, 0);
        }), r2({}, e3, { columnResizing: r2({}, e3.columnResizing, { columnWidths: r2({}, e3.columnResizing.columnWidths, {}, g3) }) });
      }
      return t3.type === l2.columnDoneResizing ? r2({}, e3, { columnResizing: r2({}, e3.columnResizing, { startX: null, isResizingColumn: null }) }) : void 0;
    }
    kt.pluginName = "useResizeColumns";
    var zt = function(e3) {
      var t3 = e3.flatHeaders, n3 = e3.disableResizing, o2 = e3.getHooks, r3 = e3.state.columnResizing, i3 = h2(e3);
      t3.forEach(function(e4) {
        var t4 = I(true !== e4.disableResizing && void 0, true !== n3 && void 0, true);
        e4.canResize = t4, e4.width = r3.columnWidths[e4.id] || e4.originalWidth || e4.width, e4.isResizing = r3.isResizingColumn === e4.id, t4 && (e4.getResizerProps = f2(o2().getResizerProps, { instance: i3(), header: e4 }));
      });
    };
    function Wt(e3) {
      var n3 = e3.plugins, o2 = e3.dispatch, r3 = e3.autoResetResize, i3 = void 0 === r3 || r3, u2 = e3.columns;
      v2(n3, ["useAbsoluteLayout"], "useResizeColumns");
      var s2 = h2(i3);
      w2(function() {
        s2() && o2({ type: l2.resetResize });
      }, [u2]);
      var a2 = t2.useCallback(function() {
        return o2({ type: l2.resetResize });
      }, [o2]);
      Object.assign(e3, { resetResizing: a2 });
    }
    var Ot = { position: "absolute", top: 0 }, Mt = function(e3) {
      e3.getTableBodyProps.push(jt), e3.getRowProps.push(jt), e3.getHeaderGroupProps.push(jt), e3.getFooterGroupProps.push(jt), e3.getHeaderProps.push(function(e4, t3) {
        var n3 = t3.column;
        return [e4, { style: r2({}, Ot, { left: n3.totalLeft + "px", width: n3.totalWidth + "px" }) }];
      }), e3.getCellProps.push(function(e4, t3) {
        var n3 = t3.cell;
        return [e4, { style: r2({}, Ot, { left: n3.column.totalLeft + "px", width: n3.column.totalWidth + "px" }) }];
      }), e3.getFooterProps.push(function(e4, t3) {
        var n3 = t3.column;
        return [e4, { style: r2({}, Ot, { left: n3.totalLeft + "px", width: n3.totalWidth + "px" }) }];
      });
    };
    Mt.pluginName = "useAbsoluteLayout";
    var jt = function(e3, t3) {
      return [e3, { style: { position: "relative", width: t3.instance.totalColumnsWidth + "px" } }];
    }, Nt = { display: "inline-block", boxSizing: "border-box" }, Lt = function(e3, t3) {
      return [e3, { style: { display: "flex", width: t3.instance.totalColumnsWidth + "px" } }];
    }, Dt = function(e3) {
      e3.getRowProps.push(Lt), e3.getHeaderGroupProps.push(Lt), e3.getFooterGroupProps.push(Lt), e3.getHeaderProps.push(function(e4, t3) {
        var n3 = t3.column;
        return [e4, { style: r2({}, Nt, { width: n3.totalWidth + "px" }) }];
      }), e3.getCellProps.push(function(e4, t3) {
        var n3 = t3.cell;
        return [e4, { style: r2({}, Nt, { width: n3.column.totalWidth + "px" }) }];
      }), e3.getFooterProps.push(function(e4, t3) {
        var n3 = t3.column;
        return [e4, { style: r2({}, Nt, { width: n3.totalWidth + "px" }) }];
      });
    };
    function Vt(e3) {
      e3.getTableProps.push(_t), e3.getRowProps.push(Xt), e3.getHeaderGroupProps.push(Xt), e3.getFooterGroupProps.push(Xt), e3.getHeaderProps.push(qt), e3.getCellProps.push(Kt), e3.getFooterProps.push(Ut);
    }
    Dt.pluginName = "useBlockLayout", Vt.pluginName = "useFlexLayout";
    var _t = function(e3, t3) {
      return [e3, { style: { minWidth: t3.instance.totalColumnsMinWidth + "px" } }];
    }, Xt = function(e3, t3) {
      return [e3, { style: { display: "flex", flex: "1 0 auto", minWidth: t3.instance.totalColumnsMinWidth + "px" } }];
    }, qt = function(e3, t3) {
      var n3 = t3.column;
      return [e3, { style: { boxSizing: "border-box", flex: n3.totalFlexWidth ? n3.totalFlexWidth + " 0 auto" : void 0, minWidth: n3.totalMinWidth + "px", width: n3.totalWidth + "px" } }];
    }, Kt = function(e3, t3) {
      var n3 = t3.cell;
      return [e3, { style: { boxSizing: "border-box", flex: n3.column.totalFlexWidth + " 0 auto", minWidth: n3.column.totalMinWidth + "px", width: n3.column.totalWidth + "px" } }];
    }, Ut = function(e3, t3) {
      var n3 = t3.column;
      return [e3, { style: { boxSizing: "border-box", flex: n3.totalFlexWidth ? n3.totalFlexWidth + " 0 auto" : void 0, minWidth: n3.totalMinWidth + "px", width: n3.totalWidth + "px" } }];
    };
    function $t(e3) {
      e3.stateReducers.push(Qt), e3.getTableProps.push(Jt), e3.getHeaderProps.push(Yt);
    }
    $t.pluginName = "useGridLayout";
    var Jt = function(e3, t3) {
      return [e3, { style: { display: "grid", gridTemplateColumns: t3.instance.state.gridLayout.columnWidths.map(function(e4) {
        return e4;
      }).join(" ") } }];
    }, Yt = function(e3, t3) {
      return [e3, { id: "header-cell-" + t3.column.id, style: { position: "sticky" } }];
    };
    function Qt(e3, t3, n3, o2) {
      if ("init" === t3.type)
        return r2({ gridLayout: { columnWidths: o2.columns.map(function() {
          return "auto";
        }) } }, e3);
      if ("columnStartResizing" === t3.type) {
        var i3 = t3.columnId, u2 = o2.visibleColumns.findIndex(function(e4) {
          return e4.id === i3;
        }), l3 = function(e4) {
          var t4, n4 = null == (t4 = document.getElementById("header-cell-" + e4)) ? void 0 : t4.offsetWidth;
          if (void 0 !== n4)
            return n4;
        }(i3);
        return void 0 !== l3 ? r2({}, e3, { gridLayout: r2({}, e3.gridLayout, { columnId: i3, columnIndex: u2, startingWidth: l3 }) }) : e3;
      }
      if ("columnResizing" === t3.type) {
        var s2 = e3.gridLayout, a2 = s2.columnIndex, c3 = s2.startingWidth, d3 = s2.columnWidths, f3 = c3 - (e3.columnResizing.startX - t3.clientX), p3 = [].concat(d3);
        return p3[a2] = f3 + "px", r2({}, e3, { gridLayout: r2({}, e3.gridLayout, { columnWidths: p3 }) });
      }
    }
    e2._UNSTABLE_usePivotColumns = nt, e2.actions = l2, e2.defaultColumn = c2, e2.defaultGroupByFn = De, e2.defaultOrderByFn = Qe, e2.defaultRenderer = s, e2.emptyRenderer = a, e2.ensurePluginOrder = v2, e2.flexRender = b2, e2.functionalUpdate = m2, e2.loopHooks = g2, e2.makePropGetter = f2, e2.makeRenderer = R, e2.reduceHooks = p2, e2.safeUseLayoutEffect = y2, e2.useAbsoluteLayout = Mt, e2.useAsyncDebounce = function(e3, n3) {
      void 0 === n3 && (n3 = 0);
      var r3 = t2.useRef({}), i3 = h2(e3), u2 = h2(n3);
      return t2.useCallback(function() {
        var e4 = o(regeneratorRuntime.mark(function e5() {
          var t3, n4, l3, s2 = arguments;
          return regeneratorRuntime.wrap(function(e6) {
            for (; ; )
              switch (e6.prev = e6.next) {
                case 0:
                  for (t3 = s2.length, n4 = new Array(t3), l3 = 0; l3 < t3; l3++)
                    n4[l3] = s2[l3];
                  return r3.current.promise || (r3.current.promise = new Promise(function(e7, t4) {
                    r3.current.resolve = e7, r3.current.reject = t4;
                  })), r3.current.timeout && clearTimeout(r3.current.timeout), r3.current.timeout = setTimeout(o(regeneratorRuntime.mark(function e7() {
                    return regeneratorRuntime.wrap(function(e8) {
                      for (; ; )
                        switch (e8.prev = e8.next) {
                          case 0:
                            return delete r3.current.timeout, e8.prev = 1, e8.t0 = r3.current, e8.next = 5, i3().apply(void 0, n4);
                          case 5:
                            e8.t1 = e8.sent, e8.t0.resolve.call(e8.t0, e8.t1), e8.next = 12;
                            break;
                          case 9:
                            e8.prev = 9, e8.t2 = e8.catch(1), r3.current.reject(e8.t2);
                          case 12:
                            return e8.prev = 12, delete r3.current.promise, e8.finish(12);
                          case 15:
                          case "end":
                            return e8.stop();
                        }
                    }, e7, null, [[1, 9, 12, 15]]);
                  })), u2()), e6.abrupt("return", r3.current.promise);
                case 5:
                case "end":
                  return e6.stop();
              }
          }, e5);
        }));
        return function() {
          return e4.apply(this, arguments);
        };
      }(), [i3, u2]);
    }, e2.useBlockLayout = Dt, e2.useColumnOrder = It, e2.useExpanded = se, e2.useFilters = Pe, e2.useFlexLayout = Vt, e2.useGetLatest = h2, e2.useGlobalFilter = Ie, e2.useGridLayout = $t, e2.useGroupBy = ze, e2.useMountedLayoutEffect = w2, e2.usePagination = Ze, e2.useResizeColumns = kt, e2.useRowSelect = vt, e2.useRowState = xt, e2.useSortBy = Ue, e2.useTable = function(e3) {
      for (var n3 = arguments.length, o2 = new Array(n3 > 1 ? n3 - 1 : 0), i3 = 1; i3 < n3; i3++)
        o2[i3 - 1] = arguments[i3];
      e3 = ie(e3), o2 = [K].concat(o2);
      var u2 = t2.useRef({}), s2 = h2(u2.current);
      Object.assign(s2(), r2({}, e3, { plugins: o2, hooks: q2() })), o2.filter(Boolean).forEach(function(e4) {
        e4(s2().hooks);
      });
      var a2 = h2(s2().hooks);
      s2().getHooks = a2, delete s2().hooks, Object.assign(s2(), p2(a2().useOptions, ie(e3)));
      var c3 = s2(), d3 = c3.data, v3 = c3.columns, m3 = c3.initialState, y3 = c3.defaultColumn, w3 = c3.getSubRows, b3 = c3.getRowId, E2 = c3.stateReducer, I2 = c3.useControlledState, F2 = h2(E2), G2 = t2.useCallback(function(e4, t3) {
        if (!t3.type)
          throw console.info({ action: t3 }), new Error("Unknown Action \u{1F446}");
        return [].concat(a2().stateReducers, Array.isArray(F2()) ? F2() : [F2()]).reduce(function(n4, o3) {
          return o3(n4, t3, e4, s2()) || n4;
        }, e4);
      }, [a2, F2, s2]), A3 = t2.useReducer(G2, void 0, function() {
        return G2(m3, { type: l2.init });
      }), k3 = A3[0], H2 = A3[1], T2 = p2([].concat(a2().useControlledState, [I2]), k3, { instance: s2() });
      Object.assign(s2(), { state: T2, dispatch: H2 });
      var z3 = t2.useMemo(function() {
        return S(p2(a2().columns, v3, { instance: s2() }));
      }, [a2, s2, v3].concat(p2(a2().columnsDeps, [], { instance: s2() })));
      s2().columns = z3;
      var W2 = t2.useMemo(function() {
        return p2(a2().allColumns, C(z3), { instance: s2() }).map(x2);
      }, [z3, a2, s2].concat(p2(a2().allColumnsDeps, [], { instance: s2() })));
      s2().allColumns = W2;
      var O2 = t2.useMemo(function() {
        for (var e4 = [], t3 = [], n4 = {}, o3 = [].concat(W2); o3.length; ) {
          var r3 = o3.shift();
          le({ data: d3, rows: e4, flatRows: t3, rowsById: n4, column: r3, getRowId: b3, getSubRows: w3, accessValueHooks: a2().accessValue, getInstance: s2 });
        }
        return [e4, t3, n4];
      }, [W2, d3, b3, w3, a2, s2]), M2 = O2[0], j2 = O2[1], N2 = O2[2];
      Object.assign(s2(), { rows: M2, initialRows: [].concat(M2), flatRows: j2, rowsById: N2 }), g2(a2().useInstanceAfterData, s2());
      var L2 = t2.useMemo(function() {
        return p2(a2().visibleColumns, W2, { instance: s2() }).map(function(e4) {
          return P(e4, y3);
        });
      }, [a2, W2, s2, y3].concat(p2(a2().visibleColumnsDeps, [], { instance: s2() })));
      W2 = t2.useMemo(function() {
        var e4 = [].concat(L2);
        return W2.forEach(function(t3) {
          e4.find(function(e5) {
            return e5.id === t3.id;
          }) || e4.push(t3);
        }), e4;
      }, [W2, L2]), s2().allColumns = W2;
      var D2 = t2.useMemo(function() {
        return p2(a2().headerGroups, B(L2, y3), s2());
      }, [a2, L2, y3, s2].concat(p2(a2().headerGroupsDeps, [], { instance: s2() })));
      s2().headerGroups = D2;
      var V2 = t2.useMemo(function() {
        return D2.length ? D2[0].headers : [];
      }, [D2]);
      s2().headers = V2, s2().flatHeaders = D2.reduce(function(e4, t3) {
        return [].concat(e4, t3.headers);
      }, []), g2(a2().useInstanceBeforeDimensions, s2());
      var _2 = L2.filter(function(e4) {
        return e4.isVisible;
      }).map(function(e4) {
        return e4.id;
      }).sort().join("_");
      L2 = t2.useMemo(function() {
        return L2.filter(function(e4) {
          return e4.isVisible;
        });
      }, [L2, _2]), s2().visibleColumns = L2;
      var X2 = ue(V2), U2 = X2[0], $2 = X2[1], J2 = X2[2];
      return s2().totalColumnsMinWidth = U2, s2().totalColumnsWidth = $2, s2().totalColumnsMaxWidth = J2, g2(a2().useInstance, s2()), [].concat(s2().flatHeaders, s2().allColumns).forEach(function(e4) {
        e4.render = R(s2(), e4), e4.getHeaderProps = f2(a2().getHeaderProps, { instance: s2(), column: e4 }), e4.getFooterProps = f2(a2().getFooterProps, { instance: s2(), column: e4 });
      }), s2().headerGroups = t2.useMemo(function() {
        return D2.filter(function(e4, t3) {
          return e4.headers = e4.headers.filter(function(e5) {
            return e5.headers ? function e6(t4) {
              return t4.filter(function(t5) {
                return t5.headers ? e6(t5.headers) : t5.isVisible;
              }).length;
            }(e5.headers) : e5.isVisible;
          }), !!e4.headers.length && (e4.getHeaderGroupProps = f2(a2().getHeaderGroupProps, { instance: s2(), headerGroup: e4, index: t3 }), e4.getFooterGroupProps = f2(a2().getFooterGroupProps, { instance: s2(), headerGroup: e4, index: t3 }), true);
        });
      }, [D2, s2, a2]), s2().footerGroups = [].concat(s2().headerGroups).reverse(), s2().prepareRow = t2.useCallback(function(e4) {
        e4.getRowProps = f2(a2().getRowProps, { instance: s2(), row: e4 }), e4.allCells = W2.map(function(t3) {
          var n4 = e4.values[t3.id], o3 = { column: t3, row: e4, value: n4 };
          return o3.getCellProps = f2(a2().getCellProps, { instance: s2(), cell: o3 }), o3.render = R(s2(), t3, { row: e4, cell: o3, value: n4 }), o3;
        }), e4.cells = L2.map(function(t3) {
          return e4.allCells.find(function(e5) {
            return e5.column.id === t3.id;
          });
        }), g2(a2().prepareRow, e4, { instance: s2() });
      }, [a2, s2, W2, L2]), s2().getTableProps = f2(a2().getTableProps, { instance: s2() }), s2().getTableBodyProps = f2(a2().getTableBodyProps, { instance: s2() }), g2(a2().useFinalInstance, s2()), s2();
    }, Object.defineProperty(e2, "__esModule", { value: true });
  });
})(reactTable_production_min, reactTable_production_min.exports);
{
  reactTable.exports = reactTable_production_min.exports;
}
const setMaxHeight = (visibleRowsCount, isCompact) => {
  const compactRowHeight = 56;
  const defaultRowHeight = 72;
  const cellHeight = isCompact ? compactRowHeight : defaultRowHeight;
  return !lodash.exports.isNil(visibleRowsCount) ? {
    maxHeight: `${visibleRowsCount * cellHeight}px`
  } : {};
};
const Table = ({
  columns: appColumns,
  data,
  withSearchBar,
  maxLength,
  withColumnFilter,
  emptyTitle,
  emptySubtitle,
  filters: filters2,
  defaultFilters,
  onFiltersChange,
  searchBarPlaceholder,
  searchBarLabel,
  className,
  visibleRowsCount,
  isCompact,
  withSelectableRows,
  getChildRows,
  onSelectedRowChange,
  BulkSelectRowAside,
  initialState,
  onRowClick
}) => {
  const columns = useMemo(() => getChildRows ? [makeExpanderColumn(getChildRows), ...appColumns] : appColumns, [appColumns]);
  const plugins = [reactTable.exports.useGlobalFilter, reactTable.exports.useSortBy];
  if (getChildRows)
    plugins.push(reactTable.exports.useExpanded);
  const {
    state: {
      globalFilter,
      selectedRowIds
    },
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setGlobalFilter,
    selectedFlatRows,
    toggleAllRowsSelected,
    getToggleHideAllColumnsProps,
    allColumns
  } = reactTable.exports.useTable({
    columns,
    data,
    initialState
  }, ...plugins, reactTable.exports.useRowSelect, (hooks) => {
    if (withSelectableRows) {
      hooks.visibleColumns.push((columns2) => [{
        id: "selection",
        Header: ({
          getToggleAllRowsSelectedProps
        }) => /* @__PURE__ */ jsx$1(IndeterminateCheckbox, {
          ...getToggleAllRowsSelectedProps()
        }),
        Cell: ({
          row
        }) => /* @__PURE__ */ jsx$1(IndeterminateCheckbox, {
          ...row.getToggleRowSelectedProps()
        })
      }, ...columns2]);
    }
  });
  const [showFilters, setShowFilters] = useState(false);
  const [showAllFilters, setShowAllFilters] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState(defaultFilters || {});
  const [filterFilterQueries, setFilterFilterQueries] = useState({});
  const [columnFilterVisible, setColumnFilterVisible] = useState(false);
  const [columnFilterQuery, setColumnFilterQuery] = useState("");
  const setFilters = (newFilterState) => {
    setSelectedFilters(newFilterState);
    onFiltersChange && onFiltersChange(newFilterState);
  };
  const handleChangeSelectedFilters = (filterGroup, event) => {
    if (!selectedFilters[filterGroup])
      selectedFilters[filterGroup] = [];
    setFilters({
      ...selectedFilters,
      [filterGroup]: event.target.checked ? [...selectedFilters[filterGroup], event.target.name] : [...selectedFilters[filterGroup]].filter((item2) => item2 !== event.target.name)
    });
  };
  const handleSelectAllFilters = (filterGroup, childFilterArray) => {
    setFilters({
      ...selectedFilters,
      [filterGroup]: childFilterArray.map((item2) => item2.accessor)
    });
  };
  const handleClearSelectedFilters = (filterGroup) => {
    if (filterGroup) {
      setFilters({
        ...selectedFilters,
        [filterGroup]: []
      });
    } else {
      setFilters({});
    }
  };
  const handleUpdateFilterFilterQuery = (filterGroup, e2) => {
    setFilterFilterQueries({
      ...filterFilterQueries,
      [filterGroup]: e2.target.value
    });
  };
  const searchBarProps = {
    globalFilter,
    setGlobalFilter,
    searchBarPlaceholder,
    searchBarLabel,
    maxLength
  };
  const headerProps = {
    headerGroups,
    isCompact
  };
  const bodyProps = {
    rows,
    prepareRow,
    isCompact,
    getChildRows
  };
  const bulkSelectProps = {
    selectedRowIds,
    selectedFlatRows,
    toggleAllRowsSelected,
    clearSelectedRow: () => toggleAllRowsSelected(false)
  };
  withSelectableRows && onSelectedRowChange && onSelectedRowChange({
    selectedRowIds,
    selectedFlatRows
  });
  const filterCount2 = useMemo(() => Object.keys(selectedFilters).reduce((acc, curr) => acc + selectedFilters[curr].length, 0), [selectedFilters]);
  const handleFilterBtnClick = useCallback(() => setShowFilters(!showFilters), [showFilters]);
  if (columns.length === 0)
    return /* @__PURE__ */ jsx$1(Fragment, {});
  return /* @__PURE__ */ jsxs("div", {
    className: classnames$2(className),
    children: [(withSearchBar || (filters2 == null ? void 0 : filters2.length) || withColumnFilter) && /* @__PURE__ */ jsxs("div", {
      className: styles$4.searchFilterSection,
      children: [withSearchBar && /* @__PURE__ */ jsx$1(SearchBar, {
        ...searchBarProps
      }), (filters2 == null ? void 0 : filters2.length) > 0 && /* @__PURE__ */ jsx$1(FilterButton, {
        showFilters,
        handleFilterBtnClick,
        filterCount: filterCount2
      }), withColumnFilter && /* @__PURE__ */ jsx$1(ColumnFilterButton, {
        columns: allColumns,
        toggleAll: getToggleHideAllColumnsProps,
        columnFilterVisible,
        setColumnFilterVisible,
        columnFilterQuery,
        setColumnFilterQuery,
        withSelectableRows
      })]
    }), showFilters && (filters2 == null ? void 0 : filters2.length) > 0 && /* @__PURE__ */ jsx$1(FilterSection, {
      selectedFilters,
      handleChangeSelectedFilters,
      handleSelectAllFilters,
      handleClearSelectedFilters,
      showAllFilters,
      setShowAllFilters,
      filters: filters2,
      filterFilterQueries,
      handleUpdateFilterFilterQuery
    }), /* @__PURE__ */ jsxs("div", {
      className: `${styles$4.scrollTable}`,
      children: [withSelectableRows && (selectedFlatRows == null ? void 0 : selectedFlatRows.length) > 0 && /* @__PURE__ */ jsx$1(BulkSelectRow, {
        ...bulkSelectProps,
        children: BulkSelectRowAside && /* @__PURE__ */ jsx$1(BulkSelectRowAside, {
          ...bulkSelectProps
        })
      }), (data == null ? void 0 : data.length) === 0 ? /* @__PURE__ */ jsx$1(NoDataRow, {
        title: emptyTitle,
        subtitle: emptySubtitle
      }) : /* @__PURE__ */ jsxs(TableContainer, {
        className: classnames$2(withSelectableRows && styles$4.withCheckboxColumn, withSelectableRows && (selectedFlatRows == null ? void 0 : selectedFlatRows.length) > 0 && styles$4.bulkSelectRowActive),
        ...getTableProps(),
        children: [/* @__PURE__ */ jsx$1(TableHeader, {
          ...headerProps
        }), /* @__PURE__ */ jsx$1(Tbody, {
          ...getTableBodyProps(),
          style: setMaxHeight(visibleRowsCount, isCompact),
          children: (data == null ? void 0 : data.length) === 0 ? /* @__PURE__ */ jsx$1(NoDataRow, {}) : /* @__PURE__ */ jsx$1(NoPagination, {
            onRowClick,
            ...bodyProps,
            expanderCell: /* @__PURE__ */ jsx$1(Td, {
              className: styles$4.expander
            })
          })
        })]
      })]
    })]
  });
};
Table.propTypes = {
  className: PropTypes$1.string,
  columns: PropTypes$1.arrayOf(PropTypes$1.shape({
    Header: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.object]),
    accessor: PropTypes$1.string.isRequired,
    defaultCanSort: PropTypes$1.bool,
    disableSortBy: PropTypes$1.bool,
    sortDescFirst: PropTypes$1.bool,
    sortInverted: PropTypes$1.bool,
    sortType: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.func])
  })).isRequired,
  data: PropTypes$1.arrayOf(PropTypes$1.object).isRequired,
  withSearchBar: PropTypes$1.bool,
  maxLength: PropTypes$1.number,
  filters: PropTypes$1.arrayOf(PropTypes$1.shape({
    name: PropTypes$1.string.isRequired,
    accessor: PropTypes$1.string.isRequired,
    filters: PropTypes$1.arrayOf(PropTypes$1.shape({
      name: PropTypes$1.string.isRequired,
      accessor: PropTypes$1.string.isRequired
    }))
  })),
  defaultFilters: PropTypes$1.object,
  onFiltersChange: PropTypes$1.func,
  searchBarPlaceholder: PropTypes$1.string,
  searchBarLabel: PropTypes$1.string,
  isCompact: PropTypes$1.bool,
  visibleRowsCount: PropTypes$1.number,
  withSelectableRows: PropTypes$1.bool,
  onSelectedRowChange: PropTypes$1.func,
  BulkSelectRowAside: PropTypes$1.func,
  withColumnFilter: PropTypes$1.bool,
  getChildRows: PropTypes$1.func,
  onRowClick: PropTypes$1.func,
  emptyTitle: PropTypes$1.string,
  emptySubtitle: PropTypes$1.string
};
Table.defaultProps = {
  className: "",
  columns: [],
  data: [],
  withSearchBar: false,
  filters: [],
  onFiltersChange: null,
  searchBarPlaceholder: "Search",
  searchBarLabel: "",
  isCompact: false,
  visibleRowsCount: 10,
  withSelectableRows: false,
  withColumnFilter: false
};
function makeExpanderColumn(getChildRows) {
  return {
    Header: () => null,
    id: "expander",
    className: styles$4.expander,
    Cell: ({
      row
    }) => {
      var _a;
      if (!((_a = getChildRows({
        row
      })) == null ? void 0 : _a.length))
        return null;
      return /* @__PURE__ */ jsx$1("span", {
        ...row.getToggleRowExpandedProps(),
        children: row.isExpanded ? /* @__PURE__ */ jsx$1(Icon, {
          type: "CaretUp",
          size: "m"
        }) : /* @__PURE__ */ jsx$1(Icon, {
          type: "CaretDown",
          size: "m"
        })
      });
    }
  };
}
function PaginationTable({
  columns,
  data,
  withSearchBar,
  maxLength,
  withColumnFilter,
  searchBarPlaceholder,
  searchBarLabel,
  pageSizeOptions,
  className,
  isCompact,
  initialState,
  defaultFilters,
  filters: filters2,
  onFiltersChange,
  withSelectableRows,
  onSelectedRowChange,
  BulkSelectRowAside,
  emptyTitle,
  emptySubtitle,
  getRowId,
  autoResetSelectedRows = true,
  visibleRowsCount,
  paginationSelectDropdownMenuPlacement
}) {
  const {
    state: {
      globalFilter,
      pageIndex,
      pageSize,
      selectedRowIds
    },
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    setGlobalFilter,
    selectedFlatRows,
    toggleAllRowsSelected,
    getToggleHideAllColumnsProps,
    allColumns
  } = reactTable.exports.useTable({
    columns,
    data,
    initialState: {
      pageSize: pageSizeOptions.length > 0 ? pageSizeOptions[0] : 10,
      ...initialState
    },
    autoResetSelectedRows,
    getRowId
  }, reactTable.exports.useGlobalFilter, reactTable.exports.useSortBy, reactTable.exports.usePagination, reactTable.exports.useRowSelect, (hooks) => {
    if (withSelectableRows) {
      hooks.visibleColumns.push((columns2) => [{
        id: "selection",
        Header: ({
          getToggleAllPageRowsSelectedProps
        }) => /* @__PURE__ */ jsx$1(IndeterminateCheckbox, {
          ...getToggleAllPageRowsSelectedProps()
        }),
        Cell: ({
          row
        }) => {
          return /* @__PURE__ */ jsx$1(IndeterminateCheckbox, {
            ...row.getToggleRowSelectedProps()
          });
        }
      }, ...columns2]);
    }
  });
  if (columns.length === 0)
    return null;
  const [showFilters, setShowFilters] = useState(false);
  const [showAllFilters, setShowAllFilters] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState(defaultFilters || {});
  const [filterFilterQueries, setFilterFilterQueries] = useState({});
  const [columnFilterVisible, setColumnFilterVisible] = useState(false);
  const [columnFilterQuery, setColumnFilterQuery] = useState("");
  const setFilters = (newFilterState) => {
    setSelectedFilters(newFilterState);
    onFiltersChange(newFilterState);
  };
  const handleChangeSelectedFilters = (filterGroup, event) => {
    if (!selectedFilters[filterGroup])
      selectedFilters[filterGroup] = [];
    setFilters({
      ...selectedFilters,
      [filterGroup]: event.target.checked ? [...selectedFilters[filterGroup], event.target.name] : [...selectedFilters[filterGroup]].filter((item2) => item2 !== event.target.name)
    });
  };
  const handleSelectAllFilters = (filterGroup, childFilterArray) => {
    setFilters({
      ...selectedFilters,
      [filterGroup]: childFilterArray.map((item2) => item2.accessor)
    });
  };
  const handleClearSelectedFilters = (filterGroup) => {
    if (filterGroup) {
      setFilters({
        ...selectedFilters,
        [filterGroup]: []
      });
    } else {
      setFilters({});
    }
  };
  const handleUpdateFilterFilterQuery = (filterGroup, e2) => {
    setFilterFilterQueries({
      ...filterFilterQueries,
      [filterGroup]: e2.target.value
    });
  };
  const paginationProps = {
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageIndex,
    pageOptions,
    totalRowCount: rows.length,
    gotoPage,
    pageCount,
    pageSize,
    setPageSize,
    pageSizeOptions,
    pageNumbersOptions: [...Array(pageCount)].map((_, num) => ({
      value: num.toString(),
      label: `${num + 1}`.toString()
    })),
    selectDropdownMenuPlacement: paginationSelectDropdownMenuPlacement
  };
  const searchBarProps = {
    className: styles$4.SearchBar,
    globalFilter,
    setGlobalFilter,
    searchBarPlaceholder,
    searchBarLabel,
    ariaLabel: "GlobalTableFilter",
    maxLength
  };
  const headerProps = {
    headerGroups,
    isCompact
  };
  const bodyProps = {
    page,
    prepareRow,
    isCompact
  };
  const bulkSelectProps = {
    selectedRowIds,
    selectedFlatRows,
    toggleAllRowsSelected,
    clearSelectedRow: () => toggleAllRowsSelected(false)
  };
  useEffect(() => {
    withSelectableRows && onSelectedRowChange && onSelectedRowChange({
      selectedRowIds,
      selectedFlatRows
    });
  }, [selectedFlatRows.length]);
  const filterCount2 = useMemo(() => Object.keys(selectedFilters).reduce((acc, curr) => acc + selectedFilters[curr].length, 0), [selectedFilters]);
  const handleFilterBtnClick = useCallback(() => setShowFilters(!showFilters), [showFilters]);
  return /* @__PURE__ */ jsxs("div", {
    ...className,
    children: [/* @__PURE__ */ jsxs("div", {
      className: styles$4.searchFilterSection,
      children: [withSearchBar && /* @__PURE__ */ jsx$1(SearchBar, {
        ...searchBarProps
      }), !!filters2.length && /* @__PURE__ */ jsx$1(FilterButton, {
        showFilters,
        handleFilterBtnClick,
        filterCount: filterCount2
      }), withColumnFilter && /* @__PURE__ */ jsx$1(ColumnFilterButton, {
        columns: allColumns,
        toggleAll: getToggleHideAllColumnsProps,
        columnFilterVisible,
        setColumnFilterVisible,
        columnFilterQuery,
        setColumnFilterQuery,
        withSelectableRows
      })]
    }), showFilters ? /* @__PURE__ */ jsx$1(FilterSection, {
      selectedFilters,
      handleChangeSelectedFilters,
      handleSelectAllFilters,
      handleClearSelectedFilters,
      showAllFilters,
      setShowAllFilters,
      filters: filters2,
      filterFilterQueries,
      handleUpdateFilterFilterQuery
    }) : null, selectedFlatRows.length > 0 && /* @__PURE__ */ jsx$1(BulkSelectRow, {
      ...bulkSelectProps,
      children: BulkSelectRowAside && /* @__PURE__ */ jsx$1(BulkSelectRowAside, {
        ...bulkSelectProps
      })
    }), data.length === 0 ? /* @__PURE__ */ jsx$1(NoDataRow, {
      title: emptyTitle,
      subtitle: emptySubtitle
    }) : /* @__PURE__ */ jsx$1(TableContainer, {
      className: classnames$2({
        [styles$4.scrollTable]: !lodash.exports.isNil(visibleRowsCount) && visibleRowsCount > 0,
        [styles$4.withCheckboxColumn]: withSelectableRows,
        [styles$4.bulkSelectRowActive]: withSelectableRows && selectedFlatRows.length > 0
      }),
      ...getTableProps(),
      children: /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx$1(TableHeader, {
          ...headerProps
        }), /* @__PURE__ */ jsx$1(Tbody, {
          ...getTableBodyProps(),
          style: setMaxHeight(visibleRowsCount, isCompact),
          children: /* @__PURE__ */ jsx$1(Pagination, {
            ...bodyProps
          })
        })]
      })
    }), data.length !== 0 && /* @__PURE__ */ jsx$1(PaginationControls, {
      ...paginationProps
    })]
  });
}
PaginationTable.propTypes = {
  className: PropTypes$1.string,
  columns: PropTypes$1.arrayOf(PropTypes$1.shape({
    Header: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.object]),
    accessor: PropTypes$1.string.isRequired,
    defaultCanSort: PropTypes$1.bool,
    disableSortBy: PropTypes$1.bool,
    sortDescFirst: PropTypes$1.bool,
    sortInverted: PropTypes$1.bool,
    sortType: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.func])
  })).isRequired,
  data: PropTypes$1.arrayOf(PropTypes$1.object).isRequired,
  withSearchBar: PropTypes$1.bool,
  maxLength: PropTypes$1.number,
  searchBarPlaceholder: PropTypes$1.string,
  searchBarLabel: PropTypes$1.string,
  isCompact: PropTypes$1.bool,
  initialState: PropTypes$1.object,
  defaultFilters: PropTypes$1.object,
  pageSizeOptions: PropTypes$1.arrayOf(PropTypes$1.number),
  withSelectableRows: PropTypes$1.bool,
  onSelectedRowChange: PropTypes$1.func,
  BulkSelectRowAside: PropTypes$1.func,
  filters: PropTypes$1.arrayOf(PropTypes$1.shape({
    name: PropTypes$1.string.isRequired,
    accessor: PropTypes$1.string.isRequired,
    filters: PropTypes$1.arrayOf(PropTypes$1.shape({
      name: PropTypes$1.string.isRequired,
      accessor: PropTypes$1.string.isRequired
    }))
  })),
  onFiltersChange: PropTypes$1.func,
  withColumnFilter: PropTypes$1.bool,
  emptyTitle: PropTypes$1.string,
  emptySubtitle: PropTypes$1.string,
  visibleRowsCount: PropTypes$1.number,
  paginationSelectDropdownMenuPlacement: PropTypes$1.string
};
PaginationTable.defaultProps = {
  className: "",
  columns: [],
  data: [],
  withSearchBar: false,
  searchBarPlaceholder: "Search",
  searchBarLabel: "",
  isCompact: false,
  initialState: {},
  filters: [],
  onFiltersChange: null,
  pageSizeOptions: [10, 20, 25],
  withSelectableRows: false,
  withColumnFilter: false
};
const PaginationControlledTable = forwardRef(({
  className,
  columns,
  data,
  withSearchBar,
  withColumnFilter,
  searchBarPlaceholder,
  searchBarLabel,
  maxLength,
  onTableChange,
  loading,
  pageCount: controlledPageCount,
  pageSizeOptions,
  isCompact,
  initialState,
  defaultFilters,
  filters: filters2,
  onFiltersChange,
  totalRowCount,
  withSelectableRows,
  onSelectedRowChange,
  BulkSelectRowAside,
  emptyTitle,
  emptySubtitle,
  getRowId,
  autoResetSelectedRows = true,
  autoResetPage = false,
  visibleRowsCount,
  onControlledFilterQueryChange,
  paginationSelectDropdownMenuPlacement,
  ...props
}, ref) => {
  const {
    state: {
      globalFilter,
      pageIndex,
      pageSize,
      sortBy,
      selectedRowIds
    },
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setGlobalFilter,
    selectedFlatRows,
    toggleAllPageRowsSelected,
    getToggleHideAllColumnsProps,
    allColumns,
    dispatch
  } = reactTable.exports.useTable({
    columns,
    data,
    initialState: {
      pageSize: pageSizeOptions.length > 0 ? pageSizeOptions[0] : 10,
      ...initialState
    },
    pageCount: controlledPageCount,
    manualPagination: true,
    manualGlobalFilter: true,
    manualSortBy: true,
    autoResetPage,
    autoResetSortBy: false,
    autoResetSelectedRows,
    getRowId
  }, reactTable.exports.useGlobalFilter, reactTable.exports.useSortBy, reactTable.exports.usePagination, reactTable.exports.useRowSelect, (hooks) => {
    if (withSelectableRows) {
      hooks.visibleColumns.push((columns2) => [{
        id: "selection",
        Header: ({
          getToggleAllPageRowsSelectedProps
        }) => /* @__PURE__ */ jsx$1(IndeterminateCheckbox, {
          ...getToggleAllPageRowsSelectedProps()
        }),
        Cell: ({
          row
        }) => /* @__PURE__ */ jsx$1(IndeterminateCheckbox, {
          ...row.getToggleRowSelectedProps()
        })
      }, ...columns2]);
    }
  });
  useEffect(() => {
    onTableChange == null ? void 0 : onTableChange({
      pageIndex,
      pageSize,
      globalFilter,
      sortBy
    });
  }, [onTableChange, pageIndex, pageSize, globalFilter, sortBy]);
  useImperativeHandle(ref, () => ({
    resetAllSelectedRows: () => dispatch({
      type: reactTable.exports.actions.resetSelectedRows
    }),
    resetPageIndex: () => dispatch({
      type: reactTable.exports.actions.gotoPage,
      pageIndex: 0
    })
  }));
  const [showFilters, setShowFilters] = useState(false);
  const [showAllFilters, setShowAllFilters] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState(defaultFilters || {});
  const [filterFilterQueries, setFilterFilterQueries] = useState({});
  const [columnFilterVisible, setColumnFilterVisible] = useState(false);
  const [columnFilterQuery, setColumnFilterQuery] = useState("");
  useEffect(() => {
    onFiltersChange == null ? void 0 : onFiltersChange(selectedFilters);
  }, [onFiltersChange, selectedFilters]);
  const setFilters = (newFilterState) => {
    setSelectedFilters(newFilterState);
  };
  const handleChangeSelectedFilters = (filterGroup, event) => {
    if (!selectedFilters[filterGroup])
      selectedFilters[filterGroup] = [];
    setFilters({
      ...selectedFilters,
      [filterGroup]: event.target.checked ? [...selectedFilters[filterGroup], event.target.name] : [...selectedFilters[filterGroup]].filter((item2) => item2 !== event.target.name)
    });
  };
  const handleSelectAllFilters = (filterGroup, childFilterArray) => {
    setFilters({
      ...selectedFilters,
      [filterGroup]: childFilterArray.map((item2) => item2.accessor)
    });
  };
  const handleClearSelectedFilters = (filterGroup) => {
    if (filterGroup) {
      setFilters({
        ...selectedFilters,
        [filterGroup]: []
      });
    } else {
      setFilters({});
    }
  };
  const handleUpdateFilterFilterQuery = (filterGroup, e2) => {
    setFilterFilterQueries({
      ...filterFilterQueries,
      [filterGroup]: e2.target.value
    });
    onControlledFilterQueryChange == null ? void 0 : onControlledFilterQueryChange({
      [filterGroup]: e2.target.value
    });
  };
  const searchBarProps = {
    globalFilter,
    setGlobalFilter,
    searchBarPlaceholder,
    searchBarLabel,
    maxLength
  };
  const paginationProps = {
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageIndex,
    pageOptions,
    totalRowCount,
    gotoPage,
    pageCount,
    pageSize,
    setPageSize,
    pageSizeOptions,
    pageNumbersOptions: [...Array(pageCount)].map((_, num) => ({
      value: num.toString(),
      label: `${num + 1}`.toString()
    })),
    selectDropdownMenuPlacement: paginationSelectDropdownMenuPlacement,
    ...props
  };
  const headerProps = {
    headerGroups,
    controledPagination: true,
    isCompact
  };
  const bodyProps = {
    page,
    prepareRow,
    isCompact
  };
  const clearSelectedRows = () => toggleAllPageRowsSelected(false);
  const bulkSelectProps = {
    selectedRowIds,
    selectedFlatRows,
    toggleAllRowsSelected: toggleAllPageRowsSelected,
    clearSelectedRow: clearSelectedRows
  };
  useEffect(() => {
    withSelectableRows && onSelectedRowChange && onSelectedRowChange({
      selectedRowIds,
      selectedFlatRows,
      clearSelectedRows
    });
  }, [selectedFlatRows.length]);
  const filterCount2 = useMemo(() => Object.keys(selectedFilters).reduce((acc, curr) => acc + selectedFilters[curr].length, 0), [selectedFilters]);
  const handleFilterBtnClick = useCallback(() => setShowFilters(!showFilters), [showFilters]);
  return /* @__PURE__ */ jsxs("div", {
    ...className,
    children: [/* @__PURE__ */ jsxs("div", {
      className: styles$4.searchFilterSection,
      children: [withSearchBar && /* @__PURE__ */ jsx$1(SearchBar, {
        ...searchBarProps
      }), !!filters2.length && /* @__PURE__ */ jsx$1(FilterButton, {
        showFilters,
        handleFilterBtnClick,
        filterCount: filterCount2
      }), withColumnFilter && /* @__PURE__ */ jsx$1(ColumnFilterButton, {
        columns: allColumns,
        toggleAll: getToggleHideAllColumnsProps,
        columnFilterVisible,
        setColumnFilterVisible,
        columnFilterQuery,
        setColumnFilterQuery,
        withSelectableRows
      })]
    }), showFilters ? /* @__PURE__ */ jsx$1(FilterSection, {
      selectedFilters,
      handleChangeSelectedFilters,
      handleSelectAllFilters,
      handleClearSelectedFilters,
      showAllFilters,
      setShowAllFilters,
      filters: filters2,
      filterFilterQueries,
      handleUpdateFilterFilterQuery
    }) : null, selectedFlatRows.length > 0 && /* @__PURE__ */ jsx$1(BulkSelectRow, {
      ...bulkSelectProps,
      children: BulkSelectRowAside && /* @__PURE__ */ jsx$1(BulkSelectRowAside, {
        ...bulkSelectProps
      })
    }), !loading && data.length === 0 ? /* @__PURE__ */ jsx$1(NoDataRow, {
      title: emptyTitle,
      subtitle: emptySubtitle
    }) : /* @__PURE__ */ jsx$1(TableContainer, {
      className: classnames$2({
        [styles$4.scrollTable]: !lodash.exports.isNil(visibleRowsCount) && visibleRowsCount > 0,
        [styles$4.withCheckboxColumn]: withSelectableRows,
        [styles$4.bulkSelectRowActive]: withSelectableRows && selectedFlatRows.length > 0
      }),
      ...getTableProps(),
      children: /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx$1(TableHeader, {
          ...headerProps
        }), /* @__PURE__ */ jsx$1(Tbody, {
          ...getTableBodyProps(),
          style: setMaxHeight(visibleRowsCount, isCompact),
          children: loading ? /* @__PURE__ */ jsx$1(LoadingRow, {
            isCompact: true
          }) : /* @__PURE__ */ jsx$1(Pagination, {
            ...bodyProps
          })
        })]
      })
    }), data.length !== 0 && /* @__PURE__ */ jsx$1(PaginationControls, {
      ...paginationProps
    })]
  });
});
PaginationControlledTable.propTypes = {
  className: PropTypes$1.string,
  columns: PropTypes$1.arrayOf(PropTypes$1.shape({
    Header: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.object]),
    accessor: PropTypes$1.string.isRequired,
    defaultCanSort: PropTypes$1.bool,
    disableSortBy: PropTypes$1.bool,
    sortDescFirst: PropTypes$1.bool,
    sortInverted: PropTypes$1.bool,
    sortType: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.func])
  })).isRequired,
  data: PropTypes$1.arrayOf(PropTypes$1.object).isRequired,
  withSearchBar: PropTypes$1.bool,
  maxLength: PropTypes$1.number,
  searchBarPlaceholder: PropTypes$1.string,
  searchBarLabel: PropTypes$1.string,
  isCompact: PropTypes$1.bool,
  initialState: PropTypes$1.object,
  defaultFilters: PropTypes$1.object,
  pageSizeOptions: PropTypes$1.arrayOf(PropTypes$1.number),
  loading: PropTypes$1.bool.isRequired,
  onTableChange: PropTypes$1.func,
  totalRowCount: PropTypes$1.number,
  withSelectableRows: PropTypes$1.bool,
  onSelectedRowChange: PropTypes$1.func,
  BulkSelectRowAside: PropTypes$1.func,
  filters: PropTypes$1.arrayOf(PropTypes$1.shape({
    name: PropTypes$1.string.isRequired,
    accessor: PropTypes$1.string.isRequired,
    filters: PropTypes$1.arrayOf(PropTypes$1.shape({
      name: PropTypes$1.string.isRequired,
      accessor: PropTypes$1.string.isRequired
    }))
  })),
  onFiltersChange: PropTypes$1.func,
  withColumnFilter: PropTypes$1.bool,
  emptyTitle: PropTypes$1.string,
  emptySubtitle: PropTypes$1.string,
  getRowId: PropTypes$1.func,
  autoResetSelectedRows: PropTypes$1.bool,
  autoResetPage: PropTypes$1.bool,
  visibleRowsCount: PropTypes$1.number,
  onControlledFilterQueryChange: PropTypes$1.func,
  paginationSelectDropdownMenuPlacement: PropTypes$1.string
};
PaginationControlledTable.defaultProps = {
  className: "",
  columns: [],
  data: [],
  withSearchBar: false,
  searchBarPlaceholder: "Search",
  searchBarLabel: "",
  isCompact: false,
  initialState: {},
  filters: [],
  onFiltersChange: null,
  totalRowCount: 0,
  pageSizeOptions: [10, 20, 25],
  loading: true,
  withSelectableRows: false,
  withColumnFilter: false
};
const accountDataToDropdownOptions = (accounts) => accounts == null ? void 0 : accounts.map((account) => ({
  value: account.accountId,
  label: `${account.name}-${account.accountType.toLowerCase()} (${account.accountId})`
}));
const responseDataToAccountList = (response) => {
  const {
    data: {
      user: { accountsWithAccess }
    }
  } = response;
  return accountsWithAccess;
};
const urls$1 = {
  prod: "https://ajsv6bjh0a.execute-api.us-west-2.amazonaws.com/v1/prod"
};
const headers$4 = (accessToken) => {
  return { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` };
};
const waffleIronApi = {
  listByUser: async (username, accessToken, env = "prod") => {
    const params = new URLSearchParams({
      username
    });
    try {
      const url = `${urls$1[env]}?` + params;
      const response = await fetch(url, {
        method: "GET",
        headers: headers$4(accessToken)
      });
      if (!(response == null ? void 0 : response.ok))
        Promise.reject(response);
      const data = await response.json();
      const accountsWithAccess = responseDataToAccountList(data);
      return accountsWithAccess;
    } catch (error) {
      console.log("[API]", error);
      throw new Error(error);
    }
  }
};
function useFetchWaffleIronAccounts(username, accessToken, env, service = waffleIronApi.listByUser) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await service(username, accessToken, env);
      setData(response);
    } catch (error2) {
      console.log("[HOOK]", error2);
      setError(error2);
    } finally {
      setLoading(false);
    }
  }, [username, accessToken, env, service]);
  useEffect(() => {
    fetchData(username, accessToken, env);
  }, [fetchData]);
  return {
    data,
    loading,
    error,
    fetchData
  };
}
function SelectWaffleIron({
  username,
  accessToken,
  env,
  ...props
}) {
  var _a, _b;
  const [waffleAccountOptions, setWaffleAccountOptions] = useState([]);
  const {
    data,
    loading,
    error
  } = useFetchWaffleIronAccounts(username, accessToken, env);
  useEffect(() => {
    let mounted = true;
    const selectOptions = accountDataToDropdownOptions(data);
    if (mounted) {
      setWaffleAccountOptions(selectOptions);
    }
    return () => {
      mounted = false;
    };
  }, [data]);
  return /* @__PURE__ */ jsx$1(Select, {
    ...props,
    label: (_a = props == null ? void 0 : props.label) != null ? _a : "Waffle Iron Account ID",
    placeholder: (_b = props == null ? void 0 : props.placeholder) != null ? _b : "463456716078",
    maxChars: 12,
    options: waffleAccountOptions,
    noOptionsMessage: () => {
      if (loading)
        return "Loading...";
      if (error)
        return "Error fetching waffle iron accounts";
      return "Please provide a valid AWS Waffle Iron Account ID";
    }
  });
}
SelectWaffleIron.propTypes = {
  username: PropTypes$1.string.isRequired,
  accessToken: PropTypes$1.string.isRequired,
  env: PropTypes$1.string.isRequired
};
const icon$3 = "epic__icon__163";
const ripple$3 = "epic__ripple__ce9";
const errorMsg$2 = "epic__errorMsg__bd2";
const msg$2 = "epic__msg__519";
var styles$3 = {
  icon: icon$3,
  "epic-icon": "epic__epic-icon__461",
  "epic-icon-add": "epic__epic-icon-add__1ec",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__0fe",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__74b",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__fd5",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__1df",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__026",
  "epic-icon-calendar": "epic__epic-icon-calendar__6df",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__e73",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__28a",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__f9a",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__59c",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__f59",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__cfd",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__eb3",
  "epic-icon-close-x": "epic__epic-icon-close-x__a0d",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__407",
  "epic-icon-confluence": "epic__epic-icon-confluence__a83",
  "epic-icon-contact": "epic__epic-icon-contact__6f8",
  "epic-icon-delete": "epic__epic-icon-delete__cfb",
  "epic-icon-edit": "epic__epic-icon-edit__a80",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__01a",
  "epic-icon-filter": "epic__epic-icon-filter__16d",
  "epic-icon-github": "epic__epic-icon-github__acb",
  "epic-icon-information": "epic__epic-icon-information__aa3",
  "epic-icon-jira": "epic__epic-icon-jira__000",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__cc0",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__fa3",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__01d",
  "epic-icon-preview": "epic__epic-icon-preview__652",
  "epic-icon-profile": "epic__epic-icon-profile__b62",
  "epic-icon-quotes": "epic__epic-icon-quotes__bfc",
  "epic-icon-search": "epic__epic-icon-search__a33",
  "epic-icon-share": "epic__epic-icon-share__61a",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__8fa",
  "epic-icon-slack": "epic__epic-icon-slack__758",
  "epic-icon-steps": "epic__epic-icon-steps__592",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__b37",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__a2d",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__ae4",
  "epic-icon-warning": "epic__epic-icon-warning__412",
  "epic-font-base": "epic__epic-font-base__f8a",
  "epic-font-base-md": "epic__epic-font-base-md__8af",
  "epic-font-marketing": "epic__epic-font-marketing__afd",
  "epic-font-brand": "epic__epic-font-brand__b12",
  ripple: ripple$3,
  errorMsg: errorMsg$2,
  msg: msg$2
};
const urls = {
  qa: "https://api.aegis.nikecloud.com/v1/qa",
  prod: "https://api.aegis.nikecloud.com/v1/prod"
};
const headers$3 = (token2) => {
  return { "Content-Type": "application/json", Authorization: `Bearer ${token2}` };
};
const adGroupsApi = {
  listAdGroups: async (accessToken, env = "prod") => {
    const url = `${urls[env]}/userinfo?claims=nike:groups`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: headers$3(accessToken)
      });
      if (!(response == null ? void 0 : response.ok))
        throw new Error(response);
      const data = await response.json();
      if (data["nike:groups"])
        return data["nike:groups"];
      return data;
    } catch (error) {
      console.log("[API error]", error);
      throw new Error(error);
    }
  },
  unlimitedAdGroups: async (accessToken, env = "prod", input2) => {
    const url = `${urls[env]}/groups?`;
    try {
      const response = await fetch(url + new URLSearchParams({
        q: input2,
        count: 50
      }), {
        method: "GET",
        headers: headers$3(accessToken)
      });
      if (!(response == null ? void 0 : response.ok))
        throw new Error(response);
      const data = await response.json();
      if (data["items"])
        return data["items"];
      return data;
    } catch (error) {
      console.log("[API error]", error);
      throw new Error(error);
    }
  }
};
function useFetchAdGroups({
  accessToken,
  env,
  service,
  isLazyFetch = false,
  queryString
} = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const fetchData = useCallback(async (accessToken2, env2, service2, queryString2) => {
    setLoading(true);
    setError(null);
    try {
      const response = await service2(accessToken2, env2, queryString2);
      setData(response);
    } catch (error2) {
      console.log("[HOOK]", error2);
      setError(error2);
    } finally {
      setLoading(false);
    }
  }, [accessToken, env, service]);
  useEffect(() => {
    isLazyFetch && fetchData(accessToken, env, service, queryString);
  }, [fetchData, isLazyFetch]);
  return {
    data,
    loading,
    error,
    fetchData
  };
}
function validateAdGroupPattern(adGroup) {
  const pattern = /^[^.\n]+(\.[^.\n]+){2,}$/;
  return pattern.test(adGroup);
}
const overrideReactSelectOptions$2 = {
  formatCreateLabel: (inputValue) => {
    return `Use "${inputValue}"`;
  },
  getNewOptionData: (inputValue, optionLabel) => {
    if (!validateAdGroupPattern(inputValue))
      return null;
    return {
      value: inputValue,
      label: optionLabel
    };
  }
};
function ErrorFetchingData$2() {
  return /* @__PURE__ */ jsxs("div", {
    className: styles$3.errorMsg,
    children: [/* @__PURE__ */ jsx$1(Icon$1, {
      className: styles$3.icon,
      name: "AlertCircle",
      size: "m"
    }), /* @__PURE__ */ jsx$1("span", {
      className: styles$3.msg,
      children: " Error fetching AD Groups"
    })]
  });
}
const fetchErrorMsg$2 = "Fail to fetch data, maybe your accessToken has expired or it's not the right Okta Environment";
const minCharacters = 3;
function SelectAdGroup({
  env = "prod",
  accessToken,
  id = "MyAdGroups",
  label = "My AD Groups",
  subtitle: subtitle2 = "Select AD Groups",
  placeholder = "",
  isMulti = true,
  isCreatable = true,
  isUnlimitedSearch = false,
  ...props
}) {
  const [adGroupOptions, setAdGroupOptions] = useState([]);
  const [fetchError, setFetchError] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const {
    data,
    loading,
    error,
    fetchData
  } = useFetchAdGroups();
  const onInputChange = (e2) => setInputValue(e2);
  const debounceInput = useMemo(() => lodash.exports.debounce(onInputChange, 400));
  useEffect(() => {
    if (!isUnlimitedSearch) {
      fetchData(accessToken, env, adGroupsApi.listAdGroups);
    }
    setAdGroupOptions([]);
  }, [isUnlimitedSearch]);
  useEffect(() => {
    if (isUnlimitedSearch) {
      if (inputValue.length >= minCharacters) {
        fetchData(accessToken, env, adGroupsApi.unlimitedAdGroups, inputValue);
      } else {
        setAdGroupOptions([]);
      }
    }
  }, [inputValue]);
  useEffect(() => {
    setFetchError(error ? fetchErrorMsg$2 : null);
    const selectOptions = isUnlimitedSearch ? data == null ? void 0 : data.map((adGroup) => ({
      value: adGroup.displayName,
      label: adGroup.displayName
    })) : data == null ? void 0 : data.map((adGroup) => ({
      value: adGroup,
      label: adGroup
    }));
    setAdGroupOptions(selectOptions);
  }, [loading, data, error, env]);
  return /* @__PURE__ */ jsx$1(Select, {
    id,
    label,
    subtitle: subtitle2,
    placeholder,
    isMulti,
    isCreatable,
    accessToken,
    options: adGroupOptions,
    onInputChange: debounceInput,
    ...props,
    ...overrideReactSelectOptions$2,
    noOptionsMessage: () => {
      if (isUnlimitedSearch && inputValue.length < minCharacters)
        return `To start searching type at least ${minCharacters} characters`;
      if (loading)
        return "Loading...";
      if (fetchError)
        return /* @__PURE__ */ jsx$1(ErrorFetchingData$2, {});
      return "Please provide a valid AD Group format. e.g. `some.AD.Group`";
    }
  });
}
SelectAdGroup.propTypes = {
  env: PropTypes$1.string.isRequired,
  accessToken: PropTypes$1.string.isRequired,
  id: PropTypes$1.string,
  label: PropTypes$1.string,
  subtitle: PropTypes$1.string,
  placeholder: PropTypes$1.string,
  isMulti: PropTypes$1.bool,
  isCreatable: PropTypes$1.bool,
  isUnlimitedSearch: PropTypes$1.bool
};
const icon$2 = "epic__icon__0f9";
const ripple$2 = "epic__ripple__af6";
const errorMsg$1 = "epic__errorMsg__ba6";
const msg$1 = "epic__msg__898";
var styles$2 = {
  icon: icon$2,
  "epic-icon": "epic__epic-icon__09e",
  "epic-icon-add": "epic__epic-icon-add__4b9",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__f9c",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__d37",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__e90",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__e2c",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__9c9",
  "epic-icon-calendar": "epic__epic-icon-calendar__f0e",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__972",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__7e4",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__71d",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__5b2",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__646",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__1d0",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__9d0",
  "epic-icon-close-x": "epic__epic-icon-close-x__526",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__8f3",
  "epic-icon-confluence": "epic__epic-icon-confluence__43c",
  "epic-icon-contact": "epic__epic-icon-contact__86f",
  "epic-icon-delete": "epic__epic-icon-delete__c7d",
  "epic-icon-edit": "epic__epic-icon-edit__a1c",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__418",
  "epic-icon-filter": "epic__epic-icon-filter__c06",
  "epic-icon-github": "epic__epic-icon-github__a5d",
  "epic-icon-information": "epic__epic-icon-information__13f",
  "epic-icon-jira": "epic__epic-icon-jira__6b7",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__967",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__744",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__e85",
  "epic-icon-preview": "epic__epic-icon-preview__105",
  "epic-icon-profile": "epic__epic-icon-profile__575",
  "epic-icon-quotes": "epic__epic-icon-quotes__51e",
  "epic-icon-search": "epic__epic-icon-search__e05",
  "epic-icon-share": "epic__epic-icon-share__411",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__bf3",
  "epic-icon-slack": "epic__epic-icon-slack__0be",
  "epic-icon-steps": "epic__epic-icon-steps__aef",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__c8a",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__75b",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__7fe",
  "epic-icon-warning": "epic__epic-icon-warning__012",
  "epic-font-base": "epic__epic-font-base__e5e",
  "epic-font-base-md": "epic__epic-font-base-md__fa8",
  "epic-font-marketing": "epic__epic-font-marketing__f08",
  "epic-font-brand": "epic__epic-font-brand__5a2",
  ripple: ripple$2,
  errorMsg: errorMsg$1,
  msg: msg$1
};
const devPortalUrls = {
  qa: "https://api-developer.preprod.niketech.com/v1",
  prod: "https://api-developer.niketech.com/prod/v1"
};
const headers$2 = (token2) => {
  return { "Content-Type": "application/json", Authorization: `Bearer ${token2}` };
};
const oauthAppsApi = {
  listClientIds: async (accessToken, userEmail, env = "prod") => {
    const url = `${devPortalUrls[env]}/apps?username=${userEmail}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: headers$2(accessToken)
      });
      if (!(response == null ? void 0 : response.ok))
        throw new Error(response);
      const data = await response.json();
      if (data.items && Array.isArray(data.items)) {
        const listClientIds = data.items.map(({ clientId }) => clientId);
        return listClientIds;
      } else {
        return [];
      }
    } catch (error) {
      console.log("[API]", error);
      throw new Error(error);
    }
  }
};
function useFetchClientIds(accessToken, userEmail, env, service = oauthAppsApi.listClientIds) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await service(accessToken, userEmail, env);
      setData(response);
    } catch (error2) {
      console.log("[HOOK Error]", error2);
      setError(error2);
    } finally {
      setLoading(false);
    }
  }, [accessToken, env, service]);
  useEffect(() => {
    fetchData(accessToken, env);
  }, [fetchData]);
  return {
    data,
    loading,
    error,
    fetchData
  };
}
function validateClientPattern(clientId) {
  const pattern = /^([^.]+\.[^.]+){2}$/;
  return pattern.test(clientId);
}
const overrideReactSelectOptions$1 = {
  formatCreateLabel: (inputValue) => {
    return `Use "${inputValue}"`;
  },
  getNewOptionData: (inputValue, optionLabel) => {
    const clientIdRegExp = validateClientPattern(inputValue);
    if (!clientIdRegExp)
      return null;
    return {
      value: inputValue,
      label: optionLabel
    };
  }
};
function ErrorFetchingData$1() {
  return /* @__PURE__ */ jsxs("div", {
    className: styles$2.errorMsg,
    children: [/* @__PURE__ */ jsx$1(Icon$1, {
      className: styles$2.icon,
      name: "AlertCircle",
      size: "m"
    }), /* @__PURE__ */ jsx$1("span", {
      className: styles$2.msg,
      children: " Error fetching Client IDs"
    })]
  });
}
const fetchErrorMsg$1 = "Fail to fetch data, maybe your accessToken has expired or it's not the right Okta Environment";
function SelectOktaClientId({
  env = "prod",
  accessToken,
  userEmail,
  id = "OktaClientId",
  label = "Okta Client ID",
  subtitle: subtitle2 = "Select the Okta OAuth clientId(s)",
  placeholder = "nike.niketech.my-client-id",
  isMulti = true,
  isCreatable = true,
  ...props
}) {
  const [clientIdOptions, setClientIdOptions] = useState([]);
  const [fetchError, setFetchError] = useState(null);
  const {
    data,
    loading,
    error
  } = useFetchClientIds(accessToken, userEmail, env);
  useEffect(() => {
    setFetchError(error ? fetchErrorMsg$1 : null);
    const selectOptions = data == null ? void 0 : data.map((clientId) => ({
      value: clientId,
      label: clientId
    }));
    setClientIdOptions(selectOptions);
  }, [loading, data, error, env]);
  return /* @__PURE__ */ jsx$1(Select, {
    id,
    label,
    subtitle: subtitle2,
    placeholder,
    isMulti,
    isCreatable,
    accessToken,
    options: clientIdOptions,
    ...props,
    ...overrideReactSelectOptions$1,
    noOptionsMessage: () => {
      if (loading)
        return "Loading...";
      if (fetchError)
        return /* @__PURE__ */ jsx$1(ErrorFetchingData$1, {});
      return "Please provide a valid ClientId format. e.g. `some.client.id`";
    }
  });
}
SelectOktaClientId.propTypes = {
  env: PropTypes$1.string,
  accessToken: PropTypes$1.string.isRequired,
  userEmail: PropTypes$1.string.isRequired,
  id: PropTypes$1.string,
  label: PropTypes$1.string,
  subtitle: PropTypes$1.string,
  placeholder: PropTypes$1.string,
  isMulti: PropTypes$1.bool,
  isCreatable: PropTypes$1.bool
};
const icon$1 = "epic__icon__6ea";
const ripple$1 = "epic__ripple__8e0";
const errorMsg = "epic__errorMsg__4cc";
const msg = "epic__msg__765";
var styles$1 = {
  icon: icon$1,
  "epic-icon": "epic__epic-icon__45e",
  "epic-icon-add": "epic__epic-icon-add__422",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__f92",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__a3b",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__cb1",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__059",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__fac",
  "epic-icon-calendar": "epic__epic-icon-calendar__747",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__fda",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__340",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__3ad",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__74b",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__b3e",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__093",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__048",
  "epic-icon-close-x": "epic__epic-icon-close-x__00e",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__cfe",
  "epic-icon-confluence": "epic__epic-icon-confluence__bec",
  "epic-icon-contact": "epic__epic-icon-contact__bf7",
  "epic-icon-delete": "epic__epic-icon-delete__582",
  "epic-icon-edit": "epic__epic-icon-edit__000",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__aa4",
  "epic-icon-filter": "epic__epic-icon-filter__7ec",
  "epic-icon-github": "epic__epic-icon-github__07f",
  "epic-icon-information": "epic__epic-icon-information__15b",
  "epic-icon-jira": "epic__epic-icon-jira__c41",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__0d0",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__4d3",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__6a1",
  "epic-icon-preview": "epic__epic-icon-preview__7bf",
  "epic-icon-profile": "epic__epic-icon-profile__7db",
  "epic-icon-quotes": "epic__epic-icon-quotes__8cf",
  "epic-icon-search": "epic__epic-icon-search__252",
  "epic-icon-share": "epic__epic-icon-share__7c8",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__e68",
  "epic-icon-slack": "epic__epic-icon-slack__292",
  "epic-icon-steps": "epic__epic-icon-steps__436",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__aa7",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__088",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__acc",
  "epic-icon-warning": "epic__epic-icon-warning__7b9",
  "epic-font-base": "epic__epic-font-base__4f2",
  "epic-font-base-md": "epic__epic-font-base-md__1bb",
  "epic-font-marketing": "epic__epic-font-marketing__9c6",
  "epic-font-brand": "epic__epic-font-brand__e95",
  ripple: ripple$1,
  errorMsg,
  msg
};
const cloudRedUrl = "https://cloudred.nike.com/api/ssot/systems";
const headers$1 = (token2) => {
  return { "Content-Type": "application/json", Authorization: `Bearer ${token2}` };
};
const cloudRedApi = {
  listCloudRedGuids: async (accessToken, userEmail) => {
    const url = `${cloudRedUrl}/?owner=${userEmail}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: headers$1(accessToken)
      });
      if (!(response == null ? void 0 : response.ok))
        throw new Error(response);
      const data = await response.json();
      if (data && Array.isArray(data)) {
        return data.map(({ name, key, owner, type }) => ({ name, guid: key, owner, type }));
      } else {
        return [];
      }
    } catch (error) {
      console.log("[API error]", error);
      throw new Error(error);
    }
  }
};
function useFetchCloudRedGuids(accessToken, userEmail, service = cloudRedApi.listCloudRedGuids) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await service(accessToken, userEmail);
      setData(response);
    } catch (error2) {
      console.log("[HOOK Error]", error2);
      setError(error2);
    } finally {
      setLoading(false);
    }
  }, [accessToken, userEmail, service]);
  useEffect(() => {
    fetchData(accessToken, userEmail);
  }, [fetchData]);
  return {
    data,
    loading,
    error,
    fetchData
  };
}
function validateGuid(guid) {
  const pattern = /^[a-f\d]{8}-(?:[a-f\d]{4}-){3}[a-f\d]{12}$/i;
  return pattern.test(guid);
}
const overrideReactSelectOptions = {
  formatCreateLabel: (inputValue) => {
    return `Use "${inputValue}"`;
  },
  getNewOptionData: (inputValue, optionLabel) => {
    const guidRegExp = validateGuid(inputValue);
    if (!guidRegExp)
      return null;
    return {
      value: inputValue,
      label: optionLabel
    };
  }
};
function ErrorFetchingData() {
  return /* @__PURE__ */ jsxs("div", {
    className: styles$1.errorMsg,
    children: [/* @__PURE__ */ jsx$1(Icon$1, {
      className: styles$1.icon,
      name: "AlertCircle",
      size: "m"
    }), /* @__PURE__ */ jsx$1("span", {
      className: styles$1.msg,
      children: " Error fetching CloudRed Guids"
    })]
  });
}
const fetchErrorMsg = "Please provide a valid GUID format e.g. `12345678-abcd-ef34-1234-123456789012`";
function SelectCloudRedGuids({
  accessToken,
  userEmail,
  id = "CloudRedGuids",
  label = "CloudRed Guids",
  subtitle: subtitle2 = "Select the CloudRed GUIDs",
  placeholder = "cloudred guids ...",
  isMulti = true,
  isCreatable = true,
  ...props
}) {
  const [adGroupOptions, setCloudRedGuidsOptions] = useState([]);
  const [fetchError, setFetchError] = useState(null);
  const {
    data,
    loading,
    error
  } = useFetchCloudRedGuids(accessToken, userEmail);
  useEffect(() => {
    setFetchError(error ? fetchErrorMsg : null);
    const selectOptions = data == null ? void 0 : data.map(({
      name,
      guid
    }) => ({
      value: guid,
      label: `${guid} - (${name})`
    }));
    setCloudRedGuidsOptions(selectOptions);
  }, [loading, data, error, accessToken, userEmail]);
  return /* @__PURE__ */ jsx$1(Select, {
    id,
    label,
    subtitle: subtitle2,
    placeholder,
    isMulti,
    isCreatable,
    accessToken,
    options: adGroupOptions,
    ...props,
    ...overrideReactSelectOptions,
    noOptionsMessage: () => {
      if (loading)
        return "Loading...";
      if (fetchError)
        return /* @__PURE__ */ jsx$1(ErrorFetchingData, {});
      return "Please provide a valid Guid format.";
    }
  });
}
SelectCloudRedGuids.propTypes = {
  accessToken: PropTypes$1.string.isRequired,
  userEmail: PropTypes$1.string.isRequired,
  id: PropTypes$1.string,
  label: PropTypes$1.string,
  subtitle: PropTypes$1.string,
  placeholder: PropTypes$1.string,
  isMulti: PropTypes$1.bool,
  isCreatable: PropTypes$1.bool
};
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
function _toPrimitive(input2, hint) {
  if (_typeof(input2) !== "object" || input2 === null)
    return input2;
  var prim = input2[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input2, hint || "default");
    if (_typeof(res) !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input2);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key = sourceKeys[i2];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++) {
      key = sourceSymbolKeys[i2];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
var FUNC_ERROR_TEXT = "Expected a function";
var NAN = 0 / 0;
var symbolTag = "[object Symbol]";
var reTrim = /^\s+|\s+$/g;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal || freeSelf || Function("return this")();
var objectProto = Object.prototype;
var objectToString = objectProto.toString;
var nativeMax = Math.max, nativeMin = Math.min;
var now = function() {
  return root.Date.now();
};
function debounce(func, wait, options) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    lastInvokeTime = time;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result2 = wait - timeSinceLastCall;
    return maxing ? nativeMin(result2, maxWait - timeSinceLastInvoke) : result2;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now());
  }
  function debounced() {
    var time = now(), isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
function isObject(value) {
  var type = typeof value;
  return !!value && (type == "object" || type == "function");
}
function isObjectLike(value) {
  return !!value && typeof value == "object";
}
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
function toNumber(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, "");
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var lodash_debounce = debounce;
function useForceUpdate() {
  const [, dispatch] = useReducer((state) => !state, false);
  return dispatch;
}
function usePrevious(value) {
  const ref = useRef(null);
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
var ALIGN_VALUES = ["justify", "left", "right"];
var DEFAULT_LABELKEY = "label";
var SIZES = ["lg", "sm"];
var invariant = function(condition, format, a, b2, c2, d2, e2, f2) {
  if (!condition) {
    var error;
    if (format === void 0) {
      error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    } else {
      var args = [a, b2, c2, d2, e2, f2];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function() {
        return args[argIndex++];
      }));
      error.name = "Invariant Violation";
    }
    error.framesToPop = 1;
    throw error;
  }
};
var browser = invariant;
function getStringLabelKey(labelKey) {
  return typeof labelKey === "string" ? labelKey : DEFAULT_LABELKEY;
}
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
var idCounter = 0;
function isFunction(value) {
  return typeof value === "function";
}
function isString(value) {
  return typeof value === "string";
}
function noop$1() {
}
function pick(obj, keys) {
  var result = {};
  keys.forEach(function(key) {
    result[key] = obj[key];
  });
  return result;
}
function uniqueId(prefix2) {
  idCounter += 1;
  return (prefix2 == null ? "" : String(prefix2)) + idCounter;
}
function getOptionLabel3(option, labelKey) {
  if (!isString(option) && (hasOwnProperty(option, "paginationOption") || hasOwnProperty(option, "customOption"))) {
    return option[getStringLabelKey(labelKey)];
  }
  var optionLabel;
  if (isFunction(labelKey)) {
    optionLabel = labelKey(option);
  } else if (isString(option)) {
    optionLabel = option;
  } else {
    optionLabel = option[labelKey];
  }
  !isString(optionLabel) ? browser(false) : void 0;
  return optionLabel;
}
function addCustomOption(results, props) {
  var allowNew = props.allowNew, labelKey = props.labelKey, text = props.text;
  if (!allowNew || !text.trim()) {
    return false;
  }
  if (isFunction(allowNew)) {
    return allowNew(results, props);
  }
  return !results.some(function(o) {
    return getOptionLabel3(o, labelKey) === text;
  });
}
var fastDeepEqual = function equal2(a, b2) {
  if (a === b2)
    return true;
  if (a && b2 && typeof a == "object" && typeof b2 == "object") {
    if (a.constructor !== b2.constructor)
      return false;
    var length2, i2, keys;
    if (Array.isArray(a)) {
      length2 = a.length;
      if (length2 != b2.length)
        return false;
      for (i2 = length2; i2-- !== 0; )
        if (!equal2(a[i2], b2[i2]))
          return false;
      return true;
    }
    if (a.constructor === RegExp)
      return a.source === b2.source && a.flags === b2.flags;
    if (a.valueOf !== Object.prototype.valueOf)
      return a.valueOf() === b2.valueOf();
    if (a.toString !== Object.prototype.toString)
      return a.toString() === b2.toString();
    keys = Object.keys(a);
    length2 = keys.length;
    if (length2 !== Object.keys(b2).length)
      return false;
    for (i2 = length2; i2-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(b2, keys[i2]))
        return false;
    for (i2 = length2; i2-- !== 0; ) {
      var key = keys[i2];
      if (!equal2(a[key], b2[key]))
        return false;
    }
    return true;
  }
  return a !== a && b2 !== b2;
};
function getOptionProperty(option, key) {
  if (isString(option)) {
    return void 0;
  }
  return option[key];
}
var map = [{
  base: "A",
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: "AA",
  letters: "\uA732"
}, {
  base: "AE",
  letters: "\xC6\u01FC\u01E2"
}, {
  base: "AO",
  letters: "\uA734"
}, {
  base: "AU",
  letters: "\uA736"
}, {
  base: "AV",
  letters: "\uA738\uA73A"
}, {
  base: "AY",
  letters: "\uA73C"
}, {
  base: "B",
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: "C",
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: "D",
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779\xD0"
}, {
  base: "DZ",
  letters: "\u01F1\u01C4"
}, {
  base: "Dz",
  letters: "\u01F2\u01C5"
}, {
  base: "E",
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: "F",
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: "G",
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: "H",
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: "I",
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: "J",
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: "K",
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: "L",
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: "LJ",
  letters: "\u01C7"
}, {
  base: "Lj",
  letters: "\u01C8"
}, {
  base: "M",
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: "N",
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: "NJ",
  letters: "\u01CA"
}, {
  base: "Nj",
  letters: "\u01CB"
}, {
  base: "O",
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: "OI",
  letters: "\u01A2"
}, {
  base: "OO",
  letters: "\uA74E"
}, {
  base: "OU",
  letters: "\u0222"
}, {
  base: "OE",
  letters: "\x8C\u0152"
}, {
  base: "oe",
  letters: "\x9C\u0153"
}, {
  base: "P",
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: "Q",
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: "R",
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: "S",
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: "T",
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: "TZ",
  letters: "\uA728"
}, {
  base: "U",
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: "V",
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: "VY",
  letters: "\uA760"
}, {
  base: "W",
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: "X",
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: "Y",
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: "Z",
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: "a",
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: "aa",
  letters: "\uA733"
}, {
  base: "ae",
  letters: "\xE6\u01FD\u01E3"
}, {
  base: "ao",
  letters: "\uA735"
}, {
  base: "au",
  letters: "\uA737"
}, {
  base: "av",
  letters: "\uA739\uA73B"
}, {
  base: "ay",
  letters: "\uA73D"
}, {
  base: "b",
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: "c",
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: "d",
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: "dz",
  letters: "\u01F3\u01C6"
}, {
  base: "e",
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: "f",
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: "g",
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: "h",
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: "hv",
  letters: "\u0195"
}, {
  base: "i",
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: "j",
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: "k",
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: "l",
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: "lj",
  letters: "\u01C9"
}, {
  base: "m",
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: "n",
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: "nj",
  letters: "\u01CC"
}, {
  base: "o",
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: "oi",
  letters: "\u01A3"
}, {
  base: "ou",
  letters: "\u0223"
}, {
  base: "oo",
  letters: "\uA74F"
}, {
  base: "p",
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: "q",
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: "r",
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: "s",
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: "t",
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: "tz",
  letters: "\uA729"
}, {
  base: "u",
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: "v",
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: "vy",
  letters: "\uA761"
}, {
  base: "w",
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: "x",
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: "y",
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: "z",
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}].reduce(function(acc, _ref3) {
  var base = _ref3.base, letters = _ref3.letters;
  letters.split("").forEach(function(letter) {
    acc[letter] = base;
  });
  return acc;
}, {});
function stripDiacritics2(str) {
  return str.normalize("NFD").replace(/[\u0300-\u036F]/g, "").replace(/[^\u0000-\u007E]/g, function(a) {
    return map[a] || a;
  });
}
var warned = {};
function warn(falseToWarn, message) {
  if (!falseToWarn && message.indexOf("deprecated") !== -1) {
    if (warned[message]) {
      return;
    }
    warned[message] = true;
  }
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  warning_1.apply(void 0, [falseToWarn, "[react-bootstrap-typeahead] ".concat(message)].concat(args));
}
function isMatch(input2, string, props) {
  var searchStr = input2;
  var str = string;
  if (!props.caseSensitive) {
    searchStr = searchStr.toLowerCase();
    str = str.toLowerCase();
  }
  if (props.ignoreDiacritics) {
    searchStr = stripDiacritics2(searchStr);
    str = stripDiacritics2(str);
  }
  return str.indexOf(searchStr) !== -1;
}
function defaultFilterBy(option, props) {
  var filterBy = props.filterBy, labelKey = props.labelKey, multiple = props.multiple, selected2 = props.selected, text = props.text;
  if (multiple && selected2.some(function(o) {
    return fastDeepEqual(o, option);
  })) {
    return false;
  }
  if (isFunction(labelKey)) {
    return isMatch(text, labelKey(option), props);
  }
  var fields = filterBy.slice();
  if (isString(labelKey)) {
    if (fields.indexOf(labelKey) === -1) {
      fields.unshift(labelKey);
    }
  }
  if (isString(option)) {
    warn(fields.length <= 1, "You cannot filter by properties when `option` is a string.");
    return isMatch(text, option, props);
  }
  return fields.some(function(field) {
    var value = getOptionProperty(option, field);
    if (!isString(value)) {
      warn(false, "Fields passed to `filterBy` should have string values. Value will be converted to a string; results may be unexpected.");
      value = String(value);
    }
    return isMatch(text, value, props);
  });
}
function isSelectable(inputNode) {
  return inputNode.selectionStart != null;
}
function defaultSelectHint(e2, selectHint) {
  var shouldSelectHint = false;
  if (e2.key === "ArrowRight") {
    shouldSelectHint = isSelectable(e2.currentTarget) ? e2.currentTarget.selectionStart === e2.currentTarget.value.length : true;
  }
  if (e2.key === "Tab") {
    e2.preventDefault();
    shouldSelectHint = true;
  }
  return selectHint ? selectHint(shouldSelectHint, e2) : shouldSelectHint;
}
var CASE_INSENSITIVE = "i";
var COMBINING_MARKS = /[\u0300-\u036F]/;
function escapeStringRegexp(str) {
  !(typeof str === "string") ? browser(false) : void 0;
  return str.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
function getMatchBounds(subject, str) {
  var search = new RegExp(escapeStringRegexp(stripDiacritics2(str)), CASE_INSENSITIVE);
  var matches2 = search.exec(stripDiacritics2(subject));
  if (!matches2) {
    return null;
  }
  var start2 = matches2.index;
  var matchLength = matches2[0].length;
  if (COMBINING_MARKS.test(subject)) {
    for (var ii = 0; ii <= start2; ii++) {
      if (COMBINING_MARKS.test(subject[ii])) {
        start2 += 1;
      }
    }
    for (var _ii = start2; _ii <= start2 + matchLength; _ii++) {
      if (COMBINING_MARKS.test(subject[_ii])) {
        matchLength += 1;
      }
    }
  }
  return {
    end: start2 + matchLength,
    start: start2
  };
}
function getHintText(_ref3) {
  var activeIndex = _ref3.activeIndex, initialItem = _ref3.initialItem, isFocused = _ref3.isFocused, isMenuShown = _ref3.isMenuShown, labelKey = _ref3.labelKey, multiple = _ref3.multiple, selected2 = _ref3.selected, text = _ref3.text;
  if (!text || !isFocused || !isMenuShown || !initialItem || !isString(initialItem) && hasOwnProperty(initialItem, "customOption") || activeIndex > -1 || !!selected2.length && !multiple) {
    return "";
  }
  var initialItemStr = getOptionLabel3(initialItem, labelKey);
  var bounds = getMatchBounds(initialItemStr.toLowerCase(), text.toLowerCase());
  if (!(bounds && bounds.start === 0)) {
    return "";
  }
  return text + initialItemStr.slice(bounds.end, initialItemStr.length);
}
var classnames = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(module) {
  (function() {
    var hasOwn = {}.hasOwnProperty;
    function classNames2() {
      var classes = [];
      for (var i2 = 0; i2 < arguments.length; i2++) {
        var arg = arguments[i2];
        if (!arg)
          continue;
        var argType = typeof arg;
        if (argType === "string" || argType === "number") {
          classes.push(arg);
        } else if (Array.isArray(arg)) {
          if (arg.length) {
            var inner2 = classNames2.apply(null, arg);
            if (inner2) {
              classes.push(inner2);
            }
          }
        } else if (argType === "object") {
          if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
            classes.push(arg.toString());
            continue;
          }
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }
      return classes.join(" ");
    }
    if (module.exports) {
      classNames2.default = classNames2;
      module.exports = classNames2;
    } else {
      window.classNames = classNames2;
    }
  })();
})(classnames);
var cx = classnames.exports;
function getMenuItemId() {
  var id = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  var position2 = arguments.length > 1 ? arguments[1] : void 0;
  return "".concat(id, "-item-").concat(position2);
}
var _excluded$e = ["activeIndex", "id", "isFocused", "isMenuShown", "multiple", "onClick", "onFocus", "placeholder"];
function ownKeys$b(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$b(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys$b(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$b(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var getInputProps = function getInputProps2(_ref3) {
  var activeIndex = _ref3.activeIndex, id = _ref3.id, isFocused = _ref3.isFocused, isMenuShown = _ref3.isMenuShown, multiple = _ref3.multiple, onClick = _ref3.onClick, onFocus2 = _ref3.onFocus, placeholder = _ref3.placeholder, props = _objectWithoutProperties(_ref3, _excluded$e);
  return function() {
    var _cx;
    var inputProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var className = hasOwnProperty(inputProps, "className") ? String(inputProps.className) : void 0;
    return _objectSpread$b(_objectSpread$b(_objectSpread$b(_objectSpread$b({
      autoComplete: "off",
      placeholder,
      type: "text"
    }, inputProps), props), {}, {
      "aria-activedescendant": activeIndex >= 0 ? getMenuItemId(id, activeIndex) : void 0,
      "aria-autocomplete": "both",
      "aria-expanded": isMenuShown,
      "aria-haspopup": "listbox",
      "aria-multiselectable": multiple || void 0,
      "aria-owns": isMenuShown ? id : void 0,
      className: cx((_cx = {}, _defineProperty(_cx, className || "", !multiple), _defineProperty(_cx, "focus", isFocused), _cx))
    }, multiple && {
      inputClassName: className
    }), {}, {
      onClick,
      onFocus: onFocus2,
      role: "combobox"
    });
  };
};
function getInputText(props) {
  var activeItem = props.activeItem, labelKey = props.labelKey, multiple = props.multiple, selected2 = props.selected, text = props.text;
  if (activeItem) {
    return getOptionLabel3(activeItem, labelKey);
  }
  if (!multiple && selected2.length && selected2[0]) {
    return getOptionLabel3(selected2[0], labelKey);
  }
  return text;
}
function getIsOnlyResult(props) {
  var allowNew = props.allowNew, highlightOnlyResult = props.highlightOnlyResult, results = props.results;
  if (!highlightOnlyResult || allowNew) {
    return false;
  }
  return results.length === 1 && !getOptionProperty(results[0], "disabled");
}
function getTruncatedOptions(options, maxResults) {
  if (!maxResults || maxResults >= options.length) {
    return options;
  }
  return options.slice(0, maxResults);
}
function isDisabledOption(index2, items) {
  var option = items[index2];
  return !!option && !isString(option) && hasOwnProperty(option, "disabled");
}
function skipDisabledOptions(currentIndex, key, items) {
  var newIndex = currentIndex;
  while (isDisabledOption(newIndex, items)) {
    newIndex += key === "ArrowUp" ? -1 : 1;
  }
  return newIndex;
}
function getUpdatedActiveIndex(currentIndex, key, items) {
  var newIndex = currentIndex;
  newIndex += key === "ArrowUp" ? -1 : 1;
  newIndex = skipDisabledOptions(newIndex, key, items);
  if (newIndex === items.length) {
    newIndex = -1;
  } else if (newIndex === -2) {
    newIndex = items.length - 1;
    newIndex = skipDisabledOptions(newIndex, key, items);
  }
  return newIndex;
}
function isShown(_ref3) {
  var open = _ref3.open, minLength = _ref3.minLength, showMenu = _ref3.showMenu, text = _ref3.text;
  if (open || open === false) {
    return open;
  }
  if (text.length < minLength) {
    return false;
  }
  return showMenu;
}
function preventInputBlur(e2) {
  e2.preventDefault();
}
function isSizeLarge(size) {
  return size === "lg";
}
function isSizeSmall(size) {
  return size === "sm";
}
var _excluded$d = ["className", "isInvalid", "isValid", "size"];
function ownKeys$a(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$a(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys$a(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$a(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function propsWithBsClassName(_ref3) {
  var className = _ref3.className, isInvalid = _ref3.isInvalid, isValid = _ref3.isValid, size = _ref3.size, props = _objectWithoutProperties(_ref3, _excluded$d);
  return _objectSpread$a(_objectSpread$a({}, props), {}, {
    className: cx("form-control", "rbt-input", {
      "form-control-lg": isSizeLarge(size),
      "form-control-sm": isSizeSmall(size),
      "is-invalid": isInvalid,
      "is-valid": isValid
    }, className)
  });
}
function validateSelectedPropChange(prevSelected, selected2) {
  var uncontrolledToControlled = !prevSelected && selected2;
  var controlledToUncontrolled = prevSelected && !selected2;
  var from2, to, precedent;
  if (uncontrolledToControlled) {
    from2 = "uncontrolled";
    to = "controlled";
    precedent = "an";
  } else {
    from2 = "controlled";
    to = "uncontrolled";
    precedent = "a";
  }
  var message = "You are changing ".concat(precedent, " ").concat(from2, " typeahead to be ").concat(to, ". ") + "Input elements should not switch from ".concat(from2, " to ").concat(to, " (or vice versa). ") + "Decide between using a controlled or uncontrolled element for the lifetime of the component.";
  warn(!(uncontrolledToControlled || controlledToUncontrolled), message);
}
var INPUT_PROPS_BLACKLIST = [{
  alt: "onBlur",
  prop: "onBlur"
}, {
  alt: "onInputChange",
  prop: "onChange"
}, {
  alt: "onFocus",
  prop: "onFocus"
}, {
  alt: "onKeyDown",
  prop: "onKeyDown"
}];
var sizeType = PropTypes$1.oneOf(SIZES);
function checkPropType(validator, callback) {
  return function(props, propName, componentName) {
    PropTypes$1.checkPropTypes(_defineProperty({}, propName, validator), props, "prop", componentName);
    isFunction(callback) && callback(props, propName, componentName);
  };
}
function caseSensitiveType(props) {
  var caseSensitive = props.caseSensitive, filterBy = props.filterBy;
  warn(!caseSensitive || typeof filterBy !== "function", "Your `filterBy` function will override the `caseSensitive` prop.");
}
function defaultInputValueType(props) {
  var defaultInputValue = props.defaultInputValue, defaultSelected = props.defaultSelected, multiple = props.multiple, selected2 = props.selected;
  var name = defaultSelected.length ? "defaultSelected" : "selected";
  warn(!(!multiple && defaultInputValue && (defaultSelected.length || selected2 && selected2.length)), "`defaultInputValue` will be overridden by the value from `".concat(name, "`."));
}
function defaultSelectedType(props) {
  var defaultSelected = props.defaultSelected, multiple = props.multiple;
  warn(multiple || defaultSelected.length <= 1, "You are passing multiple options to the `defaultSelected` prop of a Typeahead in single-select mode. The selections will be truncated to a single selection.");
}
function highlightOnlyResultType(_ref3) {
  var allowNew = _ref3.allowNew, highlightOnlyResult = _ref3.highlightOnlyResult;
  warn(!(highlightOnlyResult && allowNew), "`highlightOnlyResult` will not work with `allowNew`.");
}
function ignoreDiacriticsType(props) {
  var filterBy = props.filterBy, ignoreDiacritics = props.ignoreDiacritics;
  warn(ignoreDiacritics || typeof filterBy !== "function", "Your `filterBy` function will override the `ignoreDiacritics` prop.");
}
function inputPropsType(_ref22) {
  var inputProps = _ref22.inputProps;
  if (!(inputProps && Object.prototype.toString.call(inputProps) === "[object Object]")) {
    return;
  }
  INPUT_PROPS_BLACKLIST.forEach(function(_ref3) {
    var alt = _ref3.alt, prop = _ref3.prop;
    var msg2 = alt ? " Use the top-level `".concat(alt, "` prop instead.") : null;
    warn(!inputProps[prop], "The `".concat(prop, "` property of `inputProps` will be ignored.").concat(msg2));
  });
}
function isRequiredForA11y(props, propName, componentName) {
  warn(props[propName] != null, "The prop `".concat(propName, "` is required to make `").concat(componentName, "` ") + "accessible for users of assistive technologies such as screen readers.");
}
function labelKeyType(_ref4) {
  var allowNew = _ref4.allowNew, labelKey = _ref4.labelKey;
  warn(!(isFunction(labelKey) && allowNew), "`labelKey` must be a string when `allowNew={true}`.");
}
var optionType = PropTypes$1.oneOfType([PropTypes$1.object, PropTypes$1.string]);
function selectedType(_ref5) {
  var multiple = _ref5.multiple, onChange2 = _ref5.onChange, selected2 = _ref5.selected;
  warn(multiple || !selected2 || selected2.length <= 1, "You are passing multiple options to the `selected` prop of a Typeahead in single-select mode. This may lead to unexpected behaviors or errors.");
  warn(!selected2 || selected2 && isFunction(onChange2), "You provided a `selected` prop without an `onChange` handler. If you want the typeahead to be uncontrolled, use `defaultSelected`. Otherwise, set `onChange`.");
}
var _excluded$c = ["allowNew", "delay", "emptyLabel", "isLoading", "minLength", "onInputChange", "onSearch", "options", "promptText", "searchText", "useCache"];
function ownKeys$9(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$9(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys$9(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$9(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
({
  delay: PropTypes$1.number,
  isLoading: PropTypes$1.bool.isRequired,
  minLength: PropTypes$1.number,
  onSearch: PropTypes$1.func.isRequired,
  options: PropTypes$1.arrayOf(optionType),
  promptText: PropTypes$1.node,
  searchText: PropTypes$1.node,
  useCache: PropTypes$1.bool
});
function useAsync(props) {
  var allowNew = props.allowNew, _props$delay = props.delay, delay3 = _props$delay === void 0 ? 200 : _props$delay, emptyLabel = props.emptyLabel, isLoading2 = props.isLoading, _props$minLength = props.minLength, minLength = _props$minLength === void 0 ? 2 : _props$minLength, onInputChange = props.onInputChange, onSearch = props.onSearch, _props$options = props.options, options = _props$options === void 0 ? [] : _props$options, _props$promptText = props.promptText, promptText = _props$promptText === void 0 ? "Type to search..." : _props$promptText, _props$searchText = props.searchText, searchText = _props$searchText === void 0 ? "Searching..." : _props$searchText, _props$useCache = props.useCache, useCache = _props$useCache === void 0 ? true : _props$useCache, otherProps = _objectWithoutProperties(props, _excluded$c);
  var cacheRef = useRef({});
  var handleSearchDebouncedRef = useRef(null);
  var queryRef = useRef(props.defaultInputValue || "");
  var forceUpdate = useForceUpdate();
  var prevProps = usePrevious(props);
  var handleSearch = useCallback(function(query) {
    queryRef.current = query;
    if (!query || minLength && query.length < minLength) {
      return;
    }
    if (useCache && cacheRef.current[query]) {
      forceUpdate();
      return;
    }
    onSearch(query);
  }, [forceUpdate, minLength, onSearch, useCache]);
  useEffect(function() {
    handleSearchDebouncedRef.current = lodash_debounce(handleSearch, delay3);
    return function() {
      handleSearchDebouncedRef.current && handleSearchDebouncedRef.current.cancel();
    };
  }, [delay3, handleSearch]);
  useEffect(function() {
    if (!isLoading2 && prevProps && prevProps.isLoading && useCache) {
      cacheRef.current[queryRef.current] = options;
    }
  });
  var getEmptyLabel = function getEmptyLabel2() {
    if (!queryRef.current.length) {
      return promptText;
    }
    if (isLoading2) {
      return searchText;
    }
    return emptyLabel;
  };
  var handleInputChange = useCallback(function(query, e2) {
    onInputChange && onInputChange(query, e2);
    handleSearchDebouncedRef.current && handleSearchDebouncedRef.current(query);
  }, [onInputChange]);
  var cachedQuery = cacheRef.current[queryRef.current];
  return _objectSpread$9(_objectSpread$9({}, otherProps), {}, {
    allowNew: isFunction(allowNew) ? allowNew : allowNew && !isLoading2,
    emptyLabel: getEmptyLabel(),
    isLoading: isLoading2,
    minLength,
    onInputChange: handleInputChange,
    options: useCache && cachedQuery ? cachedQuery : options
  });
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i2 = 0; i2 < props.length; i2++) {
    var descriptor = props[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _setPrototypeOf(o, p2) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p3) {
    o2.__proto__ = p3;
    return o2;
  };
  return _setPrototypeOf(o, p2);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass)
    _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self2, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self2);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}
var defaultContext = {
  activeIndex: -1,
  hintText: "",
  id: "",
  initialItem: null,
  inputNode: null,
  isOnlyResult: false,
  onActiveItemChange: noop$1,
  onAdd: noop$1,
  onInitialItemChange: noop$1,
  onMenuItemClick: noop$1,
  setItem: noop$1
};
var TypeaheadContext = /* @__PURE__ */ createContext(defaultContext);
var useTypeaheadContext = function useTypeaheadContext2() {
  return useContext(TypeaheadContext);
};
function ownKeys$8(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$8(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys$8(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$8(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var inputPropKeys = ["activeIndex", "disabled", "id", "inputRef", "isFocused", "isMenuShown", "multiple", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "placeholder"];
var propKeys = ["activeIndex", "hideMenu", "isMenuShown", "labelKey", "onClear", "onHide", "onRemove", "results", "selected", "text", "toggleMenu"];
var contextKeys = ["activeIndex", "id", "initialItem", "inputNode", "onActiveItemChange", "onAdd", "onInitialItemChange", "onMenuItemClick", "setItem"];
var TypeaheadManager = function TypeaheadManager2(props) {
  var allowNew = props.allowNew, children = props.children, initialItem = props.initialItem, isMenuShown = props.isMenuShown, onAdd = props.onAdd, onInitialItemChange = props.onInitialItemChange, onKeyDown = props.onKeyDown, onMenuToggle = props.onMenuToggle, results = props.results, selectHint = props.selectHint;
  var hintText = getHintText(props);
  useEffect(function() {
    if (!(allowNew || results.length)) {
      onInitialItemChange();
    }
  });
  var isInitialRender = useRef(true);
  useEffect(function() {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }
    onMenuToggle(isMenuShown);
  }, [isMenuShown, onMenuToggle]);
  var handleKeyDown = function handleKeyDown2(e2) {
    onKeyDown(e2);
    if (!initialItem) {
      return;
    }
    var addOnlyResult = e2.key === "Enter" && getIsOnlyResult(props);
    var shouldSelectHint = hintText && defaultSelectHint(e2, selectHint);
    if (addOnlyResult || shouldSelectHint) {
      onAdd(initialItem);
    }
  };
  var childProps = _objectSpread$8(_objectSpread$8({}, pick(props, propKeys)), {}, {
    getInputProps: getInputProps(_objectSpread$8(_objectSpread$8({}, pick(props, inputPropKeys)), {}, {
      onKeyDown: handleKeyDown,
      value: getInputText(props)
    }))
  });
  var contextValue = _objectSpread$8(_objectSpread$8({}, pick(props, contextKeys)), {}, {
    hintText,
    isOnlyResult: getIsOnlyResult(props)
  });
  return /* @__PURE__ */ jsx$1(TypeaheadContext.Provider, {
    value: contextValue,
    children: isFunction(children) ? children(childProps) : children
  });
};
function ownKeys$7(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$7(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys$7(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$7(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function getInitialState(props) {
  var defaultInputValue = props.defaultInputValue, defaultOpen = props.defaultOpen, defaultSelected = props.defaultSelected, maxResults = props.maxResults, multiple = props.multiple;
  var selected2 = props.selected ? props.selected.slice() : defaultSelected.slice();
  var text = defaultInputValue;
  if (!multiple && selected2.length) {
    text = getOptionLabel3(selected2[0], props.labelKey);
    if (selected2.length > 1) {
      selected2 = selected2.slice(0, 1);
    }
  }
  return {
    activeIndex: -1,
    activeItem: void 0,
    initialItem: void 0,
    isFocused: false,
    selected: selected2,
    showMenu: defaultOpen,
    shownResults: maxResults,
    text
  };
}
function clearTypeahead(state, props) {
  return _objectSpread$7(_objectSpread$7({}, getInitialState(props)), {}, {
    isFocused: state.isFocused,
    selected: [],
    text: ""
  });
}
function clickOrFocusInput(state) {
  return _objectSpread$7(_objectSpread$7({}, state), {}, {
    isFocused: true,
    showMenu: true
  });
}
function hideMenu(state, props) {
  var _getInitialState = getInitialState(props), activeIndex = _getInitialState.activeIndex, activeItem = _getInitialState.activeItem, initialItem = _getInitialState.initialItem, shownResults = _getInitialState.shownResults;
  return _objectSpread$7(_objectSpread$7({}, state), {}, {
    activeIndex,
    activeItem,
    initialItem,
    showMenu: false,
    shownResults
  });
}
function toggleMenu(state, props) {
  return state.showMenu ? hideMenu(state, props) : _objectSpread$7(_objectSpread$7({}, state), {}, {
    showMenu: true
  });
}
var _excluded$b = ["onChange"];
function ownKeys$6(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$6(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys$6(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e2) {
    return false;
  }
}
var propTypes$7 = {
  allowNew: PropTypes$1.oneOfType([PropTypes$1.bool, PropTypes$1.func]),
  autoFocus: PropTypes$1.bool,
  caseSensitive: checkPropType(PropTypes$1.bool, caseSensitiveType),
  defaultInputValue: checkPropType(PropTypes$1.string, defaultInputValueType),
  defaultOpen: PropTypes$1.bool,
  defaultSelected: checkPropType(PropTypes$1.arrayOf(optionType), defaultSelectedType),
  filterBy: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.string.isRequired), PropTypes$1.func]),
  highlightOnlyResult: checkPropType(PropTypes$1.bool, highlightOnlyResultType),
  id: checkPropType(PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]), isRequiredForA11y),
  ignoreDiacritics: checkPropType(PropTypes$1.bool, ignoreDiacriticsType),
  labelKey: checkPropType(PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.func]), labelKeyType),
  maxResults: PropTypes$1.number,
  minLength: PropTypes$1.number,
  multiple: PropTypes$1.bool,
  onBlur: PropTypes$1.func,
  onChange: PropTypes$1.func,
  onFocus: PropTypes$1.func,
  onInputChange: PropTypes$1.func,
  onKeyDown: PropTypes$1.func,
  onMenuToggle: PropTypes$1.func,
  onPaginate: PropTypes$1.func,
  open: PropTypes$1.bool,
  options: PropTypes$1.arrayOf(optionType).isRequired,
  paginate: PropTypes$1.bool,
  selected: checkPropType(PropTypes$1.arrayOf(optionType), selectedType)
};
var defaultProps$6 = {
  allowNew: false,
  autoFocus: false,
  caseSensitive: false,
  defaultInputValue: "",
  defaultOpen: false,
  defaultSelected: [],
  filterBy: [],
  highlightOnlyResult: false,
  ignoreDiacritics: true,
  labelKey: DEFAULT_LABELKEY,
  maxResults: 100,
  minLength: 0,
  multiple: false,
  onBlur: noop$1,
  onFocus: noop$1,
  onInputChange: noop$1,
  onKeyDown: noop$1,
  onMenuToggle: noop$1,
  onPaginate: noop$1,
  paginate: true
};
function triggerInputChange(input2, value) {
  var inputValue = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value");
  inputValue && inputValue.set && inputValue.set.call(input2, value);
  var e2 = new Event("input", {
    bubbles: true
  });
  input2.dispatchEvent(e2);
}
var Typeahead = /* @__PURE__ */ function(_React$Component) {
  _inherits(Typeahead2, _React$Component);
  var _super = _createSuper$1(Typeahead2);
  function Typeahead2() {
    var _this;
    _classCallCheck(this, Typeahead2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", getInitialState(_this.props));
    _defineProperty(_assertThisInitialized(_this), "inputNode", null);
    _defineProperty(_assertThisInitialized(_this), "isMenuShown", false);
    _defineProperty(_assertThisInitialized(_this), "items", []);
    _defineProperty(_assertThisInitialized(_this), "blur", function() {
      _this.inputNode && _this.inputNode.blur();
      _this.hideMenu();
    });
    _defineProperty(_assertThisInitialized(_this), "clear", function() {
      _this.setState(clearTypeahead);
    });
    _defineProperty(_assertThisInitialized(_this), "focus", function() {
      _this.inputNode && _this.inputNode.focus();
    });
    _defineProperty(_assertThisInitialized(_this), "getInput", function() {
      return _this.inputNode;
    });
    _defineProperty(_assertThisInitialized(_this), "inputRef", function(inputNode) {
      _this.inputNode = inputNode;
    });
    _defineProperty(_assertThisInitialized(_this), "setItem", function(item2, position2) {
      _this.items[position2] = item2;
    });
    _defineProperty(_assertThisInitialized(_this), "hideMenu", function() {
      _this.setState(hideMenu);
    });
    _defineProperty(_assertThisInitialized(_this), "toggleMenu", function() {
      _this.setState(toggleMenu);
    });
    _defineProperty(_assertThisInitialized(_this), "_handleActiveIndexChange", function(activeIndex) {
      _this.setState(function(state) {
        return {
          activeIndex,
          activeItem: activeIndex >= 0 ? state.activeItem : void 0
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_handleActiveItemChange", function(activeItem) {
      if (!fastDeepEqual(activeItem, _this.state.activeItem)) {
        _this.setState({
          activeItem
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_handleBlur", function(e2) {
      e2.persist();
      _this.setState({
        isFocused: false
      }, function() {
        return _this.props.onBlur(e2);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_handleChange", function(selected2) {
      _this.props.onChange && _this.props.onChange(selected2);
    });
    _defineProperty(_assertThisInitialized(_this), "_handleClear", function() {
      _this.inputNode && triggerInputChange(_this.inputNode, "");
      _this.setState(clearTypeahead, function() {
        if (_this.props.multiple) {
          _this._handleChange([]);
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_handleClick", function(e2) {
      var _this$props$inputProp;
      e2.persist();
      var onClick = (_this$props$inputProp = _this.props.inputProps) === null || _this$props$inputProp === void 0 ? void 0 : _this$props$inputProp.onClick;
      _this.setState(clickOrFocusInput, function() {
        return isFunction(onClick) && onClick(e2);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_handleFocus", function(e2) {
      e2.persist();
      _this.setState(clickOrFocusInput, function() {
        return _this.props.onFocus(e2);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_handleInitialItemChange", function(initialItem) {
      if (!fastDeepEqual(initialItem, _this.state.initialItem)) {
        _this.setState({
          initialItem
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_handleInputChange", function(e2) {
      e2.persist();
      var text = e2.currentTarget.value;
      var _this$props = _this.props, multiple = _this$props.multiple, onInputChange = _this$props.onInputChange;
      var shouldClearSelections = _this.state.selected.length && !multiple;
      _this.setState(function(state, props) {
        var _getInitialState = getInitialState(props), activeIndex = _getInitialState.activeIndex, activeItem = _getInitialState.activeItem, shownResults = _getInitialState.shownResults;
        return {
          activeIndex,
          activeItem,
          selected: shouldClearSelections ? [] : state.selected,
          showMenu: true,
          shownResults,
          text
        };
      }, function() {
        onInputChange(text, e2);
        shouldClearSelections && _this._handleChange([]);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_handleKeyDown", function(e2) {
      var activeItem = _this.state.activeItem;
      if (!_this.isMenuShown) {
        if (e2.key === "ArrowUp" || e2.key === "ArrowDown") {
          _this.setState({
            showMenu: true
          });
        }
        _this.props.onKeyDown(e2);
        return;
      }
      switch (e2.key) {
        case "ArrowUp":
        case "ArrowDown":
          e2.preventDefault();
          _this._handleActiveIndexChange(getUpdatedActiveIndex(_this.state.activeIndex, e2.key, _this.items));
          break;
        case "Enter":
          e2.preventDefault();
          activeItem && _this._handleMenuItemSelect(activeItem, e2);
          break;
        case "Escape":
        case "Tab":
          _this.hideMenu();
          break;
      }
      _this.props.onKeyDown(e2);
    });
    _defineProperty(_assertThisInitialized(_this), "_handleMenuItemSelect", function(option, e2) {
      if (getOptionProperty(option, "paginationOption")) {
        _this._handlePaginate(e2);
      } else {
        _this._handleSelectionAdd(option);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_handlePaginate", function(e2) {
      e2.persist();
      _this.setState(function(state, props) {
        return {
          shownResults: state.shownResults + props.maxResults
        };
      }, function() {
        return _this.props.onPaginate(e2, _this.state.shownResults);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_handleSelectionAdd", function(option) {
      var _this$props2 = _this.props, multiple = _this$props2.multiple, labelKey = _this$props2.labelKey;
      var selected2;
      var selection = option;
      var text;
      if (!isString(selection) && selection.customOption) {
        selection = _objectSpread$6(_objectSpread$6({}, selection), {}, {
          id: uniqueId("new-id-")
        });
      }
      if (multiple) {
        selected2 = _this.state.selected.concat(selection);
        text = "";
      } else {
        selected2 = [selection];
        text = getOptionLabel3(selection, labelKey);
      }
      _this.setState(function(state, props) {
        return _objectSpread$6(_objectSpread$6({}, hideMenu(state, props)), {}, {
          initialItem: selection,
          selected: selected2,
          text
        });
      }, function() {
        return _this._handleChange(selected2);
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_handleSelectionRemove", function(selection) {
      var selected2 = _this.state.selected.filter(function(option) {
        return !fastDeepEqual(option, selection);
      });
      _this.focus();
      _this.setState(function(state, props) {
        return _objectSpread$6(_objectSpread$6({}, hideMenu(state, props)), {}, {
          selected: selected2
        });
      }, function() {
        return _this._handleChange(selected2);
      });
    });
    return _this;
  }
  _createClass(Typeahead2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.autoFocus && this.focus();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props3 = this.props, labelKey = _this$props3.labelKey, multiple = _this$props3.multiple, selected2 = _this$props3.selected;
      validateSelectedPropChange(selected2, prevProps.selected);
      if (selected2 && !fastDeepEqual(selected2, prevState.selected)) {
        this.setState({
          selected: selected2
        });
        if (!multiple) {
          this.setState({
            text: selected2.length ? getOptionLabel3(selected2[0], labelKey) : ""
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props;
      _this$props4.onChange;
      var props = _objectWithoutProperties(_this$props4, _excluded$b);
      var mergedPropsAndState = _objectSpread$6(_objectSpread$6({}, props), this.state);
      var filterBy = mergedPropsAndState.filterBy, labelKey = mergedPropsAndState.labelKey, options = mergedPropsAndState.options, paginate = mergedPropsAndState.paginate, shownResults = mergedPropsAndState.shownResults, text = mergedPropsAndState.text;
      this.isMenuShown = isShown(mergedPropsAndState);
      this.items = [];
      var results = [];
      if (this.isMenuShown) {
        var cb = isFunction(filterBy) ? filterBy : defaultFilterBy;
        results = options.filter(function(option) {
          return cb(option, mergedPropsAndState);
        });
        var shouldPaginate = paginate && results.length > shownResults;
        results = getTruncatedOptions(results, shownResults);
        if (addCustomOption(results, mergedPropsAndState)) {
          results.push(_defineProperty({
            customOption: true
          }, getStringLabelKey(labelKey), text));
        }
        if (shouldPaginate) {
          var _results$push2;
          results.push((_results$push2 = {}, _defineProperty(_results$push2, getStringLabelKey(labelKey), ""), _defineProperty(_results$push2, "paginationOption", true), _results$push2));
        }
      }
      return /* @__PURE__ */ React__default.createElement(TypeaheadManager, _extends({}, mergedPropsAndState, {
        hideMenu: this.hideMenu,
        inputNode: this.inputNode,
        inputRef: this.inputRef,
        isMenuShown: this.isMenuShown,
        onActiveItemChange: this._handleActiveItemChange,
        onAdd: this._handleSelectionAdd,
        onBlur: this._handleBlur,
        onChange: this._handleInputChange,
        onClear: this._handleClear,
        onClick: this._handleClick,
        onFocus: this._handleFocus,
        onHide: this.hideMenu,
        onInitialItemChange: this._handleInitialItemChange,
        onKeyDown: this._handleKeyDown,
        onMenuItemClick: this._handleMenuItemSelect,
        onRemove: this._handleSelectionRemove,
        results,
        setItem: this.setItem,
        toggleMenu: this.toggleMenu
      }));
    }
  }]);
  return Typeahead2;
}(React__default.Component);
_defineProperty(Typeahead, "propTypes", propTypes$7);
_defineProperty(Typeahead, "defaultProps", defaultProps$6);
var _excluded$a = ["className", "label", "onClick", "onKeyDown", "size"];
var propTypes$6 = {
  label: PropTypes$1.string,
  onClick: PropTypes$1.func,
  onKeyDown: PropTypes$1.func,
  size: sizeType
};
var defaultProps$5 = {
  label: "Clear"
};
var ClearButton = function ClearButton2(_ref3) {
  var className = _ref3.className, label = _ref3.label, _onClick = _ref3.onClick, _onKeyDown = _ref3.onKeyDown, size = _ref3.size, props = _objectWithoutProperties(_ref3, _excluded$a);
  return /* @__PURE__ */ React__default.createElement("button", _extends({}, props, {
    "aria-label": label,
    className: cx("close", "btn-close", "rbt-close", {
      "rbt-close-lg": isSizeLarge(size),
      "rbt-close-sm": isSizeSmall(size)
    }, className),
    onClick: function onClick(e2) {
      e2.stopPropagation();
      _onClick && _onClick(e2);
    },
    onKeyDown: function onKeyDown(e2) {
      if (e2.key === "Backspace") {
        e2.preventDefault();
      }
      _onKeyDown && _onKeyDown(e2);
    },
    type: "button"
  }), /* @__PURE__ */ React__default.createElement("span", {
    "aria-hidden": "true",
    className: "rbt-close-content"
  }, "\xD7"), /* @__PURE__ */ React__default.createElement("span", {
    className: "sr-only visually-hidden"
  }, label));
};
ClearButton.propTypes = propTypes$6;
ClearButton.defaultProps = defaultProps$5;
var propTypes$5 = {
  label: PropTypes$1.string
};
var defaultProps$4 = {
  label: "Loading..."
};
var Loader = function Loader2(_ref3) {
  var label = _ref3.label;
  return /* @__PURE__ */ React__default.createElement("div", {
    className: "rbt-loader spinner-border spinner-border-sm",
    role: "status"
  }, /* @__PURE__ */ React__default.createElement("span", {
    className: "sr-only visually-hidden"
  }, label));
};
Loader.propTypes = propTypes$5;
Loader.defaultProps = defaultProps$4;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _iterableToArrayLimit(r2, l2) {
  var t2 = null == r2 ? null : "undefined" != typeof Symbol && r2[Symbol.iterator] || r2["@@iterator"];
  if (null != t2) {
    var e2, n2, i2, u, a = [], f2 = true, o = false;
    try {
      if (i2 = (t2 = t2.call(r2)).next, 0 === l2) {
        if (Object(t2) !== t2)
          return;
        f2 = false;
      } else
        for (; !(f2 = (e2 = i2.call(t2)).done) && (a.push(e2.value), a.length !== l2); f2 = true)
          ;
    } catch (r3) {
      o = true, n2 = r3;
    } finally {
      try {
        if (!f2 && null != t2["return"] && (u = t2["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n2;
      }
    }
    return a;
  }
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n2 = Object.prototype.toString.call(o).slice(8, -1);
  if (n2 === "Object" && o.constructor)
    n2 = o.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray(o, minLen);
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i2) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i2) || _unsupportedIterableToArray(arr, i2) || _nonIterableRest();
}
function ownKeys$5(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$5(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys$5(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var setPopperWidth = {
  enabled: true,
  fn: function fn2(data) {
    data.state.styles.popper.width = "".concat(data.state.rects.reference.width, "px");
  },
  name: "setPopperWidth",
  phase: "write"
};
function getModifiers(props) {
  var modifiers = [{
    enabled: !!props.flip,
    name: "flip"
  }];
  if (props.align !== "right" && props.align !== "left") {
    modifiers.push(setPopperWidth);
  }
  return modifiers;
}
function getPlacement(props) {
  var x2 = props.align === "right" ? "end" : "start";
  var y2 = props.dropup ? "top" : "bottom";
  return "".concat(y2, "-").concat(x2);
}
function useOverlay(referenceElement, options) {
  var _useState = useState(null), _useState2 = _slicedToArray(_useState, 2), popperElement = _useState2[0], attachRef = _useState2[1];
  var _usePopper = usePopper(referenceElement, popperElement, {
    modifiers: getModifiers(options),
    placement: getPlacement(options),
    strategy: options.positionFixed ? "fixed" : "absolute"
  }), attributes = _usePopper.attributes, styles2 = _usePopper.styles, forceUpdate = _usePopper.forceUpdate;
  var refElementHeight = referenceElement === null || referenceElement === void 0 ? void 0 : referenceElement.offsetHeight;
  useEffect(function() {
    forceUpdate && forceUpdate();
  }, [refElementHeight]);
  return _objectSpread$5(_objectSpread$5({}, attributes.popper), {}, {
    innerRef: attachRef,
    style: styles2.popper
  });
}
var _excluded$9 = ["referenceElement", "isMenuShown"];
var SafeElement = typeof Element === "undefined" ? noop$1 : Element;
var propTypes$4 = {
  align: PropTypes$1.oneOf(ALIGN_VALUES),
  children: PropTypes$1.func.isRequired,
  dropup: PropTypes$1.bool,
  flip: PropTypes$1.bool,
  isMenuShown: PropTypes$1.bool,
  positionFixed: PropTypes$1.bool,
  referenceElement: PropTypes$1.instanceOf(SafeElement)
};
var Overlay = function Overlay2(_ref3) {
  var referenceElement = _ref3.referenceElement, isMenuShown = _ref3.isMenuShown, props = _objectWithoutProperties(_ref3, _excluded$9);
  var overlayProps = useOverlay(referenceElement, props);
  if (!isMenuShown) {
    return null;
  }
  return props.children(overlayProps);
};
Overlay.propTypes = propTypes$4;
function contains(context, node2) {
  if (context.contains)
    return context.contains(node2);
  if (context.compareDocumentPosition)
    return context === node2 || !!(context.compareDocumentPosition(node2) & 16);
}
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var optionsSupported = false;
var onceSupported = false;
try {
  var options = {
    get passive() {
      return optionsSupported = true;
    },
    get once() {
      return onceSupported = optionsSupported = true;
    }
  };
  if (canUseDOM) {
    window.addEventListener("test", options, options);
    window.removeEventListener("test", options, true);
  }
} catch (e2) {
}
function addEventListener(node2, eventName, handler, options) {
  if (options && typeof options !== "boolean" && !onceSupported) {
    var once = options.once, capture = options.capture;
    var wrappedHandler = handler;
    if (!onceSupported && once) {
      wrappedHandler = handler.__once || function onceHandler(event) {
        this.removeEventListener(eventName, onceHandler, capture);
        handler.call(this, event);
      };
      handler.__once = wrappedHandler;
    }
    node2.addEventListener(eventName, wrappedHandler, optionsSupported ? options : capture);
  }
  node2.addEventListener(eventName, handler, options);
}
function removeEventListener(node2, eventName, handler, options) {
  var capture = options && typeof options !== "boolean" ? options.capture : options;
  node2.removeEventListener(eventName, handler, capture);
  if (handler.__once) {
    node2.removeEventListener(eventName, handler.__once, capture);
  }
}
function listen(node2, eventName, handler, options) {
  addEventListener(node2, eventName, handler, options);
  return function() {
    removeEventListener(node2, eventName, handler, options);
  };
}
function useCommittedRef(value) {
  const ref = useRef(value);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref;
}
function useEventCallback(fn3) {
  const ref = useCommittedRef(fn3);
  return useCallback(function(...args) {
    return ref.current && ref.current(...args);
  }, [ref]);
}
function ownerDocument$1(node2) {
  return node2 && node2.ownerDocument || document;
}
function safeFindDOMNode(componentOrElement) {
  if (componentOrElement && "setState" in componentOrElement) {
    return ReactDOM__default.findDOMNode(componentOrElement);
  }
  return componentOrElement != null ? componentOrElement : null;
}
var ownerDocument = function(componentOrElement) {
  return ownerDocument$1(safeFindDOMNode(componentOrElement));
};
var escapeKeyCode = 27;
var noop2 = function noop3() {
};
function isLeftClickEvent(event) {
  return event.button === 0;
}
function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var getRefTarget = function getRefTarget2(ref) {
  return ref && ("current" in ref ? ref.current : ref);
};
function useRootClose$1(ref, onRootClose, _temp) {
  var _ref3 = _temp === void 0 ? {} : _temp, disabled2 = _ref3.disabled, _ref$clickTrigger = _ref3.clickTrigger, clickTrigger = _ref$clickTrigger === void 0 ? "click" : _ref$clickTrigger;
  var preventMouseRootCloseRef = useRef(false);
  var onClose = onRootClose || noop2;
  var handleMouseCapture = useCallback(function(e2) {
    var _e$composedPath$;
    var currentTarget = getRefTarget(ref);
    preventMouseRootCloseRef.current = !currentTarget || isModifiedEvent(e2) || !isLeftClickEvent(e2) || !!contains(currentTarget, (_e$composedPath$ = e2.composedPath == null ? void 0 : e2.composedPath()[0]) != null ? _e$composedPath$ : e2.target);
  }, [ref]);
  var handleMouse = useEventCallback(function(e2) {
    if (!preventMouseRootCloseRef.current) {
      onClose(e2);
    }
  });
  var handleKeyUp = useEventCallback(function(e2) {
    if (e2.keyCode === escapeKeyCode) {
      onClose(e2);
    }
  });
  useEffect(function() {
    if (disabled2 || ref == null)
      return void 0;
    var currentEvent = window.event;
    var doc = ownerDocument(getRefTarget(ref));
    var removeMouseCaptureListener = listen(doc, clickTrigger, handleMouseCapture, true);
    var removeMouseListener = listen(doc, clickTrigger, function(e2) {
      if (e2 === currentEvent) {
        currentEvent = void 0;
        return;
      }
      handleMouse(e2);
    });
    var removeKeyupListener = listen(doc, "keyup", function(e2) {
      if (e2 === currentEvent) {
        currentEvent = void 0;
        return;
      }
      handleKeyUp(e2);
    });
    var mobileSafariHackListeners = [];
    if ("ontouchstart" in doc.documentElement) {
      mobileSafariHackListeners = [].slice.call(doc.body.children).map(function(el) {
        return listen(el, "mousemove", noop2);
      });
    }
    return function() {
      removeMouseCaptureListener();
      removeMouseListener();
      removeKeyupListener();
      mobileSafariHackListeners.forEach(function(remove) {
        return remove();
      });
    };
  }, [ref, disabled2, clickTrigger, handleMouseCapture, handleMouse, handleKeyUp]);
}
function useRootClose(onRootClose, options) {
  var rootElementRef = useRef(null);
  useRootClose$1(rootElementRef.current, onRootClose, options);
  return rootElementRef;
}
var _excluded$8 = ["children", "onRootClose"];
function RootClose(_ref3) {
  var children = _ref3.children, onRootClose = _ref3.onRootClose, props = _objectWithoutProperties(_ref3, _excluded$8);
  var rootRef = useRootClose(onRootClose, props);
  return children(rootRef);
}
var _excluded$7 = ["onBlur", "onClick", "onFocus", "onRemove", "option"];
function ownKeys$4(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$4(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys$4(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
({
  onBlur: PropTypes$1.func,
  onClick: PropTypes$1.func,
  onFocus: PropTypes$1.func,
  onRemove: PropTypes$1.func,
  option: optionType.isRequired
});
function useToken(_ref3) {
  var onBlur = _ref3.onBlur, onClick = _ref3.onClick, onFocus2 = _ref3.onFocus, onRemove = _ref3.onRemove, option = _ref3.option, props = _objectWithoutProperties(_ref3, _excluded$7);
  var _useState = useState(false), _useState2 = _slicedToArray(_useState, 2), active2 = _useState2[0], setActive = _useState2[1];
  var _useState3 = useState(null), _useState4 = _slicedToArray(_useState3, 2), rootElement = _useState4[0], attachRef = _useState4[1];
  var handleBlur = function handleBlur2(e2) {
    setActive(false);
    onBlur && onBlur(e2);
  };
  var handleClick = function handleClick2(e2) {
    setActive(true);
    onClick && onClick(e2);
  };
  var handleFocus = function handleFocus2(e2) {
    setActive(true);
    onFocus2 && onFocus2(e2);
  };
  var handleRemove = function handleRemove2() {
    onRemove && onRemove(option);
  };
  var handleKeyDown = function handleKeyDown2(e2) {
    if (e2.key === "Backspace" && active2) {
      e2.preventDefault();
      handleRemove();
    }
  };
  useRootClose$1(rootElement, handleBlur, _objectSpread$4(_objectSpread$4({}, props), {}, {
    disabled: !active2
  }));
  return {
    active: active2,
    onBlur: handleBlur,
    onClick: handleClick,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onRemove: isFunction(onRemove) ? handleRemove : void 0,
    ref: attachRef
  };
}
var _excluded$6 = ["active", "children", "className", "onRemove", "tabIndex"], _excluded2 = ["children", "option", "readOnly"], _excluded3 = ["ref"];
function ownKeys$3(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$3(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys$3(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var InteractiveToken = /* @__PURE__ */ forwardRef(function(_ref3, ref) {
  var active2 = _ref3.active, children = _ref3.children, className = _ref3.className, onRemove = _ref3.onRemove, tabIndex = _ref3.tabIndex, props = _objectWithoutProperties(_ref3, _excluded$6);
  return /* @__PURE__ */ jsxs("div", {
    ...props,
    className: cx("rbt-token", "rbt-token-removeable", {
      "rbt-token-active": !!active2
    }, className),
    ref,
    tabIndex: tabIndex || 0,
    children: [children, /* @__PURE__ */ jsx$1(ClearButton, {
      className: "rbt-token-remove-button",
      label: "Remove",
      onClick: onRemove,
      tabIndex: -1
    })]
  });
});
var StaticToken = function StaticToken2(_ref22) {
  var children = _ref22.children, className = _ref22.className, disabled2 = _ref22.disabled, href = _ref22.href;
  var classnames2 = cx("rbt-token", {
    "rbt-token-disabled": disabled2
  }, className);
  if (href && !disabled2) {
    return /* @__PURE__ */ jsx$1("a", {
      className: classnames2,
      href,
      children
    });
  }
  return /* @__PURE__ */ jsx$1("div", {
    className: classnames2,
    children
  });
};
var Token = function Token2(_ref3) {
  var children = _ref3.children, option = _ref3.option, readOnly = _ref3.readOnly, props = _objectWithoutProperties(_ref3, _excluded2);
  var _useToken = useToken(_objectSpread$3(_objectSpread$3({}, props), {}, {
    option
  })), ref = _useToken.ref, tokenProps = _objectWithoutProperties(_useToken, _excluded3);
  var child = /* @__PURE__ */ jsx$1("div", {
    className: "rbt-token-label",
    children
  });
  return !props.disabled && !readOnly && isFunction(tokenProps.onRemove) ? /* @__PURE__ */ jsx$1(InteractiveToken, {
    ...props,
    ...tokenProps,
    ref,
    children: child
  }) : /* @__PURE__ */ jsx$1(StaticToken, {
    ...props,
    children: child
  });
};
function interpolateStyle(styles2, attr) {
  var subattr = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  if (subattr) {
    subattr = subattr.replace(subattr[0], subattr[0].toUpperCase());
  }
  return ["Top", "Right", "Bottom", "Left"].map(function(dir) {
    return styles2["".concat(attr).concat(dir).concat(subattr)];
  }).join(" ");
}
function copyStyles(inputNode, hintNode) {
  var inputStyle3 = window.getComputedStyle(inputNode);
  hintNode.style.borderStyle = interpolateStyle(inputStyle3, "border", "style");
  hintNode.style.borderWidth = interpolateStyle(inputStyle3, "border", "width");
  hintNode.style.fontSize = inputStyle3.fontSize;
  hintNode.style.fontWeight = inputStyle3.fontWeight;
  hintNode.style.height = inputStyle3.height;
  hintNode.style.lineHeight = inputStyle3.lineHeight;
  hintNode.style.margin = interpolateStyle(inputStyle3, "margin");
  hintNode.style.padding = interpolateStyle(inputStyle3, "padding");
}
var useHint = function useHint2() {
  var _useTypeaheadContext = useTypeaheadContext(), hintText = _useTypeaheadContext.hintText, inputNode = _useTypeaheadContext.inputNode;
  var hintRef = useRef(null);
  useEffect(function() {
    if (inputNode && hintRef.current) {
      copyStyles(inputNode, hintRef.current);
    }
  });
  return {
    hintRef,
    hintText
  };
};
var Hint = function Hint2(_ref3) {
  var children = _ref3.children, className = _ref3.className;
  var _useHint = useHint(), hintRef = _useHint.hintRef, hintText = _useHint.hintText;
  return /* @__PURE__ */ jsxs("div", {
    className,
    style: {
      display: "flex",
      flex: 1,
      height: "100%",
      position: "relative"
    },
    children: [children, /* @__PURE__ */ jsx$1("input", {
      "aria-hidden": true,
      className: "rbt-input-hint",
      ref: hintRef,
      readOnly: true,
      style: {
        backgroundColor: "transparent",
        borderColor: "transparent",
        boxShadow: "none",
        color: "rgba(0, 0, 0, 0.54)",
        left: 0,
        pointerEvents: "none",
        position: "absolute",
        top: 0,
        width: "100%"
      },
      tabIndex: -1,
      value: hintText
    })]
  });
};
var Input2 = /* @__PURE__ */ forwardRef(function(props, ref) {
  return /* @__PURE__ */ jsx$1("input", {
    ...props,
    className: cx("rbt-input-main", props.className),
    ref
  });
});
var _excluded$5 = ["children", "className", "inputClassName", "inputRef", "referenceElementRef", "selected"];
function TypeaheadInputMulti(props) {
  var wrapperRef = React__default.useRef(null);
  var inputElem = React__default.useRef(null);
  var _propsWithBsClassName = propsWithBsClassName(props), children = _propsWithBsClassName.children, className = _propsWithBsClassName.className, inputClassName = _propsWithBsClassName.inputClassName;
  _propsWithBsClassName.inputRef;
  var referenceElementRef = _propsWithBsClassName.referenceElementRef, selected2 = _propsWithBsClassName.selected, rest = _objectWithoutProperties(_propsWithBsClassName, _excluded$5);
  function getInputRef(input2) {
    inputElem.current = input2;
    props.inputRef(input2);
  }
  function handleContainerClickOrFocus(e2) {
    if (props.disabled) {
      e2.currentTarget.blur();
      return;
    }
    var inputNode = inputElem.current;
    if (!inputNode || e2.currentTarget.contains(e2.target) && e2.currentTarget !== e2.target) {
      return;
    }
    if (isSelectable(inputNode)) {
      inputNode.selectionStart = inputNode.value.length;
    }
    inputNode.focus();
  }
  function handleKeyDown(e2) {
    if (e2.key === "Backspace" && selected2.length && !props.value) {
      var _wrapperRef$current;
      e2.preventDefault();
      var wrapperChildren = (_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 ? void 0 : _wrapperRef$current.children;
      if (wrapperChildren !== null && wrapperChildren !== void 0 && wrapperChildren.length) {
        var lastToken = wrapperChildren[wrapperChildren.length - 2];
        lastToken === null || lastToken === void 0 ? void 0 : lastToken.focus();
      }
    }
    props.onKeyDown && props.onKeyDown(e2);
  }
  return /* @__PURE__ */ React__default.createElement("div", {
    className: cx("rbt-input-multi", {
      disabled: props.disabled
    }, className),
    onClick: handleContainerClickOrFocus,
    onFocus: handleContainerClickOrFocus,
    ref: referenceElementRef,
    tabIndex: -1
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: "rbt-input-wrapper",
    ref: wrapperRef
  }, children, /* @__PURE__ */ React__default.createElement(Hint, null, /* @__PURE__ */ React__default.createElement(Input2, _extends({}, rest, {
    className: inputClassName,
    onKeyDown: handleKeyDown,
    ref: getInputRef,
    style: {
      backgroundColor: "transparent",
      border: 0,
      boxShadow: "none",
      cursor: "inherit",
      outline: "none",
      padding: 0,
      width: "100%",
      zIndex: 1
    }
  })))));
}
var _excluded$4 = ["inputRef", "referenceElementRef"];
var TypeaheadInputSingle = function TypeaheadInputSingle2(_ref3) {
  var inputRef = _ref3.inputRef, referenceElementRef = _ref3.referenceElementRef, props = _objectWithoutProperties(_ref3, _excluded$4);
  return /* @__PURE__ */ React__default.createElement(Hint, null, /* @__PURE__ */ React__default.createElement(Input2, _extends({}, propsWithBsClassName(props), {
    ref: function ref(node2) {
      inputRef(node2);
      referenceElementRef(node2);
    }
  })));
};
var propTypes$3 = {
  children: PropTypes$1.string.isRequired,
  highlightClassName: PropTypes$1.string,
  search: PropTypes$1.string.isRequired
};
var defaultProps$3 = {
  highlightClassName: "rbt-highlight-text"
};
var Highlighter = function Highlighter2(_ref3) {
  var children = _ref3.children, highlightClassName = _ref3.highlightClassName, search = _ref3.search;
  if (!search || !children) {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, children);
  }
  var matchCount = 0;
  var remaining = children;
  var highlighterChildren = [];
  while (remaining) {
    var bounds = getMatchBounds(remaining, search);
    if (!bounds) {
      highlighterChildren.push(remaining);
      break;
    }
    var nonMatch = remaining.slice(0, bounds.start);
    if (nonMatch) {
      highlighterChildren.push(nonMatch);
    }
    var match2 = remaining.slice(bounds.start, bounds.end);
    highlighterChildren.push(/* @__PURE__ */ React__default.createElement("mark", {
      className: highlightClassName,
      key: matchCount
    }, match2));
    matchCount += 1;
    remaining = remaining.slice(bounds.end);
  }
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, highlighterChildren);
};
Highlighter.propTypes = propTypes$3;
Highlighter.defaultProps = defaultProps$3;
function t(t2) {
  return "object" == typeof t2 && null != t2 && 1 === t2.nodeType;
}
function e(t2, e2) {
  return (!e2 || "hidden" !== t2) && "visible" !== t2 && "clip" !== t2;
}
function n(t2, n2) {
  if (t2.clientHeight < t2.scrollHeight || t2.clientWidth < t2.scrollWidth) {
    var r2 = getComputedStyle(t2, null);
    return e(r2.overflowY, n2) || e(r2.overflowX, n2) || function(t3) {
      var e2 = function(t4) {
        if (!t4.ownerDocument || !t4.ownerDocument.defaultView)
          return null;
        try {
          return t4.ownerDocument.defaultView.frameElement;
        } catch (t5) {
          return null;
        }
      }(t3);
      return !!e2 && (e2.clientHeight < t3.scrollHeight || e2.clientWidth < t3.scrollWidth);
    }(t2);
  }
  return false;
}
function r(t2, e2, n2, r2, i2, o, l2, d2) {
  return o < t2 && l2 > e2 || o > t2 && l2 < e2 ? 0 : o <= t2 && d2 <= n2 || l2 >= e2 && d2 >= n2 ? o - t2 - r2 : l2 > e2 && d2 < n2 || o < t2 && d2 > n2 ? l2 - e2 + i2 : 0;
}
var i = function(e2, i2) {
  var o = window, l2 = i2.scrollMode, d2 = i2.block, f2 = i2.inline, h2 = i2.boundary, u = i2.skipOverflowHiddenElements, s = "function" == typeof h2 ? h2 : function(t2) {
    return t2 !== h2;
  };
  if (!t(e2))
    throw new TypeError("Invalid target");
  for (var a, c2, g2 = document.scrollingElement || document.documentElement, p2 = [], m2 = e2; t(m2) && s(m2); ) {
    if ((m2 = null == (c2 = (a = m2).parentElement) ? a.getRootNode().host || null : c2) === g2) {
      p2.push(m2);
      break;
    }
    null != m2 && m2 === document.body && n(m2) && !n(document.documentElement) || null != m2 && n(m2, u) && p2.push(m2);
  }
  for (var w2 = o.visualViewport ? o.visualViewport.width : innerWidth, v2 = o.visualViewport ? o.visualViewport.height : innerHeight, W = window.scrollX || pageXOffset, H = window.scrollY || pageYOffset, b2 = e2.getBoundingClientRect(), y2 = b2.height, E = b2.width, M = b2.top, V = b2.right, x2 = b2.bottom, I = b2.left, C = "start" === d2 || "nearest" === d2 ? M : "end" === d2 ? x2 : M + y2 / 2, R = "center" === f2 ? I + E / 2 : "end" === f2 ? V : I, T = [], k2 = 0; k2 < p2.length; k2++) {
    var B = p2[k2], D = B.getBoundingClientRect(), O = D.height, X = D.width, Y = D.top, L = D.right, S = D.bottom, j = D.left;
    if ("if-needed" === l2 && M >= 0 && I >= 0 && x2 <= v2 && V <= w2 && M >= Y && x2 <= S && I >= j && V <= L)
      return T;
    var N = getComputedStyle(B), q2 = parseInt(N.borderLeftWidth, 10), z2 = parseInt(N.borderTopWidth, 10), A2 = parseInt(N.borderRightWidth, 10), F = parseInt(N.borderBottomWidth, 10), G = 0, J = 0, K = "offsetWidth" in B ? B.offsetWidth - B.clientWidth - q2 - A2 : 0, P = "offsetHeight" in B ? B.offsetHeight - B.clientHeight - z2 - F : 0, Q = "offsetWidth" in B ? 0 === B.offsetWidth ? 0 : X / B.offsetWidth : 0, U = "offsetHeight" in B ? 0 === B.offsetHeight ? 0 : O / B.offsetHeight : 0;
    if (g2 === B)
      G = "start" === d2 ? C : "end" === d2 ? C - v2 : "nearest" === d2 ? r(H, H + v2, v2, z2, F, H + C, H + C + y2, y2) : C - v2 / 2, J = "start" === f2 ? R : "center" === f2 ? R - w2 / 2 : "end" === f2 ? R - w2 : r(W, W + w2, w2, q2, A2, W + R, W + R + E, E), G = Math.max(0, G + H), J = Math.max(0, J + W);
    else {
      G = "start" === d2 ? C - Y - z2 : "end" === d2 ? C - S + F + P : "nearest" === d2 ? r(Y, S, O, z2, F + P, C, C + y2, y2) : C - (Y + O / 2) + P / 2, J = "start" === f2 ? R - j - q2 : "center" === f2 ? R - (j + X / 2) + K / 2 : "end" === f2 ? R - L + A2 + K : r(j, L, X, q2, A2 + K, R, R + E, E);
      var Z = B.scrollLeft, $ = B.scrollTop;
      C += $ - (G = Math.max(0, Math.min($ + G / U, B.scrollHeight - O / U + P))), R += Z - (J = Math.max(0, Math.min(Z + J / Q, B.scrollWidth - X / Q + K)));
    }
    T.push({ el: B, top: G, left: J });
  }
  return T;
};
function isOptionsObject(options) {
  return options === Object(options) && Object.keys(options).length !== 0;
}
function defaultBehavior(actions, behavior) {
  if (behavior === void 0) {
    behavior = "auto";
  }
  var canSmoothScroll = "scrollBehavior" in document.body.style;
  actions.forEach(function(_ref3) {
    var el = _ref3.el, top2 = _ref3.top, left2 = _ref3.left;
    if (el.scroll && canSmoothScroll) {
      el.scroll({
        top: top2,
        left: left2,
        behavior
      });
    } else {
      el.scrollTop = top2;
      el.scrollLeft = left2;
    }
  });
}
function getOptions(options) {
  if (options === false) {
    return {
      block: "end",
      inline: "nearest"
    };
  }
  if (isOptionsObject(options)) {
    return options;
  }
  return {
    block: "start",
    inline: "nearest"
  };
}
function scrollIntoView(target, options) {
  var isTargetAttached = target.isConnected || target.ownerDocument.documentElement.contains(target);
  if (isOptionsObject(options) && typeof options.behavior === "function") {
    return options.behavior(isTargetAttached ? i(target, options) : []);
  }
  if (!isTargetAttached) {
    return;
  }
  var computeOptions = getOptions(options);
  return defaultBehavior(i(target, computeOptions), computeOptions.behavior);
}
var _excluded$3 = ["label", "onClick", "option", "position"];
function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$2(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys$2(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
({
  option: optionType.isRequired,
  position: PropTypes$1.number
});
function useItem(_ref3) {
  var label = _ref3.label, onClick = _ref3.onClick, option = _ref3.option, position2 = _ref3.position, props = _objectWithoutProperties(_ref3, _excluded$3);
  var _useTypeaheadContext = useTypeaheadContext(), activeIndex = _useTypeaheadContext.activeIndex, id = _useTypeaheadContext.id, isOnlyResult = _useTypeaheadContext.isOnlyResult, onActiveItemChange = _useTypeaheadContext.onActiveItemChange, onInitialItemChange = _useTypeaheadContext.onInitialItemChange, onMenuItemClick = _useTypeaheadContext.onMenuItemClick, setItem = _useTypeaheadContext.setItem;
  var itemRef = useRef(null);
  useEffect(function() {
    if (position2 === 0) {
      onInitialItemChange(option);
    }
  });
  useEffect(function() {
    if (position2 === activeIndex) {
      onActiveItemChange(option);
      var node2 = itemRef.current;
      node2 && scrollIntoView(node2, {
        block: "nearest",
        boundary: node2.parentNode,
        inline: "nearest",
        scrollMode: "if-needed"
      });
    }
  });
  var handleClick = useCallback(function(e2) {
    onMenuItemClick(option, e2);
    onClick && onClick(e2);
  }, [onClick, onMenuItemClick, option]);
  var active2 = isOnlyResult || activeIndex === position2;
  setItem(option, position2);
  return _objectSpread$2(_objectSpread$2({}, props), {}, {
    active: active2,
    "aria-label": label,
    "aria-selected": active2,
    id: getMenuItemId(id, position2),
    onClick: handleClick,
    onMouseDown: preventInputBlur,
    ref: itemRef,
    role: "option"
  });
}
var _excluded$2 = ["active", "children", "className", "disabled", "onClick"];
var BaseMenuItem = /* @__PURE__ */ forwardRef(function(_ref3, ref) {
  var active2 = _ref3.active, children = _ref3.children, className = _ref3.className, disabled2 = _ref3.disabled, _onClick = _ref3.onClick, props = _objectWithoutProperties(_ref3, _excluded$2);
  return /* @__PURE__ */ jsx$1("a", {
    ...props,
    className: cx("dropdown-item", {
      active: active2,
      disabled: disabled2
    }, className),
    href: props.href || "#",
    onClick: function onClick(e2) {
      e2.preventDefault();
      !disabled2 && _onClick && _onClick(e2);
    },
    ref,
    children
  });
});
function MenuItem(props) {
  return /* @__PURE__ */ jsx$1(BaseMenuItem, {
    ...useItem(props)
  });
}
var _excluded$1 = ["emptyLabel", "innerRef", "maxHeight", "style"];
function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$1(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys$1(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var MenuDivider = function MenuDivider2() {
  return /* @__PURE__ */ jsx$1("div", {
    className: "dropdown-divider",
    role: "separator"
  });
};
var MenuHeader = function MenuHeader2(props) {
  return /* @__PURE__ */ jsx$1("div", {
    ...props,
    className: "dropdown-header",
    role: "heading"
  });
};
var propTypes$2 = {
  "aria-label": PropTypes$1.string,
  emptyLabel: PropTypes$1.node,
  id: checkPropType(PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]), isRequiredForA11y),
  maxHeight: PropTypes$1.string
};
var defaultProps$2 = {
  "aria-label": "menu-options"
};
var Menu2 = function Menu3(_ref3) {
  var _ref$emptyLabel = _ref3.emptyLabel, emptyLabel = _ref$emptyLabel === void 0 ? "No matches found." : _ref$emptyLabel, innerRef = _ref3.innerRef, _ref$maxHeight = _ref3.maxHeight, maxHeight = _ref$maxHeight === void 0 ? "300px" : _ref$maxHeight, style = _ref3.style, props = _objectWithoutProperties(_ref3, _excluded$1);
  var children = Children.count(props.children) === 0 ? /* @__PURE__ */ jsx$1(BaseMenuItem, {
    disabled: true,
    role: "option",
    children: emptyLabel
  }) : props.children;
  return /* @__PURE__ */ jsx$1("div", {
    ...props,
    className: cx("rbt-menu", "dropdown-menu", "show", props.className),
    onMouseDown: preventInputBlur,
    ref: innerRef,
    role: "listbox",
    style: _objectSpread$1(_objectSpread$1({}, style), {}, {
      display: "block",
      maxHeight,
      overflow: "auto"
    }),
    children
  });
};
Menu2.propTypes = propTypes$2;
Menu2.defaultProps = defaultProps$2;
Menu2.Divider = MenuDivider;
Menu2.Header = MenuHeader;
var _excluded = ["labelKey", "newSelectionPrefix", "options", "paginationText", "renderMenuItemChildren", "text"];
var propTypes$1 = {
  newSelectionPrefix: PropTypes$1.node,
  paginationText: PropTypes$1.node,
  renderMenuItemChildren: PropTypes$1.func
};
var defaultProps$1 = {
  newSelectionPrefix: "New selection: ",
  paginationText: "Display additional results...",
  renderMenuItemChildren: function renderMenuItemChildren(option, props) {
    return /* @__PURE__ */ React__default.createElement(Highlighter, {
      search: props.text
    }, getOptionLabel3(option, props.labelKey));
  }
};
var TypeaheadMenu = function TypeaheadMenu2(props) {
  var labelKey = props.labelKey, newSelectionPrefix = props.newSelectionPrefix, options = props.options, paginationText = props.paginationText, renderMenuItemChildren2 = props.renderMenuItemChildren, text = props.text, menuProps = _objectWithoutProperties(props, _excluded);
  var renderMenuItem = function renderMenuItem2(option, position2) {
    var label = getOptionLabel3(option, labelKey);
    var menuItemProps = {
      disabled: !!getOptionProperty(option, "disabled"),
      label,
      option,
      position: position2
    };
    if (getOptionProperty(option, "customOption")) {
      return /* @__PURE__ */ React__default.createElement(MenuItem, _extends({}, menuItemProps, {
        className: "rbt-menu-custom-option",
        key: position2,
        label
      }), newSelectionPrefix, /* @__PURE__ */ React__default.createElement(Highlighter, {
        search: text
      }, label));
    }
    if (getOptionProperty(option, "paginationOption")) {
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, {
        key: "pagination-option-divider"
      }, /* @__PURE__ */ React__default.createElement(Menu2.Divider, null), /* @__PURE__ */ React__default.createElement(MenuItem, _extends({}, menuItemProps, {
        className: "rbt-menu-pagination-option",
        label: isString(paginationText) ? paginationText : ""
      }), paginationText));
    }
    return /* @__PURE__ */ React__default.createElement(MenuItem, _extends({}, menuItemProps, {
      key: position2
    }), renderMenuItemChildren2(option, props, position2));
  };
  return /* @__PURE__ */ React__default.createElement(Menu2, _extends({}, menuProps, {
    key: text
  }), options.map(renderMenuItem));
};
TypeaheadMenu.propTypes = propTypes$1;
TypeaheadMenu.defaultProps = defaultProps$1;
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e2) {
    return false;
  }
}
var propTypes = {
  clearButton: PropTypes$1.bool,
  inputProps: checkPropType(PropTypes$1.object, inputPropsType),
  isInvalid: PropTypes$1.bool,
  isLoading: PropTypes$1.bool,
  isValid: PropTypes$1.bool,
  renderInput: PropTypes$1.func,
  renderMenu: PropTypes$1.func,
  renderToken: PropTypes$1.func,
  size: sizeType
};
var defaultProps = {
  isLoading: false
};
var defaultRenderMenu = function defaultRenderMenu2(results, menuProps, props) {
  return /* @__PURE__ */ jsx$1(TypeaheadMenu, {
    ...menuProps,
    labelKey: props.labelKey,
    options: results,
    text: props.text
  });
};
var defaultRenderToken = function defaultRenderToken2(option, props, idx) {
  return /* @__PURE__ */ jsx$1(Token, {
    disabled: props.disabled,
    onRemove: props.onRemove,
    option,
    tabIndex: props.tabIndex,
    children: getOptionLabel3(option, props.labelKey)
  }, idx);
};
var overlayPropKeys = ["align", "dropup", "flip", "positionFixed"];
function getOverlayProps(props) {
  return pick(props, overlayPropKeys);
}
var TypeaheadComponent = /* @__PURE__ */ function(_React$Component) {
  _inherits(TypeaheadComponent2, _React$Component);
  var _super = _createSuper(TypeaheadComponent2);
  function TypeaheadComponent2() {
    var _this;
    _classCallCheck(this, TypeaheadComponent2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "_referenceElement", null);
    _defineProperty(_assertThisInitialized(_this), "referenceElementRef", function(referenceElement) {
      _this._referenceElement = referenceElement;
    });
    _defineProperty(_assertThisInitialized(_this), "_renderInput", function(inputProps, props) {
      var _this$props = _this.props, isInvalid = _this$props.isInvalid, isValid = _this$props.isValid, multiple = _this$props.multiple, renderInput = _this$props.renderInput, renderToken = _this$props.renderToken, size = _this$props.size;
      if (isFunction(renderInput)) {
        return renderInput(inputProps, props);
      }
      var commonProps = _objectSpread(_objectSpread({}, inputProps), {}, {
        isInvalid,
        isValid,
        size
      });
      if (!multiple) {
        return /* @__PURE__ */ jsx$1(TypeaheadInputSingle, {
          ...commonProps
        });
      }
      var labelKey = props.labelKey, onRemove = props.onRemove, selected2 = props.selected;
      return /* @__PURE__ */ jsx$1(TypeaheadInputMulti, {
        ...commonProps,
        placeholder: selected2.length ? "" : inputProps.placeholder,
        selected: selected2,
        children: selected2.map(function(option, idx) {
          return (renderToken || defaultRenderToken)(option, _objectSpread(_objectSpread({}, commonProps), {}, {
            labelKey,
            onRemove
          }), idx);
        })
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_renderMenu", function(results, menuProps, props) {
      var _this$props2 = _this.props, emptyLabel = _this$props2.emptyLabel, id = _this$props2.id, maxHeight = _this$props2.maxHeight, newSelectionPrefix = _this$props2.newSelectionPrefix, paginationText = _this$props2.paginationText, renderMenu = _this$props2.renderMenu, renderMenuItemChildren2 = _this$props2.renderMenuItemChildren;
      return (renderMenu || defaultRenderMenu)(results, _objectSpread(_objectSpread({}, menuProps), {}, {
        emptyLabel,
        id,
        maxHeight,
        newSelectionPrefix,
        paginationText,
        renderMenuItemChildren: renderMenuItemChildren2
      }), props);
    });
    _defineProperty(_assertThisInitialized(_this), "_renderAux", function(_ref3) {
      var onClear = _ref3.onClear, selected2 = _ref3.selected;
      var _this$props3 = _this.props, clearButton2 = _this$props3.clearButton, disabled2 = _this$props3.disabled, isLoading2 = _this$props3.isLoading, size = _this$props3.size;
      var content2;
      if (isLoading2) {
        content2 = /* @__PURE__ */ jsx$1(Loader, {});
      } else if (clearButton2 && !disabled2 && selected2.length) {
        content2 = /* @__PURE__ */ jsx$1(ClearButton, {
          onClick: onClear,
          onMouseDown: preventInputBlur,
          size
        });
      }
      return content2 ? /* @__PURE__ */ jsx$1("div", {
        className: cx("rbt-aux", {
          "rbt-aux-lg": isSizeLarge(size)
        }),
        children: content2
      }) : null;
    });
    return _this;
  }
  _createClass(TypeaheadComponent2, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props4 = this.props, children = _this$props4.children, className = _this$props4.className, instanceRef = _this$props4.instanceRef, open = _this$props4.open, options = _this$props4.options, style = _this$props4.style;
      return /* @__PURE__ */ jsx$1(Typeahead, {
        ...this.props,
        options,
        ref: instanceRef,
        children: function(props) {
          var hideMenu2 = props.hideMenu, isMenuShown = props.isMenuShown, results = props.results;
          var auxContent = _this2._renderAux(props);
          return /* @__PURE__ */ jsx$1(RootClose, {
            disabled: open || !isMenuShown,
            onRootClose: hideMenu2,
            children: function(ref) {
              return /* @__PURE__ */ jsxs("div", {
                className: cx("rbt", {
                  "has-aux": !!auxContent,
                  "is-invalid": _this2.props.isInvalid,
                  "is-valid": _this2.props.isValid
                }, className),
                ref,
                style: _objectSpread(_objectSpread({}, style), {}, {
                  outline: "none",
                  position: "relative"
                }),
                tabIndex: -1,
                children: [_this2._renderInput(_objectSpread(_objectSpread({}, props.getInputProps(_this2.props.inputProps)), {}, {
                  referenceElementRef: _this2.referenceElementRef
                }), props), /* @__PURE__ */ jsx$1(Overlay, {
                  ...getOverlayProps(_this2.props),
                  isMenuShown,
                  referenceElement: _this2._referenceElement,
                  children: function(menuProps) {
                    return _this2._renderMenu(results, menuProps, props);
                  }
                }), auxContent, isFunction(children) ? children(props) : children]
              });
            }
          });
        }
      });
    }
  }]);
  return TypeaheadComponent2;
}(React__default.Component);
_defineProperty(TypeaheadComponent, "propTypes", propTypes);
_defineProperty(TypeaheadComponent, "defaultProps", defaultProps);
var TypeaheadComponent$1 = /* @__PURE__ */ forwardRef(function(props, ref) {
  return /* @__PURE__ */ jsx$1(TypeaheadComponent, {
    ...props,
    instanceRef: ref
  });
});
var AsyncTypeahead = /* @__PURE__ */ forwardRef(function(props, ref) {
  return /* @__PURE__ */ jsx$1(TypeaheadComponent$1, {
    ...useAsync(props),
    ref
  });
});
const icon = "epic__icon__305";
const ripple = "epic__ripple__f99";
const required = "epic__required__5ec";
const normal = "epic__normal__e45";
const errored = "epic__errored__13e";
var styles = {
  icon,
  "epic-icon": "epic__epic-icon__3fd",
  "epic-icon-add": "epic__epic-icon-add__4b9",
  "epic-icon-arrow-backward": "epic__epic-icon-arrow-backward__b90",
  "epic-icon-arrow-down": "epic__epic-icon-arrow-down__1cf",
  "epic-icon-arrow-forward": "epic__epic-icon-arrow-forward__14b",
  "epic-icon-arrow-up": "epic__epic-icon-arrow-up__65b",
  "epic-icon-bookmark": "epic__epic-icon-bookmark__47c",
  "epic-icon-calendar": "epic__epic-icon-calendar__be6",
  "epic-icon-checkmark": "epic__epic-icon-checkmark__3b0",
  "epic-icon-chevron-back": "epic__epic-icon-chevron-back__a06",
  "epic-icon-chevron-circle-back": "epic__epic-icon-chevron-circle-back__1d2",
  "epic-icon-chevron-circle-forward": "epic__epic-icon-chevron-circle-forward__5e2",
  "epic-icon-chevron-down": "epic__epic-icon-chevron-down__32a",
  "epic-icon-chevron-forward": "epic__epic-icon-chevron-forward__5e5",
  "epic-icon-chevron-up": "epic__epic-icon-chevron-up__a25",
  "epic-icon-close-x": "epic__epic-icon-close-x__b43",
  "epic-icon-collaborate": "epic__epic-icon-collaborate__4c6",
  "epic-icon-confluence": "epic__epic-icon-confluence__35d",
  "epic-icon-contact": "epic__epic-icon-contact__ff1",
  "epic-icon-delete": "epic__epic-icon-delete__106",
  "epic-icon-edit": "epic__epic-icon-edit__46d",
  "epic-icon-filter-x": "epic__epic-icon-filter-x__69a",
  "epic-icon-filter": "epic__epic-icon-filter__f7f",
  "epic-icon-github": "epic__epic-icon-github__134",
  "epic-icon-information": "epic__epic-icon-information__30b",
  "epic-icon-jira": "epic__epic-icon-jira__256",
  "epic-icon-map-pin": "epic__epic-icon-map-pin__8b7",
  "epic-icon-nike-logo": "epic__epic-icon-nike-logo__256",
  "epic-icon-preview-eye": "epic__epic-icon-preview-eye__4cb",
  "epic-icon-preview": "epic__epic-icon-preview__41f",
  "epic-icon-profile": "epic__epic-icon-profile__90e",
  "epic-icon-quotes": "epic__epic-icon-quotes__42d",
  "epic-icon-search": "epic__epic-icon-search__8ef",
  "epic-icon-share": "epic__epic-icon-share__141",
  "epic-icon-slack-with-name": "epic__epic-icon-slack-with-name__f5d",
  "epic-icon-slack": "epic__epic-icon-slack__704",
  "epic-icon-steps": "epic__epic-icon-steps__05d",
  "epic-icon-up-and-running": "epic__epic-icon-up-and-running__1c7",
  "epic-icon-user-profile": "epic__epic-icon-user-profile__956",
  "epic-icon-walkthrough": "epic__epic-icon-walkthrough__cab",
  "epic-icon-warning": "epic__epic-icon-warning__718",
  "epic-font-base": "epic__epic-font-base__f73",
  "epic-font-base-md": "epic__epic-font-base-md__dce",
  "epic-font-marketing": "epic__epic-font-marketing__2e7",
  "epic-font-brand": "epic__epic-font-brand__d67",
  ripple,
  required,
  normal,
  errored
};
const aegisUrls = {
  qa: "https://api.aegis.nikecloud.com/v1/qa",
  prod: "https://api.aegis.nikecloud.com/v1/prod"
};
const headers = (accessToken) => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${accessToken}`
});
const aegisApi = {
  findUsers: async (query, accessToken, env = "prod") => {
    try {
      const searchUri = `${aegisUrls[env]}/users`;
      const url = `${searchUri}?count=50&startsWith=${query}`;
      const response = await fetch(url, {
        method: "GET",
        headers: headers(accessToken)
      });
      if (!(response == null ? void 0 : response.ok))
        Promise.reject(response);
      const { items } = await response.json();
      return items.filter(({ email, displayName }) => email !== null && displayName !== null).map(({ email, displayName }) => ({ email, displayName }));
    } catch (error) {
      console.log("[API]", error);
      throw new Error(error);
    }
  }
};
function SelectEmails({
  accessToken,
  env,
  id = "emai-async-typeahead-id",
  label = "Nike Email",
  placeholder = "firstName.lastName@nike.com",
  subtitle: subtitle2 = "Search for a Nike email address",
  required: required2 = false,
  labelKey = "email",
  hasErrors: hasErrors2 = false,
  errorMessage,
  ...props
}) {
  const [options, setOptions] = useState([]);
  const [isLoading2, setIsLoading] = useState(false);
  const [errors, setErrors] = useState(null);
  const handleOnSearch = async (query) => {
    setIsLoading(true);
    try {
      const users = await aegisApi.findUsers(query, accessToken, env);
      setOptions(users);
    } catch (err) {
      setErrors("Error fetching Emails");
    } finally {
      setIsLoading(false);
    }
  };
  const handleRenderMenuItemChildren = ({
    displayName,
    email
  }) => /* @__PURE__ */ jsxs("div", {
    children: [/* @__PURE__ */ jsx$1("span", {
      children: displayName
    }), /* @__PURE__ */ jsx$1("br", {}), /* @__PURE__ */ jsx$1("span", {
      children: email
    })]
  });
  const handleOnBlur = (event) => {
    var _a;
    if (required2) {
      const value = (_a = event == null ? void 0 : event.target) == null ? void 0 : _a.value;
      value === "" ? setErrors("This is a required field") : setErrors(null);
    }
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx$1(Label, {
      font: "title-6",
      hasErrors: hasErrors2,
      className: required2 && styles.required,
      children: label
    }), /* @__PURE__ */ jsx$1(Text$2, {
      font: "subtitle-2",
      color: "grey-7",
      children: subtitle2
    }), /* @__PURE__ */ jsx$1(AsyncTypeahead, {
      minLength: 3,
      maxResults: 8,
      delay: 500,
      paginate: true,
      allowNew: false,
      multiple: false,
      filterBy: () => true,
      onSearch: handleOnSearch,
      isLoading: isLoading2,
      renderMenuItemChildren: handleRenderMenuItemChildren,
      labelKey,
      options,
      onBlur: handleOnBlur,
      emptyLabel: errors ? "Error fetching Emails" : "No Email matches found.",
      id,
      className: `${hasErrors2 ? styles.errored : styles.normal}`,
      placeholder,
      ...props
    }), !!errors && /* @__PURE__ */ jsx$1(Text$2, {
      font: "legal-1",
      color: "red-50",
      children: String(errors)
    }), !!hasErrors2 && /* @__PURE__ */ jsx$1(Text$2, {
      font: "legal-1",
      color: "red-50",
      children: String(errorMessage)
    })]
  });
}
SelectEmails.propTypes = {
  accessToken: PropTypes$1.string.isRequired,
  env: PropTypes$1.string.isRequired,
  id: PropTypes$1.string,
  label: PropTypes$1.string,
  placeholder: PropTypes$1.string,
  subtitle: PropTypes$1.string,
  required: PropTypes$1.bool,
  labelKey: PropTypes$1.string,
  hasErrors: PropTypes$1.bool,
  errorMessage: PropTypes$1.string
};
export { ActionInput, Breadcrumbs, Chips, Collapsible, Favorites, FileInput, Icon, ListItem, NavBar, Overlay$1 as Overlay, PaginationControlledTable, PaginationControls, PaginationTable, SelectAdGroup, SelectCloudRedGuids, SelectEmails, SelectOktaClientId, SelectWaffleIron, StaticTable, StepFormProgressBars, Table, TableContainer, Tbody, Td, Th, Thead, Tr, useFetchAdGroups, useFetchClientIds, useFetchCloudRedGuids, useFetchWaffleIronAccounts };
//# sourceMappingURL=index.esm.js.map
